import _wrapNativeSuper from "/Users/ramawidi/inimedia/SchoolTalk-PWA/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _asyncToGenerator from "/Users/ramawidi/inimedia/SchoolTalk-PWA/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _assertThisInitialized from "/Users/ramawidi/inimedia/SchoolTalk-PWA/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/ramawidi/inimedia/SchoolTalk-PWA/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/ramawidi/inimedia/SchoolTalk-PWA/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _toConsumableArray from "/Users/ramawidi/inimedia/SchoolTalk-PWA/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _inherits from "/Users/ramawidi/inimedia/SchoolTalk-PWA/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/ramawidi/inimedia/SchoolTalk-PWA/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _slicedToArray from "/Users/ramawidi/inimedia/SchoolTalk-PWA/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/Users/ramawidi/inimedia/SchoolTalk-PWA/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _defineProperty from "/Users/ramawidi/inimedia/SchoolTalk-PWA/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/Users/ramawidi/inimedia/SchoolTalk-PWA/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/Users/ramawidi/inimedia/SchoolTalk-PWA/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ramawidi/inimedia/SchoolTalk-PWA/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
/* MathLive 0.69.8  */
function e(e) {
  return Array.isArray(e);
}
var t = {
    m0: "#3F3D99",
    m1: "#993D71",
    m2: "#998B3D",
    m3: "#3D9956",
    m4: "#3D5A99",
    m5: "#993D90",
    m6: "#996D3D",
    m7: "#43993D",
    m8: "#3D7999",
    m9: "#843D99"
  },
  i = {
    blue: "#0072BD",
    orange: "#D95319",
    yellow: "#EDB120",
    purple: "#7E2F8E",
    green: "#77AC30",
    cyan: "#4DBEEE",
    red: "#A2142F"
  },
  r = {
    red: "#fbbbb6",
    orange: "#ffe0c2",
    yellow: "#fff1c2",
    lime: "#d0e8b9",
    green: "#bceac4",
    teal: "#b9f1f1",
    blue: "#b6d9fb",
    indigo: "#d1c2f0",
    purple: "#e3baf8",
    magenta: "#f9c8e0",
    black: "#353535",
    "dark-grey": "#8C8C8C",
    grey: "#D0D0D0",
    "light-grey": "#F0F0F0",
    white: "#ffffff"
  },
  n = {
    red: "#d7170b",
    orange: "#fe8a2b",
    yellow: "#ffc02b",
    lime: "#63b215",
    green: "#21ba3a",
    teal: "#17cfcf",
    blue: "#0d80f2",
    indigo: "#63c",
    purple: "#a219e6",
    magenta: "#eb4799",
    black: "#000",
    "dark-grey": "#666",
    grey: "#A6A6A6",
    "light-grey": "#d4d5d2",
    white: "#ffffff"
  },
  a = {
    Red: "red",
    Orange: "orange",
    Yellow: "yellow",
    LimeGreen: "lime",
    Green: "green",
    TealBlue: "teal",
    Blue: "blue",
    Violet: "indigo",
    Purple: "purple",
    Magenta: "magenta",
    Black: "black",
    Gray: "grey",
    White: "white"
  },
  o = {
    Apricot: "#FBB982",
    Aquamarine: "#00B5BE",
    Bittersweet: "#C04F17",
    Black: "#221E1F",
    Blue: "#2D2F92",
    BlueGreen: "#00B3B8",
    BlueViolet: "#473992",
    BrickRed: "#B6321C",
    Brown: "#792500",
    BurntOrange: "#F7921D",
    CadetBlue: "#74729A",
    CarnationPink: "#F282B4",
    Cerulean: "#00A2E3",
    CornflowerBlue: "#41B0E4",
    Cyan: "#00AEEF",
    Dandelion: "#FDBC42",
    DarkOrchid: "#A4538A",
    Emerald: "#00A99D",
    ForestGreen: "#009B55",
    Fuchsia: "#8C368C",
    Goldenrod: "#FFDF42",
    Gray: "#949698",
    Green: "#00A64F",
    GreenYellow: "#DFE674",
    JungleGreen: "#00A99A",
    Lavender: "#F49EC4",
    Limegreen: "#8DC73E",
    Magenta: "#EC008C",
    Mahogany: "#A9341F",
    Maroon: "#AF3235",
    Melon: "#F89E7B",
    MidnightBlue: "#006795",
    Mulberry: "#A93C93",
    NavyBlue: "#006EB8",
    OliveGreen: "#3C8031",
    Orange: "#F58137",
    OrangeRed: "#ED135A",
    Orchid: "#AF72B0",
    Peach: "#F7965A",
    Periwinkle: "#7977B8",
    PineGreen: "#008B72",
    Plum: "#92268F",
    ProcessBlue: "#00B0F0",
    Purple: "#99479B",
    RawSienna: "#974006",
    Red: "#ED1B23",
    RedOrange: "#F26035",
    RedViolet: "#A1246B",
    Rhodamine: "#EF559F",
    RoyalBlue: "#0071BC",
    RoyalPurple: "#613F99",
    RubineRed: "#ED017D",
    Salmon: "#F69289",
    SeaGreen: "#3FBC9D",
    Sepia: "#671800",
    SkyBlue: "#46C5DD",
    SpringGreen: "#C6DC67",
    Tan: "#DA9D76",
    TealBlue: "#00AEB3",
    Thistle: "#D883B7",
    Turquoise: "#00B4CE",
    Violet: "#58429B",
    VioletRed: "#EF58A0",
    White: "#FFFFFF",
    WildStrawberry: "#EE2967",
    Yellow: "#FFF200",
    YellowGreen: "#98CC70",
    YellowOrange: "#FAA21A"
  };
function s(e) {
  var r, s, l, c, u, d;
  var h = e.split("!");
  var p,
    m,
    f,
    g = 255,
    y = 255,
    b = 255,
    v = -1;
  var x = h.length > 0 && h[0].startsWith("-");
  x && (h[0] = h[0].slice(1));
  for (var _e2 = 0; _e2 < h.length; _e2++) {
    p = g, m = y, f = b;
    var _x = null === (r = h[_e2].trim().match(/^([A-Za-z\d]+)/)) || void 0 === r ? void 0 : r[1],
      _k = null == _x ? void 0 : _x.toLowerCase(),
      _w = _x && null !== (d = null !== (u = null !== (c = null !== (l = null !== (s = n[_k]) && void 0 !== s ? s : n[a[_x]]) && void 0 !== l ? l : i[_x]) && void 0 !== c ? c : o[_x]) && void 0 !== u ? u : t[_x]) && void 0 !== d ? d : h[_e2].trim();
    var _2 = _w.match(/^#([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
    if ((null == _2 ? void 0 : _2[1]) && _2[2] && _2[3]) g = Math.max(0, Math.min(255, Number.parseInt(_2[1], 16))), y = Math.max(0, Math.min(255, Number.parseInt(_2[2], 16))), b = Math.max(0, Math.min(255, Number.parseInt(_2[3], 16)));else if (_2 = _w.match(/^#([\da-f]{3})$/i), null == _2 ? void 0 : _2[1]) {
      var _e3 = Number.parseInt(_2[1][0], 16),
        _t2 = Number.parseInt(_2[1][1], 16),
        _i2 = Number.parseInt(_2[1][2], 16);
      g = Math.max(0, Math.min(255, 16 * _e3 + _e3)), y = Math.max(0, Math.min(255, 16 * _t2 + _t2)), b = Math.max(0, Math.min(255, 16 * _i2 + _i2));
    } else {
      if (_2 = _w.match(/^rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i), !((null == _2 ? void 0 : _2[1]) && _2[2] && _2[3])) return;
      g = Math.max(0, Math.min(255, Number.parseInt(_2[1]))), y = Math.max(0, Math.min(255, Number.parseInt(_2[2]))), b = Math.max(0, Math.min(255, Number.parseInt(_2[3])));
    }
    v >= 0 && (g = (1 - v) * g + v * p, y = (1 - v) * y + v * m, b = (1 - v) * b + v * f, v = -1), _e2 + 1 < h.length && (v = Math.max(0, Math.min(100, Number.parseInt(h[++_e2]))) / 100);
  }
  return v >= 0 && (g = v * g + (1 - v) * p, y = v * y + (1 - v) * m, b = v * b + (1 - v) * f), x && (g = 255 - g, y = 255 - y, b = 255 - b), "#" + ("00" + Math.round(g).toString(16)).slice(-2) + ("00" + Math.round(y).toString(16)).slice(-2) + ("00" + Math.round(b).toString(16)).slice(-2);
}
function l(e) {
  var t, i;
  return e = e.trim(), null !== (i = null !== (t = r[e.toLowerCase()]) && void 0 !== t ? t : r[a[e]]) && void 0 !== i ? i : s(e);
}
function c(e, t, i) {
  return i < 0 && (i += 6), i >= 6 && (i -= 6), i < 1 ? (t - e) * i + e : i < 3 ? t : i < 4 ? (t - e) * (4 - i) + e : e;
}
function u(e) {
  return e < 0 ? 0 : e > 255 ? 255 : Math.round(e);
}
var d = [0, .69444, 0, 0],
  h = [0, .61111, 0, 0],
  p = [.25, .75, 0, 0],
  m = [0, .44444, 0, 0],
  f = [0, .68611, 0, 0],
  g = [.19444, .69444, 0, 0],
  y = [0, .68333, 0, 0],
  b = [0, .68889, 0, 0],
  v = [0, .69141, 0, 0],
  x = [0, 0, 0, 0],
  k = [0, .64444, 0, 0],
  w = [0, .69224, 0, 0],
  _ = [.19444, .44444, 0, 0],
  M = [.65002, 1.15, 0, 0],
  S = [0, .55556, 0, 0],
  L = [.35001, .85, 0, 0],
  C = [1.25003, 1.75, 0, 0],
  A = [.95003, 1.45, 0, 0],
  N = [0, .75, 0, 0],
  z = [0, .47534, 0, 0],
  q = [.25001, .75, 0, 0],
  D = [.55001, 1.05, 0, 0],
  E = [.16667, .68889, 0, 0],
  T = [.08167, .58167, 0, 0];
var O = {
  "AMS-Regular": {
    32: x,
    65: b,
    66: b,
    67: b,
    68: b,
    69: b,
    70: b,
    71: b,
    72: b,
    73: b,
    74: E,
    75: b,
    76: b,
    77: b,
    78: b,
    79: E,
    80: b,
    81: E,
    82: b,
    83: b,
    84: b,
    85: b,
    86: b,
    87: b,
    88: b,
    89: b,
    90: b,
    107: b,
    160: x,
    165: [0, .675, .025, 0],
    174: [.15559, .69224, 0, 0],
    240: b,
    295: b,
    710: [0, .825, 0, 0],
    732: [0, .9, 0, 0],
    770: [0, .825, 0, 0],
    771: [0, .9, 0, 0],
    989: T,
    1008: [0, .43056, .04028, 0],
    8245: [0, .54986, 0, 0],
    8463: b,
    8487: b,
    8498: b,
    8502: b,
    8503: b,
    8504: b,
    8513: b,
    8592: [-.03598, .46402, 0, 0],
    8594: [-.03598, .46402, 0, 0],
    8602: [-.13313, .36687, 0, 0],
    8603: [-.13313, .36687, 0, 0],
    8606: [.01354, .52239, 0, 0],
    8608: [.01354, .52239, 0, 0],
    8610: [.01354, .52239, 0, 0],
    8611: [.01354, .52239, 0, 0],
    8619: [0, .54986, 0, 0],
    8620: [0, .54986, 0, 0],
    8621: [-.13313, .37788, 0, 0],
    8622: [-.13313, .36687, 0, 0],
    8624: w,
    8625: w,
    8630: [0, .43056, 0, 0],
    8631: [0, .43056, 0, 0],
    8634: [.08198, .58198, 0, 0],
    8635: [.08198, .58198, 0, 0],
    8638: [.19444, .69224, 0, 0],
    8639: [.19444, .69224, 0, 0],
    8642: [.19444, .69224, 0, 0],
    8643: [.19444, .69224, 0, 0],
    8644: [.1808, .675, 0, 0],
    8646: [.1808, .675, 0, 0],
    8647: [.1808, .675, 0, 0],
    8648: [.19444, .69224, 0, 0],
    8649: [.1808, .675, 0, 0],
    8650: [.19444, .69224, 0, 0],
    8651: [.01354, .52239, 0, 0],
    8652: [.01354, .52239, 0, 0],
    8653: [-.13313, .36687, 0, 0],
    8654: [-.13313, .36687, 0, 0],
    8655: [-.13313, .36687, 0, 0],
    8666: [.13667, .63667, 0, 0],
    8667: [.13667, .63667, 0, 0],
    8669: [-.13313, .37788, 0, 0],
    8672: [-.064, .437, 0, 0],
    8674: [-.064, .437, 0, 0],
    8705: [0, .825, 0, 0],
    8708: b,
    8709: T,
    8717: [0, .43056, 0, 0],
    8722: [-.03598, .46402, 0, 0],
    8724: [.08198, .69224, 0, 0],
    8726: T,
    8733: w,
    8736: w,
    8737: w,
    8738: [.03517, .52239, 0, 0],
    8739: T,
    8740: [.25142, .74111, 0, 0],
    8741: T,
    8742: [.25142, .74111, 0, 0],
    8756: w,
    8757: w,
    8764: [-.13313, .36687, 0, 0],
    8765: [-.13313, .37788, 0, 0],
    8769: [-.13313, .36687, 0, 0],
    8770: [-.03625, .46375, 0, 0],
    8774: [.30274, .79383, 0, 0],
    8776: [-.01688, .48312, 0, 0],
    8778: T,
    8782: [.06062, .54986, 0, 0],
    8783: [.06062, .54986, 0, 0],
    8785: [.08198, .58198, 0, 0],
    8786: [.08198, .58198, 0, 0],
    8787: [.08198, .58198, 0, 0],
    8790: w,
    8791: [.22958, .72958, 0, 0],
    8796: [.08198, .91667, 0, 0],
    8806: [.25583, .75583, 0, 0],
    8807: [.25583, .75583, 0, 0],
    8808: [.25142, .75726, 0, 0],
    8809: [.25142, .75726, 0, 0],
    8812: [.25583, .75583, 0, 0],
    8814: [.20576, .70576, 0, 0],
    8815: [.20576, .70576, 0, 0],
    8816: [.30274, .79383, 0, 0],
    8817: [.30274, .79383, 0, 0],
    8818: [.22958, .72958, 0, 0],
    8819: [.22958, .72958, 0, 0],
    8822: [.1808, .675, 0, 0],
    8823: [.1808, .675, 0, 0],
    8828: [.13667, .63667, 0, 0],
    8829: [.13667, .63667, 0, 0],
    8830: [.22958, .72958, 0, 0],
    8831: [.22958, .72958, 0, 0],
    8832: [.20576, .70576, 0, 0],
    8833: [.20576, .70576, 0, 0],
    8840: [.30274, .79383, 0, 0],
    8841: [.30274, .79383, 0, 0],
    8842: [.13597, .63597, 0, 0],
    8843: [.13597, .63597, 0, 0],
    8847: [.03517, .54986, 0, 0],
    8848: [.03517, .54986, 0, 0],
    8858: [.08198, .58198, 0, 0],
    8859: [.08198, .58198, 0, 0],
    8861: [.08198, .58198, 0, 0],
    8862: [0, .675, 0, 0],
    8863: [0, .675, 0, 0],
    8864: [0, .675, 0, 0],
    8865: [0, .675, 0, 0],
    8872: w,
    8873: w,
    8874: w,
    8876: b,
    8877: b,
    8878: b,
    8879: b,
    8882: [.03517, .54986, 0, 0],
    8883: [.03517, .54986, 0, 0],
    8884: [.13667, .63667, 0, 0],
    8885: [.13667, .63667, 0, 0],
    8888: [0, .54986, 0, 0],
    8890: [.19444, .43056, 0, 0],
    8891: [.19444, .69224, 0, 0],
    8892: [.19444, .69224, 0, 0],
    8901: [0, .54986, 0, 0],
    8903: T,
    8905: T,
    8906: T,
    8907: w,
    8908: w,
    8909: [-.03598, .46402, 0, 0],
    8910: [0, .54986, 0, 0],
    8911: [0, .54986, 0, 0],
    8912: [.03517, .54986, 0, 0],
    8913: [.03517, .54986, 0, 0],
    8914: [0, .54986, 0, 0],
    8915: [0, .54986, 0, 0],
    8916: w,
    8918: [.0391, .5391, 0, 0],
    8919: [.0391, .5391, 0, 0],
    8920: [.03517, .54986, 0, 0],
    8921: [.03517, .54986, 0, 0],
    8922: [.38569, .88569, 0, 0],
    8923: [.38569, .88569, 0, 0],
    8926: [.13667, .63667, 0, 0],
    8927: [.13667, .63667, 0, 0],
    8928: [.30274, .79383, 0, 0],
    8929: [.30274, .79383, 0, 0],
    8934: [.23222, .74111, 0, 0],
    8935: [.23222, .74111, 0, 0],
    8936: [.23222, .74111, 0, 0],
    8937: [.23222, .74111, 0, 0],
    8938: [.20576, .70576, 0, 0],
    8939: [.20576, .70576, 0, 0],
    8940: [.30274, .79383, 0, 0],
    8941: [.30274, .79383, 0, 0],
    8994: [.19444, .69224, 0, 0],
    8995: [.19444, .69224, 0, 0],
    9416: [.15559, .69224, 0, 0],
    9484: w,
    9488: w,
    9492: [0, .37788, 0, 0],
    9496: [0, .37788, 0, 0],
    9585: [.19444, .68889, 0, 0],
    9586: [.19444, .74111, 0, 0],
    9632: [0, .675, 0, 0],
    9633: [0, .675, 0, 0],
    9650: [0, .54986, 0, 0],
    9651: [0, .54986, 0, 0],
    9654: [.03517, .54986, 0, 0],
    9660: [0, .54986, 0, 0],
    9661: [0, .54986, 0, 0],
    9664: [.03517, .54986, 0, 0],
    9674: [.11111, .69224, 0, 0],
    9733: [.19444, .69224, 0, 0],
    10003: w,
    10016: w,
    10731: [.11111, .69224, 0, 0],
    10846: [.19444, .75583, 0, 0],
    10877: [.13667, .63667, 0, 0],
    10878: [.13667, .63667, 0, 0],
    10885: [.25583, .75583, 0, 0],
    10886: [.25583, .75583, 0, 0],
    10887: [.13597, .63597, 0, 0],
    10888: [.13597, .63597, 0, 0],
    10889: [.26167, .75726, 0, 0],
    10890: [.26167, .75726, 0, 0],
    10891: [.48256, .98256, 0, 0],
    10892: [.48256, .98256, 0, 0],
    10901: [.13667, .63667, 0, 0],
    10902: [.13667, .63667, 0, 0],
    10933: [.25142, .75726, 0, 0],
    10934: [.25142, .75726, 0, 0],
    10935: [.26167, .75726, 0, 0],
    10936: [.26167, .75726, 0, 0],
    10937: [.26167, .75726, 0, 0],
    10938: [.26167, .75726, 0, 0],
    10949: [.25583, .75583, 0, 0],
    10950: [.25583, .75583, 0, 0],
    10955: [.28481, .79383, 0, 0],
    10956: [.28481, .79383, 0, 0],
    57350: T,
    57351: T,
    57352: T,
    57353: [0, .43056, .04028, 0],
    57356: [.25142, .75726, 0, 0],
    57357: [.25142, .75726, 0, 0],
    57358: [.41951, .91951, 0, 0],
    57359: [.30274, .79383, 0, 0],
    57360: [.30274, .79383, 0, 0],
    57361: [.41951, .91951, 0, 0],
    57366: [.25142, .75726, 0, 0],
    57367: [.25142, .75726, 0, 0],
    57368: [.25142, .75726, 0, 0],
    57369: [.25142, .75726, 0, 0],
    57370: [.13597, .63597, 0, 0],
    57371: [.13597, .63597, 0, 0]
  },
  "Caligraphic-Regular": {
    32: x,
    65: [0, .68333, 0, .19445],
    66: [0, .68333, .03041, .13889],
    67: [0, .68333, .05834, .13889],
    68: [0, .68333, .02778, .08334],
    69: [0, .68333, .08944, .11111],
    70: [0, .68333, .09931, .11111],
    71: [.09722, .68333, .0593, .11111],
    72: [0, .68333, .00965, .11111],
    73: [0, .68333, .07382, 0],
    74: [.09722, .68333, .18472, .16667],
    75: [0, .68333, .01445, .05556],
    76: [0, .68333, 0, .13889],
    77: [0, .68333, 0, .13889],
    78: [0, .68333, .14736, .08334],
    79: [0, .68333, .02778, .11111],
    80: [0, .68333, .08222, .08334],
    81: [.09722, .68333, 0, .11111],
    82: [0, .68333, 0, .08334],
    83: [0, .68333, .075, .13889],
    84: [0, .68333, .25417, 0],
    85: [0, .68333, .09931, .08334],
    86: [0, .68333, .08222, 0],
    87: [0, .68333, .08222, .08334],
    88: [0, .68333, .14643, .13889],
    89: [.09722, .68333, .08222, .08334],
    90: [0, .68333, .07944, .13889],
    160: x
  },
  "Fraktur-Regular": {
    32: x,
    33: v,
    34: v,
    38: v,
    39: v,
    40: [.24982, .74947, 0, 0],
    41: [.24982, .74947, 0, 0],
    42: [0, .62119, 0, 0],
    43: [.08319, .58283, 0, 0],
    44: [0, .10803, 0, 0],
    45: [.08319, .58283, 0, 0],
    46: [0, .10803, 0, 0],
    47: [.24982, .74947, 0, 0],
    48: z,
    49: z,
    50: z,
    51: [.18906, .47534, 0, 0],
    52: [.18906, .47534, 0, 0],
    53: [.18906, .47534, 0, 0],
    54: v,
    55: [.18906, .47534, 0, 0],
    56: v,
    57: [.18906, .47534, 0, 0],
    58: z,
    59: [.12604, .47534, 0, 0],
    61: [-.13099, .36866, 0, 0],
    63: v,
    65: v,
    66: v,
    67: v,
    68: v,
    69: v,
    70: [.12604, .69141, 0, 0],
    71: v,
    72: [.06302, .69141, 0, 0],
    73: v,
    74: [.12604, .69141, 0, 0],
    75: v,
    76: v,
    77: v,
    78: v,
    79: v,
    80: [.18906, .69141, 0, 0],
    81: [.03781, .69141, 0, 0],
    82: v,
    83: v,
    84: v,
    85: v,
    86: v,
    87: v,
    88: v,
    89: [.18906, .69141, 0, 0],
    90: [.12604, .69141, 0, 0],
    91: [.24982, .74947, 0, 0],
    93: [.24982, .74947, 0, 0],
    94: v,
    97: z,
    98: v,
    99: z,
    100: [0, .62119, 0, 0],
    101: z,
    102: [.18906, .69141, 0, 0],
    103: [.18906, .47534, 0, 0],
    104: [.18906, .69141, 0, 0],
    105: v,
    106: v,
    107: v,
    108: v,
    109: z,
    110: z,
    111: z,
    112: [.18906, .52396, 0, 0],
    113: [.18906, .47534, 0, 0],
    114: z,
    115: z,
    116: [0, .62119, 0, 0],
    117: z,
    118: [0, .52396, 0, 0],
    119: [0, .52396, 0, 0],
    120: [.18906, .47534, 0, 0],
    121: [.18906, .47534, 0, 0],
    122: [.18906, .47534, 0, 0],
    160: x,
    8216: v,
    8217: v,
    58112: [0, .62119, 0, 0],
    58113: [0, .62119, 0, 0],
    58114: [.18906, .69141, 0, 0],
    58115: [.18906, .69141, 0, 0],
    58116: [.18906, .47534, 0, 0],
    58117: v,
    58118: [0, .62119, 0, 0],
    58119: z
  },
  "Main-Bold": {
    32: x,
    33: d,
    34: d,
    35: g,
    36: [.05556, .75, 0, 0],
    37: [.05556, .75, 0, 0],
    38: d,
    39: d,
    40: p,
    41: p,
    42: N,
    43: [.13333, .63333, 0, 0],
    44: [.19444, .15556, 0, 0],
    45: m,
    46: [0, .15556, 0, 0],
    47: p,
    48: k,
    49: k,
    50: k,
    51: k,
    52: k,
    53: k,
    54: k,
    55: k,
    56: k,
    57: k,
    58: m,
    59: _,
    60: [.08556, .58556, 0, 0],
    61: [-.10889, .39111, 0, 0],
    62: [.08556, .58556, 0, 0],
    63: d,
    64: d,
    65: f,
    66: f,
    67: f,
    68: f,
    69: f,
    70: f,
    71: f,
    72: f,
    73: f,
    74: f,
    75: f,
    76: f,
    77: f,
    78: f,
    79: f,
    80: f,
    81: [.19444, .68611, 0, 0],
    82: f,
    83: f,
    84: f,
    85: f,
    86: [0, .68611, .01597, 0],
    87: [0, .68611, .01597, 0],
    88: f,
    89: [0, .68611, .02875, 0],
    90: f,
    91: p,
    92: p,
    93: p,
    94: d,
    95: [.31, .13444, .03194, 0],
    97: m,
    98: d,
    99: m,
    100: d,
    101: m,
    102: [0, .69444, .10903, 0],
    103: [.19444, .44444, .01597, 0],
    104: d,
    105: d,
    106: g,
    107: d,
    108: d,
    109: m,
    110: m,
    111: m,
    112: _,
    113: _,
    114: m,
    115: m,
    116: [0, .63492, 0, 0],
    117: m,
    118: [0, .44444, .01597, 0],
    119: [0, .44444, .01597, 0],
    120: m,
    121: [.19444, .44444, .01597, 0],
    122: m,
    123: p,
    124: p,
    125: p,
    126: [.35, .34444, 0, 0],
    160: x,
    163: d,
    168: d,
    172: m,
    176: d,
    177: [.13333, .63333, 0, 0],
    184: [.17014, 0, 0, 0],
    198: f,
    215: [.13333, .63333, 0, 0],
    216: [.04861, .73472, 0, 0],
    223: d,
    230: m,
    247: [.13333, .63333, 0, 0],
    248: [.09722, .54167, 0, 0],
    305: m,
    338: f,
    339: m,
    567: _,
    710: d,
    711: [0, .63194, 0, 0],
    713: [0, .59611, 0, 0],
    714: d,
    715: d,
    728: d,
    729: d,
    730: d,
    732: d,
    733: d,
    915: f,
    916: f,
    920: f,
    923: f,
    926: f,
    928: f,
    931: f,
    933: f,
    934: f,
    936: f,
    937: f,
    8211: [0, .44444, .03194, 0],
    8212: [0, .44444, .03194, 0],
    8216: d,
    8217: d,
    8220: d,
    8221: d,
    8224: g,
    8225: g,
    8242: S,
    8407: [0, .72444, .15486, 0],
    8463: d,
    8465: d,
    8467: d,
    8472: _,
    8476: d,
    8501: d,
    8592: [-.10889, .39111, 0, 0],
    8593: g,
    8594: [-.10889, .39111, 0, 0],
    8595: g,
    8596: [-.10889, .39111, 0, 0],
    8597: p,
    8598: g,
    8599: g,
    8600: g,
    8601: g,
    8636: [-.10889, .39111, 0, 0],
    8637: [-.10889, .39111, 0, 0],
    8640: [-.10889, .39111, 0, 0],
    8641: [-.10889, .39111, 0, 0],
    8656: [-.10889, .39111, 0, 0],
    8657: g,
    8658: [-.10889, .39111, 0, 0],
    8659: g,
    8660: [-.10889, .39111, 0, 0],
    8661: p,
    8704: d,
    8706: [0, .69444, .06389, 0],
    8707: d,
    8709: [.05556, .75, 0, 0],
    8711: f,
    8712: [.08556, .58556, 0, 0],
    8715: [.08556, .58556, 0, 0],
    8722: [.13333, .63333, 0, 0],
    8723: [.13333, .63333, 0, 0],
    8725: p,
    8726: p,
    8727: [-.02778, .47222, 0, 0],
    8728: [-.02639, .47361, 0, 0],
    8729: [-.02639, .47361, 0, 0],
    8730: [.18, .82, 0, 0],
    8733: m,
    8734: m,
    8736: w,
    8739: p,
    8741: p,
    8743: S,
    8744: S,
    8745: S,
    8746: S,
    8747: [.19444, .69444, .12778, 0],
    8764: [-.10889, .39111, 0, 0],
    8768: g,
    8771: [.00222, .50222, 0, 0],
    8776: [.02444, .52444, 0, 0],
    8781: [.00222, .50222, 0, 0],
    8801: [.00222, .50222, 0, 0],
    8804: [.19667, .69667, 0, 0],
    8805: [.19667, .69667, 0, 0],
    8810: [.08556, .58556, 0, 0],
    8811: [.08556, .58556, 0, 0],
    8826: [.08556, .58556, 0, 0],
    8827: [.08556, .58556, 0, 0],
    8834: [.08556, .58556, 0, 0],
    8835: [.08556, .58556, 0, 0],
    8838: [.19667, .69667, 0, 0],
    8839: [.19667, .69667, 0, 0],
    8846: S,
    8849: [.19667, .69667, 0, 0],
    8850: [.19667, .69667, 0, 0],
    8851: S,
    8852: S,
    8853: [.13333, .63333, 0, 0],
    8854: [.13333, .63333, 0, 0],
    8855: [.13333, .63333, 0, 0],
    8856: [.13333, .63333, 0, 0],
    8857: [.13333, .63333, 0, 0],
    8866: d,
    8867: d,
    8868: d,
    8869: d,
    8900: [-.02639, .47361, 0, 0],
    8901: [-.02639, .47361, 0, 0],
    8902: [-.02778, .47222, 0, 0],
    8968: p,
    8969: p,
    8970: p,
    8971: p,
    8994: [-.13889, .36111, 0, 0],
    8995: [-.13889, .36111, 0, 0],
    9651: g,
    9657: [-.02778, .47222, 0, 0],
    9661: g,
    9667: [-.02778, .47222, 0, 0],
    9711: g,
    9824: [.12963, .69444, 0, 0],
    9825: [.12963, .69444, 0, 0],
    9826: [.12963, .69444, 0, 0],
    9827: [.12963, .69444, 0, 0],
    9837: N,
    9838: g,
    9839: g,
    10216: p,
    10217: p,
    10815: f,
    10927: [.19667, .69667, 0, 0],
    10928: [.19667, .69667, 0, 0],
    57376: g
  },
  "Main-BoldItalic": {
    32: x,
    33: [0, .69444, .11417, 0],
    34: [0, .69444, .07939, 0],
    35: [.19444, .69444, .06833, 0],
    37: [.05556, .75, .12861, 0],
    38: [0, .69444, .08528, 0],
    39: [0, .69444, .12945, 0],
    40: [.25, .75, .15806, 0],
    41: [.25, .75, .03306, 0],
    42: [0, .75, .14333, 0],
    43: [.10333, .60333, .03306, 0],
    44: [.19444, .14722, 0, 0],
    45: [0, .44444, .02611, 0],
    46: [0, .14722, 0, 0],
    47: [.25, .75, .15806, 0],
    48: [0, .64444, .13167, 0],
    49: [0, .64444, .13167, 0],
    50: [0, .64444, .13167, 0],
    51: [0, .64444, .13167, 0],
    52: [.19444, .64444, .13167, 0],
    53: [0, .64444, .13167, 0],
    54: [0, .64444, .13167, 0],
    55: [.19444, .64444, .13167, 0],
    56: [0, .64444, .13167, 0],
    57: [0, .64444, .13167, 0],
    58: [0, .44444, .06695, 0],
    59: [.19444, .44444, .06695, 0],
    61: [-.10889, .39111, .06833, 0],
    63: [0, .69444, .11472, 0],
    64: [0, .69444, .09208, 0],
    65: f,
    66: [0, .68611, .0992, 0],
    67: [0, .68611, .14208, 0],
    68: [0, .68611, .09062, 0],
    69: [0, .68611, .11431, 0],
    70: [0, .68611, .12903, 0],
    71: [0, .68611, .07347, 0],
    72: [0, .68611, .17208, 0],
    73: [0, .68611, .15681, 0],
    74: [0, .68611, .145, 0],
    75: [0, .68611, .14208, 0],
    76: f,
    77: [0, .68611, .17208, 0],
    78: [0, .68611, .17208, 0],
    79: [0, .68611, .09062, 0],
    80: [0, .68611, .0992, 0],
    81: [.19444, .68611, .09062, 0],
    82: [0, .68611, .02559, 0],
    83: [0, .68611, .11264, 0],
    84: [0, .68611, .12903, 0],
    85: [0, .68611, .17208, 0],
    86: [0, .68611, .18625, 0],
    87: [0, .68611, .18625, 0],
    88: [0, .68611, .15681, 0],
    89: [0, .68611, .19803, 0],
    90: [0, .68611, .14208, 0],
    91: [.25, .75, .1875, 0],
    93: [.25, .75, .09972, 0],
    94: [0, .69444, .06709, 0],
    95: [.31, .13444, .09811, 0],
    97: [0, .44444, .09426, 0],
    98: [0, .69444, .07861, 0],
    99: [0, .44444, .05222, 0],
    100: [0, .69444, .10861, 0],
    101: [0, .44444, .085, 0],
    102: [.19444, .69444, .21778, 0],
    103: [.19444, .44444, .105, 0],
    104: [0, .69444, .09426, 0],
    105: [0, .69326, .11387, 0],
    106: [.19444, .69326, .1672, 0],
    107: [0, .69444, .11111, 0],
    108: [0, .69444, .10861, 0],
    109: [0, .44444, .09426, 0],
    110: [0, .44444, .09426, 0],
    111: [0, .44444, .07861, 0],
    112: [.19444, .44444, .07861, 0],
    113: [.19444, .44444, .105, 0],
    114: [0, .44444, .11111, 0],
    115: [0, .44444, .08167, 0],
    116: [0, .63492, .09639, 0],
    117: [0, .44444, .09426, 0],
    118: [0, .44444, .11111, 0],
    119: [0, .44444, .11111, 0],
    120: [0, .44444, .12583, 0],
    121: [.19444, .44444, .105, 0],
    122: [0, .44444, .13889, 0],
    126: [.35, .34444, .11472, 0],
    160: x,
    168: [0, .69444, .11473, 0],
    176: d,
    184: [.17014, 0, 0, 0],
    198: [0, .68611, .11431, 0],
    216: [.04861, .73472, .09062, 0],
    223: [.19444, .69444, .09736, 0],
    230: [0, .44444, .085, 0],
    248: [.09722, .54167, .09458, 0],
    305: [0, .44444, .09426, 0],
    338: [0, .68611, .11431, 0],
    339: [0, .44444, .085, 0],
    567: [.19444, .44444, .04611, 0],
    710: [0, .69444, .06709, 0],
    711: [0, .63194, .08271, 0],
    713: [0, .59444, .10444, 0],
    714: [0, .69444, .08528, 0],
    715: d,
    728: [0, .69444, .10333, 0],
    729: [0, .69444, .12945, 0],
    730: d,
    732: [0, .69444, .11472, 0],
    733: [0, .69444, .11472, 0],
    915: [0, .68611, .12903, 0],
    916: f,
    920: [0, .68611, .09062, 0],
    923: f,
    926: [0, .68611, .15092, 0],
    928: [0, .68611, .17208, 0],
    931: [0, .68611, .11431, 0],
    933: [0, .68611, .10778, 0],
    934: [0, .68611, .05632, 0],
    936: [0, .68611, .10778, 0],
    937: [0, .68611, .0992, 0],
    8211: [0, .44444, .09811, 0],
    8212: [0, .44444, .09811, 0],
    8216: [0, .69444, .12945, 0],
    8217: [0, .69444, .12945, 0],
    8220: [0, .69444, .16772, 0],
    8221: [0, .69444, .07939, 0]
  },
  "Main-Italic": {
    32: x,
    33: [0, .69444, .12417, 0],
    34: [0, .69444, .06961, 0],
    35: [.19444, .69444, .06616, 0],
    37: [.05556, .75, .13639, 0],
    38: [0, .69444, .09694, 0],
    39: [0, .69444, .12417, 0],
    40: [.25, .75, .16194, 0],
    41: [.25, .75, .03694, 0],
    42: [0, .75, .14917, 0],
    43: [.05667, .56167, .03694, 0],
    44: [.19444, .10556, 0, 0],
    45: [0, .43056, .02826, 0],
    46: [0, .10556, 0, 0],
    47: [.25, .75, .16194, 0],
    48: [0, .64444, .13556, 0],
    49: [0, .64444, .13556, 0],
    50: [0, .64444, .13556, 0],
    51: [0, .64444, .13556, 0],
    52: [.19444, .64444, .13556, 0],
    53: [0, .64444, .13556, 0],
    54: [0, .64444, .13556, 0],
    55: [.19444, .64444, .13556, 0],
    56: [0, .64444, .13556, 0],
    57: [0, .64444, .13556, 0],
    58: [0, .43056, .0582, 0],
    59: [.19444, .43056, .0582, 0],
    61: [-.13313, .36687, .06616, 0],
    63: [0, .69444, .1225, 0],
    64: [0, .69444, .09597, 0],
    65: y,
    66: [0, .68333, .10257, 0],
    67: [0, .68333, .14528, 0],
    68: [0, .68333, .09403, 0],
    69: [0, .68333, .12028, 0],
    70: [0, .68333, .13305, 0],
    71: [0, .68333, .08722, 0],
    72: [0, .68333, .16389, 0],
    73: [0, .68333, .15806, 0],
    74: [0, .68333, .14028, 0],
    75: [0, .68333, .14528, 0],
    76: y,
    77: [0, .68333, .16389, 0],
    78: [0, .68333, .16389, 0],
    79: [0, .68333, .09403, 0],
    80: [0, .68333, .10257, 0],
    81: [.19444, .68333, .09403, 0],
    82: [0, .68333, .03868, 0],
    83: [0, .68333, .11972, 0],
    84: [0, .68333, .13305, 0],
    85: [0, .68333, .16389, 0],
    86: [0, .68333, .18361, 0],
    87: [0, .68333, .18361, 0],
    88: [0, .68333, .15806, 0],
    89: [0, .68333, .19383, 0],
    90: [0, .68333, .14528, 0],
    91: [.25, .75, .1875, 0],
    93: [.25, .75, .10528, 0],
    94: [0, .69444, .06646, 0],
    95: [.31, .12056, .09208, 0],
    97: [0, .43056, .07671, 0],
    98: [0, .69444, .06312, 0],
    99: [0, .43056, .05653, 0],
    100: [0, .69444, .10333, 0],
    101: [0, .43056, .07514, 0],
    102: [.19444, .69444, .21194, 0],
    103: [.19444, .43056, .08847, 0],
    104: [0, .69444, .07671, 0],
    105: [0, .65536, .1019, 0],
    106: [.19444, .65536, .14467, 0],
    107: [0, .69444, .10764, 0],
    108: [0, .69444, .10333, 0],
    109: [0, .43056, .07671, 0],
    110: [0, .43056, .07671, 0],
    111: [0, .43056, .06312, 0],
    112: [.19444, .43056, .06312, 0],
    113: [.19444, .43056, .08847, 0],
    114: [0, .43056, .10764, 0],
    115: [0, .43056, .08208, 0],
    116: [0, .61508, .09486, 0],
    117: [0, .43056, .07671, 0],
    118: [0, .43056, .10764, 0],
    119: [0, .43056, .10764, 0],
    120: [0, .43056, .12042, 0],
    121: [.19444, .43056, .08847, 0],
    122: [0, .43056, .12292, 0],
    126: [.35, .31786, .11585, 0],
    160: x,
    168: [0, .66786, .10474, 0],
    176: d,
    184: [.17014, 0, 0, 0],
    198: [0, .68333, .12028, 0],
    216: [.04861, .73194, .09403, 0],
    223: [.19444, .69444, .10514, 0],
    230: [0, .43056, .07514, 0],
    248: [.09722, .52778, .09194, 0],
    338: [0, .68333, .12028, 0],
    339: [0, .43056, .07514, 0],
    710: [0, .69444, .06646, 0],
    711: [0, .62847, .08295, 0],
    713: [0, .56167, .10333, 0],
    714: [0, .69444, .09694, 0],
    715: d,
    728: [0, .69444, .10806, 0],
    729: [0, .66786, .11752, 0],
    730: d,
    732: [0, .66786, .11585, 0],
    733: [0, .69444, .1225, 0],
    915: [0, .68333, .13305, 0],
    916: y,
    920: [0, .68333, .09403, 0],
    923: y,
    926: [0, .68333, .15294, 0],
    928: [0, .68333, .16389, 0],
    931: [0, .68333, .12028, 0],
    933: [0, .68333, .11111, 0],
    934: [0, .68333, .05986, 0],
    936: [0, .68333, .11111, 0],
    937: [0, .68333, .10257, 0],
    8211: [0, .43056, .09208, 0],
    8212: [0, .43056, .09208, 0],
    8216: [0, .69444, .12417, 0],
    8217: [0, .69444, .12417, 0],
    8220: [0, .69444, .1685, 0],
    8221: [0, .69444, .06961, 0],
    8463: b
  },
  "Main-Regular": {
    32: x,
    33: d,
    34: d,
    35: g,
    36: [.05556, .75, 0, 0],
    37: [.05556, .75, 0, 0],
    38: d,
    39: d,
    40: p,
    41: p,
    42: N,
    43: [.08333, .58333, 0, 0],
    44: [.19444, .10556, 0, 0],
    45: [0, .43056, 0, 0],
    46: [0, .10556, 0, 0],
    47: p,
    48: k,
    49: k,
    50: k,
    51: k,
    52: k,
    53: k,
    54: k,
    55: k,
    56: k,
    57: k,
    58: [0, .43056, 0, 0],
    59: [.19444, .43056, 0, 0],
    60: [.0391, .5391, 0, 0],
    61: [-.13313, .36687, 0, 0],
    62: [.0391, .5391, 0, 0],
    63: d,
    64: d,
    65: y,
    66: y,
    67: y,
    68: y,
    69: y,
    70: y,
    71: y,
    72: y,
    73: y,
    74: y,
    75: y,
    76: y,
    77: y,
    78: y,
    79: y,
    80: y,
    81: [.19444, .68333, 0, 0],
    82: y,
    83: y,
    84: y,
    85: y,
    86: [0, .68333, .01389, 0],
    87: [0, .68333, .01389, 0],
    88: y,
    89: [0, .68333, .025, 0],
    90: y,
    91: p,
    92: p,
    93: p,
    94: d,
    95: [.31, .12056, .02778, 0],
    97: [0, .43056, 0, 0],
    98: d,
    99: [0, .43056, 0, 0],
    100: d,
    101: [0, .43056, 0, 0],
    102: [0, .69444, .07778, 0],
    103: [.19444, .43056, .01389, 0],
    104: d,
    105: [0, .66786, 0, 0],
    106: [.19444, .66786, 0, 0],
    107: d,
    108: d,
    109: [0, .43056, 0, 0],
    110: [0, .43056, 0, 0],
    111: [0, .43056, 0, 0],
    112: [.19444, .43056, 0, 0],
    113: [.19444, .43056, 0, 0],
    114: [0, .43056, 0, 0],
    115: [0, .43056, 0, 0],
    116: [0, .61508, 0, 0],
    117: [0, .43056, 0, 0],
    118: [0, .43056, .01389, 0],
    119: [0, .43056, .01389, 0],
    120: [0, .43056, 0, 0],
    121: [.19444, .43056, .01389, 0],
    122: [0, .43056, 0, 0],
    123: p,
    124: p,
    125: p,
    126: [.35, .31786, 0, 0],
    160: x,
    163: d,
    167: g,
    168: [0, .66786, 0, 0],
    172: [0, .43056, 0, 0],
    176: d,
    177: [.08333, .58333, 0, 0],
    182: g,
    184: [.17014, 0, 0, 0],
    198: y,
    215: [.08333, .58333, 0, 0],
    216: [.04861, .73194, 0, 0],
    223: d,
    230: [0, .43056, 0, 0],
    247: [.08333, .58333, 0, 0],
    248: [.09722, .52778, 0, 0],
    305: [0, .43056, 0, 0],
    338: y,
    339: [0, .43056, 0, 0],
    567: [.19444, .43056, 0, 0],
    710: d,
    711: [0, .62847, 0, 0],
    713: [0, .56778, 0, 0],
    714: d,
    715: d,
    728: d,
    729: [0, .66786, 0, 0],
    730: d,
    732: [0, .66786, 0, 0],
    733: d,
    915: y,
    916: y,
    920: y,
    923: y,
    926: y,
    928: y,
    931: y,
    933: y,
    934: y,
    936: y,
    937: y,
    8211: [0, .43056, .02778, 0],
    8212: [0, .43056, .02778, 0],
    8216: d,
    8217: d,
    8220: d,
    8221: d,
    8224: g,
    8225: g,
    8230: [0, .12, 0, 0],
    8242: S,
    8407: [0, .71444, .15382, 0],
    8463: b,
    8465: d,
    8467: [0, .69444, 0, .11111],
    8472: [.19444, .43056, 0, .11111],
    8476: d,
    8501: d,
    8592: [-.13313, .36687, 0, 0],
    8593: g,
    8594: [-.13313, .36687, 0, 0],
    8595: g,
    8596: [-.13313, .36687, 0, 0],
    8597: p,
    8598: g,
    8599: g,
    8600: g,
    8601: g,
    8614: [.011, .511, 0, 0],
    8617: [.011, .511, 0, 0],
    8618: [.011, .511, 0, 0],
    8636: [-.13313, .36687, 0, 0],
    8637: [-.13313, .36687, 0, 0],
    8640: [-.13313, .36687, 0, 0],
    8641: [-.13313, .36687, 0, 0],
    8652: [.011, .671, 0, 0],
    8656: [-.13313, .36687, 0, 0],
    8657: g,
    8658: [-.13313, .36687, 0, 0],
    8659: g,
    8660: [-.13313, .36687, 0, 0],
    8661: p,
    8704: d,
    8706: [0, .69444, .05556, .08334],
    8707: d,
    8709: [.05556, .75, 0, 0],
    8711: y,
    8712: [.0391, .5391, 0, 0],
    8715: [.0391, .5391, 0, 0],
    8722: [.08333, .58333, 0, 0],
    8723: [.08333, .58333, 0, 0],
    8725: p,
    8726: p,
    8727: [-.03472, .46528, 0, 0],
    8728: [-.05555, .44445, 0, 0],
    8729: [-.05555, .44445, 0, 0],
    8730: [.2, .8, 0, 0],
    8733: [0, .43056, 0, 0],
    8734: [0, .43056, 0, 0],
    8736: w,
    8739: p,
    8741: p,
    8743: S,
    8744: S,
    8745: S,
    8746: S,
    8747: [.19444, .69444, .11111, 0],
    8764: [-.13313, .36687, 0, 0],
    8768: g,
    8771: [-.03625, .46375, 0, 0],
    8773: [-.022, .589, 0, 0],
    8776: [-.01688, .48312, 0, 0],
    8781: [-.03625, .46375, 0, 0],
    8784: [-.133, .67, 0, 0],
    8801: [-.03625, .46375, 0, 0],
    8804: [.13597, .63597, 0, 0],
    8805: [.13597, .63597, 0, 0],
    8810: [.0391, .5391, 0, 0],
    8811: [.0391, .5391, 0, 0],
    8826: [.0391, .5391, 0, 0],
    8827: [.0391, .5391, 0, 0],
    8834: [.0391, .5391, 0, 0],
    8835: [.0391, .5391, 0, 0],
    8838: [.13597, .63597, 0, 0],
    8839: [.13597, .63597, 0, 0],
    8846: S,
    8849: [.13597, .63597, 0, 0],
    8850: [.13597, .63597, 0, 0],
    8851: S,
    8852: S,
    8853: [.08333, .58333, 0, 0],
    8854: [.08333, .58333, 0, 0],
    8855: [.08333, .58333, 0, 0],
    8856: [.08333, .58333, 0, 0],
    8857: [.08333, .58333, 0, 0],
    8866: d,
    8867: d,
    8868: d,
    8869: d,
    8872: [.249, .75, 0, 0],
    8900: [-.05555, .44445, 0, 0],
    8901: [-.05555, .44445, 0, 0],
    8902: [-.03472, .46528, 0, 0],
    8904: [.005, .505, 0, 0],
    8942: [.03, .9, 0, 0],
    8943: [-.19, .31, 0, 0],
    8945: [-.1, .82, 0, 0],
    8968: p,
    8969: p,
    8970: p,
    8971: p,
    8994: [-.14236, .35764, 0, 0],
    8995: [-.14236, .35764, 0, 0],
    9136: [.244, .744, 0, 0],
    9137: [.244, .744, 0, 0],
    9651: g,
    9657: [-.03472, .46528, 0, 0],
    9661: g,
    9667: [-.03472, .46528, 0, 0],
    9711: g,
    9824: [.12963, .69444, 0, 0],
    9825: [.12963, .69444, 0, 0],
    9826: [.12963, .69444, 0, 0],
    9827: [.12963, .69444, 0, 0],
    9837: N,
    9838: g,
    9839: g,
    10216: p,
    10217: p,
    10222: [.244, .744, 0, 0],
    10223: [.244, .744, 0, 0],
    10229: [.011, .511, 0, 0],
    10230: [.011, .511, 0, 0],
    10231: [.011, .511, 0, 0],
    10232: [.024, .525, 0, 0],
    10233: [.024, .525, 0, 0],
    10234: [.024, .525, 0, 0],
    10236: [.011, .511, 0, 0],
    10815: y,
    10927: [.13597, .63597, 0, 0],
    10928: [.13597, .63597, 0, 0],
    57376: g
  },
  "Math-BoldItalic": {
    32: x,
    48: m,
    49: m,
    50: m,
    51: _,
    52: _,
    53: _,
    54: k,
    55: _,
    56: k,
    57: _,
    65: f,
    66: [0, .68611, .04835, 0],
    67: [0, .68611, .06979, 0],
    68: [0, .68611, .03194, 0],
    69: [0, .68611, .05451, 0],
    70: [0, .68611, .15972, 0],
    71: f,
    72: [0, .68611, .08229, 0],
    73: [0, .68611, .07778, 0],
    74: [0, .68611, .10069, 0],
    75: [0, .68611, .06979, 0],
    76: f,
    77: [0, .68611, .11424, 0],
    78: [0, .68611, .11424, 0],
    79: [0, .68611, .03194, 0],
    80: [0, .68611, .15972, 0],
    81: [.19444, .68611, 0, 0],
    82: [0, .68611, .00421, 0],
    83: [0, .68611, .05382, 0],
    84: [0, .68611, .15972, 0],
    85: [0, .68611, .11424, 0],
    86: [0, .68611, .25555, 0],
    87: [0, .68611, .15972, 0],
    88: [0, .68611, .07778, 0],
    89: [0, .68611, .25555, 0],
    90: [0, .68611, .06979, 0],
    97: m,
    98: d,
    99: m,
    100: d,
    101: m,
    102: [.19444, .69444, .11042, 0],
    103: [.19444, .44444, .03704, 0],
    104: d,
    105: [0, .69326, 0, 0],
    106: [.19444, .69326, .0622, 0],
    107: [0, .69444, .01852, 0],
    108: [0, .69444, .0088, 0],
    109: m,
    110: m,
    111: m,
    112: _,
    113: [.19444, .44444, .03704, 0],
    114: [0, .44444, .03194, 0],
    115: m,
    116: [0, .63492, 0, 0],
    117: m,
    118: [0, .44444, .03704, 0],
    119: [0, .44444, .02778, 0],
    120: m,
    121: [.19444, .44444, .03704, 0],
    122: [0, .44444, .04213, 0],
    160: x,
    915: [0, .68611, .15972, 0],
    916: f,
    920: [0, .68611, .03194, 0],
    923: f,
    926: [0, .68611, .07458, 0],
    928: [0, .68611, .08229, 0],
    931: [0, .68611, .05451, 0],
    933: [0, .68611, .15972, 0],
    934: f,
    936: [0, .68611, .11653, 0],
    937: [0, .68611, .04835, 0],
    945: m,
    946: [.19444, .69444, .03403, 0],
    947: [.19444, .44444, .06389, 0],
    948: [0, .69444, .03819, 0],
    949: m,
    950: [.19444, .69444, .06215, 0],
    951: [.19444, .44444, .03704, 0],
    952: [0, .69444, .03194, 0],
    953: m,
    954: m,
    955: d,
    956: _,
    957: [0, .44444, .06898, 0],
    958: [.19444, .69444, .03021, 0],
    959: m,
    960: [0, .44444, .03704, 0],
    961: _,
    962: [.09722, .44444, .07917, 0],
    963: [0, .44444, .03704, 0],
    964: [0, .44444, .13472, 0],
    965: [0, .44444, .03704, 0],
    966: _,
    967: _,
    968: [.19444, .69444, .03704, 0],
    969: [0, .44444, .03704, 0],
    977: d,
    981: g,
    982: [0, .44444, .03194, 0],
    1009: _,
    1013: m,
    57649: m,
    57911: _
  },
  "Math-Italic": {
    32: x,
    48: [0, .43056, 0, 0],
    49: [0, .43056, 0, 0],
    50: [0, .43056, 0, 0],
    51: [.19444, .43056, 0, 0],
    52: [.19444, .43056, 0, 0],
    53: [.19444, .43056, 0, 0],
    54: k,
    55: [.19444, .43056, 0, 0],
    56: k,
    57: [.19444, .43056, 0, 0],
    65: [0, .68333, 0, .13889],
    66: [0, .68333, .05017, .08334],
    67: [0, .68333, .07153, .08334],
    68: [0, .68333, .02778, .05556],
    69: [0, .68333, .05764, .08334],
    70: [0, .68333, .13889, .08334],
    71: [0, .68333, 0, .08334],
    72: [0, .68333, .08125, .05556],
    73: [0, .68333, .07847, .11111],
    74: [0, .68333, .09618, .16667],
    75: [0, .68333, .07153, .05556],
    76: [0, .68333, 0, .02778],
    77: [0, .68333, .10903, .08334],
    78: [0, .68333, .10903, .08334],
    79: [0, .68333, .02778, .08334],
    80: [0, .68333, .13889, .08334],
    81: [.19444, .68333, 0, .08334],
    82: [0, .68333, .00773, .08334],
    83: [0, .68333, .05764, .08334],
    84: [0, .68333, .13889, .08334],
    85: [0, .68333, .10903, .02778],
    86: [0, .68333, .22222, 0],
    87: [0, .68333, .13889, 0],
    88: [0, .68333, .07847, .08334],
    89: [0, .68333, .22222, 0],
    90: [0, .68333, .07153, .08334],
    97: [0, .43056, 0, 0],
    98: d,
    99: [0, .43056, 0, .05556],
    100: [0, .69444, 0, .16667],
    101: [0, .43056, 0, .05556],
    102: [.19444, .69444, .10764, .16667],
    103: [.19444, .43056, .03588, .02778],
    104: d,
    105: [0, .65952, 0, 0],
    106: [.19444, .65952, .05724, 0],
    107: [0, .69444, .03148, 0],
    108: [0, .69444, .01968, .08334],
    109: [0, .43056, 0, 0],
    110: [0, .43056, 0, 0],
    111: [0, .43056, 0, .05556],
    112: [.19444, .43056, 0, .08334],
    113: [.19444, .43056, .03588, .08334],
    114: [0, .43056, .02778, .05556],
    115: [0, .43056, 0, .05556],
    116: [0, .61508, 0, .08334],
    117: [0, .43056, 0, .02778],
    118: [0, .43056, .03588, .02778],
    119: [0, .43056, .02691, .08334],
    120: [0, .43056, 0, .02778],
    121: [.19444, .43056, .03588, .05556],
    122: [0, .43056, .04398, .05556],
    160: x,
    915: [0, .68333, .13889, .08334],
    916: [0, .68333, 0, .16667],
    920: [0, .68333, .02778, .08334],
    923: [0, .68333, 0, .16667],
    926: [0, .68333, .07569, .08334],
    928: [0, .68333, .08125, .05556],
    931: [0, .68333, .05764, .08334],
    933: [0, .68333, .13889, .05556],
    934: [0, .68333, 0, .08334],
    936: [0, .68333, .11, .05556],
    937: [0, .68333, .05017, .08334],
    945: [0, .43056, .0037, .02778],
    946: [.19444, .69444, .05278, .08334],
    947: [.19444, .43056, .05556, 0],
    948: [0, .69444, .03785, .05556],
    949: [0, .43056, 0, .08334],
    950: [.19444, .69444, .07378, .08334],
    951: [.19444, .43056, .03588, .05556],
    952: [0, .69444, .02778, .08334],
    953: [0, .43056, 0, .05556],
    954: [0, .43056, 0, 0],
    955: d,
    956: [.19444, .43056, 0, .02778],
    957: [0, .43056, .06366, .02778],
    958: [.19444, .69444, .04601, .11111],
    959: [0, .43056, 0, .05556],
    960: [0, .43056, .03588, 0],
    961: [.19444, .43056, 0, .08334],
    962: [.09722, .43056, .07986, .08334],
    963: [0, .43056, .03588, 0],
    964: [0, .43056, .1132, .02778],
    965: [0, .43056, .03588, .02778],
    966: [.19444, .43056, 0, .08334],
    967: [.19444, .43056, 0, .05556],
    968: [.19444, .69444, .03588, .11111],
    969: [0, .43056, .03588, 0],
    977: [0, .69444, 0, .08334],
    981: [.19444, .69444, 0, .08334],
    982: [0, .43056, .02778, 0],
    1009: [.19444, .43056, 0, .08334],
    1013: [0, .43056, 0, .05556],
    57649: [0, .43056, 0, .02778],
    57911: [.19444, .43056, 0, .08334]
  },
  "SansSerif-Bold": {
    32: x,
    33: d,
    34: d,
    35: g,
    36: [.05556, .75, 0, 0],
    37: [.05556, .75, 0, 0],
    38: d,
    39: d,
    40: p,
    41: p,
    42: N,
    43: [.11667, .61667, 0, 0],
    44: [.10556, .13056, 0, 0],
    45: [0, .45833, 0, 0],
    46: [0, .13056, 0, 0],
    47: p,
    48: d,
    49: d,
    50: d,
    51: d,
    52: d,
    53: d,
    54: d,
    55: d,
    56: d,
    57: d,
    58: [0, .45833, 0, 0],
    59: [.10556, .45833, 0, 0],
    61: [-.09375, .40625, 0, 0],
    63: d,
    64: d,
    65: d,
    66: d,
    67: d,
    68: d,
    69: d,
    70: d,
    71: d,
    72: d,
    73: d,
    74: d,
    75: d,
    76: d,
    77: d,
    78: d,
    79: d,
    80: d,
    81: [.10556, .69444, 0, 0],
    82: d,
    83: d,
    84: d,
    85: d,
    86: [0, .69444, .01528, 0],
    87: [0, .69444, .01528, 0],
    88: d,
    89: [0, .69444, .0275, 0],
    90: d,
    91: p,
    93: p,
    94: d,
    95: [.35, .10833, .03056, 0],
    97: [0, .45833, 0, 0],
    98: d,
    99: [0, .45833, 0, 0],
    100: d,
    101: [0, .45833, 0, 0],
    102: [0, .69444, .07639, 0],
    103: [.19444, .45833, .01528, 0],
    104: d,
    105: d,
    106: g,
    107: d,
    108: d,
    109: [0, .45833, 0, 0],
    110: [0, .45833, 0, 0],
    111: [0, .45833, 0, 0],
    112: [.19444, .45833, 0, 0],
    113: [.19444, .45833, 0, 0],
    114: [0, .45833, .01528, 0],
    115: [0, .45833, 0, 0],
    116: [0, .58929, 0, 0],
    117: [0, .45833, 0, 0],
    118: [0, .45833, .01528, 0],
    119: [0, .45833, .01528, 0],
    120: [0, .45833, 0, 0],
    121: [.19444, .45833, .01528, 0],
    122: [0, .45833, 0, 0],
    126: [.35, .34444, 0, 0],
    160: x,
    168: d,
    176: d,
    180: d,
    184: [.17014, 0, 0, 0],
    305: [0, .45833, 0, 0],
    567: [.19444, .45833, 0, 0],
    710: d,
    711: [0, .63542, 0, 0],
    713: [0, .63778, 0, 0],
    728: d,
    729: d,
    730: d,
    732: d,
    733: d,
    915: d,
    916: d,
    920: d,
    923: d,
    926: d,
    928: d,
    931: d,
    933: d,
    934: d,
    936: d,
    937: d,
    8211: [0, .45833, .03056, 0],
    8212: [0, .45833, .03056, 0],
    8216: d,
    8217: d,
    8220: d,
    8221: d
  },
  "SansSerif-Italic": {
    32: x,
    33: [0, .69444, .05733, 0],
    34: [0, .69444, .00316, 0],
    35: [.19444, .69444, .05087, 0],
    36: [.05556, .75, .11156, 0],
    37: [.05556, .75, .03126, 0],
    38: [0, .69444, .03058, 0],
    39: [0, .69444, .07816, 0],
    40: [.25, .75, .13164, 0],
    41: [.25, .75, .02536, 0],
    42: [0, .75, .11775, 0],
    43: [.08333, .58333, .02536, 0],
    44: [.125, .08333, 0, 0],
    45: [0, .44444, .01946, 0],
    46: [0, .08333, 0, 0],
    47: [.25, .75, .13164, 0],
    48: [0, .65556, .11156, 0],
    49: [0, .65556, .11156, 0],
    50: [0, .65556, .11156, 0],
    51: [0, .65556, .11156, 0],
    52: [0, .65556, .11156, 0],
    53: [0, .65556, .11156, 0],
    54: [0, .65556, .11156, 0],
    55: [0, .65556, .11156, 0],
    56: [0, .65556, .11156, 0],
    57: [0, .65556, .11156, 0],
    58: [0, .44444, .02502, 0],
    59: [.125, .44444, .02502, 0],
    61: [-.13, .37, .05087, 0],
    63: [0, .69444, .11809, 0],
    64: [0, .69444, .07555, 0],
    65: d,
    66: [0, .69444, .08293, 0],
    67: [0, .69444, .11983, 0],
    68: [0, .69444, .07555, 0],
    69: [0, .69444, .11983, 0],
    70: [0, .69444, .13372, 0],
    71: [0, .69444, .11983, 0],
    72: [0, .69444, .08094, 0],
    73: [0, .69444, .13372, 0],
    74: [0, .69444, .08094, 0],
    75: [0, .69444, .11983, 0],
    76: d,
    77: [0, .69444, .08094, 0],
    78: [0, .69444, .08094, 0],
    79: [0, .69444, .07555, 0],
    80: [0, .69444, .08293, 0],
    81: [.125, .69444, .07555, 0],
    82: [0, .69444, .08293, 0],
    83: [0, .69444, .09205, 0],
    84: [0, .69444, .13372, 0],
    85: [0, .69444, .08094, 0],
    86: [0, .69444, .1615, 0],
    87: [0, .69444, .1615, 0],
    88: [0, .69444, .13372, 0],
    89: [0, .69444, .17261, 0],
    90: [0, .69444, .11983, 0],
    91: [.25, .75, .15942, 0],
    93: [.25, .75, .08719, 0],
    94: [0, .69444, .0799, 0],
    95: [.35, .09444, .08616, 0],
    97: [0, .44444, .00981, 0],
    98: [0, .69444, .03057, 0],
    99: [0, .44444, .08336, 0],
    100: [0, .69444, .09483, 0],
    101: [0, .44444, .06778, 0],
    102: [0, .69444, .21705, 0],
    103: [.19444, .44444, .10836, 0],
    104: [0, .69444, .01778, 0],
    105: [0, .67937, .09718, 0],
    106: [.19444, .67937, .09162, 0],
    107: [0, .69444, .08336, 0],
    108: [0, .69444, .09483, 0],
    109: [0, .44444, .01778, 0],
    110: [0, .44444, .01778, 0],
    111: [0, .44444, .06613, 0],
    112: [.19444, .44444, .0389, 0],
    113: [.19444, .44444, .04169, 0],
    114: [0, .44444, .10836, 0],
    115: [0, .44444, .0778, 0],
    116: [0, .57143, .07225, 0],
    117: [0, .44444, .04169, 0],
    118: [0, .44444, .10836, 0],
    119: [0, .44444, .10836, 0],
    120: [0, .44444, .09169, 0],
    121: [.19444, .44444, .10836, 0],
    122: [0, .44444, .08752, 0],
    126: [.35, .32659, .08826, 0],
    160: x,
    168: [0, .67937, .06385, 0],
    176: d,
    184: [.17014, 0, 0, 0],
    305: [0, .44444, .04169, 0],
    567: [.19444, .44444, .04169, 0],
    710: [0, .69444, .0799, 0],
    711: [0, .63194, .08432, 0],
    713: [0, .60889, .08776, 0],
    714: [0, .69444, .09205, 0],
    715: d,
    728: [0, .69444, .09483, 0],
    729: [0, .67937, .07774, 0],
    730: d,
    732: [0, .67659, .08826, 0],
    733: [0, .69444, .09205, 0],
    915: [0, .69444, .13372, 0],
    916: d,
    920: [0, .69444, .07555, 0],
    923: d,
    926: [0, .69444, .12816, 0],
    928: [0, .69444, .08094, 0],
    931: [0, .69444, .11983, 0],
    933: [0, .69444, .09031, 0],
    934: [0, .69444, .04603, 0],
    936: [0, .69444, .09031, 0],
    937: [0, .69444, .08293, 0],
    8211: [0, .44444, .08616, 0],
    8212: [0, .44444, .08616, 0],
    8216: [0, .69444, .07816, 0],
    8217: [0, .69444, .07816, 0],
    8220: [0, .69444, .14205, 0],
    8221: [0, .69444, .00316, 0]
  },
  "SansSerif-Regular": {
    32: x,
    33: d,
    34: d,
    35: g,
    36: [.05556, .75, 0, 0],
    37: [.05556, .75, 0, 0],
    38: d,
    39: d,
    40: p,
    41: p,
    42: N,
    43: [.08333, .58333, 0, 0],
    44: [.125, .08333, 0, 0],
    45: m,
    46: [0, .08333, 0, 0],
    47: p,
    48: [0, .65556, 0, 0],
    49: [0, .65556, 0, 0],
    50: [0, .65556, 0, 0],
    51: [0, .65556, 0, 0],
    52: [0, .65556, 0, 0],
    53: [0, .65556, 0, 0],
    54: [0, .65556, 0, 0],
    55: [0, .65556, 0, 0],
    56: [0, .65556, 0, 0],
    57: [0, .65556, 0, 0],
    58: m,
    59: [.125, .44444, 0, 0],
    61: [-.13, .37, 0, 0],
    63: d,
    64: d,
    65: d,
    66: d,
    67: d,
    68: d,
    69: d,
    70: d,
    71: d,
    72: d,
    73: d,
    74: d,
    75: d,
    76: d,
    77: d,
    78: d,
    79: d,
    80: d,
    81: [.125, .69444, 0, 0],
    82: d,
    83: d,
    84: d,
    85: d,
    86: [0, .69444, .01389, 0],
    87: [0, .69444, .01389, 0],
    88: d,
    89: [0, .69444, .025, 0],
    90: d,
    91: p,
    93: p,
    94: d,
    95: [.35, .09444, .02778, 0],
    97: m,
    98: d,
    99: m,
    100: d,
    101: m,
    102: [0, .69444, .06944, 0],
    103: [.19444, .44444, .01389, 0],
    104: d,
    105: [0, .67937, 0, 0],
    106: [.19444, .67937, 0, 0],
    107: d,
    108: d,
    109: m,
    110: m,
    111: m,
    112: _,
    113: _,
    114: [0, .44444, .01389, 0],
    115: m,
    116: [0, .57143, 0, 0],
    117: m,
    118: [0, .44444, .01389, 0],
    119: [0, .44444, .01389, 0],
    120: m,
    121: [.19444, .44444, .01389, 0],
    122: m,
    126: [.35, .32659, 0, 0],
    160: x,
    168: [0, .67937, 0, 0],
    176: d,
    184: [.17014, 0, 0, 0],
    305: m,
    567: _,
    710: d,
    711: [0, .63194, 0, 0],
    713: [0, .60889, 0, 0],
    714: d,
    715: d,
    728: d,
    729: [0, .67937, 0, 0],
    730: d,
    732: [0, .67659, 0, 0],
    733: d,
    915: d,
    916: d,
    920: d,
    923: d,
    926: d,
    928: d,
    931: d,
    933: d,
    934: d,
    936: d,
    937: d,
    8211: [0, .44444, .02778, 0],
    8212: [0, .44444, .02778, 0],
    8216: d,
    8217: d,
    8220: d,
    8221: d
  },
  "Script-Regular": {
    32: x,
    65: [0, .7, .22925, 0],
    66: [0, .7, .04087, 0],
    67: [0, .7, .1689, 0],
    68: [0, .7, .09371, 0],
    69: [0, .7, .18583, 0],
    70: [0, .7, .13634, 0],
    71: [0, .7, .17322, 0],
    72: [0, .7, .29694, 0],
    73: [0, .7, .19189, 0],
    74: [.27778, .7, .19189, 0],
    75: [0, .7, .31259, 0],
    76: [0, .7, .19189, 0],
    77: [0, .7, .15981, 0],
    78: [0, .7, .3525, 0],
    79: [0, .7, .08078, 0],
    80: [0, .7, .08078, 0],
    81: [0, .7, .03305, 0],
    82: [0, .7, .06259, 0],
    83: [0, .7, .19189, 0],
    84: [0, .7, .29087, 0],
    85: [0, .7, .25815, 0],
    86: [0, .7, .27523, 0],
    87: [0, .7, .27523, 0],
    88: [0, .7, .26006, 0],
    89: [0, .7, .2939, 0],
    90: [0, .7, .24037, 0],
    160: x
  },
  "Size1-Regular": {
    32: x,
    40: L,
    41: L,
    47: L,
    91: L,
    92: L,
    93: L,
    123: L,
    125: L,
    160: x,
    710: [0, .72222, 0, 0],
    732: [0, .72222, 0, 0],
    770: [0, .72222, 0, 0],
    771: [0, .72222, 0, 0],
    8214: [-99e-5, .601, 0, 0],
    8593: [1e-5, .6, 0, 0],
    8595: [1e-5, .6, 0, 0],
    8657: [1e-5, .6, 0, 0],
    8659: [1e-5, .6, 0, 0],
    8719: q,
    8720: q,
    8721: q,
    8730: L,
    8739: [-.00599, .606, 0, 0],
    8741: [-.00599, .606, 0, 0],
    8747: [.30612, .805, .19445, 0],
    8748: [.306, .805, .19445, 0],
    8749: [.306, .805, .19445, 0],
    8750: [.30612, .805, .19445, 0],
    8896: q,
    8897: q,
    8898: q,
    8899: q,
    8968: L,
    8969: L,
    8970: L,
    8971: L,
    9168: [-99e-5, .601, 0, 0],
    10216: L,
    10217: L,
    10752: q,
    10753: q,
    10754: q,
    10756: q,
    10758: q
  },
  "Size2-Regular": {
    32: x,
    40: M,
    41: M,
    47: M,
    91: M,
    92: M,
    93: M,
    123: M,
    125: M,
    160: x,
    710: N,
    732: N,
    770: N,
    771: N,
    8719: D,
    8720: D,
    8721: D,
    8730: M,
    8747: [.86225, 1.36, .44445, 0],
    8748: [.862, 1.36, .44445, 0],
    8749: [.862, 1.36, .44445, 0],
    8750: [.86225, 1.36, .44445, 0],
    8896: D,
    8897: D,
    8898: D,
    8899: D,
    8968: M,
    8969: M,
    8970: M,
    8971: M,
    10216: M,
    10217: M,
    10752: D,
    10753: D,
    10754: D,
    10756: D,
    10758: D
  },
  "Size3-Regular": {
    32: x,
    40: A,
    41: A,
    47: A,
    91: A,
    92: A,
    93: A,
    123: A,
    125: A,
    160: x,
    710: N,
    732: N,
    770: N,
    771: N,
    8730: A,
    8968: A,
    8969: A,
    8970: A,
    8971: A,
    10216: A,
    10217: A
  },
  "Size4-Regular": {
    32: x,
    40: C,
    41: C,
    47: C,
    91: C,
    92: C,
    93: C,
    123: C,
    125: C,
    160: x,
    710: [0, .825, 0, 0],
    732: [0, .825, 0, 0],
    770: [0, .825, 0, 0],
    771: [0, .825, 0, 0],
    8730: C,
    8968: C,
    8969: C,
    8970: C,
    8971: C,
    9115: [.64502, 1.155, 0, 0],
    9116: [1e-5, .6, 0, 0],
    9117: [.64502, 1.155, 0, 0],
    9118: [.64502, 1.155, 0, 0],
    9119: [1e-5, .6, 0, 0],
    9120: [.64502, 1.155, 0, 0],
    9121: [.64502, 1.155, 0, 0],
    9122: [-99e-5, .601, 0, 0],
    9123: [.64502, 1.155, 0, 0],
    9124: [.64502, 1.155, 0, 0],
    9125: [-99e-5, .601, 0, 0],
    9126: [.64502, 1.155, 0, 0],
    9127: [1e-5, .9, 0, 0],
    9128: M,
    9129: [.90001, 0, 0, 0],
    9130: [0, .3, 0, 0],
    9131: [1e-5, .9, 0, 0],
    9132: M,
    9133: [.90001, 0, 0, 0],
    9143: [.88502, .915, 0, 0],
    10216: C,
    10217: C,
    57344: [-.00499, .605, 0, 0],
    57345: [-.00499, .605, 0, 0],
    57680: [0, .12, 0, 0],
    57681: [0, .12, 0, 0],
    57682: [0, .12, 0, 0],
    57683: [0, .12, 0, 0]
  },
  "Typewriter-Regular": {
    32: x,
    33: h,
    34: h,
    35: h,
    36: [.08333, .69444, 0, 0],
    37: [.08333, .69444, 0, 0],
    38: h,
    39: h,
    40: [.08333, .69444, 0, 0],
    41: [.08333, .69444, 0, 0],
    42: [0, .52083, 0, 0],
    43: [-.08056, .53055, 0, 0],
    44: [.13889, .125, 0, 0],
    45: [-.08056, .53055, 0, 0],
    46: [0, .125, 0, 0],
    47: [.08333, .69444, 0, 0],
    48: h,
    49: h,
    50: h,
    51: h,
    52: h,
    53: h,
    54: h,
    55: h,
    56: h,
    57: h,
    58: [0, .43056, 0, 0],
    59: [.13889, .43056, 0, 0],
    60: [-.05556, .55556, 0, 0],
    61: [-.19549, .41562, 0, 0],
    62: [-.05556, .55556, 0, 0],
    63: h,
    64: h,
    65: h,
    66: h,
    67: h,
    68: h,
    69: h,
    70: h,
    71: h,
    72: h,
    73: h,
    74: h,
    75: h,
    76: h,
    77: h,
    78: h,
    79: h,
    80: h,
    81: [.13889, .61111, 0, 0],
    82: h,
    83: h,
    84: h,
    85: h,
    86: h,
    87: h,
    88: h,
    89: h,
    90: h,
    91: [.08333, .69444, 0, 0],
    92: [.08333, .69444, 0, 0],
    93: [.08333, .69444, 0, 0],
    94: h,
    95: [.09514, 0, 0, 0],
    96: h,
    97: [0, .43056, 0, 0],
    98: h,
    99: [0, .43056, 0, 0],
    100: h,
    101: [0, .43056, 0, 0],
    102: h,
    103: [.22222, .43056, 0, 0],
    104: h,
    105: h,
    106: [.22222, .61111, 0, 0],
    107: h,
    108: h,
    109: [0, .43056, 0, 0],
    110: [0, .43056, 0, 0],
    111: [0, .43056, 0, 0],
    112: [.22222, .43056, 0, 0],
    113: [.22222, .43056, 0, 0],
    114: [0, .43056, 0, 0],
    115: [0, .43056, 0, 0],
    116: [0, .55358, 0, 0],
    117: [0, .43056, 0, 0],
    118: [0, .43056, 0, 0],
    119: [0, .43056, 0, 0],
    120: [0, .43056, 0, 0],
    121: [.22222, .43056, 0, 0],
    122: [0, .43056, 0, 0],
    123: [.08333, .69444, 0, 0],
    124: [.08333, .69444, 0, 0],
    125: [.08333, .69444, 0, 0],
    126: h,
    127: h,
    160: x,
    176: h,
    184: [.19445, 0, 0, 0],
    305: [0, .43056, 0, 0],
    567: [.22222, .43056, 0, 0],
    711: [0, .56597, 0, 0],
    713: [0, .56555, 0, 0],
    714: h,
    715: h,
    728: h,
    730: h,
    770: h,
    771: h,
    776: h,
    915: h,
    916: h,
    920: h,
    923: h,
    926: h,
    928: h,
    931: h,
    933: h,
    934: h,
    936: h,
    937: h,
    8216: h,
    8217: h,
    8242: h,
    9251: [.11111, .21944, 0, 0]
  }
};
var B = /[\u3040-\u309F]|[\u30A0-\u30FF]|[\u4E00-\u9FAF]|[\uAC00-\uD7AF]/,
  K = {
    slant: [.25, .25, .25],
    space: [0, 0, 0],
    stretch: [0, 0, 0],
    shrink: [0, 0, 0],
    xHeight: [.431, .431, .431],
    quad: [1, 1.171, 1.472],
    extraSpace: [0, 0, 0],
    num1: [.677, .732, .925],
    num2: [.394, .384, .387],
    num3: [.444, .471, .504],
    denom1: [.686, .752, 1.025],
    denom2: [.345, .344, .532],
    sup1: [.413, .503, .504],
    sup2: [.363, .431, .404],
    sup3: [.289, .286, .294],
    sub1: [.15, .143, .2],
    sub2: [.247, .286, .4],
    supDrop: [.386, .353, .494],
    subDrop: [.05, .071, .1],
    delim1: [2.39, 1.7, 1.98],
    delim2: [1.01, 1.157, 1.42],
    axisHeight: [.25, .25, .25],
    defaultRuleThickness: [.04, .049, .049],
    bigOpSpacing1: [.111, .111, .111],
    bigOpSpacing2: [.166, .166, .166],
    bigOpSpacing3: [.2, .2, .2],
    bigOpSpacing4: [.6, .611, .611],
    bigOpSpacing5: [.1, .143, .143],
    sqrtRuleThickness: [.04, .04, .04]
  },
  F = [0, .5, .7, .8, .9, 1, 1.2, 1.44, 1.728, 2.074, 2.488],
  $ = {
    "\xa0": " ",
    "\u200B": " ",
    "\xc5": "A",
    "\xc7": "C",
    "\xd0": "D",
    "\xde": "o",
    "\xe5": "a",
    "\xe7": "c",
    "\xf0": "d",
    "\xfe": "o",
    "\u0410": "A",
    "\u0411": "B",
    "\u0412": "B",
    "\u0413": "F",
    "\u0414": "A",
    "\u0415": "E",
    "\u0416": "K",
    "\u0417": "3",
    "\u0418": "N",
    "\u0419": "N",
    "\u041A": "K",
    "\u041B": "N",
    "\u041C": "M",
    "\u041D": "H",
    "\u041E": "O",
    "\u041F": "N",
    "\u0420": "P",
    "\u0421": "C",
    "\u0422": "T",
    "\u0423": "y",
    "\u0424": "O",
    "\u0425": "X",
    "\u0426": "U",
    "\u0427": "h",
    "\u0428": "W",
    "\u0429": "W",
    "\u042A": "B",
    "\u042B": "X",
    "\u042C": "B",
    "\u042D": "3",
    "\u042E": "X",
    "\u042F": "R",
    "\u0430": "a",
    "\u0431": "b",
    "\u0432": "a",
    "\u0433": "r",
    "\u0434": "y",
    "\u0435": "e",
    "\u0436": "m",
    "\u0437": "e",
    "\u0438": "n",
    "\u0439": "n",
    "\u043A": "n",
    "\u043B": "n",
    "\u043C": "m",
    "\u043D": "n",
    "\u043E": "o",
    "\u043F": "n",
    "\u0440": "p",
    "\u0441": "c",
    "\u0442": "o",
    "\u0443": "y",
    "\u0444": "b",
    "\u0445": "x",
    "\u0446": "n",
    "\u0447": "n",
    "\u0448": "w",
    "\u0449": "w",
    "\u044A": "a",
    "\u044B": "m",
    "\u044C": "a",
    "\u044D": "e",
    "\u044E": "m",
    "\u044F": "r"
  };
function P(e, t) {
  void 0 === e && (e = 77);
  var i = O[t][e];
  if (i) return {
    defaultMetrics: !1,
    depth: i[0],
    height: i[1],
    italic: i[2],
    skew: i[3]
  };
  if (11034 === e) return {
    defaultMetrics: !0,
    depth: .2,
    height: .8,
    italic: 0,
    skew: 0
  };
  var r = String.fromCodePoint(e);
  if (r in $) e = $[r].codePointAt(0);else if (B.test(r)) return e = 77, {
    defaultMetrics: !0,
    depth: .2,
    height: .9,
    italic: 0,
    skew: 0
  };
  return {
    defaultMetrics: !0,
    depth: .2,
    height: .7,
    italic: 0,
    skew: 0
  };
}
var I = /*#__PURE__*/function () {
  function I(e, t, i) {
    _classCallCheck(this, I);
    this.id = e, this.sizeDelta = t, this.cramped = i;
    var r = {
      "-4": 2,
      "-3": 1,
      0: 0
    }[t];
    this.metrics = Object.keys(K).reduce(function (e, t) {
      return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t, K[t][r]));
    }, {});
  }
  _createClass(I, [{
    key: "getFontSize",
    value: function getFontSize(e) {
      return Math.max(1, e + this.sizeDelta);
    }
  }, {
    key: "sup",
    get: function get() {
      return R[[0, 1, 0, 1, 2, 3, 2, 3][this.id]];
    }
  }, {
    key: "sub",
    get: function get() {
      return R[[0, 0, 0, 0, 2, 2, 2, 2][this.id]];
    }
  }, {
    key: "fracNum",
    get: function get() {
      return R[[0, 1, 0, 1, 2, 3, 4, 5][this.id]];
    }
  }, {
    key: "fracDen",
    get: function get() {
      return R[[0, 0, 0, 0, 2, 2, 4, 4][this.id]];
    }
  }, {
    key: "cramp",
    get: function get() {
      return R[[0, 0, 2, 2, 4, 4, 6, 6][this.id]];
    }
  }, {
    key: "isTight",
    get: function get() {
      return this.sizeDelta < 0;
    }
  }]);
  return I;
}();
var R = {
  7: new I(7, 0, !1),
  6: new I(6, 0, !0),
  5: new I(5, 0, !1),
  4: new I(4, 0, !0),
  3: new I(3, -3, !1),
  2: new I(2, -3, !0),
  1: new I(1, -4, !1),
  0: new I(0, -4, !0)
};
function V(e, t) {
  return null === e ? 0 : function (e, t) {
    var i;
    if (!e) return 0;
    var r = {
      pt: 1,
      mm: 7227 / 2540,
      cm: 7227 / 254,
      ex: 35271 / 8192,
      px: 3 / 4,
      em: 10,
      bp: 1.00375,
      dd: 1238 / 1157,
      pc: 12,
      in: 72.27,
      mu: 10 / 18
    }[null !== (i = e.unit) && void 0 !== i ? i : "pt"];
    if (Number.isFinite(t)) {
      var _i3 = Math.pow(10, t);
      return Math.round(e.dimension / 10 * r * _i3) / _i3;
    }
    return e.dimension * r;
  }(e, t) / 10;
}
function j(e) {
  var t;
  return "".concat(e.dimension).concat(null !== (t = e.unit) && void 0 !== t ? t : "pt");
}
R.displaystyle = R[7], R.textstyle = R[5], R.scriptstyle = R[3], R.scriptscriptstyle = R[1];
var H = /*#__PURE__*/function () {
  function H(e, t, i) {
    _classCallCheck(this, H);
    var r, n, a, o, s, l, d, h, p, m;
    e instanceof H && (this.parent = e), e instanceof H || (this.registers = null !== (r = e.registers) && void 0 !== r ? r : {}), this.isSelected = null !== (a = null !== (n = null == t ? void 0 : t.isSelected) && void 0 !== n ? n : null == e ? void 0 : e.isSelected) && void 0 !== a && a, this.isPhantom = null !== (l = null !== (o = null == t ? void 0 : t.isPhantom) && void 0 !== o ? o : null === (s = this.parent) || void 0 === s ? void 0 : s.isPhantom) && void 0 !== l && l;
    var f = _objectSpread({}, e);
    if (t) {
      var _e4;
      t.fontSize && "auto" !== t.fontSize && t.fontSize !== (null === (d = this.parent) || void 0 === d ? void 0 : d._size) && (_e4 = t.fontSize), t.letterShapeStyle && "auto" !== t.letterShapeStyle && (f.letterShapeStyle = t.letterShapeStyle), t.color && "none" !== t.color && (f.color = t.color), t.backgroundColor && "none" !== t.backgroundColor && (f.backgroundColor = this.isSelected ? function (e) {
        var t = function (e) {
          if (!e) return;
          if ("#" !== e[0]) return;
          var t;
          return (e = e.slice(1)).length <= 4 ? (t = {
            r: parseInt(e[0] + e[0], 16),
            g: parseInt(e[1] + e[1], 16),
            b: parseInt(e[2] + e[2], 16)
          }, 4 === e.length && (t.a = parseInt(e[3] + e[3], 16) / 255)) : (t = {
            r: parseInt(e[0] + e[1], 16),
            g: parseInt(e[2] + e[3], 16),
            b: parseInt(e[4] + e[5], 16)
          }, 8 === e.length && (t.a = parseInt(e[6] + e[7], 16) / 255)), t && void 0 === t.a && (t.a = 1), t;
        }(e);
        if (!t) return e;
        var _ref = function (e) {
            var t = e.r,
              i = e.g,
              r = e.b;
            t /= 255, i /= 255, r /= 255;
            var n = Math.min(t, i, r),
              a = Math.max(t, i, r),
              o = a - n;
            var s, l;
            a === n ? s = 0 : t === a ? s = (i - r) / o : i === a ? s = 2 + (r - t) / o : r === a && (s = 4 + (t - i) / o), s = Math.min(60 * s, 360), s < 0 && (s += 360);
            var c = (n + a) / 2;
            return l = a === n ? 0 : c <= .5 ? o / (a + n) : o / (2 - a - n), {
              h: s,
              s: l,
              l: c
            };
          }(t),
          i = _ref.h,
          r = _ref.s,
          n = _ref.l;
        return r += .1, n -= .1, function (e) {
          var t = e.r,
            i = e.g,
            r = e.b;
          var n = ((1 << 24) + (u(t) << 16) + (u(i) << 8) + u(r)).toString(16).slice(1);
          return n[0] === n[1] && n[2] === n[3] && n[4] === n[5] && n[6] === n[7] && (n = n[0] + n[2] + n[4]), "#" + n;
        }(function (e) {
          var _ref2 = [e.h, e.s, e.l],
            t = _ref2[0],
            i = _ref2[1],
            r = _ref2[2];
          t = (t + 360) % 360 / 60, r = Math.max(0, Math.min(r, 1)), i = Math.max(0, Math.min(i, 1));
          var n = r <= .5 ? r * (i + 1) : r + i - r * i,
            a = 2 * r - n;
          return {
            r: Math.round(255 * c(a, n, t + 2)),
            g: Math.round(255 * c(a, n, t)),
            b: Math.round(255 * c(a, n, t - 2))
          };
        }({
          h: i,
          s: r,
          l: n
        }));
      }(t.backgroundColor) : t.backgroundColor), this._size = _e4;
    }
    var g;
    if (this.letterShapeStyle = null !== (h = f.letterShapeStyle) && void 0 !== h ? h : "tex", this.color = f.color, this.backgroundColor = f.backgroundColor, "string" == typeof i) {
      if (e instanceof H) switch (i) {
        case "cramp":
          g = e.mathstyle.cramp;
          break;
        case "superscript":
          g = e.mathstyle.sup;
          break;
        case "subscript":
          g = e.mathstyle.sub;
          break;
        case "numerator":
          g = e.mathstyle.fracNum;
          break;
        case "denominator":
          g = e.mathstyle.fracDen;
      }
      switch (i) {
        case "textstyle":
          g = R.textstyle;
          break;
        case "displaystyle":
          g = R.displaystyle;
          break;
        case "scriptstyle":
          g = R.scriptstyle;
          break;
        case "scriptscriptstyle":
          g = R.scriptscriptstyle;
      }
    }
    this._mathstyle = g, this.atomIdsSettings = e.atomIdsSettings, this.macros = null !== (p = f.macros) && void 0 !== p ? p : {}, this.smartFence = null !== (m = f.smartFence) && void 0 !== m && m, this.renderPlaceholder = f.renderPlaceholder;
  }
  _createClass(H, [{
    key: "mathstyle",
    get: function get() {
      var e = this._mathstyle,
        t = this.parent;
      for (; !e;) e = t._mathstyle, t = t.parent;
      return e;
    }
  }, {
    key: "getRegister",
    value: function getRegister(e) {
      var t;
      return (null === (t = this.registers) || void 0 === t ? void 0 : t[e]) ? this.registers[e] : this.parent ? this.parent.getRegister(e) : void 0;
    }
  }, {
    key: "getRegisterAsGlue",
    value: function getRegisterAsGlue(e) {
      var t;
      if (null === (t = this.registers) || void 0 === t ? void 0 : t[e]) {
        var _t3 = this.registers[e];
        return "object" == typeof _t3 && "glue" in _t3 ? _t3 : "object" == typeof _t3 && "dimension" in _t3 ? {
          glue: {
            dimension: _t3.dimension
          }
        } : "number" == typeof _t3 ? {
          glue: {
            dimension: _t3
          }
        } : void 0;
      }
      if (this.parent) return this.parent.getRegisterAsGlue(e);
    }
  }, {
    key: "getRegisterAsEm",
    value: function getRegisterAsEm(e) {
      return V(this.getRegisterAsDimension(e));
    }
  }, {
    key: "getRegisterAsDimension",
    value: function getRegisterAsDimension(e) {
      var t;
      if (null === (t = this.registers) || void 0 === t ? void 0 : t[e]) {
        var _t4 = this.registers[e];
        return "object" == typeof _t4 && "glue" in _t4 ? _t4.glue : "object" == typeof _t4 && "dimension" in _t4 ? _t4 : "number" == typeof _t4 ? {
          dimension: _t4
        } : void 0;
      }
      if (this.parent) return this.parent.getRegisterAsDimension(e);
    }
  }, {
    key: "setRegister",
    value: function setRegister(e, t) {
      void 0 !== t ? this.registers[e] = t : delete this.registers[e];
    }
  }, {
    key: "setGlobalRegister",
    value: function setGlobalRegister(e, t) {
      var i = this;
      for (; i.parent;) i.setRegister(e, void 0), i = i.parent;
      i.setRegister(e, t);
    }
  }, {
    key: "size",
    get: function get() {
      var e = this._size,
        t = this.parent;
      for (; !e;) e = t._size, t = t.parent;
      return e;
    }
  }, {
    key: "makeID",
    value: function makeID() {
      if (!this.atomIdsSettings) return;
      if ("number" != typeof this.atomIdsSettings.seed) return Date.now().toString(36).slice(-2) + Math.floor(1e5 * Math.random()).toString(36);
      var e = this.atomIdsSettings.overrideID ? this.atomIdsSettings.overrideID : this.atomIdsSettings.seed.toString(36);
      return this.atomIdsSettings.seed += 1, e;
    }
  }, {
    key: "scale",
    value: function scale(e) {
      return e * this.effectiveFontSize;
    }
  }, {
    key: "scalingFactor",
    get: function get() {
      return this.parent ? this.effectiveFontSize / this.parent.effectiveFontSize : 1;
    }
  }, {
    key: "isDisplayStyle",
    get: function get() {
      return 7 === this.mathstyle.id || 6 === this.mathstyle.id;
    }
  }, {
    key: "isCramped",
    get: function get() {
      return this.mathstyle.cramped;
    }
  }, {
    key: "isTight",
    get: function get() {
      return this.mathstyle.isTight;
    }
  }, {
    key: "effectiveFontSize",
    get: function get() {
      return F[Math.max(1, this.size + this.mathstyle.sizeDelta)];
    }
  }, {
    key: "computedColor",
    get: function get() {
      var e = this.color,
        t = this.parent;
      return !e && t && (e = t.color, t = t.parent), null != e ? e : "";
    }
  }, {
    key: "computedBackgroundColor",
    get: function get() {
      var e = this.backgroundColor,
        t = this.parent;
      return !e && t && (e = t.backgroundColor, t = t.parent), null != e ? e : "";
    }
  }, {
    key: "metrics",
    get: function get() {
      return this.mathstyle.metrics;
    }
  }]);
  return H;
}();
var U = {
    overrightarrow: [["rightarrow"], .888, 522, "xMaxYMin"],
    overleftarrow: [["leftarrow"], .888, 522, "xMinYMin"],
    underrightarrow: [["rightarrow"], .888, 522, "xMaxYMin"],
    underleftarrow: [["leftarrow"], .888, 522, "xMinYMin"],
    xrightarrow: [["rightarrow"], 1.469, 522, "xMaxYMin"],
    xleftarrow: [["leftarrow"], 1.469, 522, "xMinYMin"],
    Overrightarrow: [["doublerightarrow"], .888, 560, "xMaxYMin"],
    xRightarrow: [["doublerightarrow"], 1.526, 560, "xMaxYMin"],
    xLeftarrow: [["doubleleftarrow"], 1.526, 560, "xMinYMin"],
    overleftharpoon: [["leftharpoon"], .888, 522, "xMinYMin"],
    xleftharpoonup: [["leftharpoon"], .888, 522, "xMinYMin"],
    xleftharpoondown: [["leftharpoondown"], .888, 522, "xMinYMin"],
    overrightharpoon: [["rightharpoon"], .888, 522, "xMaxYMin"],
    xrightharpoonup: [["rightharpoon"], .888, 522, "xMaxYMin"],
    xrightharpoondown: [["rightharpoondown"], .888, 522, "xMaxYMin"],
    xlongequal: [["longequal"], .888, 334, "xMinYMin"],
    xtwoheadleftarrow: [["twoheadleftarrow"], .888, 334, "xMinYMin"],
    xtwoheadrightarrow: [["twoheadrightarrow"], .888, 334, "xMaxYMin"],
    overleftrightarrow: [["leftarrow", "rightarrow"], .888, 522],
    overbrace: [["leftbrace", "midbrace", "rightbrace"], 1.6, 548],
    underbrace: [["leftbraceunder", "midbraceunder", "rightbraceunder"], 1.6, 548],
    underleftrightarrow: [["leftarrow", "rightarrow"], .888, 522],
    xleftrightarrow: [["leftarrow", "rightarrow"], 1.75, 522],
    xLeftrightarrow: [["doubleleftarrow", "doublerightarrow"], 1.75, 560],
    xrightleftharpoons: [["leftharpoondownplus", "rightharpoonplus"], 1.75, 716],
    xleftrightharpoons: [["leftharpoonplus", "rightharpoondownplus"], 1.75, 716],
    xhookleftarrow: [["leftarrow", "righthook"], 1.08, 522],
    xhookrightarrow: [["lefthook", "rightarrow"], 1.08, 522],
    overlinesegment: [["leftlinesegment", "rightlinesegment"], .888, 522],
    underlinesegment: [["leftlinesegment", "rightlinesegment"], .888, 522],
    overgroup: [["leftgroup", "rightgroup"], .888, 342],
    undergroup: [["leftgroupunder", "rightgroupunder"], .888, 342],
    xmapsto: [["leftmapsto", "rightarrow"], 1.5, 522],
    xtofrom: [["leftToFrom", "rightToFrom"], 1.75, 528],
    xrightleftarrows: [["baraboveleftarrow", "rightarrowabovebar"], 1.75, 901],
    xrightequilibrium: [["baraboveshortleftharpoon", "rightharpoonaboveshortbar"], 1.75, 716],
    xleftequilibrium: [["shortbaraboveleftharpoon", "shortrightharpoonabovebar"], 1.75, 716]
  },
  W = {
    widehat1: [1062, 239, .24],
    widehat2: [2364, 300, .3],
    widehat3: [2364, 360, .36],
    widehat4: [2364, 420, .42],
    widecheck1: [1062, 239, .24],
    widecheck2: [2364, 300, .3],
    widecheck3: [2364, 360, .36],
    widecheck4: [2364, 420, .42],
    widetilde1: [600, 260, .26],
    widetilde2: [1033, 286, .286],
    widetilde3: [2339, 306, .306],
    widetilde4: [2340, 312, .34],
    overarc: [1061, 159, .3],
    underarc: [1061, 159, .3]
  },
  Z = {
    doubleleftarrow: "M262 157\nl10-10c34-36 62.7-77 86-123 3.3-8 5-13.3 5-16 0-5.3-6.7-8-20-8-7.3\n 0-12.2.5-14.5 1.5-2.3 1-4.8 4.5-7.5 10.5-49.3 97.3-121.7 169.3-217 216-28\n 14-57.3 25-88 33-6.7 2-11 3.8-13 5.5-2 1.7-3 4.2-3 7.5s1 5.8 3 7.5\nc2 1.7 6.3 3.5 13 5.5 68 17.3 128.2 47.8 180.5 91.5 52.3 43.7 93.8 96.2 124.5\n 157.5 9.3 8 15.3 12.3 18 13h6c12-.7 18-4 18-10 0-2-1.7-7-5-15-23.3-46-52-87\n-86-123l-10-10h399738v-40H218c328 0 0 0 0 0l-10-8c-26.7-20-65.7-43-117-69 2.7\n-2 6-3.7 10-5 36.7-16 72.3-37.3 107-64l10-8h399782v-40z\nm8 0v40h399730v-40zm0 194v40h399730v-40z",
    doublerightarrow: "M399738 392l\n-10 10c-34 36-62.7 77-86 123-3.3 8-5 13.3-5 16 0 5.3 6.7 8 20 8 7.3 0 12.2-.5\n 14.5-1.5 2.3-1 4.8-4.5 7.5-10.5 49.3-97.3 121.7-169.3 217-216 28-14 57.3-25 88\n-33 6.7-2 11-3.8 13-5.5 2-1.7 3-4.2 3-7.5s-1-5.8-3-7.5c-2-1.7-6.3-3.5-13-5.5-68\n-17.3-128.2-47.8-180.5-91.5-52.3-43.7-93.8-96.2-124.5-157.5-9.3-8-15.3-12.3-18\n-13h-6c-12 .7-18 4-18 10 0 2 1.7 7 5 15 23.3 46 52 87 86 123l10 10H0v40h399782\nc-328 0 0 0 0 0l10 8c26.7 20 65.7 43 117 69-2.7 2-6 3.7-10 5-36.7 16-72.3 37.3\n-107 64l-10 8H0v40zM0 157v40h399730v-40zm0 194v40h399730v-40z",
    leftarrow: "M400000 241H110l3-3c68.7-52.7 113.7-120\n 135-202 4-14.7 6-23 6-25 0-7.3-7-11-21-11-8 0-13.2.8-15.5 2.5-2.3 1.7-4.2 5.8\n-5.5 12.5-1.3 4.7-2.7 10.3-4 17-12 48.7-34.8 92-68.5 130S65.3 228.3 18 247\nc-10 4-16 7.7-18 11 0 8.7 6 14.3 18 17 47.3 18.7 87.8 47 121.5 85S196 441.3 208\n 490c.7 2 1.3 5 2 9s1.2 6.7 1.5 8c.3 1.3 1 3.3 2 6s2.2 4.5 3.5 5.5c1.3 1 3.3\n 1.8 6 2.5s6 1 10 1c14 0 21-3.7 21-11 0-2-2-10.3-6-25-20-79.3-65-146.7-135-202\n l-3-3h399890zM100 241v40h399900v-40z",
    leftbrace: "M6 548l-6-6v-35l6-11c56-104 135.3-181.3 238-232 57.3-28.7 117\n-45 179-50h399577v120H403c-43.3 7-81 15-113 26-100.7 33-179.7 91-237 174-2.7\n 5-6 9-10 13-.7 1-7.3 1-20 1H6z",
    leftbraceunder: "M0 6l6-6h17c12.688 0 19.313.3 20 1 4 4 7.313 8.3 10 13\n 35.313 51.3 80.813 93.8 136.5 127.5 55.688 33.7 117.188 55.8 184.5 66.5.688\n 0 2 .3 4 1 18.688 2.7 76 4.3 172 5h399450v120H429l-6-1c-124.688-8-235-61.7\n-331-161C60.687 138.7 32.312 99.3 7 54L0 41V6z",
    overarc: "M529 0c179 0 524 115 524 115 5 1 9 5 9 10 0 1-1 2-1 3l-4 22c-1 5-5 9-11 9h-2s-338-93-512-92c-174 0-513 92-513 92h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13 0 0 342-115 520-115z",
    underarc: "m 529 160\n  c -179 0 -524 -115 -524 -115\n  c -5 -1 -9 -5 -9 -10\n  c 0 -1 1 -2 1 -3\n  l 4 -22\n  c 1 -5 5 -9 11 -9\n  h 2\n  s 338 93 512 92\n  c 174 0 513 -92 513 -92\n  h 2\n  c 5 0 9 4 11 9\n  l 5 22\n  c 1 6 -2 12 -8 13\n  c 0 0 -342 115 -520 115\n  z\n  ",
    leftgroup: "M400000 80\nH435C64 80 168.3 229.4 21 260c-5.9 1.2-18 0-18 0-2 0-3-1-3-3v-38C76 61 257 0\n 435 0h399565z",
    leftgroupunder: "M400000 262\nH435C64 262 168.3 112.6 21 82c-5.9-1.2-18 0-18 0-2 0-3 1-3 3v38c76 158 257 219\n 435 219h399565z",
    leftharpoon: "M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3\n-3.3 10.2-9.5 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5\n-18.3 3-21-1.3-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7\n-196 228-6.7 4.7-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40z",
    leftharpoonplus: "M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3-3.3 10.2-9.5\n 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5-18.3 3-21-1.3\n-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7-196 228-6.7 4.7\n-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40zM0 435v40h400000v-40z\nm0 0v40h400000v-40z",
    leftharpoondown: "M7 241c-4 4-6.333 8.667-7 14 0 5.333.667 9 2 11s5.333\n 5.333 12 10c90.667 54 156 130 196 228 3.333 10.667 6.333 16.333 9 17 2 .667 5\n 1 9 1h5c10.667 0 16.667-2 18-6 2-2.667 1-9.667-3-21-32-87.333-82.667-157.667\n-152-211l-3-3h399907v-40zM93 281 H400000 v-40L7 241z",
    leftharpoondownplus: "M7 435c-4 4-6.3 8.7-7 14 0 5.3.7 9 2 11s5.3 5.3 12\n 10c90.7 54 156 130 196 228 3.3 10.7 6.3 16.3 9 17 2 .7 5 1 9 1h5c10.7 0 16.7\n-2 18-6 2-2.7 1-9.7-3-21-32-87.3-82.7-157.7-152-211l-3-3h399907v-40H7zm93 0\nv40h399900v-40zM0 241v40h399900v-40zm0 0v40h399900v-40z",
    lefthook: "M400000 281 H103s-33-11.2-61-33.5S0 197.3 0 164s14.2-61.2 42.5\n-83.5C70.8 58.2 104 47 142 47 c16.7 0 25 6.7 25 20 0 12-8.7 18.7-26 20-40 3.3\n-68.7 15.7-86 37-10 12-15 25.3-15 40 0 22.7 9.8 40.7 29.5 54 19.7 13.3 43.5 21\n 71.5 23h399859zM103 281v-40h399897v40z",
    leftlinesegment: "M40 281 V428 H0 V94 H40 V241 H400000 v40z\nM40 281 V428 H0 V94 H40 V241 H400000 v40z",
    leftmapsto: "M40 281 V448H0V74H40V241H400000v40z\nM40 281 V448H0V74H40V241H400000v40z",
    leftToFrom: "M0 147h400000v40H0zm0 214c68 40 115.7 95.7 143 167h22c15.3 0 23\n-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69-70-101l-7-8h399905v-40H95l7-8\nc28.7-32 52-65.7 70-101 10.7-23.3 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 265.3\n 68 321 0 361zm0-174v-40h399900v40zm100 154v40h399900v-40z",
    longequal: "M0 50 h400000 v40H0z m0 194h40000v40H0z\nM0 50 h400000 v40H0z m0 194h40000v40H0z",
    midbrace: "M200428 334\nc-100.7-8.3-195.3-44-280-108-55.3-42-101.7-93-139-153l-9-14c-2.7 4-5.7 8.7-9 14\n-53.3 86.7-123.7 153-211 199-66.7 36-137.3 56.3-212 62H0V214h199568c178.3-11.7\n 311.7-78.3 403-201 6-8 9.7-12 11-12 .7-.7 6.7-1 18-1s17.3.3 18 1c1.3 0 5 4 11\n 12 44.7 59.3 101.3 106.3 170 141s145.3 54.3 229 60h199572v120z",
    midbraceunder: "M199572 214\nc100.7 8.3 195.3 44 280 108 55.3 42 101.7 93 139 153l9 14c2.7-4 5.7-8.7 9-14\n 53.3-86.7 123.7-153 211-199 66.7-36 137.3-56.3 212-62h199568v120H200432c-178.3\n 11.7-311.7 78.3-403 201-6 8-9.7 12-11 12-.7.7-6.7 1-18 1s-17.3-.3-18-1c-1.3 0\n-5-4-11-12-44.7-59.3-101.3-106.3-170-141s-145.3-54.3-229-60H0V214z",
    oiintSize1: "M512.6 71.6c272.6 0 320.3 106.8 320.3 178.2 0 70.8-47.7 177.6\n-320.3 177.6S193.1 320.6 193.1 249.8c0-71.4 46.9-178.2 319.5-178.2z\nm368.1 178.2c0-86.4-60.9-215.4-368.1-215.4-306.4 0-367.3 129-367.3 215.4 0 85.8\n60.9 214.8 367.3 214.8 307.2 0 368.1-129 368.1-214.8z",
    oiintSize2: "M757.8 100.1c384.7 0 451.1 137.6 451.1 230 0 91.3-66.4 228.8\n-451.1 228.8-386.3 0-452.7-137.5-452.7-228.8 0-92.4 66.4-230 452.7-230z\nm502.4 230c0-111.2-82.4-277.2-502.4-277.2s-504 166-504 277.2\nc0 110 84 276 504 276s502.4-166 502.4-276z",
    oiiintSize1: "M681.4 71.6c408.9 0 480.5 106.8 480.5 178.2 0 70.8-71.6 177.6\n-480.5 177.6S202.1 320.6 202.1 249.8c0-71.4 70.5-178.2 479.3-178.2z\nm525.8 178.2c0-86.4-86.8-215.4-525.7-215.4-437.9 0-524.7 129-524.7 215.4 0\n85.8 86.8 214.8 524.7 214.8 438.9 0 525.7-129 525.7-214.8z",
    oiiintSize2: "M1021.2 53c603.6 0 707.8 165.8 707.8 277.2 0 110-104.2 275.8\n-707.8 275.8-606 0-710.2-165.8-710.2-275.8C311 218.8 415.2 53 1021.2 53z\nm770.4 277.1c0-131.2-126.4-327.6-770.5-327.6S248.4 198.9 248.4 330.1\nc0 130 128.8 326.4 772.7 326.4s770.5-196.4 770.5-326.4z",
    rightarrow: "M0 241v40h399891c-47.3 35.3-84 78-110 128\n-16.7 32-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20\n 11 8 0 13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7\n 39-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85\n-40.5-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5\n-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67\n 151.7 139 205zm0 0v40h399900v-40z",
    rightbrace: "M400000 542l\n-6 6h-17c-12.7 0-19.3-.3-20-1-4-4-7.3-8.3-10-13-35.3-51.3-80.8-93.8-136.5-127.5\ns-117.2-55.8-184.5-66.5c-.7 0-2-.3-4-1-18.7-2.7-76-4.3-172-5H0V214h399571l6 1\nc124.7 8 235 61.7 331 161 31.3 33.3 59.7 72.7 85 118l7 13v35z",
    rightbraceunder: "M399994 0l6 6v35l-6 11c-56 104-135.3 181.3-238 232-57.3\n 28.7-117 45-179 50H-300V214h399897c43.3-7 81-15 113-26 100.7-33 179.7-91 237\n-174 2.7-5 6-9 10-13 .7-1 7.3-1 20-1h17z",
    rightgroup: "M0 80h399565c371 0 266.7 149.4 414 180 5.9 1.2 18 0 18 0 2 0\n 3-1 3-3v-38c-76-158-257-219-435-219H0z",
    rightgroupunder: "M0 262h399565c371 0 266.7-149.4 414-180 5.9-1.2 18 0 18\n 0 2 0 3 1 3 3v38c-76 158-257 219-435 219H0z",
    rightharpoon: "M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3\n-3.7-15.3-11-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2\n-10.7 0-16.7 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58\n 69.2 92 94.5zm0 0v40h399900v-40z",
    rightharpoonplus: "M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3-3.7-15.3-11\n-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2-10.7 0-16.7\n 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58 69.2 92 94.5z\nm0 0v40h399900v-40z m100 194v40h399900v-40zm0 0v40h399900v-40z",
    rightharpoondown: "M399747 511c0 7.3 6.7 11 20 11 8 0 13-.8 15-2.5s4.7-6.8\n 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3 8.5-5.8 9.5\n-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3-64.7 57-92 95\n-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 241v40h399900v-40z",
    rightharpoondownplus: "M399747 705c0 7.3 6.7 11 20 11 8 0 13-.8\n 15-2.5s4.7-6.8 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3\n 8.5-5.8 9.5-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3\n-64.7 57-92 95-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 435v40h399900v-40z\nm0-194v40h400000v-40zm0 0v40h400000v-40z",
    righthook: "M399859 241c-764 0 0 0 0 0 40-3.3 68.7-15.7 86-37 10-12 15-25.3\n 15-40 0-22.7-9.8-40.7-29.5-54-19.7-13.3-43.5-21-71.5-23-17.3-1.3-26-8-26-20 0\n-13.3 8.7-20 26-20 38 0 71 11.2 99 33.5 0 0 7 5.6 21 16.7 14 11.2 21 33.5 21\n 66.8s-14 61.2-42 83.5c-28 22.3-61 33.5-99 33.5L0 241z M0 281v-40h399859v40z",
    rightlinesegment: "M399960 241 V94 h40 V428 h-40 V281 H0 v-40z\nM399960 241 V94 h40 V428 h-40 V281 H0 v-40z",
    rightToFrom: "M400000 167c-70.7-42-118-97.7-142-167h-23c-15.3 0-23 .3-23\n 1 0 1.3 5.3 13.7 16 37 18 35.3 41.3 69 70 101l7 8H0v40h399905l-7 8c-28.7 32\n-52 65.7-70 101-10.7 23.3-16 35.7-16 37 0 .7 7.7 1 23 1h23c24-69.3 71.3-125 142\n-167z M100 147v40h399900v-40zM0 341v40h399900v-40z",
    twoheadleftarrow: "M0 167c68 40\n 115.7 95.7 143 167h22c15.3 0 23-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69\n-70-101l-7-8h125l9 7c50.7 39.3 85 86 103 140h46c0-4.7-6.3-18.7-19-42-18-35.3\n-40-67.3-66-96l-9-9h399716v-40H284l9-9c26-28.7 48-60.7 66-96 12.7-23.333 19\n-37.333 19-42h-46c-18 54-52.3 100.7-103 140l-9 7H95l7-8c28.7-32 52-65.7 70-101\n 10.7-23.333 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 71.3 68 127 0 167z",
    twoheadrightarrow: "M400000 167\nc-68-40-115.7-95.7-143-167h-22c-15.3 0-23 .3-23 1 0 1.3 5.3 13.7 16 37 18 35.3\n 41.3 69 70 101l7 8h-125l-9-7c-50.7-39.3-85-86-103-140h-46c0 4.7 6.3 18.7 19 42\n 18 35.3 40 67.3 66 96l9 9H0v40h399716l-9 9c-26 28.7-48 60.7-66 96-12.7 23.333\n-19 37.333-19 42h46c18-54 52.3-100.7 103-140l9-7h125l-7 8c-28.7 32-52 65.7-70\n 101-10.7 23.333-16 35.7-16 37 0 .7 7.7 1 23 1h22c27.3-71.3 75-127 143-167z",
    widetilde1: "M200 55.538c-77 0-168 73.953-177 73.953-3 0-7\n-2.175-9-5.437L2 97c-1-2-2-4-2-6 0-4 2-7 5-9l20-12C116 12 171 0 207 0c86 0\n 114 68 191 68 78 0 168-68 177-68 4 0 7 2 9 5l12 19c1 2.175 2 4.35 2 6.525 0\n 4.35-2 7.613-5 9.788l-19 13.05c-92 63.077-116.937 75.308-183 76.128\n-68.267.847-113-73.952-191-73.952z",
    widetilde2: "M344 55.266c-142 0-300.638 81.316-311.5 86.418\n-8.01 3.762-22.5 10.91-23.5 5.562L1 120c-1-2-1-3-1-4 0-5 3-9 8-10l18.4-9C160.9\n 31.9 283 0 358 0c148 0 188 122 331 122s314-97 326-97c4 0 8 2 10 7l7 21.114\nc1 2.14 1 3.21 1 4.28 0 5.347-3 9.626-7 10.696l-22.3 12.622C852.6 158.372 751\n 181.476 676 181.476c-149 0-189-126.21-332-126.21z",
    widetilde3: "M786 59C457 59 32 175.242 13 175.242c-6 0-10-3.457\n-11-10.37L.15 138c-1-7 3-12 10-13l19.2-6.4C378.4 40.7 634.3 0 804.3 0c337 0\n 411.8 157 746.8 157 328 0 754-112 773-112 5 0 10 3 11 9l1 14.075c1 8.066-.697\n 16.595-6.697 17.492l-21.052 7.31c-367.9 98.146-609.15 122.696-778.15 122.696\n -338 0-409-156.573-744-156.573z",
    widetilde4: "M786 58C457 58 32 177.487 13 177.487c-6 0-10-3.345\n-11-10.035L.15 143c-1-7 3-12 10-13l22-6.7C381.2 35 637.15 0 807.15 0c337 0 409\n 177 744 177 328 0 754-127 773-127 5 0 10 3 11 9l1 14.794c1 7.805-3 13.38-9\n 14.495l-20.7 5.574c-366.85 99.79-607.3 139.372-776.3 139.372-338 0-409\n -175.236-744-175.236z",
    vec: "M377 20c0-5.333 1.833-10 5.5-14S391 0 397 0c4.667 0 8.667 1.667 12 5\n3.333 2.667 6.667 9 10 19 6.667 24.667 20.333 43.667 41 57 7.333 4.667 11\n10.667 11 18 0 6-1 10-3 12s-6.667 5-14 9c-28.667 14.667-53.667 35.667-75 63\n-1.333 1.333-3.167 3.5-5.5 6.5s-4 4.833-5 5.5c-1 .667-2.5 1.333-4.5 2s-4.333 1\n-7 1c-4.667 0-9.167-1.833-13.5-5.5S337 184 337 178c0-12.667 15.667-32.333 47-59\nH213l-171-1c-8.667-6-13-12.333-13-19 0-4.667 4.333-11.333 13-20h359\nc-16-25.333-24-45-24-59z",
    widehat1: "M529 0h5l519 115c5 1 9 5 9 10 0 1-1 2-1 3l-4 22\nc-1 5-5 9-11 9h-2L532 67 19 159h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13z",
    widehat2: "M1181 0h2l1171 176c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 220h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",
    widehat3: "M1181 0h2l1171 236c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 280h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",
    widehat4: "M1181 0h2l1171 296c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 340h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",
    widecheck1: "M529,159h5l519,-115c5,-1,9,-5,9,-10c0,-1,-1,-2,-1,-3l-4,-22c-1,\n-5,-5,-9,-11,-9h-2l-512,92l-513,-92h-2c-5,0,-9,4,-11,9l-5,22c-1,6,2,12,8,13z",
    widecheck2: "M1181,220h2l1171,-176c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,\n-11,-10h-1l-1168,153l-1167,-153h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z",
    widecheck3: "M1181,280h2l1171,-236c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,\n-11,-10h-1l-1168,213l-1167,-213h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z",
    widecheck4: "M1181,340h2l1171,-296c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,\n-11,-10h-1l-1168,273l-1167,-273h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z",
    baraboveleftarrow: "M400000 620h-399890l3 -3c68.7 -52.7 113.7 -120 135 -202\nc4 -14.7 6 -23 6 -25c0 -7.3 -7 -11 -21 -11c-8 0 -13.2 0.8 -15.5 2.5\nc-2.3 1.7 -4.2 5.8 -5.5 12.5c-1.3 4.7 -2.7 10.3 -4 17c-12 48.7 -34.8 92 -68.5 130\ns-74.2 66.3 -121.5 85c-10 4 -16 7.7 -18 11c0 8.7 6 14.3 18 17c47.3 18.7 87.8 47\n121.5 85s56.5 81.3 68.5 130c0.7 2 1.3 5 2 9s1.2 6.7 1.5 8c0.3 1.3 1 3.3 2 6\ns2.2 4.5 3.5 5.5c1.3 1 3.3 1.8 6 2.5s6 1 10 1c14 0 21 -3.7 21 -11\nc0 -2 -2 -10.3 -6 -25c-20 -79.3 -65 -146.7 -135 -202l-3 -3h399890z\nM100 620v40h399900v-40z M0 241v40h399900v-40zM0 241v40h399900v-40z",
    rightarrowabovebar: "M0 241v40h399891c-47.3 35.3-84 78-110 128-16.7 32\n-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20 11 8 0\n13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7 39\n-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85-40.5\n-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5\n-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67\n151.7 139 205zm96 379h399894v40H0zm0 0h399904v40H0z",
    baraboveshortleftharpoon: "M507,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11\nc1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17\nc2,0.7,5,1,9,1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21\nc-32,-87.3,-82.7,-157.7,-152,-211c0,0,-3,-3,-3,-3l399351,0l0,-40\nc-398570,0,-399437,0,-399437,0z M593 435 v40 H399500 v-40z\nM0 281 v-40 H399908 v40z M0 281 v-40 H399908 v40z",
    rightharpoonaboveshortbar: "M0,241 l0,40c399126,0,399993,0,399993,0\nc4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,\n-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6\nc-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z\nM0 241 v40 H399908 v-40z M0 475 v-40 H399500 v40z M0 475 v-40 H399500 v40z",
    shortbaraboveleftharpoon: "M7,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11\nc1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17c2,0.7,5,1,9,\n1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21c-32,-87.3,-82.7,-157.7,\n-152,-211c0,0,-3,-3,-3,-3l399907,0l0,-40c-399126,0,-399993,0,-399993,0z\nM93 435 v40 H400000 v-40z M500 241 v40 H400000 v-40z M500 241 v40 H400000 v-40z",
    shortrightharpoonabovebar: "M53,241l0,40c398570,0,399437,0,399437,0\nc4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,\n-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6\nc-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z\nM500 241 v40 H399408 v-40z M500 435 v40 H400000 v-40z"
  };
var G = /*#__PURE__*/function () {
  function G(e) {
    _classCallCheck(this, G);
    G._registry[e] = this;
  }
  _createClass(G, [{
    key: "createAtom",
    value: function createAtom(e, t) {
      return null;
    }
  }, {
    key: "parseTokens",
    value: function parseTokens(e, t, i) {
      return null;
    }
  }, {
    key: "serialize",
    value: function serialize(e, t) {
      return "";
    }
  }, {
    key: "applyStyle",
    value: function applyStyle(e, t) {
      return "";
    }
  }], [{
    key: "createAtom",
    value: function createAtom(e, t, i) {
      return G._registry[e].createAtom(t, i);
    }
  }, {
    key: "parseTokens",
    value: function parseTokens(e, t, i, r) {
      return G._registry[e].parseTokens(t, i, r);
    }
  }, {
    key: "serialize",
    value: function serialize(e, t) {
      return G._registry[e[0].mode].serialize(e, t);
    }
  }, {
    key: "applyStyle",
    value: function applyStyle(e, t, i) {
      return G._registry[e].applyStyle(t, i);
    }
  }]);
  return G;
}();
function X(e, t) {
  var i = [];
  var r,
    n = [];
  var _iterator = _createForOfIteratorHelper(e),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _a2 = _step.value;
      if ("first" !== _a2.type) {
        var _e5 = void 0;
        "variant" === t ? (_e5 = _a2.style.variant, _a2.style.variantStyle && "up" !== _a2.style.variantStyle && (_e5 += "-" + _a2.style.variantStyle)) : "cssClass" === t ? "group" === _a2.type && (_e5 = _a2.customClass) : _e5 = _a2.style[t], _e5 === r ? n.push(_a2) : (n.length > 0 && i.push(n), n = [_a2], r = _e5);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return n.length > 0 && i.push(n), i;
}
G._registry = {};
var Y = ["", "chem", "mord", "mbin", "mop", "mrel", "mopen", "mclose", "mpunct", "minner", "spacing", "first", "latex", "composition", "error", "placeholder", "supsub", "none", "mathfield"],
  Q = {
    mord: {
      mop: 3,
      mbin: 4,
      mrel: 5,
      minner: 3
    },
    mop: {
      mord: 3,
      mop: 3,
      rel: 5,
      minner: 3
    },
    mbin: {
      mord: 4,
      mop: 4,
      mopen: 4,
      minner: 4
    },
    mrel: {
      mord: 5,
      mop: 5,
      mopen: 5,
      minner: 5
    },
    mclose: {
      mop: 3,
      mbin: 4,
      mrel: 5,
      minner: 3
    },
    mpunct: {
      mord: 3,
      mop: 3,
      mrel: 3,
      mopen: 3,
      mpunct: 3,
      minner: 3
    },
    minner: {
      mord: 3,
      mop: 3,
      mbin: 4,
      mrel: 5,
      mopen: 3,
      mpunct: 3,
      minner: 3
    }
  },
  J = {
    mord: {
      mop: 3
    },
    mop: {
      mord: 3,
      mop: 3
    },
    mclose: {
      mop: 3
    },
    minner: {
      mop: 3
    }
  };
function ee(e, t) {
  if ("string" == typeof e) return e;
  if ("number" == typeof e) {
    var _i4 = Math.ceil(100 * e) / 100;
    return 0 === _i4 ? "0" : _i4.toString() + (null != t ? t : "");
  }
  return "";
}
var te = /*#__PURE__*/function () {
  function te(t, i) {
    _classCallCheck(this, te);
    var r, n, a, o, s, l, c, u;
    if ("number" == typeof t ? this.value = String.fromCodePoint(t) : "string" == typeof t ? this.value = t : e(t) ? this.children = t.filter(function (e) {
      return null !== e;
    }) : t && t instanceof te && (this.children = [t]), this.type = null !== (r = null == i ? void 0 : i.type) && void 0 !== r ? r : "", this.isSelected = !1, this.isTight = null !== (n = null == i ? void 0 : i.isTight) && void 0 !== n && n, this.newList = null !== (a = null == i ? void 0 : i.newList) && void 0 !== a && a, null == i ? void 0 : i.properties) for (var _i5 = 0, _Object$keys = Object.keys(i.properties); _i5 < _Object$keys.length; _i5++) {
      var _e6 = _Object$keys[_i5];
      this.setStyle(_e6, i.properties[_e6]);
    }
    (null == i ? void 0 : i.attributes) && (this.attributes = i.attributes), this.classes = null !== (o = null == i ? void 0 : i.classes) && void 0 !== o ? o : "";
    var d = null !== (s = null == i ? void 0 : i.fontFamily) && void 0 !== s ? s : "Main-Regular";
    if ((null == i ? void 0 : i.style) && this.value && (d = null !== (c = G.applyStyle(null !== (l = i.mode) && void 0 !== l ? l : "math", this, i.style)) && void 0 !== c ? c : "Main-Regular"), this.height = 0, this.depth = 0, this.skew = 0, this.italic = 0, this.maxFontSize = 0, "number" == typeof t) {
      var _e7 = P(t, d);
      this.height = _e7.height, this.depth = _e7.depth, this.skew = _e7.skew, this.italic = _e7.italic, this.right = _e7.italic;
    } else if (this.value) {
      this.height = -1 / 0, this.depth = -1 / 0, this.skew = -1 / 0, this.italic = -1 / 0;
      for (var _e8 = 0; _e8 < this.value.length; _e8++) {
        var _t5 = P(this.value.codePointAt(_e8), null != d ? d : "Main-Regular");
        this.height = Math.max(this.height, _t5.height), this.depth = Math.max(this.depth, _t5.depth), this.skew = _t5.skew, this.italic = _t5.italic;
      }
      this.right = this.italic;
    } else if ("latex" === this.type) this.height = .8, this.depth = .2;else if (this.children && this.children.length > 0) if (1 === this.children.length) {
      var _e9 = this.children[0];
      this.height = _e9.height, this.depth = _e9.depth, this.maxFontSize = _e9.maxFontSize, this.skew = _e9.skew, this.italic = _e9.italic;
    } else {
      var _e10 = -1 / 0,
        _t6 = -1 / 0,
        _i6 = 0;
      var _iterator2 = _createForOfIteratorHelper(this.children),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _r2 = _step2.value;
          _r2.height > _e10 && (_e10 = _r2.height), _r2.depth > _t6 && (_t6 = _r2.depth), _i6 = Math.max(_i6, null !== (u = _r2.maxFontSize) && void 0 !== u ? u : 0);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.height = _e10, this.depth = _t6, this.maxFontSize = _i6;
    }
    void 0 !== (null == i ? void 0 : i.height) && (this.height = i.height), void 0 !== (null == i ? void 0 : i.depth) && (this.depth = i.depth), void 0 !== (null == i ? void 0 : i.maxFontSize) && (this.maxFontSize = i.maxFontSize);
  }
  _createClass(te, [{
    key: "atomID",
    set: function set(e) {
      void 0 !== e && (this.attributes || (this.attributes = {}), this.attributes["data-atom-id"] = e);
    }
  }, {
    key: "selected",
    value: function selected(e) {
      if (this.isSelected = e, this.children) {
        var _iterator3 = _createForOfIteratorHelper(this.children),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _t7 = _step3.value;
            _t7.selected(e);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  }, {
    key: "setStyle",
    value: function setStyle(e, t, i) {
      var r = ee(t, i);
      r.length > 0 && (this.cssProperties || (this.cssProperties = {}), this.cssProperties[e] = r);
    }
  }, {
    key: "setTop",
    value: function setTop(e) {
      Number.isFinite(e) && Math.abs(e) > .01 && (this.cssProperties || (this.cssProperties = {}), this.cssProperties.top = ee(e, "em"), this.height -= e, this.depth += e);
    }
  }, {
    key: "left",
    get: function get() {
      var e;
      return (null === (e = this.cssProperties) || void 0 === e ? void 0 : e["margin-left"]) ? Number.parseFloat(this.cssProperties["margin-left"]) : 0;
    },
    set: function set(e) {
      Number.isFinite(e) && (this.cssProperties || (this.cssProperties = {}), 0 === e ? delete this.cssProperties["margin-left"] : this.cssProperties["margin-left"] = ee(e, "em"));
    }
  }, {
    key: "right",
    set: function set(e) {
      Number.isFinite(e) && (this.cssProperties || (this.cssProperties = {}), 0 === e ? delete this.cssProperties["margin-right"] : this.cssProperties["margin-right"] = ee(e, "em"));
    }
  }, {
    key: "width",
    set: function set(e) {
      this.cssProperties || (this.cssProperties = {}), this.cssProperties.width = ee(e, "em");
    }
  }, {
    key: "wrap",
    value: function wrap(e, t) {
      var i = e.parent;
      if (!i) return this;
      e.isPhantom && this.setStyle("opacity", 0);
      var r = e.computedColor === i.computedColor ? void 0 : e.color;
      this.setStyle("color", r);
      var n = e.effectiveFontSize === i.effectiveFontSize ? void 0 : e.effectiveFontSize,
        a = e.computedBackgroundColor === i.computedBackgroundColor ? void 0 : e.backgroundColor;
      if (!(n || a || t && (t.classes || t.type))) return this;
      var o;
      a ? (o = se(this, t), o.selected(this.isSelected), o.setStyle("background-color", a), o.setStyle("display", "inline-block")) : o = new te(this, t);
      var s = e.scalingFactor;
      return 1 !== s && (o.setStyle("font-size", 100 * s, "%"), o.height *= s, o.depth *= s, o.italic *= s, o.skew *= s), o;
    }
  }, {
    key: "toMarkup",
    value: function toMarkup() {
      var _this = this;
      var e, t, i;
      var r = null !== (e = this.value) && void 0 !== e ? e : "";
      if (this.children) {
        var _iterator4 = _createForOfIteratorHelper(this.children),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _e11 = _step4.value;
            r += _e11.toMarkup();
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
      var n = this.classes.split(" ");
      n.push(null !== (t = {
        latex: "ML__latex",
        placeholder: "ML__placeholder",
        error: "ML__error"
      }[this.type]) && void 0 !== t ? t : ""), "latex" === this.caret && n.push("ML__latex-caret");
      var a = 1 === n.length ? n[0] : n.filter(function (e, t, i) {
        return e.length > 0 && i.indexOf(e) === t;
      }).join(" ");
      var o = "";
      if (r.length > 0 && "\u200B" !== r || a.length > 0 || this.cssId || this.htmlData || this.attributes || this.cssProperties || this.svgBody || this.svgOverlay) {
        var _e12 = "";
        if (this.cssId && (_e12 += " id=".concat(this.cssId.replace(/ /g, "-"), " ")), this.htmlData) {
          var _t8 = this.htmlData.split(",");
          var _iterator5 = _createForOfIteratorHelper(_t8),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _i7 = _step5.value;
              var _t9 = _i7.match(/([^=]+)=(.+$)/);
              if (_t9) {
                var _i8 = _t9[1].trim().replace(/ /g, "-");
                _i8 && (_e12 += " data-".concat(_i8, "=").concat(_t9[2], " "));
              } else {
                var _t10 = _i7.trim().replace(/ /g, "-");
                _t10 && (_e12 += " data-".concat(_t10, " "));
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
        if (this.attributes && (_e12 += " " + Object.keys(this.attributes).map(function (e) {
          return "".concat(e, "=\"").concat(_this.attributes[e], "\"");
        }).join(" ")), a.length > 0 && (_e12 += " class=\"".concat(a, "\"")), this.cssProperties) {
          var _t11 = Object.keys(this.cssProperties).map(function (e) {
            return "".concat(e, ":").concat(_this.cssProperties[e]);
          }).join(";");
          _t11.length > 0 && (_e12 += " style=\"".concat(_t11, "\""));
        }
        var _t12 = "";
        this.svgBody ? _t12 = function (e) {
          if (W[e]) {
            var _W$e = _slicedToArray(W[e], 3),
              _t13 = _W$e[0],
              _i9 = _W$e[1],
              _r3 = _W$e[2];
            return "<span style=\"display:inline-block;height:".concat(_r3 / 2, "em;min-width:0\"><span class=\"stretchy\" style=\"height:").concat(_r3, "em\"><svg width=\"100%\" height=\"").concat(_r3, "em\" viewBox=\"0 0 ").concat(_t13, " ").concat(_i9, "\" preserveAspectRatio=\"none\" ><path d=\"").concat(Z[e], "\"></path></svg></span></span>");
          }
          var _U$e = _slicedToArray(U[e], 4),
            t = _U$e[0],
            i = _U$e[1],
            r = _U$e[2],
            n = _U$e[3];
          var a, o;
          var s = r / 1e3;
          3 === t.length ? (a = ["slice-1-of-3", "slice-2-of-3", "slice-3-of-3"], o = ["xMinYMin", "xMidYMin", "xMaxYMin"]) : 2 === t.length ? (a = ["slice-1-of-2", "slice-2-of-2"], o = ["xMinYMin", "xMaxYMin"]) : (a = ["slice-1-of-1"], o = [n]);
          var l = t.map(function (e, t) {
            return "<span class=\"".concat(a[t], "\" style=height:").concat(s, "em><svg width=400em height=").concat(s, "em viewBox=\"0 0 400000 ").concat(r, "\" preserveAspectRatio=\"").concat(o[t], " slice\"><path d=\"").concat(Z[e], "\"></path></svg></span>");
          }).join("");
          return "<span style=\"display:inline-block;height:".concat(s, "em;min-width:").concat(i, "em;\">").concat(l, "</span>");
        }(this.svgBody) : this.svgOverlay && (_t12 = '<span style="', _t12 += "display: inline-block;", _t12 += "height:".concat(this.height + this.depth, "em;"), _t12 += "vertical-align:".concat(this.depth, "em;"), _t12 += '">', _t12 += r, _t12 += "</span>", _t12 += '<svg style="position:absolute;overflow:overlay;', _t12 += "height:".concat(this.height + this.depth, "em;"), (null === (i = this.cssProperties) || void 0 === i ? void 0 : i.padding) ? (_t12 += "top:".concat(this.cssProperties.padding, "em;"), _t12 += "left:".concat(this.cssProperties.padding, "em;"), _t12 += "width:calc(100% - 2 * ".concat(this.cssProperties.padding, "em );")) : _t12 += "top:0;left:0;width:100%;", _t12 += "z-index:2;", _t12 += '"', this.svgStyle && (_t12 += " style=\"".concat(this.svgStyle, "\"")), _t12 += ">".concat(this.svgOverlay, "</svg>")), o = "<span".concat(_e12, ">").concat(r).concat(_t12, "</span>");
      }
      return "text" === this.caret ? o += '<span class="ML__text-caret"></span>' : "math" === this.caret && (o += '<span class="ML__caret"></span>'), o;
    }
  }, {
    key: "tryCoalesceWith",
    value: function tryCoalesceWith(e) {
      if (this.type !== e.type) return !1;
      if (!/ML__text/.test(this.classes) && !["mord", "mbin", "mrel"].includes(this.type)) return !1;
      if (this.svgBody || !this.value) return !1;
      if (e.svgBody || !e.value) return !1;
      var t = this.children && this.children.length > 0,
        i = e.children && e.children.length > 0;
      if (t || i) return !1;
      var r = this.cssProperties ? Object.keys(this.cssProperties).length : 0;
      if (r !== (e.cssProperties ? Object.keys(e.cssProperties).length : 0)) return !1;
      if (r > 0) for (var _i10 = 0, _Object$keys2 = Object.keys(this.cssProperties); _i10 < _Object$keys2.length; _i10++) {
        var _t14 = _Object$keys2[_i10];
        if (this.cssProperties[_t14] !== e.cssProperties[_t14]) return !1;
      }
      var n = this.classes.trim().replace(/\s+/g, " ").split(" "),
        a = e.classes.trim().replace(/\s+/g, " ").split(" ");
      if (n.length !== a.length) return !1;
      n.sort(), a.sort();
      var _iterator6 = _createForOfIteratorHelper(n.entries()),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _step6$value = _slicedToArray(_step6.value, 2),
            _e13 = _step6$value[0],
            _t15 = _step6$value[1];
          if ("vertical-separator" === _t15) return !1;
          if (_t15 !== a[_e13]) return !1;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return this.value += e.value, this.height = Math.max(this.height, e.height), this.depth = Math.max(this.depth, e.depth), this.maxFontSize = Math.max(this.maxFontSize, e.maxFontSize), this.italic = e.italic, !0;
    }
  }]);
  return te;
}();
function ie(e) {
  if (!e || 0 === e.length) return [];
  e[0].children = ie(e[0].children);
  var t = [e[0]];
  for (var _i11 = 1; _i11 < e.length; _i11++) t[t.length - 1].tryCoalesceWith(e[_i11]) || (e[_i11].children = ie(e[_i11].children), t.push(e[_i11]));
  return t;
}
function re(e) {
  return e.children && (e.children = ie(e.children)), e;
}
function ne(e, t, i) {
  t.newList && (e = null);
  var r = t.type;
  if ("first" === r) return null;
  if ("spacing" === r) return e;
  if (i(e, t), t.children) {
    var _n2 = null;
    void 0 !== r && 0 !== r.length || (_n2 = e);
    var _iterator7 = _createForOfIteratorHelper(t.children),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var _e14 = _step7.value;
        _n2 = ne(_n2, _e14, i);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
    void 0 !== r && 0 !== r.length || (e = _n2);
  }
  return "supsub" !== r && void 0 !== r && r.length > 0 && (e = t), e;
}
function ae(e, t) {
  e && ne(null, e, t);
}
function oe(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return function (e) {
    ae(e, function (e, t) {
      "mbin" !== t.type || e && !/first|none|mbin|mop|mrel|mopen|mpunct/.test(e.type) || (t.type = "mord"), e && "mbin" === e.type && /mrel|mclose|mpunct|placeholder/.test(t.type) && (e.type = "mord");
    });
  }(e), function (e, t) {
    ae(e, function (e, i) {
      var r, n, a, o;
      var s = null !== (r = null == e ? void 0 : e.type) && void 0 !== r ? r : "none",
        l = i.isTight ? null !== (n = J[s]) && void 0 !== n ? n : null : null !== (a = Q[s]) && void 0 !== a ? a : null,
        c = l && null !== (o = l[i.type]) && void 0 !== o ? o : 0;
      c && (i.left += t * (c / 18));
    });
  }(e, t), e;
}
function se(e, t) {
  if (!e) return new te(null, t);
  var i = new te(null, {
    classes: "ML__strut"
  });
  i.setStyle("height", Math.max(0, e.height), "em");
  var r = [i];
  if (0 !== e.depth) {
    var _t16 = new te(null, {
      classes: "ML__strut--bottom"
    });
    _t16.setStyle("height", e.height + e.depth, "em"), _t16.setStyle("vertical-align", -e.depth, "em"), r.push(_t16);
  }
  return r.push(e), new te(r, t);
}
function le(e) {
  var t = function (e) {
      return U[e] ? U[e][2] / 1e3 : W[e][2];
    }(e) / 2,
    i = new te(null, {
      height: t + .166,
      depth: t - .166,
      maxFontSize: 0
    });
  return i.svgBody = e, i;
}
var ce = /*#__PURE__*/function (_te) {
  _inherits(ce, _te);
  var _super = _createSuper(ce);
  function ce(e, t) {
    _classCallCheck(this, ce);
    var i;
    var _ref3 = function (e) {
        var t;
        var _ref5 = function (e) {
            if ("individualShift" in e) {
              var _t17 = e.individualShift;
              var _i12 = _t17[0];
              var _r4 = [_i12],
                _n3 = -_i12.shift - _i12.box.depth;
              var _a3 = _n3;
              for (var _e15 = 1; _e15 < _t17.length; _e15++) {
                var _n4 = _t17[_e15],
                  _o2 = -_n4.shift - _a3 - _n4.box.depth,
                  _s2 = _o2 - (_i12.box.height + _i12.box.depth);
                _a3 += _o2, _r4.push(_s2), _r4.push(_n4), _i12 = _n4;
              }
              return [_r4, _n3];
            }
            if ("top" in e) {
              var _t18 = e.top;
              var _iterator8 = _createForOfIteratorHelper(e.children),
                _step8;
              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  var _i13 = _step8.value;
                  _t18 -= "number" == typeof _i13 ? _i13 : _i13.box.height + _i13.box.depth;
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
              return [e.children, _t18];
            }
            if ("bottom" in e) return [e.children, -e.bottom];
            if ("firstBaseline" in e) {
              var _t19 = e.firstBaseline[0];
              if ("number" == typeof _t19) throw new Error("First child must be an element.");
              return [e.firstBaseline, -_t19.box.depth];
            }
            if ("shift" in e) {
              var _t20 = e.children[0];
              if ("number" == typeof _t20) throw new Error("First child must be an element.");
              return [e.children, -_t20.box.depth - e.shift];
            }
            return [null, 0];
          }(e),
          _ref6 = _slicedToArray(_ref5, 2),
          i = _ref6[0],
          r = _ref6[1];
        if (!i) return [[], 0, 0];
        var n = 0;
        var _iterator9 = _createForOfIteratorHelper(i),
          _step9;
        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var _e17 = _step9.value;
            if ("number" != typeof _e17) {
              var _t22 = _e17.box;
              n = Math.max(n, _t22.maxFontSize, _t22.height);
            }
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
        n += 2;
        var a = new te(null, {
          classes: "pstrut"
        });
        a.setStyle("height", n, "em");
        var o = [];
        var s = r,
          l = r,
          c = r;
        var _iterator10 = _createForOfIteratorHelper(i),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _e18 = _step10.value;
            if ("number" == typeof _e18) c += _e18;else {
              var _i14 = _e18.box,
                _r5 = null !== (t = _e18.classes) && void 0 !== t ? t : [],
                _s3 = new te([a, _i14], {
                  classes: _r5.join(" "),
                  style: _e18.style
                });
              _s3.setStyle("top", -n - c - _i14.depth, "em"), _e18.marginLeft && _s3.setStyle("margin-left", _e18.marginLeft, "em"), _e18.marginRight && _s3.setStyle("margin-right", _e18.marginRight, "em"), o.push(_s3), c += _i14.height + _i14.depth;
            }
            s = Math.min(s, c), l = Math.max(l, c);
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
        var u = new te(o, {
          classes: "vlist"
        });
        var d;
        if (u.setStyle("height", l, "em"), s < 0) {
          var _e16 = new te(new te(null), {
            classes: "vlist"
          });
          _e16.setStyle("height", -s, "em");
          var _t21 = new te(8203, {
            classes: "vlist-s",
            maxFontSize: 0,
            height: 0,
            depth: 0
          });
          d = [new te([u, _t21], {
            classes: "vlist-r"
          }), new te(_e16, {
            classes: "vlist-r"
          })];
        } else d = [new te(u, {
          classes: "vlist-r"
        })];
        return [d, l, -s];
      }(e),
      _ref4 = _slicedToArray(_ref3, 3),
      r = _ref4[0],
      n = _ref4[1],
      a = _ref4[2];
    return _super.call(this, 1 === r.length ? r[0] : r, {
      classes: (null !== (i = null == t ? void 0 : t.classes) && void 0 !== i ? i : "") + " vlist-t" + (2 === r.length ? " vlist-t2" : ""),
      height: n,
      depth: a,
      type: null == t ? void 0 : t.type
    });
  }
  return _createClass(ce);
}(te);
var ue = [[8205, 1], [65038, 2], [127995, 5], [129456, 4], [917536, 96]];
var de;
var he = [127462, 127487];
function pe(e) {
  var t;
  if (void 0 === de) {
    de = {};
    for (var _i15 = 0, _ue = ue; _i15 < _ue.length; _i15++) {
      var _e19 = _ue[_i15];
      for (var _t23 = _e19[0]; _t23 <= _e19[0] + _e19[1] - 1; _t23++) de[_t23] = !0;
    }
  }
  return null !== (t = de[e]) && void 0 !== t && t;
}
function me(e) {
  return e >= he[0] && e <= he[1];
}
function fe(e) {
  if (/^[\u0020-\u00FF]*$/.test(e)) return e;
  var t = [],
    i = function (e) {
      var t = [];
      for (var _i16 = 0; _i16 < e.length; _i16++) {
        var _r6 = e.charCodeAt(_i16);
        if (13 === _r6 && 10 === e.charCodeAt(_i16 + 1) && (_r6 = 10, _i16++), 13 !== _r6 && 12 !== _r6 || (_r6 = 10), 0 === _r6 && (_r6 = 65533), _r6 >= 55296 && _r6 <= 56319) {
          var _t24 = e.charCodeAt(_i16 + 1);
          _t24 >= 56320 && _t24 <= 57343 && (_r6 = 65536 + 1024 * (_r6 - 55296) + (_t24 - 56320), _i16++);
        }
        t.push(_r6);
      }
      return t;
    }(e);
  var r = 0;
  for (; r < i.length;) {
    var _e20 = i[r++],
      _n5 = i[r];
    if (8205 === _n5) {
      var _e21 = r - 1;
      for (r += 2; 8205 === i[r];) r += 2;
      t.push(String.fromCodePoint.apply(String, _toConsumableArray(i.slice(_e21, r - _e21 + 1))));
    } else if (pe(_n5)) {
      var _e22 = r - 1;
      for (; pe(i[r]);) r += 8205 === i[r] ? 2 : 1;
      t.push(String.fromCodePoint.apply(String, _toConsumableArray(i.slice(_e22, 2 * r - _e22 - 1))));
    } else me(_e20) ? (r += 1, t.push(String.fromCodePoint.apply(String, _toConsumableArray(i.slice(r - 2, 2))))) : t.push(String.fromCodePoint(_e20));
  }
  return t;
}
var ge = /*#__PURE__*/function () {
  function ge(e) {
    _classCallCheck(this, ge);
    this.s = fe(e), this.pos = 0, this.obeyspaces = !1;
  }
  _createClass(ge, [{
    key: "end",
    value: function end() {
      return this.pos >= this.s.length;
    }
  }, {
    key: "get",
    value: function get() {
      return this.pos < this.s.length ? this.s[this.pos++] : "";
    }
  }, {
    key: "peek",
    value: function peek() {
      return this.s[this.pos];
    }
  }, {
    key: "match",
    value: function match(e) {
      var t = "string" == typeof this.s ? e.exec(this.s.slice(this.pos)) : e.exec(this.s.slice(this.pos).join(""));
      return (null == t ? void 0 : t[0]) ? (this.pos += t[0].length, t[0]) : "";
    }
  }, {
    key: "next",
    value: function next() {
      if (this.end()) return null;
      if (!this.obeyspaces && this.match(/^[ \f\n\r\t\v\u00A0\u2028\u2029]+/)) return "<space>";
      if (this.obeyspaces && this.match(/^[ \f\n\r\t\v\u00A0\u2028\u2029]/)) return "<space>";
      var e = this.get();
      if ("\\" === e) {
        if (!this.end()) {
          var _e23 = this.match(/^[a-zA-Z*]+/);
          if (_e23) this.match(/^[ \f\n\r\t\v\u00A0\u2028\u2029]*/);else if (_e23 = this.get(), " " === _e23) return "<space>";
          return "\\" + _e23;
        }
      } else {
        if ("{" === e) return "<{>";
        if ("}" === e) return "<}>";
        if ("^" === e) {
          if ("^" === this.peek()) {
            this.get();
            var _e24 = this.match(/^(\^(\^(\^(\^[\da-f])?[\da-f])?[\da-f])?[\da-f])?[\da-f]{2}/);
            if (_e24) return String.fromCodePoint(Number.parseInt(_e24.slice(_e24.lastIndexOf("^") + 1), 16));
          }
          return e;
        }
        if ("#" === e) {
          if (!this.end()) {
            var _e25 = !1;
            if (/[\d?@]/.test(this.peek()) && (_e25 = !0, this.pos + 1 < this.s.length)) {
              var _t25 = this.s[this.pos + 1];
              _e25 = /[^\dA-Za-z]/.test(_t25);
            }
            return _e25 ? "#" + this.get() : "#";
          }
        } else if ("$" === e) return "$" === this.peek() ? (this.get(), "<$$>") : "<$>";
      }
      return e;
    }
  }]);
  return ge;
}();
function ye(e, t) {
  var i, r, n, a;
  var o = [],
    s = e.next();
  if (s) if ("\\relax" === s) ;else if ("\\noexpand" === s) s = e.next(), s && o.push(s);else if ("\\obeyspaces" === s) e.obeyspaces = !0;else if ("\\space" === s || "~" === s) o.push("<space>");else if ("\\bgroup" === s) o.push("<{>");else if ("\\egroup" === s) o.push("<}>");else if ("\\string" === s) {
    if (s = e.next(), s) if (s.startsWith("\\")) {
      var _iterator11 = _createForOfIteratorHelper(s),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var _e26 = _step11.value;
          o.push("\\" === _e26 ? "\\backslash" : _e26);
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    } else "<{>" === s ? o.push("\\{") : "<space>" === s ? o.push("~") : "<}>" === s && o.push("\\}");
  } else if ("\\csname" === s) {
    for (; "<space>" === e.peek();) e.next();
    var _n6 = "",
      _a4 = !1,
      _l2 = [];
    do {
      if (0 === _l2.length) if (/^#[\d?@]$/.test(e.peek())) {
        var _n7 = e.get().slice(1);
        _l2 = be(null !== (r = null !== (i = null == t ? void 0 : t(_n7)) && void 0 !== i ? i : null == t ? void 0 : t("?")) && void 0 !== r ? r : "\\placeholder{}", t), s = _l2[0];
      } else s = e.next(), _l2 = s ? [s] : [];
      _a4 = 0 === _l2.length, _a4 || "\\endcsname" !== s || (_a4 = !0, _l2.shift()), _a4 || (_a4 = "<$>" === s || "<$$>" === s || "<{>" === s || "<}>" === s || "string" == typeof s && s.length > 1 && s.startsWith("\\")), _a4 || (_n6 += _l2.shift());
    } while (!_a4);
    _n6 && o.push("\\" + _n6), o = o.concat(_l2);
  } else if ("\\endcsname" === s) ;else if (s.length > 1 && s.startsWith("#")) {
    var _e27 = s.slice(1);
    o = o.concat(be(null !== (a = null !== (n = null == t ? void 0 : t(_e27)) && void 0 !== n ? n : null == t ? void 0 : t("?")) && void 0 !== a ? a : "\\placeholder{}", t));
  } else o.push(s);
  return o;
}
function be(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var i = e.toString().split(/\r?\n/);
  var r = "",
    n = "";
  var _iterator12 = _createForOfIteratorHelper(i),
    _step12;
  try {
    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
      var _e28 = _step12.value;
      r += n, n = " ";
      var _t26 = _e28.match(/((?:\\%)|[^%])*/);
      null !== _t26 && (r += _t26[0]);
    }
  } catch (err) {
    _iterator12.e(err);
  } finally {
    _iterator12.f();
  }
  var a = new ge(r);
  var o = [];
  do {
    o = o.concat(ye(a, t));
  } while (!a.end());
  return o;
}
function ve(e) {
  var t = "",
    i = "";
  var _iterator13 = _createForOfIteratorHelper(e),
    _step13;
  try {
    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
      var _r7 = _step13.value;
      _r7 && (/[a-zA-Z*]/.test(_r7[0]) && (i += t), t = /\\[a-zA-Z]+\*?$/.test(_r7) ? " " : "", i += _r7);
    }
  } catch (err) {
    _iterator13.e(err);
  } finally {
    _iterator13.f();
  }
  return i;
}
function xe(e) {
  var t = ve(e.map(function (e) {
    var t;
    return null !== (t = {
      "<space>": " ",
      "<$$>": "$$",
      "<$>": "$",
      "<{>": "{",
      "<}>": "}"
    }[e]) && void 0 !== t ? t : e;
  }));
  return t;
}
function ke() {
  return "window" in globalThis && "document" in globalThis;
}
function we() {
  if (!ke()) throw new Error("<math-field> is an interactive component that needs to run in a browser environment\nIf you are using nextjs, see https://nextjs.org/docs/advanced-features/dynamic-import#with-no-ssr");
}
function _e() {
  var e, t;
  return null !== (t = ke() && (null === (e = window.matchMedia) || void 0 === e ? void 0 : e.call(window, "(any-pointer: coarse)").matches)) && void 0 !== t && t;
}
function Me() {
  return ke() && "function" == typeof navigator.vibrate;
}
function Se() {
  if (!ke()) return "other";
  var e = navigator.platform;
  return /^(mac)/i.test(e) ? 5 === navigator.maxTouchPoints ? "ios" : "macos" : /^(win)/i.test(e) ? "windows" : /(android)/i.test(navigator.userAgent) ? "android" : /(iphone|ipod|ipad)/i.test(navigator.userAgent) ? "ios" : /\bcros\b/i.test(navigator.userAgent) ? "chromeos" : "other";
}
function Le() {
  if (!ke()) return !0;
  if (/firefox/i.test(navigator.userAgent)) {
    var _e29 = navigator.userAgent.match(/firefox\/(\d+)/i);
    return !!_e29 && parseInt(_e29[1]) >= 78;
  }
  if (/trident/i.test(navigator.userAgent)) return !1;
  if (/edge/i.test(navigator.userAgent)) {
    var _e30 = navigator.userAgent.match(/edg\/(\d+)/i);
    return !!_e30 && parseInt(_e30[1]) >= 79;
  }
  return !0;
}
var Ce = {},
  Ae = {
    60: "<",
    62: ">",
    111: "o",
    38: "\\&",
    123: "\\lbrace",
    125: "\\rbrace",
    91: "\\lbrack",
    93: "\\rbrack",
    58: "\\colon",
    160: "~",
    172: "\\neg",
    183: "\\cdot",
    188: "\\frac{1}{4}",
    189: "\\frac{1}{2}",
    190: "\\frac{3}{4}",
    8304: "^{0}",
    8305: "^{i}",
    185: "^{1}",
    178: "^{2}",
    179: "^{3}",
    8224: "\\dagger",
    8225: "\\ddagger",
    8230: "\\ldots",
    8308: "^{4}",
    8309: "^{5}",
    8310: "^{6}",
    8311: "^{7}",
    8312: "^{8}",
    8313: "^{9}",
    8314: "^{+}",
    8315: "^{-}",
    8316: "^{=}",
    8319: "^{n}",
    8320: "_{0}",
    8321: "_{1}",
    8322: "_{2}",
    8323: "_{3}",
    8324: "_{4}",
    8325: "_{5}",
    8326: "_{6}",
    8327: "_{7}",
    8328: "_{8}",
    8329: "_{9}",
    8330: "_{+}",
    8331: "_{-}",
    8332: "_{=}",
    8336: "_{a}",
    8337: "_{e}",
    8338: "_{o}",
    8339: "_{x}",
    8242: "\\prime",
    39: "\\prime",
    8592: "\\gets",
    8594: "\\to",
    9651: "\\triangle",
    9661: "\\triangledown",
    8715: "\\owns",
    8727: "\\ast",
    8739: "\\vert",
    8741: "\\Vert",
    8743: "\\land",
    8744: "\\lor",
    8901: "\\cdot",
    8904: "\\bowtie",
    8800: "\\ne",
    8804: "\\le",
    8805: "\\ge",
    8869: "\\bot",
    10231: "\\biconditional",
    10232: "\\impliedby",
    10233: "\\implies",
    10234: "\\iff",
    8450: "\\C",
    8469: "\\N",
    8473: "\\P",
    8474: "\\Q",
    8477: "\\R",
    8484: "\\Z"
  },
  Ne = {},
  ze = {},
  qe = {
    iff: "\\;\u27FA\\;",
    nicefrac: "^{#1}\\!\\!/\\!_{#2}",
    rd: "\\mathrm{d}",
    rD: "\\mathrm{D}",
    doubleStruckCapitalN: "\\mathbb{N}",
    doubleStruckCapitalR: "\\mathbb{R}",
    doubleStruckCapitalQ: "\\mathbb{Q}",
    doubleStruckCapitalZ: "\\mathbb{Z}",
    doubleStruckCapitalP: "\\mathbb{P}",
    scriptCapitalE: "\\mathscr{E}",
    scriptCapitalH: "\\mathscr{H}",
    scriptCapitalL: "\\mathscr{L}",
    gothicCapitalC: "\\mathfrak{C}",
    gothicCapitalH: "\\mathfrak{H}",
    gothicCapitalI: "\\mathfrak{I}",
    gothicCapitalR: "\\mathfrak{R}",
    imaginaryI: "\\mathrm{i}",
    imaginaryJ: "\\mathrm{j}",
    exponentialE: "\\mathrm{e}",
    differentialD: "\\mathrm{d}",
    capitalDifferentialD: "\\mathrm{D}",
    "braket.sty": {
      package: {
        bra: "\\mathinner{\\langle{#1}|}",
        ket: "\\mathinner{|{#1}\\rangle}",
        braket: "\\mathinner{\\langle{#1}\\rangle}",
        set: "\\mathinner{\\lbrace #1 \\rbrace}",
        Bra: "\\left\\langle #1\\right|",
        Ket: "\\left|#1\\right\\rangle",
        Braket: "\\left\\langle{#1}\\right\\rangle",
        Set: "\\left\\lbrace #1 \\right\\rbrace"
      }
    },
    "amsmath.sty": {
      package: {
        varGamma: "\\mathit{\\Gamma}",
        varDelta: "\\mathit{\\Delta}",
        varTheta: "\\mathit{\\Theta}",
        varLambda: "\\mathit{\\Lambda}",
        varXi: "\\mathit{\\Xi}",
        varPi: "\\mathit{\\Pi}",
        varSigma: "\\mathit{\\Sigma}",
        varUpsilon: "\\mathit{\\Upsilon}",
        varPhi: "\\mathit{\\Phi}",
        varPsi: "\\mathit{\\Psi}",
        varOmega: "\\mathit{\\Omega}",
        pmod: {
          def: "\\quad(\\operatorname{mod}\\ #1)",
          args: 1,
          expand: !1,
          captureSelection: !1
        },
        mod: {
          def: "\\quad\\operatorname{mod}\\,\\,#1",
          args: 1,
          expand: !1,
          captureSelection: !1
        },
        bmod: {
          def: "\\;\\mathbin{\\operatorname{mod }}",
          expand: !1
        }
      },
      expand: !1
    },
    "texvc.sty": {
      package: {
        darr: "\\downarrow",
        dArr: "\\Downarrow",
        Darr: "\\Downarrow",
        lang: "\\langle",
        rang: "\\rangle",
        uarr: "\\uparrow",
        uArr: "\\Uparrow",
        Uarr: "\\Uparrow",
        N: "\\mathbb{N}",
        R: "\\mathbb{R}",
        Z: "\\mathbb{Z}",
        alef: "\\aleph",
        alefsym: "\\aleph",
        Alpha: "\\mathrm{A}",
        Beta: "\\mathrm{B}",
        bull: "\\bullet",
        Chi: "\\mathrm{X}",
        clubs: "\\clubsuit",
        cnums: "\\mathbb{C}",
        Complex: "\\mathbb{C}",
        Dagger: "\\ddagger",
        diamonds: "\\diamondsuit",
        empty: "\\emptyset",
        Epsilon: "\\mathrm{E}",
        Eta: "\\mathrm{H}",
        exist: "\\exists",
        harr: "\\leftrightarrow",
        hArr: "\\Leftrightarrow",
        Harr: "\\Leftrightarrow",
        hearts: "\\heartsuit",
        image: "\\Im",
        infin: "\\infty",
        Iota: "\\mathrm{I}",
        isin: "\\in",
        Kappa: "\\mathrm{K}",
        larr: "\\leftarrow",
        lArr: "\\Leftarrow",
        Larr: "\\Leftarrow",
        lrarr: "\\leftrightarrow",
        lrArr: "\\Leftrightarrow",
        Lrarr: "\\Leftrightarrow",
        Mu: "\\mathrm{M}",
        natnums: "\\mathbb{N}",
        Nu: "\\mathrm{N}",
        Omicron: "\\mathrm{O}",
        plusmn: "\\pm",
        rarr: "\\rightarrow",
        rArr: "\\Rightarrow",
        Rarr: "\\Rightarrow",
        real: "\\Re",
        reals: "\\mathbb{R}",
        Reals: "\\mathbb{R}",
        Rho: "\\mathrm{P}",
        sdot: "\\cdot",
        sect: "\\S",
        spades: "\\spadesuit",
        sub: "\\subset",
        sube: "\\subseteq",
        supe: "\\supseteq",
        Tau: "\\mathrm{T}",
        thetasym: "\\vartheta",
        weierp: "\\wp",
        Zeta: "\\mathrm{Z}"
      },
      expand: !1
    }
  },
  De = {
    " ": 32,
    "\\#": 35,
    "\\&": 38,
    "\\$": 36,
    "\\%": 37,
    "\\_": 95,
    "\\euro": 8364,
    "\\maltese": 10016,
    "\\{": 123,
    "\\}": 125,
    "\\nobreakspace": 160,
    "\\ldots": 8230,
    "\\textellipsis": 8230,
    "\\backslash": 92,
    "`": 8216,
    "'": 8217,
    "``": 8220,
    "''": 8221,
    "\\degree": 176,
    "\\textasciicircum": 94,
    "\\textasciitilde": 126,
    "\\textasteriskcentered": 42,
    "\\textbackslash": 92,
    "\\textbraceleft": 123,
    "\\textbraceright": 125,
    "\\textbullet": 8226,
    "\\textdollar": 36,
    "\\textsterling": 163,
    "\\textdagger": 8224,
    "\\textdaggerdbl": 8225,
    "\u2013": 8211,
    "\u2014": 8212,
    "\u2018": 8216,
    "\u2019": 8217,
    "\u201C": 8220,
    "\u201D": 8221,
    '"': 8221,
    "\\ss": 223,
    "\\ae": 230,
    "\\oe": 339,
    "\\AE": 198,
    "\\OE": 338,
    "\\O": 216,
    "\\i": 305,
    "\\j": 567,
    "\\aa": 229,
    "\\AA": 197
  },
  Ee = /[\w!@*()-=+{}[\]\\';:?/.,~<>`|$%#&^" ]/,
  Te = Le() ? new RegExp("\\p{Letter}", "u") : /[a-zA-Z\u0430\u0410\u0431\u0411\u0432\u0412\u0433\u0413\u0434\u0414\u0435\u0415\u0451\u0401\u0436\u0416\u0437\u0417\u0438\u0418\u0439\u0419\u043a\u041a\u043b\u041b\u043c\u041c\u043d\u041d\u043e\u041e\u043f\u041f\u0440\u0420\u0441\u0421\u0442\u0422\u0443\u0423\u0444\u0424\u0445\u0425\u0446\u0426\u0447\u0427\u0448\u0428\u0449\u0429\u044a\u042a\u044b\u042b\u044c\u042c\u044d\u042d\u044e\u042e\u044f\u0104\u0105\u0106\u0107\u0118\u0119\u0141\u0142\u0143\u0144\xd3\xf3\u015a\u015b\u0179\u017a\u017b\u017c\xe0\xe2\xe4\xf4\xe9\xe8\xeb\xea\xef\xee\xe7\xf9\xfb\xfc\xff\xe6\u0153\xc0\xc2\xc4\xd4\xc9\xc8\xcb\xca\xcf\xce\u0178\xc7\xd9\xdb\xdc\xc6\u0152\xf6\xdf\xd6\u1e9e\xec\xed\xf2\xfa\xcc\xcd\xd2\xda\xe1\xf1\xc1\xd1]/,
  Oe = Le() ? new RegExp("[0-9\\p{Letter}]", "u") : /[\da-zA-Z\u0430\u0410\u0431\u0411\u0432\u0412\u0433\u0413\u0434\u0414\u0435\u0415\u0451\u0401\u0436\u0416\u0437\u0417\u0438\u0418\u0439\u0419\u043a\u041a\u043b\u041b\u043c\u041c\u043d\u041d\u043e\u041e\u043f\u041f\u0440\u0420\u0441\u0421\u0442\u0422\u0443\u0423\u0444\u0424\u0445\u0425\u0446\u0426\u0447\u0427\u0448\u0428\u0449\u0429\u044a\u042a\u044b\u042b\u044c\u042c\u044d\u042d\u044e\u042e\u044f\u0104\u0105\u0106\u0107\u0118\u0119\u0141\u0142\u0143\u0144\xd3\xf3\u015a\u015b\u0179\u017a\u017b\u017c\xe0\xe2\xe4\xf4\xe9\xe8\xeb\xea\xef\xee\xe7\xf9\xfb\xfc\xff\xe6\u0153\xc0\xc2\xc4\xd4\xc9\xc8\xcb\xca\xcf\xce\u0178\xc7\xd9\xdb\xdc\xc6\u0152\xf6\xdf\xd6\u1e9e\xec\xed\xf2\xfa\xcc\xcd\xd2\xda\xe1\xf1\xc1\xd1]/;
function Be(e, t) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "mord";
  var r = arguments.length > 3 ? arguments[3] : undefined;
  void 0 !== t && (Ce[e] = {
    type: i,
    variant: r,
    codepoint: t
  }, Ae[t] || r || (Ae[t] = e), De[e] || (De[e] = t));
}
function Ke(e, t, i) {
  if ("string" != typeof e) {
    var _iterator14 = _createForOfIteratorHelper(e),
      _step14;
    try {
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
        var _step14$value = _slicedToArray(_step14.value, 4),
          _r8 = _step14$value[0],
          _n8 = _step14$value[1],
          _a5 = _step14$value[2],
          _o3 = _step14$value[3];
        Be(_r8, _n8, null != _a5 ? _a5 : t, null != _o3 ? _o3 : i);
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }
  } else for (var _t27 = 0; _t27 < e.length; _t27++) {
    var _i17 = e.charAt(_t27);
    Be(_i17, _i17.codePointAt(0));
  }
}
function Fe(e, t) {
  for (var _i18 = e; _i18 <= t; _i18++) Be(String.fromCodePoint(_i18), _i18);
}
function $e(e, t) {
  if (void 0 === t) return "";
  if ("math" === e && Ae[t]) return Ae[t];
  if ("text" === e) {
    var _e31 = Object.keys(De).find(function (e) {
      return De[e] === t;
    });
    if (!_e31) {
      var _i19 = t.toString(16);
      _e31 = "^".repeat(_i19.length) + _i19;
    }
    return _e31;
  }
  return String.fromCodePoint(t);
}
var Pe = {
    119893: 8462,
    119965: 8492,
    119968: 8496,
    119969: 8497,
    119971: 8459,
    119972: 8464,
    119975: 8466,
    119976: 8499,
    119981: 8475,
    119994: 8495,
    119996: 8458,
    120004: 8500,
    120070: 8493,
    120075: 8460,
    120076: 8465,
    120085: 8476,
    120093: 8488,
    120122: 8450,
    120127: 8461,
    120133: 8469,
    120135: 8473,
    120136: 8474,
    120137: 8477,
    120145: 8484
  },
  Ie = [{
    start: 119808,
    len: 26,
    offset: 65,
    style: "bold"
  }, {
    start: 119834,
    len: 26,
    offset: 97,
    style: "bold"
  }, {
    start: 119860,
    len: 26,
    offset: 65,
    style: "italic"
  }, {
    start: 119886,
    len: 26,
    offset: 97,
    style: "italic"
  }, {
    start: 119912,
    len: 26,
    offset: 65,
    style: "bolditalic"
  }, {
    start: 119938,
    len: 26,
    offset: 97,
    style: "bolditalic"
  }, {
    start: 119964,
    len: 26,
    offset: 65,
    variant: "script"
  }, {
    start: 119990,
    len: 26,
    offset: 97,
    variant: "script"
  }, {
    start: 120016,
    len: 26,
    offset: 65,
    variant: "script",
    style: "bold"
  }, {
    start: 120042,
    len: 26,
    offset: 97,
    variant: "script",
    style: "bold"
  }, {
    start: 120068,
    len: 26,
    offset: 65,
    variant: "fraktur"
  }, {
    start: 120094,
    len: 26,
    offset: 97,
    variant: "fraktur"
  }, {
    start: 120172,
    len: 26,
    offset: 65,
    variant: "fraktur",
    style: "bold"
  }, {
    start: 120198,
    len: 26,
    offset: 97,
    variant: "fraktur",
    style: "bold"
  }, {
    start: 120120,
    len: 26,
    offset: 65,
    variant: "double-struck"
  }, {
    start: 120146,
    len: 26,
    offset: 97,
    variant: "double-struck"
  }, {
    start: 120224,
    len: 26,
    offset: 65,
    variant: "sans-serif"
  }, {
    start: 120250,
    len: 26,
    offset: 97,
    variant: "sans-serif"
  }, {
    start: 120276,
    len: 26,
    offset: 65,
    variant: "sans-serif",
    style: "bold"
  }, {
    start: 120302,
    len: 26,
    offset: 97,
    variant: "sans-serif",
    style: "bold"
  }, {
    start: 120328,
    len: 26,
    offset: 65,
    variant: "sans-serif",
    style: "italic"
  }, {
    start: 120354,
    len: 26,
    offset: 97,
    variant: "sans-serif",
    style: "italic"
  }, {
    start: 120380,
    len: 26,
    offset: 65,
    variant: "sans-serif",
    style: "bolditalic"
  }, {
    start: 120406,
    len: 26,
    offset: 97,
    variant: "sans-serif",
    style: "bolditalic"
  }, {
    start: 120432,
    len: 26,
    offset: 65,
    variant: "monospace"
  }, {
    start: 120458,
    len: 26,
    offset: 97,
    variant: "monospace"
  }, {
    start: 120488,
    len: 25,
    offset: 913,
    style: "bold"
  }, {
    start: 120514,
    len: 25,
    offset: 945,
    style: "bold"
  }, {
    start: 120546,
    len: 25,
    offset: 913,
    style: "italic"
  }, {
    start: 120572,
    len: 25,
    offset: 945,
    style: "italic"
  }, {
    start: 120604,
    len: 25,
    offset: 913,
    style: "bolditalic"
  }, {
    start: 120630,
    len: 25,
    offset: 945,
    style: "bolditalic"
  }, {
    start: 120662,
    len: 25,
    offset: 913,
    variant: "sans-serif",
    style: "bold"
  }, {
    start: 120688,
    len: 25,
    offset: 945,
    variant: "sans-serif",
    style: "bold"
  }, {
    start: 120720,
    len: 25,
    offset: 913,
    variant: "sans-serif",
    style: "bolditalic"
  }, {
    start: 120746,
    len: 25,
    offset: 945,
    variant: "sans-serif",
    style: "bolditalic"
  }, {
    start: 120782,
    len: 10,
    offset: 48,
    variant: "main",
    style: "bold"
  }, {
    start: 120792,
    len: 10,
    offset: 48,
    variant: "double-struck"
  }, {
    start: 120803,
    len: 10,
    offset: 48,
    variant: "sans-serif"
  }, {
    start: 120812,
    len: 10,
    offset: 48,
    variant: "sans-serif",
    style: "bold"
  }, {
    start: 120822,
    len: 10,
    offset: 48,
    variant: "monospace"
  }];
function Re(e, t, i) {
  var r, n;
  if (!e || 0 === e.length) return null;
  var a = null;
  if (e.startsWith("\\")) {
    if (a = null !== (r = Ne[e]) && void 0 !== r ? r : null, a) return a;
    if ("math" === t ? a = Ce[e] : De[e] && (a = {
      type: "mord",
      codepoint: De[e]
    }), !a) {
      var _t28 = e.slice(1);
      if (null == i ? void 0 : i[_t28]) {
        var _e32 = null !== (n = i[_t28].args) && void 0 !== n ? n : 0;
        for (a = {
          type: "group",
          params: [],
          infix: !1
        }; _e32 >= 1;) a.params.push({
          isOptional: !1,
          type: "math"
        }), _e32 -= 1;
      }
    }
  } else "math" === t ? a = Ce[e] : De[e] ? a = {
    codepoint: De[e],
    type: "mord"
  } : "text" === t && (a = {
    codepoint: e.codePointAt(0),
    type: "mord"
  });
  return !a || "mord" !== a.type || 102 !== a.codepoint && 103 !== a.codepoint && 104 !== a.codepoint || (a.isFunction = !0), a;
}
function Ve(e) {
  var t = "auto";
  var i = e.match(/:([^=]+)/);
  return i && (t = i[1].trim()), t;
}
function je(e) {
  if (!e) return [];
  var t = [],
    i = e.split("]");
  if (i[0].startsWith("[")) {
    t.push({
      isOptional: !0,
      type: Ve(i[0].slice(1))
    });
    for (var _e33 = 1; _e33 <= i.length; _e33++) t = t.concat(je(i[_e33]));
  } else if (i = e.split("}"), i[0].startsWith("{")) {
    t.push({
      isOptional: !1,
      type: Ve(i[0].slice(1))
    });
    for (var _e34 = 1; _e34 <= i.length; _e34++) t = t.concat(je(i[_e34]));
  }
  return t;
}
function He(e) {
  if (!e) return "";
  var t = "",
    i = !0;
  var _iterator15 = _createForOfIteratorHelper(e),
    _step15;
  try {
    for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
      var _r9 = _step15.value;
      "string" == typeof _r9.value ? t += _r9.value : i = !1;
    }
  } catch (err) {
    _iterator15.e(err);
  } finally {
    _iterator15.f();
  }
  return i ? t : "";
}
function Ue(e, t, i) {
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  "string" == typeof e && (e = [e]);
  var n = {
    tabular: r,
    params: je(t),
    createAtom: i
  };
  var _iterator16 = _createForOfIteratorHelper(e),
    _step16;
  try {
    for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
      var _t29 = _step16.value;
      ze[_t29] = n;
    }
  } catch (err) {
    _iterator16.e(err);
  } finally {
    _iterator16.f();
  }
}
function We(e, t, i) {
  Ue(e, t, i, !0);
}
function Ze(e, t, i) {
  var r, n;
  i || (i = {});
  var a = {
    params: je(t),
    ifMode: i.ifMode,
    isFunction: null !== (r = i.isFunction) && void 0 !== r && r,
    applyMode: i.applyMode,
    infix: null !== (n = i.infix) && void 0 !== n && n,
    createAtom: i.createAtom,
    applyStyle: i.applyStyle
  };
  if ("string" == typeof e) Ne["\\" + e] = a;else {
    var _iterator17 = _createForOfIteratorHelper(e),
      _step17;
    try {
      for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
        var _t30 = _step17.value;
        Ne["\\" + _t30] = a;
      }
    } catch (err) {
      _iterator17.e(err);
    } finally {
      _iterator17.f();
    }
  }
}
var Ge;
function Xe(e) {
  return Ge || (Ge = Qe(qe)), e ? _objectSpread(_objectSpread({}, Ge), Qe(e)) : Ge;
}
function Ye(e, t) {
  var i, r, n, a;
  if ("string" == typeof e) {
    var _n9 = 0;
    var _a6 = e;
    return /(^|[^\\])#1/.test(_a6) && (_n9 = 1), /(^|[^\\])#2/.test(_a6) && (_n9 = 2), /(^|[^\\])#3/.test(_a6) && (_n9 = 3), /(^|[^\\])#4/.test(_a6) && (_n9 = 4), /(^|[^\\])#5/.test(_a6) && (_n9 = 5), /(^|[^\\])#6/.test(_a6) && (_n9 = 6), /(^|[^\\])#7/.test(_a6) && (_n9 = 7), /(^|[^\\])#8/.test(_a6) && (_n9 = 8), /(^|[^\\])#9/.test(_a6) && (_n9 = 9), {
      expand: null === (i = null == t ? void 0 : t.expand) || void 0 === i || i,
      captureSelection: null === (r = null == t ? void 0 : t.captureSelection) || void 0 === r || r,
      args: _n9,
      def: _a6
    };
  }
  return _objectSpread({
    expand: null === (n = null == t ? void 0 : t.expand) || void 0 === n || n,
    captureSelection: null === (a = null == t ? void 0 : t.captureSelection) || void 0 === a || a,
    args: 0
  }, e);
}
function Qe(e) {
  if (!e) return {};
  var t = {};
  for (var _i20 = 0, _Object$keys3 = Object.keys(e); _i20 < _Object$keys3.length; _i20++) {
    var _i21 = _Object$keys3[_i20];
    var _r10 = e[_i21];
    if (null == _r10) delete t[_i21];else if ("object" == typeof _r10 && "package" in _r10) for (var _i22 = 0, _Object$keys4 = Object.keys(_r10.package); _i22 < _Object$keys4.length; _i22++) {
      var _e35 = _Object$keys4[_i22];
      t[_e35] = Ye(_r10.package[_e35], {
        expand: _r10.expand,
        captureSelection: _r10.captureSelection
      });
    } else t[_i21] = Ye(_r10);
  }
  return t;
}
var Je = /*#__PURE__*/function (_te2) {
  _inherits(Je, _te2);
  var _super2 = _createSuper(Je);
  function Je(e, t, i) {
    var _this2;
    _classCallCheck(this, Je);
    _this2 = _super2.call(this, null, i), _this2.placeholderId = e, _this2.element = t, _this2.htmlData = "placeholder-id=".concat(e), _this2.height = "" === t.style.fontSize ? 1 : t.clientHeight / parseInt(t.style.fontSize) * .6;
    return _this2;
  }
  _createClass(Je, [{
    key: "toMarkup",
    value: function toMarkup() {
      var _this3 = this;
      var e = "";
      var t = this.classes.split(" "),
        i = 1 === t.length ? t[0] : t.filter(function (e, t, i) {
          return e.length > 0 && i.indexOf(e) === t;
        }).join(" ");
      if (this.cssId && (e += " id=".concat(this.cssId.replace(/ /g, "-"), " ")), this.htmlData) {
        var _t31 = this.htmlData.split(",");
        var _iterator18 = _createForOfIteratorHelper(_t31),
          _step18;
        try {
          for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
            var _i23 = _step18.value;
            var _t32 = _i23.match(/([^=]+)=(.+$)/);
            if (_t32) {
              var _i24 = _t32[1].trim().replace(/ /g, "-");
              _i24 && (e += " data-".concat(_i24, "=").concat(_t32[2], " "));
            } else {
              var _t33 = _i23.trim().replace(/ /g, "-");
              _t33 && (e += " data-".concat(_t33, " "));
            }
          }
        } catch (err) {
          _iterator18.e(err);
        } finally {
          _iterator18.f();
        }
      }
      return this.attributes && (e += " " + Object.keys(this.attributes).map(function (e) {
        return "".concat(e, "=\"").concat(_this3.attributes[e], "\"");
      }).join(" ")), i.length > 0 && (e += " class=\"".concat(i, "\"")), e += " style=\"display: inline-block; width:".concat(this.element.clientWidth, "px; height:").concat(this.element.clientHeight, "px; \""), "<span ".concat(e, "></span>");
    }
  }]);
  return Je;
}(te);
var et = ["above", "body", "below", "superscript", "subscript"];
function tt(e) {
  return "string" == typeof e && et.includes(e);
}
function it(e) {
  return void 0 !== e && Array.isArray(e) && 2 === e.length;
}
var rt = /*#__PURE__*/function () {
  function rt(e, t) {
    _classCallCheck(this, rt);
    var i, r, n, a;
    this.command = null == t ? void 0 : t.command, this.type = e, "string" == typeof (null == t ? void 0 : t.value) && (this.value = t.value), this._isDirty = !1, this._changeCounter = 0, this.mode = null !== (i = null == t ? void 0 : t.mode) && void 0 !== i ? i : "math", this.isFunction = null !== (r = null == t ? void 0 : t.isFunction) && void 0 !== r && r, this.subsupPlacement = null == t ? void 0 : t.limits, this.style = null !== (n = null == t ? void 0 : t.style) && void 0 !== n ? n : {}, this.serializeOverride = null == t ? void 0 : t.serialize, this.displayContainsHighlight = null !== (a = null == t ? void 0 : t.displayContainsHighlight) && void 0 !== a && a;
  }
  _createClass(rt, [{
    key: "changeCounter",
    get: function get() {
      return this._changeCounter;
    }
  }, {
    key: "isDirty",
    get: function get() {
      return this._isDirty;
    },
    set: function set(e) {
      if (this._isDirty = e, e) {
        this._changeCounter++, this.verbatimLatex = void 0, this._children = void 0;
        var _e36 = this.parent;
        for (; _e36;) _e36._isDirty = !0, _e36._changeCounter++, _e36.verbatimLatex = void 0, _e36._children = void 0, _e36 = _e36.parent;
      }
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      var t;
      return this.body && this.command ? ve([this.command, "{", this.bodyToLatex(e), "}", this.supsubToLatex(e)]) : this.body ? ve([this.bodyToLatex(e), this.supsubToLatex(e)]) : this.value && "\u200B" !== this.value ? null !== (t = this.command) && void 0 !== t ? t : function (e, t) {
        var i;
        if ("text" === e) return null !== (i = $e(e, t.codePointAt(0))) && void 0 !== i ? i : t;
        var r;
        if (r = $e(e, t.codePointAt(0)), r) return r;
        var n = function (e) {
          var t;
          if ((e < 119808 || e > 120831) && (e < 8448 || e > 8527)) return {
            char: String.fromCodePoint(e)
          };
          for (var _i25 in Pe) if (Pe[_i25] === e) {
            e = null !== (t = _i25.codePointAt(0)) && void 0 !== t ? t : 0;
            break;
          }
          for (var _i26 = 0, _Ie = Ie; _i26 < _Ie.length; _i26++) {
            var _t34 = _Ie[_i26];
            if (e >= _t34.start && e < _t34.start + _t34.len) return {
              char: String.fromCodePoint(e - _t34.start + _t34.offset),
              variant: _t34.variant,
              style: _t34.style
            };
          }
          return {
            char: String.fromCodePoint(e)
          };
        }(t.codePointAt(0));
        return n.style || n.variant ? (r = n.char, n.variant && (r = "\\" + n.variant + "{" + r + "}"), "bold" === n.style ? r = "\\mathbf{" + r + "}" : "italic" === n.style ? r = "\\mathit{" + r + "}" : "bolditalic" === n.style && (r = "\\mathbfit{" + r + "}"), "\\mathord{" + r + "}") : "";
      }(this.mode, this.value) : "";
    }
  }, {
    key: "bodyToLatex",
    value: function bodyToLatex(e) {
      return nt(this.body, e);
    }
  }, {
    key: "aboveToLatex",
    value: function aboveToLatex(e) {
      return nt(this.above, e);
    }
  }, {
    key: "belowToLatex",
    value: function belowToLatex(e) {
      return nt(this.below, e);
    }
  }, {
    key: "supsubToLatex",
    value: function supsubToLatex(e) {
      var t = "";
      if (void 0 !== this.branch("subscript")) {
        var _i27 = nt(this.subscript, e);
        0 === _i27.length ? t += "_" : 1 === _i27.length ? t += "_" + _i27 : t += "_{".concat(_i27, "}");
      }
      if (void 0 !== this.branch("superscript")) {
        var _i28 = nt(this.superscript, e);
        0 === _i28.length ? t += "^" : 1 === _i28.length ? t += "\u2032" === _i28 ? "^\\prime " : "\u2033" === _i28 ? "^\\doubleprime " : "^" + _i28 : t += "^{".concat(_i28, "}");
      }
      return t;
    }
  }, {
    key: "treeDepth",
    get: function get() {
      var e = 1,
        t = this.parent;
      for (; t;) t = t.parent, e += 1;
      return e;
    }
  }, {
    key: "inCaptureSelection",
    get: function get() {
      var e = !1,
        t = this;
      for (; t;) {
        if (t.captureSelection) {
          e = !0;
          break;
        }
        t = t.parent;
      }
      return e;
    }
  }, {
    key: "branch",
    value: function branch(e) {
      if (tt(e) && this._branches) return this._branches[e];
    }
  }, {
    key: "branches",
    get: function get() {
      if (!this._branches) return [];
      var e = [];
      for (var _i29 = 0, _et = et; _i29 < _et.length; _i29++) {
        var _t35 = _et[_i29];
        this._branches[_t35] && e.push(_t35);
      }
      return e;
    }
  }, {
    key: "createBranch",
    value: function createBranch(e) {
      return tt(e) ? (this._branches ? this._branches[e] || (this._branches[e] = [this.makeFirstAtom(e)]) : this._branches = _defineProperty({}, e, [this.makeFirstAtom(e)]), this.isDirty = !0, this._branches[e]) : [];
    }
  }, {
    key: "row",
    get: function get() {
      return it(this.treeBranch) ? this.treeBranch[0] : -1;
    }
  }, {
    key: "col",
    get: function get() {
      return it(this.treeBranch) ? this.treeBranch[1] : -1;
    }
  }, {
    key: "body",
    get: function get() {
      var e;
      return null === (e = this._branches) || void 0 === e ? void 0 : e.body;
    },
    set: function set(e) {
      this.setChildren(e, "body");
    }
  }, {
    key: "superscript",
    get: function get() {
      var e;
      return null === (e = this._branches) || void 0 === e ? void 0 : e.superscript;
    },
    set: function set(e) {
      this.setChildren(e, "superscript");
    }
  }, {
    key: "subscript",
    get: function get() {
      var e;
      return null === (e = this._branches) || void 0 === e ? void 0 : e.subscript;
    },
    set: function set(e) {
      this.setChildren(e, "subscript");
    }
  }, {
    key: "above",
    get: function get() {
      var e;
      return null === (e = this._branches) || void 0 === e ? void 0 : e.above;
    },
    set: function set(e) {
      this.setChildren(e, "above");
    }
  }, {
    key: "below",
    get: function get() {
      var e;
      return null === (e = this._branches) || void 0 === e ? void 0 : e.below;
    },
    set: function set(e) {
      this.setChildren(e, "below");
    }
  }, {
    key: "computedStyle",
    get: function get() {
      var e = _objectSpread({}, this.style),
        t = void 0 !== this.style.verbatimColor,
        i = void 0 !== this.style.verbatimBackgroundColor;
      if (e && (delete e.variant, delete e.variantStyle), !this.parent) return null != e ? e : {};
      var r = _objectSpread(_objectSpread({}, this.parent.computedStyle), e);
      return i || delete r.verbatimBackgroundColor, t || delete r.verbatimColor, r;
    }
  }, {
    key: "applyStyle",
    value: function applyStyle(e) {
      this.isDirty = !0, this.style = _objectSpread(_objectSpread({}, this.style), e), "none" === this.style.fontFamily && delete this.style.fontFamily, "auto" === this.style.fontShape && delete this.style.fontShape, "auto" === this.style.fontSeries && delete this.style.fontSeries, "none" === this.style.color && (delete this.style.color, delete this.style.verbatimColor), "none" === this.style.backgroundColor && (delete this.style.backgroundColor, delete this.style.verbatimBackgroundColor), "auto" === this.style.fontSize && delete this.style.fontSize;
    }
  }, {
    key: "getInitialBaseElement",
    value: function getInitialBaseElement() {
      var e;
      return this.hasEmptyBranch("body") || (e = this.body[1].getInitialBaseElement()), null != e ? e : this;
    }
  }, {
    key: "getFinalBaseElement",
    value: function getFinalBaseElement() {
      return this.hasEmptyBranch("body") ? this : this.body[this.body.length - 1].getFinalBaseElement();
    }
  }, {
    key: "isCharacterBox",
    value: function isCharacterBox() {
      var e = this.getInitialBaseElement();
      return /mord/.test(e.type);
    }
  }, {
    key: "hasEmptyBranch",
    value: function hasEmptyBranch(e) {
      var t = this.branch(e);
      return !t || 1 === t.length;
    }
  }, {
    key: "setChildren",
    value: function setChildren(e, t) {
      if (e && tt(t)) {
        this._branches ? this._branches[t] = [this.makeFirstAtom(t)].concat(_toConsumableArray(e)) : this._branches = _defineProperty({}, t, [this.makeFirstAtom(t)].concat(_toConsumableArray(e))), this.isDirty = !0;
        var _iterator19 = _createForOfIteratorHelper(e),
          _step19;
        try {
          for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
            var _i30 = _step19.value;
            _i30.parent = this, _i30.treeBranch = t;
          }
        } catch (err) {
          _iterator19.e(err);
        } finally {
          _iterator19.f();
        }
      }
    }
  }, {
    key: "makeFirstAtom",
    value: function makeFirstAtom(e) {
      var t = new rt("first", {
        mode: this.mode
      });
      return t.parent = this, t.treeBranch = e, t;
    }
  }, {
    key: "addChild",
    value: function addChild(e, t) {
      this.createBranch(t).push(e), this.isDirty = !0, e.parent = this, e.treeBranch = t;
    }
  }, {
    key: "addChildBefore",
    value: function addChildBefore(e, t) {
      var i = this.createBranch(t.treeBranch);
      i.splice(i.indexOf(t), 0, e), this.isDirty = !0, e.parent = this, e.treeBranch = t.treeBranch;
    }
  }, {
    key: "addChildAfter",
    value: function addChildAfter(e, t) {
      var i = this.createBranch(t.treeBranch);
      i.splice(i.indexOf(t) + 1, 0, e), this.isDirty = !0, e.parent = this, e.treeBranch = t.treeBranch;
    }
  }, {
    key: "addChildren",
    value: function addChildren(e, t) {
      var _iterator20 = _createForOfIteratorHelper(e),
        _step20;
      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var _i31 = _step20.value;
          this.addChild(_i31, t);
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
    }
  }, {
    key: "addChildrenAfter",
    value: function addChildrenAfter(e, t) {
      var i = this.createBranch(t.treeBranch);
      i.splice.apply(i, [i.indexOf(t) + 1, 0].concat(_toConsumableArray(e))), this.isDirty = !0;
      var _iterator21 = _createForOfIteratorHelper(e),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var _i32 = _step21.value;
          _i32.parent = this, _i32.treeBranch = t.treeBranch;
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
      return e[e.length - 1];
    }
  }, {
    key: "removeBranch",
    value: function removeBranch(e) {
      var t = this.branch(e);
      if (tt(e) && (this._branches[e] = void 0), !t) return [];
      var _iterator22 = _createForOfIteratorHelper(t),
        _step22;
      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var _e37 = _step22.value;
          _e37.parent = void 0, _e37.treeBranch = void 0;
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
      return t.shift(), this.isDirty = !0, t;
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      if ("first" === e.type) return;
      var t = this.branch(e.treeBranch),
        i = t.indexOf(e);
      t.splice(i, 1), this.isDirty = !0, e.parent = void 0, e.treeBranch = void 0;
    }
  }, {
    key: "siblings",
    get: function get() {
      return "root" === this.type ? [] : this.parent.branch(this.treeBranch);
    }
  }, {
    key: "firstSibling",
    get: function get() {
      return this.siblings[0];
    }
  }, {
    key: "lastSibling",
    get: function get() {
      var e = this.siblings;
      return e[e.length - 1];
    }
  }, {
    key: "isFirstSibling",
    get: function get() {
      return this === this.firstSibling;
    }
  }, {
    key: "isLastSibling",
    get: function get() {
      return this === this.lastSibling;
    }
  }, {
    key: "hasNoSiblings",
    get: function get() {
      return 1 === this.siblings.length;
    }
  }, {
    key: "leftSibling",
    get: function get() {
      var e = this.parent.branch(this.treeBranch);
      return e[e.indexOf(this) - 1];
    }
  }, {
    key: "rightSibling",
    get: function get() {
      var e = this.parent.branch(this.treeBranch);
      return e[e.indexOf(this) + 1];
    }
  }, {
    key: "hasChildren",
    get: function get() {
      return this._branches && this.children.length > 0;
    }
  }, {
    key: "firstChild",
    get: function get() {
      return this.children[0];
    }
  }, {
    key: "lastChild",
    get: function get() {
      var e = this.children;
      return e[e.length - 1];
    }
  }, {
    key: "children",
    get: function get() {
      if (this._children) return this._children;
      if (!this._branches) return [];
      var e = [];
      for (var _i33 = 0, _et2 = et; _i33 < _et2.length; _i33++) {
        var _t36 = _et2[_i33];
        if (this._branches[_t36]) {
          var _iterator23 = _createForOfIteratorHelper(this._branches[_t36]),
            _step23;
          try {
            for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
              var _i34 = _step23.value;
              e.push.apply(e, _toConsumableArray(_i34.children)), e.push(_i34);
            }
          } catch (err) {
            _iterator23.e(err);
          } finally {
            _iterator23.f();
          }
        }
      }
      return this._children = e, e;
    }
  }, {
    key: "render",
    value: function render(e, t) {
      if ("first" === this.type && !e.atomIdsSettings) return null;
      var i = new H(e, this.style);
      var r = this.createBox(i, {
        classes: "root" === this.type ? " ML__base" : "",
        newList: !0 === (null == t ? void 0 : t.newList) || "first" === this.type
      });
      return r ? (this.subsupPlacement || !this.superscript && !this.subscript || (r = this.attachSupsub(i, {
        base: r
      })), r.wrap(i)) : null;
    }
  }, {
    key: "attachSupsub",
    value: function attachSupsub(e, t) {
      var i, r;
      var n = t.base,
        a = this.superscript,
        o = this.subscript;
      if (!a && !o) return n;
      var s = null,
        l = null;
      var c = null !== (i = t.isCharacterBox) && void 0 !== i ? i : this.isCharacterBox();
      var u = 0;
      if (a) {
        var _t37 = new H(e, void 0, "superscript");
        s = rt.createBox(_t37, a, {
          newList: !0
        }), c || (u = n.height - e.metrics.supDrop * _t37.scalingFactor);
      }
      var d,
        h = 0;
      if (o) {
        var _t38 = new H(e, void 0, "subscript");
        l = rt.createBox(_t38, o, {
          newList: !0
        }), c || (h = n.depth + e.metrics.subDrop * _t38.scalingFactor);
      }
      d = e.isDisplayStyle ? e.metrics.sup1 : e.isCramped ? e.metrics.sup3 : e.metrics.sup2;
      var p = .05 / e.scalingFactor;
      var m = null;
      if (l && s) {
        u = Math.max(u, d, s.depth + .25 * e.metrics.xHeight), h = Math.max(h, e.metrics.sub2);
        var _t39 = e.metrics.defaultRuleThickness;
        if (u - s.depth - (l.height - h) < 4 * _t39) {
          h = 4 * _t39 - (u - s.depth) + l.height;
          var _i35 = .8 * e.metrics.xHeight - (u - s.depth);
          _i35 > 0 && (u += _i35, h -= _i35);
        }
        var _i36 = this.isExtensibleSymbol && n.italic ? -n.italic : 0;
        m = new ce({
          individualShift: [{
            box: l,
            shift: h,
            marginLeft: _i36
          }, {
            box: s,
            shift: -u
          }]
        }).wrap(e);
      } else l && !s ? (h = Math.max(h, e.metrics.sub1, l.height - .3448), m = new ce({
        shift: h,
        children: [{
          box: l,
          marginRight: p,
          marginLeft: this.isCharacterBox() ? -(null !== (r = n.italic) && void 0 !== r ? r : 0) : 0
        }]
      })) : !l && s && (u = Math.max(u, d, s.depth + .10775), m = new ce({
        shift: -u,
        children: [{
          box: s,
          marginRight: p
        }]
      }), m.wrap(e));
      var f = new te(m, {
        classes: "msubsup"
      });
      return this.caret && (f.caret = this.caret), new te([n, f], {
        type: t.type
      });
    }
  }, {
    key: "attachLimits",
    value: function attachLimits(e, t) {
      var i;
      var r = this.superscript ? rt.createBox(new H(e, this.style, "superscript"), this.superscript, {
          newList: !0
        }) : null,
        n = this.subscript ? rt.createBox(new H(e, this.style, "subscript"), this.subscript, {
          newList: !0
        }) : null;
      return r || n ? function (e, t) {
        var i, r, n, a, o;
        var s = e.metrics,
          l = new te(t.base),
          c = null !== (i = t.baseShift) && void 0 !== i ? i : 0,
          u = null !== (r = t.slant) && void 0 !== r ? r : 0;
        var d = 0,
          h = 0;
        t.above && (d = null !== (n = t.aboveShift) && void 0 !== n ? n : Math.max(s.bigOpSpacing1, s.bigOpSpacing3 - t.above.depth)), t.below && (h = null !== (a = t.belowShift) && void 0 !== a ? a : Math.max(s.bigOpSpacing2, s.bigOpSpacing4 - t.below.height));
        var p = null;
        if (t.below && t.above) {
          var _i37 = s.bigOpSpacing5 + t.below.height + t.below.depth + h + l.depth + c;
          p = new ce({
            bottom: _i37,
            children: [s.bigOpSpacing5, {
              box: t.below,
              marginLeft: -u,
              classes: ["ML__center"]
            }, h, {
              box: l,
              classes: ["ML__center"]
            }, d, {
              box: t.above,
              marginLeft: u,
              classes: ["ML__center"]
            }, s.bigOpSpacing5]
          }).wrap(e);
        } else if (t.below && !t.above) p = new ce({
          top: l.height - c,
          children: [s.bigOpSpacing5, {
            box: t.below,
            marginLeft: -u,
            classes: ["ML__center"]
          }, h, {
            box: l,
            classes: ["ML__center"]
          }]
        }).wrap(e);else if (!t.below && t.above) {
          var _i38 = l.depth + c;
          p = new ce({
            bottom: _i38,
            children: [{
              box: l,
              classes: ["ML__center"]
            }, d, {
              box: t.above,
              marginLeft: u,
              classes: ["ML__center"]
            }, s.bigOpSpacing5]
          }).wrap(e);
        } else {
          var _t40 = l.depth + c;
          p = new ce({
            bottom: _t40,
            children: [{
              box: l
            }, s.bigOpSpacing5]
          }).wrap(e);
        }
        return new te(p, {
          type: null !== (o = t.type) && void 0 !== o ? o : "mop"
        });
      }(e, _objectSpread(_objectSpread({}, t), {}, {
        above: r,
        below: n,
        type: null !== (i = null == t ? void 0 : t.type) && void 0 !== i ? i : "mop"
      })) : t.base.wrap(e);
    }
  }, {
    key: "bind",
    value: function bind(e, t) {
      return t ? e.isPhantom ? t : t && "\u200B" !== this.value ? (this.id || (this.id = e.makeID()), t.atomID = this.id, t) : t : null;
    }
  }, {
    key: "createMathfieldBox",
    value: function createMathfieldBox(e, t) {
      var i;
      var r = null !== (i = null == t ? void 0 : t.classes) && void 0 !== i ? i : "",
        n = new Je(t.placeholderId, t.element, {
          type: "mathfield",
          mode: this.mode,
          maxFontSize: e.scalingFactor,
          style: _objectSpread(_objectSpread({
            variant: "normal"
          }, this.style), {}, {
            letterShapeStyle: e.letterShapeStyle,
            fontSize: Math.max(1, e.size + e.mathstyle.sizeDelta)
          }),
          classes: r,
          newList: null == t ? void 0 : t.newList
        });
      return e.isTight && (n.isTight = !0), "math" !== this.mode && (n.italic = 0), n.right = n.italic, this.bind(e, n), n;
    }
  }, {
    key: "createBox",
    value: function createBox(e, t) {
      var i, r, n, a;
      var o = null !== (i = this.value) && void 0 !== i ? i : this.body,
        s = function (e) {
          return Y.includes(e);
        }(this.type) ? this.type : void 0;
      var l = null !== (r = null == t ? void 0 : t.classes) && void 0 !== r ? r : "";
      "text" === this.mode && (l += " ML__text");
      var c = "string" == typeof o || void 0 === o ? new te(null !== (n = o) && void 0 !== n ? n : null, {
        type: s,
        mode: this.mode,
        maxFontSize: e.scalingFactor,
        style: _objectSpread(_objectSpread({
          variant: "normal"
        }, this.style), {}, {
          letterShapeStyle: e.letterShapeStyle,
          fontSize: Math.max(1, e.size + e.mathstyle.sizeDelta)
        }),
        classes: l,
        newList: null == t ? void 0 : t.newList
      }) : null !== (a = rt.createBox(e, o, {
        type: s,
        mode: this.mode,
        style: this.style,
        classes: l,
        newList: null == t ? void 0 : t.newList
      })) && void 0 !== a ? a : new te(null);
      return e.isTight && (c.isTight = !0), "math" !== this.mode && (c.italic = 0), c.right = c.italic, this.bind(e, c), this.caret && (this.superscript || this.subscript || (c.caret = this.caret)), c;
    }
  }], [{
    key: "createBox",
    value: function createBox(e, t, i) {
      var r, n, a;
      if (!t) return null;
      var o = function (e) {
        var t, i;
        var r = [];
        var n = [];
        var _iterator24 = _createForOfIteratorHelper(e),
          _step24;
        try {
          for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
            var _a7 = _step24.value;
            var _e38 = _a7.computedStyle;
            t || _a7.style ? t && i === _a7.isSelected && _e38.color === t.color && _e38.backgroundColor === t.backgroundColor && _e38.fontSize === t.fontSize ? n.push(_a7) : (n.length > 0 && r.push(n), n = [_a7], t = _a7.computedStyle, i = _a7.isSelected) : n.push(_a7);
          }
        } catch (err) {
          _iterator24.e(err);
        } finally {
          _iterator24.f();
        }
        return n.length > 0 && r.push(n), r;
      }(t);
      if (1 === o.length) {
        var _t41 = o[0];
        return _t41[0].style ? at(e, _t41, _objectSpread(_objectSpread({}, i), {}, {
          style: {
            color: _t41[0].style.color,
            backgroundColor: _t41[0].style.backgroundColor,
            fontSize: _t41[0].style.fontSize
          }
        })) : at(e, _t41, i);
      }
      var s = [];
      var l = null == i ? void 0 : i.newList;
      var _iterator25 = _createForOfIteratorHelper(o),
        _step25;
      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var _t42 = _step25.value;
          var _i39 = at(new H(e, {
            color: null === (r = _t42[0].style) || void 0 === r ? void 0 : r.color,
            backgroundColor: null === (n = _t42[0].style) || void 0 === n ? void 0 : n.backgroundColor,
            fontSize: null === (a = _t42[0].style) || void 0 === a ? void 0 : a.fontSize,
            isSelected: _t42[0].isSelected
          }), _t42, {
            newList: l
          });
          _i39 && (l = !1, s.push(_i39));
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
      return 0 === s.length ? null : 1 !== s.length || (null == i ? void 0 : i.classes) || (null == i ? void 0 : i.type) ? new te(s, {
        classes: null == i ? void 0 : i.classes,
        type: null == i ? void 0 : i.type,
        newList: null == i ? void 0 : i.newList
      }).wrap(e) : s[0].wrap(e);
    }
  }, {
    key: "serialize",
    value: function serialize(t, i) {
      var r = "";
      if (e(t)) r = nt(t, i);else if ("number" == typeof t || "boolean" == typeof t) r = t.toString();else if ("string" == typeof t) r = t.replace(/\s/g, "~");else if (void 0 !== t) {
        if (!i.expandMacro && "string" == typeof t.verbatimLatex) return t.verbatimLatex;
        if (t.serializeOverride) return t.serializeOverride(t, i);
        r = t.serialize(i);
      }
      return r;
    }
  }, {
    key: "commonAncestor",
    value: function commonAncestor(e, t) {
      if (e === t) return e.parent;
      if (e.parent === t.parent) return e.parent;
      var i = new WeakSet();
      var r = e.parent;
      for (; r;) i.add(r), r = r.parent;
      for (r = t.parent; r;) {
        if (i.has(r)) return r;
        r = r.parent;
      }
    }
  }]);
  return rt;
}();
function nt(e, t) {
  if (!e || 0 === e.length) return "";
  if ("first" === e[0].type) {
    if (1 === e.length) return "";
    e = e.slice(1);
  }
  return 0 === e.length ? "" : ve(X(e, "cssClass").map(function (e) {
    return ve(X(e, "color").map(function (e) {
      return ve(function (e) {
        var t = [];
        var i = [],
          r = "NONE";
        var _iterator26 = _createForOfIteratorHelper(e),
          _step26;
        try {
          for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
            var _n10 = _step26.value;
            "first" !== _n10.type && (_n10.mode !== r ? (i.length > 0 && t.push(i), i = [_n10], r = _n10.mode) : i.push(_n10));
          }
        } catch (err) {
          _iterator26.e(err);
        } finally {
          _iterator26.f();
        }
        return i.length > 0 && t.push(i), t;
      }(e).map(function (e) {
        return G.serialize(e, t);
      }));
    }));
  }));
}
function at(e, t, i) {
  var r, n, a, o, s;
  function l(e) {
    return "mord" === e.type && Boolean(e.value) && /^[\d,.]$/.test(e.value);
  }
  function c(e) {
    return "text" === e.mode;
  }
  if (!t || 0 === t.length) return null;
  var u = new H(e, null == i ? void 0 : i.style),
    d = !u.atomIdsSettings || !u.atomIdsSettings.groupNumbers;
  var h = [];
  if (1 === t.length) {
    var _e39 = t[0].render(u, {
      newList: null !== (r = null == i ? void 0 : i.newList) && void 0 !== r && r
    });
    _e39 && d && t[0].isSelected && _e39.selected(!0), _e39 && (h = [_e39]);
  } else {
    var _e40 = [],
      _r11 = "",
      _p = !0,
      _m = null !== (n = null == i ? void 0 : i.newList) && void 0 !== n && n;
    var _iterator27 = _createForOfIteratorHelper(t),
      _step27;
    try {
      for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
        var _i40 = _step27.value;
        (null === (a = u.atomIdsSettings) || void 0 === a ? void 0 : a.groupNumbers) && _r11 && (_p && l(_i40) || !_p && c(_i40)) && (u.atomIdsSettings.overrideID = _r11);
        var _t43 = _i40.render(u, {
          newList: _m
        });
        if (u.atomIdsSettings && (u.atomIdsSettings.overrideID = void 0), _t43) if (_m = !1, (null === (o = u.atomIdsSettings) || void 0 === o ? void 0 : o.groupNumbers) && ((l(_i40) || c(_i40)) && (_r11 && _p === l(_i40) || (_p = l(_i40), _r11 = null !== (s = _i40.id) && void 0 !== s ? s : "")), (l(_i40) || c(_i40)) && _i40.hasEmptyBranch("superscript") && _i40.hasEmptyBranch("subscript") || !_r11 || (_r11 = "")), d && _i40.isSelected) {
          _e40.push(_t43);
          var _iterator28 = _createForOfIteratorHelper(_e40),
            _step28;
          try {
            for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
              var _t44 = _step28.value;
              _t44.selected(!0);
            }
          } catch (err) {
            _iterator28.e(err);
          } finally {
            _iterator28.f();
          }
        } else _e40.length > 0 && (h = [].concat(_toConsumableArray(h), _toConsumableArray(_e40)), _e40 = []), h.push(_t43);
      }
    } catch (err) {
      _iterator27.e(err);
    } finally {
      _iterator27.f();
    }
    _e40.length > 0 && (h = [].concat(_toConsumableArray(h), _toConsumableArray(_e40)), _e40 = []);
  }
  if (!h || 0 === h.length) return null;
  var p = h[0];
  return (i || h.length > 1) && (p = new te(h, _objectSpread({
    isTight: u.isTight
  }, i)), p.selected(h[0].isSelected)), p.wrap(u).wrap(e);
}
var ot = /*#__PURE__*/function (_rt) {
  _inherits(ot, _rt);
  var _super3 = _createSuper(ot);
  function ot(e, t) {
    var _this4;
    _classCallCheck(this, ot);
    var i, r;
    _this4 = _super3.call(this, "group", {
      mode: null !== (i = null == t ? void 0 : t.mode) && void 0 !== i ? i : "math",
      serialize: null == t ? void 0 : t.serialize,
      style: null == t ? void 0 : t.style,
      displayContainsHighlight: !0
    }), _this4.body = e, _this4.mathstyleName = null == t ? void 0 : t.mathstyleName, _this4.latexOpen = null == t ? void 0 : t.latexOpen, _this4.latexClose = null == t ? void 0 : t.latexClose, _this4.cssId = null == t ? void 0 : t.cssId, _this4.htmlData = null == t ? void 0 : t.htmlData, _this4.customClass = null == t ? void 0 : t.customClass, _this4.boxType = null == t ? void 0 : t.boxType, _this4.skipBoundary = !0, _this4.captureSelection = null == t ? void 0 : t.captureSelection, _this4.changeMode = null !== (r = null == t ? void 0 : t.changeMode) && void 0 !== r && r, _this4.displayContainsHighlight = !1;
    return _this4;
  }
  _createClass(ot, [{
    key: "render",
    value: function render(e) {
      var t = new H(e, this.style, this.mathstyleName),
        i = rt.createBox(t, this.body, {
          type: this.boxType,
          classes: this.customClass,
          mode: this.mode,
          style: {
            backgroundColor: this.style.backgroundColor
          }
        });
      return i ? (this.cssId && (i.cssId = this.cssId), this.htmlData && (i.htmlData = this.htmlData), this.caret && (i.caret = this.caret), this.bind(e, i)) : i;
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      var t = this.bodyToLatex(e);
      return "string" == typeof this.latexOpen && (t = this.latexOpen + t + this.latexClose), this.htmlData && (t = "\\htmlData{".concat(this.htmlData, "}{").concat(t, "}")), this.customClass && (t = "\\class{".concat(this.customClass, "}{").concat(t, "}")), this.cssId && (t = "\\cssId{".concat(this.cssId, "}{").concat(t, "}")), t;
    }
  }]);
  return ot;
}(rt);
var st = /*#__PURE__*/function (_rt2) {
  _inherits(st, _rt2);
  var _super4 = _createSuper(st);
  function st(e, t, i) {
    var _this5;
    _classCallCheck(this, st);
    _this5 = _super4.call(this, "spacing", {
      command: e,
      style: t
    }), _this5.width = i;
    return _this5;
  }
  _createClass(st, [{
    key: "render",
    value: function render(e) {
      var t;
      var i;
      if (this.width) i = new te(null, {
        classes: "mspace"
      }), i.left = V(this.width.glue);else {
        var _e41 = null !== (t = {
          "\\qquad": "qquad",
          "\\quad": "quad",
          "\\enspace": "enspace",
          "\\;": "thickspace",
          "\\:": "mediumspace",
          "\\,": "thinspace",
          "\\!": "negativethinspace"
        }[this.command]) && void 0 !== t ? t : "mediumspace";
        i = new te(null, {
          classes: _e41
        });
      }
      return this.caret && (i.caret = this.caret), i;
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      var t;
      var i = null !== (t = this.command) && void 0 !== t ? t : "";
      return "\\hspace" === this.command || "\\hspace*" === this.command ? Number.isFinite(this.width) ? i += "{".concat(this.width, "em'}") : i += "{0pt}" : Number.isFinite(this.width) && (i += " ".concat(this.width, "em")), i;
    }
  }]);
  return st;
}(rt);
var lt = {
  "(": ")",
  "{": "}",
  "[": "]",
  "|": "|",
  "\\lbrace": "\\rbrace",
  "\\lparen": "\\rparen",
  "\\{": "\\}",
  "\\langle": "\\rangle",
  "\\lfloor": "\\rfloor",
  "\\lceil": "\\rceil",
  "\\vert": "\\vert",
  "\\lvert": "\\rvert",
  "\\Vert": "\\Vert",
  "\\lVert": "\\rVert",
  "\\lbrack": "\\rbrack",
  "\\ulcorner": "\\urcorner",
  "\\llcorner": "\\lrcorner",
  "\\lgroup": "\\rgroup",
  "\\lmoustache": "\\rmoustache"
};
function ct(e) {
  var t;
  return null !== (t = {
    "[": 91,
    "]": 93,
    "(": 40,
    ")": 41,
    "\\mid": 8739,
    "|": 8739,
    "\u2223": 8739,
    "\u2225": 8741,
    "\\|": 8739,
    "\\{": 123,
    "\\}": 125,
    "\\lbrace": 123,
    "\\rbrace": 125,
    "\\lparen": 40,
    "\\rparen": 41,
    "\\lbrack": 91,
    "\\rbrack": 93,
    "\\vert": 8739,
    "\\lvert": 8739,
    "\\mvert": 8739,
    "\\rvert": 8739,
    "\\Vert": 8741,
    "\\lVert": 8741,
    "\\mVert": 8741,
    "\\rVert": 8741,
    "\\parallel": 8741,
    "\\shortparallel": 8741,
    "\\langle": 10216,
    "\\rangle": 10217,
    "\\lfloor": 8970,
    "\\rfloor": 8971,
    "\\lceil": 8968,
    "\\rceil": 8969,
    "\\ulcorner": 9484,
    "\\urcorner": 9488,
    "\\llcorner": 9492,
    "\\lrcorner": 9496,
    "\\lgroup": 10222,
    "\\rgroup": 10223,
    "\\lmoustache": 9136,
    "\\rmoustache": 9137,
    "\\surd": 8730
  }[e]) && void 0 !== t ? t : e.codePointAt(0);
}
function ut(e, t, i, r, n) {
  var a = new H(r, null == n ? void 0 : n.style, "textstyle"),
    o = new te(ct(e), {
      fontFamily: "Size" + t + "-Regular",
      classes: "ML__delim-size" + t
    }).wrap(a);
  return i && o.setTop(.25 * (1 - a.scalingFactor)), o;
}
function dt(e, t, i, r, n) {
  var a;
  var o, s, l, c;
  o = l = c = ct(e), s = null;
  var u = "Size1-Regular";
  "\\vert" === e || "\\lvert" === e || "\\rvert" === e || "\\mvert" === e || "\\mid" === e ? l = o = c = 8739 : "\\Vert" === e || "\\lVert" === e || "\\rVert" === e || "\\mVert" === e || "\\|" === e ? l = o = c = 8741 : "\\uparrow" === e ? l = c = 9168 : "\\Uparrow" === e ? l = c = 8214 : "\\downarrow" === e ? o = l = 9168 : "\\Downarrow" === e ? o = l = 8214 : "\\updownarrow" === e ? (o = 8593, l = 9168, c = 8595) : "\\Updownarrow" === e ? (o = 8657, l = 8214, c = 8659) : "[" === e || "\\lbrack" === e ? (o = 9121, l = 9122, c = 9123, u = "Size4-Regular") : "]" === e || "\\rbrack" === e ? (o = 9124, l = 9125, c = 9126, u = "Size4-Regular") : "\\lfloor" === e || "\u230A" === e ? (l = o = 9122, c = 9123, u = "Size4-Regular") : "\\lceil" === e || "\u2308" === e ? (o = 9121, l = c = 9122, u = "Size4-Regular") : "\\rfloor" === e || "\u230B" === e ? (l = o = 9125, c = 9126, u = "Size4-Regular") : "\\rceil" === e || "\u2309" === e ? (o = 9124, l = c = 9125, u = "Size4-Regular") : "(" === e || "\\lparen" === e ? (o = 9115, l = 9116, c = 9117, u = "Size4-Regular") : ")" === e || "\\rparen" === e ? (o = 9118, l = 9119, c = 9120, u = "Size4-Regular") : "\\{" === e || "\\lbrace" === e ? (o = 9127, s = 9128, c = 9129, l = 9130, u = "Size4-Regular") : "\\}" === e || "\\rbrace" === e ? (o = 9131, s = 9132, c = 9133, l = 9130, u = "Size4-Regular") : "\\lgroup" === e || "\u27EE" === e ? (o = 9127, c = 9129, l = 9130, u = "Size4-Regular") : "\\rgroup" === e || "\u27EF" === e ? (o = 9131, c = 9133, l = 9130, u = "Size4-Regular") : "\\lmoustache" === e || "\u23B0" === e ? (o = 9127, c = 9133, l = 9130, u = "Size4-Regular") : "\\rmoustache" === e || "\u23B1" === e ? (o = 9131, c = 9129, l = 9130, u = "Size4-Regular") : "\\surd" === e ? (o = 57345, c = 9143, l = 57344, u = "Size4-Regular") : "\\ulcorner" === e ? (o = 9484, l = c = 32) : "\\urcorner" === e ? (o = 9488, l = c = 32) : "\\llcorner" === e ? (c = 9492, l = o = 32) : "\\lrcorner" === e && (o = 9496, l = o = 32);
  var d = P(o, u),
    h = d.height + d.depth,
    p = P(l, u),
    m = p.height + p.depth,
    f = P(c, u),
    g = f.height + f.depth;
  var y = 0,
    b = 1;
  if (null !== s) {
    var _e42 = P(s, u);
    y = _e42.height + _e42.depth, b = 2;
  }
  var v = h + g + y,
    x = Math.max(0, Math.ceil((t - v) / (b * m))),
    k = v + x * b * m;
  var w = .25;
  i && (w *= r.scalingFactor);
  var _ = k / 2 - w,
    M = [];
  M.push({
    box: new te(c, {
      fontFamily: u
    })
  }), M.push(-.008);
  var S = new te(l, {
    fontFamily: u
  });
  if (null === s) for (var _e43 = 0; _e43 < x; _e43++) M.push({
    box: S
  });else {
    for (var _e44 = 0; _e44 < x; _e44++) M.push({
      box: S
    });
    M.push(-.008), M.push({
      box: new te(s, {
        fontFamily: u
      })
    }), M.push(-.008);
    for (var _e45 = 0; _e45 < x; _e45++) M.push({
      box: S
    });
  }
  M.push(-.008), M.push({
    box: new te(o, {
      fontFamily: u
    })
  });
  var L = "";
  "Size1-Regular" === u ? L = " delim-size1" : "Size4-Regular" === u && (L = " delim-size4");
  var C = new ce({
    bottom: _,
    children: M
  }, {
    classes: L
  });
  return new te(C, _objectSpread(_objectSpread({}, null != n ? n : {}), {}, {
    classes: (null !== (a = null == n ? void 0 : n.classes) && void 0 !== a ? a : "") + " ML__delim-mult"
  }));
}
var ht = new Set(["(", ")", "\\lparen", "\\rparen", "[", "]", "\\lbrack", "\\rbrack", "\\{", "\\}", "\\lbrace", "\\rbrace", "\\lfloor", "\\rfloor", "\\lceil", "\\rceil", "\\surd", "\u230A", "\u230B", "\u2308", "\u2309"]),
  pt = new Set(["\\uparrow", "\\downarrow", "\\updownarrow", "\\Uparrow", "\\Downarrow", "\\Updownarrow", "|", "\\|", "\\vert", "\\Vert", "\\lvert", "\\rvert", "\\lVert", "\\rVert", "\\mvert", "\\mid", "\\lgroup", "\\rgroup", "\\lmoustache", "\\rmoustache", "\u27EE", "\u27EF", "\u23B0", "\u23B1"]),
  mt = new Set(["<", ">", "\\langle", "\\rangle", "/", "\\backslash", "\\lt", "\\gt"]),
  ft = [0, 1.2, 1.8, 2.4, 3],
  gt = [{
    type: "small",
    mathstyle: "scriptscriptstyle"
  }, {
    type: "small",
    mathstyle: "scriptstyle"
  }, {
    type: "small",
    mathstyle: "textstyle"
  }, {
    type: "large",
    size: 1
  }, {
    type: "large",
    size: 2
  }, {
    type: "large",
    size: 3
  }, {
    type: "large",
    size: 4
  }],
  yt = [{
    type: "small",
    mathstyle: "scriptscriptstyle"
  }, {
    type: "small",
    mathstyle: "scriptscriptstyle"
  }, {
    type: "small",
    mathstyle: "textstyle"
  }, {
    type: "stack"
  }],
  bt = [{
    type: "small",
    mathstyle: "scriptscriptstyle"
  }, {
    type: "small",
    mathstyle: "scriptstyle"
  }, {
    type: "small",
    mathstyle: "textstyle"
  }, {
    type: "large",
    size: 1
  }, {
    type: "large",
    size: 2
  }, {
    type: "large",
    size: 3
  }, {
    type: "large",
    size: 4
  }, {
    type: "stack"
  }];
function vt(e, t, i, r, n, a) {
  var o;
  if (!t || 0 === t.length || "." === t) return kt(n, e, e);
  var s;
  "<" === t || "\\lt" === t ? t = "\\langle" : ">" !== t && "\\gt" !== t || (t = "\\rangle"), s = mt.has(t) ? gt : ht.has(t) ? bt : yt;
  var l = function (e, t, i, r) {
      for (var _a8 = {
        "-4": 0,
        "-3": 1,
        0: 2
      }[r.mathstyle.sizeDelta]; _a8 < i.length && "stack" !== i[_a8].type; _a8++) {
        var _o4 = P(e, "small" === (n = i[_a8]).type ? "Main-Regular" : "large" === n.type ? "Size" + n.size + "-Regular" : "Size4-Regular");
        if (_o4.defaultMetrics) return {
          type: "small",
          mathstyle: "scriptstyle"
        };
        var _s4 = _o4.height + _o4.depth;
        if ("small" === i[_a8].type && ("scriptscriptstyle" === i[_a8].mathstyle ? _s4 *= F[Math.max(1, r.size - 2)] : "scriptstyle" === i[_a8].mathstyle && (_s4 *= F[Math.max(1, r.size - 1)])), _s4 > t) return i[_a8];
      }
      var n;
      return i[i.length - 1];
    }(ct(t), i, s, n),
    c = new H(n, null == a ? void 0 : a.style, l.mathstyle);
  return "small" === l.type ? function (e, t, i, r) {
    var n = new te(ct(e), {
      fontFamily: "Main-Regular"
    }).wrap(t, r);
    return i && n.setTop(.25 * (1 - t.scalingFactor)), n;
  }(t, c, r, {
    type: e,
    classes: "ML__small-delim " + (null !== (o = null == a ? void 0 : a.classes) && void 0 !== o ? o : "")
  }) : "large" === l.type ? ut(t, l.size, r, c, _objectSpread(_objectSpread({}, a), {}, {
    type: e
  })) : dt(t, i, r, c, _objectSpread(_objectSpread({}, a), {}, {
    type: e
  }));
}
function xt(e, t, i, r, n, a) {
  if ("." === t) return kt(n, e, null == a ? void 0 : a.classes);
  var o = .25 * n.scalingFactor,
    s = Math.max(i - o, r + o);
  return vt(e, t, Math.max(s / 500 * 901, 2 * s - .5), !0, n, a);
}
function kt(e, t, i) {
  var r = new H(e, void 0, "textstyle");
  return new te(null, {
    classes: " nulldelimiter " + (null != i ? i : ""),
    type: t
  }).wrap(r);
}
var wt = /*#__PURE__*/function (_rt3) {
  _inherits(wt, _rt3);
  var _super5 = _createSuper(wt);
  function wt(e, t) {
    var _this6;
    _classCallCheck(this, wt);
    var i;
    _this6 = _super5.call(this, "leftright", {
      style: t.style,
      displayContainsHighlight: !0
    }), _this6.body = e, _this6.inner = null !== (i = t.inner) && void 0 !== i && i, _this6.leftDelim = t.leftDelim, _this6.rightDelim = t.rightDelim;
    return _this6;
  }
  _createClass(wt, [{
    key: "serialize",
    value: function serialize(e) {
      var t, i, r, n;
      var a = [];
      return a = this.inner ? ["\\left" + (null !== (t = this.leftDelim) && void 0 !== t ? t : "."), this.bodyToLatex(e), "\\right" + (null !== (i = this.rightDelim) && void 0 !== i ? i : ".")] : e.expandMacro ? [this.leftDelim && "." !== this.leftDelim ? this.leftDelim : "", this.bodyToLatex(e), this.rightDelim && "." !== this.rightDelim ? this.rightDelim : ""] : ["\\mleft" + (null !== (r = this.leftDelim) && void 0 !== r ? r : "."), this.bodyToLatex(e), "\\mright" + (null !== (n = this.rightDelim) && void 0 !== n ? n : ".")], ve(a);
    }
  }, {
    key: "render",
    value: function render(e) {
      var t, i, r, n;
      var a = new H(e, this.style);
      if (!this.body) {
        var _e46 = [];
        return this.leftDelim && _e46.push(new rt("mopen", {
          value: this.leftDelim
        }).render(a)), this.rightDelim && _e46.push(new rt("mclose", {
          value: this.rightDelim
        }).render(a)), 0 === _e46.length ? null : new te(_e46, {
          type: "minner"
        });
      }
      var o = new H(e, this.style, "textstyle"),
        s = null !== (t = rt.createBox(a, this.body, {
          newList: !0
        })) && void 0 !== t ? t : new te(null, {
          newList: !0
        }),
        l = s.height / o.scalingFactor,
        c = s.depth / o.scalingFactor,
        u = [];
      if (this.leftDelim && u.push(this.bind(o, xt("mopen", this.leftDelim, l, c, o, {
        classes: "ML__open" + (this.containsCaret ? " ML__contains-caret" : ""),
        mode: this.mode,
        style: this.style
      }))), s) {
        if (s.children) for (var _e47 = 0; _e47 < s.children.length; _e47++) {
          var _t45 = s.children[_e47];
          if (_t45.delim) {
            var _i41 = _t45.caret;
            s.children[_e47] = this.bind(a, xt("minner", _t45.delim, l, c, a)), s.children[_e47].caret = _i41;
          }
        }
        u.push(s);
      }
      if (this.rightDelim) {
        var _e48 = this.rightDelim,
          _t46 = this.containsCaret ? " ML__contains-caret" : "";
        "?" === _e48 && (a.smartFence ? (_e48 = null !== (n = null !== (r = {
          "(": ")",
          "[": "\\rbrack",
          "\\{": "\\}",
          "\\lbrace": "\\rbrace",
          "\\lparen": "\\rparen",
          "\\langle": "\\rangle",
          "\\lfloor": "\\rfloor",
          "\\lceil": "\\rceil",
          "\\vert": "\\vert",
          "\\lvert": "\\rvert",
          "\\Vert": "\\Vert",
          "\\lVert": "\\rVert",
          "\\lbrack": "\\rbrack",
          "\\ulcorner": "\\urcorner",
          "\\llcorner": "\\lrcorner",
          "\\lgroup": "\\rgroup",
          "\\lmoustache": "\\rmoustache"
        }[null !== (i = this.leftDelim) && void 0 !== i ? i : "."]) && void 0 !== r ? r : this.leftDelim) && void 0 !== n ? n : ".", _t46 += " ML__smart-fence__close") : _e48 = "."), u.push(this.bind(o, xt("mclose", _e48, l, c, o, {
          classes: _t46 + " ML__close",
          mode: this.mode,
          style: this.style
        })));
      }
      var d = new te(u, {
        type: this.inner ? "minner" : "mclose",
        classes: "left-right"
      });
      return this.caret && (d.caret = this.caret), this.bind(a, d.wrap(a));
    }
  }]);
  return wt;
}(rt);
var _t = /*#__PURE__*/function (_rt4) {
  _inherits(_t, _rt4);
  var _super6 = _createSuper(_t);
  function _t(e) {
    _classCallCheck(this, _t);
    return _super6.call(this, "msubsup", {
      style: null == e ? void 0 : e.style
    });
  }
  _createClass(_t, [{
    key: "render",
    value: function render(e) {
      var t;
      var i = new H(e, {
          isPhantom: !0
        }),
        r = null !== (t = this.leftSibling.render(i)) && void 0 !== t ? t : new te(null),
        n = new te(null, {
          height: r.height,
          depth: r.depth
        });
      return this.attachSupsub(e, {
        base: n,
        isCharacterBox: this.leftSibling.isCharacterBox(),
        type: "supsub"
      });
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      return this.supsubToLatex(e);
    }
  }]);
  return _t;
}(rt);
var Mt = /*#__PURE__*/function (_rt5) {
  _inherits(Mt, _rt5);
  var _super7 = _createSuper(Mt);
  function Mt(e) {
    var _this7;
    _classCallCheck(this, Mt);
    _this7 = _super7.call(this, "placeholder", {
      mode: null == e ? void 0 : e.mode,
      style: null == e ? void 0 : e.style,
      value: null == e ? void 0 : e.value
    }), _this7.captureSelection = !0, _this7.value = "\u2B1A", _this7.placeholderId = null == e ? void 0 : e.placeholderId, _this7.defaultValue = null == e ? void 0 : e.default;
    return _this7;
  }
  _createClass(Mt, [{
    key: "render",
    value: function render(e) {
      return "function" == typeof e.renderPlaceholder ? e.renderPlaceholder(e, this) : this.createBox(e, {
        classes: this.caret ? "ML__placeholder-selected" : ""
      });
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      var t;
      return "\\placeholder".concat(this.placeholderId ? "[".concat(this.placeholderId, "]") : "").concat(this.defaultValue ? "[".concat(rt.serialize(this.defaultValue, e), "]") : "", "{").concat(null !== (t = this.value) && void 0 !== t ? t : "", "}");
    }
  }]);
  return Mt;
}(rt);
var St = /*#__PURE__*/function (_rt6) {
  _inherits(St, _rt6);
  var _super8 = _createSuper(St);
  function St(e) {
    var _this8;
    _classCallCheck(this, St);
    _this8 = _super8.call(this, "error", {
      value: e,
      command: e,
      mode: "math"
    }), _this8.verbatimLatex = e;
    return _this8;
  }
  _createClass(St, [{
    key: "render",
    value: function render(e) {
      var t = this.createBox(e, {
        classes: "ML__error"
      });
      return this.caret && (t.caret = this.caret), t;
    }
  }]);
  return St;
}(rt);
var Lt = /*#__PURE__*/function (_rt7) {
  _inherits(Lt, _rt7);
  var _super9 = _createSuper(Lt);
  function Lt(e, t) {
    var _this9;
    _classCallCheck(this, Lt);
    var i, r;
    _this9 = _super9.call(this, "macro", {
      command: e
    }), _this9.body = t.body, _this9.captureSelection = null === (i = t.captureSelection) || void 0 === i || i, _this9.macroLatex = e + t.args, _this9.expand = null !== (r = t.expand) && void 0 !== r && r;
    return _this9;
  }
  _createClass(Lt, [{
    key: "serialize",
    value: function serialize(e) {
      return e.expandMacro && this.expand ? this.bodyToLatex(e) : this.macroLatex;
    }
  }, {
    key: "render",
    value: function render(e) {
      var t = rt.createBox(e, this.body);
      return t ? (this.caret && (t.caret = this.caret), this.bind(e, t)) : null;
    }
  }]);
  return Lt;
}(rt);
var Ct = /*#__PURE__*/function (_rt8) {
  _inherits(Ct, _rt8);
  var _super10 = _createSuper(Ct);
  function Ct(e, t, i) {
    var _this10;
    _classCallCheck(this, Ct);
    _this10 = _super10.call(this, "text", {
      command: e,
      mode: "text",
      displayContainsHighlight: !0
    }), _this10.value = t, _this10.verbatimLatex = t, _this10.applyStyle(i);
    return _this10;
  }
  _createClass(Ct, [{
    key: "render",
    value: function render(e) {
      var t = this.createBox(e);
      return this.caret && (t.caret = this.caret), t;
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      var t;
      return null !== (t = this.verbatimLatex) && void 0 !== t ? t : $e("text", this.value.codePointAt(0));
    }
  }]);
  return Ct;
}(rt);
function At(e) {
  return !/^<({|}|\$|\$\$|space)>$/.test(e);
}
var Nt = /*#__PURE__*/function () {
  function Nt(e, t) {
    var _this11 = this;
    _classCallCheck(this, Nt);
    var i, r, n, a, o, s;
    this.index = 0, this.smartFence = !1, this.endCount = 0, this.tokens = e, this.args = null !== (i = t.args) && void 0 !== i ? i : null, this.macros = t.macros, this.colorMap = t.colorMap, this.backgroundColorMap = null !== (r = t.backgroundColorMap) && void 0 !== r ? r : this.colorMap, this.smartFence = null !== (n = t.smartFence) && void 0 !== n && n, this.onError = t.onError ? function (e) {
      return t.onError(_objectSpread({
        before: xe(_this11.tokens.slice(_this11.index, _this11.index + 10)),
        after: xe(_this11.tokens.slice(Math.max(0, _this11.index - 10), _this11.index))
      }, e));
    } : function () {}, this._parsingContexts = [{
      parseMode: null !== (a = t.parseMode) && void 0 !== a ? a : "math",
      mathstyle: null !== (o = t.mathstyle) && void 0 !== o ? o : "displaystyle",
      registers: t.registers,
      tabular: !1,
      style: null !== (s = t.style) && void 0 !== s ? s : {},
      mathlist: []
    }];
  }
  _createClass(Nt, [{
    key: "currentContext",
    get: function get() {
      return this._parsingContexts[this._parsingContexts.length - 1];
    }
  }, {
    key: "beginContext",
    value: function beginContext(e) {
      var t, i, r;
      this._parsingContexts.push({
        parseMode: null !== (t = null == e ? void 0 : e.mode) && void 0 !== t ? t : this.currentContext.parseMode,
        mathstyle: null !== (i = null == e ? void 0 : e.mathstyle) && void 0 !== i ? i : this.currentContext.mathstyle,
        registers: null,
        style: _objectSpread({}, this.currentContext.style),
        tabular: null !== (r = null == e ? void 0 : e.tabular) && void 0 !== r && r,
        mathlist: []
      });
    }
  }, {
    key: "endContext",
    value: function endContext() {
      this._parsingContexts.pop();
    }
  }, {
    key: "mathlist",
    get: function get() {
      return this._parsingContexts[this._parsingContexts.length - 1].mathlist;
    },
    set: function set(e) {
      this._parsingContexts[this._parsingContexts.length - 1].mathlist = e;
    }
  }, {
    key: "parseMode",
    get: function get() {
      return this._parsingContexts[this._parsingContexts.length - 1].parseMode;
    },
    set: function set(e) {
      this._parsingContexts[this._parsingContexts.length - 1].parseMode = e;
    }
  }, {
    key: "tabularMode",
    get: function get() {
      return this._parsingContexts[this._parsingContexts.length - 1].tabular;
    }
  }, {
    key: "style",
    get: function get() {
      var e = this._parsingContexts.length - 1,
        t = this._parsingContexts[e].style;
      for (; void 0 === t && e > 0;) e -= 1, t = this._parsingContexts[e].style;
      return null != t ? t : {};
    },
    set: function set(e) {
      this._parsingContexts[this._parsingContexts.length - 1].style = e;
    }
  }, {
    key: "getRegister",
    value: function getRegister(e) {
      var t, i, r, n;
      if (e.startsWith("global ")) return null !== (i = null === (t = this._parsingContexts[0].registers) || void 0 === t ? void 0 : t[e.slice(7)]) && void 0 !== i ? i : 0;
      var a = this._parsingContexts.length - 1,
        o = this._parsingContexts[a].registers;
      for (; a >= 0 && o && void 0 === o[e];) a -= 1, o = null === (r = this._parsingContexts[a]) || void 0 === r ? void 0 : r.registers;
      return null !== (n = null == o ? void 0 : o[e]) && void 0 !== n ? n : 0;
    }
  }, {
    key: "setRegister",
    value: function setRegister(e, t) {
      if (e.startsWith("global ")) {
        e = e.slice(7);
        var _i42 = this._parsingContexts.length - 1;
        for (; _i42 > 0;) this._parsingContexts[_i42].registers && delete this._parsingContexts[_i42].registers[e], _i42 -= 1;
        this._parsingContexts[0].registers[e] = t;
      } else this._parsingContexts[this._parsingContexts.length - 1].registers || (this._parsingContexts[this._parsingContexts.length - 1].registers = {}), this._parsingContexts[this._parsingContexts.length - 1].registers[e] = t;
    }
  }, {
    key: "end",
    value: function end() {
      return this.endCount++, this.index >= this.tokens.length || this.endCount > 1e3;
    }
  }, {
    key: "get",
    value: function get() {
      return this.endCount = 0, this.index < this.tokens.length ? this.tokens[this.index++] : "";
    }
  }, {
    key: "peek",
    value: function peek() {
      return this.tokens[this.index];
    }
  }, {
    key: "match",
    value: function match(e) {
      return this.tokens[this.index] === e && (this.index++, !0);
    }
  }, {
    key: "lastSubsupAtom",
    value: function lastSubsupAtom() {
      var e;
      if (this.mathlist.length > 0) {
        if (e = this.mathlist[this.mathlist.length - 1], "msubsup" === e.type) return e;
        if (void 0 !== e.subsupPlacement) return e;
      }
      return e = new _t({
        style: this.style
      }), this.mathlist.push(e), e;
    }
  }, {
    key: "hasPattern",
    value: function hasPattern(e) {
      return e.test(this.tokens[this.index]);
    }
  }, {
    key: "hasInfixCommand",
    value: function hasInfixCommand() {
      var e;
      var t = this.index;
      if (t < this.tokens.length && this.tokens[t].startsWith("\\")) {
        var _i43 = Re(this.tokens[t], this.parseMode, this.macros);
        return !!_i43 && !(_i43.ifMode && !_i43.ifMode.includes(this.parseMode)) && null !== (e = _i43.infix) && void 0 !== e && e;
      }
      return !1;
    }
  }, {
    key: "matchColumnSeparator",
    value: function matchColumnSeparator() {
      var e = this.index;
      return !(!this.tabularMode || "&" !== this.tokens[e] || (this.index++, 0));
    }
  }, {
    key: "matchRowSeparator",
    value: function matchRowSeparator() {
      var e = this.index;
      return !(!this.tabularMode || "\\\\" !== this.tokens[e] && "\\cr" !== this.tokens[e] || (this.index++, 0));
    }
  }, {
    key: "placeholder",
    value: function placeholder() {
      var e;
      var t = null === (e = this.args) || void 0 === e ? void 0 : e.call(this, "?");
      return t ? zt(t, {
        parseMode: this.parseMode,
        onError: this.onError,
        registers: this.currentContext.registers,
        mathstyle: "textstyle",
        colorMap: this.colorMap,
        backgroundColorMap: this.backgroundColorMap
      }) : [new Mt({
        mode: this.parseMode,
        style: this.style
      })];
    }
  }, {
    key: "matchWhitespace",
    value: function matchWhitespace() {
      var e = !1;
      for (; this.match("<space>");) e = !0;
      return e;
    }
  }, {
    key: "skipUntilToken",
    value: function skipUntilToken(e) {
      var t = this.tokens[this.index];
      for (; t && t !== e;) t = this.tokens[++this.index];
      t === e && this.index++;
    }
  }, {
    key: "skipFiller",
    value: function skipFiller() {
      var e = !1;
      do {
        var _t47 = this.matchWhitespace(),
          _i44 = this.match("\\relax");
        e = !_t47 && !_i44;
      } while (!e);
    }
  }, {
    key: "matchKeyword",
    value: function matchKeyword(e) {
      var t = this.index;
      var i = this.end(),
        r = "";
      for (; !i;) {
        var _t48 = this.get();
        At(_t48) ? (r += _t48, i = this.end() || r.length >= e.length) : i = !0;
      }
      var n = e.toUpperCase() === r.toUpperCase();
      return n || (this.index = t), n;
    }
  }, {
    key: "scanString",
    value: function scanString() {
      var e = "";
      for (; !this.end();) if (this.match("<space>")) e += " ";else {
        var _t49 = this.peek();
        if ("]" === _t49) break;
        if (At(_t49)) e += this.get();else {
          if (!_t49.startsWith("\\")) break;
          this.onError({
            code: "unbalanced-braces"
          }), e += this.get();
        }
      }
      return e;
    }
  }, {
    key: "scanBalancedString",
    value: function scanBalancedString() {
      var e = "",
        t = this.end(),
        i = 1;
      for (; !t;) {
        if (this.match("<space>")) e += " ";else {
          var _t50 = this.get();
          "<{>" === _t50 ? (e += "{", i += 1) : "<}>" === _t50 ? (i -= 1, i > 0 ? e += "}" : this.index -= 1) : e += "<$>" === _t50 ? "$" : "<$$>" === _t50 ? "$$" : _t50;
        }
        t = 0 === i || this.end();
      }
      return e;
    }
  }, {
    key: "matchLiteralArg",
    value: function matchLiteralArg() {
      var e;
      var t = "";
      if (this.match("<{>")) {
        var _i45 = 1;
        for (; _i45 > 0 && !this.end();) {
          var _r12 = this.get();
          "<}>" === _r12 ? (_i45 -= 1, _i45 > 0 && (t += "}")) : "<{>" === _r12 ? (_i45 += 1, t += "{") : t += null !== (e = {
            "<space>": " ",
            "<$$>": "$$",
            "<$>": "$"
          }[_r12]) && void 0 !== e ? e : _r12;
        }
      }
      return t;
    }
  }, {
    key: "scanNumber",
    value: function scanNumber() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      var t, i;
      var r = !1,
        n = this.peek();
      for (; "<space>" === n || "+" === n || "-" === n;) this.get(), "-" === n && (r = !r), n = this.peek();
      e = Boolean(e);
      var a = 10,
        o = /\d/;
      if (this.match("'")) a = 8, o = /[0-7]/, e = !0;else if (this.match('"') || this.match("x")) a = 16, o = /[\dA-F]/, e = !0;else if (this.match("`")) return n = this.get(), n ? n.startsWith("\\") && 2 === n.length ? (r ? -1 : 1) * (null !== (t = n.codePointAt(1)) && void 0 !== t ? t : 0) : (r ? -1 : 1) * (null !== (i = n.codePointAt(0)) && void 0 !== i ? i : 0) : null;
      var s = "";
      for (; this.hasPattern(o);) s += this.get();
      if (!e && (this.match(".") || this.match(","))) for (s += "."; this.hasPattern(o);) s += this.get();
      var l = e ? Number.parseInt(s, a) : Number.parseFloat(s);
      return Number.isNaN(l) ? null : r ? -l : l;
    }
  }, {
    key: "scanDimen",
    value: function scanDimen() {
      var e, t, i;
      var r,
        n = this.scanNumber(!1);
      if (null === n) {
        if (!(null === (e = this.peek()) || void 0 === e ? void 0 : e.startsWith("\\"))) return null;
        n = 1;
      }
      return this.matchWhitespace(), this.matchKeyword("pt") ? r = {
        dimension: n,
        unit: "pt"
      } : this.matchKeyword("mm") ? r = {
        dimension: n,
        unit: "mm"
      } : this.matchKeyword("cm") ? r = {
        dimension: n,
        unit: "cm"
      } : this.matchKeyword("ex") ? r = {
        dimension: n,
        unit: "ex"
      } : this.matchKeyword("px") ? r = {
        dimension: n,
        unit: "px"
      } : this.matchKeyword("em") ? r = {
        dimension: n,
        unit: "em"
      } : this.matchKeyword("bp") ? r = {
        dimension: n,
        unit: "bp"
      } : this.matchKeyword("dd") ? r = {
        dimension: n,
        unit: "dd"
      } : this.matchKeyword("pc") ? r = {
        dimension: n,
        unit: "pc"
      } : this.matchKeyword("in") ? r = {
        dimension: n,
        unit: "in"
      } : this.matchKeyword("mu") ? r = {
        dimension: n,
        unit: "mu"
      } : (null === (t = this.peek()) || void 0 === t ? void 0 : t.startsWith("\\")) ? (r = null !== (i = qt(this.getRegister(this.get().slice(1)), this.currentContext.registers)) && void 0 !== i ? i : {
        dimension: 0
      }, r.dimension *= n) : (this.match("\\relax") || this.onError({
        code: "missing-unit"
      }), r = {
        dimension: n,
        unit: "pt"
      }), r;
    }
  }, {
    key: "scanGlue",
    value: function scanGlue() {
      var e = this.scanDimen();
      if (null === e) return null;
      var t = {
        glue: e
      };
      return this.matchWhitespace(), this.match("\\relax") || (this.matchKeyword("plus") && this.scanDimen(), this.matchWhitespace(), this.match("\\relax") || (this.matchWhitespace(), this.matchKeyword("minus") && this.scanDimen())), t;
    }
  }, {
    key: "scanColspec",
    value: function scanColspec() {
      this.matchWhitespace();
      var e = [];
      for (; !this.end() && "<}>" !== this.peek() && "]" !== this.peek();) {
        var _t51 = this.get();
        "c" === _t51 || "r" === _t51 || "l" === _t51 ? e.push({
          align: _t51
        }) : "|" === _t51 ? e.push({
          separator: "solid"
        }) : ":" === _t51 ? e.push({
          separator: "dashed"
        }) : "@" === _t51 && (this.match("<{>") && (this.beginContext({
          mode: "math"
        }), e.push({
          gap: this.parse(function (e) {
            return "<}>" === e;
          })
        }), this.endContext()), this.match("<}>") || this.onError({
          code: "unbalanced-braces"
        }));
      }
      return e;
    }
  }, {
    key: "parseModeSet",
    value: function parseModeSet() {
      var e = "";
      if (this.match("\\(") && (e = "\\)"), !e && this.match("\\[") && (e = "\\]"), !e) return null;
      this.beginContext({
        mode: "math",
        mathstyle: "\\)" === e ? "textstyle" : "displaystyle"
      });
      var t = new ot(this.parse(function (t) {
        return t === e;
      }), {
        mathstyleName: "\\)" === e ? "textstyle" : "displaystyle",
        latexOpen: "\\]" === e ? "\\[" : "\\(",
        latexClose: e,
        boxType: "mord"
      });
      return this.match(e) || this.onError({
        code: "unbalanced-mode-shift"
      }), this.endContext(), t.hasEmptyBranch("body") ? null : t;
    }
  }, {
    key: "parseModeShift",
    value: function parseModeShift() {
      var e = "";
      if (this.match("<$>") && (e = "<$>"), !e && this.match("<$$>") && (e = "<$$>"), !e) return null;
      this.beginContext({
        mode: "math",
        mathstyle: "textstyle"
      });
      var t = new ot(this.parse(function (t) {
        return t === e;
      }), {
        mathstyleName: "<$>" === e ? "textstyle" : "displaystyle",
        latexOpen: "<$>" === e ? "$ " : "$$ ",
        latexClose: "<$>" === e ? " $" : " $$"
      });
      return this.match(e) || this.onError({
        code: "unbalanced-mode-shift"
      }), this.endContext(), t.hasEmptyBranch("body") ? null : t;
    }
  }, {
    key: "parseEnvironment",
    value: function parseEnvironment() {
      if (!this.match("\\begin")) return null;
      var e = this.parseArgument("string");
      if (!e) return null;
      var t = function (e) {
        var t;
        return null !== (t = ze[e]) && void 0 !== t ? t : null;
      }(e);
      if (!t) return this.onError({
        code: "unknown-environment",
        arg: e
      }), null;
      var i = [];
      if (t.params) {
        var _iterator29 = _createForOfIteratorHelper(t.params),
          _step29;
        try {
          for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
            var _r13 = _step29.value;
            if (_r13.isOptional) i.push(this.parseOptionalArgument(_r13.type));else {
              var _t52 = this.parseArgument(_r13.type);
              _t52 || this.onError({
                code: "missing-argument",
                arg: e
              }), i.push(_t52);
            }
          }
        } catch (err) {
          _iterator29.e(err);
        } finally {
          _iterator29.f();
        }
      }
      this.beginContext({
        tabular: t.tabular
      });
      var r = [],
        n = [];
      var a = [],
        o = !1;
      do {
        if (this.end() && (this.onError({
          code: "unbalanced-environment",
          arg: e
        }), o = !0), !o && this.match("\\end") && (this.parseArgument("string") !== e && this.onError({
          code: "unbalanced-environment",
          arg: e
        }), o = !0), !o) if (this.matchColumnSeparator()) a.push(this.mathlist), this.mathlist = [];else if (this.matchRowSeparator()) {
          a.push(this.mathlist), this.mathlist = [];
          var _e49 = null;
          this.matchWhitespace(), this.match("[") && (_e49 = this.scanDimen(), this.matchWhitespace(), this.match("]")), n.push(null != _e49 ? _e49 : {
            dimension: 0
          }), r.push(a), a = [];
        } else this.mathlist = this.mathlist.concat(this.parse(function (e) {
          return "<}>" === e || "&" === e || "\\end" === e || "\\cr" === e || "\\\\" === e;
        }));
      } while (!o);
      return a.push(this.mathlist), a.length > 0 && r.push(a), this.endContext(), t.createAtom(e, r, n, i);
    }
  }, {
    key: "parse",
    value: function parse(e) {
      this.beginContext(), e || (e = function e(_e50) {
        return "<}>" === _e50;
      });
      var t = "",
        i = null,
        r = [],
        n = null;
      var a = this.mathlist;
      for (this.mathlist = []; !this.end() && !e(this.peek());) this.hasInfixCommand() && !t ? (t = this.get(), i = Re(t, "math", this.macros), i && (r = this.parseArguments(i)[1]), n = this.mathlist, this.mathlist = []) : this.parseToken();
      var o;
      return t ? (r.unshift(this.mathlist), this.mathlist = a, n && r.unshift(n), o = [i.createAtom(t, r, this.style, {
        colorMap: this.colorMap,
        backgroundColorMap: this.backgroundColorMap
      })]) : (o = this.mathlist, this.mathlist = a), this.endContext(), o;
    }
  }, {
    key: "parseGroup",
    value: function parseGroup() {
      if (!this.match("<{>")) return null;
      var e = new ot(this.parse(function (e) {
        return "<}>" === e;
      }), {
        mode: this.parseMode,
        latexOpen: "{",
        latexClose: "}"
      });
      return this.match("<}>") || this.onError({
        code: "unbalanced-braces"
      }), e;
    }
  }, {
    key: "scanSmartFence",
    value: function scanSmartFence() {
      if (this.matchWhitespace(), !this.match("(")) return null;
      this.beginContext();
      var e = 1;
      for (; !this.end() && 0 !== e;) this.match("(") && (e += 1), this.match(")") && (e -= 1), 0 !== e && this.parseToken();
      0 === e && this.match(")");
      var t = new wt(this.mathlist, {
        inner: !1,
        leftDelim: "(",
        rightDelim: 0 === e ? ")" : "?"
      });
      return this.endContext(), t;
    }
  }, {
    key: "scanDelim",
    value: function scanDelim() {
      this.matchWhitespace();
      var e = this.get();
      if (!e) return this.onError({
        code: "unexpected-end-of-string"
      }), null;
      var t = ".";
      (e.startsWith("\\") || At(e)) && (t = e);
      var i = Re(t, "math", this.macros);
      return i ? i.ifMode && !i.ifMode.includes(this.parseMode) ? (this.onError({
        code: "unexpected-delimiter",
        arg: t
      }), null) : "mopen" === i.type || "mclose" === i.type || /^(\.|\?|\||<|>|\\vert|\\Vert|\\\||\\surd|\\uparrow|\\downarrow|\\Uparrow|\\Downarrow|\\updownarrow|\\Updownarrow|\\mid|\\mvert|\\mVert)$/.test(t) ? t : (this.onError({
        code: "unexpected-delimiter",
        arg: t
      }), null) : (this.onError({
        code: "unknown-command",
        arg: t
      }), null);
    }
  }, {
    key: "parseLeftRight",
    value: function parseLeftRight() {
      var e;
      if (this.match("\\right") || this.match("\\mright")) return this.onError({
        code: "unbalanced-braces"
      }), null;
      var t = "\\right";
      if (!this.match("\\left")) {
        if (!this.match("\\mleft")) return null;
        t = "\\mright";
      }
      var i = this.scanDelim();
      if (!i) return null;
      for (this.beginContext(); !this.end() && !this.match(t);) this.parseToken();
      var r = this.mathlist;
      this.endContext();
      var n = null !== (e = this.scanDelim()) && void 0 !== e ? e : ".";
      return new wt(r, {
        leftDelim: i,
        rightDelim: n,
        inner: "\\right" === t,
        style: this.style
      });
    }
  }, {
    key: "parseSupSub",
    value: function parseSupSub() {
      if ("math" !== this.parseMode) return !1;
      var e = this.peek();
      if ("^" !== e && "_" !== e && "'" !== e) return !1;
      for (; "^" === e || "_" === e || "'" === e;) {
        if (this.match("'")) this.match("'") ? this.lastSubsupAtom().addChild(new rt("mord", {
          command: "\\doubleprime",
          mode: "math",
          value: "\u2032\u2032"
        }), "superscript") : this.lastSubsupAtom().addChild(new rt("mord", {
          command: "\\prime",
          mode: "math",
          value: "\u2032"
        }), "superscript");else if (this.match("^") || this.match("_")) {
          var _t53 = this.parseArgument("math");
          _t53 ? this.lastSubsupAtom().addChildren(_t53, "_" === e ? "subscript" : "superscript") : this.lastSubsupAtom().createBranch("_" === e ? "subscript" : "superscript");
        }
        e = this.peek();
      }
      return !0;
    }
  }, {
    key: "parseLimits",
    value: function parseLimits() {
      var e = this.match("\\limits"),
        t = !e && this.match("\\nolimits"),
        i = !t && !e && this.match("\\displaylimits");
      if (!e && !t && !i) return !1;
      var r = this.mathlist.length > 0 ? this.mathlist[this.mathlist.length - 1] : null;
      return !(null === r || "mop" !== r.type || (e ? (r.subsupPlacement = "over-under", r.explicitSubsupPlacement = !0, 0) : t ? (r.subsupPlacement = "adjacent", r.explicitSubsupPlacement = !0, 0) : !i || (r.subsupPlacement = "auto", r.explicitSubsupPlacement = !0, 0)));
    }
  }, {
    key: "parseArguments",
    value: function parseArguments(e) {
      if (!e || !e.params) return [void 0, []];
      var t;
      var i = [];
      var r = e.infix ? 2 : 0;
      for (; r < e.params.length;) {
        var _n11 = e.params[r];
        if ("rest" === _n11.type) i.push(this.parse(function (e) {
          return "<}>" === e || "&" === e || "\\end" === e || "\\cr" === e || "\\\\" === e;
        }));else if (_n11.isOptional) i.push(this.parseOptionalArgument(_n11.type));else if (_n11.type.endsWith("*")) t = _n11.type.slice(0, -1);else {
          var _e51 = this.parseArgument(_n11.type);
          if (null !== _e51) i.push(_e51);else switch (this.onError({
            code: "missing-argument"
          }), _n11.type) {
            case "number":
              i.push(0);
              break;
            case "dimen":
              i.push({
                dimension: 0,
                unit: "pt"
              });
              break;
            case "glue":
              i.push({
                glue: {
                  dimension: 0,
                  unit: "pt"
                }
              });
              break;
            case "string":
            case "balanced-string":
              i.push("");
              break;
            case "delim":
              i.push(".");
              break;
            case "colspec":
              i.push("llllllllll");
              break;
            default:
              i.push(this.placeholder());
          }
        }
        r += 1;
      }
      return [t, i];
    }
  }, {
    key: "parseArgument",
    value: function parseArgument(e) {
      var _this12 = this;
      var t, i, r, n;
      this.skipFiller(), e = "auto" === e ? this.parseMode : e;
      var a = null;
      if (!this.match("<{>")) {
        if ("delim" === e) return null !== (t = this.scanDelim()) && void 0 !== t ? t : ".";
        if ("text" === e || "math" === e) {
          this.beginContext();
          var _e52 = this.parseSimpleToken();
          return this.endContext(), _e52;
        }
      }
      if ("text" === e || "math" === e) {
        this.beginContext({
          mode: e
        });
        var _t54 = this.index;
        var _n12 = 1;
        do {
          var _e53 = this.get();
          "<}>" === _e53 && (_n12 -= 1), "<{>" === _e53 && (_n12 += 1);
        } while (_n12 > 0 && !this.end());
        if (a = G.parseTokens(e, this.tokens.slice(_t54, this.index - 1), this.onError, {
          args: null !== (i = this.args) && void 0 !== i ? i : function () {
            return "";
          },
          macros: null !== (r = this.macros) && void 0 !== r ? r : {},
          smartFence: this.smartFence,
          style: this.style,
          parse: function parse(e, t, i) {
            var r = new Nt(t, {
              args: i.args,
              parseMode: e,
              smartFence: _this12.smartFence,
              macros: i.macros,
              registers: _this12.currentContext.registers,
              mathstyle: _this12.currentContext.mathstyle,
              colorMap: _this12.colorMap,
              backgroundColorMap: _this12.backgroundColorMap,
              style: i.style,
              onError: _this12.onError
            });
            return a = r.parse(), [a, t.slice(r.index)];
          }
        }), !a) {
          this.index = _t54;
          do {
            this.mathlist = this.mathlist.concat(this.parse());
          } while (!this.match("<}>") && !this.end());
        }
      } else {
        if (this.beginContext(), "string" === e ? a = this.scanString() : "balanced-string" === e ? a = this.scanBalancedString() : "number" === e ? a = this.scanNumber() : "colspec" === e ? a = this.scanColspec() : "dimen" === e ? a = this.scanDimen() : "glue" === e ? a = this.scanGlue() : "delim" === e && (a = null !== (n = this.scanDelim()) && void 0 !== n ? n : "."), null === a) return this.endContext(), null;
        this.skipUntilToken("<}>");
      }
      var o = this.mathlist;
      return this.endContext(), null != a ? a : o;
    }
  }, {
    key: "parseOptionalArgument",
    value: function parseOptionalArgument(e) {
      var t;
      if (e = "auto" === e ? this.parseMode : e, this.matchWhitespace(), !this.match("[")) return null;
      var i = null;
      for (; !this.end() && !this.match("]");) if ("string" === e) i = this.scanString();else if ("number" === e) i = this.scanNumber();else if ("dimen" === e) i = this.scanDimen();else if ("glue" === e) i = this.scanGlue();else if ("colspec" === e) i = this.scanColspec();else if ("bbox" === e) {
        var _e54 = this.scanString().toLowerCase().trim().split(/,(?![^(]*\)(?:(?:[^(]*\)){2})*[^"]*$)/),
          _r14 = {};
        var _iterator30 = _createForOfIteratorHelper(_e54),
          _step30;
        try {
          for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
            var _i46 = _step30.value;
            var _e55 = null === (t = this.backgroundColorMap) || void 0 === t ? void 0 : t.call(this, _i46);
            if (_e55) _r14.backgroundcolor = _e55;else {
              var _e56 = _i46.match(/^\s*([\d.]+)\s*([a-z]{2})/);
              if (_e56) _r14.padding = _e56[0];else {
                var _e57 = _i46.match(/^\s*border\s*:\s*(.*)/);
                _e57 && (_r14.border = _e57[1]);
              }
            }
          }
        } catch (err) {
          _iterator30.e(err);
        } finally {
          _iterator30.f();
        }
        i = _r14;
      } else "math" === e && (this.beginContext({
        mode: "math"
      }), i = this.mathlist.concat(this.parse(function (e) {
        return "]" === e;
      })), this.endContext());
      return i;
    }
  }, {
    key: "parseCommand",
    value: function parseCommand(e) {
      var t, i, r, n, a, o;
      var s = null;
      if ("\\placeholder" === e) return [new Mt({
        mode: this.parseMode,
        placeholderId: this.parseOptionalArgument("string"),
        default: this.parseOptionalArgument("math"),
        value: null !== (t = this.parseArgument("string")) && void 0 !== t ? t : void 0,
        style: this.style
      })];
      if ("\\char" === e) {
        var _e58 = this.index;
        var _t55 = Math.floor(null !== (i = this.scanNumber(!0)) && void 0 !== i ? i : Number.NaN);
        (!Number.isFinite(_t55) || _t55 < 0 || _t55 > 1114111) && (_t55 = 10067);
        var _r15 = "\\char" + xe(this.tokens.slice(_e58, this.index));
        return s = new rt("math" === this.parseMode ? "mord" : "text", {
          command: "\\char",
          mode: this.parseMode,
          value: String.fromCodePoint(_t55),
          serialize: function serialize() {
            return _r15;
          }
        }), s.verbatimLatex = _r15, [s];
      }
      if ("\\hskip" === e || "\\kern" === e) {
        var _t56 = this.scanGlue();
        return _t56 ? [new st(e, this.style, _t56)] : null;
      }
      if (s = this.scanMacro(e), s) return [s];
      var l = Re(e, this.parseMode, {});
      if (!l) return this.onError({
        code: "unknown-command",
        arg: e
      }), [new St(e)];
      if (l.ifMode && !l.ifMode.includes(this.parseMode)) return [];
      var c = this.parseMode;
      l.applyMode && (this.parseMode = l.applyMode);
      var u = this.index,
        _this$parseArguments = this.parseArguments(l),
        _this$parseArguments2 = _slicedToArray(_this$parseArguments, 2),
        d = _this$parseArguments2[0],
        h = _this$parseArguments2[1];
      if (this.parseMode = c, !h) return null;
      if (l.applyMode && !l.applyStyle && !l.createAtom) return h[0];
      if (l.infix) return this.onError({
        code: "too-many-infix-commands",
        arg: e
      }), null;
      if ("function" == typeof l.createAtom) s = l.createAtom(e, h, this.style, {
        colorMap: this.colorMap,
        backgroundColorMap: this.backgroundColorMap
      }), d && (s.body = null !== (r = this.parseArgument(d)) && void 0 !== r ? r : void 0);else if ("function" == typeof l.applyStyle) {
        var _t57 = l.applyStyle(e, h, {
            colorMap: this.colorMap,
            backgroundColorMap: this.backgroundColorMap
          }),
          _i47 = this.parseMode;
        if (l.applyMode && (this.parseMode = l.applyMode), d) {
          var _e59 = this.style;
          this.style = _objectSpread(_objectSpread({}, this.style), _t57);
          var _r16 = this.parseArgument(d);
          return this.style = _e59, this.parseMode = _i47, _r16;
        }
        this.style = _objectSpread(_objectSpread({}, this.style), _t57), this.parseMode = _i47;
      } else {
        var _t58 = _objectSpread({}, this.style);
        l.variant && (_t58.variant = l.variant), s = new rt(null !== (n = l.type) && void 0 !== n ? n : "mop", {
          command: e,
          style: _t58,
          value: l.codepoint ? String.fromCodePoint(l.codepoint) : e,
          mode: null !== (a = l.applyMode) && void 0 !== a ? a : this.parseMode
        });
      }
      if (s instanceof rt && !s.verbatimLatex && !/^\\(llap|rlap|class|cssId|htmlData)$/.test(e) && (s.verbatimLatex = (null !== (o = s.command) && void 0 !== o ? o : "") + xe(this.tokens.slice(u, this.index)), s.isFunction && this.smartFence)) {
        var _e60 = this.scanSmartFence();
        if (_e60) return [s, _e60];
      }
      return s ? [s] : null;
    }
  }, {
    key: "parseLiteral",
    value: function parseLiteral(e) {
      var t = G.createAtom(this.parseMode, e, _objectSpread({}, this.style));
      if (!t) return null;
      if (t.isFunction && this.smartFence) {
        var _e61 = this.scanSmartFence();
        if (_e61) return [t, _e61];
      }
      return [t];
    }
  }, {
    key: "parseSimpleToken",
    value: function parseSimpleToken() {
      var e = this.get();
      return e ? "<space>" === e ? "text" === this.parseMode ? [new Ct(" ", " ", this.style)] : null : e.startsWith("\\") ? this.parseCommand(e) : At(e) ? this.parseLiteral(e) : ("<}>" === e ? this.onError({
        latex: "",
        code: "unbalanced-braces"
      }) : this.onError({
        latex: "",
        code: "unexpected-token",
        arg: e
      }), null) : null;
    }
  }, {
    key: "scanMacro",
    value: function scanMacro(e) {
      var t, i;
      var r = e.slice(1);
      if (!this.macros || !this.macros[r]) return null;
      var n = this.index,
        a = this.macros[r].def,
        o = this.macros[r].args,
        s = {};
      for (var _e62 = 1; _e62 <= o; _e62++) s[_e62] = this.matchLiteralArg();
      return s["?"] = null === (t = this.args) || void 0 === t ? void 0 : t.call(this, "?"), new Lt(e, {
        expand: this.macros[r].expand,
        captureSelection: this.macros[r].captureSelection,
        args: xe(this.tokens.slice(n, this.index)),
        body: zt(a, {
          parseMode: this.parseMode,
          args: function args(e) {
            return s[e];
          },
          macros: this.macros,
          registers: null !== (i = this.currentContext.registers) && void 0 !== i ? i : null,
          mathstyle: this.currentContext.mathstyle,
          colorMap: this.colorMap,
          backgroundColorMap: this.backgroundColorMap,
          onError: this.onError
        })
      });
    }
  }, {
    key: "parseToken",
    value: function parseToken() {
      var t, i, r, n;
      var a = null !== (n = null !== (r = null !== (i = null !== (t = this.parseEnvironment()) && void 0 !== t ? t : this.parseModeShift()) && void 0 !== i ? i : this.parseModeSet()) && void 0 !== r ? r : this.parseGroup()) && void 0 !== n ? n : this.parseLeftRight();
      if (null === a) {
        if (this.parseSupSub()) return !0;
        if (this.parseLimits()) return !0;
        a = this.parseSimpleToken();
      }
      return e(a) ? this.mathlist = this.mathlist.concat(a) : a && this.mathlist.push(a), null !== a;
    }
  }]);
  return Nt;
}();
function zt(e, t) {
  var i, r, n, a, o, c, u, d;
  var h = new Nt(be(e, null !== (i = null == t ? void 0 : t.args) && void 0 !== i ? i : null), {
    args: null !== (r = null == t ? void 0 : t.args) && void 0 !== r ? r : null,
    macros: Xe(null == t ? void 0 : t.macros),
    registers: null !== (n = null == t ? void 0 : t.registers) && void 0 !== n ? n : null,
    mathstyle: null !== (a = null == t ? void 0 : t.mathstyle) && void 0 !== a ? a : "displaystyle",
    colorMap: null !== (o = null == t ? void 0 : t.colorMap) && void 0 !== o ? o : s,
    parseMode: null !== (c = null == t ? void 0 : t.parseMode) && void 0 !== c ? c : "math",
    smartFence: null == t ? void 0 : t.smartFence,
    backgroundColorMap: null !== (d = null !== (u = null == t ? void 0 : t.backgroundColorMap) && void 0 !== u ? u : null == t ? void 0 : t.colorMap) && void 0 !== d ? d : l,
    onError: function onError(i) {
      "function" == typeof (null == t ? void 0 : t.onError) && t.onError(_objectSpread(_objectSpread({}, i), {}, {
        latex: e
      }));
    }
  });
  var p = [];
  for (; !h.end();) {
    var _e63 = h.parse();
    if (!_e63) break;
    p = p.concat(_e63);
  }
  return p;
}
function qt(e, t) {
  return "number" == typeof e ? {
    dimension: e,
    unit: "pt"
  } : ("object" == typeof e && "glue" in e && (e = e.glue), "object" == typeof e && "dimension" in e ? e : new Nt(be(e), {
    registers: t
  }).scanDimen());
}
var Dt = /*#__PURE__*/function (_rt9) {
  _inherits(Dt, _rt9);
  var _super11 = _createSuper(Dt);
  function Dt(e, t, i) {
    var _this13;
    _classCallCheck(this, Dt);
    _this13 = _super11.call(this, "accent", {
      command: e,
      style: i.style
    }), i.accentChar ? _this13.accent = i.accentChar : _this13.svgAccent = null == i ? void 0 : i.svgAccent, _this13.body = t, _this13.skipBoundary = !0;
    return _this13;
  }
  _createClass(Dt, [{
    key: "render",
    value: function render(e) {
      var t;
      var i = new H(e, this.style, "cramp"),
        r = null !== (t = rt.createBox(i, this.body)) && void 0 !== t ? t : new te(null);
      var n = 0;
      !this.hasEmptyBranch("body") && 2 === this.body.length && this.body[1].isCharacterBox() && (n = r.skew);
      var a,
        o = Math.min(r.height, .431);
      if (this.svgAccent) a = le(this.svgAccent), o = i.metrics.bigOpSpacing1 - o;else if (this.accent) {
        var _e64 = new te(this.accent, {
          fontFamily: "Main-Regular"
        });
        _e64.italic = 0;
        var _t59 = 8407 === this.accent ? " ML__accent-vec" : "";
        a = new te(new te(_e64), {
          classes: "ML__accent-body" + _t59
        });
      }
      a = new ce({
        shift: 0,
        children: [{
          box: new te(r)
        }, -o, {
          box: a,
          marginLeft: r.left + 2 * n,
          classes: ["ML__center"]
        }]
      });
      var s = new te(a, {
        newList: !0,
        type: "mord"
      });
      return this.caret && (s.caret = this.caret), this.bind(i, s.wrap(i)), this.attachSupsub(i, {
        base: s
      });
    }
  }]);
  return Dt;
}(rt);
var Et = /*#__PURE__*/function (_rt10) {
  _inherits(Et, _rt10);
  var _super12 = _createSuper(Et);
  function Et(e, t) {
    var _this14;
    _classCallCheck(this, Et);
    var i, r, n;
    _this14 = _super12.call(this, "overunder", {
      command: e,
      serialize: t.serialize,
      style: t.style
    }), _this14.skipBoundary = null === (i = t.skipBoundary) || void 0 === i || i, _this14.subsupPlacement = t.supsubPlacement, _this14.body = t.body, _this14.svgAbove = t.svgAbove, _this14.svgBelow = t.svgBelow, _this14.svgBody = t.svgBody, _this14.above = t.above, _this14.below = t.below, _this14.boxType = null !== (r = t.boxType) && void 0 !== r ? r : "mord", _this14.padded = null !== (n = t.padded) && void 0 !== n && n;
    return _this14;
  }
  _createClass(Et, [{
    key: "render",
    value: function render(e) {
      var t = this.svgBody ? le(this.svgBody) : rt.createBox(e, this.body, {
        newList: !0
      });
      var i = new H(e, this.style, "scriptstyle");
      var r = null;
      this.svgAbove ? r = le(this.svgAbove) : this.above && (r = rt.createBox(i, this.above, {
        newList: !0
      }));
      var n = null;
      this.svgBelow ? n = le(this.svgBelow) : this.below && (n = rt.createBox(i, this.below, {
        newList: !0
      })), this.padded && (t = new te([kt(e, "mopen"), t, kt(e, "mclose")], {
        newList: !0
      }));
      var a = function (e, t) {
        if (!t.base) return null;
        if (!t.above && !t.below) {
          var _e65 = new te(t.base, {
            type: t.type
          });
          return _e65.setStyle("position", "relative"), _e65;
        }
        var i = 0;
        t.above && (i = -t.above.depth + e.metrics.bigOpSpacing2);
        var r = null;
        var n = t.base;
        if (t.below && t.above) {
          var _a9 = e.metrics.bigOpSpacing5 + t.below.height + t.below.depth + n.depth + 0;
          r = new ce({
            bottom: _a9,
            children: [e.metrics.bigOpSpacing5, {
              box: t.below,
              classes: ["ML__center"]
            }, {
              box: n,
              classes: ["ML__center"]
            }, i, {
              box: t.above,
              classes: ["ML__center"]
            }, e.metrics.bigOpSpacing5]
          });
        } else t.below ? r = new ce({
          top: n.height - 0,
          children: [e.metrics.bigOpSpacing5, {
            box: t.below,
            classes: ["ML__center"]
          }, {
            box: n,
            classes: ["ML__center"]
          }]
        }) : t.above && (r = new ce({
          bottom: n.depth + 0,
          children: [{
            box: n,
            classes: ["ML__center"]
          }, i, {
            box: t.above,
            classes: ["ML__center"]
          }, e.metrics.bigOpSpacing5]
        }));
        return new te(r, {
          type: t.type
        });
      }(e, {
        base: t,
        above: r,
        below: n,
        type: "mbin" === this.boxType || "mrel" === this.boxType ? this.boxType : "mord"
      });
      return a ? (a = "over-under" === this.subsupPlacement ? this.attachLimits(e, {
        base: a,
        type: a.type
      }) : this.attachSupsub(e, {
        base: a
      }), this.caret && (a.caret = this.caret), this.bind(e, a)) : null;
    }
  }]);
  return Et;
}(rt);
var Tt = /*#__PURE__*/function (_rt11) {
  _inherits(Tt, _rt11);
  var _super13 = _createSuper(Tt);
  function Tt(e, t, i) {
    var _this15;
    _classCallCheck(this, Tt);
    _this15 = _super13.call(this, "box", {
      command: e,
      serialize: i.serialize,
      style: i.style
    }), _this15.body = t, _this15.framecolor = i.framecolor, _this15.verbatimFramecolor = i.verbatimBackgroundcolor, _this15.backgroundcolor = i.backgroundcolor, _this15.verbatimBackgroundcolor = i.verbatimBackgroundcolor, _this15.padding = i.padding, _this15.border = i.border;
    return _this15;
  }
  _createClass(Tt, [{
    key: "render",
    value: function render(e) {
      var t = new H(e, this.style),
        i = V(t.getRegisterAsDimension("fboxsep")),
        r = void 0 === this.padding ? i : V(qt(this.padding, e.registers)),
        n = rt.createBox(e, this.body);
      if (!n) return null;
      n.setStyle("vertical-align", -n.height, "em");
      var a = new te(n, {
          type: "mord"
        }),
        o = new te(null, {
          classes: "ML__box"
        });
      o.height = a.height + r, o.depth = a.depth + r, o.setStyle("box-sizing", "border-box"), o.setStyle("position", "absolute"), o.setStyle("height", a.height + a.depth + 2 * r, "em"), 0 === r ? o.setStyle("width", "100%") : (o.setStyle("width", "calc(100% + ".concat(2 * r, "em)")), o.setStyle("top", i, "em"), o.setStyle("left", -r, "em")), o.setStyle("z-index", "-1"), this.backgroundcolor && o.setStyle("background-color", this.backgroundcolor), this.framecolor && o.setStyle("border", "".concat(V(t.getRegisterAsDimension("fboxrule")), "em solid ").concat(this.framecolor)), this.border && o.setStyle("border", this.border), a.setStyle("display", "inline-block"), a.setStyle("height", n.height + n.depth, "em"), a.setStyle("vertical-align", -r, "em");
      var s = new te([o, a]);
      return s.setStyle("position", "relative"), s.setStyle("display", "inline-block"), s.setStyle("line-height", 0), s.height = a.height + r, s.depth = a.depth + r, s.left = r, s.right = r, s.setStyle("height", a.height + r, "em"), s.setStyle("top", a.depth - a.height, "em"), s.setStyle("vertical-align", a.depth + r, "em"), this.caret && (s.caret = this.caret), this.attachSupsub(e, {
        base: s
      });
    }
  }]);
  return Tt;
}(rt);
var Ot = /*#__PURE__*/function (_rt12) {
  _inherits(Ot, _rt12);
  var _super14 = _createSuper(Ot);
  function Ot(e, t, i) {
    var _this16;
    _classCallCheck(this, Ot);
    var r, n, a, o;
    _this16 = _super14.call(this, "phantom", {
      command: e,
      style: i.style
    }), _this16.captureSelection = !0, _this16.body = t, _this16.isInvisible = null !== (r = i.isInvisible) && void 0 !== r && r, _this16.smashDepth = null !== (n = i.smashDepth) && void 0 !== n && n, _this16.smashHeight = null !== (a = i.smashHeight) && void 0 !== a && a, _this16.smashWidth = null !== (o = i.smashWidth) && void 0 !== o && o;
    return _this16;
  }
  _createClass(Ot, [{
    key: "render",
    value: function render(e) {
      var t = new H(e, {
        isPhantom: !0
      });
      if (!this.smashDepth && !this.smashHeight && !this.smashWidth) return rt.createBox(t, this.body, {
        classes: "inner"
      });
      var i = rt.createBox(this.isInvisible ? t : e, this.body);
      if (!i) return null;
      if (this.smashWidth) {
        var _t60 = new te(null, {
          classes: "fix"
        });
        return new te([i, _t60], {
          classes: "rlap"
        }).wrap(e);
      }
      if (!this.smashHeight && !this.smashDepth) return i;
      if (this.smashHeight && (i.height = 0), this.smashDepth && (i.depth = 0), i.children) {
        var _iterator31 = _createForOfIteratorHelper(i.children),
          _step31;
        try {
          for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
            var _e66 = _step31.value;
            this.smashHeight && (_e66.height = 0), this.smashDepth && (_e66.depth = 0);
          }
        } catch (err) {
          _iterator31.e(err);
        } finally {
          _iterator31.f();
        }
      }
      return new ce({
        firstBaseline: [{
          box: i
        }]
      }, {
        type: "mord"
      }).wrap(e);
    }
  }]);
  return Ot;
}(rt);
var Bt = /*#__PURE__*/function (_rt13) {
  _inherits(Bt, _rt13);
  var _super15 = _createSuper(Bt);
  function Bt(e, t, i) {
    var _this17;
    _classCallCheck(this, Bt);
    _this17 = _super15.call(this, "delim", {
      command: e,
      style: null == i ? void 0 : i.style
    }), _this17.value = t, _this17.size = null == i ? void 0 : i.size;
    return _this17;
  }
  _createClass(Bt, [{
    key: "render",
    value: function render(e) {
      var t = new te(null);
      return t.delim = this.value, t;
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      return 1 === this.value.length ? this.command + this.value : this.command + "{" + this.value + "}";
    }
  }]);
  return Bt;
}(rt);
var Kt = /*#__PURE__*/function (_rt14) {
  _inherits(Kt, _rt14);
  var _super16 = _createSuper(Kt);
  function Kt(e, t, i) {
    var _this18;
    _classCallCheck(this, Kt);
    _this18 = _super16.call(this, "sizeddelim", {
      command: e,
      style: i.style
    }), _this18.value = t, _this18.delimClass = i.delimClass, _this18.size = i.size;
    return _this18;
  }
  _createClass(Kt, [{
    key: "render",
    value: function render(e) {
      var t = this.bind(e, function (e, t, i, r) {
        var n;
        return void 0 === e || "." === e ? kt(i, null !== (n = r.type) && void 0 !== n ? n : "minner", r.classes) : ("<" === e || "\\lt" === e || "\u27E8" === e ? e = "\\langle" : ">" !== e && "\\gt" !== e && "\u27E9" !== e || (e = "\\rangle"), ht.has(e) || mt.has(e) ? ut(e, t, !1, i, r) : pt.has(e) ? dt(e, ft[t], !1, i, r) : null);
      }(this.value, this.size, e, {
        classes: this.delimClass
      }));
      return t ? (this.caret && (t.caret = this.caret), t) : null;
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      return 1 === this.value.length ? this.command + this.value : this.command + "{" + this.value + "}";
    }
  }]);
  return Kt;
}(rt);
var Ft = /*#__PURE__*/function (_rt15) {
  _inherits(Ft, _rt15);
  var _super17 = _createSuper(Ft);
  function Ft(e, t, i) {
    var _this19;
    _classCallCheck(this, Ft);
    _this19 = _super17.call(this, "line", {
      command: e,
      style: i.style
    }), _this19.skipBoundary = !0, _this19.body = t, _this19.position = i.position;
    return _this19;
  }
  _createClass(Ft, [{
    key: "render",
    value: function render(e) {
      var t = new H(e, this.style, "cramp"),
        i = rt.createBox(t, this.body);
      if (!i) return null;
      var r = t.metrics.defaultRuleThickness / t.scalingFactor,
        n = new te(null, {
          classes: this.position + "-line"
        });
      var a;
      return n.height = r, n.maxFontSize = 1.125 * r * t.scalingFactor, a = "overline" === this.position ? new ce({
        shift: 0,
        children: [{
          box: i
        }, 3 * r, {
          box: n
        }, r]
      }) : new ce({
        top: i.height,
        children: [r, {
          box: n
        }, 3 * r, {
          box: i
        }]
      }), this.caret && (a.caret = this.caret), new te(a, {
        classes: this.position,
        type: "mord"
      });
    }
  }]);
  return Ft;
}(rt);
var $t = /*#__PURE__*/function (_rt16) {
  _inherits($t, _rt16);
  var _super18 = _createSuper($t);
  function $t(e, t, i) {
    var _this20;
    _classCallCheck(this, $t);
    var r, n;
    _this20 = _super18.call(this, "overlap", {
      command: e,
      style: null == i ? void 0 : i.style
    }), _this20.skipBoundary = !0, _this20.body = "string" == typeof t ? [new rt("mord", {
      value: t
    })] : t, _this20.align = null !== (r = null == i ? void 0 : i.align) && void 0 !== r ? r : "left", _this20.boxType = null !== (n = null == i ? void 0 : i.boxType) && void 0 !== n ? n : "mord";
    return _this20;
  }
  _createClass($t, [{
    key: "render",
    value: function render(e) {
      var t = rt.createBox(e, this.body, {
        classes: "inner"
      });
      return t ? (this.caret && (t.caret = this.caret), this.bind(e, new te([t, new te(null, {
        classes: "fix"
      })], {
        classes: "left" === this.align ? "llap" : "rlap",
        type: this.boxType
      }))) : null;
    }
  }]);
  return $t;
}(rt);
var Pt = /*#__PURE__*/function (_rt17) {
  _inherits(Pt, _rt17);
  var _super19 = _createSuper(Pt);
  function Pt(e, t, i, r) {
    var _this21;
    _classCallCheck(this, Pt);
    var n, a;
    _this21 = _super19.call(this, "genfrac", {
      style: r.style,
      command: e,
      serialize: r.serialize,
      displayContainsHighlight: !0
    }), _this21.above = t, _this21.below = i, _this21.hasBarLine = null === (n = null == r ? void 0 : r.hasBarLine) || void 0 === n || n, _this21.continuousFraction = null !== (a = null == r ? void 0 : r.continuousFraction) && void 0 !== a && a, _this21.numerPrefix = null == r ? void 0 : r.numerPrefix, _this21.denomPrefix = null == r ? void 0 : r.denomPrefix, _this21.mathstyleName = null == r ? void 0 : r.mathstyleName, _this21.leftDelim = null == r ? void 0 : r.leftDelim, _this21.rightDelim = null == r ? void 0 : r.rightDelim;
    return _this21;
  }
  _createClass(Pt, [{
    key: "serialize",
    value: function serialize(e) {
      return this.command + "{".concat(this.aboveToLatex(e), "}") + "{".concat(this.belowToLatex(e), "}");
    }
  }, {
    key: "render",
    value: function render(e) {
      var t, i;
      var r = new H(e, this.style, this.mathstyleName),
        n = r.metrics,
        a = new H(r, this.style, this.continuousFraction ? "" : "numerator"),
        o = this.numerPrefix ? new te([new te(this.numerPrefix), rt.createBox(a, this.above)], {
          isTight: a.isTight,
          newList: !0
        }) : null !== (t = rt.createBox(a, this.above, {
          newList: !0
        })) && void 0 !== t ? t : new te(null, {
          newList: !0
        }),
        s = new H(r, this.style, this.continuousFraction ? "" : "denominator"),
        l = this.denomPrefix ? new te([new te(this.denomPrefix), rt.createBox(s, this.below, {
          newList: !0
        })]) : null !== (i = rt.createBox(s, this.below, {
          newList: !0
        })) && void 0 !== i ? i : new te(null, {
          newList: !0
        }),
        c = this.hasBarLine ? n.defaultRuleThickness : 0;
      var u,
        d,
        h = 0;
      r.isDisplayStyle ? (u = n.num1, h = c > 0 ? 3 * c : 7 * c, d = n.denom1) : (c > 0 ? (u = n.num2, h = c) : (u = n.num3, h = 3 * c), d = n.denom2);
      var p = o.depth,
        m = l.height;
      var f;
      if (c <= 0) {
        var _e67 = u - p - (m - d);
        _e67 < h && (u += (h - _e67) / 2, d += (h - _e67) / 2), f = new ce({
          individualShift: [{
            box: o,
            shift: -u,
            classes: ["ML__center"]
          }, {
            box: l,
            shift: d,
            classes: ["ML__center"]
          }]
        }).wrap(r);
      } else {
        var _e68 = .25 + c / 2,
          _t61 = .25 - c / 2;
        u < h + p + _e68 && (u = h + p + _e68), d < h + m - _t61 && (d = h + m - _t61);
        var _i48 = new te(null, {
          classes: "ML__frac-line",
          mode: this.mode,
          style: this.style
        });
        _i48.height = c / 2, _i48.depth = c / 2, f = new ce({
          individualShift: [{
            box: l,
            shift: d,
            classes: ["ML__center"]
          }, {
            box: _i48,
            shift: -_t61
          }, {
            box: o,
            shift: -u,
            classes: ["ML__center"]
          }]
        }).wrap(r);
      }
      var g = r.isDisplayStyle ? n.delim1 : n.delim2,
        y = this.leftDelim ? this.bind(e, vt("mopen", this.leftDelim, g, !0, e, {
          style: this.style,
          mode: this.mode
        })) : kt(r, "mopen");
      var b = null;
      b = this.continuousFraction ? new te(null, {
        type: "mclose"
      }) : this.rightDelim ? this.bind(e, vt("mclose", this.rightDelim, g, !0, e, {
        style: this.style,
        mode: this.mode
      })) : kt(r, "mclose");
      var v = this.bind(e, new te([y, f, b], {
        isTight: r.isTight,
        type: "mord",
        classes: "mfrac"
      }));
      return v ? (this.caret && (v.caret = this.caret), this.attachSupsub(e, {
        base: v
      })) : null;
    }
  }]);
  return Pt;
}(rt);
var It = /*#__PURE__*/function (_rt18) {
  _inherits(It, _rt18);
  var _super20 = _createSuper(It);
  function It(e, t) {
    var _this22;
    _classCallCheck(this, It);
    var i;
    _this22 = _super20.call(this, "rule", {
      command: e,
      style: t.style
    }), _this22.shift = null !== (i = t.shift) && void 0 !== i ? i : {
      dimension: 0
    }, _this22.height = t.height, _this22.width = t.width;
    return _this22;
  }
  _createClass(It, [{
    key: "render",
    value: function render(e) {
      var t = new H(e, this.style, "textstyle"),
        i = V(this.shift),
        r = V(this.width),
        n = V(this.height),
        a = new te(null, {
          classes: "rule",
          type: "mord"
        });
      return a.setStyle("border-right-width", r, "em"), a.setStyle("border-top-width", n, "em"), a.setStyle("border-color", this.style.color), a.setStyle("vertical-align", i, "em"), t.isSelected && a.setStyle("opacity", "50%"), a.width = r, a.height = n + i, a.depth = -i, this.bind(e, a), this.caret && (a.caret = this.caret), a.wrap(t);
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      var t;
      var i = null !== (t = this.command) && void 0 !== t ? t : "";
      return this.shift && (i += "[".concat(j(this.shift), "]")), i += "{".concat(j(this.width), "}{").concat(j(this.height), "}"), i;
    }
  }]);
  return It;
}(rt);
var Rt = /*#__PURE__*/function (_rt19) {
  _inherits(Rt, _rt19);
  var _super21 = _createSuper(Rt);
  function Rt(e, t, i) {
    var _this23;
    _classCallCheck(this, Rt);
    var r, n;
    _this23 = _super21.call(this, null !== (r = i.type) && void 0 !== r ? r : "mop", {
      command: e,
      style: i.style,
      isFunction: null == i ? void 0 : i.isFunction
    }), "string" == typeof t ? _this23.value = t : _this23.body = t, _this23.captureSelection = i.captureSelection, _this23.variant = null == i ? void 0 : i.variant, _this23.variantStyle = null == i ? void 0 : i.variantStyle, _this23.subsupPlacement = null == i ? void 0 : i.limits, _this23.isExtensibleSymbol = null !== (n = null == i ? void 0 : i.isExtensibleSymbol) && void 0 !== n && n;
    return _this23;
  }
  _createClass(Rt, [{
    key: "render",
    value: function render(e) {
      var t;
      var i,
        r = 0,
        n = 0;
      if (this.isExtensibleSymbol) {
        var _t62 = e.isDisplayStyle && "\\smallint" !== this.value;
        if (i = new te(this.value, {
          fontFamily: _t62 ? "Size2-Regular" : "Size1-Regular",
          classes: "op-symbol " + (_t62 ? "large-op" : "small-op"),
          type: "mop",
          maxFontSize: e.scalingFactor
        }), !i) return null;
        r = (i.height - i.depth) / 2 - .25 * e.scalingFactor, n = i.italic, i.setStyle("color", this.style.color), i.setStyle("background-color", this.style.backgroundColor);
      } else if (this.body) {
        if (i = rt.createBox(e, this.body, {
          newList: !0
        }), !i) return null;
        i.setStyle("color", this.style.color), i.setStyle("background-color", this.style.backgroundColor);
      } else i = new te(this.value, {
        type: "mop",
        mode: "math",
        maxFontSize: e.scalingFactor,
        style: {
          color: this.style.color,
          backgroundColor: this.style.backgroundColor,
          letterShapeStyle: e.letterShapeStyle,
          variant: this.variant,
          variantStyle: this.variantStyle
        }
      });
      this.isExtensibleSymbol && i.setTop(r);
      var a = i;
      if (this.superscript || this.subscript) {
        var _o5 = null !== (t = this.subsupPlacement) && void 0 !== t ? t : "auto";
        a = "over-under" === _o5 || "auto" === _o5 && e.isDisplayStyle ? this.attachLimits(e, {
          base: i,
          baseShift: r,
          slant: n
        }) : this.attachSupsub(e, {
          base: i
        });
      }
      return this.caret && (a.caret = this.caret), new te(this.bind(e, a), {
        type: "mop",
        classes: "op-group"
      });
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      var t;
      var i = [];
      return "\u200B" !== this.value && (i.push("\\mathop" === this.command || "\\operatorname" === this.command ? this.command + "{".concat(this.bodyToLatex(e), "}") : null !== (t = this.command) && void 0 !== t ? t : ""), this.explicitSubsupPlacement && ("over-under" === this.subsupPlacement && i.push("\\limits"), "adjacent" === this.subsupPlacement && i.push("\\nolimits"), "auto" === this.subsupPlacement && i.push("\\displaylimits"))), i.push(this.supsubToLatex(e)), ve(i);
    }
  }]);
  return Rt;
}(rt);
Ze("ensuremath", "{:math}", {
  createAtom: function createAtom(e, t, i) {
    return new ot(t[0], {
      mode: "math",
      latexOpen: "\\ensuremath{",
      latexClose: "}",
      style: i
    });
  }
}), Ze("color", "{:string}", {
  applyStyle: function applyStyle(e, t, i) {
    var r, n;
    var a = t[0];
    return {
      verbatimColor: t[0],
      color: null !== (n = null === (r = i.colorMap) || void 0 === r ? void 0 : r.call(i, a)) && void 0 !== n ? n : a
    };
  }
}), Ze("textcolor", "{:string}{content:auto*}", {
  applyStyle: function applyStyle(e, t, i) {
    var r, n;
    var a = t[0];
    return {
      verbatimColor: a,
      color: null !== (n = null === (r = i.colorMap) || void 0 === r ? void 0 : r.call(i, a)) && void 0 !== n ? n : a
    };
  }
}), Ze("boxed", "{content:math}", {
  createAtom: function createAtom(e, t, i) {
    return new Tt(e, t[0], {
      framecolor: "black",
      style: i
    });
  }
}), Ze("colorbox", "{:string}{content:auto*}", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t, i) {
    var r, n;
    var a = t[0];
    return {
      verbatimBackgroundColor: t[0],
      backgroundColor: null !== (n = null === (r = i.backgroundColorMap) || void 0 === r ? void 0 : r.call(i, a)) && void 0 !== n ? n : a
    };
  }
}), Ze("fcolorbox", "{frame-color:string}{background-color:string}{content:auto}", {
  applyMode: "text",
  createAtom: function createAtom(e, t, i, r) {
    var n, a, o, s;
    var l = t[0],
      c = t[1];
    return new Tt(e, t[2], {
      verbatimFramecolor: l,
      framecolor: null !== (a = null === (n = r.colorMap) || void 0 === n ? void 0 : n.call(r, l)) && void 0 !== a ? a : l,
      verbatimBackgroundcolor: t[1],
      backgroundcolor: null !== (s = null === (o = r.backgroundColorMap) || void 0 === o ? void 0 : o.call(r, c)) && void 0 !== s ? s : c,
      style: i,
      serialize: function serialize(e, t) {
        var i, r;
        return "".concat(e.command, "{").concat(null !== (i = e.verbatimFramecolor) && void 0 !== i ? i : e.framecolor, "{").concat(null !== (r = e.verbatimBackgroundcolor) && void 0 !== r ? r : e.backgroundcolor, "}{").concat(e.bodyToLatex(t), "}");
      }
    });
  }
}), Ze("bbox", "[:bbox]{body:auto}", {
  createAtom: function createAtom(e, t, i) {
    if (t[0]) {
      var _r17 = t[0];
      return new Tt(e, t[1], {
        padding: _r17.padding,
        border: _r17.border,
        backgroundcolor: _r17.backgroundcolor,
        style: i,
        serialize: function serialize(t, i) {
          var r;
          var n = e;
          if (Number.isFinite(t.padding) || void 0 !== t.border || void 0 !== t.backgroundcolor) {
            var _e69 = [];
            t.padding && _e69.push(t.padding), t.border && _e69.push("border: ".concat(t.border)), (t.verbatimBackgroundcolor || t.backgroundcolor) && _e69.push(null !== (r = t.verbatimBackgroundcolor) && void 0 !== r ? r : t.backgroundcolor), n += "[".concat(_e69.join(","), "]");
          }
          return n + "{".concat(t.bodyToLatex(i), "}");
        }
      });
    }
    return new Tt(e, t[1], {
      style: i
    });
  }
}), Ze(["displaystyle", "textstyle", "scriptstyle", "scriptscriptstyle"], "{:rest}", {
  createAtom: function createAtom(e, t, i) {
    return new ot(t[0], {
      latexOpen: "{".concat(e, " "),
      latexClose: "}",
      style: i,
      mathstyleName: e.slice(1)
    });
  }
}), Ze(["tiny", "scriptsize", "footnotesize", "small", "normalsize", "large", "Large", "LARGE", "huge", "Huge"], "", {
  applyStyle: function applyStyle(e, t) {
    return {
      fontSize: {
        "\\tiny": 1,
        "\\scriptsize": 2,
        "\\footnotesize": 3,
        "\\small": 4,
        "\\normalsize": 5,
        "\\large": 6,
        "\\Large": 7,
        "\\LARGE": 8,
        "\\huge": 9,
        "\\Huge": 10
      }[e]
    };
  }
}), Ze("fontseries", "{:string}", {
  ifMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontSeries: t[0]
    };
  }
}), Ze("fontshape", "{:string}", {
  ifMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontShape: t[0]
    };
  }
}), Ze("fontfamily", "{:string}", {
  ifMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontFamily: t[0]
    };
  }
}), Ze("selectfont", "", {
  ifMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {};
  }
}), Ze("bf", "", {
  applyStyle: function applyStyle(e, t) {
    return {
      fontSeries: "b",
      fontShape: "n",
      fontFamily: "cmr"
    };
  }
}), Ze(["boldsymbol", "bm"], "{:math*}", {
  applyMode: "math",
  createAtom: function createAtom(e, t, i) {
    return new ot(t[0], {
      latexOpen: "".concat(e, "{"),
      latexClose: "}",
      style: i,
      customClass: "ML__boldsymbol"
    });
  }
}), Ze("bold", "{:math*}", {
  applyMode: "math",
  applyStyle: function applyStyle(e, t) {
    return {
      variantStyle: "bold"
    };
  }
}), Ze("bfseries", "", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontSeries: "b"
    };
  }
}), Ze("mdseries", "", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontSeries: "m"
    };
  }
}), Ze("upshape", "", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontShape: "n"
    };
  }
}), Ze("slshape", "", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontShape: "sl"
    };
  }
}), Ze("scshape", "", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontShape: "sc"
    };
  }
}), Ze("textbf", "{:text*}", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontSeries: "b"
    };
  }
}), Ze("textmd", "{:text*}", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontSeries: "m"
    };
  }
}), Ze("textup", "{:text*}", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontShape: "n"
    };
  }
}), Ze("textnormal", "{:text*}", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontShape: "n",
      fontSeries: "m"
    };
  }
}), Ze("textsl", "{:text*}", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontShape: "sl"
    };
  }
}), Ze("textit", "{:text*}", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontShape: "it"
    };
  }
}), Ze("textsc", "{:text*}", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontShape: "sc"
    };
  }
}), Ze("textrm", "{:text*}", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontFamily: "roman"
    };
  }
}), Ze("textsf", "{:text*}", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontFamily: "sans-serif"
    };
  }
}), Ze("texttt", "{:text*}", {
  applyMode: "text",
  applyStyle: function applyStyle(e, t) {
    return {
      fontFamily: "monospace"
    };
  }
}), Ze("mathbf", "{:math*}", {
  applyMode: "math",
  applyStyle: function applyStyle(e, t) {
    return {
      variant: "normal",
      variantStyle: "bold"
    };
  }
}), Ze("mathit", "{:math*}", {
  applyMode: "math",
  applyStyle: function applyStyle(e, t) {
    return {
      variant: "normal",
      variantStyle: "italic"
    };
  }
}), Ze("mathbfit", "{:math*}", {
  applyMode: "math",
  applyStyle: function applyStyle(e, t) {
    return {
      variant: "normal",
      variantStyle: "bolditalic"
    };
  }
}), Ze("mathrm", "{:math*}", {
  applyMode: "math",
  applyStyle: function applyStyle(e, t) {
    return {
      variant: "normal",
      variantStyle: "up"
    };
  }
}), Ze("mathsf", "{:math*}", {
  applyMode: "math",
  applyStyle: function applyStyle(e, t) {
    return {
      variant: "sans-serif",
      variantStyle: "up"
    };
  }
}), Ze("mathtt", "{:math*}", {
  applyMode: "math",
  applyStyle: function applyStyle(e, t) {
    return {
      variant: "monospace",
      variantStyle: "up"
    };
  }
}), Ze("it", "", {
  applyStyle: function applyStyle(e, t) {
    return {
      fontSeries: "m",
      fontShape: "it",
      fontFamily: "cmr",
      variantStyle: "italic"
    };
  }
}), Ze("rmfamily", "", {
  applyStyle: function applyStyle(e, t) {
    return {
      fontFamily: "roman"
    };
  }
}), Ze("sffamily", "", {
  applyStyle: function applyStyle(e, t) {
    return {
      fontFamily: "sans-serif"
    };
  }
}), Ze("ttfamily", "", {
  applyStyle: function applyStyle(e, t) {
    return {
      fontFamily: "monospace"
    };
  }
}), Ze(["Bbb", "mathbb"], "{:math*}", {
  applyStyle: function applyStyle(e, t) {
    return {
      variant: "double-struck",
      variantStyle: "up"
    };
  }
}), Ze(["frak", "mathfrak"], "{:math*}", {
  applyStyle: function applyStyle(e, t) {
    return {
      variant: "fraktur",
      variantStyle: "up"
    };
  }
}), Ze("mathcal", "{:math*}", {
  applyStyle: function applyStyle(e, t) {
    return {
      variant: "calligraphic",
      variantStyle: "up"
    };
  }
}), Ze("mathscr", "{:math*}", {
  applyStyle: function applyStyle(e, t) {
    return {
      variant: "script",
      variantStyle: "up"
    };
  }
}), Ze("mbox", "{:text}", {
  ifMode: "math",
  createAtom: function createAtom(e, t, i) {
    return new ot(t[0], {
      changeMode: !0,
      style: i,
      mode: "text",
      serialize: function serialize(e, t) {
        return "\\mbox{".concat(e.bodyToLatex(_objectSpread(_objectSpread({}, t), {}, {
          skipModeCommand: !0
        })), "}");
      }
    });
  }
}), Ze("text", "{:text}", {
  ifMode: "math",
  applyMode: "text"
}), Ze("class", "{name:string}{content:auto*}", {
  createAtom: function createAtom(e, t, i) {
    return new ot(t[1], {
      customClass: t[0],
      style: i
    });
  }
}), Ze("cssId", "{id:string}{content:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new ot(t[1], {
      cssId: t[0],
      style: i
    });
  }
}), Ze("htmlData", "{data:string}{content:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new ot(t[1], {
      htmlData: t[0],
      style: i
    });
  }
}), Ze("em", "{:auto*}", {
  createAtom: function createAtom(e, t, i) {
    return new ot(t[0], {
      latexOpen: "\\em",
      latexClose: "",
      customClass: "ML__emph",
      style: i
    });
  }
}), Ze("emph", "{:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new ot(t[0], {
      latexOpen: "\\emph{",
      latexClose: "}",
      customClass: "ML__emph",
      style: i
    });
  }
});
var Vt = {
  "\\bigl": {
    mclass: "mopen",
    size: 1
  },
  "\\Bigl": {
    mclass: "mopen",
    size: 2
  },
  "\\biggl": {
    mclass: "mopen",
    size: 3
  },
  "\\Biggl": {
    mclass: "mopen",
    size: 4
  },
  "\\bigr": {
    mclass: "mclose",
    size: 1
  },
  "\\Bigr": {
    mclass: "mclose",
    size: 2
  },
  "\\biggr": {
    mclass: "mclose",
    size: 3
  },
  "\\Biggr": {
    mclass: "mclose",
    size: 4
  },
  "\\bigm": {
    mclass: "mrel",
    size: 1
  },
  "\\Bigm": {
    mclass: "mrel",
    size: 2
  },
  "\\biggm": {
    mclass: "mrel",
    size: 3
  },
  "\\Biggm": {
    mclass: "mrel",
    size: 4
  },
  "\\big": {
    mclass: "mord",
    size: 1
  },
  "\\Big": {
    mclass: "mord",
    size: 2
  },
  "\\bigg": {
    mclass: "mord",
    size: 3
  },
  "\\Bigg": {
    mclass: "mord",
    size: 4
  }
};
Ze(["bigl", "Bigl", "biggl", "Biggl", "bigr", "Bigr", "biggr", "Biggr", "bigm", "Bigm", "biggm", "Biggm", "big", "Big", "bigg", "Bigg"], "{:delim}", {
  createAtom: function createAtom(e, t, i) {
    return new Kt(e, t[0], {
      size: Vt[e].size,
      delimClass: Vt[e].mclass,
      style: i
    });
  }
}), Ze(["hspace", "hspace*"], "{width:glue}", {
  createAtom: function createAtom(e, t, i) {
    var r;
    return new st(e, i, null !== (r = t[0]) && void 0 !== r ? r : {
      glue: {
        dimension: 0
      }
    });
  }
}), Ze("mathop", "{:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Rt(e, t[0], {
      type: "mop",
      captureSelection: !0,
      limits: "over-under",
      isFunction: !0,
      style: i
    });
  }
}), Ze(["mathbin", "mathrel", "mathopen", "mathclose", "mathpunct", "mathord", "mathinner"], "{:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Rt(e, t[0], {
      type: {
        "\\mathbin": "mbin",
        "\\mathrel": "mrel",
        "\\mathopen": "mopen",
        "\\mathclose": "mclose",
        "\\mathpunct": "mpunct",
        "\\mathord": "mord",
        "\\mathinner": "minner"
      }[e],
      captureSelection: !0,
      style: i
    });
  }
}), Ze(["operatorname", "operatorname*"], "{operator:math}", {
  createAtom: function createAtom(e, t, i) {
    var r = new Rt(e, t[0], {
      isFunction: !0,
      limits: "\\operatorname" === e ? "adjacent" : "over-under",
      style: i
    });
    return r.captureSelection = !0, r.body && r.body.forEach(function (e) {
      var t;
      "first" !== e.type && (e.type = "mord", e.value = null !== (t = {
        "\u2217": "*",
        "\u2212": "-"
      }[e.value]) && void 0 !== t ? t : e.value, e.isFunction = !1, e.style.variant || e.style.variantStyle || (e.style.variant = "main", e.style.variantStyle = "up"));
    }), r;
  }
});
var jt = /*#__PURE__*/function (_rt20) {
  _inherits(jt, _rt20);
  var _super22 = _createSuper(jt);
  function jt(e, t) {
    var _this24;
    _classCallCheck(this, jt);
    var i = Number.parseInt(e);
    Number.isFinite(i) || (i = 10067), _this24 = _super22.call(this, "mord", {
      value: String.fromCodePoint(i),
      style: t
    }), _this24.codepoint = i;
    return _this24;
  }
  _createClass(jt, [{
    key: "serialize",
    value: function serialize(e) {
      return "\\unicode\"" + ("000000" + this.codepoint.toString(16)).toUpperCase().slice(-6);
    }
  }]);
  return jt;
}(rt);
function Ht(e) {
  if (1 === e.length) {
    var _t63 = e[0];
    if ("mbin" === _t63.type) return "mbin";
    if ("mrel" === _t63.type) return "mrel";
  }
  return "mord";
}
Ze("unicode", "{charcode:number}", {
  createAtom: function createAtom(e, t, i) {
    return new jt(t[0], i);
  }
}), Ze("rule", "[raise:dimen]{width:dimen}{thickness:dimen}", {
  createAtom: function createAtom(e, t, i) {
    return new It(e, {
      shift: t[0],
      width: t[1],
      height: t[2],
      style: i
    });
  }
}), Ze("overline", "{:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Ft(e, t[0], {
      position: "overline",
      style: i
    });
  }
}), Ze("underline", "{:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Ft(e, t[0], {
      position: "underline",
      style: i
    });
  }
}), Ze("overset", "{above:auto}{base:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Et(e, {
      above: t[0],
      body: t[1],
      skipBoundary: !1,
      style: i,
      boxType: Ht(t[1]),
      serialize: function serialize(e, t) {
        return "".concat(e.command, "{").concat(e.aboveToLatex(t), "}{").concat(e.bodyToLatex(t), "}");
      }
    });
  }
}), Ze("underset", "{below:auto}{base:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Et(e, {
      below: t[0],
      body: t[1],
      skipBoundary: !1,
      style: i,
      boxType: Ht(t[1]),
      serialize: function serialize(t, i) {
        return "".concat(e, "{").concat(t.belowToLatex(i), "}{").concat(t.bodyToLatex(i), "}");
      }
    });
  }
}), Ze("overunderset", "{above:auto}{below:auto}{base:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Et(e, {
      above: t[0],
      below: t[1],
      body: t[2],
      skipBoundary: !1,
      style: i,
      boxType: Ht(t[2]),
      serialize: function serialize(e, t) {
        return "".concat(e.command, "{").concat(e.aboveToLatex(t), "}{").concat(e.bodyToLatex(t), "}");
      }
    });
  }
}), Ze(["stackrel", "stackbin"], "[below:auto]{above:auto}{base:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Et(e, {
      body: t[2],
      above: t[1],
      below: t[0],
      skipBoundary: !1,
      style: i,
      boxType: "\\stackrel" === e ? "mrel" : "mbin",
      serialize: function serialize(e, t) {
        return "".concat(e.command, "{").concat(e.aboveToLatex(t), "}{").concat(e.bodyToLatex(t), "}");
      }
    });
  }
}), Ze(["overwithdelims", "atopwithdelims"], "{numer:auto}{denom:auto}{left-delim:delim}{right-delim:delim}", {
  infix: !0,
  createAtom: function createAtom(e, t, i) {
    return new Pt(e, t[0], t[1], {
      leftDelim: t[2],
      rightDelim: t[3],
      hasBarLine: !1,
      style: i,
      serialize: function serialize(e, t) {
        return "".concat(e.aboveToLatex(t), " ").concat(e.command).concat(e.leftDelim).concat(e.rightDelim).concat(e.belowToLatex(t));
      }
    });
  }
}), Ze("smash", "[:string]{:auto}", {
  createAtom: function createAtom(e, t, i) {
    return t[0] ? new Ot(e, t[1], {
      smashHeight: t[0].includes("t"),
      smashDepth: t[0].includes("b"),
      style: i
    }) : new Ot(e, t[1], {
      smashHeight: !0,
      smashDepth: !0,
      style: i
    });
  }
}), Ze(["vphantom"], "{:auto*}", {
  createAtom: function createAtom(e, t, i) {
    return new Ot(e, t[1], {
      isInvisible: !0,
      smashWidth: !0,
      style: i
    });
  }
}), Ze(["hphantom"], "{:auto*}", {
  createAtom: function createAtom(e, t, i) {
    return new Ot(e, t[1], {
      isInvisible: !0,
      smashHeight: !0,
      smashDepth: !0,
      style: i
    });
  }
}), Ze(["phantom"], "{:auto*}", {
  createAtom: function createAtom(e, t, i) {
    return new Ot(e, t[1], {
      isInvisible: !0,
      style: i
    });
  }
}), Ze("not", "{:math}", {
  createAtom: function createAtom(e, t, i) {
    if (t.length < 1 || null === t[0]) return new rt("mrel", {
      command: e,
      style: i,
      value: "\uE020"
    });
    var r = t[0];
    return new ot([new $t(e, "\uE020", {
      align: "right",
      style: i,
      boxType: "mrel"
    })].concat(_toConsumableArray(r)), {
      boxType: "mrel",
      captureSelection: !0,
      serialize: function serialize(e, t) {
        var i = rt.serialize(r, t);
        return 1 !== i.length || /[a-zA-Z]/.test(i) ? "\\not{".concat(i, "}") : "\\not" + i;
      }
    });
  }
}), Ze(["ne", "neq"], "", {
  createAtom: function createAtom(e, t, i) {
    return new ot([new $t(e, "\uE020", {
      align: "right",
      style: i,
      boxType: "mrel"
    }), new rt("mrel", {
      style: i,
      value: "="
    })], {
      boxType: "mrel",
      captureSelection: !0,
      serialize: function serialize() {
        return e;
      }
    });
  }
}), Ze("rlap", "{:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new $t(e, t[0], {
      align: "right",
      style: i
    });
  }
}), Ze("llap", "{:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new $t(e, t[0], {
      style: i
    });
  }
}), Ze("mathllap", "{:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new $t(e, t[0], {
      style: i
    });
  }
}), Ze("mathrlap", "{:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new $t(e, t[0], {
      align: "right",
      style: i
    });
  }
});
var Ut = {
  acute: 714,
  grave: 715,
  dot: 729,
  ddot: 168,
  mathring: 730,
  tilde: 126,
  bar: 713,
  breve: 728,
  check: 711,
  hat: 94,
  vec: 8407
};
Ze(Object.keys(Ut), "{body:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Dt(e, t[0], {
      accentChar: Ut[e.slice(1)],
      style: i
    });
  }
}), Ze(["widehat", "widecheck", "widetilde"], "{body:auto}", {
  createAtom: function createAtom(e, t, i) {
    var r = He(t[0]);
    return new Dt(e, t[0], {
      style: i,
      svgAccent: e.slice(1) + (r.length > 5 ? "4" : ["1", "1", "2", "2", "3", "3"][r.length])
    });
  }
}), Ze(["overarc", "overparen", "wideparen"], "{body:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Dt(e, t[0], {
      style: i,
      svgAccent: "overarc"
    });
  }
}), Ze(["underarc", "underparen"], "{body:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Et(e, {
      body: t[0],
      style: i,
      svgBelow: "underarc"
    });
  }
}), Ze("utilde", "{body:auto}", {
  createAtom: function createAtom(e, t, i) {
    var r = He(t[0]),
      n = "widetilde" + (r.length > 5 ? "4" : ["1", "1", "2", "2", "3", "3"][r.length]);
    return new Et(e, {
      body: t[0],
      svgBelow: n,
      style: i,
      boxType: Ht(t[0])
    });
  }
}), Ze("^", "{:string}", {
  createAtom: function createAtom(e, t, i) {
    var r;
    return new rt("mord", {
      command: e,
      isFunction: !1,
      limits: "adjacent",
      style: i,
      value: t[0] && null !== (r = {
        a: "\xe2",
        e: "\xea",
        i: "\xee",
        o: "\xf4",
        u: "\xfb",
        A: "\xc2",
        E: "\xca",
        I: "\xce",
        O: "\xd4",
        U: "\xdb"
      }[t[0]]) && void 0 !== r ? r : "^"
    });
  }
}), Ze("`", "{:string}", {
  createAtom: function createAtom(e, t, i) {
    var r;
    return new rt("mord", {
      command: e,
      isFunction: !1,
      limits: "adjacent",
      style: i,
      value: t[0] && null !== (r = {
        a: "\xe0",
        e: "\xe8",
        i: "\xec",
        o: "\xf2",
        u: "\xf9",
        A: "\xc0",
        E: "\xc8",
        I: "\xcc",
        O: "\xd2",
        U: "\xd9"
      }[t[0]]) && void 0 !== r ? r : "`"
    });
  }
}), Ze("'", "{:string}", {
  createAtom: function createAtom(e, t, i) {
    var r;
    return new rt("mord", {
      command: e,
      isFunction: !1,
      limits: "adjacent",
      style: i,
      value: t[0] && null !== (r = {
        a: "\xe1",
        e: "\xe9",
        i: "\xed",
        o: "\xf3",
        u: "\xfa",
        A: "\xc1",
        E: "\xc9",
        I: "\xcd",
        O: "\xd3",
        U: "\xda"
      }[t[0]]) && void 0 !== r ? r : "^"
    });
  }
}), Ze("~", "{:string}", {
  createAtom: function createAtom(e, t, i) {
    var r;
    return new rt("mord", {
      command: e,
      isFunction: !1,
      limits: "adjacent",
      style: i,
      value: t[0] && null !== (r = {
        n: "\xf1",
        N: "\xd1",
        a: "\xe3",
        o: "\xf5",
        A: "\xc3",
        O: "\xd5"
      }[t[0]]) && void 0 !== r ? r : "\xb4"
    });
  }
}), Ze("c", "{:string}", {
  createAtom: function createAtom(e, t, i) {
    var r;
    return new rt("mord", {
      command: e,
      isFunction: !1,
      limits: "adjacent",
      style: i,
      value: t[0] && null !== (r = {
        c: "\xe7",
        C: "\xc7"
      }[t[0]]) && void 0 !== r ? r : ""
    });
  }
});
var Wt = /*#__PURE__*/function (_rt21) {
  _inherits(Wt, _rt21);
  var _super23 = _createSuper(Wt);
  function Wt(e, t, i, r) {
    var _this25;
    _classCallCheck(this, Wt);
    _this25 = _super23.call(this, "enclose", {
      command: e,
      style: r.style
    }), _this25.body = t, _this25.backgroundcolor = r.backgroundcolor, i.updiagonalarrow && (i.updiagonalstrike = !1), i.box && (i.left = !1, i.right = !1, i.bottom = !1, i.top = !1), _this25.notation = i, _this25.shadow = r.shadow, _this25.strokeWidth = r.strokeWidth, _this25.strokeStyle = r.strokeStyle, _this25.svgStrokeStyle = r.svgStrokeStyle, _this25.strokeColor = r.strokeColor, _this25.borderStyle = r.borderStyle, _this25.padding = r.padding, _this25.captureSelection = !0;
    return _this25;
  }
  _createClass(Wt, [{
    key: "serialize",
    value: function serialize(e) {
      var t;
      var i = null !== (t = this.command) && void 0 !== t ? t : "";
      if ("\\enclose" === this.command) {
        i += "{" + Object.keys(this.notation).join(" ") + "}";
        var _e70 = "",
          _t64 = "";
        this.backgroundcolor && "transparent" !== this.backgroundcolor && (_e70 += _t64 + 'mathbackground="' + this.backgroundcolor + '"', _t64 = ","), this.shadow && "auto" !== this.shadow && (_e70 += _t64 + 'shadow="' + this.shadow + '"', _t64 = ","), this.strokeWidth || "solid" !== this.strokeStyle ? (_e70 += _t64 + this.borderStyle, _t64 = ",") : this.strokeColor && "currentColor" !== this.strokeColor && (_e70 += _t64 + 'mathcolor="' + this.strokeColor + '"', _t64 = ","), _e70 && (i += "[".concat(_e70, "]"));
      }
      return i += "{".concat(this.bodyToLatex(e), "}"), i;
    }
  }, {
    key: "render",
    value: function render(e) {
      var t;
      var i = new H(e, this.style),
        r = rt.createBox(i, this.body);
      if (!r) return null;
      var n = null !== (t = V(this.padding && "auto" !== this.padding ? qt(this.padding, e.registers) : i.getRegisterAsDimension("fboxsep"))) && void 0 !== t ? t : 0,
        a = new te(null, {
          classes: "ML__notation"
        });
      a.setStyle("position", "absolute"), a.setStyle("height", r.height + r.depth + 2 * n, "em"), a.height = r.height + n, a.depth = r.depth + n, 0 !== n ? a.setStyle("width", "calc(100% + ".concat(2 * n, "em)")) : a.setStyle("width", "100%"), a.setStyle("top", -r.height + 2 * n, "em"), a.setStyle("left", -n, "em"), a.setStyle("z-index", "-1"), a.setStyle("box-sizing", "border-box"), this.backgroundcolor && a.setStyle("background-color", this.backgroundcolor), this.notation.box && a.setStyle("border", this.borderStyle), this.notation.actuarial && (a.setStyle("border-top", this.borderStyle), a.setStyle("border-right", this.borderStyle)), this.notation.madruwb && (a.setStyle("border-bottom", this.borderStyle), a.setStyle("border-right", this.borderStyle)), this.notation.roundedbox && (a.setStyle("border-radius", (r.height + r.depth) / 2, "em"), a.setStyle("border", this.borderStyle)), this.notation.circle && (a.setStyle("border-radius", "50%"), a.setStyle("border", this.borderStyle)), this.notation.top && a.setStyle("border-top", this.borderStyle), this.notation.left && a.setStyle("border-left", this.borderStyle), this.notation.right && a.setStyle("border-right", this.borderStyle), this.notation.bottom && a.setStyle("border-bottom", this.borderStyle);
      var o = "";
      if (this.notation.horizontalstrike && (o += '<line x1="3%"  y1="50%" x2="97%" y2="50%"', o += " stroke-width=\"".concat(this.strokeWidth, "\" stroke=\"").concat(this.strokeColor, "\""), o += ' stroke-linecap="round"', this.svgStrokeStyle && (o += " stroke-dasharray=\"".concat(this.svgStrokeStyle, "\"")), o += "/>"), this.notation.verticalstrike && (o += '<line x1="50%"  y1="3%" x2="50%" y2="97%"', o += " stroke-width=\"".concat(this.strokeWidth, "\" stroke=\"").concat(this.strokeColor, "\""), o += ' stroke-linecap="round"', this.svgStrokeStyle && (o += " stroke-dasharray=\"".concat(this.svgStrokeStyle, "\"")), o += "/>"), this.notation.updiagonalstrike && (o += '<line x1="3%"  y1="97%" x2="97%" y2="3%"', o += " stroke-width=\"".concat(this.strokeWidth, "\" stroke=\"").concat(this.strokeColor, "\""), o += ' stroke-linecap="round"', this.svgStrokeStyle && (o += " stroke-dasharray=\"".concat(this.svgStrokeStyle, "\"")), o += "/>"), this.notation.downdiagonalstrike && (o += '<line x1="3%"  y1="3%" x2="97%" y2="97%"', o += " stroke-width=\"".concat(this.strokeWidth, "\" stroke=\"").concat(this.strokeColor, "\""), o += ' stroke-linecap="round"', this.svgStrokeStyle && (o += " stroke-dasharray=\"".concat(this.svgStrokeStyle, "\"")), o += "/>"), o) {
        var _e71;
        "none" !== this.shadow && (_e71 = "auto" === this.shadow ? "filter: drop-shadow(0 0 .5px rgba(255, 255, 255, .7)) drop-shadow(1px 1px 2px #333)" : "filter: drop-shadow(" + this.shadow + ")"), function (e, t, i) {
          e.svgOverlay = t, e.svgStyle = i;
        }(a, o, _e71);
      }
      var s = new te([a, r]);
      return s.setStyle("position", "relative"), s.setStyle("display", "inline"), s.height = r.height + n, s.depth = r.depth + n, s.left = n, s.right = n, this.caret && (s.caret = this.caret), s.wrap(i);
    }
  }]);
  return Wt;
}(rt);
Ze("enclose", "{notation:string}[style:string]{body:auto}", {
  createAtom: function createAtom(e, t, i) {
    var r;
    var n = {
      strokeColor: "currentColor",
      strokeWidth: "",
      strokeStyle: "solid",
      backgroundcolor: "transparent",
      padding: "auto",
      shadow: "auto",
      svgStrokeStyle: void 0,
      borderStyle: void 0,
      style: i
    };
    if (t[1]) {
      var _e72 = t[1].split(/,(?![^(]*\)(?:(?:[^(]*\)){2})*[^"]*$)/);
      var _iterator32 = _createForOfIteratorHelper(_e72),
        _step32;
      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var _t65 = _step32.value;
          var _e73 = _t65.match(/\s*(\S+)\s+(\S+)\s+(.*)/);
          if (_e73) n.strokeWidth = _e73[1], n.strokeStyle = _e73[2], n.strokeColor = _e73[3];else {
            var _e74 = _t65.match(/\s*([a-z]*)\s*=\s*"(.*)"/);
            _e74 && ("mathbackground" === _e74[1] ? n.backgroundcolor = _e74[2] : "mathcolor" === _e74[1] ? n.strokeColor = _e74[2] : "padding" === _e74[1] ? n.padding = _e74[2] : "shadow" === _e74[1] && (n.shadow = _e74[2]));
          }
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
      "dashed" === n.strokeStyle ? n.svgStrokeStyle = "5,5" : "dotted" === n.strokeStyle && (n.svgStrokeStyle = "1,5");
    }
    n.borderStyle = "".concat(n.strokeWidth, "px ").concat(n.strokeStyle, " ").concat(n.strokeColor);
    var a = {};
    return (null !== (r = t[0]) && void 0 !== r ? r : "").split(/[, ]/).filter(function (e) {
      return e.length > 0;
    }).forEach(function (e) {
      a[e.toLowerCase()] = !0;
    }), new Wt(e, t[2], a, n);
  }
}), Ze("cancel", "{body:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Wt(e, t[0], {
      updiagonalstrike: !0
    }, {
      strokeColor: "currentColor",
      strokeWidth: "",
      strokeStyle: "solid",
      borderStyle: "1px solid currentColor",
      backgroundcolor: "transparent",
      padding: "auto",
      shadow: "auto",
      style: i
    });
  }
}), Ze("bcancel", "{body:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Wt(e, t[0], {
      downdiagonalstrike: !0
    }, {
      strokeColor: "currentColor",
      strokeWidth: "",
      strokeStyle: "solid",
      borderStyle: "1px solid currentColor",
      backgroundcolor: "transparent",
      padding: "auto",
      shadow: "auto",
      style: i
    });
  }
}), Ze("xcancel", "{body:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Wt(e, t[0], {
      updiagonalstrike: !0,
      downdiagonalstrike: !0
    }, {
      strokeColor: "currentColor",
      strokeWidth: "",
      strokeStyle: "solid",
      borderStyle: "1px solid currentColor",
      backgroundcolor: "transparent",
      padding: "auto",
      shadow: "auto",
      style: i
    });
  }
});
var Zt = /*#__PURE__*/function (_rt22) {
  _inherits(Zt, _rt22);
  var _super24 = _createSuper(Zt);
  function Zt(e, t, i) {
    var _this26;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, Zt);
    var n;
    _this26 = _super24.call(this, "array"), _this26.environmentName = e, _this26.rowGaps = i, r.mathstyleName && (_this26.mathstyleName = r.mathstyleName), r.columns && (0 === r.columns.length ? _this26.colFormat = [{
      align: "l"
    }] : _this26.colFormat = r.columns), _this26.colFormat || (_this26.colFormat = [{
      align: "l"
    }, {
      align: "l"
    }, {
      align: "l"
    }, {
      align: "l"
    }, {
      align: "l"
    }, {
      align: "l"
    }, {
      align: "l"
    }, {
      align: "l"
    }, {
      align: "l"
    }, {
      align: "l"
    }]), _this26.array = function (e, t, i) {
      var r = 0;
      var _iterator33 = _createForOfIteratorHelper(i),
        _step33;
      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var _e75 = _step33.value;
          "align" in _e75 && (r += 1);
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }
      var n = 0;
      var a = [];
      var _iterator34 = _createForOfIteratorHelper(t),
        _step34;
      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var _i53 = _step34.value;
          var _t69 = 0;
          for (n = Math.max(n, Math.min(_i53.length, r)); _t69 < _i53.length;) {
            var _n13 = [],
              _o7 = Math.min(_i53.length, _t69 + r);
            for (; _t69 < _o7;) _i53[_t69].length > 0 && "first" !== _i53[_t69][0].type ? _n13.push([new rt("first", {
              mode: e.mode
            })].concat(_toConsumableArray(_i53[_t69]))) : _n13.push(_i53[_t69]), _t69 += 1;
            a.push(_n13);
          }
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
      1 === a[a.length - 1].length && 0 === a[a.length - 1][0].length && a.pop();
      var o = [];
      for (var _i49 = 0, _a10 = a; _i49 < _a10.length; _i49++) {
        var _t66 = _a10[_i49];
        if (_t66.length !== n) for (var _i50 = _t66.length; _i50 < n; _i50++) _t66.push([new rt("first", {
          mode: e.mode
        }), new Mt()]);
        o.push(_t66);
      }
      var s = 0,
        l = 0;
      for (var _i51 = 0, _o6 = o; _i51 < _o6.length; _i51++) {
        var _t67 = _o6[_i51];
        l = 0;
        var _iterator35 = _createForOfIteratorHelper(_t67),
          _step35;
        try {
          for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
            var _i52 = _step35.value;
            var _iterator36 = _createForOfIteratorHelper(_i52),
              _step36;
            try {
              for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
                var _t68 = _step36.value;
                _t68.parent = e, _t68.treeBranch = [s, l];
              }
            } catch (err) {
              _iterator36.e(err);
            } finally {
              _iterator36.f();
            }
            l += 1;
          }
        } catch (err) {
          _iterator35.e(err);
        } finally {
          _iterator35.f();
        }
        s += 1;
      }
      return e.isDirty = !0, o;
    }(_assertThisInitialized(_this26), t, _this26.colFormat), r.leftDelim && (_this26.leftDelim = r.leftDelim), r.rightDelim && (_this26.rightDelim = r.rightDelim), void 0 !== r.jot && (_this26.jot = r.jot), r.arraycolsep && (_this26.arraycolsep = r.arraycolsep), _this26.colSeparationType = r.colSeparationType, _this26.arraystretch = null !== (n = r.arraystretch) && void 0 !== n ? n : 1;
    return _this26;
  }
  _createClass(Zt, [{
    key: "branch",
    value: function branch(e) {
      var t;
      if (it(e)) return null !== (t = this.array[e[0]][e[1]]) && void 0 !== t ? t : void 0;
    }
  }, {
    key: "branches",
    get: function get() {
      var _this27 = this;
      var e = _get(_getPrototypeOf(Zt.prototype), "branches", this);
      return this.array.forEach(function (t, i) {
        _this27.array[i].forEach(function (t, r) {
          _this27.array[i][r] && e.push([i, r]);
        });
      }), e;
    }
  }, {
    key: "createBranch",
    value: function createBranch(e) {
      return it(e), [];
    }
  }, {
    key: "rowCount",
    get: function get() {
      return this.array.length;
    }
  }, {
    key: "colCount",
    get: function get() {
      return this.array[0].length;
    }
  }, {
    key: "removeBranch",
    value: function removeBranch(e) {
      if (tt(e)) return _get(_getPrototypeOf(Zt.prototype), "removeBranch", this).call(this, e);
      var t = this.branch(e);
      return this.array[e[0]][e[1]] = void 0, t.forEach(function (e) {
        e.parent = void 0, e.treeBranch = void 0;
      }), t.shift(), this.isDirty = !0, t;
    }
  }, {
    key: "hasChildren",
    get: function get() {
      return this.children.length > 0;
    }
  }, {
    key: "children",
    get: function get() {
      var e = [];
      var _iterator37 = _createForOfIteratorHelper(this.array),
        _step37;
      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var _t70 = _step37.value;
          var _iterator38 = _createForOfIteratorHelper(_t70),
            _step38;
          try {
            for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
              var _i54 = _step38.value;
              if (_i54) {
                var _iterator39 = _createForOfIteratorHelper(_i54),
                  _step39;
                try {
                  for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
                    var _t71 = _step39.value;
                    e.push.apply(e, _toConsumableArray(_t71.children)), e.push(_t71);
                  }
                } catch (err) {
                  _iterator39.e(err);
                } finally {
                  _iterator39.f();
                }
              }
            }
          } catch (err) {
            _iterator38.e(err);
          } finally {
            _iterator38.f();
          }
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
      return [].concat(e, _toConsumableArray(_get(_getPrototypeOf(Zt.prototype), "children", this)));
    }
  }, {
    key: "render",
    value: function render(e) {
      var t, i, r, n, a;
      var o = new H(e, this.style, this.mathstyleName),
        s = o.getRegisterAsEm("arrayrulewidth"),
        l = o.getRegisterAsEm("arraycolsep"),
        c = o.getRegisterAsEm("doublerulesep"),
        u = null !== (t = this.arraystretch) && void 0 !== t ? t : 1;
      var d = "number" == typeof this.arraycolsep ? this.arraycolsep : l;
      "small" === this.colSeparationType && (d = new H(e, void 0, "scriptstyle").scalingFactor / e.scalingFactor * .2778);
      var h = 1.2 * u,
        p = .7 * h,
        m = .3 * h;
      var f = 0;
      var g = [];
      var y = 0;
      var b = this.array.length;
      for (var _e76 = 0; _e76 < b; ++_e76) {
        var _t72 = this.array[_e76];
        y = Math.max(y, _t72.length);
        var _n14 = new H(o, this.style, this.mathstyleName);
        var _a11 = p / _n14.scalingFactor,
          _s5 = m / _n14.scalingFactor;
        var _l3 = {
          cells: [],
          height: 0,
          depth: 0,
          pos: 0
        };
        var _iterator40 = _createForOfIteratorHelper(_t72),
          _step40;
        try {
          for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
            var _e77 = _step40.value;
            var _t73 = null !== (i = rt.createBox(_n14, _e77, {
              newList: !0
            })) && void 0 !== i ? i : new te(null, {
              newList: !0
            });
            _s5 = Math.max(_s5, _t73.depth), _a11 = Math.max(_a11, _t73.height), _l3.cells.push(_t73);
          }
        } catch (err) {
          _iterator40.e(err);
        } finally {
          _iterator40.f();
        }
        var _c = null !== (r = V(this.rowGaps[_e76])) && void 0 !== r ? r : 0;
        _c > 0 && (_c += m, _s5 = Math.max(_s5, _c), _c = 0), void 0 !== this.jot && (_s5 += this.jot), _l3.height = _a11, _l3.depth = _s5, f += _a11, _l3.pos = f, f += _s5 + _c, g.push(_l3);
      }
      var v = f / 2 + .25,
        x = [];
      for (var _e78 = 0; _e78 < y; _e78++) {
        var _t74 = [];
        var _iterator41 = _createForOfIteratorHelper(g),
          _step41;
        try {
          for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
            var _i55 = _step41.value;
            var _r18 = _i55.cells[_e78];
            _r18.depth = _i55.depth, _r18.height = _i55.height, _t74.push({
              box: _r18,
              shift: _i55.pos - v
            });
          }
        } catch (err) {
          _iterator41.e(err);
        } finally {
          _iterator41.f();
        }
        _t74.length > 0 && x.push(new ce({
          individualShift: _t74
        }));
      }
      var k = [];
      var w = !1,
        _ = !1,
        M = 0,
        S = !this.leftDelim;
      var L = this.colFormat;
      var _iterator42 = _createForOfIteratorHelper(L),
        _step42;
      try {
        for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
          var _t75 = _step42.value;
          if ("align" in _t75 && M >= x.length) break;
          if ("align" in _t75) w ? k.push(Gt(2 * d)) : (_ || S) && k.push(Gt(d)), k.push(new te(x[M], {
            classes: "col-align-" + _t75.align
          })), M++, w = !0, _ = !1, S = !1;else if ("gap" in _t75) {
            if ("number" == typeof _t75.gap) k.push(Gt(_t75.gap));else {
              var _i56 = Xt(e, g, v, _t75.gap);
              _i56 && k.push(_i56);
            }
            w = !1, _ = !1, S = !1;
          } else if ("separator" in _t75) {
            var _e79 = new te(null, {
              classes: "vertical-separator"
            });
            _e79.setStyle("height", f, "em"), _e79.setStyle("border-right", "".concat(s, "em ").concat(_t75.separator, " currentColor")), _e79.setStyle("vertical-align", -(f - v), "em");
            var _i57 = 0;
            _ ? _i57 = c - s : w && (_i57 = d - s), _e79.left = _i57, k.push(_e79), w = !1, _ = !0, S = !1;
          }
        }
      } catch (err) {
        _iterator42.e(err);
      } finally {
        _iterator42.f();
      }
      w && !this.rightDelim && k.push(Gt(d));
      var C = new te(k, {
        classes: "mtable"
      });
      if (!(this.leftDelim && "." !== this.leftDelim || this.rightDelim && "." !== this.rightDelim)) return C;
      var A = C.height,
        N = C.depth,
        z = this.bind(e, new te([this.bind(e, xt("mopen", null !== (n = this.leftDelim) && void 0 !== n ? n : ".", A, N, o)), C, this.bind(e, xt("mclose", null !== (a = this.rightDelim) && void 0 !== a ? a : ".", A, N, o))], {
          type: "mord"
        }));
      return z ? (this.caret && (z.caret = this.caret), this.attachSupsub(e, {
        base: z
      })) : null;
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      var t = "\\begin{" + this.environmentName + "}";
      if ("array" === this.environmentName) {
        if (t += "{", void 0 !== this.colFormat) {
          var _iterator43 = _createForOfIteratorHelper(this.colFormat),
            _step43;
          try {
            for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
              var _e80 = _step43.value;
              "align" in _e80 ? t += _e80.align : "separator" in _e80 && "solid" === _e80.separator ? t += "|" : "separator" in _e80 && "dashed" === _e80.separator && (t += ":");
            }
          } catch (err) {
            _iterator43.e(err);
          } finally {
            _iterator43.f();
          }
        }
        t += "}";
      }
      for (var _i58 = 0; _i58 < this.array.length; _i58++) {
        for (var _r19 = 0; _r19 < this.array[_i58].length; _r19++) _r19 > 0 && (t += " & "), t = ve([t, rt.serialize(this.array[_i58][_r19], e)]);
        _i58 < this.array.length - 1 && (t += " \\\\ ");
      }
      return t += "\\end{" + this.environmentName + "}", t;
    }
  }, {
    key: "getCell",
    value: function getCell(e, t) {
      return this.array[e][t];
    }
  }, {
    key: "setCell",
    value: function setCell(e, t, i) {
      this.isDirty = !0;
    }
  }, {
    key: "addRowBefore",
    value: function addRowBefore(e) {
      this.isDirty = !0;
    }
  }, {
    key: "addRowAfter",
    value: function addRowAfter(e) {
      this.isDirty = !0;
    }
  }, {
    key: "addColumnBefore",
    value: function addColumnBefore(e) {
      this.isDirty = !0;
    }
  }, {
    key: "addColumnAfter",
    value: function addColumnAfter(e) {
      this.isDirty = !0;
    }
  }, {
    key: "cells",
    get: function get() {
      var e = [];
      var _iterator44 = _createForOfIteratorHelper(this.array),
        _step44;
      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          var _t76 = _step44.value;
          var _iterator45 = _createForOfIteratorHelper(_t76),
            _step45;
          try {
            for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
              var _i59 = _step45.value;
              _i59 && e.push(_i59);
            }
          } catch (err) {
            _iterator45.e(err);
          } finally {
            _iterator45.f();
          }
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }
      return e;
    }
  }]);
  return Zt;
}(rt);
function Gt(e) {
  var t = new te(null, {
    classes: "arraycolsep"
  });
  return t.width = e, t;
}
function Xt(e, t, i, r) {
  if (!r) return null;
  var n = [];
  var _iterator46 = _createForOfIteratorHelper(t),
    _step46;
  try {
    for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
      var _a12 = _step46.value;
      var _t77 = rt.createBox(e, r, {
        newList: !0
      });
      _t77 && (_t77.depth = _a12.depth, _t77.height = _a12.height, n.push({
        box: _t77,
        shift: _a12.pos - i
      }));
    }
  } catch (err) {
    _iterator46.e(err);
  } finally {
    _iterator46.f();
  }
  return new ce({
    individualShift: n
  }).wrap(e);
}
Ue("math", "", function (e, t, i) {
  return new Zt(e, t, i, {
    mathstyleName: "textstyle"
  });
}), Ue("displaymath", "", function (e, t, i) {
  return new Zt(e, t, i, {
    mathstyleName: "textstyle"
  });
}), We("array", "{columns:colspec}", function (e, t, i, r) {
  return new Zt(e, t, i, {
    columns: r[0],
    mathstyleName: "textstyle"
  });
}), We(["equation", "equation*", "subequations"], "", function (e, t, i) {
  return new Zt(e, t, i, {
    columns: [{
      align: "c"
    }]
  });
}), We("multline", "", function (e, t, i) {
  return new Zt(e, t, i, {
    columns: [{
      align: "m"
    }]
  });
}), We(["align", "align*", "aligned", "eqnarray"], "", function (e, t, i) {
  var r = 0;
  var _iterator47 = _createForOfIteratorHelper(t),
    _step47;
  try {
    for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
      var _e81 = _step47.value;
      r = Math.max(r, _e81.length);
    }
  } catch (err) {
    _iterator47.e(err);
  } finally {
    _iterator47.f();
  }
  var n = [{
    gap: 0
  }, {
    align: "r"
  }, {
    gap: 0
  }, {
    align: "l"
  }];
  var a = 2;
  for (; a < r;) n.push({
    gap: 1
  }), n.push({
    align: "r"
  }), n.push({
    gap: 0
  }), n.push({
    align: "l"
  }), a += 2;
  return n.push({
    gap: 0
  }), new Zt(e, t, i, {
    arraycolsep: 0,
    columns: n,
    colSeparationType: "align",
    jot: .3
  });
}), We("split", "", function (e, t, i) {
  return new Zt(e, t, i, {
    columns: [{
      align: "r"
    }, {
      align: "l"
    }]
  });
}), We(["gather", "gathered"], "", function (e, t, i) {
  return new Zt(e, t, i, {
    columns: [{
      gap: .25
    }, {
      align: "c"
    }, {
      gap: 0
    }],
    colSeparationType: "gather"
  });
}), We(["matrix", "pmatrix", "bmatrix", "Bmatrix", "vmatrix", "Vmatrix", "matrix*", "pmatrix*", "bmatrix*", "Bmatrix*", "vmatrix*", "Vmatrix*"], "[columns:colspec]", function (e, t, i, r) {
  var n;
  var a = ".",
    o = ".";
  switch (e) {
    case "pmatrix":
    case "pmatrix*":
      a = "(", o = ")";
      break;
    case "bmatrix":
    case "bmatrix*":
      a = "[", o = "]";
      break;
    case "Bmatrix":
    case "Bmatrix*":
      a = "\\lbrace", o = "\\rbrace";
      break;
    case "vmatrix":
    case "vmatrix*":
      a = "\\vert", o = "\\vert";
      break;
    case "Vmatrix":
    case "Vmatrix*":
      a = "\\Vert", o = "\\Vert";
      break;
    case "matrix":
    case "matrix*":
      a = ".", o = ".";
  }
  return new Zt(e, t, i, {
    mathstyleName: "textstyle",
    leftDelim: a,
    rightDelim: o,
    columns: null !== (n = r[0]) && void 0 !== n ? n : [{
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }]
  });
}), We(["smallmatrix", "smallmatrix*"], "[columns:colspec]", function (e, t, i, r) {
  var n;
  return new Zt(e, t, i, {
    mathstyleName: "scriptstyle",
    columns: null !== (n = r[0]) && void 0 !== n ? n : [{
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }, {
      align: "c"
    }],
    colSeparationType: "small",
    arraystretch: .5
  });
}), We(["cases", "dcases"], "", function (e, t, i) {
  return new Zt(e, t, i, {
    mathstyleName: "dcases" === e ? "displaystyle" : "textstyle",
    arraystretch: 1.2,
    leftDelim: "\\lbrace",
    rightDelim: ".",
    columns: [{
      align: "l"
    }, {
      gap: 1
    }, {
      align: "l"
    }]
  });
}), We("rcases", "", function (e, t, i) {
  return new Zt(e, t, i, {
    arraystretch: 1.2,
    leftDelim: ".",
    rightDelim: "\\rbrace",
    columns: [{
      align: "l"
    }, {
      gap: 1
    }, {
      align: "l"
    }]
  });
}), Ue("center", "", function (e, t, i) {
  return new Zt(e, t, i, {
    columns: [{
      align: "c"
    }]
  });
}), Ze(["overrightarrow", "overleftarrow", "Overrightarrow", "overleftharpoon", "overrightharpoon", "overleftrightarrow", "overlinesegment", "overgroup"], "{:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Et(e, {
      body: t[0],
      skipBoundary: !1,
      supsubPlacement: "over-under",
      padded: !0,
      boxType: "mrel",
      style: i,
      svgAbove: e.slice(1)
    });
  }
}), Ze("overbrace", "{:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Et(e, {
      body: t[0],
      skipBoundary: !1,
      supsubPlacement: "over-under",
      padded: !0,
      boxType: "mord",
      style: i,
      svgAbove: e.slice(1)
    });
  }
}), Ze(["underrightarrow", "underleftarrow", "underleftrightarrow", "underlinesegment", "undergroup"], "{:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Et(e, {
      body: t[0],
      skipBoundary: !1,
      supsubPlacement: "over-under",
      padded: !0,
      boxType: "mrel",
      style: i,
      svgBelow: e.slice(1)
    });
  }
}), Ze(["underbrace"], "{:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Et(e, {
      body: t[0],
      skipBoundary: !1,
      supsubPlacement: "over-under",
      padded: !0,
      boxType: "mord",
      style: i,
      svgBelow: e.slice(1)
    });
  }
}), Ze(["xrightarrow", "xleftarrow", "xRightarrow", "xLeftarrow", "xleftharpoonup", "xleftharpoondown", "xrightharpoonup", "xrightharpoondown", "xlongequal", "xtwoheadleftarrow", "xtwoheadrightarrow", "xleftrightarrow", "xLeftrightarrow", "xrightleftharpoons", "xleftrightharpoons", "xhookleftarrow", "xhookrightarrow", "xmapsto", "xtofrom", "xrightleftarrows", "xrightequilibrium", "xleftequilibrium"], "[:auto]{:auto}", {
  createAtom: function createAtom(e, t, i) {
    var r, n;
    return new Et(e, {
      style: i,
      svgBody: e.slice(1),
      above: 0 === (null === (r = t[1]) || void 0 === r ? void 0 : r.length) ? void 0 : t[1],
      below: null !== (n = t[0]) && void 0 !== n ? n : null,
      skipBoundary: !1,
      supsubPlacement: "over-under",
      padded: !0,
      boxType: "mrel",
      serialize: function serialize(t, i) {
        return e + (t.hasEmptyBranch("below") ? "" : "[".concat(t.belowToLatex(i), "]")) + "{".concat(t.aboveToLatex(i), "}");
      }
    });
  }
});
var Yt = /*#__PURE__*/function (_rt23) {
  _inherits(Yt, _rt23);
  var _super25 = _createSuper(Yt);
  function Yt(e, t) {
    var _this28;
    _classCallCheck(this, Yt);
    var i;
    _this28 = _super25.call(this, "surd", {
      command: e,
      mode: null !== (i = t.mode) && void 0 !== i ? i : "math",
      style: t.style,
      displayContainsHighlight: !0
    }), _this28.body = t.body, _this28.above = t.index;
    return _this28;
  }
  _createClass(Yt, [{
    key: "serialize",
    value: function serialize(e) {
      var t = "";
      return this.above && (t += "[".concat(this.aboveToLatex(e), "]")), t += "{".concat(this.bodyToLatex(e), "}"), this.command + t;
    }
  }, {
    key: "render",
    value: function render(e) {
      var t;
      var i = new H(e, this.style, "cramp"),
        r = null !== (t = rt.createBox(i, this.body, {
          style: this.style,
          newList: !0
        })) && void 0 !== t ? t : new te(null),
        n = i.scalingFactor,
        a = i.metrics.defaultRuleThickness / n,
        o = e.isDisplayStyle ? .431 : a,
        s = new te(null, {
          classes: "ML__sqrt-line",
          style: this.style,
          height: a
        });
      var l = n * (a + o / 4);
      var c = Math.max(2 * n * o, r.height + r.depth) + l + a,
        u = new H(e, this.style),
        d = this.bind(u, new te(vt("", "\\surd", c, !1, u), {
          classes: "ML__sqrt-sign",
          style: this.style
        }));
      if (!d) return null;
      var h = d.height + d.depth - a;
      h > r.height + r.depth + l && (l = (l + h - (r.height + r.depth)) / 2), d.setTop(d.height - r.height - (l + a));
      var p = new ce({
          firstBaseline: [{
            box: new te(r)
          }, l - 2 * a, {
            box: s
          }, a]
        }).wrap(e),
        m = rt.createBox(new H(e, this.style, "scriptscriptstyle"), this.above, {
          style: this.style,
          newList: !0
        });
      if (!m) {
        var _t78 = new te([d, p], {
          classes: this.containsCaret ? "ML__contains-caret" : "",
          type: "mord"
        });
        return this.caret && (_t78.caret = this.caret), this.bind(e, _t78.wrap(e));
      }
      var f = new ce({
          shift: -.6 * (Math.max(d.height, p.height) - Math.max(d.depth, p.depth)),
          children: [{
            box: m
          }]
        }),
        g = new te([new te(f, {
          classes: "ML__sqrt-index"
        }), d, p], {
          type: "mord",
          classes: this.containsCaret ? "ML__contains-caret" : ""
        });
      return g.height = d.height, g.depth = d.depth, this.caret && (g.caret = this.caret), this.bind(e, g.wrap(e));
    }
  }]);
  return Yt;
}(rt);
Ze(["arccos", "arcsin", "arctan", "arctg", "arcctg", "arg", "ch", "cos", "cosh", "cot", "coth", "ctg", "cth", "cotg", "csc", "cosec", "deg", "dim", "exp", "hom", "inf", "ker", "lg", "lb", "lg", "ln", "log", "Pr", "sec", "sh", "sin", "sinh", "sup", "tan", "tanh", "tg", "th"], "", {
  isFunction: !0,
  createAtom: function createAtom(e, t, i) {
    return new Rt(e, e.slice(1), {
      limits: "adjacent",
      isFunction: !0,
      variant: "main",
      variantStyle: "up",
      style: i
    });
  }
}), Ze(["liminf", "limsup"], "", {
  createAtom: function createAtom(e, t, i) {
    return new Rt(e, {
      "\\liminf": "lim inf",
      "\\limsup": "lim sup"
    }[e], {
      limits: "over-under",
      variant: "main",
      style: i
    });
  }
}), Ze(["lim", "mod"], "", {
  createAtom: function createAtom(e, t, i) {
    return new Rt(e, e.slice(1), {
      limits: "over-under",
      variant: "main",
      style: i
    });
  }
}), Ze(["det", "max", "min"], "", {
  isFunction: !0,
  createAtom: function createAtom(e, t, i) {
    return new Rt(e, e.slice(1), {
      limits: "over-under",
      isFunction: !0,
      variant: "main",
      style: i
    });
  }
}), Ze("sqrt", "[index:auto]{radicand:auto}", {
  createAtom: function createAtom(e, t, i) {
    return new Yt(e, {
      body: t[1],
      index: t[0],
      style: i
    });
  }
}), Ze(["frac", "dfrac", "tfrac", "cfrac", "binom", "dbinom", "tbinom"], "{numerator}{denominator}", {
  createAtom: function createAtom(e, t, i) {
    var r = {
      style: i
    };
    switch (e) {
      case "\\dfrac":
      case "\\frac":
      case "\\tfrac":
        r.hasBarLine = !0;
        break;
      case "\\atopfrac":
        r.hasBarLine = !1;
        break;
      case "\\dbinom":
      case "\\binom":
      case "\\tbinom":
        r.hasBarLine = !1, r.leftDelim = "(", r.rightDelim = ")";
    }
    switch (e) {
      case "\\dfrac":
      case "\\dbinom":
        r.mathstyleName = "displaystyle";
        break;
      case "\\tfrac":
      case "\\tbinom":
        r.mathstyleName = "textstyle";
        break;
      case "\\cfrac":
        r.hasBarLine = !0, r.continuousFraction = !0;
    }
    return new Pt(e, t[0], t[1], r);
  }
}), Ze(["over", "atop", "choose"], "", {
  infix: !0,
  createAtom: function createAtom(e, t, i) {
    var r, n;
    return "\\choose" === e && (r = "(", n = ")"), new Pt(e, t[0], t[1], {
      hasBarLine: "\\over" === e,
      leftDelim: r,
      rightDelim: n,
      style: i,
      serialize: function serialize(e, t) {
        return "{".concat(e.aboveToLatex(t)).concat(e.command, " ").concat(e.belowToLatex(t), "}");
      }
    });
  }
}), Ze("pdiff", "{numerator}{denominator}", {
  createAtom: function createAtom(e, t, i) {
    return new Pt(e, t[0], t[1], {
      hasBarLine: !0,
      numerPrefix: "\u2202",
      denomPrefix: "\u2202",
      style: i
    });
  }
}), Ze(["sum", "prod", "bigcup", "bigcap", "coprod", "bigvee", "bigwedge", "biguplus", "bigotimes", "bigoplus", "bigodot", "bigsqcup", "smallint", "intop"], "", {
  createAtom: function createAtom(e, t, i) {
    return new Rt(e, {
      coprod: "\u2210",
      bigvee: "\u22C1",
      bigwedge: "\u22C0",
      biguplus: "\u2A04",
      bigcap: "\u22C2",
      bigcup: "\u22C3",
      intop: "\u222B",
      prod: "\u220F",
      sum: "\u2211",
      bigotimes: "\u2A02",
      bigoplus: "\u2A01",
      bigodot: "\u2A00",
      bigsqcup: "\u2A06",
      smallint: "\u222B"
    }[e.slice(1)], {
      isExtensibleSymbol: !0,
      limits: "auto",
      variant: "main",
      style: i
    });
  }
});
var Qt = {
  int: "\u222B",
  iint: "\u222C",
  iiint: "\u222D",
  oint: "\u222E",
  oiint: "\u222F",
  oiiint: "\u2230",
  intclockwise: "\u2231",
  varointclockwise: "\u2232",
  ointctrclockwise: "\u2233",
  intctrclockwise: "\u2A11",
  sqcup: "\u2294",
  sqcap: "\u2293",
  uplus: "\u228E",
  wr: "\u2240",
  amalg: "\u2A3F",
  Cap: "\u22D2",
  Cup: "\u22D3",
  doublecap: "\u22D2",
  doublecup: "\u22D3"
};
Ze(Object.keys(Qt), "", {
  createAtom: function createAtom(e, t, i) {
    return new Rt(e, Qt[e.slice(1)], {
      limits: "adjacent",
      isExtensibleSymbol: !0,
      style: i,
      variant: {
        "\u22D2": "ams",
        "\u22D3": "ams"
      }[Qt[e.slice(1)]]
    });
  }
}), Ze(["Re", "Im"], "", {
  createAtom: function createAtom(e, t, i) {
    return new Rt(e, {
      "\\Re": "\u211C",
      "\\Im": "\u2111"
    }[e], {
      limits: "adjacent",
      style: i,
      isFunction: !0,
      variant: "fraktur"
    });
  }
}), Ze("middle", "{:delim}", {
  createAtom: function createAtom(e, t, i) {
    return new Bt(e, t[0], {
      size: 1,
      style: i
    });
  }
});
var Jt = /*#__PURE__*/function (_rt24) {
  _inherits(Jt, _rt24);
  var _super26 = _createSuper(Jt);
  function Jt(e, t) {
    var _this29;
    _classCallCheck(this, Jt);
    _this29 = _super26.call(this, "chem", {
      command: e,
      mode: "math"
    });
    var i = ri.go(ei.go(t, "\\pu" === e ? "pu" : "ce"), !1);
    _this29.body = zt(i), _this29.verbatimLatex = e + "{" + t + "}", _this29.captureSelection = !0;
    return _this29;
  }
  _createClass(Jt, [{
    key: "render",
    value: function render(e) {
      var t = rt.createBox(e, this.body, {
        type: "chem",
        newList: !0
      });
      return this.caret && (t.caret = this.caret), this.bind(e, t);
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      return this.verbatimLatex;
    }
  }]);
  return Jt;
}(rt);
Ze(["ce", "pu"], "{chemformula:balanced-string}", {
  createAtom: function createAtom(e, t, i) {
    return new Jt(e, t[0]);
  }
});
var ei = {
  go: function go(e, t) {
    if (!e) return [];
    void 0 === t && (t = "ce");
    var i,
      r = "0",
      n = {
        parenthesisLevel: 0
      };
    e = (e = (e = e.replace(/\n/g, " ")).replace(/[\u2212\u2013\u2014\u2010]/g, "-")).replace(/[\u2026]/g, "...");
    for (var a = 10, o = [];;) {
      i !== e ? (a = 10, i = e) : a--;
      var s = ei.stateMachines[t],
        l = s.transitions[r] || s.transitions["*"];
      e: for (var c = 0; c < l.length; c++) {
        var u = ei.patterns.match_(l[c].pattern, e);
        if (u) {
          for (var d = l[c].task, h = 0; h < d.action_.length; h++) {
            var p;
            if (s.actions[d.action_[h].type_]) p = s.actions[d.action_[h].type_](n, u.match_, d.action_[h].option);else {
              if (!ei.actions[d.action_[h].type_]) throw ["MhchemBugA", "mhchem bug A. Please report. (" + d.action_[h].type_ + ")"];
              p = ei.actions[d.action_[h].type_](n, u.match_, d.action_[h].option);
            }
            ei.concatArray(o, p);
          }
          if (r = d.nextState || r, !(e.length > 0)) return o;
          if (d.revisit || (e = u.remainder), !d.toContinue) break e;
        }
      }
      if (a <= 0) throw ["MhchemBugU", "mhchem bug U. Please report."];
    }
  },
  concatArray: function concatArray(e, t) {
    if (t) if (Array.isArray(t)) for (var i = 0; i < t.length; i++) e.push(t[i]);else e.push(t);
  },
  patterns: {
    patterns: {
      empty: /^$/,
      else: /^./,
      else2: /^./,
      space: /^\s/,
      "space A": /^\s(?=[A-Z\\$])/,
      space$: /^\s$/,
      "a-z": /^[a-z]/,
      x: /^x/,
      x$: /^x$/,
      i$: /^i$/,
      letters: /^(?:[a-zA-Z\u03B1-\u03C9\u0391-\u03A9?@]|(?:\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Gamma|Delta|Theta|Lambda|Xi|Pi|Sigma|Upsilon|Phi|Psi|Omega)(?:\s+|\{\}|(?![a-zA-Z]))))+/,
      "\\greek": /^\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Gamma|Delta|Theta|Lambda|Xi|Pi|Sigma|Upsilon|Phi|Psi|Omega)(?:\s+|\{\}|(?![a-zA-Z]))/,
      "one lowercase latin letter $": /^(?:([a-z])(?:$|[^a-zA-Z]))$/,
      "$one lowercase latin letter$ $": /^\$(?:([a-z])(?:$|[^a-zA-Z]))\$$/,
      "one lowercase greek letter $": /^(?:\$?[\u03B1-\u03C9]\$?|\$?\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega)\s*\$?)(?:\s+|\{\}|(?![a-zA-Z]))$/,
      digits: /^[0-9]+/,
      "-9.,9": /^[+\-]?(?:[0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))/,
      "-9.,9 no missing 0": /^[+\-]?[0-9]+(?:[.,][0-9]+)?/,
      "(-)(9.,9)(e)(99)": function e99(e) {
        var t = e.match(/^(\+\-|\+\/\-|\+|\-|\\pm\s?)?([0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))?(\((?:[0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))\))?(?:([eE]|\s*(\*|x|\\times|\u00D7)\s*10\^)([+\-]?[0-9]+|\{[+\-]?[0-9]+\}))?/);
        return t && t[0] ? {
          match_: t.splice(1),
          remainder: e.substr(t[0].length)
        } : null;
      },
      "(-)(9)^(-9)": function _(e) {
        var t = e.match(/^(\+\-|\+\/\-|\+|\-|\\pm\s?)?([0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+)?)\^([+\-]?[0-9]+|\{[+\-]?[0-9]+\})/);
        return t && t[0] ? {
          match_: t.splice(1),
          remainder: e.substr(t[0].length)
        } : null;
      },
      "state of aggregation $": function stateOfAggregation$(e) {
        var t = ei.patterns.findObserveGroups(e, "", /^\([a-z]{1,3}(?=[\),])/, ")", "");
        if (t && t.remainder.match(/^($|[\s,;\)\]\}])/)) return t;
        var i = e.match(/^(?:\((?:\\ca\s?)?\$[amothc]\$\))/);
        return i ? {
          match_: i[0],
          remainder: e.substr(i[0].length)
        } : null;
      },
      "_{(state of aggregation)}$": /^_\{(\([a-z]{1,3}\))\}/,
      "{[(": /^(?:\\\{|\[|\()/,
      ")]}": /^(?:\)|\]|\\\})/,
      ", ": /^[,;]\s*/,
      ",": /^[,;]/,
      ".": /^[.]/,
      ". ": /^([.\u22C5\u00B7\u2022])\s*/,
      "...": /^\.\.\.(?=$|[^.])/,
      "* ": /^([*])\s*/,
      "^{(...)}": function _(e) {
        return ei.patterns.findObserveGroups(e, "^{", "", "", "}");
      },
      "^($...$)": function $$(e) {
        return ei.patterns.findObserveGroups(e, "^", "$", "$", "");
      },
      "^a": /^\^([0-9]+|[^\\_])/,
      "^\\x{}{}": function x(e) {
        return ei.patterns.findObserveGroups(e, "^", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", !0);
      },
      "^\\x{}": function x(e) {
        return ei.patterns.findObserveGroups(e, "^", /^\\[a-zA-Z]+\{/, "}", "");
      },
      "^\\x": /^\^(\\[a-zA-Z]+)\s*/,
      "^(-1)": /^\^(-?\d+)/,
      "'": /^'/,
      "_{(...)}": function _(e) {
        return ei.patterns.findObserveGroups(e, "_{", "", "", "}");
      },
      "_($...$)": function _$$(e) {
        return ei.patterns.findObserveGroups(e, "_", "$", "$", "");
      },
      _9: /^_([+\-]?[0-9]+|[^\\])/,
      "_\\x{}{}": function _X(e) {
        return ei.patterns.findObserveGroups(e, "_", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", !0);
      },
      "_\\x{}": function _X(e) {
        return ei.patterns.findObserveGroups(e, "_", /^\\[a-zA-Z]+\{/, "}", "");
      },
      "_\\x": /^_(\\[a-zA-Z]+)\s*/,
      "^_": /^(?:\^(?=_)|\_(?=\^)|[\^_]$)/,
      "{}": /^\{\}/,
      "{...}": function _(e) {
        return ei.patterns.findObserveGroups(e, "", "{", "}", "");
      },
      "{(...)}": function _(e) {
        return ei.patterns.findObserveGroups(e, "{", "", "", "}");
      },
      "$...$": function $$(e) {
        return ei.patterns.findObserveGroups(e, "", "$", "$", "");
      },
      "${(...)}$": function $$(e) {
        return ei.patterns.findObserveGroups(e, "${", "", "", "}$");
      },
      "$(...)$": function $$(e) {
        return ei.patterns.findObserveGroups(e, "$", "", "", "$");
      },
      "=<>": /^[=<>]/,
      "#": /^[#\u2261]/,
      "+": /^\+/,
      "-$": /^-(?=[\s_},;\]/]|$|\([a-z]+\))/,
      "-9": /^-(?=[0-9])/,
      "- orbital overlap": /^-(?=(?:[spd]|sp)(?:$|[\s,;\)\]\}]))/,
      "-": /^-/,
      "pm-operator": /^(?:\\pm|\$\\pm\$|\+-|\+\/-)/,
      operator: /^(?:\+|(?:[\-=<>]|<<|>>|\\approx|\$\\approx\$)(?=\s|$|-?[0-9]))/,
      arrowUpDown: /^(?:v|\(v\)|\^|\(\^\))(?=$|[\s,;\)\]\}])/,
      "\\bond{(...)}": function bond(e) {
        return ei.patterns.findObserveGroups(e, "\\bond{", "", "", "}");
      },
      "->": /^(?:<->|<-->|->|<-|<=>>|<<=>|<=>|[\u2192\u27F6\u21CC])/,
      CMT: /^[CMT](?=\[)/,
      "[(...)]": function _(e) {
        return ei.patterns.findObserveGroups(e, "[", "", "", "]");
      },
      "1st-level escape": /^(&|\\\\|\\hline)\s*/,
      "\\,": /^(?:\\[,\ ;:])/,
      "\\x{}{}": function x(e) {
        return ei.patterns.findObserveGroups(e, "", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", !0);
      },
      "\\x{}": function x(e) {
        return ei.patterns.findObserveGroups(e, "", /^\\[a-zA-Z]+\{/, "}", "");
      },
      "\\ca": /^\\ca(?:\s+|(?![a-zA-Z]))/,
      "\\x": /^(?:\\[a-zA-Z]+\s*|\\[_&{}%])/,
      orbital: /^(?:[0-9]{1,2}[spdfgh]|[0-9]{0,2}sp)(?=$|[^a-zA-Z])/,
      others: /^[\/~|]/,
      "\\frac{(...)}": function frac(e) {
        return ei.patterns.findObserveGroups(e, "\\frac{", "", "", "}", "{", "", "", "}");
      },
      "\\overset{(...)}": function overset(e) {
        return ei.patterns.findObserveGroups(e, "\\overset{", "", "", "}", "{", "", "", "}");
      },
      "\\underset{(...)}": function underset(e) {
        return ei.patterns.findObserveGroups(e, "\\underset{", "", "", "}", "{", "", "", "}");
      },
      "\\underbrace{(...)}": function underbrace(e) {
        return ei.patterns.findObserveGroups(e, "\\underbrace{", "", "", "}_", "{", "", "", "}");
      },
      "\\color{(...)}0": function color0(e) {
        return ei.patterns.findObserveGroups(e, "\\color{", "", "", "}");
      },
      "\\color{(...)}{(...)}1": function color1(e) {
        return ei.patterns.findObserveGroups(e, "\\color{", "", "", "}", "{", "", "", "}");
      },
      "\\color(...){(...)}2": function color2(e) {
        return ei.patterns.findObserveGroups(e, "\\color", "\\", "", /^(?=\{)/, "{", "", "", "}");
      },
      "\\ce{(...)}": function ce(e) {
        return ei.patterns.findObserveGroups(e, "\\ce{", "", "", "}");
      },
      oxidation$: /^(?:[+-][IVX]+|\\pm\s*0|\$\\pm\$\s*0)$/,
      "d-oxidation$": /^(?:[+-]?\s?[IVX]+|\\pm\s*0|\$\\pm\$\s*0)$/,
      "roman numeral": /^[IVX]+/,
      "1/2$": /^[+\-]?(?:[0-9]+|\$[a-z]\$|[a-z])\/[0-9]+(?:\$[a-z]\$|[a-z])?$/,
      amount: function amount(e) {
        var t;
        if (t = e.match(/^(?:(?:(?:\([+\-]?[0-9]+\/[0-9]+\)|[+\-]?(?:[0-9]+|\$[a-z]\$|[a-z])\/[0-9]+|[+\-]?[0-9]+[.,][0-9]+|[+\-]?\.[0-9]+|[+\-]?[0-9]+)(?:[a-z](?=\s*[A-Z]))?)|[+\-]?[a-z](?=\s*[A-Z])|\+(?!\s))/)) return {
          match_: t[0],
          remainder: e.substr(t[0].length)
        };
        var i = ei.patterns.findObserveGroups(e, "", "$", "$", "");
        return i && (t = i.match_.match(/^\$(?:\(?[+\-]?(?:[0-9]*[a-z]?[+\-])?[0-9]*[a-z](?:[+\-][0-9]*[a-z]?)?\)?|\+|-)\$$/)) ? {
          match_: t[0],
          remainder: e.substr(t[0].length)
        } : null;
      },
      amount2: function amount2(e) {
        return this.amount(e);
      },
      "(KV letters),": /^(?:[A-Z][a-z]{0,2}|i)(?=,)/,
      formula$: function formula$(e) {
        if (e.match(/^\([a-z]+\)$/)) return null;
        var t = e.match(/^(?:[a-z]|(?:[0-9\ \+\-\,\.\(\)]+[a-z])+[0-9\ \+\-\,\.\(\)]*|(?:[a-z][0-9\ \+\-\,\.\(\)]+)+[a-z]?)$/);
        return t ? {
          match_: t[0],
          remainder: e.substr(t[0].length)
        } : null;
      },
      uprightEntities: /^(?:pH|pOH|pC|pK|iPr|iBu)(?=$|[^a-zA-Z])/,
      "/": /^\s*(\/)\s*/,
      "//": /^\s*(\/\/)\s*/,
      "*": /^\s*[*.]\s*/
    },
    findObserveGroups: function findObserveGroups(e, t, i, r, n, a, o, s, l, c) {
      var u = function u(e, t) {
          if ("string" == typeof t) return 0 !== e.indexOf(t) ? null : t;
          var i = e.match(t);
          return i ? i[0] : null;
        },
        d = u(e, t);
      if (null === d) return null;
      if (e = e.substr(d.length), null === (d = u(e, i))) return null;
      var h = function (e, t, i) {
        for (var r = 0; t < e.length;) {
          var n = e.charAt(t),
            a = u(e.substr(t), i);
          if (null !== a && 0 === r) return {
            endMatchBegin: t,
            endMatchEnd: t + a.length
          };
          if ("{" === n) r++;else if ("}" === n) {
            if (0 === r) throw ["ExtraCloseMissingOpen", "Extra close brace or missing open brace"];
            r--;
          }
          t++;
        }
        return null;
      }(e, d.length, r || n);
      if (null === h) return null;
      var p = e.substring(0, r ? h.endMatchEnd : h.endMatchBegin);
      if (a || o) {
        var m = this.findObserveGroups(e.substr(h.endMatchEnd), a, o, s, l);
        if (null === m) return null;
        var f = [p, m.match_];
        return {
          match_: c ? f.join("") : f,
          remainder: m.remainder
        };
      }
      return {
        match_: p,
        remainder: e.substr(h.endMatchEnd)
      };
    },
    match_: function match_(e, t) {
      var i = ei.patterns.patterns[e];
      if (void 0 === i) throw ["MhchemBugP", "mhchem bug P. Please report. (" + e + ")"];
      if ("function" == typeof i) return ei.patterns.patterns[e](t);
      var r = t.match(i);
      return r ? {
        match_: r[2] ? [r[1], r[2]] : r[1] ? r[1] : r[0],
        remainder: t.substr(r[0].length)
      } : null;
    }
  },
  actions: {
    "a=": function a(e, t) {
      e.a = (e.a || "") + t;
    },
    "b=": function b(e, t) {
      e.b = (e.b || "") + t;
    },
    "p=": function p(e, t) {
      e.p = (e.p || "") + t;
    },
    "o=": function o(e, t) {
      e.o = (e.o || "") + t;
    },
    "q=": function q(e, t) {
      e.q = (e.q || "") + t;
    },
    "d=": function d(e, t) {
      e.d = (e.d || "") + t;
    },
    "rm=": function rm(e, t) {
      e.rm = (e.rm || "") + t;
    },
    "text=": function text(e, t) {
      e.text_ = (e.text_ || "") + t;
    },
    insert: function insert(e, t, i) {
      return {
        type_: i
      };
    },
    "insert+p1": function insertP1(e, t, i) {
      return {
        type_: i,
        p1: t
      };
    },
    "insert+p1+p2": function insertP1P2(e, t, i) {
      return {
        type_: i,
        p1: t[0],
        p2: t[1]
      };
    },
    copy: function copy(e, t) {
      return t;
    },
    rm: function rm(e, t) {
      return {
        type_: "rm",
        p1: t || ""
      };
    },
    text: function text(e, t) {
      return ei.go(t, "text");
    },
    "{text}": function text(e, t) {
      var i = ["{"];
      return ei.concatArray(i, ei.go(t, "text")), i.push("}"), i;
    },
    "tex-math": function texMath(e, t) {
      return ei.go(t, "tex-math");
    },
    "tex-math tight": function texMathTight(e, t) {
      return ei.go(t, "tex-math tight");
    },
    bond: function bond(e, t, i) {
      return {
        type_: "bond",
        kind_: i || t
      };
    },
    "color0-output": function color0Output(e, t) {
      return {
        type_: "color0",
        color: t[0]
      };
    },
    ce: function ce(e, t) {
      return ei.go(t);
    },
    "1/2": function _(e, t) {
      var i = [];
      t.match(/^[+\-]/) && (i.push(t.substr(0, 1)), t = t.substr(1));
      var r = t.match(/^([0-9]+|\$[a-z]\$|[a-z])\/([0-9]+)(\$[a-z]\$|[a-z])?$/);
      return r[1] = r[1].replace(/\$/g, ""), i.push({
        type_: "frac",
        p1: r[1],
        p2: r[2]
      }), r[3] && (r[3] = r[3].replace(/\$/g, ""), i.push({
        type_: "tex-math",
        p1: r[3]
      })), i;
    },
    "9,9": function _(e, t) {
      return ei.go(t, "9,9");
    }
  },
  createTransitions: function createTransitions(e) {
    var t,
      i,
      r,
      n,
      a = {};
    for (t in e) for (i in e[t]) for (r = i.split("|"), e[t][i].stateArray = r, n = 0; n < r.length; n++) a[r[n]] = [];
    for (t in e) for (i in e[t]) for (r = e[t][i].stateArray || [], n = 0; n < r.length; n++) {
      var o = e[t][i];
      if (o.action_) {
        o.action_ = [].concat(o.action_);
        for (var s = 0; s < o.action_.length; s++) "string" == typeof o.action_[s] && (o.action_[s] = {
          type_: o.action_[s]
        });
      } else o.action_ = [];
      for (var l = t.split("|"), c = 0; c < l.length; c++) if ("*" === r[n]) for (var u in a) a[u].push({
        pattern: l[c],
        task: o
      });else a[r[n]].push({
        pattern: l[c],
        task: o
      });
    }
    return a;
  },
  stateMachines: {}
};
ei.stateMachines = {
  ce: {
    transitions: ei.createTransitions({
      empty: {
        "*": {
          action_: "output"
        }
      },
      else: {
        "0|1|2": {
          action_: "beginsWithBond=false",
          revisit: !0,
          toContinue: !0
        }
      },
      oxidation$: {
        0: {
          action_: "oxidation-output"
        }
      },
      CMT: {
        r: {
          action_: "rdt=",
          nextState: "rt"
        },
        rd: {
          action_: "rqt=",
          nextState: "rdt"
        }
      },
      arrowUpDown: {
        "0|1|2|as": {
          action_: ["sb=false", "output", "operator"],
          nextState: "1"
        }
      },
      uprightEntities: {
        "0|1|2": {
          action_: ["o=", "output"],
          nextState: "1"
        }
      },
      orbital: {
        "0|1|2|3": {
          action_: "o=",
          nextState: "o"
        }
      },
      "->": {
        "0|1|2|3": {
          action_: "r=",
          nextState: "r"
        },
        "a|as": {
          action_: ["output", "r="],
          nextState: "r"
        },
        "*": {
          action_: ["output", "r="],
          nextState: "r"
        }
      },
      "+": {
        o: {
          action_: "d= kv",
          nextState: "d"
        },
        "d|D": {
          action_: "d=",
          nextState: "d"
        },
        q: {
          action_: "d=",
          nextState: "qd"
        },
        "qd|qD": {
          action_: "d=",
          nextState: "qd"
        },
        dq: {
          action_: ["output", "d="],
          nextState: "d"
        },
        3: {
          action_: ["sb=false", "output", "operator"],
          nextState: "0"
        }
      },
      amount: {
        "0|2": {
          action_: "a=",
          nextState: "a"
        }
      },
      "pm-operator": {
        "0|1|2|a|as": {
          action_: ["sb=false", "output", {
            type_: "operator",
            option: "\\pm"
          }],
          nextState: "0"
        }
      },
      operator: {
        "0|1|2|a|as": {
          action_: ["sb=false", "output", "operator"],
          nextState: "0"
        }
      },
      "-$": {
        "o|q": {
          action_: ["charge or bond", "output"],
          nextState: "qd"
        },
        d: {
          action_: "d=",
          nextState: "d"
        },
        D: {
          action_: ["output", {
            type_: "bond",
            option: "-"
          }],
          nextState: "3"
        },
        q: {
          action_: "d=",
          nextState: "qd"
        },
        qd: {
          action_: "d=",
          nextState: "qd"
        },
        "qD|dq": {
          action_: ["output", {
            type_: "bond",
            option: "-"
          }],
          nextState: "3"
        }
      },
      "-9": {
        "3|o": {
          action_: ["output", {
            type_: "insert",
            option: "hyphen"
          }],
          nextState: "3"
        }
      },
      "- orbital overlap": {
        o: {
          action_: ["output", {
            type_: "insert",
            option: "hyphen"
          }],
          nextState: "2"
        },
        d: {
          action_: ["output", {
            type_: "insert",
            option: "hyphen"
          }],
          nextState: "2"
        }
      },
      "-": {
        "0|1|2": {
          action_: [{
            type_: "output",
            option: 1
          }, "beginsWithBond=true", {
            type_: "bond",
            option: "-"
          }],
          nextState: "3"
        },
        3: {
          action_: {
            type_: "bond",
            option: "-"
          }
        },
        a: {
          action_: ["output", {
            type_: "insert",
            option: "hyphen"
          }],
          nextState: "2"
        },
        as: {
          action_: [{
            type_: "output",
            option: 2
          }, {
            type_: "bond",
            option: "-"
          }],
          nextState: "3"
        },
        b: {
          action_: "b="
        },
        o: {
          action_: {
            type_: "- after o/d",
            option: !1
          },
          nextState: "2"
        },
        q: {
          action_: {
            type_: "- after o/d",
            option: !1
          },
          nextState: "2"
        },
        "d|qd|dq": {
          action_: {
            type_: "- after o/d",
            option: !0
          },
          nextState: "2"
        },
        "D|qD|p": {
          action_: ["output", {
            type_: "bond",
            option: "-"
          }],
          nextState: "3"
        }
      },
      amount2: {
        "1|3": {
          action_: "a=",
          nextState: "a"
        }
      },
      letters: {
        "0|1|2|3|a|as|b|p|bp|o": {
          action_: "o=",
          nextState: "o"
        },
        "q|dq": {
          action_: ["output", "o="],
          nextState: "o"
        },
        "d|D|qd|qD": {
          action_: "o after d",
          nextState: "o"
        }
      },
      digits: {
        o: {
          action_: "q=",
          nextState: "q"
        },
        "d|D": {
          action_: "q=",
          nextState: "dq"
        },
        q: {
          action_: ["output", "o="],
          nextState: "o"
        },
        a: {
          action_: "o=",
          nextState: "o"
        }
      },
      "space A": {
        "b|p|bp": {}
      },
      space: {
        a: {
          nextState: "as"
        },
        0: {
          action_: "sb=false"
        },
        "1|2": {
          action_: "sb=true"
        },
        "r|rt|rd|rdt|rdq": {
          action_: "output",
          nextState: "0"
        },
        "*": {
          action_: ["output", "sb=true"],
          nextState: "1"
        }
      },
      "1st-level escape": {
        "1|2": {
          action_: ["output", {
            type_: "insert+p1",
            option: "1st-level escape"
          }]
        },
        "*": {
          action_: ["output", {
            type_: "insert+p1",
            option: "1st-level escape"
          }],
          nextState: "0"
        }
      },
      "[(...)]": {
        "r|rt": {
          action_: "rd=",
          nextState: "rd"
        },
        "rd|rdt": {
          action_: "rq=",
          nextState: "rdq"
        }
      },
      "...": {
        "o|d|D|dq|qd|qD": {
          action_: ["output", {
            type_: "bond",
            option: "..."
          }],
          nextState: "3"
        },
        "*": {
          action_: [{
            type_: "output",
            option: 1
          }, {
            type_: "insert",
            option: "ellipsis"
          }],
          nextState: "1"
        }
      },
      ". |* ": {
        "*": {
          action_: ["output", {
            type_: "insert",
            option: "addition compound"
          }],
          nextState: "1"
        }
      },
      "state of aggregation $": {
        "*": {
          action_: ["output", "state of aggregation"],
          nextState: "1"
        }
      },
      "{[(": {
        "a|as|o": {
          action_: ["o=", "output", "parenthesisLevel++"],
          nextState: "2"
        },
        "0|1|2|3": {
          action_: ["o=", "output", "parenthesisLevel++"],
          nextState: "2"
        },
        "*": {
          action_: ["output", "o=", "output", "parenthesisLevel++"],
          nextState: "2"
        }
      },
      ")]}": {
        "0|1|2|3|b|p|bp|o": {
          action_: ["o=", "parenthesisLevel--"],
          nextState: "o"
        },
        "a|as|d|D|q|qd|qD|dq": {
          action_: ["output", "o=", "parenthesisLevel--"],
          nextState: "o"
        }
      },
      ", ": {
        "*": {
          action_: ["output", "comma"],
          nextState: "0"
        }
      },
      "^_": {
        "*": {}
      },
      "^{(...)}|^($...$)": {
        "0|1|2|as": {
          action_: "b=",
          nextState: "b"
        },
        p: {
          action_: "b=",
          nextState: "bp"
        },
        "3|o": {
          action_: "d= kv",
          nextState: "D"
        },
        q: {
          action_: "d=",
          nextState: "qD"
        },
        "d|D|qd|qD|dq": {
          action_: ["output", "d="],
          nextState: "D"
        }
      },
      "^a|^\\x{}{}|^\\x{}|^\\x|'": {
        "0|1|2|as": {
          action_: "b=",
          nextState: "b"
        },
        p: {
          action_: "b=",
          nextState: "bp"
        },
        "3|o": {
          action_: "d= kv",
          nextState: "d"
        },
        q: {
          action_: "d=",
          nextState: "qd"
        },
        "d|qd|D|qD": {
          action_: "d="
        },
        dq: {
          action_: ["output", "d="],
          nextState: "d"
        }
      },
      "_{(state of aggregation)}$": {
        "d|D|q|qd|qD|dq": {
          action_: ["output", "q="],
          nextState: "q"
        }
      },
      "_{(...)}|_($...$)|_9|_\\x{}{}|_\\x{}|_\\x": {
        "0|1|2|as": {
          action_: "p=",
          nextState: "p"
        },
        b: {
          action_: "p=",
          nextState: "bp"
        },
        "3|o": {
          action_: "q=",
          nextState: "q"
        },
        "d|D": {
          action_: "q=",
          nextState: "dq"
        },
        "q|qd|qD|dq": {
          action_: ["output", "q="],
          nextState: "q"
        }
      },
      "=<>": {
        "0|1|2|3|a|as|o|q|d|D|qd|qD|dq": {
          action_: [{
            type_: "output",
            option: 2
          }, "bond"],
          nextState: "3"
        }
      },
      "#": {
        "0|1|2|3|a|as|o": {
          action_: [{
            type_: "output",
            option: 2
          }, {
            type_: "bond",
            option: "#"
          }],
          nextState: "3"
        }
      },
      "{}": {
        "*": {
          action_: {
            type_: "output",
            option: 1
          },
          nextState: "1"
        }
      },
      "{...}": {
        "0|1|2|3|a|as|b|p|bp": {
          action_: "o=",
          nextState: "o"
        },
        "o|d|D|q|qd|qD|dq": {
          action_: ["output", "o="],
          nextState: "o"
        }
      },
      "$...$": {
        a: {
          action_: "a="
        },
        "0|1|2|3|as|b|p|bp|o": {
          action_: "o=",
          nextState: "o"
        },
        "as|o": {
          action_: "o="
        },
        "q|d|D|qd|qD|dq": {
          action_: ["output", "o="],
          nextState: "o"
        }
      },
      "\\bond{(...)}": {
        "*": {
          action_: [{
            type_: "output",
            option: 2
          }, "bond"],
          nextState: "3"
        }
      },
      "\\frac{(...)}": {
        "*": {
          action_: [{
            type_: "output",
            option: 1
          }, "frac-output"],
          nextState: "3"
        }
      },
      "\\overset{(...)}": {
        "*": {
          action_: [{
            type_: "output",
            option: 2
          }, "overset-output"],
          nextState: "3"
        }
      },
      "\\underset{(...)}": {
        "*": {
          action_: [{
            type_: "output",
            option: 2
          }, "underset-output"],
          nextState: "3"
        }
      },
      "\\underbrace{(...)}": {
        "*": {
          action_: [{
            type_: "output",
            option: 2
          }, "underbrace-output"],
          nextState: "3"
        }
      },
      "\\color{(...)}{(...)}1|\\color(...){(...)}2": {
        "*": {
          action_: [{
            type_: "output",
            option: 2
          }, "color-output"],
          nextState: "3"
        }
      },
      "\\color{(...)}0": {
        "*": {
          action_: [{
            type_: "output",
            option: 2
          }, "color0-output"]
        }
      },
      "\\ce{(...)}": {
        "*": {
          action_: [{
            type_: "output",
            option: 2
          }, "ce"],
          nextState: "3"
        }
      },
      "\\,": {
        "*": {
          action_: [{
            type_: "output",
            option: 1
          }, "copy"],
          nextState: "1"
        }
      },
      "\\x{}{}|\\x{}|\\x": {
        "0|1|2|3|a|as|b|p|bp|o|c0": {
          action_: ["o=", "output"],
          nextState: "3"
        },
        "*": {
          action_: ["output", "o=", "output"],
          nextState: "3"
        }
      },
      others: {
        "*": {
          action_: [{
            type_: "output",
            option: 1
          }, "copy"],
          nextState: "3"
        }
      },
      else2: {
        a: {
          action_: "a to o",
          nextState: "o",
          revisit: !0
        },
        as: {
          action_: ["output", "sb=true"],
          nextState: "1",
          revisit: !0
        },
        "r|rt|rd|rdt|rdq": {
          action_: ["output"],
          nextState: "0",
          revisit: !0
        },
        "*": {
          action_: ["output", "copy"],
          nextState: "3"
        }
      }
    }),
    actions: {
      "o after d": function oAfterD(e, t) {
        var i;
        if ((e.d || "").match(/^[0-9]+$/)) {
          var r = e.d;
          e.d = void 0, i = this.output(e), e.b = r;
        } else i = this.output(e);
        return ei.actions["o="](e, t), i;
      },
      "d= kv": function dKv(e, t) {
        e.d = t, e.dType = "kv";
      },
      "charge or bond": function chargeOrBond(e, t) {
        if (e.beginsWithBond) {
          var i = [];
          return ei.concatArray(i, this.output(e)), ei.concatArray(i, ei.actions.bond(e, t, "-")), i;
        }
        e.d = t;
      },
      "- after o/d": function afterOD(e, t, i) {
        var r = ei.patterns.match_("orbital", e.o || ""),
          n = ei.patterns.match_("one lowercase greek letter $", e.o || ""),
          a = ei.patterns.match_("one lowercase latin letter $", e.o || ""),
          o = ei.patterns.match_("$one lowercase latin letter$ $", e.o || ""),
          s = "-" === t && (r && "" === r.remainder || n || a || o);
        !s || e.a || e.b || e.p || e.d || e.q || r || !a || (e.o = "$" + e.o + "$");
        var l = [];
        return s ? (ei.concatArray(l, this.output(e)), l.push({
          type_: "hyphen"
        })) : (r = ei.patterns.match_("digits", e.d || ""), i && r && "" === r.remainder ? (ei.concatArray(l, ei.actions["d="](e, t)), ei.concatArray(l, this.output(e))) : (ei.concatArray(l, this.output(e)), ei.concatArray(l, ei.actions.bond(e, t, "-")))), l;
      },
      "a to o": function aToO(e) {
        e.o = e.a, e.a = void 0;
      },
      "sb=true": function sbTrue(e) {
        e.sb = !0;
      },
      "sb=false": function sbFalse(e) {
        e.sb = !1;
      },
      "beginsWithBond=true": function beginsWithBondTrue(e) {
        e.beginsWithBond = !0;
      },
      "beginsWithBond=false": function beginsWithBondFalse(e) {
        e.beginsWithBond = !1;
      },
      "parenthesisLevel++": function parenthesisLevel(e) {
        e.parenthesisLevel++;
      },
      "parenthesisLevel--": function parenthesisLevel(e) {
        e.parenthesisLevel--;
      },
      "state of aggregation": function stateOfAggregation(e, t) {
        return {
          type_: "state of aggregation",
          p1: ei.go(t, "o")
        };
      },
      comma: function comma(e, t) {
        var i = t.replace(/\s*$/, "");
        return i !== t && 0 === e.parenthesisLevel ? {
          type_: "comma enumeration L",
          p1: i
        } : {
          type_: "comma enumeration M",
          p1: i
        };
      },
      output: function output(e, t, i) {
        var r, n, a;
        for (var o in e.r ? (n = "M" === e.rdt ? ei.go(e.rd, "tex-math") : "T" === e.rdt ? [{
          type_: "text",
          p1: e.rd || ""
        }] : ei.go(e.rd), a = "M" === e.rqt ? ei.go(e.rq, "tex-math") : "T" === e.rqt ? [{
          type_: "text",
          p1: e.rq || ""
        }] : ei.go(e.rq), r = {
          type_: "arrow",
          r: e.r,
          rd: n,
          rq: a
        }) : (r = [], (e.a || e.b || e.p || e.o || e.q || e.d || i) && (e.sb && r.push({
          type_: "entitySkip"
        }), e.o || e.q || e.d || e.b || e.p || 2 === i ? e.o || e.q || e.d || !e.b && !e.p ? e.o && "kv" === e.dType && ei.patterns.match_("d-oxidation$", e.d || "") ? e.dType = "oxidation" : e.o && "kv" === e.dType && !e.q && (e.dType = void 0) : (e.o = e.a, e.d = e.b, e.q = e.p, e.a = e.b = e.p = void 0) : (e.o = e.a, e.a = void 0), r.push({
          type_: "chemfive",
          a: ei.go(e.a, "a"),
          b: ei.go(e.b, "bd"),
          p: ei.go(e.p, "pq"),
          o: ei.go(e.o, "o"),
          q: ei.go(e.q, "pq"),
          d: ei.go(e.d, "oxidation" === e.dType ? "oxidation" : "bd"),
          dType: e.dType
        }))), e) "parenthesisLevel" !== o && "beginsWithBond" !== o && delete e[o];
        return r;
      },
      "oxidation-output": function oxidationOutput(e, t) {
        var i = ["{"];
        return ei.concatArray(i, ei.go(t, "oxidation")), i.push("}"), i;
      },
      "frac-output": function fracOutput(e, t) {
        return {
          type_: "frac-ce",
          p1: ei.go(t[0]),
          p2: ei.go(t[1])
        };
      },
      "overset-output": function oversetOutput(e, t) {
        return {
          type_: "overset",
          p1: ei.go(t[0]),
          p2: ei.go(t[1])
        };
      },
      "underset-output": function undersetOutput(e, t) {
        return {
          type_: "underset",
          p1: ei.go(t[0]),
          p2: ei.go(t[1])
        };
      },
      "underbrace-output": function underbraceOutput(e, t) {
        return {
          type_: "underbrace",
          p1: ei.go(t[0]),
          p2: ei.go(t[1])
        };
      },
      "color-output": function colorOutput(e, t) {
        return {
          type_: "color",
          color1: t[0],
          color2: ei.go(t[1])
        };
      },
      "r=": function r(e, t) {
        e.r = t;
      },
      "rdt=": function rdt(e, t) {
        e.rdt = t;
      },
      "rd=": function rd(e, t) {
        e.rd = t;
      },
      "rqt=": function rqt(e, t) {
        e.rqt = t;
      },
      "rq=": function rq(e, t) {
        e.rq = t;
      },
      operator: function operator(e, t, i) {
        return {
          type_: "operator",
          kind_: i || t
        };
      }
    }
  },
  a: {
    transitions: ei.createTransitions({
      empty: {
        "*": {}
      },
      "1/2$": {
        0: {
          action_: "1/2"
        }
      },
      else: {
        0: {
          nextState: "1",
          revisit: !0
        }
      },
      "$(...)$": {
        "*": {
          action_: "tex-math tight",
          nextState: "1"
        }
      },
      ",": {
        "*": {
          action_: {
            type_: "insert",
            option: "commaDecimal"
          }
        }
      },
      else2: {
        "*": {
          action_: "copy"
        }
      }
    }),
    actions: {}
  },
  o: {
    transitions: ei.createTransitions({
      empty: {
        "*": {}
      },
      "1/2$": {
        0: {
          action_: "1/2"
        }
      },
      else: {
        0: {
          nextState: "1",
          revisit: !0
        }
      },
      letters: {
        "*": {
          action_: "rm"
        }
      },
      "\\ca": {
        "*": {
          action_: {
            type_: "insert",
            option: "circa"
          }
        }
      },
      "\\x{}{}|\\x{}|\\x": {
        "*": {
          action_: "copy"
        }
      },
      "${(...)}$|$(...)$": {
        "*": {
          action_: "tex-math"
        }
      },
      "{(...)}": {
        "*": {
          action_: "{text}"
        }
      },
      else2: {
        "*": {
          action_: "copy"
        }
      }
    }),
    actions: {}
  },
  text: {
    transitions: ei.createTransitions({
      empty: {
        "*": {
          action_: "output"
        }
      },
      "{...}": {
        "*": {
          action_: "text="
        }
      },
      "${(...)}$|$(...)$": {
        "*": {
          action_: "tex-math"
        }
      },
      "\\greek": {
        "*": {
          action_: ["output", "rm"]
        }
      },
      "\\,|\\x{}{}|\\x{}|\\x": {
        "*": {
          action_: ["output", "copy"]
        }
      },
      else: {
        "*": {
          action_: "text="
        }
      }
    }),
    actions: {
      output: function output(e) {
        if (e.text_) {
          var t = {
            type_: "text",
            p1: e.text_
          };
          for (var i in e) delete e[i];
          return t;
        }
      }
    }
  },
  pq: {
    transitions: ei.createTransitions({
      empty: {
        "*": {}
      },
      "state of aggregation $": {
        "*": {
          action_: "state of aggregation"
        }
      },
      i$: {
        0: {
          nextState: "!f",
          revisit: !0
        }
      },
      "(KV letters),": {
        0: {
          action_: "rm",
          nextState: "0"
        }
      },
      formula$: {
        0: {
          nextState: "f",
          revisit: !0
        }
      },
      "1/2$": {
        0: {
          action_: "1/2"
        }
      },
      else: {
        0: {
          nextState: "!f",
          revisit: !0
        }
      },
      "${(...)}$|$(...)$": {
        "*": {
          action_: "tex-math"
        }
      },
      "{(...)}": {
        "*": {
          action_: "text"
        }
      },
      "a-z": {
        f: {
          action_: "tex-math"
        }
      },
      letters: {
        "*": {
          action_: "rm"
        }
      },
      "-9.,9": {
        "*": {
          action_: "9,9"
        }
      },
      ",": {
        "*": {
          action_: {
            type_: "insert+p1",
            option: "comma enumeration S"
          }
        }
      },
      "\\color{(...)}{(...)}1|\\color(...){(...)}2": {
        "*": {
          action_: "color-output"
        }
      },
      "\\color{(...)}0": {
        "*": {
          action_: "color0-output"
        }
      },
      "\\ce{(...)}": {
        "*": {
          action_: "ce"
        }
      },
      "\\,|\\x{}{}|\\x{}|\\x": {
        "*": {
          action_: "copy"
        }
      },
      else2: {
        "*": {
          action_: "copy"
        }
      }
    }),
    actions: {
      "state of aggregation": function stateOfAggregation(e, t) {
        return {
          type_: "state of aggregation subscript",
          p1: ei.go(t, "o")
        };
      },
      "color-output": function colorOutput(e, t) {
        return {
          type_: "color",
          color1: t[0],
          color2: ei.go(t[1], "pq")
        };
      }
    }
  },
  bd: {
    transitions: ei.createTransitions({
      empty: {
        "*": {}
      },
      x$: {
        0: {
          nextState: "!f",
          revisit: !0
        }
      },
      formula$: {
        0: {
          nextState: "f",
          revisit: !0
        }
      },
      else: {
        0: {
          nextState: "!f",
          revisit: !0
        }
      },
      "-9.,9 no missing 0": {
        "*": {
          action_: "9,9"
        }
      },
      ".": {
        "*": {
          action_: {
            type_: "insert",
            option: "electron dot"
          }
        }
      },
      "a-z": {
        f: {
          action_: "tex-math"
        }
      },
      x: {
        "*": {
          action_: {
            type_: "insert",
            option: "KV x"
          }
        }
      },
      letters: {
        "*": {
          action_: "rm"
        }
      },
      "'": {
        "*": {
          action_: {
            type_: "insert",
            option: "prime"
          }
        }
      },
      "${(...)}$|$(...)$": {
        "*": {
          action_: "tex-math"
        }
      },
      "{(...)}": {
        "*": {
          action_: "text"
        }
      },
      "\\color{(...)}{(...)}1|\\color(...){(...)}2": {
        "*": {
          action_: "color-output"
        }
      },
      "\\color{(...)}0": {
        "*": {
          action_: "color0-output"
        }
      },
      "\\ce{(...)}": {
        "*": {
          action_: "ce"
        }
      },
      "\\,|\\x{}{}|\\x{}|\\x": {
        "*": {
          action_: "copy"
        }
      },
      else2: {
        "*": {
          action_: "copy"
        }
      }
    }),
    actions: {
      "color-output": function colorOutput(e, t) {
        return {
          type_: "color",
          color1: t[0],
          color2: ei.go(t[1], "bd")
        };
      }
    }
  },
  oxidation: {
    transitions: ei.createTransitions({
      empty: {
        "*": {}
      },
      "roman numeral": {
        "*": {
          action_: "roman-numeral"
        }
      },
      "${(...)}$|$(...)$": {
        "*": {
          action_: "tex-math"
        }
      },
      else: {
        "*": {
          action_: "copy"
        }
      }
    }),
    actions: {
      "roman-numeral": function romanNumeral(e, t) {
        return {
          type_: "roman numeral",
          p1: t || ""
        };
      }
    }
  },
  "tex-math": {
    transitions: ei.createTransitions({
      empty: {
        "*": {
          action_: "output"
        }
      },
      "\\ce{(...)}": {
        "*": {
          action_: ["output", "ce"]
        }
      },
      "{...}|\\,|\\x{}{}|\\x{}|\\x": {
        "*": {
          action_: "o="
        }
      },
      else: {
        "*": {
          action_: "o="
        }
      }
    }),
    actions: {
      output: function output(e) {
        if (e.o) {
          var t = {
            type_: "tex-math",
            p1: e.o
          };
          for (var i in e) delete e[i];
          return t;
        }
      }
    }
  },
  "tex-math tight": {
    transitions: ei.createTransitions({
      empty: {
        "*": {
          action_: "output"
        }
      },
      "\\ce{(...)}": {
        "*": {
          action_: ["output", "ce"]
        }
      },
      "{...}|\\,|\\x{}{}|\\x{}|\\x": {
        "*": {
          action_: "o="
        }
      },
      "-|+": {
        "*": {
          action_: "tight operator"
        }
      },
      else: {
        "*": {
          action_: "o="
        }
      }
    }),
    actions: {
      "tight operator": function tightOperator(e, t) {
        e.o = (e.o || "") + "{" + t + "}";
      },
      output: function output(e) {
        if (e.o) {
          var t = {
            type_: "tex-math",
            p1: e.o
          };
          for (var i in e) delete e[i];
          return t;
        }
      }
    }
  },
  "9,9": {
    transitions: ei.createTransitions({
      empty: {
        "*": {}
      },
      ",": {
        "*": {
          action_: "comma"
        }
      },
      else: {
        "*": {
          action_: "copy"
        }
      }
    }),
    actions: {
      comma: function comma() {
        return {
          type_: "commaDecimal"
        };
      }
    }
  },
  pu: {
    transitions: ei.createTransitions({
      empty: {
        "*": {
          action_: "output"
        }
      },
      space$: {
        "*": {
          action_: ["output", "space"]
        }
      },
      "{[(|)]}": {
        "0|a": {
          action_: "copy"
        }
      },
      "(-)(9)^(-9)": {
        0: {
          action_: "number^",
          nextState: "a"
        }
      },
      "(-)(9.,9)(e)(99)": {
        0: {
          action_: "enumber",
          nextState: "a"
        }
      },
      space: {
        "0|a": {}
      },
      "pm-operator": {
        "0|a": {
          action_: {
            type_: "operator",
            option: "\\pm"
          },
          nextState: "0"
        }
      },
      operator: {
        "0|a": {
          action_: "copy",
          nextState: "0"
        }
      },
      "//": {
        d: {
          action_: "o=",
          nextState: "/"
        }
      },
      "/": {
        d: {
          action_: "o=",
          nextState: "/"
        }
      },
      "{...}|else": {
        "0|d": {
          action_: "d=",
          nextState: "d"
        },
        a: {
          action_: ["space", "d="],
          nextState: "d"
        },
        "/|q": {
          action_: "q=",
          nextState: "q"
        }
      }
    }),
    actions: {
      enumber: function enumber(e, t) {
        var i = [];
        return "+-" === t[0] || "+/-" === t[0] ? i.push("\\pm ") : t[0] && i.push(t[0]), t[1] && (ei.concatArray(i, ei.go(t[1], "pu-9,9")), t[2] && (t[2].match(/[,.]/) ? ei.concatArray(i, ei.go(t[2], "pu-9,9")) : i.push(t[2])), t[3] = t[4] || t[3], t[3] && (t[3] = t[3].trim(), "e" === t[3] || "*" === t[3].substr(0, 1) ? i.push({
          type_: "cdot"
        }) : i.push({
          type_: "times"
        }))), t[3] && i.push("10^{" + t[5] + "}"), i;
      },
      "number^": function number(e, t) {
        var i = [];
        return "+-" === t[0] || "+/-" === t[0] ? i.push("\\pm ") : t[0] && i.push(t[0]), ei.concatArray(i, ei.go(t[1], "pu-9,9")), i.push("^{" + t[2] + "}"), i;
      },
      operator: function operator(e, t, i) {
        return {
          type_: "operator",
          kind_: i || t
        };
      },
      space: function space() {
        return {
          type_: "pu-space-1"
        };
      },
      output: function output(e) {
        var t,
          i = ei.patterns.match_("{(...)}", e.d || "");
        i && "" === i.remainder && (e.d = i.match_);
        var r = ei.patterns.match_("{(...)}", e.q || "");
        if (r && "" === r.remainder && (e.q = r.match_), e.d && (e.d = e.d.replace(/\u00B0C|\^oC|\^{o}C/g, "{}^{\\circ}C"), e.d = e.d.replace(/\u00B0F|\^oF|\^{o}F/g, "{}^{\\circ}F")), e.q) {
          e.q = e.q.replace(/\u00B0C|\^oC|\^{o}C/g, "{}^{\\circ}C"), e.q = e.q.replace(/\u00B0F|\^oF|\^{o}F/g, "{}^{\\circ}F");
          var n = {
            d: ei.go(e.d, "pu"),
            q: ei.go(e.q, "pu")
          };
          "//" === e.o ? t = {
            type_: "pu-frac",
            p1: n.d,
            p2: n.q
          } : (t = n.d, n.d.length > 1 || n.q.length > 1 ? t.push({
            type_: " / "
          }) : t.push({
            type_: "/"
          }), ei.concatArray(t, n.q));
        } else t = ei.go(e.d, "pu-2");
        for (var a in e) delete e[a];
        return t;
      }
    }
  },
  "pu-2": {
    transitions: ei.createTransitions({
      empty: {
        "*": {
          action_: "output"
        }
      },
      "*": {
        "*": {
          action_: ["output", "cdot"],
          nextState: "0"
        }
      },
      "\\x": {
        "*": {
          action_: "rm="
        }
      },
      space: {
        "*": {
          action_: ["output", "space"],
          nextState: "0"
        }
      },
      "^{(...)}|^(-1)": {
        1: {
          action_: "^(-1)"
        }
      },
      "-9.,9": {
        0: {
          action_: "rm=",
          nextState: "0"
        },
        1: {
          action_: "^(-1)",
          nextState: "0"
        }
      },
      "{...}|else": {
        "*": {
          action_: "rm=",
          nextState: "1"
        }
      }
    }),
    actions: {
      cdot: function cdot() {
        return {
          type_: "tight cdot"
        };
      },
      "^(-1)": function _(e, t) {
        e.rm += "^{" + t + "}";
      },
      space: function space() {
        return {
          type_: "pu-space-2"
        };
      },
      output: function output(e) {
        var t = [];
        if (e.rm) {
          var i = ei.patterns.match_("{(...)}", e.rm || "");
          t = i && "" === i.remainder ? ei.go(i.match_, "pu") : {
            type_: "rm",
            p1: e.rm
          };
        }
        for (var r in e) delete e[r];
        return t;
      }
    }
  },
  "pu-9,9": {
    transitions: ei.createTransitions({
      empty: {
        0: {
          action_: "output-0"
        },
        o: {
          action_: "output-o"
        }
      },
      ",": {
        0: {
          action_: ["output-0", "comma"],
          nextState: "o"
        }
      },
      ".": {
        0: {
          action_: ["output-0", "copy"],
          nextState: "o"
        }
      },
      else: {
        "*": {
          action_: "text="
        }
      }
    }),
    actions: {
      comma: function comma() {
        return {
          type_: "commaDecimal"
        };
      },
      "output-0": function output0(e) {
        var t = [];
        if (e.text_ = e.text_ || "", e.text_.length > 4) {
          var i = e.text_.length % 3;
          0 === i && (i = 3);
          for (var r = e.text_.length - 3; r > 0; r -= 3) t.push(e.text_.substr(r, 3)), t.push({
            type_: "1000 separator"
          });
          t.push(e.text_.substr(0, i)), t.reverse();
        } else t.push(e.text_);
        for (var n in e) delete e[n];
        return t;
      },
      "output-o": function outputO(e) {
        var t = [];
        if (e.text_ = e.text_ || "", e.text_.length > 4) {
          for (var i = e.text_.length - 3, r = 0; r < i; r += 3) t.push(e.text_.substr(r, 3)), t.push({
            type_: "1000 separator"
          });
          t.push(e.text_.substr(r));
        } else t.push(e.text_);
        for (var n in e) delete e[n];
        return t;
      }
    }
  }
};
var ti,
  ii,
  ri = {
    go: function go(e, t) {
      if (!e) return "";
      for (var i = "", r = !1, n = 0; n < e.length; n++) {
        var a = e[n];
        "string" == typeof a ? i += a : (i += ri._go2(a), "1st-level escape" === a.type_ && (r = !0));
      }
      return t || r || !i || (i = "{" + i + "}"), i;
    },
    _goInner: function _goInner(e) {
      return e ? ri.go(e, !0) : e;
    },
    _go2: function _go2(e) {
      var t;
      switch (e.type_) {
        case "chemfive":
          t = "";
          var i = {
            a: ri._goInner(e.a),
            b: ri._goInner(e.b),
            p: ri._goInner(e.p),
            o: ri._goInner(e.o),
            q: ri._goInner(e.q),
            d: ri._goInner(e.d)
          };
          i.a && (i.a.match(/^[+\-]/) && (i.a = "{" + i.a + "}"), t += i.a + "\\,"), (i.b || i.p) && (t += "{\\vphantom{X}}", t += "^{\\hphantom{" + (i.b || "") + "}}_{\\hphantom{" + (i.p || "") + "}}", t += "{\\vphantom{X}}", t += "^{\\smash[t]{\\vphantom{2}}\\mathllap{" + (i.b || "") + "}}", t += "_{\\vphantom{2}\\mathllap{\\smash[t]{" + (i.p || "") + "}}}"), i.o && (i.o.match(/^[+\-]/) && (i.o = "{" + i.o + "}"), t += i.o), "kv" === e.dType ? ((i.d || i.q) && (t += "{\\vphantom{X}}"), i.d && (t += "^{" + i.d + "}"), i.q && (t += "_{\\smash[t]{" + i.q + "}}")) : "oxidation" === e.dType ? (i.d && (t += "{\\vphantom{X}}", t += "^{" + i.d + "}"), i.q && (t += "{\\vphantom{X}}", t += "_{\\smash[t]{" + i.q + "}}")) : (i.q && (t += "{\\vphantom{X}}", t += "_{\\smash[t]{" + i.q + "}}"), i.d && (t += "{\\vphantom{X}}", t += "^{" + i.d + "}"));
          break;
        case "rm":
        case "roman numeral":
          t = "\\mathrm{" + e.p1 + "}";
          break;
        case "text":
          e.p1.match(/[\^_]/) ? (e.p1 = e.p1.replace(" ", "~").replace("-", "\\text{-}"), t = "\\mathrm{" + e.p1 + "}") : t = "\\text{" + e.p1 + "}";
          break;
        case "state of aggregation":
          t = "\\mskip2mu " + ri._goInner(e.p1);
          break;
        case "state of aggregation subscript":
          t = "\\mskip1mu " + ri._goInner(e.p1);
          break;
        case "bond":
          if (!(t = ri._getBond(e.kind_))) throw ["MhchemErrorBond", "mhchem Error. Unknown bond type (" + e.kind_ + ")"];
          break;
        case "frac":
          var r = "\\frac{" + e.p1 + "}{" + e.p2 + "}";
          t = "\\mathchoice{\\textstyle" + r + "}{" + r + "}{" + r + "}{" + r + "}";
          break;
        case "pu-frac":
          var n = "\\frac{" + ri._goInner(e.p1) + "}{" + ri._goInner(e.p2) + "}";
          t = "\\mathchoice{\\textstyle" + n + "}{" + n + "}{" + n + "}{" + n + "}";
          break;
        case "tex-math":
        case "1st-level escape":
          t = e.p1 + " ";
          break;
        case "frac-ce":
          t = "\\frac{" + ri._goInner(e.p1) + "}{" + ri._goInner(e.p2) + "}";
          break;
        case "overset":
          t = "\\overset{" + ri._goInner(e.p1) + "}{" + ri._goInner(e.p2) + "}";
          break;
        case "underset":
          t = "\\underset{" + ri._goInner(e.p1) + "}{" + ri._goInner(e.p2) + "}";
          break;
        case "underbrace":
          t = "\\underbrace{" + ri._goInner(e.p1) + "}_{" + ri._goInner(e.p2) + "}";
          break;
        case "color":
          t = "{\\color{" + e.color1 + "}{" + ri._goInner(e.color2) + "}}";
          break;
        case "color0":
          t = "\\color{" + e.color + "}";
          break;
        case "arrow":
          var a = {
              rd: ri._goInner(e.rd),
              rq: ri._goInner(e.rq)
            },
            o = "\\x" + ri._getArrow(e.r);
          a.rq && (o += "[{" + a.rq + "}]"), t = o += a.rd ? "{" + a.rd + "}" : "{}";
          break;
        case "operator":
          t = ri._getOperator(e.kind_);
          break;
        case "space":
          t = " ";
          break;
        case "entitySkip":
        case "pu-space-1":
          t = "~";
          break;
        case "pu-space-2":
          t = "\\mkern3mu ";
          break;
        case "1000 separator":
          t = "\\mkern2mu ";
          break;
        case "commaDecimal":
          t = "{,}";
          break;
        case "comma enumeration L":
          t = "{" + e.p1 + "}\\mkern6mu ";
          break;
        case "comma enumeration M":
          t = "{" + e.p1 + "}\\mkern3mu ";
          break;
        case "comma enumeration S":
          t = "{" + e.p1 + "}\\mkern1mu ";
          break;
        case "hyphen":
          t = "\\text{-}";
          break;
        case "addition compound":
          t = "\\,{\\cdot}\\,";
          break;
        case "electron dot":
          t = "\\mkern1mu \\bullet\\mkern1mu ";
          break;
        case "KV x":
          t = "{\\times}";
          break;
        case "prime":
          t = "\\prime ";
          break;
        case "cdot":
          t = "\\cdot ";
          break;
        case "tight cdot":
          t = "\\mkern1mu{\\cdot}\\mkern1mu ";
          break;
        case "times":
          t = "\\times ";
          break;
        case "circa":
          t = "{\\sim}";
          break;
        case "^":
          t = "uparrow";
          break;
        case "v":
          t = "downarrow";
          break;
        case "ellipsis":
          t = "\\ldots ";
          break;
        case "/":
          t = "/";
          break;
        case " / ":
          t = "\\,/\\,";
          break;
        default:
          throw ["MhchemBugT", "mhchem bug T. Please report."];
      }
      return t;
    },
    _getArrow: function _getArrow(e) {
      switch (e) {
        case "->":
        case "\u2192":
        case "\u27F6":
          return "rightarrow";
        case "<-":
          return "leftarrow";
        case "<->":
          return "leftrightarrow";
        case "<--\x3e":
          return "rightleftarrows";
        case "<=>":
        case "\u21CC":
          return "rightleftharpoons";
        case "<=>>":
          return "rightequilibrium";
        case "<<=>":
          return "leftequilibrium";
        default:
          throw ["MhchemBugT", "mhchem bug T. Please report."];
      }
    },
    _getBond: function _getBond(e) {
      switch (e) {
        case "-":
        case "1":
          return "{-}";
        case "=":
        case "2":
          return "{=}";
        case "#":
        case "3":
          return "{\\equiv}";
        case "~":
          return "{\\tripledash}";
        case "~-":
          return "{\\mathrlap{\\raisebox{-.1em}{$-$}}\\raisebox{.1em}{$\\tripledash$}}";
        case "~=":
        case "~--":
          return "{\\mathrlap{\\raisebox{-.2em}{$-$}}\\mathrlap{\\raisebox{.2em}{$\\tripledash$}}-}";
        case "-~-":
          return "{\\mathrlap{\\raisebox{-.2em}{$-$}}\\mathrlap{\\raisebox{.2em}{$-$}}\\tripledash}";
        case "...":
          return "{{\\cdot}{\\cdot}{\\cdot}}";
        case "....":
          return "{{\\cdot}{\\cdot}{\\cdot}{\\cdot}}";
        case "->":
          return "{\\rightarrow}";
        case "<-":
          return "{\\leftarrow}";
        case "<":
          return "{<}";
        case ">":
          return "{>}";
        default:
          throw ["MhchemBugT", "mhchem bug T. Please report."];
      }
    },
    _getOperator: function _getOperator(e) {
      switch (e) {
        case "+":
          return " {}+{} ";
        case "-":
          return " {}-{} ";
        case "=":
          return " {}={} ";
        case "<":
          return " {}<{} ";
        case ">":
          return " {}>{} ";
        case "<<":
          return " {}\\ll{} ";
        case ">>":
          return " {}\\gg{} ";
        case "\\pm":
          return " {}\\pm{} ";
        case "\\approx":
        case "$\\approx$":
          return " {}\\approx{} ";
        case "v":
        case "(v)":
          return " \\downarrow{} ";
        case "^":
        case "(^)":
          return " \\uparrow{} ";
        default:
          throw ["MhchemBugT", "mhchem bug T. Please report."];
      }
    }
  };
function ni(e) {
  var t = "";
  try {
    t = new URL(e, ai).toString();
  } catch (e) {}
  return t;
}
Ke("0123456789/@.?!"), Fe(65, 90), Fe(97, 122), Ke([["\\forall", 8704], ["\\exists", 8707], ["\\nexists", 8708, "mord", "ams"], ["\\mid", 8739, "mrel"], ["\\top", 8868], ["\\bot", 8869]]), Ke([["\\sharp", 9839], ["\\flat", 9837], ["\\natural", 9838], ["\\#", 35], ["\\&", 38], ["\\clubsuit", 9827], ["\\heartsuit", 9825], ["\\spadesuit", 9824], ["\\diamondsuit", 9826]]), Ke([["\\backslash", 92], ["\\nabla", 8711], ["\\partial", 8706], ["\\ell", 8467], ["\\hbar", 8463], ["\\Q", 81, "mord", "double-struck"], ["\\C", 67, "mord", "double-struck"], ["\\P", 80, "mord", "double-struck"], ["\\pounds", 163], ["\\euro", 8364]]), Ke([["\\rightarrow", 8594], ["\\to", 8594], ["\\leftarrow", 8592], ["\\gets", 8592], ["\\Rightarrow", 8658], ["\\Leftarrow", 8656], ["\\longrightarrow", 10230], ["\\longleftarrow", 10229], ["\\Longrightarrow", 10233], ["\\implies", 10233], ["\\Longleftarrow", 10232], ["\\impliedby", 10232], ["\\longleftrightarrow", 10231], ["\\biconditional", 10231], ["\\Longleftrightarrow", 10234], ["\\mapsto", 8614], ["\\longmapsto", 10236], ["\\uparrow", 8593], ["\\downarrow", 8595], ["\\Uparrow", 8657], ["\\Downarrow", 8659], ["\\updownarrow", 8597], ["\\Updownarrow", 8661], ["\\hookrightarrow", 8618], ["\\hookleftarrow", 8617], ["\\rightharpoonup", 8640], ["\\leftharpoonup", 8636], ["\\rightharpoondown", 8641], ["\\leftharpoondown", 8637], ["\\searrow", 8600], ["\\nearrow", 8599], ["\\swarrow", 8601], ["\\nwarrow", 8598], ["\\originalof", 8886], ["\\laplace", 8886], ["\\imageof", 8887], ["\\Laplace", 8887]], "mrel"), Ke([["\\lbrace", 123, "mopen"], ["\\rbrace", 125, "mclose"], ["\\lparen", 40, "mopen"], ["\\rparen", 41, "mclose"], ["\\langle", 10216, "mopen"], ["\\rangle", 10217, "mclose"], ["\\lfloor", 8970, "mopen"], ["\\rfloor", 8971, "mclose"], ["\\lceil", 8968, "mopen"], ["\\rceil", 8969, "mclose"], ["\\vert", 8739], ["\\lvert", 8739, "mopen"], ["\\rvert", 8739, "mclose"], ["\\|", 8741], ["\\Vert", 8741], ["\\mVert", 8741], ["\\lVert", 8741, "mopen"], ["\\rVert", 8741, "mclose"], ["\\lbrack", 91, "mopen"], ["\\rbrack", 93, "mclose"], ["\\{", 123, "mopen"], ["\\}", 125, "mclose"], ["(", 40, "mopen"], [")", 41, "mclose"], ["[", 91, "mopen"], ["]", 93, "mclose"], ["\\ulcorner", 9484, "mopen", "ams"], ["\\urcorner", 9488, "mclose", "ams"], ["\\llcorner", 9492, "mopen", "ams"], ["\\lrcorner", 9496, "mclose", "ams"], ["\\lgroup", 10222, "mopen"], ["\\rgroup", 10223, "mclose"], ["\\lmoustache", 9136, "mopen"], ["\\rmoustache", 9137, "mclose"]]), Ke([["\\dashrightarrow", 8674], ["\\dashleftarrow", 8672], ["\\Rrightarrow", 8667], ["\\Lleftarrow", 8666], ["\\leftrightarrows", 8646], ["\\rightleftarrows", 8644], ["\\curvearrowright", 8631], ["\\curvearrowleft", 8630], ["\\rightrightarrows", 8649], ["\\leftleftarrows", 8647], ["\\upuparrows", 8648], ["\\downdownarrows", 8650], ["\\vartriangle", 9651], ["\\triangleq", 8796], ["\\vartriangleleft", 8882], ["\\trianglelefteq", 8884], ["\\ntriangleleft", 8938], ["\\ntrianglelefteq", 8940], ["\\vartriangleright", 8883], ["\\trianglerighteq", 8885], ["\\ntriangleright", 8939], ["\\ntrianglerighteq", 8941], ["\\blacktriangleleft", 9664], ["\\blacktriangleright", 9654], ["\\leftarrowtail", 8610], ["\\rightarrowtail", 8611], ["\\looparrowright", 8620], ["\\looparrowleft", 8619], ["\\twoheadleftarrow", 8606], ["\\twoheadrightarrow", 8608], ["\\rightleftharpoons", 8652], ["\\leftrightharpoons", 8651], ["\\Rsh", 8625], ["\\Lsh", 8624], ["\\circlearrowright", 8635], ["\\circlearrowleft", 8634], ["\\restriction", 8638], ["\\upharpoonright", 8638], ["\\upharpoonleft", 8639], ["\\downharpoonright", 8642], ["\\downharpoonleft", 8643], ["\\rightsquigarrow", 8669], ["\\leadsto", 8669], ["\\leftrightsquigarrow", 8621], ["\\multimap", 8888], ["\\nrightarrow", 8603], ["\\nleftarrow", 8602], ["\\nRightarrow", 8655], ["\\nLeftarrow", 8653], ["\\nleftrightarrow", 8622], ["\\nLeftrightarrow", 8654], ["\\shortparallel", 8741], ["\\nless", 8814], ["\\nleqslant", 57360], ["\\lneq", 10887], ["\\lneqq", 8808], ["\\nleqq", 57361], ["\\lvertneqq", 57356], ["\\lnsim", 8934], ["\\lnapprox", 10889], ["\\nprec", 8832], ["\\npreceq", 8928], ["\\precnsim", 8936], ["\\precnapprox", 10937], ["\\nsim", 8769], ["\\nshortmid", 57350], ["\\nmid", 8740], ["\\nvdash", 8876], ["\\nvDash", 8877], ["\\ngtr", 8815], ["\\ngeqslant", 57359], ["\\ngeqq", 57358], ["\\gneq", 10888], ["\\gneqq", 8809], ["\\gvertneqq", 57357], ["\\gnsim", 8935], ["\\gnapprox", 10890], ["\\nsucc", 8833], ["\\nsucceq", 8929], ["\\succnsim", 8937], ["\\succnapprox", 10938], ["\\ncong", 8774], ["\\nshortparallel", 57351], ["\\nparallel", 8742], ["\\nVDash", 8879], ["\\nsupseteqq", 57368], ["\\supsetneq", 8843], ["\\varsupsetneq", 57371], ["\\supsetneqq", 10956], ["\\varsupsetneqq", 57369], ["\\nVdash", 8878], ["\\precneqq", 10933], ["\\succneqq", 10934], ["\\nsubseteqq", 57366], ["\\leqslant", 10877], ["\\geqslant", 10878], ["\\gtrsim", 8819], ["\\approxeq", 8778], ["\\thickapprox", 8776], ["\\lessapprox", 10885], ["\\gtrapprox", 10886], ["\\precapprox", 10935], ["\\succapprox", 10936], ["\\thicksim", 8764], ["\\succsim", 8831], ["\\precsim", 8830], ["\\backsim", 8765], ["\\eqsim", 8770], ["\\backsimeq", 8909], ["\\lesssim", 8818], ["\\nleq", 8816], ["\\ngeq", 8817], ["\\smallsmile", 8995], ["\\smallfrown", 8994], ["\\leqq", 8806], ["\\eqslantless", 10901], ["\\lll", 8920], ["\\lessgtr", 8822], ["\\lesseqgtr", 8922], ["\\lesseqqgtr", 10891], ["\\risingdotseq", 8787], ["\\fallingdotseq", 8786], ["\\subseteqq", 10949], ["\\Subset", 8912], ["\\sqsubset", 8847], ["\\preccurlyeq", 8828], ["\\curlyeqprec", 8926], ["\\vDash", 8872], ["\\Vvdash", 8874], ["\\bumpeq", 8783], ["\\Bumpeq", 8782], ["\\geqq", 8807], ["\\eqslantgtr", 10902], ["\\ggg", 8921], ["\\gtrless", 8823], ["\\gtreqless", 8923], ["\\gtreqqless", 10892], ["\\supseteqq", 10950], ["\\Supset", 8913], ["\\sqsupset", 8848], ["\\succcurlyeq", 8829], ["\\curlyeqsucc", 8927], ["\\Vdash", 8873], ["\\shortmid", 8739], ["\\between", 8812], ["\\pitchfork", 8916], ["\\varpropto", 8733], ["\\backepsilon", 8717], ["\\llless", 8920], ["\\gggtr", 8921], ["\\doteqdot", 8785], ["\\Doteq", 8785], ["\\eqcirc", 8790], ["\\circeq", 8791], ["\\therefore", 8756], ["\\because", 8757]], "mrel", "ams"), Ke([["+", 43], ["-", 8722], ["\u2212", 8722], ["\\pm", 177], ["\\mp", 8723], ["*", 8727], ["\\times", 215], ["\\div", 247], ["\\divides", 8739], ["\\cdot", 8901], ["\\cap", 8745], ["\\cup", 8746], ["\\setminus", 8726], ["\\land", 8743], ["\\wedge", 8743], ["\\lor", 8744], ["\\vee", 8744], ["\\circ", 8728], ["\\bigcirc", 9711], ["\\bullet", 8729], ["\\oplus", 8853], ["\\ominus", 8854], ["\\otimes", 8855], ["\\odot", 8857], ["\\oslash", 8856], ["\\bigtriangleup", 9651], ["\\bigtriangledown", 9661], ["\\triangleleft", 9667], ["\\triangleright", 9657], ["\\And", 38], ["\\dagger", 8224], ["\\dag", 8224], ["\\ddag", 8225], ["\\ddagger", 8225], ["\\ast", 8727], ["\\star", 8902], ["\\bigstar", 9733], ["\\diamond", 8900]], "mbin"), Ke([["\\lhd", 8882], ["\\rhd", 8883], ["\\lessdot", 8918], ["\\gtrdot", 8919], ["\\ltimes", 8905], ["\\rtimes", 8906], ["\\leftthreetimes", 8907], ["\\rightthreetimes", 8908], ["\\intercal", 8890], ["\\dotplus", 8724], ["\\doublebarwedge", 10846], ["\\divideontimes", 8903], ["\\centerdot", 8901], ["\\smallsetminus", 8726], ["\\barwedge", 8892], ["\\veebar", 8891], ["\\nor", 8891], ["\\curlywedge", 8911], ["\\curlyvee", 8910], ["\\boxminus", 8863], ["\\boxplus", 8862], ["\\boxtimes", 8864], ["\\boxdot", 8865], ["\\circleddash", 8861], ["\\circledast", 8859], ["\\circledcirc", 8858], ["\\unlhd", 8884], ["\\unrhd", 8885]], "mbin", "ams"), Ke([["\\surd", 8730], ["\\infty", 8734], ["\\prime", 8242], ["\\doubleprime", 8243], ["\\angle", 8736], ["`", 8216], ["\\$", 36], ["\\%", 37], ["\\_", 95], ["\\alpha", 945], ["\\beta", 946], ["\\gamma", 947], ["\\delta", 948], ["\\epsilon", 1013], ["\\varepsilon", 949], ["\\zeta", 950], ["\\eta", 951], ["\\theta", 952], ["\\vartheta", 977], ["\\iota", 953], ["\\kappa", 954], ["\\varkappa", 1008, "mord", "ams"], ["\\lambda", 955], ["\\mu", 956], ["\\nu", 957], ["\\xi", 958], ["\\omicron", 111], ["\\pi", 960], ["\\varpi", 982], ["\\rho", 961], ["\\varrho", 1009], ["\\sigma", 963], ["\\varsigma", 962], ["\\tau", 964], ["\\phi", 981], ["\\varphi", 966], ["\\upsilon", 965], ["\\chi", 967], ["\\psi", 968], ["\\omega", 969], ["\\Gamma", 915], ["\\Delta", 916], ["\\Theta", 920], ["\\Lambda", 923], ["\\Xi", 926], ["\\Pi", 928], ["\\Sigma", 931], ["\\Upsilon", 933], ["\\Phi", 934], ["\\Psi", 936], ["\\Omega", 937], ["\\digamma", 989, "mord", "ams"], ["\\emptyset", 8709]]), Ke([["=", 61], ["<", 60], ["\\lt", 60], [">", 62], ["\\gt", 62], ["\\le", 8804], ["\\leq", 8804], ["\\ge", 8805], ["\\geq", 8805], ["\\ll", 8810], ["\\gg", 8811], ["\\coloneq", 8788], ["\\measeq", 8797], ["\\eqdef", 8798], ["\\questeq", 8799], [":", 58], ["\\cong", 8773], ["\\equiv", 8801], ["\\prec", 8826], ["\\preceq", 10927], ["\\succ", 8827], ["\\succeq", 10928], ["\\perp", 8869], ["\\propto", 8733], ["\\Colon", 8759], ["\\smile", 8995], ["\\frown", 8994], ["\\sim", 8764], ["\\doteq", 8784], ["\\bowtie", 8904], ["\\Join", 8904], ["\\asymp", 8781], ["\\sqsubseteq", 8849], ["\\sqsupseteq", 8850], ["\\approx", 8776], ["\\~", 126], ["\\leftrightarrow", 8596], ["\\Leftrightarrow", 8660], ["\\models", 8872], ["\\vdash", 8866], ["\\dashv", 8867], ["\\roundimplies", 10608], ["\\in", 8712], ["\\notin", 8713], ["\\ni", 8715], ["\\owns", 8715], ["\\subset", 8834], ["\\supset", 8835], ["\\subseteq", 8838], ["\\supseteq", 8839], ["\\differencedelta", 8710], ["\\mvert", 8739], ["\\parallel", 8741], ["\\simeq", 8771]], "mrel"), Ke([["\\lnot", 172], ["\\neg", 172], ["\\triangle", 9651], ["\\subsetneq", 8842], ["\\varsubsetneq", 57370], ["\\subsetneqq", 10955], ["\\varsubsetneqq", 57367], ["\\nsubset", 8836], ["\\nsupset", 8837], ["\\nsubseteq", 8840], ["\\nsupseteq", 8841]], "mrel", "ams"), Ke([["\\wp", 8472], ["\\aleph", 8501]]), Ke([["\\blacktriangle", 9650], ["\\hslash", 8463], ["\\Finv", 8498], ["\\Game", 8513], ["\\eth", 240], ["\\mho", 8487], ["\\Bbbk", 107], ["\\yen", 165], ["\\square", 9633], ["\\Box", 9633], ["\\blacksquare", 9632], ["\\circledS", 9416], ["\\circledR", 174], ["\\triangledown", 9661], ["\\blacktriangledown", 9660], ["\\checkmark", 10003], ["\\diagup", 9585], ["\\measuredangle", 8737], ["\\sphericalangle", 8738], ["\\backprime", 8245], ["\\backdoubleprime", 8246], ["\\Diamond", 9674], ["\\lozenge", 9674], ["\\blacklozenge", 10731], ["\\varnothing", 8709], ["\\complement", 8705], ["\\maltese", 10016], ["\\beth", 8502], ["\\daleth", 8504], ["\\gimel", 8503]], "mord", "ams"), Ke([["\\ ", 160], ["~", 160], ["\\space", 160]], "space"), Ze(["!", ",", ":", ";", "enskip", "enspace", "quad", "qquad"], "", {
  createAtom: function createAtom(e, t, i) {
    return new st(e, i);
  }
}), Ke([["\\colon", 58], ["\\cdotp", 8901], ["\\vdots", 8942, "mord"], ["\\ldotp", 46], [",", 44], [";", 59]], "mpunct"), Ke([["\\cdots", 8943], ["\\ddots", 8945], ["\\ldots", 8230], ["\\mathellipsis", 8230]], "minner"), Ke([["\\/", 47], ["|", 8739, "mord"], ["\\imath", 305], ["\\jmath", 567], ["\\degree", 176], ["'", 8242], ['"', 8221]]);
var ai = (null === (ii = null === (ti = null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) || void 0 === ti ? void 0 : ti.currentScript) || void 0 === ii ? void 0 : ii.src) || function () {
  var e = String(new Error().stack).replace(/^Error.*\n/, "").split("\n");
  if (0 === e.length) return "";
  var t = e[1],
    i = t.match(/http.*\.ts[\?:]/);
  return i && (t = e[2]), i = t.match(/(http.*(\.mjs|\.js))[\?:]/), i || (i = t.match(/at (.*(\.ts))[\?:]/), i || (i = t.match(/at (.*(\.mjs|\.js))[\?:]/))), i ? i[1] : "";
}();
function oi(_x2, _x3) {
  return _oi.apply(this, arguments);
}
function _oi() {
  _oi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e, t) {
    var i, _i216, _r89, _n83, _a41;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(ke() && !document.body.classList.contains("ML__fonts-loading") && (null === (i = getComputedStyle(document.documentElement).getPropertyValue("--ML__static-fonts")) || void 0 === i || !i) && "fonts" in document)) {
            _context.next = 21;
            break;
          }
          _i216 = ["KaTeX_Main", "KaTeX_Math", "KaTeX_AMS", "KaTeX_Caligraphic", "KaTeX_Fraktur", "KaTeX_SansSerif", "KaTeX_Script", "KaTeX_Size1", "KaTeX_Size2", "KaTeX_Size3", "KaTeX_Size4"];
          _r89 = !1;
          if (ke() && !/firefox|safari/i.test(navigator.userAgent)) try {
            _r89 = _i216.every(function (e) {
              return document.fonts.check("16px " + e);
            });
          } catch (_unused2) {
            _r89 = !1;
          }
          if (!_r89) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return");
        case 6:
          _n83 = ni(null != e ? e : "./fonts");
          if (_n83) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return");
        case 9:
          document.body.classList.add("ML__fonts-loading");
          _a41 = [["KaTeX_Main-Regular"], ["KaTeX_Main-BoldItalic", {
            style: "italic",
            weight: "bold"
          }], ["KaTeX_Main-Bold", {
            weight: "bold"
          }], ["KaTeX_Main-Italic", {
            style: "italic"
          }], ["KaTeX_Math-Italic", {
            style: "italic"
          }], ["KaTeX_Math-BoldItalic", {
            style: "italic",
            weight: "bold"
          }], ["KaTeX_AMS-Regular"], ["KaTeX_Caligraphic-Regular"], ["KaTeX_Caligraphic-Bold", {
            weight: "bold"
          }], ["KaTeX_Fraktur-Regular"], ["KaTeX_Fraktur-Bold", {
            weight: "bold"
          }], ["KaTeX_SansSerif-Regular", {
            style: "italic"
          }], ["KaTeX_SansSerif-Bold", {
            weight: "bold"
          }], ["KaTeX_SansSerif-Italic", {
            style: "italic"
          }], ["KaTeX_Script-Regular"], ["KaTeX_Typewriter-Regular"], ["KaTeX_Size1-Regular"], ["KaTeX_Size2-Regular"], ["KaTeX_Size3-Regular"], ["KaTeX_Size4-Regular"]].map(function (e) {
            return function (e, t) {
              var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              return new FontFace(e, "url(".concat(t, ".woff2) format('woff2')"), i);
            }(e[0].replace(/-[a-zA-Z]+$/, ""), _n83 + "/" + e[0], e[1]);
          });
          _context.prev = 11;
          _context.next = 14;
          return Promise.all(_a41.map(function (e) {
            try {
              return e.load();
            } catch (_unused3) {}
          }));
        case 14:
          _context.sent.forEach(function (e) {
            return document.fonts.add(e);
          });
          _context.next = 20;
          break;
        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](11);
          "function" == typeof t && t({
            code: "font-not-found",
            arg: _context.t0
          });
        case 20:
          document.body.classList.remove("ML__fonts-loading");
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[11, 17]]);
  }));
  return _oi.apply(this, arguments);
}
function si(e, t, i) {
  var r, n;
  if (we(), !t) return null;
  var a = null !== (r = null == e ? void 0 : e.getRootNode()) && void 0 !== r ? r : null === document || void 0 === document ? void 0 : document.head;
  if (!a) return null;
  a === document && (a = document.head);
  var o = a.querySelector("style[data-id=\"".concat(i, "\"]"));
  if (o) {
    var _e82 = Number.parseFloat(null !== (n = o.getAttribute("data-refcount")) && void 0 !== n ? n : "0");
    o.dataset.refcount = Number(_e82 + 1).toString();
  } else {
    var _e83 = document.createElement("style");
    _e83.dataset.id = i, _e83.dataset.refcount = "1", _e83.append(document.createTextNode(t)), a.appendChild(_e83);
  }
  return {
    release: function release() {
      var e;
      var t = document.head.querySelector("style[data-id=\"".concat(i, "\"]"));
      if (t) {
        var _i60 = Number.parseFloat(null !== (e = t.getAttribute("data-refcount")) && void 0 !== e ? e : "0");
        1 === _i60 ? t.remove() : t.dataset.refcount = Number(_i60 - 1).toString();
      }
    }
  };
}
var li = '.ML__sr-only{clip:rect(0,0,0,0);border:0;height:1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.ML__base,.ML__isInline{display:inline-block}.ML__base{border:0;box-sizing:content-box;cursor:text;font-family:inherit;font-style:inherit;font-weight:inherit;margin:0;outline:0;padding:0;position:relative;text-decoration:none;vertical-align:baseline;visibility:inherit;width:100%}body.ML__fonts-loading .ML__base{visibility:hidden}.ML__strut,.ML__strut--bottom{display:inline-block;min-height:.5em}.ML__small-delim{font-family:KaTeX_Main}.ML__text{font-family:var(--text-font-family,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);white-space:pre}.ML__cmr{font-family:KaTeX_Main;font-style:normal}.ML__mathit{font-family:KaTeX_Math;font-style:italic}.ML__mathbf{font-family:KaTeX_Main;font-weight:700}.lcGreek.ML__mathbf{font-family:KaTeX_Math;font-weight:400}.ML__mathbfit{font-family:KaTeX_Math;font-style:italic;font-weight:700}.ML__ams,.ML__bb{font-family:KaTeX_AMS}.ML__cal{font-family:KaTeX_Caligraphic}.ML__frak{font-family:KaTeX_Fraktur}.ML__tt{font-family:KaTeX_Typewriter}.ML__script{font-family:KaTeX_Script}.ML__sans{font-family:KaTeX_SansSerif}.ML__series_el,.ML__series_ul{font-weight:100}.ML__series_l{font-weight:200}.ML__series_sl{font-weight:300}.ML__series_sb{font-weight:500}.ML__bold,.ML__boldsymbol{font-weight:700}.ML__series_eb{font-weight:800}.ML__series_ub{font-weight:900}.ML__series_uc{font-stretch:ultra-condensed}.ML__series_ec{font-stretch:extra-condensed}.ML__series_c{font-stretch:condensed}.ML__series_sc{font-stretch:semi-condensed}.ML__series_sx{font-stretch:semi-expanded}.ML__series_x{font-stretch:expanded}.ML__series_ex{font-stretch:extra-expanded}.ML__series_ux{font-stretch:ultra-expanded}.ML__it{font-style:italic}.ML__shape_ol{-webkit-text-stroke:1px #000;text-stroke:1px #000;color:transparent}.ML__shape_sc{font-variant:small-caps}.ML__shape_sl{font-style:oblique}.ML__emph{color:#bc2612}.ML__emph .ML__emph{color:#0c7f99}.ML__highlight{background:#edd1b0;color:#007cb2}.ML__center{text-align:center}.ML__frac-line{min-height:1px;width:100%}.ML__frac-line:after{background:currentColor;box-sizing:content-box;content:"";display:block;margin-top:-.04em;min-height:.04em;transform:translate(0)}.ML__sqrt,.ML__sqrt-sign{display:inline-block}.ML__sqrt-sign{font-family:KaTeX_Main;position:relative}.ML__sqrt-line{display:inline-block;height:.04em;width:100%}.ML__sqrt-line:before{background:currentColor;content:"";display:block;margin-top:-.04em;min-height:.04em}.ML__sqrt-line:after{border-bottom-width:1px;content:" ";display:block;margin-top:-.1em;transform:translate(0)}.ML__sqrt-index{margin-left:.27777778em;margin-right:-.55555556em}.ML__delim-size1{font-family:KaTeX_Size1}.ML__delim-size2{font-family:KaTeX_Size2}.ML__delim-size3{font-family:KaTeX_Size3}.ML__delim-size4{font-family:KaTeX_Size4}.ML__delim-mult .delim-size1>span{font-family:KaTeX_Size1}.ML__delim-mult .delim-size4>span{font-family:KaTeX_Size4}.ML__accent-body>span{font-family:KaTeX_Main;width:0}.ML__accent-vec>span{left:.38em;position:relative}.ML__mathlive{text-rendering:auto;word-wrap:normal;direction:ltr;display:inline-block;font-family:KaTeX_Main;font-size-adjust:none;font-stretch:normal;font-style:normal;font-variant-caps:normal;letter-spacing:normal;text-align:left;text-indent:0;text-shadow:none;transform:translateZ(0);-webkit-user-select:none;user-select:none;white-space:normal;width:100;word-spacing:normal}.ML__mathlive .style-wrap{position:relative}.ML__mathlive .left-right,.ML__mathlive .mfrac{display:inline-block}.ML__mathlive .vlist-t{border-collapse:collapse;display:inline-table;table-layout:fixed}.ML__mathlive .vlist-r{display:table-row}.ML__mathlive .vlist{display:table-cell;position:relative;vertical-align:bottom}.ML__mathlive .vlist>span{display:block;height:0;position:relative}.ML__mathlive .vlist>span>span{display:inline-block}.ML__mathlive .vlist>span>.pstrut{overflow:hidden;width:0}.ML__mathlive .vlist-t2{margin-right:-2px}.ML__mathlive .vlist-s{display:table-cell;font-size:1px;min-width:2px;vertical-align:bottom;width:2px}.ML__mathlive .msubsup{text-align:left}.ML__mathlive .negativethinspace{display:inline-block;margin-left:-.16667em}.ML__mathlive .thinspace{display:inline-block;width:.16667em}.ML__mathlive .mediumspace{display:inline-block;width:.22222em}.ML__mathlive .thickspace{display:inline-block;width:.27778em}.ML__mathlive .enspace{display:inline-block;width:.5em}.ML__mathlive .quad{display:inline-block;width:1em}.ML__mathlive .qquad{display:inline-block;width:2em}.ML__mathlive .llap,.ML__mathlive .rlap{display:inline-block;position:relative;width:0}.ML__mathlive .llap>.inner,.ML__mathlive .rlap>.inner{position:absolute}.ML__mathlive .llap>.fix,.ML__mathlive .rlap>.fix{display:inline-block}.ML__mathlive .llap>.inner{right:0}.ML__mathlive .rlap>.inner{left:0}.ML__mathlive .rule{border:0 solid;box-sizing:border-box;display:inline-block;position:relative}.ML__mathlive .overline .overline-line,.ML__mathlive .underline .underline-line{width:100%}.ML__mathlive .overline .overline-line:before,.ML__mathlive .underline .underline-line:before{border-bottom-style:solid;border-bottom-width:.04em;content:"";display:block}.ML__mathlive .overline .overline-line:after,.ML__mathlive .underline .underline-line:after{border-bottom-style:solid;border-bottom-width:.04em;content:"";display:block;margin-top:-1px;min-height:thin}.ML__mathlive .stretchy{display:block;left:0;overflow:hidden;position:absolute;width:100%}.ML__mathlive .stretchy:after,.ML__mathlive .stretchy:before{content:""}.ML__mathlive .stretchy svg{fill:currentColor;stroke:currentColor;fill-rule:nonzero;fill-opacity:1;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;display:block;height:inherit;position:absolute;width:100%}.ML__mathlive .slice-1-of-2{left:0}.ML__mathlive .slice-1-of-2,.ML__mathlive .slice-2-of-2{display:inline-flex;overflow:hidden;position:absolute;width:50.2%}.ML__mathlive .slice-2-of-2{right:0}.ML__mathlive .slice-1-of-3{display:inline-flex;left:0;overflow:hidden;position:absolute;width:25.1%}.ML__mathlive .slice-2-of-3{display:inline-flex;left:25%;overflow:hidden;position:absolute;width:50%}.ML__mathlive .slice-3-of-3{display:inline-flex;overflow:hidden;position:absolute;right:0;width:25.1%}.ML__mathlive .slice-1-of-1{display:inline-flex;left:0;overflow:hidden;position:absolute;width:100%}.ML__mathlive .nulldelimiter{display:inline-block;width:.12em}.ML__mathlive .op-group{display:inline-block}.ML__mathlive .op-symbol{position:relative}.ML__mathlive .op-symbol.small-op{font-family:KaTeX_Size1}.ML__mathlive .op-symbol.large-op{font-family:KaTeX_Size2}.ML__mathlive .accent>.vlist>span{text-align:center}.ML__mathlive .mtable .vertical-separator{box-sizing:border-box;display:inline-block;min-width:1px}.ML__mathlive .mtable .arraycolsep{display:inline-block}.ML__mathlive .mtable .col-align-m>.vlist-t{text-align:center}.ML__mathlive .mtable .col-align-c>.vlist-t{text-align:center}.ML__mathlive .mtable .col-align-l>.vlist-t{text-align:left}.ML__mathlive .mtable .col-align-r>.vlist-t{text-align:left}.ML__error{background-image:radial-gradient(ellipse at center,#cc0041,transparent 70%);background-position:0 98%;background-repeat:repeat-x;background-size:3px 3px}.ML__composition{background:#fff1c2;color:#000;-webkit-text-decoration:underline var(--caret,hsl(var(--hue,212),40%,49%));text-decoration:underline var(--caret,hsl(var(--hue,212),40%,49%))}@media (prefers-color-scheme:dark){.ML__composition{background:#69571c;color:#fff}}.ML__placeholder{color:var(--caret,hsl(var(--hue,212),40%,49%));font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;padding-left:.4ex;padding-right:.4ex}.ML__placeholdercontainer{display:none}.ML__isReadOnly .ML__placeholdercontainer{display:block}';
function ci(e, t, i) {
  return i ? function (e, t) {
    if (!t) return "";
    if ("string" == typeof t) return t;
    if (!e) return t.value;
    var i = !1,
      r = !1,
      n = !1,
      a = !1,
      o = !1,
      s = !1,
      l = !1,
      c = !1,
      u = !1,
      d = !1,
      h = !1,
      p = !1,
      m = !1,
      f = !1,
      g = !1,
      y = e[e.length - 1],
      b = e.length - 1;
    for (; y && /msubsup|placeholder/.test(y.type);) b -= 1, y = e[b];
    if (i = !y || "first" === y.type, y) {
      if (void 0 !== t.mode && y.mode !== t.mode) return "";
      f = "text" === y.mode, r = !f && "mord" === y.type && Te.test(y.value), n = !f && "mord" === y.type && /\d+$/.test(y.value), a = !f && y.isFunction, o = "genfrac" === y.type, s = "surd" === y.type, l = "mbin" === y.type, c = "mrel" === y.type, u = "mop" === y.type, d = "mpunct" === y.type || "minner" === y.type, h = "array" === y.type, p = "mopen" === y.type, m = "mclose" === y.type || "leftright" === y.type, g = "space" === y.type;
    }
    return void 0 !== t.after ? t.after.includes("nothing") && i || t.after.includes("letter") && r || t.after.includes("digit") && n || t.after.includes("function") && a || t.after.includes("frac") && o || t.after.includes("surd") && s || t.after.includes("binop") && l || t.after.includes("relop") && c || t.after.includes("operator") && u || t.after.includes("punct") && d || t.after.includes("array") && h || t.after.includes("openfence") && p || t.after.includes("closefence") && m || t.after.includes("text") && f || t.after.includes("space") && g ? t.value : "" : t.value;
  }(e, i[t]) : "";
}
var ui = {
  "%": "\\%",
  "''": {
    mode: "math",
    value: "^{\\doubleprime}"
  },
  alpha: "\\alpha",
  delta: "\\delta",
  Delta: "\\Delta",
  pi: {
    mode: "math",
    value: "\\pi"
  },
  "pi ": {
    mode: "text",
    value: "\\pi "
  },
  Pi: {
    mode: "math",
    value: "\\Pi"
  },
  theta: "\\theta",
  Theta: "\\Theta",
  ii: {
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\imaginaryI"
  },
  jj: {
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\imaginaryJ"
  },
  ee: {
    mode: "math",
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\exponentialE"
  },
  nabla: {
    mode: "math",
    value: "\\nabla"
  },
  grad: {
    mode: "math",
    value: "\\nabla"
  },
  del: {
    mode: "math",
    value: "\\partial"
  },
  infty: {
    mode: "math",
    value: "\\infty"
  },
  "\u221E": "\\infty",
  oo: {
    mode: "math",
    after: "nothing+digit+frac+surd+binop+relop+punct+array+openfence+closefence+space",
    value: "\\infty"
  },
  "\u2211": {
    mode: "math",
    value: "\\sum"
  },
  sum: {
    mode: "math",
    value: "\\sum_{#?}^{#?}"
  },
  int: {
    mode: "math",
    value: "\\int_{#?}^{#?}"
  },
  prod: {
    mode: "math",
    value: "\\prod_{#?}^{#?}"
  },
  sqrt: {
    mode: "math",
    value: "\\sqrt{#?}"
  },
  "\u2206": {
    mode: "math",
    value: "\\differentialD"
  },
  "\u2202": {
    mode: "math",
    value: "\\differentialD"
  },
  arcsin: {
    mode: "math",
    value: "\\arcsin"
  },
  arccos: {
    mode: "math",
    value: "\\arccos"
  },
  arctan: {
    mode: "math",
    value: "\\arctan"
  },
  sin: {
    mode: "math",
    value: "\\sin"
  },
  sinh: {
    mode: "math",
    value: "\\sinh"
  },
  cos: {
    mode: "math",
    value: "\\cos"
  },
  cosh: {
    mode: "math",
    value: "\\cosh"
  },
  tan: {
    mode: "math",
    value: "\\tan"
  },
  tanh: {
    mode: "math",
    value: "\\tanh"
  },
  sec: {
    mode: "math",
    value: "\\sec"
  },
  csc: {
    mode: "math",
    value: "\\csc"
  },
  cot: {
    mode: "math",
    value: "\\cot"
  },
  log: {
    mode: "math",
    value: "\\log"
  },
  ln: {
    mode: "math",
    value: "\\ln"
  },
  exp: {
    mode: "math",
    value: "\\exp"
  },
  lim: {
    mode: "math",
    value: "\\lim_{#?}"
  },
  dx: {
    mode: "math",
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\differentialD x"
  },
  dy: {
    mode: "math",
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\differentialD y"
  },
  dt: {
    mode: "math",
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\differentialD t"
  },
  AA: {
    mode: "math",
    value: "\\forall"
  },
  EE: {
    mode: "math",
    value: "\\exists"
  },
  "!EE": {
    mode: "math",
    value: "\\nexists"
  },
  "&&": {
    mode: "math",
    value: "\\land"
  },
  xin: {
    mode: "math",
    after: "nothing+text+relop+punct+openfence+space",
    value: "x \\in"
  },
  in: {
    mode: "math",
    after: "nothing+letter+closefence",
    value: "\\in"
  },
  "!in": {
    mode: "math",
    value: "\\notin"
  },
  NN: "\\N",
  ZZ: "\\Z",
  QQ: "\\Q",
  RR: "\\R",
  CC: "\\C",
  PP: "\\P",
  xx: {
    mode: "math",
    value: "\\times"
  },
  "+-": {
    mode: "math",
    value: "\\pm"
  },
  "!=": {
    mode: "math",
    value: "\\ne"
  },
  ">=": {
    mode: "math",
    value: "\\ge"
  },
  "<=": {
    mode: "math",
    value: "\\le"
  },
  "<<": {
    mode: "math",
    value: "\\ll"
  },
  ">>": {
    mode: "math",
    value: "\\gg"
  },
  "~~": {
    mode: "math",
    value: "\\approx"
  },
  "\u2248": {
    mode: "math",
    value: "\\approx"
  },
  "?=": {
    mode: "math",
    value: "\\questeq"
  },
  "\xf7": {
    mode: "math",
    value: "\\div"
  },
  "\xac": {
    mode: "math",
    value: "\\neg"
  },
  ":=": {
    mode: "math",
    value: "\\coloneq"
  },
  "::": {
    mode: "math",
    value: "\\Colon"
  },
  "(:": {
    mode: "math",
    value: "\\langle"
  },
  ":)": {
    mode: "math",
    value: "\\rangle"
  },
  beta: "\\beta",
  chi: "\\chi",
  epsilon: "\\epsilon",
  varepsilon: "\\varepsilon",
  eta: {
    mode: "math",
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\eta"
  },
  "eta ": {
    mode: "text",
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\eta "
  },
  gamma: "\\gamma",
  Gamma: "\\Gamma",
  iota: "\\iota",
  kappa: "\\kappa",
  lambda: "\\lambda",
  Lambda: "\\Lambda",
  mu: {
    mode: "math",
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\mu"
  },
  "mu ": {
    mode: "text",
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\mu "
  },
  nu: {
    mode: "math",
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\nu"
  },
  "nu ": {
    mode: "text",
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\nu "
  },
  "\xb5": "\\mu",
  phi: {
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\phi"
  },
  Phi: {
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\Phi"
  },
  varphi: "\\varphi",
  psi: {
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\psi"
  },
  Psi: {
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\Psi"
  },
  rho: {
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\rho"
  },
  sigma: "\\sigma",
  Sigma: "\\Sigma",
  tau: {
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\tau"
  },
  vartheta: "\\vartheta",
  upsilon: "\\upsilon",
  xi: {
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\xi"
  },
  Xi: {
    after: "nothing+digit+function+frac+surd+binop+relop+punct+array+openfence+closefence+space+text",
    value: "\\Xi"
  },
  zeta: "\\zeta",
  omega: "\\omega",
  Omega: "\\Omega",
  "\u03A9": "\\omega",
  forall: {
    mode: "math",
    value: "\\forall"
  },
  exists: {
    mode: "math",
    value: "\\exists"
  },
  "!exists": {
    mode: "math",
    value: "\\nexists"
  },
  ":.": {
    mode: "math",
    value: "\\therefore"
  },
  liminf: "\\operatorname*{lim~inf}_{#?}",
  limsup: "\\operatorname*{lim~sup}_{#?}",
  argmin: "\\operatorname*{arg~min}_{#?}",
  argmax: "\\operatorname*{arg~max}_{#?}",
  det: "\\det",
  mod: {
    mode: "math",
    value: "\\mod"
  },
  max: {
    mode: "math",
    value: "\\max"
  },
  min: {
    mode: "math",
    value: "\\min"
  },
  erf: "\\operatorname{erf}",
  erfc: "\\operatorname{erfc}",
  bessel: {
    mode: "math",
    value: "\\operatorname{bessel}"
  },
  mean: {
    mode: "math",
    value: "\\operatorname{mean}"
  },
  median: {
    mode: "math",
    value: "\\operatorname{median}"
  },
  fft: {
    mode: "math",
    value: "\\operatorname{fft}"
  },
  lcm: {
    mode: "math",
    value: "\\operatorname{lcm}"
  },
  gcd: {
    mode: "math",
    value: "\\operatorname{gcd}"
  },
  randomReal: "\\operatorname{randomReal}",
  randomInteger: "\\operatorname{randomInteger}",
  Re: {
    mode: "math",
    value: "\\operatorname{Re}"
  },
  Im: {
    mode: "math",
    value: "\\operatorname{Im}"
  },
  mm: {
    mode: "math",
    after: "nothing+digit+operator",
    value: "\\operatorname{mm}"
  },
  cm: {
    mode: "math",
    after: "nothing+digit+operator",
    value: "\\operatorname{cm}"
  },
  km: {
    mode: "math",
    after: "nothing+digit+operator",
    value: "\\operatorname{km}"
  },
  kg: {
    mode: "math",
    after: "nothing+digit+operator",
    value: "\\operatorname{kg}"
  },
  "...": "\\ldots",
  "+...": "+\\cdots",
  "-...": "-\\cdots",
  "->...": "\\to\\cdots",
  "->": "\\to",
  "|->": "\\mapsto",
  "--\x3e": "\\longrightarrow",
  "<--": "\\longleftarrow",
  "=>": "\\Rightarrow",
  "==>": "\\Longrightarrow",
  "<=>": "\\Leftrightarrow",
  "<->": "\\leftrightarrow",
  "(.)": "\\odot",
  "(+)": "\\oplus",
  "(/)": "\\oslash",
  "(*)": "\\otimes",
  "(-)": "\\ominus",
  "||": "\\Vert",
  "{": "\\{",
  "}": "\\}",
  "*": "\\cdot"
};
function di(e, t) {
  var _ref7, _ref8;
  var i;
  return (_ref7 = function (e) {
    var _gi, _gi2;
    if (!(e = e.trim())) return ["latex", ""];
    if (e.length <= 1) return ["latex", e];
    var t;
    return e = e.replace(/\\\\([^\s\n])/g, "\\$1"), (_gi = gi(e), _gi2 = _slicedToArray(_gi, 2), t = _gi2[0], e = _gi2[1]), t ? ["latex", e] : e.startsWith("`") && e.endsWith("`") ? ["ascii-math", e = e.substring(1, e.length - 1)] : e.includes("\\") ? ["latex", e] : /\$(.+)\$/.test(e) ? ["latex", "\\text{".concat(e, "}")] : [void 0, e];
  }(e), _ref8 = _slicedToArray(_ref7, 2), i = _ref8[0], e = _ref8[1]), "latex" === i ? ["latex", e] : (i = "ascii-math", [i, hi(e = (e = (e = (e = (e = (e = e.replace(/\u2061/g, "")).replace(/\u3016/g, "{")).replace(/\u3017/g, "}")).replace(/([^\\])sinx/g, "$1\\sin x")).replace(/([^\\])cosx/g, "$1\\cos x ")).replace(/\u2013/g, "-"), {
    inlineShortcuts: null == t ? void 0 : t.inlineShortcuts
  })]);
}
function hi(e, t) {
  var i, r, n;
  if (!e) return "";
  var a,
    o = !1;
  var s = null !== (i = t.inlineShortcuts) && void 0 !== i ? i : ui;
  if (o || !e.startsWith("^") && !e.startsWith("_") || (a = pi(e.slice(1), {
    inlineShortcuts: s,
    noWrap: !0
  }), e = e[0] + "{" + a.match + "}", e += hi(a.rest, t), o = !0), !o && (a = e.match(/^(sqrt|\u221A)(.*)/), a) && (a = pi(a[2], {
    inlineShortcuts: s,
    noWrap: !0
  }), e = "\\sqrt{" + (null !== (r = a.match) && void 0 !== r ? r : "\\placeholder{}") + "}", e += hi(a.rest, t), o = !0), !o && (a = e.match(/^(\\cbrt|\u221B)(.*)/), a) && (a = pi(a[2], {
    inlineShortcuts: s,
    noWrap: !0
  }), e = "\\sqrt[3]{" + (null !== (n = a.match) && void 0 !== n ? n : "\\placeholder{}") + "}", e += hi(a.rest, t), o = !0), o || (a = e.match(/^abs(.*)/), a && (a = pi(a[1], {
    inlineShortcuts: s,
    noWrap: !0
  }), e = "\\left|" + a.match + "\\right|", e += hi(a.rest, t), o = !0)), o || (a = e.match(/^["\u201d\u201c](.*?)["\u201d\u201c](.*)/), a && (e = "\\text{" + a[1] + "}", e += hi(a[2], t), o = !0)), o || (a = e.match(/^([^a-zA-Z({[_^\\\s"]+)(.*)/), a && (e = mi(a[1], s), e += hi(a[2], t), o = !0)), !o && /^([fgh])[^a-zA-Z]/.test(e) && (a = pi(e.slice(1), {
    inlineShortcuts: s,
    noWrap: !0
  }), e = "(" === e[1] ? e[0] + "\\mleft(" + a.match + "\\mright)" : e[0] + a.match, e += hi(a.rest, t), o = !0), o || (a = e.match(/^([a-zA-Z]+)(.*)/), a && (e = mi(a[1], s), e += hi(a[2], t), o = !0)), !o) if (a = pi(e, {
    inlineShortcuts: s,
    noWrap: !0
  }), a.match && "/" === a.rest[0]) {
    var _i61 = pi(a.rest.slice(1), {
      inlineShortcuts: s,
      noWrap: !0
    });
    _i61.match && (e = "\\frac{" + a.match + "}{" + _i61.match + "}" + hi(_i61.rest, t)), o = !0;
  } else a.match && (e = e.startsWith("(") ? "\\left(" + a.match + "\\right)" + hi(a.rest, t) : a.match + hi(a.rest, t), o = !0);
  return o || (a = e.match(/^(\s+)(.*)$/), a && (e = " " + hi(a[2], t), o = !0)), e;
}
function pi(e, t) {
  var i = "",
    r = e = e.trim(),
    n = e.charAt(0),
    a = {
      "(": ")",
      "{": "}",
      "[": "]"
    }[n];
  if (a) {
    var _o8 = 1,
      _s6 = 1;
    for (; _s6 < e.length && _o8 > 0;) e[_s6] === n && _o8++, e[_s6] === a && _o8--, _s6++;
    0 === _o8 ? (t.noWrap && "(" === n ? i = hi(e.substring(1, _s6 - 1), t) : ("{" === n && "}" === a && (n = "\\{", a = "\\}"), i = "\\left" + n + hi(e.substring(1, _s6 - 1), t) + "\\right" + a), r = e.slice(Math.max(0, _s6))) : (i = e.substring(1, _s6), r = "");
  } else {
    var _n15 = e.match(/^([a-zA-Z]+)/);
    if (_n15) {
      var _i62 = ci(null, e, t.inlineShortcuts);
      if (_i62) return _i62 = _i62.replace("_{#?}", ""), _i62 = _i62.replace("^{#?}", ""), {
        match: _i62,
        rest: e.slice(_i62.length)
      };
    }
    if (_n15 = e.match(/^([a-zA-Z])/), _n15) return {
      match: _n15[1],
      rest: e.slice(1)
    };
    if (_n15 = e.match(/^(-)?\d+(\.\d*)?/), _n15) return {
      match: _n15[0],
      rest: e.slice(_n15[0].length)
    };
    /^\\(left|right)/.test(e) || (_n15 = e.match(/^(\\[a-zA-Z]+)/), _n15 && (r = e.slice(_n15[1].length), i = _n15[1]));
  }
  return {
    match: i,
    rest: r
  };
}
function mi(e, t) {
  var i = ci(null, e, t);
  return i ? (i = i.replace("_{#?}", ""), i = i.replace("^{#?}", ""), i += " ") : i = e, i;
}
var fi = [["\\[", "\\]"], ["\\(", "\\)"], ["$$", "$$"], ["$", "$"], ["\\begin{math}", "\\end{math}"], ["\\begin{displaymath}", "\\end{displaymath}"], ["\\begin{equation}", "\\end{equation}"], ["\\begin{equation*}", "\\end{equation*}"]];
function gi(e) {
  var t = e.trim();
  var _iterator48 = _createForOfIteratorHelper(fi),
    _step48;
  try {
    for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
      var _e84 = _step48.value;
      if (t.startsWith(_e84[0]) && t.endsWith(_e84[1])) return [!0, t.substring(_e84[0].length, t.length - _e84[1].length)];
    }
  } catch (err) {
    _iterator48.e(err);
  } finally {
    _iterator48.f();
  }
  return [!1, e];
}
function yi(e) {
  var t = 0;
  if (0 === e.length) return t;
  for (var _i63 = 0; _i63 < e.length; _i63++) t = (t << 5) - t + e.charCodeAt(_i63), t &= t;
  return Math.abs(t);
}
function bi(e, t, i) {
  var r = i,
    n = 0;
  var a = e.length;
  for (; r < t.length;) {
    var _i64 = t[r];
    if (n <= 0 && t.slice(r, r + a) === e) return r;
    "\\" === _i64 ? r++ : "{" === _i64 ? n++ : "}" === _i64 && n--, r++;
  }
  return -1;
}
function vi(e, t, i, r) {
  var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "latex";
  var a = [];
  var _iterator49 = _createForOfIteratorHelper(e),
    _step49;
  try {
    for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
      var _o9 = _step49.value;
      if ("text" === _o9.type) {
        var _e85 = _o9.data;
        var _s7 = void 0,
          _l4 = !0,
          _c2 = 0;
        _s7 = _e85.indexOf(t), -1 !== _s7 && (_c2 = _s7, _c2 > 0 && a.push({
          type: "text",
          data: _e85.slice(0, _c2)
        }), _l4 = !1);
        var _u = !1;
        for (; !_u;) {
          if (_l4) {
            if (_s7 = _e85.indexOf(t, _c2), -1 === _s7) {
              _u = !0;
              break;
            }
            _c2 !== _s7 && a.push({
              type: "text",
              data: _e85.slice(_c2, _s7)
            }), _c2 = _s7;
          } else {
            var _di, _di2;
            if (_s7 = bi(i, _e85, _c2 + t.length), -1 === _s7) {
              _u = !0;
              break;
            }
            var _o10 = _e85.slice(_c2 + t.length, _s7);
            "ascii-math" === n && (_di = di(_o10, {
              format: "ascii-math"
            }), _di2 = _slicedToArray(_di, 2), _o10 = _di2[1], _di), a.push({
              type: "math",
              data: _o10,
              rawData: _e85.slice(_c2, _s7 + i.length),
              mathstyle: r
            }), _c2 = _s7 + i.length;
          }
          _l4 = !_l4;
        }
        _c2 < _e85.length && a.push({
          type: "text",
          data: _e85.slice(_c2)
        });
      } else a.push(_o9);
    }
  } catch (err) {
    _iterator49.e(err);
  } finally {
    _iterator49.f();
  }
  return a;
}
function xi(e, t, i) {
  var r = [{
    type: "text",
    data: e
  }];
  return (null == t ? void 0 : t.inline) && t.inline.forEach(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
      e = _ref10[0],
      t = _ref10[1];
    r = vi(r, e, t, "textstyle");
  }), (null == t ? void 0 : t.display) && t.display.forEach(function (_ref11) {
    var _ref12 = _slicedToArray(_ref11, 2),
      e = _ref12[0],
      t = _ref12[1];
    r = vi(r, e, t, "displaystyle");
  }), (null == i ? void 0 : i.inline) && i.inline.forEach(function (_ref13) {
    var _ref14 = _slicedToArray(_ref13, 2),
      e = _ref14[0],
      t = _ref14[1];
    r = vi(r, e, t, "textstyle", "ascii-math");
  }), (null == i ? void 0 : i.display) && i.display.forEach(function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 2),
      e = _ref16[0],
      t = _ref16[1];
    r = vi(r, e, t, "displaystyle", "ascii-math");
  }), r;
}
function ki(e, t, i, r) {
  var n;
  var a = function (e, t, i, r) {
      we();
      var n = document.createElement("displaystyle" === i ? "div" : "span");
      n.setAttribute("aria-hidden", "true");
      try {
        var _r20 = t.renderToMarkup(e, {
          mathstyle: null != i ? i : "displaystyle",
          format: "html",
          macros: t.macros
        });
        n.innerHTML = t.createHTML ? t.createHTML(_r20) : _r20;
      } catch (t) {
        return r ? document.createTextNode(e) : null;
      }
      return n;
    }(e, i, t, r),
    o = null !== (n = i.renderAccessibleContent) && void 0 !== n ? n : "";
  if (a && /\b(mathml|speakable-text)\b/i.test(o)) {
    we();
    var _t79 = document.createElement("span");
    if (/\bmathml\b/i.test(o) && i.renderToMathML && _t79.append(function (e, t) {
      we();
      var i = document.createElement("span");
      try {
        var _r21 = "<math xmlns='http://www.w3.org/1998/Math/MathML'>" + t.renderToMathML(e, t) + "</math>";
        i.innerHTML = t.createHTML ? t.createHTML(_r21) : _r21;
      } catch (t) {
        i.textContent = e;
      }
      return i.className = "ML__sr-only", i;
    }(e, i)), /\bspeakable-text\b/i.test(o) && i.renderToSpeakableText) {
      var _r22 = document.createElement("span"),
        _n16 = i.renderToSpeakableText(e, i);
      _r22.innerHTML = i.createHTML ? i.createHTML(_n16) : _n16, _r22.className = "ML__sr-only", _t79.append(_r22);
    }
    return _t79.append(a), _t79;
  }
  return a;
}
function wi(e, t) {
  var i, r, n, a;
  we();
  var o = null;
  if ((null === (i = t.TeX) || void 0 === i ? void 0 : i.processEnvironments) && /^\s*\\begin/.test(e)) {
    o = document.createDocumentFragment();
    var _i65 = ki(e, "", t, !0);
    _i65 && o.appendChild(_i65);
  } else {
    if (!e.trim()) return null;
    var _i66 = xi(e, null === (r = t.TeX) || void 0 === r ? void 0 : r.delimiters, null === (n = t.asciiMath) || void 0 === n ? void 0 : n.delimiters);
    if (1 === _i66.length && "text" === _i66[0].type) return null;
    o = document.createDocumentFragment();
    var _iterator50 = _createForOfIteratorHelper(_i66),
      _step50;
    try {
      for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
        var _e86 = _step50.value;
        if ("text" === _e86.type) o.appendChild(document.createTextNode(_e86.data));else {
          var _i67 = ki(_e86.data, null !== (a = _e86.mathstyle) && void 0 !== a ? a : "", t, !0);
          _i67 && o.appendChild(_i67);
        }
      }
    } catch (err) {
      _iterator50.e(err);
    } finally {
      _iterator50.f();
    }
  }
  return o;
}
function _i(e, t) {
  var i, r, n, a, o, s, l, c, u, d, h;
  var p = e.getAttribute("data-" + t.namespace + "original-content");
  if (p) {
    var _i68 = ki(p, e.getAttribute("data-" + t.namespace + "mathstyle"), t, !1);
    null !== _i68 && (e.textContent = "", e.append(_i68));
  } else {
    if (1 === e.childNodes.length && 3 === e.childNodes[0].nodeType) {
      var _o11 = e.childNodes[0].textContent;
      if ((null === (i = t.TeX) || void 0 === i ? void 0 : i.processEnvironments) && /^\s*\\begin/.test(_o11)) return e.textContent = "", void e.append(ki(_o11, "", t, !0));
      var _s8 = xi(_o11, null === (r = t.TeX) || void 0 === r ? void 0 : r.delimiters, null === (n = t.asciiMath) || void 0 === n ? void 0 : n.delimiters);
      if (1 === _s8.length && "math" === _s8[0].type) return e.textContent = "", void e.append(ki(_s8[0].data, null !== (a = _s8[0].mathstyle) && void 0 !== a ? a : "", t, !0));
      if (1 === _s8.length && "text" === _s8[0].type) return;
    }
    for (var _i69 = e.childNodes.length - 1; _i69 >= 0; _i69--) {
      var _r23 = e.childNodes[_i69];
      if (3 === _r23.nodeType) {
        var _e87 = wi(_r23.textContent, t);
        _e87 && (_i69 += _e87.childNodes.length - 1, _r23.replaceWith(_e87));
      } else if (1 === _r23.nodeType) {
        var _i70 = _r23.nodeName.toLowerCase();
        if ("script" === _i70 && (null === (o = t.processScriptTypePattern) || void 0 === o ? void 0 : o.test(_r23.type))) {
          var _e88 = "displaystyle";
          var _iterator51 = _createForOfIteratorHelper(_r23.type.split(";")),
            _step51;
          try {
            for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
              var _t80 = _step51.value;
              var _i72 = _t80.split("=");
              "mode" === _i72[0].toLowerCase() && (_e88 = "display" === _i72[1].toLoweCase() ? "displaystyle" : "textstyle");
            }
          } catch (err) {
            _iterator51.e(err);
          } finally {
            _iterator51.f();
          }
          var _i71 = ki(_r23.textContent, _e88, t, !0);
          _r23.parentNode.replaceChild(_i71, _r23);
        } else if ("script" !== _i70 && (null !== (l = null === (s = t.processClassPattern) || void 0 === s ? void 0 : s.test(_r23.className)) && void 0 !== l && l || !(null !== (u = null === (c = t.skipTags) || void 0 === c ? void 0 : c.includes(_i70)) && void 0 !== u && u || null !== (h = null === (d = t.ignoreClassPattern) || void 0 === d ? void 0 : d.test(_r23.className)) && void 0 !== h && h))) if (1 === e.childNodes.length && 3 === e.childNodes[0].nodeType) {
          var _i73 = e.textContent;
          e.textContent = "", e.append(ki(_i73, "displaystyle", t, !0));
        } else _i(_r23, t);
      }
    }
  }
}
var Mi = {
  namespace: "",
  skipTags: ["math-field", "noscript", "style", "textarea", "pre", "code", "annotation", "annotation-xml"],
  processScriptType: "math/tex",
  ignoreClass: "tex2jax_ignore",
  processClass: "tex2jax_process",
  renderAccessibleContent: "mathml",
  asciiMath: {
    delimiters: {
      display: [["`", "`"]]
    }
  },
  TeX: {
    processEnvironments: !0,
    delimiters: {
      inline: [["\\(", "\\)"]],
      display: [["$$", "$$"], ["\\[", "\\]"]]
    }
  }
};
function Si(e, t) {
  var i, r, n;
  try {
    if ((t = _objectSpread(_objectSpread({}, Mi), t)).ignoreClassPattern = new RegExp(null !== (i = t.ignoreClass) && void 0 !== i ? i : ""), t.processClassPattern = new RegExp(null !== (r = t.processClass) && void 0 !== r ? r : ""), t.processScriptTypePattern = new RegExp(null !== (n = t.processScriptType) && void 0 !== n ? n : ""), t.macros = Xe(t.macros), t.namespace) {
      if (!/^[a-z]+-?$/.test(t.namespace)) throw new Error("options.namespace must be a string of lowercase characters only");
      t.namespace.endsWith("-") || (t.namespace += "-");
    }
    oi(t.fontsDirectory), si(null, li, yi(li).toString(36)), _i(e, t);
  } catch (e) {
    Error;
  }
}
var Li = [{
    key: "left",
    command: "moveToPreviousChar"
  }, {
    key: "right",
    command: "moveToNextChar"
  }, {
    key: "up",
    command: "moveUp"
  }, {
    key: "down",
    command: "moveDown"
  }, {
    key: "shift+[ArrowLeft]",
    command: "extendSelectionBackward"
  }, {
    key: "shift+[ArrowRight]",
    command: "extendSelectionForward"
  }, {
    key: "shift+[ArrowUp]",
    command: "extendSelectionUpward"
  }, {
    key: "shift+[ArrowDown]",
    command: "extendSelectionDownward"
  }, {
    key: "[Backspace]",
    command: "deleteBackward"
  }, {
    key: "alt+[Delete]",
    command: "deleteBackward"
  }, {
    key: "[Delete]",
    command: "deleteForward"
  }, {
    key: "alt+[Backspace]",
    command: "deleteForward"
  }, {
    key: "alt+[ArrowLeft]",
    command: "moveToPreviousWord"
  }, {
    key: "alt+[ArrowRight]",
    command: "moveToNextWord"
  }, {
    key: "shift+alt+[ArrowLeft]",
    command: "extendToPreviousWord"
  }, {
    key: "shift+alt+[ArrowRight]",
    command: "extendToNextWord"
  }, {
    key: "ctrl+[ArrowLeft]",
    command: "moveToGroupStart"
  }, {
    key: "ctrl+[ArrowRight]",
    command: "moveToGroupEnd"
  }, {
    key: "shift+ctrl+[ArrowLeft]",
    command: "extendToGroupStart"
  }, {
    key: "shift+ctrl+[ArrowRight]",
    command: "extendToGroupEnd"
  }, {
    key: "[Space]",
    ifMode: "math",
    command: "moveAfterParent"
  }, {
    key: "shift+[Space]",
    ifMode: "math",
    command: "moveBeforeParent"
  }, {
    key: "[Home]",
    command: "moveToMathFieldStart"
  }, {
    key: "cmd+[ArrowLeft]",
    command: "moveToMathFieldStart"
  }, {
    key: "shift+[Home]",
    command: "extendToMathFieldStart"
  }, {
    key: "shift+cmd+[ArrowLeft]",
    command: "extendToMathFieldStart"
  }, {
    key: "[End]",
    command: "moveToMathFieldEnd"
  }, {
    key: "cmd+[ArrowRight]",
    command: "moveToMathFieldEnd"
  }, {
    key: "shift+[End]",
    command: "extendToMathFieldEnd"
  }, {
    key: "shift+cmd+[ArrowRight]",
    command: "extendToMathFieldEnd"
  }, {
    key: "[Pageup]",
    command: "moveToGroupStart"
  }, {
    key: "[Pagedown]",
    command: "moveToGroupEnd"
  }, {
    key: "[Tab]",
    ifMode: "math",
    command: "moveToNextPlaceholder"
  }, {
    key: "shift+[Tab]",
    ifMode: "math",
    command: "moveToPreviousPlaceholder"
  }, {
    key: "[Tab]",
    ifMode: "text",
    command: "moveToNextPlaceholder"
  }, {
    key: "shift+[Tab]",
    ifMode: "text",
    command: "moveToPreviousPlaceholder"
  }, {
    key: "[Escape]",
    ifMode: "math",
    command: ["switchMode", "latex"]
  }, {
    key: "[Escape]",
    ifMode: "text",
    command: ["switchMode", "latex"]
  }, {
    key: "\\",
    ifMode: "math",
    command: ["switchMode", "latex", "\\"]
  }, {
    key: "[IntlBackslash]",
    ifMode: "math",
    command: ["switchMode", "latex", "\\"]
  }, {
    key: "[Escape]",
    ifMode: "latex",
    command: ["complete", "complete", {
      selectItem: "true"
    }]
  }, {
    key: "[Tab]",
    ifMode: "latex",
    command: ["complete", "accept-suggestion"]
  }, {
    key: "[Return]",
    ifMode: "latex",
    command: "complete"
  }, {
    key: "[Enter]",
    ifMode: "latex",
    command: "complete"
  }, {
    key: "shift+[Escape]",
    ifMode: "latex",
    command: ["complete", "reject"]
  }, {
    key: "[ArrowDown]",
    ifMode: "latex",
    command: "nextSuggestion"
  }, {
    key: "[ArrowUp]",
    ifMode: "latex",
    command: "previousSuggestion"
  }, {
    key: "ctrl+a",
    ifPlatform: "!macos",
    command: "selectAll"
  }, {
    key: "cmd+a",
    command: "selectAll"
  }, {
    key: "[Cut]",
    command: "cutToClipboard"
  }, {
    key: "[Copy]",
    command: "copyToClipboard"
  }, {
    key: "[Paste]",
    command: "pasteFromClipboard"
  }, {
    key: "[Clear]",
    command: "deleteBackward"
  }, {
    key: "ctrl+z",
    ifPlatform: "!macos",
    command: "undo"
  }, {
    key: "cmd+z",
    command: "undo"
  }, {
    key: "[Undo]",
    command: "undo"
  }, {
    key: "ctrl+y",
    ifPlatform: "!macos",
    command: "redo"
  }, {
    key: "shift+cmd+y",
    command: "redo"
  }, {
    key: "shift+ctrl+z",
    ifPlatform: "!macos",
    command: "redo"
  }, {
    key: "shift+cmd+z",
    command: "redo"
  }, {
    key: "[Redo]",
    command: "redo"
  }, {
    key: "[EraseEof]",
    command: "deleteToGroupEnd"
  }, {
    key: "ctrl+b",
    ifPlatform: "macos",
    command: "moveToPreviousChar"
  }, {
    key: "ctrl+f",
    ifPlatform: "macos",
    command: "moveToNextChar"
  }, {
    key: "ctrl+p",
    ifPlatform: "macos",
    command: "moveUp"
  }, {
    key: "ctrl+n",
    ifPlatform: "macos",
    command: "moveDown"
  }, {
    key: "ctrl+a",
    ifPlatform: "macos",
    command: "moveToMathFieldStart"
  }, {
    key: "ctrl+e",
    ifPlatform: "macos",
    command: "moveToMathFieldEnd"
  }, {
    key: "shift+ctrl+b",
    ifPlatform: "macos",
    command: "extendSelectionBackward"
  }, {
    key: "shift+ctrl+f",
    ifPlatform: "macos",
    command: "extendSelectionForward"
  }, {
    key: "shift+ctrl+p",
    ifPlatform: "macos",
    command: "extendSelectionUpward"
  }, {
    key: "shift+ctrl+n",
    ifPlatform: "macos",
    command: "extendSelectionDownward"
  }, {
    key: "shift+ctrl+a",
    ifPlatform: "macos",
    command: "extendToMathFieldStart"
  }, {
    key: "shift+ctrl+e",
    ifPlatform: "macos",
    command: "extendToMathFieldEnd"
  }, {
    key: "alt+ctrl+b",
    ifPlatform: "macos",
    command: "moveToPreviousWord"
  }, {
    key: "alt+ctrl+f",
    ifPlatform: "macos",
    command: "moveToNextWord"
  }, {
    key: "shift+alt+ctrl+b",
    ifPlatform: "macos",
    command: "extendToPreviousWord"
  }, {
    key: "shift+alt+ctrl+f",
    ifPlatform: "macos",
    command: "extendToNextWord"
  }, {
    key: "ctrl+h",
    ifPlatform: "macos",
    command: "deleteBackward"
  }, {
    key: "ctrl+d",
    ifPlatform: "macos",
    command: "deleteForward"
  }, {
    key: "ctrl+l",
    ifPlatform: "macos",
    command: "scrollIntoView"
  }, {
    key: "ctrl+[Digit2]",
    ifMode: "math",
    command: ["insert", "\\sqrt{#0}"]
  }, {
    key: "ctrl+[Digit5]",
    ifMode: "math",
    command: "moveToOpposite"
  }, {
    key: "ctrl+[Digit6]",
    ifMode: "math",
    command: "moveToSuperscript"
  }, {
    key: "ctrl+[Return]",
    ifMode: "math",
    command: "addRowAfter"
  }, {
    key: "ctrl+[Enter]",
    ifMode: "math",
    command: "addRowAfter"
  }, {
    key: "cmd+[Return]",
    ifMode: "math",
    command: "addRowAfter"
  }, {
    key: "cmd+[Enter]",
    ifMode: "math",
    command: "addRowAfter"
  }, {
    key: "alt+p",
    ifMode: "math",
    command: ["insert", "\\pi"]
  }, {
    key: "alt+v",
    ifMode: "math",
    command: ["insert", "\\sqrt{#0}"]
  }, {
    key: "alt+w",
    ifMode: "math",
    command: ["insert", "\\sum_{i=#?}^{#?}"]
  }, {
    key: "alt+b",
    command: ["insert", "\\int_{#?}^{#?}"]
  }, {
    key: "alt+u",
    ifMode: "math",
    command: ["insert", "\\cup"]
  }, {
    key: "alt+n",
    ifMode: "math",
    command: ["insert", "\\cap"]
  }, {
    key: "alt+o",
    ifMode: "math",
    command: ["insert", "\\emptyset"]
  }, {
    key: "alt+d",
    ifMode: "math",
    command: ["insert", "\\differentialD"]
  }, {
    key: "shift+alt+o",
    ifMode: "math",
    command: ["insert", "\\varnothing"]
  }, {
    key: "shift+alt+d",
    ifMode: "math",
    command: ["insert", "\\partial"]
  }, {
    key: "shift+alt+p",
    ifMode: "math",
    command: ["insert", "\\prod_{i=#?}^{#?}"]
  }, {
    key: "shift+alt+u",
    ifMode: "math",
    command: ["insert", "\\bigcup"]
  }, {
    key: "shift+alt+n",
    ifMode: "math",
    command: ["insert", "\\bigcap"]
  }, {
    key: "shift+alt+a",
    ifMode: "math",
    command: ["insert", "\\forall"]
  }, {
    key: "shift+alt+e",
    ifMode: "math",
    command: ["insert", "\\exists"]
  }, {
    key: "alt+[Backslash]",
    ifMode: "math",
    command: ["insert", "\\backslash"]
  }, {
    key: "[NumpadDivide]",
    ifMode: "math",
    command: ["insert", "\\frac{#@}{#?}"]
  }, {
    key: "alt+[NumpadDivide]",
    ifMode: "math",
    command: ["insert", "\\frac{#?}{#@}"]
  }, {
    key: "shift+alt+k",
    command: "toggleKeystrokeCaption"
  }, {
    key: "alt+[Space]",
    command: "toggleVirtualKeyboard"
  }, {
    key: "alt+ctrl+[ArrowUp]",
    command: ["speak", "all", {
      withHighlighting: !1
    }]
  }, {
    key: "alt+ctrl+[ArrowDown]",
    command: ["speak", "selection", {
      withHighlighting: !1
    }]
  }, {
    key: "alt+[Equal]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: ["applyStyle", {
      mode: "text"
    }]
  }, {
    key: "alt+[Equal]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "text",
    command: ["applyStyle", {
      mode: "math"
    }]
  }, {
    key: "shift+[Quote]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: ["switchMode", "text", "", "\u201C"]
  }, {
    key: "shift+[Quote]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "text",
    command: ["switchMode", "math", "\u201D", ""]
  }, {
    key: "/",
    ifMode: "math",
    command: ["insert", "\\frac{#@}{#?}"]
  }, {
    key: "alt+/",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: ["insert", "\\/"]
  }, {
    key: "alt+[BracketLeft]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: ["insert", "\\left\\lbrack #0 \\right\\rbrack"]
  }, {
    key: "ctrl+[Minus]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: "moveToSubscript"
  }, {
    key: "shift+alt+[BracketLeft]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: ["insert", "\\left\\lbrace #0 \\right\\rbrace"]
  }, {
    key: "ctrl+;",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: "addRowAfter"
  }, {
    key: "cmd+;",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: "addRowAfter"
  }, {
    key: "shift+ctrl+;",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: "addRowBefore"
  }, {
    key: "shift+cmd+;",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: "addRowBefore"
  }, {
    key: "ctrl+[Comma]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: "addColumnAfter"
  }, {
    key: "cmd+[Comma]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: "addColumnAfter"
  }, {
    key: "shift+ctrl+[Comma]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: "addColumnAfter"
  }, {
    key: "shift+cmd+[Comma]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: "addColumnAfter"
  }, {
    key: "alt+[Digit5]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: ["insert", "$\\infty"]
  }, {
    key: "alt+[Digit6]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: ["insert", "\\wedge"]
  }, {
    key: "shift+alt+[Digit6]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: ["insert", "\\vee"]
  }, {
    key: "alt+[Digit9]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: ["insert", "("]
  }, {
    key: "alt+[Digit0]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: ["insert", ")"]
  }, {
    key: "alt+|",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: ["insert", "|"]
  }, {
    key: "shift+[Backquote]",
    ifLayout: ["apple.en-intl", "windows.en-intl", "linux.en"],
    ifMode: "math",
    command: ["insert", "\\~"]
  }],
  Ci = {
    "\\theta": "alt+q",
    "\\sqrt": ["alt+v", "ctrl+[Digit2]"],
    "\\pi": "alt+p",
    "\\prod": "shift+alt+p",
    "\\sum": "alt+w",
    "\\int": "alt+b",
    "\\cup": "alt+u",
    "\\cap": "alt+n",
    "\\bigcup": "shift+alt+u",
    "\\bigcap": "shift+alt+n",
    "\\forall": "shift+alt+a",
    "\\exists": "shift+alt+e",
    "\\infty": "alt+[Digit5]",
    "\\wedge": "alt+[Digit5]",
    "\\vee": "shift+alt+[Digit6]",
    "\\differentialD": "alt+d",
    "\\partial": "shift+alt+d",
    "\\frac": "Slash",
    "\\emptyset": "alt+o",
    "\\varnothing": "shift+alt+o",
    "\\~": "~"
  };
function Ai(e) {
  var t = e.split("+"),
    i = {
      shift: !1,
      alt: !1,
      cmd: !1,
      win: !1,
      meta: !1,
      ctrl: !1,
      key: t.pop()
    };
  return t.includes("shift") && (i.shift = !0), t.includes("alt") && (i.alt = !0), t.includes("ctrl") && (i.ctrl = !0), t.includes("cmd") && (i.cmd = !0), t.includes("win") && (i.win = !0), t.includes("meta") && (i.meta = !0), i;
}
function Ni(e) {
  var t = "";
  return e.shift && (t += "shift+"), e.alt && (t += "alt+"), e.ctrl && (t += "ctrl+"), e.cmd && (t += "cmd+"), e.win && (t += "win+"), e.meta && (t += "meta+"), t + e.key;
}
var zi = "apple" === Ti() ? {
    id: "apple.en-intl",
    displayName: "English (international)",
    virtualLayout: "qwerty",
    platform: "apple",
    locale: "en",
    score: 0,
    mapping: {
      KeyA: ["a", "A", "\xe5", "\xc5"],
      KeyB: ["b", "B", "\u222B", "\u0131"],
      KeyC: ["c", "C", "\xe7", "\xc7"],
      KeyD: ["d", "D", "\u2202", "\xce"],
      KeyE: ["e", "E", "\xb4", "\xb4"],
      KeyF: ["f", "F", "\u0192", "\xcf"],
      KeyG: ["g", "G", "\xa9", "\u02DD"],
      KeyH: ["h", "H", "\u02D9", "\xd3"],
      KeyI: ["i", "I", "\u02C6", "\u02C6"],
      KeyJ: ["j", "J", "\u2206", "\xd4"],
      KeyK: ["k", "K", "\u02DA", "\uF8FF"],
      KeyL: ["l", "L", "\xac", "\xd2"],
      KeyM: ["m", "M", "\xb5", "\xc2"],
      KeyN: ["n", "N", "\u02DC", "\u02DC"],
      KeyO: ["o", "O", "\xf8", "\xd8"],
      KeyP: ["p", "P", "\u03C0", "\u220F"],
      KeyQ: ["q", "Q", "\u0153", "\u0152"],
      KeyR: ["r", "R", "\xae", "\u2030"],
      KeyS: ["s", "S", "\xdf", "\xcd"],
      KeyT: ["t", "T", "\u2020", "\u02C7"],
      KeyU: ["u", "U", "\xa8", "\xa8"],
      KeyV: ["v", "V", "\u221A", "\u25CA"],
      KeyW: ["w", "W", "\u2211", "\u201E"],
      KeyX: ["x", "X", "\u2248", "\u02DB"],
      KeyY: ["y", "Y", "\xa5", "\xc1"],
      KeyZ: ["z", "Z", "\u03A9", "\xb8"],
      Digit1: ["1", "!", "\xa1", "\u2044"],
      Digit2: ["2", "@", "\u2122", "\u20AC"],
      Digit3: ["3", "#", "\xa3", "\u2039"],
      Digit4: ["4", "$", "\xa2", "\u203A"],
      Digit5: ["5", "%", "\u221E", "\uFB01"],
      Digit6: ["6", "^", "\xa7", "\uFB02"],
      Digit7: ["7", "&", "\xb6", "\u2021"],
      Digit8: ["8", "*", "\u2022", "\xb0"],
      Digit9: ["9", "(", "\xaa", "\xb7"],
      Digit0: ["0", ")", "\xba", "\u201A"],
      Space: [" ", " ", " ", " "],
      Minus: ["-", "_", "\u2013", "\u2014"],
      Equal: ["=", "+", "\u2260", "\xb1"],
      BracketLeft: ["[", "{", "\u201C", "\u201D"],
      BracketRight: ["]", "}", "\u2018", "\u2019"],
      Backslash: ["\\", "|", "\xab", "\xbb"],
      Semicolon: [";", ":", "\u2026", "\xda"],
      Quote: ["'", '"', "\xe6", "\xc6"],
      Backquote: ["`", "\u02DC", "`", "`"],
      Comma: [",", "<", "\u2264", "\xaf"],
      Period: [".", ">", "\u2265", "\u02D8"],
      Slash: ["/", "?", "\xf7", "\xbf"],
      NumpadDivide: ["/", "/", "/", "/"],
      NumpadMultiply: ["*", "*", "*", "*"],
      NumpadSubtract: ["-", "-", "-", "-"],
      NumpadAdd: ["+", "+", "+", "+"],
      Numpad1: ["1", "1", "1", "1"],
      Numpad2: ["2", "2", "2", "2"],
      Numpad3: ["3", "3", "3", "3"],
      Numpad4: ["4", "4", "4", "4"],
      Numpad5: ["5", "5", "5", "5"],
      Numpad6: ["6", "6", "6", "6"],
      Numpad7: ["7", "7", "7", "7"],
      Numpad8: ["8", "8", "8", "8"],
      Numpad9: ["9", "9", "9", "9"],
      Numpad0: ["0", "0", "0", "0"],
      NumpadDecimal: [".", ".", ".", "."],
      IntlBackslash: ["\xa7", "\xb1", "\xa7", "\xb1"],
      NumpadEqual: ["=", "=", "=", "="],
      AudioVolumeUp: ["", "=", "", "="]
    }
  } : "windows" === Ti() ? {
    id: "windows.en-intl",
    displayName: "English (international)",
    platform: "windows",
    virtualLayout: "qwerty",
    locale: "en",
    score: 0,
    mapping: {
      KeyA: ["a", "A", "\xe1", "\xc1"],
      KeyB: ["b", "B", "", ""],
      KeyC: ["c", "C", "\xa9", "\xa2"],
      KeyD: ["d", "D", "\xf0", "\xd0"],
      KeyE: ["e", "E", "\xe9", "\xc9"],
      KeyF: ["f", "F", "", ""],
      KeyG: ["g", "G", "", ""],
      KeyH: ["h", "H", "", ""],
      KeyI: ["i", "I", "\xed", "\xcd"],
      KeyJ: ["j", "J", "", ""],
      KeyK: ["k", "K", "", ""],
      KeyL: ["l", "L", "\xf8", "\xd8"],
      KeyM: ["m", "M", "\xb5", ""],
      KeyN: ["n", "N", "\xf1", "\xd1"],
      KeyO: ["o", "O", "\xf3", "\xd3"],
      KeyP: ["p", "P", "\xf6", "\xd6"],
      KeyQ: ["q", "Q", "\xe4", "\xc4"],
      KeyR: ["r", "R", "\xae", ""],
      KeyS: ["s", "S", "\xdf", "\xa7"],
      KeyT: ["t", "T", "\xfe", "\xde"],
      KeyU: ["u", "U", "\xfa", "\xda"],
      KeyV: ["v", "V", "", ""],
      KeyW: ["w", "W", "\xe5", "\xc5"],
      KeyX: ["x", "X", "", ""],
      KeyY: ["y", "Y", "\xfc", "\xdc"],
      KeyZ: ["z", "Z", "\xe6", "\xc6"],
      Digit1: ["1", "!", "\xa1", "\xb9"],
      Digit2: ["2", "@", "\xb2", ""],
      Digit3: ["3", "#", "\xb3", ""],
      Digit4: ["4", "$", "\xa4", "\xa3"],
      Digit5: ["5", "%", "\u20AC", ""],
      Digit6: ["6", "^", "\xbc", ""],
      Digit7: ["7", "&", "\xbd", ""],
      Digit8: ["8", "*", "\xbe", ""],
      Digit9: ["9", "(", "\u2018", ""],
      Digit0: ["0", ")", "\u2019", ""],
      Space: [" ", " ", "", ""],
      Minus: ["-", "_", "\xa5", ""],
      Equal: ["=", "+", "\xd7", "\xf7"],
      BracketLeft: ["[", "{", "\xab", ""],
      BracketRight: ["]", "}", "\xbb", ""],
      Backslash: ["\\", "|", "\xac", "\xa6"],
      Semicolon: [";", ":", "\xb6", "\xb0"],
      Quote: ["'", '"', "\xb4", "\xa8"],
      Backquote: ["`", "~", "", ""],
      Comma: [",", "<", "\xe7", "\xc7"],
      Period: [".", ">", "", ""],
      Slash: ["/", "?", "\xbf", ""],
      NumpadDivide: ["/", "/", "", ""],
      NumpadMultiply: ["*", "*", "", ""],
      NumpadSubtract: ["-", "-", "", ""],
      NumpadAdd: ["+", "+", "", ""],
      IntlBackslash: ["\\", "|", "", ""]
    }
  } : {
    id: "linux.en",
    displayName: "English",
    platform: "linux",
    virtualLayout: "qwerty",
    locale: "en",
    score: 0,
    mapping: {
      KeyA: ["a", "A", "a", "A"],
      KeyB: ["b", "B", "b", "B"],
      KeyC: ["c", "C", "c", "C"],
      KeyD: ["d", "D", "d", "D"],
      KeyE: ["e", "E", "e", "E"],
      KeyF: ["f", "F", "f", "F"],
      KeyG: ["g", "G", "g", "G"],
      KeyH: ["h", "H", "h", "H"],
      KeyI: ["i", "I", "i", "I"],
      KeyJ: ["j", "J", "j", "J"],
      KeyK: ["k", "K", "k", "K"],
      KeyL: ["l", "L", "l", "L"],
      KeyM: ["m", "M", "m", "M"],
      KeyN: ["n", "N", "n", "N"],
      KeyO: ["o", "O", "o", "O"],
      KeyP: ["p", "P", "p", "P"],
      KeyQ: ["q", "Q", "q", "Q"],
      KeyR: ["r", "R", "r", "R"],
      KeyS: ["s", "S", "s", "S"],
      KeyT: ["t", "T", "t", "T"],
      KeyU: ["u", "U", "u", "U"],
      KeyV: ["v", "V", "v", "V"],
      KeyW: ["w", "W", "w", "W"],
      KeyX: ["x", "X", "x", "X"],
      KeyY: ["y", "Y", "y", "Y"],
      KeyZ: ["z", "Z", "z", "Z"],
      Digit1: ["1", "!", "1", "!"],
      Digit2: ["2", "@", "2", "@"],
      Digit3: ["3", "#", "3", "#"],
      Digit4: ["4", "$", "4", "$"],
      Digit5: ["5", "%", "5", "%"],
      Digit6: ["6", "^", "6", "^"],
      Digit7: ["7", "&", "7", "&"],
      Digit8: ["8", "*", "8", "*"],
      Digit9: ["9", "(", "9", "("],
      Digit0: ["0", ")", "0", ")"],
      Space: [" ", " ", " ", " "],
      Minus: ["-", "_", "-", "_"],
      Equal: ["=", "+", "=", "+"],
      BracketLeft: ["[", "{", "[", "{"],
      BracketRight: ["]", "}", "]", "}"],
      Backslash: ["\\", "|", "\\", "|"],
      Semicolon: [";", ":", ";", ":"],
      Quote: ["'", '"', "'", '"'],
      Backquote: ["`", "~", "`", "~"],
      Comma: [",", "<", ",", "<"],
      Period: [".", ">", ".", ">"],
      Slash: ["/", "?", "/", "?"],
      NumpadDivide: ["/", "/", "/", "/"],
      NumpadMultiply: ["*", "*", "*", "*"],
      NumpadSubtract: ["-", "-", "-", "-"],
      NumpadAdd: ["+", "+", "+", "+"],
      Numpad1: ["1", "1", "1", "1"],
      Numpad2: ["2", "2", "2", "2"],
      Numpad3: ["3", "3", "3", "3"],
      Numpad4: ["4", "4", "4", "4"],
      Numpad5: ["5", "5", "5", "5"],
      Numpad6: ["6", "6", "6", "6"],
      Numpad7: ["7", "7", "7", "7"],
      Numpad8: ["8", "8", "8", "8"],
      Numpad9: ["9", "9", "9", "9"],
      Numpad0: ["0", "0", "0", "0"],
      NumpadDecimal: ["", ".", "", "."],
      IntlBackslash: ["<", ">", "|", "\xa6"],
      NumpadEqual: ["=", "=", "=", "="],
      NumpadComma: [".", ".", ".", "."],
      NumpadParenLeft: ["(", "(", "(", "("],
      NumpadParenRight: [")", ")", ")", ")"]
    }
  },
  qi = {
    enter: "[Enter]",
    escape: "[Escape]",
    backspace: "[Backspace]",
    tab: "[Tab]",
    space: "[Space]",
    pausebreak: "[Pause]",
    insert: "[Insert]",
    home: "[Home]",
    pageup: "[PageUp]",
    delete: "[Delete]",
    end: "[End]",
    pagedown: "[PageDown]",
    right: "[ArrowRight]",
    left: "[ArrowLeft]",
    down: "[ArrowDown]",
    up: "[ArrowUp]",
    numpad0: "[Numpad0]",
    numpad1: "[Numpad1]",
    numpad2: "[Numpad2]",
    numpad3: "[Numpad3]",
    numpad4: "[Numpad4]",
    numpad5: "[Numpad5]",
    numpad6: "[Numpad6]",
    numpad7: "[Numpad7]",
    numpad8: "[Numpad8]",
    numpad9: "[Numpad9]",
    numpad_divide: "[NumpadDivide]",
    numpad_multiply: "[NumpadMultiply]",
    numpad_subtract: "[NumpadSubtract]",
    numpad_add: "[NumpadAdd]",
    numpad_decimal: "[NumpadDecimal]",
    numpad_separator: "[NumpadComma]",
    capslock: "[Capslock]",
    f1: "[F1]",
    f2: "[F2]",
    f3: "[F3]",
    f4: "[F4]",
    f5: "[F5]",
    f6: "[F6]",
    f7: "[F7]",
    f8: "[F8]",
    f9: "[F9]",
    f10: "[F10]",
    f11: "[F11]",
    f12: "[F12]",
    f13: "[F13]",
    f14: "[F14]",
    f15: "[F15]",
    f16: "[F16]",
    f17: "[F17]",
    f18: "[F18]",
    f19: "[F19]"
  },
  Di = [];
var Ei;
function Ti() {
  switch (Se()) {
    case "macos":
    case "ios":
      return "apple";
    case "windows":
      return "windows";
  }
  return "linux";
}
function Oi(e) {
  e.platform && e.platform !== Ti() || Di.push(e);
}
function Bi(e) {
  Ei = Di.find(function (t) {
    return e.startsWith(t.locale);
  });
}
function Ki() {
  return null != Ei ? Ei : Di[0];
}
function Fi(t) {
  var i = t;
  return e(i) && (i = i.length > 0 ? i[0] + "(" + i.slice(1).join("") + ")" : ""), i;
}
function $i(e) {
  var t;
  var i = /macos|ios|/.test(Se()),
    r = e.split("+");
  var n = "";
  var _iterator52 = _createForOfIteratorHelper(r),
    _step52;
  try {
    for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
      var _e89 = _step52.value;
      !i && n && (n += '<span class="ML__shortcut-join">+</span>'), _e89.startsWith("[Key") ? n += _e89.slice(4, 5) : _e89.startsWith("Key") ? n += _e89.slice(3, 4) : _e89.startsWith("[Digit") ? n += _e89.slice(6, 7) : _e89.startsWith("Digit") ? n += _e89.slice(5, 6) : n += null !== (t = {
        cmd: "\u2318",
        meta: i ? "\u2318" : "command",
        shift: i ? "\u21E7" : "shift",
        alt: i ? "\u2325" : "alt",
        ctrl: i ? "\u2303" : "control",
        "\n": i ? "\u23CE" : "return",
        "[return]": i ? "\u23CE" : "return",
        "[enter]": i ? "\u2324" : "enter",
        "[tab]": i ? "\u21E5" : "tab",
        "[escape]": "esc",
        "[backspace]": i ? "\u232B" : "backspace",
        "[delete]": i ? "\u2326" : "del",
        "[pageup]": i ? "\u21DE" : "page up",
        "[pagedown]": i ? "\u21DF" : "page down",
        "[home]": i ? "\u2912" : "home",
        "[end]": i ? "\u2913" : "end",
        "[space]": "space",
        "[equal]": "=",
        "[minus]": "-",
        "[comma]": ",",
        "[slash]": "/",
        "[backslash]": "\\",
        "[bracketleft]": "[",
        "[bracketright]": "]",
        semicolon: ";",
        period: ".",
        comma: ",",
        minus: "-",
        equal: "=",
        quote: "'",
        bracketLeft: "[",
        bracketRight: "]",
        backslash: "\\",
        intlbackslash: "\\",
        backquote: "`",
        slash: "/",
        numpadmultiply: "* &#128290;",
        numpaddivide: "/ &#128290;",
        numpadsubtract: "- &#128290;",
        numpadadd: "+ &#128290;",
        numpaddecimal: ". &#128290;",
        numpadcomma: ", &#128290;",
        help: "help",
        left: "\u21E0",
        up: "\u21E1",
        right: "\u21E2",
        down: "\u21E3",
        "[arrowleft]": "\u21E0",
        "[arrowup]": "\u21E1",
        "[arrowright]": "\u21E2",
        "[arrowdown]": "\u21E3",
        "[digit0]": "0",
        "[digit1]": "1",
        "[digit2]": "2",
        "[digit3]": "3",
        "[digit4]": "4",
        "[digit5]": "5",
        "[digit6]": "6",
        "[digit7]": "7",
        "[digit8]": "8",
        "[digit9]": "9"
      }[_e89.toLowerCase()]) && void 0 !== t ? t : _e89.toUpperCase();
    }
  } catch (err) {
    _iterator52.e(err);
  } finally {
    _iterator52.f();
  }
  return n;
}
function Pi(e, t) {
  if (e.ifPlatform && !/^!?(macos|windows|android|ios|chromeos|other)$/.test(e.ifPlatform)) throw new Error("Unexpected platform \"".concat(e.ifPlatform, "\" for keybinding ").concat(e.key));
  if (void 0 !== e.ifLayout && (0 === t.score || !e.ifLayout.includes(t.id))) return;
  var i = Ai(e.key);
  var r = e.ifPlatform;
  if (i.cmd) {
    if (r && "macos" !== r && "ios" !== r) throw new Error('Unexpected "cmd" modifier with platform "' + r + '"\n"cmd" modifier can only be used with macOS or iOS platform.');
    r || (r = "ios" === Se() ? "ios" : "macos"), i.win = !1, i.cmd = !1, i.meta = !0;
  }
  if (i.win) {
    if (r && "windows" !== r) throw new Error('Unexpected "win" modifier with platform "' + r + '"\n"win" modifier can only be used with Windows platform.');
    r = "windows", i.win = !1, i.cmd = !1, i.meta = !0;
  }
  if (!r || function (e) {
    if (ke() && navigator.platform && navigator.userAgent) {
      var _t81 = Se(),
        _i74 = e.startsWith("!"),
        _r24 = e.endsWith(_t81);
      if (_i74 && !_r24) return !0;
      if (!_i74 && _r24) return !0;
    }
    return "!other" !== e && "other" === e;
  }(r)) {
    if (!/^\[(.*)]$/.test(i.key)) {
      var _n17 = function (e, t) {
        var i;
        var r = {
          shift: !1,
          alt: !1,
          cmd: !1,
          win: !1,
          meta: !1,
          ctrl: !1,
          key: ""
        };
        if (!e) return r;
        for (var _i75 = 0, _Object$entries = Object.entries(t.mapping); _i75 < _Object$entries.length; _i75++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i75], 2),
            _i76 = _Object$entries$_i[0],
            _n18 = _Object$entries$_i[1];
          if (_n18[0] === e) return r.key = "[".concat(_i76, "]"), r;
          if (_n18[1] === e) return r.shift = !0, r.key = "[".concat(_i76, "]"), r;
          if (_n18[2] === e) return r.alt = !0, r.key = "[".concat(_i76, "]"), r;
          if (_n18[3] === e) return r.shift = !0, r.alt = !0, r.key = "[".concat(_i76, "]"), r;
        }
        return r.key = null !== (i = qi[e]) && void 0 !== i ? i : "", r;
      }(i.key, t);
      if (!_n17) throw new Error('Invalid keybinding key "' + e.key + '"');
      if (_n17.shift && i.shift || _n17.alt && i.alt) throw new Error("The keybinding ".concat(e.key, " (").concat(Ii(e.command), ") is conflicting with the key combination ").concat(Ni(_n17), " using the ").concat(t.displayName, " keyboard layout"));
      return _n17.shift = _n17.shift || i.shift, _n17.alt = _n17.alt || i.alt, _n17.meta = i.meta, _n17.ctrl = i.ctrl, _objectSpread(_objectSpread({}, e), {}, {
        ifPlatform: r,
        key: Ni(_n17)
      });
    }
    return _objectSpread(_objectSpread({}, e), {}, {
      ifPlatform: r,
      key: Ni(i)
    });
  }
}
function Ii(e) {
  if (Array.isArray(e)) {
    var _t82 = _toConsumableArray(e);
    return _t82.shift() + "(" + _t82.map(function (e) {
      return "string" == typeof e ? "\"".concat(e, "\"") : e.toString();
    }).join(", ") + ")";
  }
  return e;
}
Oi(zi), Oi({
  id: "apple.french",
  locale: "fr",
  displayName: "French",
  platform: "apple",
  virtualLayout: "azerty",
  score: 0,
  mapping: {
    KeyA: ["q", "Q", "\u2021", "\u03A9"],
    KeyB: ["b", "B", "\xdf", "\u222B"],
    KeyC: ["c", "C", "\xa9", "\xa2"],
    KeyD: ["d", "D", "\u2202", "\u2206"],
    KeyE: ["e", "E", "\xea", "\xca"],
    KeyF: ["f", "F", "\u0192", "\xb7"],
    KeyG: ["g", "G", "\uFB01", "\uFB02"],
    KeyH: ["h", "H", "\xcc", "\xce"],
    KeyI: ["i", "I", "\xee", "\xef"],
    KeyJ: ["j", "J", "\xcf", "\xcd"],
    KeyK: ["k", "K", "\xc8", "\xcb"],
    KeyL: ["l", "L", "\xac", "|"],
    KeyM: [",", "?", "\u221E", "\xbf"],
    KeyN: ["n", "N", "~", "\u0131"],
    KeyO: ["o", "O", "\u0153", "\u0152"],
    KeyP: ["p", "P", "\u03C0", "\u220F"],
    KeyQ: ["a", "A", "\xe6", "\xc6"],
    KeyR: ["r", "R", "\xae", "\u201A"],
    KeyS: ["s", "S", "\xd2", "\u2211"],
    KeyT: ["t", "T", "\u2020", "\u2122"],
    KeyU: ["u", "U", "\xba", "\xaa"],
    KeyV: ["v", "V", "\u25CA", "\u221A"],
    KeyW: ["z", "Z", "\xc2", "\xc5"],
    KeyX: ["x", "X", "\u2248", "\u2044"],
    KeyY: ["y", "Y", "\xda", "\u0178"],
    KeyZ: ["w", "W", "\u2039", "\u203A"],
    Digit1: ["&", "1", "\uF8FF", "\xb4"],
    Digit2: ["\xe9", "2", "\xeb", "\u201E"],
    Digit3: ['"', "3", "\u201C", "\u201D"],
    Digit4: ["'", "4", "\u2018", "\u2019"],
    Digit5: ["(", "5", "{", "["],
    Digit6: ["\xa7", "6", "\xb6", "\xe5"],
    Digit7: ["\xe8", "7", "\xab", "\xbb"],
    Digit8: ["!", "8", "\xa1", "\xdb"],
    Digit9: ["\xe7", "9", "\xc7", "\xc1"],
    Digit0: ["\xe0", "0", "\xf8", "\xd8"],
    Space: [" ", " ", " ", " "],
    Minus: [")", "\xb0", "}", "]"],
    Equal: ["-", "_", "\u2014", "\u2013"],
    BracketLeft: ["^", "\xa8", "\xf4", "\xd4"],
    BracketRight: ["$", "*", "\u20AC", "\xa5"],
    Backslash: ["`", "\xa3", "@", "#"],
    Semicolon: ["m", "M", "\xb5", "\xd3"],
    Quote: ["\xf9", "%", "\xd9", "\u2030"],
    Backquote: ["<", ">", "\u2264", "\u2265"],
    Comma: [";", ".", "\u2026", "\u2022"],
    Period: [":", "/", "\xf7", "\\"],
    Slash: ["=", "+", "\u2260", "\xb1"],
    NumpadDivide: ["/", "/", "/", "/"],
    NumpadMultiply: ["*", "*", "*", "*"],
    NumpadSubtract: ["-", "-", "-", "-"],
    NumpadAdd: ["+", "+", "+", "+"],
    NumpadDecimal: [",", ".", ",", "."],
    IntlBackslash: ["@", "#", "\u2022", "\u0178"],
    NumpadEqual: ["=", "=", "=", "="]
  }
}), Oi({
  id: "apple.spanish",
  locale: "es",
  displayName: "Spanish ISO",
  platform: "apple",
  virtualLayout: "qwerty",
  score: 0,
  mapping: {
    KeyA: ["a", "A", "\xe5", "\xc5"],
    KeyB: ["b", "B", "\xdf", ""],
    KeyC: ["c", "C", "\xa9", " "],
    KeyD: ["d", "D", "\u2202", "\u2206"],
    KeyE: ["e", "E", "\u20AC", "\u20AC"],
    KeyF: ["f", "F", "\u0192", "\uFB01"],
    KeyG: ["g", "G", "\uF8FF", "\uFB02"],
    KeyH: ["h", "H", "\u2122", " "],
    KeyI: ["i", "I", " ", " "],
    KeyJ: ["j", "J", "\xb6", "\xaf"],
    KeyK: ["k", "K", "\xa7", "\u02C7"],
    KeyL: ["l", "L", " ", "\u02D8"],
    KeyM: ["m", "M", "\xb5", "\u02DA"],
    KeyN: ["n", "N", " ", "\u02D9"],
    KeyO: ["o", "O", "\xf8", "\xd8"],
    KeyP: ["p", "P", "\u03C0", "\u220F"],
    KeyQ: ["q", "Q", "\u0153", "\u0152"],
    KeyR: ["r", "R", "\xae", " "],
    KeyS: ["s", "S", "\u222B", " "],
    KeyT: ["t", "T", "\u2020", "\u2021"],
    KeyU: ["u", "U", " ", " "],
    KeyV: ["v", "V", "\u221A", "\u25CA"],
    KeyW: ["w", "W", "\xe6", "\xc6"],
    KeyX: ["x", "X", "\u2211", "\u203A"],
    KeyY: ["y", "Y", "\xa5", " "],
    KeyZ: ["z", "Z", "\u03A9", "\u2039"],
    Digit1: ["1", "!", "|", "\u0131"],
    Digit2: ["2", '"', "@", "\u02DD"],
    Digit3: ["3", "\xb7", "#", "\u2022"],
    Digit4: ["4", "$", "\xa2", "\xa3"],
    Digit5: ["5", "%", "\u221E", "\u2030"],
    Digit6: ["6", "&", "\xac", " "],
    Digit7: ["7", "/", "\xf7", "\u2044"],
    Digit8: ["8", "(", "\u201C", "\u2018"],
    Digit9: ["9", ")", "\u201D", "\u2019"],
    Digit0: ["0", "=", "\u2260", "\u2248"],
    Space: [" ", " ", " ", " "],
    Minus: ["'", "?", "\xb4", "\xb8"],
    Equal: ["\xa1", "\xbf", "\u201A", "\u02DB"],
    BracketLeft: ["`", "^", "[", "\u02C6"],
    BracketRight: ["+", "*", "]", "\xb1"],
    Backslash: ["\xe7", "\xc7", "}", "\xbb"],
    Semicolon: ["\xf1", "\xd1", "~", "\u02DC"],
    Quote: ["\xb4", "\xa8", "{", "\xab"],
    Backquote: ["<", ">", "\u2264", "\u2265"],
    Comma: [",", ";", "\u201E", ""],
    Period: [".", ":", "\u2026", "\u2026"],
    Slash: ["-", "_", "\u2013", "\u2014"],
    NumpadDivide: ["/", "/", "/", "/"],
    NumpadMultiply: ["*", "*", "*", "*"],
    NumpadSubtract: ["-", "-", "-", "-"],
    NumpadAdd: ["+", "+", "+", "+"],
    Numpad1: ["1", "1", "1", "1"],
    Numpad2: ["2", "2", "2", "2"],
    Numpad3: ["3", "3", "3", "3"],
    Numpad4: ["4", "4", "4", "4"],
    Numpad5: ["5", "5", "5", "5"],
    Numpad6: ["6", "6", "6", "6"],
    Numpad7: ["7", "7", "7", "7"],
    Numpad8: ["8", "8", "8", "8"],
    Numpad9: ["9", "9", "9", "9"],
    Numpad0: ["0", "0", "0", "0"],
    NumpadDecimal: [",", ",", ",", ","],
    IntlBackslash: ["\xba", "\xaa", "\\", "\xb0"]
  }
}), Oi({
  id: "windows.spanish",
  locale: "es",
  displayName: "Spanish",
  platform: "windows",
  virtualLayout: "qwerty",
  score: 0,
  mapping: {
    KeyA: ["a", "A", "", ""],
    KeyB: ["b", "B", "", ""],
    KeyC: ["c", "C", "", ""],
    KeyD: ["d", "D", "", ""],
    KeyE: ["e", "E", "\u20AC", ""],
    KeyF: ["f", "F", "", ""],
    KeyG: ["g", "G", "", ""],
    KeyH: ["h", "H", "", ""],
    KeyI: ["i", "I", "", ""],
    KeyJ: ["j", "J", "", ""],
    KeyK: ["k", "K", "", ""],
    KeyL: ["l", "L", "", ""],
    KeyM: ["m", "M", "", ""],
    KeyN: ["n", "N", "", ""],
    KeyO: ["o", "O", "", ""],
    KeyP: ["p", "P", "", ""],
    KeyQ: ["q", "Q", "", ""],
    KeyR: ["r", "R", "", ""],
    KeyS: ["s", "S", "", ""],
    KeyT: ["t", "T", "", ""],
    KeyU: ["u", "U", "", ""],
    KeyV: ["v", "V", "", ""],
    KeyW: ["w", "W", "", ""],
    KeyX: ["x", "X", "", ""],
    KeyY: ["y", "Y", "", ""],
    KeyZ: ["z", "Z", "", ""],
    Digit1: ["1", "!", "|", ""],
    Digit2: ["2", '"', "@", ""],
    Digit3: ["3", "\xb7", "#", ""],
    Digit4: ["4", "$", "~", ""],
    Digit5: ["5", "%", "\u20AC", ""],
    Digit6: ["6", "&", "\xac", ""],
    Digit7: ["7", "/", "", ""],
    Digit8: ["8", "(", "", ""],
    Digit9: ["9", ")", "", ""],
    Digit0: ["0", "=", "", ""],
    Space: [" ", " ", "", ""],
    Minus: ["'", "?", "", ""],
    Equal: ["\xa1", "\xbf", "", ""],
    BracketLeft: ["`", "^", "[", ""],
    BracketRight: ["+", "*", "]", ""],
    Backslash: ["\xe7", "\xc7", "}", ""],
    Semicolon: ["\xf1", "\xd1", "", ""],
    Quote: ["\xb4", "\xa8", "{", ""],
    Backquote: ["\xba", "\xaa", "\\", ""],
    Comma: [",", ";", "", ""],
    Period: [".", ":", "", ""],
    Slash: ["-", "_", "", ""],
    NumpadDivide: ["/", "/", "", ""],
    NumpadMultiply: ["*", "*", "", ""],
    NumpadSubtract: ["-", "-", "", ""],
    NumpadAdd: ["+", "+", "", ""],
    IntlBackslash: ["<", ">", "", ""]
  }
}), Oi({
  id: "linux.spanish",
  locale: "es",
  displayName: "Spanish",
  platform: "linux",
  virtualLayout: "qwerty",
  score: 0,
  mapping: {
    KeyA: ["a", "A", "\xe6", "\xc6"],
    KeyB: ["b", "B", "\u201D", "\u2019"],
    KeyC: ["c", "C", "\xa2", "\xa9"],
    KeyD: ["d", "D", "\xf0", "\xd0"],
    KeyE: ["e", "E", "\u20AC", "\xa2"],
    KeyF: ["f", "F", "\u0111", "\xaa"],
    KeyG: ["g", "G", "\u014B", "\u014A"],
    KeyH: ["h", "H", "\u0127", "\u0126"],
    KeyI: ["i", "I", "\u2192", "\u0131"],
    KeyJ: ["j", "J", "\u0309", "\u031B"],
    KeyK: ["k", "K", "\u0138", "&"],
    KeyL: ["l", "L", "\u0142", "\u0141"],
    KeyM: ["m", "M", "\xb5", "\xba"],
    KeyN: ["n", "N", "n", "N"],
    KeyO: ["o", "O", "\xf8", "\xd8"],
    KeyP: ["p", "P", "\xfe", "\xde"],
    KeyQ: ["q", "Q", "@", "\u03A9"],
    KeyR: ["r", "R", "\xb6", "\xae"],
    KeyS: ["s", "S", "\xdf", "\xa7"],
    KeyT: ["t", "T", "\u0167", "\u0166"],
    KeyU: ["u", "U", "\u2193", "\u2191"],
    KeyV: ["v", "V", "\u201C", "\u2018"],
    KeyW: ["w", "W", "\u0142", "\u0141"],
    KeyX: ["x", "X", "\xbb", ">"],
    KeyY: ["y", "Y", "\u2190", "\xa5"],
    KeyZ: ["z", "Z", "\xab", "<"],
    Digit1: ["1", "!", "|", "\xa1"],
    Digit2: ["2", '"', "@", "\u215B"],
    Digit3: ["3", "\xb7", "#", "\xa3"],
    Digit4: ["4", "$", "~", "$"],
    Digit5: ["5", "%", "\xbd", "\u215C"],
    Digit6: ["6", "&", "\xac", "\u215D"],
    Digit7: ["7", "/", "{", "\u215E"],
    Digit8: ["8", "(", "[", "\u2122"],
    Digit9: ["9", ")", "]", "\xb1"],
    Digit0: ["0", "=", "}", "\xb0"],
    Enter: ["\r", "\r", "\r", "\r"],
    Escape: ["\x1b", "\x1b", "\x1b", "\x1b"],
    Backspace: ["\b", "\b", "\b", "\b"],
    Tab: ["\t", "", "\t", ""],
    Space: [" ", " ", " ", " "],
    Minus: ["'", "?", "\\", "\xbf"],
    Equal: ["\xa1", "\xbf", "\u0303", "~"],
    BracketLeft: ["\u0300", "\u0302", "[", "\u030A"],
    BracketRight: ["+", "*", "]", "\u0304"],
    Backslash: ["\xe7", "\xc7", "}", "\u0306"],
    Semicolon: ["\xf1", "\xd1", "~", "\u030B"],
    Quote: ["\u0301", "\u0308", "{", "{"],
    Backquote: ["\xba", "\xaa", "\\", "\\"],
    Comma: [",", ";", "\u2500", "\xd7"],
    Period: [".", ":", "\xb7", "\xf7"],
    Slash: ["-", "_", "\u0323", "\u0307"],
    NumpadDivide: ["/", "/", "/", "/"],
    NumpadMultiply: ["*", "*", "*", "*"],
    NumpadSubtract: ["-", "-", "-", "-"],
    NumpadAdd: ["+", "+", "+", "+"],
    NumpadEnter: ["\r", "\r", "\r", "\r"],
    Numpad1: ["", "1", "", "1"],
    Numpad2: ["", "2", "", "2"],
    Numpad3: ["", "3", "", "3"],
    Numpad4: ["", "4", "", "4"],
    Numpad5: ["", "5", "", "5"],
    Numpad6: ["", "6", "", "6"],
    Numpad7: ["", "7", "", "7"],
    Numpad8: ["", "8", "", "8"],
    Numpad9: ["", "9", "", "9"],
    Numpad0: ["", "0", "", "0"],
    NumpadDecimal: ["", ".", "", "."],
    IntlBackslash: ["<", ">", "|", "\xa6"],
    NumpadEqual: ["=", "=", "=", "="],
    NumpadComma: [".", ".", ".", "."],
    NumpadParenLeft: ["(", "(", "(", "("],
    NumpadParenRight: [")", ")", ")", ")"]
  }
}), Oi({
  id: "linux.french",
  locale: "fr",
  displayName: "French",
  virtualLayout: "azerty",
  platform: "linux",
  score: 0,
  mapping: {
    KeyA: ["q", "Q", "@", "\u03A9"],
    KeyB: ["b", "B", "\u201D", "\u2019"],
    KeyC: ["c", "C", "\xa2", "\xa9"],
    KeyD: ["d", "D", "\xf0", "\xd0"],
    KeyE: ["e", "E", "\u20AC", "\xa2"],
    KeyF: ["f", "F", "\u0111", "\xaa"],
    KeyG: ["g", "G", "\u014B", "\u014A"],
    KeyH: ["h", "H", "\u0127", "\u0126"],
    KeyI: ["i", "I", "\u2192", "\u0131"],
    KeyJ: ["j", "J", "\u0309", "\u031B"],
    KeyK: ["k", "K", "\u0138", "&"],
    KeyL: ["l", "L", "\u0142", "\u0141"],
    KeyM: [",", "?", "\u0301", "\u030B"],
    KeyN: ["n", "N", "n", "N"],
    KeyO: ["o", "O", "\xf8", "\xd8"],
    KeyP: ["p", "P", "\xfe", "\xde"],
    KeyQ: ["a", "A", "\xe6", "\xc6"],
    KeyR: ["r", "R", "\xb6", "\xae"],
    KeyS: ["s", "S", "\xdf", "\xa7"],
    KeyT: ["t", "T", "\u0167", "\u0166"],
    KeyU: ["u", "U", "\u2193", "\u2191"],
    KeyV: ["v", "V", "\u201C", "\u2018"],
    KeyW: ["z", "Z", "\xab", "<"],
    KeyX: ["x", "X", "\xbb", ">"],
    KeyY: ["y", "Y", "\u2190", "\xa5"],
    KeyZ: ["w", "W", "\u0142", "\u0141"],
    Digit1: ["&", "1", "\xb9", "\xa1"],
    Digit2: ["\xe9", "2", "~", "\u215B"],
    Digit3: ['"', "3", "#", "\xa3"],
    Digit4: ["'", "4", "{", "$"],
    Digit5: ["(", "5", "[", "\u215C"],
    Digit6: ["-", "6", "|", "\u215D"],
    Digit7: ["\xe8", "7", "`", "\u215E"],
    Digit8: ["_", "8", "\\", "\u2122"],
    Digit9: ["\xe7", "9", "^", "\xb1"],
    Digit0: ["\xe0", "0", "@", "\xb0"],
    Enter: ["\r", "\r", "\r", "\r"],
    Escape: ["\x1b", "\x1b", "\x1b", "\x1b"],
    Backspace: ["\b", "\b", "\b", "\b"],
    Tab: ["\t", "", "\t", ""],
    Space: [" ", " ", " ", " "],
    Minus: [")", "\xb0", "]", "\xbf"],
    Equal: ["=", "+", "}", "\u0328"],
    BracketLeft: ["\u0302", "\u0308", "\u0308", "\u030A"],
    BracketRight: ["$", "\xa3", "\xa4", "\u0304"],
    Backslash: ["*", "\xb5", "\u0300", "\u0306"],
    Semicolon: ["m", "M", "\xb5", "\xba"],
    Quote: ["\xf9", "%", "\u0302", "\u030C"],
    Backquote: ["\xb2", "~", "\xac", "\xac"],
    Comma: [";", ".", "\u2500", "\xd7"],
    Period: [":", "/", "\xb7", "\xf7"],
    Slash: ["!", "\xa7", "\u0323", "\u0307"],
    NumpadMultiply: ["*", "*", "*", "*"],
    NumpadSubtract: ["-", "-", "-", "-"],
    NumpadAdd: ["+", "+", "+", "+"],
    NumpadDecimal: ["", ".", "", "."],
    IntlBackslash: ["<", ">", "|", "\xa6"]
  }
}), Oi({
  id: "windows.french",
  locale: "fr",
  displayName: "French",
  virtualLayout: "azerty",
  platform: "windows",
  score: 0,
  mapping: {
    KeyA: ["q", "Q", "", ""],
    KeyB: ["b", "B", "", ""],
    KeyC: ["c", "C", "", ""],
    KeyD: ["d", "D", "", ""],
    KeyE: ["e", "E", "\u20AC", ""],
    KeyF: ["f", "F", "", ""],
    KeyG: ["g", "G", "", ""],
    KeyH: ["h", "H", "", ""],
    KeyI: ["i", "I", "", ""],
    KeyJ: ["j", "J", "", ""],
    KeyK: ["k", "K", "", ""],
    KeyL: ["l", "L", "", ""],
    KeyM: [",", "?", "", ""],
    KeyN: ["n", "N", "", ""],
    KeyO: ["o", "O", "", ""],
    KeyP: ["p", "P", "", ""],
    KeyQ: ["a", "A", "", ""],
    KeyR: ["r", "R", "", ""],
    KeyS: ["s", "S", "", ""],
    KeyT: ["t", "T", "", ""],
    KeyU: ["u", "U", "", ""],
    KeyV: ["v", "V", "", ""],
    KeyW: ["z", "Z", "", ""],
    KeyX: ["x", "X", "", ""],
    KeyY: ["y", "Y", "", ""],
    KeyZ: ["w", "W", "", ""],
    Digit1: ["&", "1", "", ""],
    Digit2: ["\xe9", "2", "~", ""],
    Digit3: ['"', "3", "#", ""],
    Digit4: ["'", "4", "{", ""],
    Digit5: ["(", "5", "[", ""],
    Digit6: ["-", "6", "|", ""],
    Digit7: ["\xe8", "7", "`", ""],
    Digit8: ["_", "8", "\\", ""],
    Digit9: ["\xe7", "9", "^", ""],
    Digit0: ["\xe0", "0", "@", ""],
    Space: [" ", " ", "", ""],
    Minus: [")", "\xb0", "]", ""],
    Equal: ["=", "+", "}", ""],
    BracketLeft: ["^", "\xa8", "", ""],
    BracketRight: ["$", "\xa3", "\xa4", ""],
    Backslash: ["*", "\xb5", "", ""],
    Semicolon: ["m", "M", "", ""],
    Quote: ["\xf9", "%", "", ""],
    Backquote: ["\xb2", "", "", ""],
    Comma: [";", ".", "", ""],
    Period: [":", "/", "", ""],
    Slash: ["!", "\xa7", "", ""],
    NumpadDivide: ["/", "/", "", ""],
    NumpadMultiply: ["*", "*", "", ""],
    NumpadSubtract: ["-", "-", "", ""],
    NumpadAdd: ["+", "+", "", ""],
    IntlBackslash: ["<", ">", "", ""]
  }
}), Oi({
  id: "windows.german",
  locale: "de",
  displayName: "German",
  platform: "windows",
  virtualLayout: "qwertz",
  score: 0,
  mapping: {
    KeyA: ["a", "A", "", ""],
    KeyB: ["b", "B", "", ""],
    KeyC: ["c", "C", "", ""],
    KeyD: ["d", "D", "", ""],
    KeyE: ["e", "E", "\u20AC", ""],
    KeyF: ["f", "F", "", ""],
    KeyG: ["g", "G", "", ""],
    KeyH: ["h", "H", "", ""],
    KeyI: ["i", "I", "", ""],
    KeyJ: ["j", "J", "", ""],
    KeyK: ["k", "K", "", ""],
    KeyL: ["l", "L", "", ""],
    KeyM: ["m", "M", "\xb5", ""],
    KeyN: ["n", "N", "", ""],
    KeyO: ["o", "O", "", ""],
    KeyP: ["p", "P", "", ""],
    KeyQ: ["q", "Q", "@", ""],
    KeyR: ["r", "R", "", ""],
    KeyS: ["s", "S", "", ""],
    KeyT: ["t", "T", "", ""],
    KeyU: ["u", "U", "", ""],
    KeyV: ["v", "V", "", ""],
    KeyW: ["w", "W", "", ""],
    KeyX: ["x", "X", "", ""],
    KeyY: ["z", "Z", "", ""],
    KeyZ: ["y", "Y", "", ""],
    Digit1: ["1", "!", "", ""],
    Digit2: ["2", '"', "\xb2", ""],
    Digit3: ["3", "\xa7", "\xb3", ""],
    Digit4: ["4", "$", "", ""],
    Digit5: ["5", "%", "", ""],
    Digit6: ["6", "&", "", ""],
    Digit7: ["7", "/", "{", ""],
    Digit8: ["8", "(", "[", ""],
    Digit9: ["9", ")", "]", ""],
    Digit0: ["0", "=", "}", ""],
    Space: [" ", " ", "", ""],
    Minus: ["\xdf", "?", "\\", "\u1E9E"],
    Equal: ["\xb4", "`", "", ""],
    BracketLeft: ["\xfc", "\xdc", "", ""],
    BracketRight: ["+", "*", "~", ""],
    Backslash: ["#", "'", "", ""],
    Semicolon: ["\xf6", "\xd6", "", ""],
    Quote: ["\xe4", "\xc4", "", ""],
    Backquote: ["^", "\xb0", "", ""],
    Comma: [",", ";", "", ""],
    Period: [".", ":", "", ""],
    Slash: ["-", "_", "", ""],
    NumpadDivide: ["/", "/", "", ""],
    NumpadMultiply: ["*", "*", "", ""],
    NumpadSubtract: ["-", "-", "", ""],
    NumpadAdd: ["+", "+", "", ""],
    IntlBackslash: ["<", ">", "|", ""]
  }
}), Oi({
  id: "apple.german",
  locale: "de",
  displayName: "German",
  virtualLayout: "qwertz",
  platform: "apple",
  score: 0,
  mapping: {
    KeyA: ["a", "A", "\xe5", "\xc5"],
    KeyB: ["b", "B", "\u222B", "\u2039"],
    KeyC: ["c", "C", "\xe7", "\xc7"],
    KeyD: ["d", "D", "\u2202", "\u2122"],
    KeyE: ["e", "E", "\u20AC", "\u2030"],
    KeyF: ["f", "F", "\u0192", "\xcf"],
    KeyG: ["g", "G", "\xa9", "\xcc"],
    KeyH: ["h", "H", "\xaa", "\xd3"],
    KeyI: ["i", "I", "\u2044", "\xdb"],
    KeyJ: ["j", "J", "\xba", "\u0131"],
    KeyK: ["k", "K", "\u2206", "\u02C6"],
    KeyL: ["l", "L", "@", "\uFB02"],
    KeyM: ["m", "M", "\xb5", "\u02D8"],
    KeyN: ["n", "N", "~", "\u203A"],
    KeyO: ["o", "O", "\xf8", "\xd8"],
    KeyP: ["p", "P", "\u03C0", "\u220F"],
    KeyQ: ["q", "Q", "\xab", "\xbb"],
    KeyR: ["r", "R", "\xae", "\xb8"],
    KeyS: ["s", "S", "\u201A", "\xcd"],
    KeyT: ["t", "T", "\u2020", "\u02DD"],
    KeyU: ["u", "U", "\xa8", "\xc1"],
    KeyV: ["v", "V", "\u221A", "\u25CA"],
    KeyW: ["w", "W", "\u2211", "\u201E"],
    KeyX: ["x", "X", "\u2248", "\xd9"],
    KeyY: ["z", "Z", "\u03A9", "\u02C7"],
    KeyZ: ["y", "Y", "\xa5", "\u2021"],
    Digit1: ["1", "!", "\xa1", "\xac"],
    Digit2: ["2", '"', "\u201C", "\u201D"],
    Digit3: ["3", "\xa7", "\xb6", "#"],
    Digit4: ["4", "$", "\xa2", "\xa3"],
    Digit5: ["5", "%", "[", "\uFB01"],
    Digit6: ["6", "&", "]", "^"],
    Digit7: ["7", "/", "|", "\\"],
    Digit8: ["8", "(", "{", "\u02DC"],
    Digit9: ["9", ")", "}", "\xb7"],
    Digit0: ["0", "=", "\u2260", "\xaf"],
    Space: [" ", " ", " ", " "],
    Minus: ["\xdf", "?", "\xbf", "\u02D9"],
    Equal: ["\xb4", "`", "'", "\u02DA"],
    BracketLeft: ["\xfc", "\xdc", "\u2022", "\xb0"],
    BracketRight: ["+", "*", "\xb1", "\uF8FF"],
    Backslash: ["#", "'", "\u2018", "\u2019"],
    Semicolon: ["\xf6", "\xd6", "\u0153", "\u0152"],
    Quote: ["\xe4", "\xc4", "\xe6", "\xc6"],
    Backquote: ["<", ">", "\u2264", "\u2265"],
    Comma: [",", ";", "\u221E", "\u02DB"],
    Period: [".", ":", "\u2026", "\xf7"],
    Slash: ["-", "_", "\u2013", "\u2014"],
    NumpadDivide: ["/", "/", "/", "/"],
    NumpadMultiply: ["*", "*", "*", "*"],
    NumpadSubtract: ["-", "-", "-", "-"],
    NumpadAdd: ["+", "+", "+", "+"],
    NumpadDecimal: [",", ",", ".", "."],
    IntlBackslash: ["^", "\xb0", "\u201E", "\u201C"],
    NumpadEqual: ["=", "=", "=", "="]
  }
}), Oi({
  id: "dvorak",
  locale: "en",
  displayName: "Dvorak",
  virtualLayout: "dvorak",
  platform: "",
  score: 0,
  mapping: {
    KeyA: ["a", "A", "\xe5", "\xc5"],
    KeyB: ["x", "X", "\u2248", "\u02DB"],
    KeyC: ["j", "J", "\u2206", "\xd4"],
    KeyD: ["e", "E", "\xb4", "\xb4"],
    KeyE: [".", ">", "\u2265", "\u02D8"],
    KeyF: ["u", "U", "\xa8", "\xa8"],
    KeyG: ["i", "I", "\u02C6", "\u02C6"],
    KeyH: ["d", "D", "\u2202", "\xce"],
    KeyI: ["c", "C", "\xe7", "\xc7"],
    KeyJ: ["h", "H", "\u02D9", "\xd3"],
    KeyK: ["t", "T", "\u2020", "\u02C7"],
    KeyL: ["n", "N", "\u02DC", "\u02DC"],
    KeyM: ["m", "M", "\xb5", "\xc2"],
    KeyN: ["b", "B", "\u222B", "\u0131"],
    KeyO: ["r", "R", "\xae", "\u2030"],
    KeyP: ["l", "L", "\xac", "\xd2"],
    KeyQ: ["'", '"', "\xe6", "\xc6"],
    KeyR: ["p", "P", "\u03C0", "\u220F"],
    KeyS: ["o", "O", "\xf8", "\xd8"],
    KeyT: ["y", "Y", "\xa5", "\xc1"],
    KeyU: ["g", "G", "\xa9", "\u02DD"],
    KeyV: ["k", "K", "\u02DA", "\uF8FF"],
    KeyW: [",", "<", "\u2264", "\xaf"],
    KeyX: ["q", "Q", "\u0153", "\u0152"],
    KeyY: ["f", "F", "\u0192", "\xcf"],
    KeyZ: [";", ":", "\u2026", "\xda"],
    Digit1: ["1", "!", "\xa1", "\u2044"],
    Digit2: ["2", "@", "\u2122", "\u20AC"],
    Digit3: ["3", "#", "\xa3", "\u2039"],
    Digit4: ["4", "$", "\xa2", "\u203A"],
    Digit5: ["5", "%", "\u221E", "\uFB01"],
    Digit6: ["6", "^", "\xa7", "\uFB02"],
    Digit7: ["7", "&", "\xb6", "\u2021"],
    Digit8: ["8", "*", "\u2022", "\xb0"],
    Digit9: ["9", "(", "\xaa", "\xb7"],
    Digit0: ["0", ")", "\xba", "\u201A"],
    Space: [" ", " ", " ", " "],
    Minus: ["[", "{", "\u201C", "\u201D"],
    Equal: ["]", "}", "\u2018", "\u2019"],
    BracketLeft: ["/", "?", "\xf7", "\xbf"],
    BracketRight: ["=", "+", "\u2260", "\xb1"],
    Backslash: ["\\", "|", "\xab", "\xbb"],
    Semicolon: ["s", "S", "\xdf", "\xcd"],
    Quote: ["-", "_", "\u2013", "\u2014"],
    Backquote: ["`", "~", "`", "`"],
    Comma: ["w", "W", "\u2211", "\u201E"],
    Period: ["v", "V", "\u221A", "\u25CA"],
    Slash: ["z", "Z", "\u03A9", "\xb8"],
    NumpadDivide: ["/", "/", "/", "/"],
    NumpadMultiply: ["*", "*", "*", "*"],
    NumpadSubtract: ["-", "-", "-", "-"],
    NumpadAdd: ["+", "+", "+", "+"],
    Numpad1: ["1", "1", "1", "1"],
    Numpad2: ["2", "2", "2", "2"],
    Numpad3: ["3", "3", "3", "3"],
    Numpad4: ["4", "4", "4", "4"],
    Numpad5: ["5", "5", "5", "5"],
    Numpad6: ["6", "6", "6", "6"],
    Numpad7: ["7", "7", "7", "7"],
    Numpad8: ["8", "8", "8", "8"],
    Numpad9: ["9", "9", "9", "9"],
    Numpad0: ["0", "0", "0", "0"],
    NumpadDecimal: [".", ".", ".", "."],
    IntlBackslash: ["\xa7", "\xb1", "\xa7", "\xb1"],
    NumpadEqual: ["=", "=", "=", "="],
    AudioVolumeUp: ["", "=", "", "="]
  }
});
var Ri = {
    "\u2212": "-",
    "-": "-",
    "\\alpha": "alpha",
    "\\beta": "beta",
    "\\gamma": "gamma",
    "\\delta": "delta",
    "\\epsilon": "epsilon",
    "\\varepsilon": "varepsilon",
    "\\zeta": "zeta",
    "\\eta": "eta",
    "\\theta": "theta",
    "\\vartheta": "vartheta",
    "\\iota": "iota",
    "\\kappa": "kappa",
    "\\lambda": "lambda",
    "\\mu": "mu",
    "\\nu": "nu",
    "\\xi": "xi",
    "\\pi": "pi",
    "\\rho": "rho",
    "\\sigma": "sigma",
    "\\tau": "tau",
    "\\upsilon": "upsilon",
    "\\phi": "phi",
    "\\varphi": "varphi",
    "\\chi": "chi",
    "\\psi": "psi",
    "\\omega": "omega",
    "\\Gamma": "Gamma",
    "\\Delta": "Delta",
    "\\Theta": "Theta",
    "\\Lambda": "Lambda",
    "\\Xi": "Xi",
    "\\Pi": "Pi",
    "\\Sigma": "Sigma",
    "\\Phi": "Phi",
    "\\Psi": "Psi",
    "\\Omega": "Omega",
    "\\exponentialE": "e",
    "\\imaginaryI": "i",
    "\\imaginaryJ": "j"
  },
  Vi = {
    "\\pm": "+-",
    "\\times": "xx",
    "\\colon": ":",
    "\\vert": "|",
    "\\Vert": "||",
    "\\mid": "|",
    "\\lbrace": "{",
    "\\rbrace": "}",
    "\\lparen": "(",
    "\\rparen": ")",
    "\\langle": "(:",
    "\\rangle": ":)"
  };
function ji(t) {
  var i, r, n, a, o, s, l, c, u, d, h;
  if (!t) return "";
  if (e(t)) {
    var _e90 = "";
    if (0 === t.length) return "";
    if ("first" === t[0].type && (t = t.slice(1)), 0 === t.length) return "";
    if ("text" === t[0].mode) {
      var _r25 = 0;
      for (_e90 = '"'; "text" === (null === (i = t[_r25]) || void 0 === i ? void 0 : i.mode);) _e90 += t[_r25].body ? ji(t[_r25].body) : t[_r25].value, _r25++;
      _e90 += '"' + ji(t.slice(_r25));
    } else if ("math" === t[0].mode) {
      var _i77 = 0;
      for (; t[_i77] && "math" === t[_i77].mode;) _e90 += ji(t[_i77]), _i77++;
      _e90 += ji(t.slice(_i77));
    }
    return _e90.trim();
  }
  if ("text" === t.mode) return '"' + t.value + '"';
  var p = "";
  var _t83 = t,
    m = _t83.command;
  var f;
  switch (t.type) {
    case "first":
      return "";
    case "group":
    case "root":
      p = ji(t.body);
      break;
    case "genfrac":
      {
        var _e91 = t;
        (_e91.leftDelim || _e91.rightDelim) && (p += "." !== _e91.leftDelim && _e91.leftDelim ? _e91.leftDelim : "{:"), _e91.hasBarLine ? (p += "(", p += ji(_e91.above), p += ")/(", p += ji(_e91.below), p += ")") : (p += "(" + ji(_e91.above) + "),", p += "(" + ji(_e91.below) + ")"), (_e91.leftDelim || _e91.rightDelim) && (p += "." !== _e91.rightDelim && _e91.rightDelim ? _e91.rightDelim : "{:");
      }
      break;
    case "surd":
      p += t.hasEmptyBranch("above") ? "sqrt(" + ji(t.body) + ")" : "root(" + ji(t.above) + ")(" + ji(t.body) + ")";
      break;
    case "leftright":
      {
        var _e92 = t;
        p += "." !== _e92.leftDelim && _e92.leftDelim ? _e92.leftDelim : "{:", p += ji(_e92.body), p += "." !== _e92.rightDelim && _e92.rightDelim ? _e92.rightDelim : ":}";
      }
      break;
    case "sizeddelim":
    case "delim":
    case "overlap":
    case "overunder":
    case "box":
    case "spacing":
      break;
    case "mord":
      p = null !== (n = null !== (r = Ri[m]) && void 0 !== r ? r : m) && void 0 !== n ? n : "string" == typeof t.value ? t.value : "", p.startsWith("\\") && (p += " "), f = m ? m.match(/{?\\char"([\dabcdefABCDEF]*)}?/) : null, f ? p = String.fromCodePoint(Number.parseInt("0x" + f[1])) : p.length > 0 && p.startsWith("\\") && (p = "string" == typeof t.value ? t.value.charAt(0) : t.command);
      break;
    case "mbin":
    case "mrel":
    case "minner":
      p = null !== (o = null !== (a = Ri[m]) && void 0 !== a ? a : Vi[m]) && void 0 !== o ? o : t.value;
      break;
    case "mopen":
    case "mclose":
      p += t.value;
      break;
    case "mpunct":
      p = null !== (s = Vi[m]) && void 0 !== s ? s : m;
      break;
    case "mop":
      "\u200B" !== t.value && (p = "", p += "\\operatorname" === m ? ji(t.body) : null !== (l = t.value) && void 0 !== l ? l : m, p += " ");
      break;
    case "array":
      var _e93 = t.array,
        _i78 = t.environmentName,
        _g = null !== (c = {
          bmatrix: ["[", "]"],
          "bmatrix*": ["[", "]"]
        }[_i78]) && void 0 !== c ? c : ["(", ")"],
        _y = [];
      var _iterator53 = _createForOfIteratorHelper(_e93),
        _step53;
      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var _t84 = _step53.value;
          var _e94 = [];
          var _iterator54 = _createForOfIteratorHelper(_t84),
            _step54;
          try {
            for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
              var _i79 = _step54.value;
              _e94.push(_g[0] + ji(_i79) + _g[1]);
            }
          } catch (err) {
            _iterator54.e(err);
          } finally {
            _iterator54.f();
          }
          _y.push(_e94.join(","));
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
      var _b = null !== (u = {
        bmatrix: ["[", "]"],
        "bmatrix*": ["[", "]"],
        cases: ["{", ":}"]
      }[_i78]) && void 0 !== u ? u : ["(", ")"];
      p = _b[0] + _y.join(",") + _b[1];
      break;
    case "enclose":
      p = "(" + ji(t.body) + ")";
      break;
    case "space":
      p = " ";
      break;
    case "msubsup":
      p = "";
      break;
    case "macro":
      p = null !== (h = null !== (d = Ri[m]) && void 0 !== d ? d : Vi[m]) && void 0 !== h ? h : ji(t.body);
  }
  if (!t.hasEmptyBranch("subscript")) {
    p += "_";
    var _e95 = ji(t.subscript);
    p += _e95.length > 1 ? "(" + _e95 + ")" : _e95;
  }
  if (!t.hasEmptyBranch("superscript")) {
    p += "^";
    var _e96 = ji(t.superscript);
    p += _e96.length > 1 ? "(" + _e96 + ")" : _e96;
  }
  return p;
}
function Hi(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "math";
  var i = new rt("root", {
    mode: "math"
  });
  return i.body = zt(e, {
    parseMode: t
  }), ji(i);
}
function Ui(e) {
  return di(e, {
    format: "ascii-math"
  })[1];
}
var Wi = {
    latexToAsciiMath: Hi,
    asciiMathToLatex: Ui,
    FUNCTIONS: Ne,
    MATH_SYMBOLS: Ce,
    TEXT_SYMBOLS: De,
    ENVIRONMENTS: ze,
    DEFAULT_KEYBINDINGS: Li,
    getKeybindingMarkup: $i
  },
  Zi = {
    "\\pm": "&#177;",
    "\\times": "&#215;",
    "\\colon": ":",
    "\\vert": "|",
    "\\Vert": "\u2225",
    "\\mid": "\u2223",
    "\\lbrace": "{",
    "\\rbrace": "}",
    "\\lparen": "(",
    "\\rparen": ")",
    "\\langle": "\u27E8",
    "\\rangle": "\u27E9",
    "\\lfloor": "\u230A",
    "\\rfloor": "\u230B",
    "\\lceil": "\u2308",
    "\\rceil": "\u2309",
    "\\vec": "&#x20d7;",
    "\\acute": "&#x00b4;",
    "\\grave": "&#x0060;",
    "\\dot": "&#x02d9;",
    "\\ddot": "&#x00a8;",
    "\\tilde": "&#x007e;",
    "\\bar": "&#x00af;",
    "\\breve": "&#x02d8;",
    "\\check": "&#x02c7;",
    "\\hat": "&#x005e;"
  };
function Gi(e) {
  return e.replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Xi(e, t) {
  return e && t.generateID ? ' extid="' + e + '"' : "";
}
function Yi(e, t, i) {
  var r = !1;
  t = t || e.atoms.length;
  var n = "",
    a = "";
  var o = e.atoms[e.index];
  return e.index < t && "mord" === o.type && !"0123456789,.".includes(o.value) && (a = sr(o, i), e.index += 1), a.length > 0 && (r = !0, n = a, "mi" !== e.lastType && "mn" !== e.lastType && "mtext" !== e.lastType && "fence" !== e.lastType || /^<mo>(.*)<\/mo>$/.test(n) || (n = "<mo>&#8290;</mo>".concat(n)), a.endsWith(">f</mi>") || a.endsWith(">g</mi>") ? (n += "<mo>&#x2061;</mo>", e.lastType = "applyfunction") : e.lastType = /^<mo>(.*)<\/mo>$/.test(n) ? "mo" : "mi", Ji(a, e, i) || (e.mathML += n)), r;
}
function Qi(e) {
  return e.index < e.atoms.length && e.atoms[e.index].superscript && "msubsup" === e.atoms[e.index].type;
}
function Ji(e, t, i) {
  var r = !1,
    n = "",
    a = t.atoms[t.index - 1];
  if (!a) return !1;
  if (a.superscript || a.subscript || (Qi(t) || function (e) {
    return e.index < e.atoms.length && e.atoms[e.index].subscript && "msubsup" === e.atoms[e.index].type;
  }(t)) && (a = t.atoms[t.index], t.index += 1), !a) return !1;
  var o = nr(a.superscript, 0, 0, i).mathML,
    s = nr(a.subscript, 0, 0, i).mathML;
  return o && s ? n = "<msubsup>".concat(e).concat(s).concat(o, "</msubsup>") : o ? n = "<msup>".concat(e).concat(o, "</msup>") : s && (n = "<msub>".concat(e).concat(s, "</msub>")), n.length > 0 && (r = !0, t.mathML += n, t.lastType = ""), r;
}
function er(e, t, i) {
  var r = !1;
  t = t || e.atoms.length;
  var n = e.index;
  var a = "";
  for (; e.index < t && "text" === e.atoms[e.index].mode;) a += e.atoms[e.index].value ? e.atoms[e.index].value : " ", e.index += 1;
  return a.length > 0 && (r = !0, a = "<mtext" + Xi(e.atoms[n].id, i) + ">" + a + "</mtext>", e.mathML += a, e.lastType = "mtext"), r;
}
function tr(e, t, i) {
  var r = !1;
  t = t || e.atoms.length;
  var n = e.index;
  var a = "",
    o = function (e) {
      var t = -1,
        i = e.index,
        r = !1,
        n = !1;
      for (; i < e.atoms.length && !r && !n;) r = "mord" !== e.atoms[i].type || !"0123456789,.".includes(e.atoms[i].body), n = !r && e.atoms[i].superscript, i++;
      return n && (t = i - 1), t;
    }(e);
  for (o >= 0 && o < t && (t = o); e.index < t && "mord" === e.atoms[e.index].type && "0123456789,.".includes(e.atoms[e.index].value);) a += e.atoms[e.index].value, e.index += 1;
  return a.length > 0 && (r = !0, a = "<mn" + Xi(e.atoms[n].id, i) + ">" + a + "</mn>", o < 0 && Qi(e) && (o = e.index, e.index += 1), Ji(a, e, i) || (e.mathML += a, e.lastType = "mn")), r;
}
function ir(e, t, i) {
  var r = !1;
  t = t || e.atoms.length;
  var n = "",
    a = "";
  if (e.index < t && "mopen" === e.atoms[e.index].type) {
    var _o12 = !1,
      _s9 = 0;
    var _l5 = e.index;
    var _c3 = -1,
      _u2 = _l5 + 1;
    for (; _u2 < t && !_o12;) "mopen" === e.atoms[_u2].type ? _s9 += 1 : "mclose" === e.atoms[_u2].type && (_s9 -= 1), -1 === _s9 && (_o12 = !0, _c3 = _u2), _u2 += 1;
    _o12 && (n = "<mrow>", n += ar(e.atoms[_l5], i), n += nr(e.atoms, _l5 + 1, _c3, i).mathML, n += ar(e.atoms[_c3], i), n += "</mrow>", "mi" !== e.lastType && "mn" !== e.lastType && "mfrac" !== e.lastType && "fence" !== e.lastType || (n = "<mo>&#8290;</mo>".concat(n)), e.index = _c3 + 1, Ji(n, e, i) && (r = !0, e.lastType = "", n = ""), a = "fence");
  }
  return n.length > 0 && (r = !0, e.mathML += n, e.lastType = a), r;
}
function rr(e, t, i) {
  var r = !1;
  t = t || e.atoms.length;
  var n = "",
    a = "";
  var o = e.atoms[e.index];
  if (e.index < t && ("mbin" === o.type || "mrel" === o.type)) n += sr(e.atoms[e.index], i), e.index += 1, a = "mo";else if (e.index < t && "mop" === o.type) {
    if ("over-under" === o.subsupPlacement && (o.superscript || o.subscript)) {
      var _e97 = ar(o, i);
      o.superscript && o.subscript ? (n += "<munderover>" + _e97, n += nr(o.subscript, 0, 0, i).mathML, n += nr(o.superscript, 0, 0, i).mathML, n += "</munderover>") : o.superscript ? (n += "<mover>" + _e97, n += nr(o.superscript, 0, 0, i).mathML, n += "</mover>") : (n += "<munder>" + _e97, n += nr(o.subscript, 0, 0, i).mathML, n += "</munder>"), a = "mo";
    } else {
      var _t85 = e.atoms[e.index],
        _o13 = "\\operatorname" === _t85.symbol,
        _s10 = _o13 ? '<mi class="MathML-Unit"' + Xi(_t85.id, i) + ">" + or(_t85.value) + "</mi>" : ar(_t85, i);
      n += _s10, e.index += 1, Ji(n, e, i) && (r = !0, e.lastType = "", n = ""), e.index -= 1, _o13 || /^<mo>(.*)<\/mo>$/.test(_s10) ? a = _o13 ? "mi" : "mo" : (n += "<mo>&#x2061;</mo>", a = "applyfunction");
    }
    "mi" !== e.lastType && "mn" !== e.lastType || /^<mo>(.*)<\/mo>$/.test(n) || (n = "<mo>&#8290;</mo>".concat(n)), e.index += 1;
  }
  return Ji(n, e, i) || n.length > 0 && (r = !0, e.mathML += n, e.lastType = a), r;
}
function nr(e, t, i, r) {
  var n = {
    atoms: e,
    index: null != t ? t : 0,
    mathML: "",
    lastType: ""
  };
  if ("number" == typeof e || "boolean" == typeof e) n.mathML = e.toString();else if ("string" == typeof e) n.mathML = e;else if (e instanceof rt) n.mathML = sr(e, r);else if (Array.isArray(e)) {
    var _t86 = 0;
    for (i = i || (e ? e.length : 0); n.index < i;) if (er(n, i, r) || tr(n, i, r) || Yi(n, i, r) || rr(n, i, r) || ir(n, i, r)) _t86 += 1;else if (n.index < i) {
      var _e98 = sr(n.atoms[n.index], r);
      "mn" === n.lastType && _e98.length > 0 && "genfrac" === n.atoms[n.index].type && (_e98 = "<mo>&#x2064;</mo>" + _e98), "genfrac" === n.atoms[n.index].type ? n.lastType = "mfrac" : n.lastType = "", _e98.length > 0 && (n.mathML += _e98, _t86 += 1), n.index += 1;
    }
    _t86 > 1 && (n.mathML = "<mrow>" + n.mathML + "</mrow>");
  }
  return n;
}
function ar(e, t) {
  var i = "";
  var r = or(e.value);
  return r && (i = "<mo" + Xi(e.id, t) + ">" + r + "</mo>"), i;
}
function or(e) {
  if (!e) return "";
  if ("string" == typeof e) return Gi(e);
  if (!Array.isArray(e) && "string" == typeof e.body) return Gi(e.body);
  var t = "";
  var _iterator55 = _createForOfIteratorHelper(e),
    _step55;
  try {
    for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
      var _i80 = _step55.value;
      "string" == typeof _i80.value && (t += _i80.value);
    }
  } catch (err) {
    _iterator55.e(err);
  } finally {
    _iterator55.f();
  }
  return Gi(t);
}
function sr(e, t) {
  var i, r, n, a, o, s, l, c, u, d, h, p, m, f;
  var g = {
      widehat: "^",
      widecheck: "\u02C7",
      widetilde: "~",
      utilde: "~",
      overleftarrow: "\u2190",
      underleftarrow: "\u2190",
      xleftarrow: "\u2190",
      overrightarrow: "\u2192",
      underrightarrow: "\u2192",
      xrightarrow: "\u2192",
      underbrace: "\u23DF",
      overbrace: "\u23DE",
      overgroup: "\u23E0",
      undergroup: "\u23E1",
      overleftrightarrow: "\u2194",
      underleftrightarrow: "\u2194",
      xleftrightarrow: "\u2194",
      Overrightarrow: "\u21D2",
      xRightarrow: "\u21D2",
      overleftharpoon: "\u21BC",
      xleftharpoonup: "\u21BC",
      overrightharpoon: "\u21C0",
      xrightharpoonup: "\u21C0",
      xLeftarrow: "\u21D0",
      xLeftrightarrow: "\u21D4",
      xhookleftarrow: "\u21A9",
      xhookrightarrow: "\u21AA",
      xmapsto: "\u21A6",
      xrightharpoondown: "\u21C1",
      xleftharpoondown: "\u21BD",
      xrightleftharpoons: "\u21CC",
      xleftrightharpoons: "\u21CB",
      xtwoheadleftarrow: "\u219E",
      xtwoheadrightarrow: "\u21A0",
      xlongequal: "=",
      xtofrom: "\u21C4",
      xrightleftarrows: "\u21C4",
      xrightequilibrium: "\u21CC",
      xleftequilibrium: "\u21CB"
    },
    y = {
      "\\exponentialE": "&#x02147;",
      "\\imaginaryI": "&#x2148;",
      "\\differentialD": "&#x2146;",
      "\\capitalDifferentialD": "&#x2145;",
      "\\alpha": "&#x03b1;",
      "\\pi": "&#x03c0;",
      "\\infty": "&#x221e;",
      "\\forall": "&#x2200;",
      "\\nexists": "&#x2204;",
      "\\exists": "&#x2203;",
      "\\hbar": "\u210F",
      "\\cdotp": "\u22C5",
      "\\ldots": "\u2026",
      "\\cdots": "\u22EF",
      "\\ddots": "\u22F1",
      "\\vdots": "\u22EE",
      "\\ldotp": "."
    },
    b = {
      "\\!": -3 / 18,
      "\\ ": 6 / 18,
      "\\,": 3 / 18,
      "\\:": 4 / 18,
      "\\;": 5 / 18,
      "\\enspace": .5,
      "\\quad": 1,
      "\\qquad": 2,
      "\\enskip": .5
    };
  var v,
    x,
    k,
    w,
    _,
    M,
    S = "",
    L = "",
    C = {
      cal: "script",
      frak: "fraktur",
      bb: "double-struck",
      scr: "script",
      cmtt: "monospace",
      cmss: "sans-serif"
    }[e.fontFamily || e.font] || "";
  C && (C = ' mathvariant="' + C + '"');
  var A = e.command;
  if ("text" === e.mode) S = "<mi" + Xi(e.id, t) + ">" + e.value + "</mi>";else switch (e.type) {
    case "first":
    case "line":
    case "overlap":
    case "msubsup":
    case "phantom":
    case "composition":
    case "rule":
    case "chem":
    case "error":
      break;
    case "group":
    case "root":
      S = nr(e.body, 0, 0, t).mathML;
      break;
    case "array":
      if ((e.leftDelim && "." !== e.leftDelim || e.rightDelim && "." !== e.rightDelim) && (S += "<mrow>", e.leftDelim && "." !== e.leftDelim && (S += "<mo>" + (Zi[e.leftDelim] || e.leftDelim) + "</mo>")), S += "<mtable", e.colFormat) {
        for (S += ' columnalign="', k = 0; k < e.colFormat.length; k++) e.colFormat[k].align && (S += {
          l: "left",
          c: "center",
          r: "right"
        }[e.colFormat[k].align] + " ");
        S += '"';
      }
      for (S += ">", x = 0; x < e.array.length; x++) {
        for (S += "<mtr>", v = 0; v < e.array[x].length; v++) S += "<mtd>" + nr(e.array[x][v], 0, 0, t).mathML + "</mtd>";
        S += "</mtr>";
      }
      S += "</mtable>", (e.leftDelim && "." !== e.leftDelim || e.rightDelim && "." !== e.rightDelim) && (e.rightDelim && "." !== e.rightDelim && (S += "<mo>" + (Zi[e.leftDelim] || e.rightDelim) + "</mo>"), S += "</mrow>");
      break;
    case "genfrac":
      (e.leftDelim || e.rightDelim) && (S += "<mrow>"), e.leftDelim && "." !== e.leftDelim && (S += "<mo" + Xi(e.id, t) + ">" + (Zi[e.leftDelim] || e.leftDelim) + "</mo>"), e.hasBarLine ? (S += "<mfrac>", S += nr(e.above, 0, 0, t).mathML || "<mi>&nbsp;</mi>", S += nr(e.below, 0, 0, t).mathML || "<mi>&nbsp;</mi>", S += "</mfrac>") : (S += "<mtable" + Xi(e.id, t) + ">", S += "<mtr>" + nr(e.above, 0, 0, t).mathML + "</mtr>", S += "<mtr>" + nr(e.below, 0, 0, t).mathML + "</mtr>", S += "</mtable>"), e.rightDelim && "." !== e.rightDelim && (S += "<mo" + Xi(e.id, t) + ">" + (Zi[e.rightDelim] || e.rightDelim) + "</mo>"), (e.leftDelim || e.rightDelim) && (S += "</mrow>");
      break;
    case "surd":
      e.hasEmptyBranch("above") ? (S += "<msqrt" + Xi(e.id, t) + ">", S += nr(e.body, 0, 0, t).mathML, S += "</msqrt>") : (S += "<mroot" + Xi(e.id, t) + ">", S += nr(e.body, 0, 0, t).mathML, S += nr(e.above, 0, 0, t).mathML, S += "</mroot>");
      break;
    case "leftright":
      S = "<mrow>", e.leftDelim && "." !== e.leftDelim && (S += "<mo" + Xi(e.id, t) + ">" + (null !== (i = Zi[e.leftDelim]) && void 0 !== i ? i : e.leftDelim) + "</mo>"), e.body && (S += nr(e.body, 0, 0, t).mathML), e.rightDelim && "." !== e.rightDelim && (S += "<mo" + Xi(e.id, t) + ">" + (null !== (r = Zi[e.rightDelim]) && void 0 !== r ? r : e.rightDelim) + "</mo>"), S += "</mrow>";
      break;
    case "sizeddelim":
    case "delim":
      S += '<mo separator="true"' + Xi(e.id, t) + ">" + (Zi[e.delim] || e.delim) + "</mo>";
      break;
    case "accent":
      S += '<mover accent="true"' + Xi(e.id, t) + ">", S += nr(e.body, 0, 0, t).mathML, S += "<mo>" + (Zi[A] || e.accent) + "</mo>", S += "</mover>";
      break;
    case "overunder":
      _ = e.above, w = e.below, (e.svgAbove || _) && (e.svgBelow || w) ? M = e.body : _ && _.length > 0 ? (M = e.body, (null === (a = null === (n = e.body) || void 0 === n ? void 0 : n[0]) || void 0 === a ? void 0 : a.below) ? (w = e.body[0].below, M = e.body[0].body) : "first" === (null === (s = null === (o = e.body) || void 0 === o ? void 0 : o[0]) || void 0 === s ? void 0 : s.type) && (null === (c = null === (l = e.body) || void 0 === l ? void 0 : l[1]) || void 0 === c ? void 0 : c.below) && (w = e.body[1].below, M = e.body[1].body)) : w && w.length > 0 && (M = e.body, (null === (d = null === (u = e.body) || void 0 === u ? void 0 : u[0]) || void 0 === d ? void 0 : d.above) ? (_ = e.body[0].above, M = e.body[0].body) : "first" === (null === (p = null === (h = e.body) || void 0 === h ? void 0 : h[0]) || void 0 === p ? void 0 : p.type) && (null === (f = null === (m = e.body) || void 0 === m ? void 0 : m[1]) || void 0 === f ? void 0 : f.above) && (_ = e.body[1].overscript, M = e.body[1].body)), (e.svgAbove || _) && (e.svgBelow || w) ? (S += "<munderover ".concat(C, " ").concat(Xi(e.id, t), ">"), S += g[e.svgBody] || nr(M, 0, 0, t).mathML, S += g[e.svgBelow] || nr(w, 0, 0, t).mathML, S += g[e.svgAbove] || nr(_, 0, 0, t).mathML, S += "</munderover>") : e.svgAbove || _ ? (S += "<mover ".concat(C, " ").concat(Xi(e.id, t), ">") + (g[e.svgBody] || nr(M, 0, 0, t).mathML), S += g[e.svgAbove] || nr(_, 0, 0, t).mathML, S += "</mover>") : (e.svgBelow || w) && (S += "<munder ".concat(C, " ").concat(Xi(e.id, t), ">") + (g[e.svgBody] || nr(M, 0, 0, t).mathML), S += g[e.svgBelow] || nr(w, 0, 0, t).mathML, S += "</munder>");
      break;
    case "placeholder":
    case "mord":
      {
        S = y[A] || A || ("string" == typeof e.value ? e.value : "");
        var _i81 = A ? A.match(/{?\\char"([\dabcdefABCDEF]*)}?/) : null;
        _i81 ? S = "&#x" + _i81[1] + ";" : S.length > 0 && S.startsWith("\\") && (S = "string" == typeof e.value && e.value.charCodeAt(0) > 255 ? "&#x" + ("000000" + e.value.charCodeAt(0).toString(16)).slice(-4) + ";" : "string" == typeof e.value ? e.value.charAt(0) : "");
        var _r26 = /\d/.test(S) ? "mn" : "mi";
        S = "<" + _r26 + C + Xi(e.id, t) + ">" + Gi(S) + "</" + _r26 + ">";
        break;
      }
    case "mbin":
    case "mrel":
    case "minner":
      S = A && y[A] ? "<mi" + Xi(e.id, t) + ">" + y[A] + "</mi>" : A && Zi[A] ? "<mo" + Xi(e.id, t) + ">" + Zi[A] + "</mo>" : ar(e, t);
      break;
    case "mpunct":
      S = '<mo separator="true"' + Xi(e.id, t) + ">" + (Zi[A] || A) + "</mo>";
      break;
    case "mop":
      "\u200B" !== e.body && (S = "<mo" + Xi(e.id, t) + ">", S += "\\operatorname" === A ? e.body : A || e.body, S += "</mo>");
      break;
    case "box":
      S = '<menclose notation="box"', e.backgroundcolor && (S += ' mathbackground="' + e.backgroundcolor + '"'), S += Xi(e.id, t) + ">" + nr(e.body, 0, 0, t).mathML + "</menclose>";
      break;
    case "spacing":
      S += '<mspace width="' + (b[A] || 0) + 'em"/>';
      break;
    case "enclose":
      S = '<menclose notation="';
      for (var _t87 in e.notation) Object.prototype.hasOwnProperty.call(e.notation, _t87) && e.notation[_t87] && (S += L + _t87, L = " ");
      S += Xi(e.id, t) + '">' + nr(e.body, 0, 0, t).mathML + "</menclose>";
      break;
    case "space":
      S += "&nbsp;";
      break;
    case "mopen":
    case "mclose":
      S += ar(e, t);
      break;
    case "macro":
      {
        var _i82 = or(e.macroLatex);
        _i82 && (S += "<mo ".concat(Xi(e.id, t), ">").concat(_i82, "</mo>"));
      }
  }
  return S;
}
function lr(e, t) {
  return nr(e, 0, 0, t).mathML;
}
var cr = {
  "\\alpha": "alpha ",
  "\\mu": "mew ",
  "\\sigma": "sigma ",
  "\\pi": "pie ",
  "\\imaginaryI": "eye ",
  "\\sum": "Summation ",
  "\\prod": "Product ",
  a: "<phoneme alphabet=\"ipa\" ph=\"e\u026A\">a</phoneme>",
  A: "capital <phoneme alphabet=\"ipa\" ph=\"e\u026A\">A</phoneme>",
  "+": "plus ",
  "-": "minus ",
  ";": '<break time="150ms"/> semi-colon <break time="150ms"/>',
  ",": '<break time="150ms"/> comma  <break time="150ms"/>',
  "|": '<break time="150ms"/>Vertical bar<break time="150ms"/>',
  "(": '<break time="150ms"/>Open paren. <break time="150ms"/>',
  ")": '<break time="150ms"/> Close paren. <break time="150ms"/>',
  "=": "equals ",
  "<": "is less than ",
  "\\lt": "is less than ",
  "<=": "is less than or equal to ",
  "\\le": "is less than or equal to ",
  "\\gt": "is greater than ",
  ">": "is greater than ",
  "\\ge": "is greater than or equal to ",
  "\\geq": "is greater than or equal to ",
  "\\leq": "is less than or equal to ",
  "!": "factorial ",
  "\\sin": "sine ",
  "\\cos": "cosine ",
  "\u200B": "",
  "\u2212": "minus ",
  ":": '<break time="150ms"/> such that <break time="200ms"/> ',
  "\\colon": '<break time="150ms"/> such that <break time="200ms"/> ',
  "\\hbar": "etch bar ",
  "\\iff": '<break time="200ms"/>if, and only if, <break time="200ms"/>',
  "\\Longleftrightarrow": '<break time="200ms"/>if, and only if, <break time="200ms"/>',
  "\\land": "and ",
  "\\lor": "or ",
  "\\neg": "not ",
  "\\div": "divided by ",
  "\\forall": "for all ",
  "\\exists": "there exists ",
  "\\nexists": "there does not exists ",
  "\\in": "element of ",
  "\\N": 'the set <break time="150ms"/><say-as interpret-as="character">n</say-as>',
  "\\C": 'the set <break time="150ms"/><say-as interpret-as="character">c</say-as>',
  "\\Z": 'the set <break time="150ms"/><say-as interpret-as="character">z</say-as>',
  "\\Q": 'the set <break time="150ms"/><say-as interpret-as="character">q</say-as>',
  "\\infty": "infinity ",
  "\\nabla": "nabla ",
  "\\partial": "partial derivative of ",
  "\\cdot": "times ",
  "\\cdots": "dot dot dot ",
  "\\Rightarrow": "implies ",
  "\\lparen": '<break time="150ms"/>open paren<break time="150ms"/>',
  "\\rparen": '<break time="150ms"/>close paren<break time="150ms"/>',
  "\\lbrace": '<break time="150ms"/>open brace<break time="150ms"/>',
  "\\{": '<break time="150ms"/>open brace<break time="150ms"/>',
  "\\rbrace": '<break time="150ms"/>close brace<break time="150ms"/>',
  "\\}": '<break time="150ms"/>close brace<break time="150ms"/>',
  "\\langle": '<break time="150ms"/>left angle bracket<break time="150ms"/>',
  "\\rangle": '<break time="150ms"/>right angle bracket<break time="150ms"/>',
  "\\lfloor": '<break time="150ms"/>open floor<break time="150ms"/>',
  "\\rfloor": '<break time="150ms"/>close floor<break time="150ms"/>',
  "\\lceil": '<break time="150ms"/>open ceiling<break time="150ms"/>',
  "\\rceil": '<break time="150ms"/>close ceiling<break time="150ms"/>',
  "\\vert": '<break time="150ms"/>vertical bar<break time="150ms"/>',
  "\\mvert": '<break time="150ms"/>divides<break time="150ms"/>',
  "\\lvert": '<break time="150ms"/>left vertical bar<break time="150ms"/>',
  "\\rvert": '<break time="150ms"/>right vertical bar<break time="150ms"/>',
  "\\lbrack": '<break time="150ms"/> open square bracket <break time="150ms"/>',
  "\\rbrack": '<break time="150ms"/> close square bracket <break time="150ms"/>',
  mm: "millimeters",
  cm: "centimeters",
  km: "kilometers",
  kg: "kilograms"
};
function ur(t) {
  var i = 0;
  if (e(t)) {
    var _iterator56 = _createForOfIteratorHelper(t),
      _step56;
    try {
      for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
        var _e99 = _step56.value;
        "first" !== _e99.type && (i += 1);
      }
    } catch (err) {
      _iterator56.e(err);
    } finally {
      _iterator56.f();
    }
  }
  return 1 === i;
}
function dr(t) {
  var i = "";
  if (e(t)) {
    var _iterator57 = _createForOfIteratorHelper(t),
      _step57;
    try {
      for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
        var _e100 = _step57.value;
        "first" !== _e100.type && "string" == typeof _e100.value && (i += _e100.value);
      }
    } catch (err) {
      _iterator57.e(err);
    } finally {
      _iterator57.f();
    }
  }
  return i;
}
function hr(t, i, r) {
  var n, a, o, s;
  function l(e) {
    return "<emphasis>" + e + "</emphasis>";
  }
  if (!i) return "";
  var c = "";
  if (e(i)) {
    var _e101 = !1,
      _a13 = !1;
    for (var _o14 = 0; _o14 < i.length; _o14++) "text" !== i[_o14].mode && (_a13 = !1), _o14 < i.length - 2 && "mopen" === i[_o14].type && "mclose" === i[_o14 + 2].type && "mord" === i[_o14 + 1].type ? (c += " of ", c += l(hr(t, i[_o14 + 1], r)), _o14 += 2) : "text" === i[_o14].mode ? _a13 ? c += null !== (n = i[_o14].value) && void 0 !== n ? n : " " : (_a13 = !0, c += hr("text", i[_o14], r)) : "mord" === i[_o14].type && /[0123456789,.]/.test(i[_o14].value) ? _e101 ? c += i[_o14].value : (_e101 = !0, c += hr(t, i[_o14], r)) : (_e101 = !1, c += hr(t, i[_o14], r));
  } else if ("text" === i.mode) i.id && "math" === t && (c += '<mark name="' + i.id.toString() + '"/>'), c += i.value;else {
    i.id && "math" === t && (c += '<mark name="' + i.id.toString() + '"/>');
    var _n19 = "",
      _d = "",
      _h = "",
      _p2 = !1;
    switch (i.type) {
      case "group":
      case "root":
        c += hr("math", i.body, r);
        break;
      case "genfrac":
        if (_n19 = hr("math", i.above, r), _d = hr("math", i.below, r), ur(i.above) && ur(i.below)) {
          var _e102 = {
            "1/2": " half ",
            "1/3": " one third ",
            "2/3": " two third",
            "1/4": " one quarter ",
            "3/4": " three quarter ",
            "1/5": " one fifth ",
            "2/5": " two fifths ",
            "3/5": " three fifths ",
            "4/5": " four fifths ",
            "1/6": " one sixth ",
            "5/6": " five sixths ",
            "1/8": " one eight ",
            "3/8": " three eights ",
            "5/8": " five eights ",
            "7/8": " seven eights ",
            "1/9": " one ninth ",
            "2/9": " two ninths ",
            "4/9": " four ninths ",
            "5/9": " five ninths ",
            "7/9": " seven ninths ",
            "8/9": " eight ninths "
          }[dr(i.above) + "/" + dr(i.below)];
          _e102 ? c = _e102 : c += _n19 + " over " + _d;
        } else c += ' the fraction <break time="150ms"/>' + _n19 + ', over <break time="150ms"/>' + _d + '.<break time="150ms"/> End fraction.<break time="150ms"/>';
        break;
      case "surd":
        if (_h = hr("math", i.body, r), i.hasEmptyBranch("above")) c += ur(i.body) ? " the square root of " + _h + " , " : ' the square root of <break time="200ms"/>' + _h + '. <break time="200ms"/> End square root';else {
          var _e103 = hr("math", i.above, r);
          _e103 = _e103.trim();
          var _t88 = _e103.replace(/<mark([^/]*)\/>/g, "");
          c += "3" === _t88 ? ' the cube root of <break time="200ms"/>' + _h + '. <break time="200ms"/> End cube root' : "n" === _t88 ? ' the nth root of <break time="200ms"/>' + _h + '. <break time="200ms"/> End root' : ' the root with index: <break time="200ms"/>' + _e103 + ', of <break time="200ms"/>' + _h + '. <break time="200ms"/> End root';
        }
        break;
      case "leftright":
        {
          var _e104 = i;
          c += null !== (a = _e104.leftDelim ? cr[_e104.leftDelim] : void 0) && void 0 !== a ? a : _e104.leftDelim, c += hr("math", i.body, r), c += null !== (o = _e104.rightDelim ? cr[_e104.rightDelim] : void 0) && void 0 !== o ? o : _e104.rightDelim;
        }
        break;
      case "rule":
      case "overunder":
      case "overlap":
        break;
      case "placeholder":
        c += "placeholder ";
        break;
      case "delim":
      case "sizeddelim":
      case "mord":
      case "minner":
      case "mbin":
      case "mrel":
      case "mpunct":
      case "mopen":
      case "mclose":
        {
          var _e105 = i.command;
          if ("\\mathbin" === _e105 || "\\mathrel" === _e105 || "\\mathopen" === _e105 || "\\mathclose" === _e105 || "\\mathpunct" === _e105 || "\\mathord" === _e105 || "\\mathinner" === _e105) {
            c = hr(t, i.body, r);
            break;
          }
          var _n20 = i.value,
            _a14 = i.command;
          if ("delim" !== i.type && "sizeddelim" !== i.type || (_a14 = i.value, _n20 = _a14), "text" === t) c += _n20;else {
            if ("mbin" === i.type && (c += '<break time="150ms"/>'), _n20) {
              var _e106 = cr[_n20] || (_a14 ? cr[_a14.trim()] : "");
              if (_e106) c += " " + _e106;else {
                var _e107 = _a14 ? function (e) {
                  var t = "";
                  return e.startsWith("\\") && (t = " " + e.replace("\\", "") + " "), t;
                }(_a14.trim()) : "";
                c += _e107 || function (e) {
                  var t = "";
                  return r.textToSpeechMarkup ? /[a-z]/.test(e) ? t += ' <say-as interpret-as="character">' + e + "</say-as>" : /[A-Z]/.test(e) ? t += String("capital " + e.toLowerCase()) : t += e : /[a-z]/.test(e) ? t += " '" + e.toUpperCase() + "'" : /[A-Z]/.test(e) ? t += " 'capital " + e.toUpperCase() + "'" : t += e, t;
                }(_n20);
              }
            } else c += hr("math", i.body, r);
            "mbin" === i.type && (c += '<break time="150ms"/>');
          }
          break;
        }
      case "mop":
        if ("\u200B" !== i.value) {
          var _e108 = i.command;
          if ("\\sum" === _e108) {
            if (i.hasEmptyBranch("superscript") || i.hasEmptyBranch("subscript")) {
              if (i.hasEmptyBranch("subscript")) c += " the summation of";else {
                var _e109 = hr("math", i.subscript, r);
                _e109 = _e109.trim(), c += ' the summation from <break time="200ms"/>' + _e109 + '<break time="200ms"/> of <break time="150ms"/>', _p2 = !0;
              }
            } else {
              var _e110 = hr("math", i.superscript, r);
              _e110 = _e110.trim();
              var _t89 = hr("math", i.subscript, r);
              _t89 = _t89.trim(), c += ' the summation from <break time="200ms"/>' + _t89 + '<break time="200ms"/> to  <break time="200ms"/>' + _e110 + '<break time="200ms"/> of <break time="150ms"/>', _p2 = !0;
            }
          } else if ("\\prod" === _e108) {
            if (i.hasEmptyBranch("superscript") || i.hasEmptyBranch("subscript")) {
              if (i.hasEmptyBranch("subscript")) c += " the product  of ";else {
                var _e111 = hr("math", i.subscript, r);
                _e111 = _e111.trim(), c += ' the product from <break time="200ms"/>' + _e111 + '<break time="200ms"/> of <break time="150ms"/>', _p2 = !0;
              }
            } else {
              var _e112 = hr("math", i.superscript, r);
              _e112 = _e112.trim();
              var _t90 = hr("math", i.subscript, r);
              _t90 = _t90.trim(), c += ' the product from <break time="200ms"/>' + _t90 + '<break time="200ms"/> to <break time="200ms"/>' + _e112 + '<break time="200ms"/> of <break time="150ms"/>', _p2 = !0;
            }
          } else if ("\\int" === _e108) {
            if (i.hasEmptyBranch("superscript") || i.hasEmptyBranch("subscript")) c += ' the integral of <break time="200ms"/> ';else {
              var _e113 = hr("math", i.superscript, r);
              _e113 = _e113.trim();
              var _t91 = hr("math", i.subscript, r);
              _t91 = _t91.trim(), c += ' the integral from <break time="200ms"/>' + l(_t91) + '<break time="200ms"/> to <break time="200ms"/>' + l(_e113) + ' <break time="200ms"/> of ', _p2 = !0;
            }
          } else "string" == typeof i.value ? c += (null !== (s = cr[i.value]) && void 0 !== s ? s : i.command ? cr[i.command] : void 0) || " " + i.value : i.command && ("\\mathop" === i.command ? c += hr("math", i.body, r) : "\\operatorname" === i.command ? c += (u = i.body) ? u.map(function (e) {
            return e.value;
          }).join("") : "" : c += i.command.startsWith("\\") ? " " + i.command.slice(1) : " " + i.command);
        }
        break;
      case "enclose":
        _h = hr("math", i.body, r), c += ur(i.body) ? " crossed out " + _h + " , " : " crossed out " + _h + ". End cross out";
    }
    if (!_p2 && !i.hasEmptyBranch("superscript")) {
      var _n21 = hr(t, i.superscript, r);
      _n21 = _n21.trim();
      var _a15 = _n21.replace(/<[^>]*>/g, "");
      if (ur(i.superscript)) {
        if ("math" === t) {
          var _t92 = function (t) {
            if (e(t)) {
              var _iterator58 = _createForOfIteratorHelper(t),
                _step58;
              try {
                for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
                  var _e114 = _step58.value;
                  if ("first" !== _e114.type && _e114.id) return _e114.id.toString();
                }
              } catch (err) {
                _iterator58.e(err);
              } finally {
                _iterator58.f();
              }
            }
            return "";
          }(i.superscript);
          _t92 && (c += '<mark name="' + _t92 + '"/>');
        }
        "\u2032" === _a15 ? c += " prime " : "2" === _a15 ? c += " squared " : "3" === _a15 ? c += " cubed " : Number.isNaN(Number.parseInt(_a15)) ? c += " to the " + _n21 + "; " : c += ' to the <say-as interpret-as="ordinal">' + _a15 + "</say-as> power; ";
      } else Number.isNaN(Number.parseInt(_a15)) ? c += " raised to the " + _n21 + "; " : c += ' raised to the <say-as interpret-as="ordinal">' + _a15 + "</say-as> power; ";
    }
    if (!_p2 && !i.hasEmptyBranch("subscript")) {
      var _e115 = hr("math", i.subscript, r);
      _e115 = _e115.trim(), c += ur(i.subscript) ? " sub " + _e115 : " subscript " + _e115 + ". End subscript. ";
    }
  }
  var u;
  return c;
}
function pr(e, t) {
  var i;
  var r = _objectSpread(_objectSpread({}, t), {}, {
    textToSpeechRulesOptions: _objectSpread({}, t.textToSpeechRulesOptions)
  });
  if (window.sre && "sre" === r.textToSpeechRules) {
    var _t93 = lr(e, r);
    return _t93 ? (r.textToSpeechMarkup && (r.textToSpeechRulesOptions = null !== (i = r.textToSpeechRulesOptions) && void 0 !== i ? i : {}, r.textToSpeechRulesOptions.markup = r.textToSpeechMarkup, "ssml" === r.textToSpeechRulesOptions.markup && (r.textToSpeechRulesOptions.markup = "ssml_step"), r.textToSpeechRulesOptions.rate = r.speechEngineRate), r.textToSpeechRulesOptions && window.sre.System.getInstance().setupEngine(r.textToSpeechRulesOptions), window.sre.System.getInstance().toSpeech(_t93)) : "";
  }
  var n = hr("math", e, r);
  if ("ssml" === r.textToSpeechMarkup) {
    var _e116 = "";
    r.speechEngineRate && (_e116 = '<prosody rate="' + r.speechEngineRate + '">'), n = '<?xml version="1.0"?><speak version="1.1" xmlns="http://www.w3.org/2001/10/synthesis" xml:lang="en-US"><amazon:auto-breaths>' + _e116 + "<p><s>" + n + "</s></p>" + (_e116 ? "</prosody>" : "") + "</amazon:auto-breaths></speak>";
  } else n = "mac" === r.textToSpeechMarkup && "macos" === Se() ? n.replace(/<mark([^/]*)\/>/g, "").replace(/<emphasis>/g, "[[emph+]]").replace(/<\/emphasis>/g, "").replace(/<break time="(\d*)ms"\/>/g, "[[slc $1]]").replace(/<say-as[^>]*>/g, "").replace(/<\/say-as>/g, "") : n.replace(/<[^>]*>/g, "").replace(/\s{2,}/g, " ");
  return n;
}
function mr(e, t) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3e3;
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "$0";
  var _iterator59 = _createForOfIteratorHelper(t),
    _step59;
  try {
    for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
      var _n22 = _step59.value;
      Ce[_n22] && (Ce[_n22].frequency = i, Ce[_n22].category = e, Ce[_n22].template = r.replace(/\$0/g, _n22)), Ne[_n22] && (Ne[_n22] = _objectSpread(_objectSpread({}, Ne[_n22]), {}, {
        frequency: i,
        category: e,
        template: r.replace(/\$0/g, _n22)
      }));
    }
  } catch (err) {
    _iterator59.e(err);
  } finally {
    _iterator59.f();
  }
}
mr("Trigonometry", ["\\cos", "\\sin", "\\tan"], 4e3), mr("Trigonometry", ["\\arcsin", "\\arccos", "\\arctan", "\\arctg", "\\arcctg", "\\arcsec", "\\arccsc", "\\arsinh", "\\arcosh", "\\artanh", "\\arcsech", "\\arccsch", "\\arg", "\\ch", "\\cosec", "\\cosh", "\\cot", "\\cotg", "\\coth", "\\csc", "\\ctg", "\\cth", "\\lg", "\\lb", "\\sec", "\\sinh", "\\sh", "\\tanh", "\\tg", "\\th"], 2e3), mr("Functions", ["\\ln", "\\log", "\\exp", "\\lim"], 4e3), mr("Functions", ["\\dim", "\\ker", "\\deg", "\\det", "\\mod", "\\min", "\\max"], 3e3), mr("Functions", ["\\hom"], 1200), mr("Decoration", ["\\rule"], 200, "$0{2em}{1em}"), mr("Decoration", ["\\color", "\\textcolor"], 200, "{$0{m0}A}{$0{m1}B}{$0{m2}C }{$0{m3}a}{$0{m4}b}{$0{m5}c}{$0{m6}8}"), mr("Decoration", ["\\overline", "\\underline"], 3e3, "$0{\\placeholder{}}"), mr("Decoration", ["\\enclose"], 1200, '\\enclose{updiagonalstrike,roundedbox}[1px solid red, mathbackground="#fbc0bd"]{x=0}'), mr("Decoration", ["\\fcolorbox"], 1200, "\\fcolorbox{#cd0030}{#ffd400}{\\unicode{\"2B1A}}"), mr("Decoration", ["\\colorbox"], 1200, "\\colorbox{#fbc0bd}{\\unicode{\"2B1A}}"), mr("Decoration", ["\\boxed", "\\cancel", "\\bcancel", "\\xcancel"], 1200, "$0{\\placeholder{}}"), mr("Decoration", ["\\bbox"], 1200, "\\bbox[#ffd400, solid 2px #ffd400]{\\unicode{\"2B1A}}"), mr("Styling", ["\\mathbb"], 4e3, "$0{Don Knuth}"), mr("Styling", ["\\textbf", "\\textup", "\\textit", "\\textrm", "\\textsf", "\\texttt", "\\textnormal", "\\textmd", "\\textsl", "\\textsc", "\\mathsf", "\\mathtt", "\\mathrm", "\\mathfrak", "\\mathcal", "\\mathscr", "\\mathbf", "\\mathmd", "\\mathit", "\\text", "\\mbox", "\\Bbb", "\\bold", "\\bm", "\\boldsymbol"], 3e3, "$0{Don Knuth}"), mr("Styling", ["\\frak", "\\tt", "\\bf", "\\it", "\\rmfamily", "\\sffamily", "\\ttfamily", "\\class", "\\cssId", "\\htmlData"], 1200, "{$0 Don Knuth}"), mr("Styling", ["\\bfseries", "\\mdseries", "\\upshape", "\\slshape", "\\scshape"], 1200, "\\text{$0 Don Knuth}"), mr("Styling", ["\\class", "\\cssId"], 1200, "$0{testIdentifier}{Don Knuth}"), mr("Styling", ["\\fontseries"], 1200, "\\text{$0{b}Don Knuth}"), mr("Styling", ["\\fontfamily"], 1200, "\\text{$0{cmtt}Don Knuth}"), mr("Styling", ["\\fontshape"], 1200, "\\text{$0{sc}Don Knuth}"), mr("Styling", ["\\selectfont"], 1200, "\\text{$0}"), mr("Styling", ["\\emph"], 1200, "Don$0{Knuth}"), mr("Styling", ["\\em"], 1200, "Don{$0 Knuth}"), mr("Layout", ["\\mathop", "\\mathbin", "\\mathrel", "\\mathopen", "\\mathclose", "\\mathpunct", "\\mathord", "\\mathinner", "\\operatorname", "\\operatorname*"], 1200, "x=$0{arg}=0"), mr("Layout", ["\\middle"], 1200, "\\left\\{x$0|x>0\\right\\}"), mr("Layout", ["\\overset", "\\underset", "\\stackrel", "\\stackbin"], 1200, "$0{arg}{x=0}"), mr("Layout", ["\\rlap", "\\mathrlap"], 1200, "$0{/}0"), mr("Layout", ["\\llap", "\\mathllap"], 1200, "o$0{/}"), mr("Fractions", ["\\frac"], 4e3, "$0{\\placeholder{}}{\\placeholder{}}"), mr("Fractions", ["\\binom", "\\dfrac", "\\tfrac", "\\dbinom", "\\tbinom", "\\pdiff", "\\cfrac"], 1200, "$0{\\placeholder{}}{\\placeholder{}}"), mr("Fractions", ["\\over", "\\atop", "\\choose"], 1200, "\\unicode{\"2B1A} $0 \\unicode{\"2B1A}"), mr("Fractions", ["\\overwithdelims", "\\atopwithdelims"], 1200, "{\\unicode{\"2B1A} $0{\\lbrace}{\\rbrace} \\unicode{\"2B1A}}"), mr("Extensible Operators", ["\\sum", "\\prod", "\\bigcap", "\\bigcup", "\\int"], 4e3), mr("Extensible Operators", ["\\bigoplus", "\\smallint", "\\iint", "\\oint"], 3e3), mr("Extensible Operators", ["\\bigwedge", "\\bigvee", "\\coprod", "\\bigsqcup", "\\bigotimes", "\\bigodot", "\\biguplus", "\\intop", "\\sqcup", "\\sqcap", "\\uplus", "\\wr", "\\Cap", "\\Cup", "\\doublecap", "\\doublecup", "\\amalg", "\\iiint", "\\oiint", "\\oiiint", "\\intclockwise", "\\varointclockwise", "\\ointctrclockwise", "\\intctrclockwise"], 1200), mr("Accents", ["\\vec"], 4e3), mr("Accents", ["\\bar", "\\ddot", "\\acute", "\\tilde", "\\check"], 3e3, "$0{\\placeholder{}}"), mr("Accents", ["\\^", "\\`", "\\'"], 1200, "$0{e}"), mr("Accents", ["\\c"], 1200, "$0{c}"), mr("Accents", ["\\~"], 1200, "$0{n}"), mr("Accents", ["\\mathring", "\\hat", "\\dot", "\\breve", "\\grave"], 1200, "$0{\\placeholder{}}"), mr("Extensible Symbols", ["\\overrightarrow", "\\overleftarrow", "\\Overrightarrow", "\\overleftharpoon", "\\overrightharpoon", "\\overleftrightarrow", "\\overbrace", "\\overlinesegment", "\\overgroup", "\\widehat", "\\widecheck", "\\widetilde"], 3e3, "$0{ABC}"), mr("Extensible Symbols", ["\\underrightarrow", "\\underleftarrow", "\\underleftrightarrow", "\\underbrace", "\\underlinesegment", "\\undergroup", "\\utilde"], 3e3, "$0{ABC}"), mr("Sizing", ["\\tiny", "\\scriptsize", "\\footnotesize", "\\small", "\\normalsize", "\\large", "\\Large", "\\LARGE", "\\huge", "\\Huge"], 1200, "$0{x=0}"), mr("Sizing", ["\\big", "\\Big", "\\bigg", "\\Bigg"], 1200, "$0($0)"), mr("Sizing", ["\\bigl", "\\Bigl", "\\biggl", "\\Biggl"], 1200, "$0("), mr("Sizing", ["\\bigr", "\\Bigr", "\\biggr", "\\Biggr"], 1200, "$0)"), mr("Sizing", ["\\bigm", "\\Bigm", "\\biggm", "\\Biggm"], 1200, "$0|"), mr("Letterlike Symbols", ["\\nabla", "\\partial", "\\N", "\\R", "\\Q", "\\C", "\\Z", "\\exponentialE", "\\forall", "\\exists", "\\nexists"], 4e3), mr("Letterlike Symbols", ["\\doubleStruckCapitalP", "\\P", "\\ell", "\\hbar", "\\hslash", "\\imath", "\\jmath", "\\imaginaryI", "\\imaginaryJ", "\\differentialD", "\\rd", "\\capitalDifferentialD", "\\doubleStruckCapitalN", "\\doubleStruckCapitalR", "\\doubleStruckCapitalQ", "\\doubleStruckCapitalC", "\\doubleStruckCapitalZ", "\\rD", "\\differencedelta", "\\mid", "@", "\\Re", "\\Im", "\\$", "\\%", "\\And", "\\degree"], 3e3), mr("Letterlike Symbols", ["\\top", "\\bot", "\\scriptCapitalE", "\\scriptCapitalH", "\\scriptCapitalL", "\\gothicCapitalC", "\\gothicCapitalH", "\\gothicCapitalI", "\\gothicCapitalR", "\\Bbbk", "\\Finv", "\\Game", "\\wp", "\\eth", "\\mho", "\\pounds", "\\yen", "\\euro"], 1200), mr("Crosses", ["\\dagger", "\\dag"], 4e3), mr("Crosses", ["\\ddag", "\\ddagger", "\\maltese", "\\textdagger", "\\textdaggerdbl"], 1200), mr("Various", ["\\checkmark", "\\diagup", "\\diagdown", "\\angle", "\\measuredangle", "\\sphericalangle", "\\prime", "\\doubleprime", "\\backprime", "\\backdoubleprime", "\\sharp", "\\flat", "\\natural", "\\&", "\\#", "\\clubsuit", "\\spadesuit", "\\diamondsuit", "\\heartsuit", "\\backslash", "\\infty", "/", "\\_", "\\/", "|", "'"], 1200), mr("Various", ["\\unicode"], 1200, '$0{"2B1A}'), mr("Arrows", ["\\longrightarrow", "\\rightarrow", "\\Longrightarrow", "\\Rightarrow"], 4e3), mr("Arrows", ["\\longmapsto", "\\mapsto", "\\Longleftrightarrow", "\\rightleftarrows", "\\leftarrow", "\\curvearrowleft", "\\uparrow", "\\downarrow", "\\hookrightarrow", "\\rightharpoonup", "\\rightleftharpoons"], 3e3), mr("Arrows", ["\\Leftarrow", "\\longleftrightarrow", "\\longleftarrow", "\\Longleftarrow", "\\searrow", "\\nearrow", "\\swarrow", "\\nwarrow", "\\Uparrow", "\\Downarrow", "\\updownarrow", "\\Updownarrow", "\\hookleftarrow", "\\leftharpoonup", "\\leftharpoondown", "\\rightharpoondown", "\\leftrightarrows", "\\dashrightarrow", "\\dashleftarrow", "\\leftleftarrows", "\\Lleftarrow", "\\twoheadleftarrow", "\\leftarrowtail", "\\looparrowleft", "\\leftrightharpoons", "\\circlearrowleft", "\\Lsh", "\\upuparrows", "\\downharpoonleft", "\\multimap", "\\leftrightsquigarrow", "\\twoheadrightarrow", "\\rightarrowtail", "\\looparrowright", "\\curvearrowright", "\\circlearrowright", "\\Rsh", "\\downdownarrows", "\\upharpoonright", "\\downharpoonright", "\\rightsquigarrow", "\\leadsto", "\\Rrightarrow", "\\restriction"], 1200), mr("Arrows", ["\\upharpoonleft", "\\rightrightarrows"], 0), mr("Negated Arrows", ["\\nrightarrow", "\\nRightarrow", "\\nleftrightarrow", "\\nLeftrightarrow", "\\nleftarrow", "\\nLeftarrow"], 1200), mr("Extensible Symbols", ["\\xrightarrow", "\\xleftarrow", "\\xRightarrow", "\\xLeftarrow", "\\xleftharpoonup", "\\xleftharpoondown", "\\xrightharpoonup", "\\xrightharpoondown", "\\xlongequal", "\\xtwoheadleftarrow", "\\xtwoheadrightarrow", "\\xleftrightarrow", "\\xLeftrightarrow", "\\xrightleftharpoons", "\\xleftrightharpoons", "\\xhookleftarrow", "\\xhookrightarrow", "\\xmapsto", "\\xtofrom", "\\xrightleftarrows", "\\xrightequilibrium", "\\xleftequilibrium"], 1200, "$0[below]{above}=0"), mr("Negated Relations", ["\\nless", "\\nleqslant", "\\lneq", "\\lneqq", "\\nleqq", "\\unlhd", "\\unrhd", "\\lvertneqq", "\\lnsim", "\\lnapprox", "\\nprec", "\\npreceq", "\\precnsim", "\\precnapprox", "\\nsim", "\\nshortmid", "\\nmid", "\\nvdash", "\\nvDash", "\\ngtr", "\\ngeqslant", "\\ngeqq", "\\gneq", "\\gneqq", "\\gvertneqq", "\\gnsim", "\\nsucc", "\\succnsim", "\\ncong", "\\nshortparallel", "\\nparallel", "\\nVDash", "\\nVdash", "\\precneqq", "\\succneqq", "\\gnapprox", "\\succnapprox", "\\nsucceq"], 1200), mr("Hebrew", ["\\aleph", "\\beth", "\\daleth", "\\gimel"], 1200), mr("Fences", ["\\lbrace", "\\rbrace", "\\vert", "\\Vert", "\\{", "\\}", "(", ")", "[", "]"], 4e3), mr("Fences", ["\\langle", "\\rangle", "\\lfloor", "\\rfloor", "\\lceil", "\\rceil", "\\mvert", "\\|", "\\mVert"], 3e3), mr("Fences", ["\\lvert", "\\rvert", "\\lVert", "\\rVert", "\\lbrack", "\\rbrack", "\\ulcorner", "\\urcorner", "\\llcorner", "\\lrcorner", "\\lgroup", "\\rgroup", "\\lmoustache", "\\rmoustache"], 1200), mr("Relations", ["=", "\\ne", "\\neq", "<", ">", "\\leqslant", "\\geqslant", "\\approx"], 4e3), mr("Relations", ["\\lt", "\\gt", "\\le", "\\ge", "\\leq", "\\geq", "\\gg", "\\cong", "\\equiv", "\\prec", "\\preceq", "\\succ", "\\perp", "\\parallel", "\\propto", "\\smile", "\\frown", "\\sim", "\\gtrsim"], 3e3), mr("Relations", ["\\coloneq", "\\succeq", "\\approxeq", "\\thickapprox", "\\lessapprox", "\\gtrapprox", "\\precapprox", "\\succapprox", "\\thicksim", "\\succsim", "\\precsim", "\\backsim", "\\eqsim", "\\backsimeq", "\\simeq", "\\lesssim", "\\nleq", "\\ngeq", "\\smallsmile", "\\smallfrown", "\\bowtie", "\\asymp", "\\leqq", "\\eqslantless", "\\ll", "\\lll", "\\lessgtr", "\\lesseqgtr", "\\lesseqqgtr", "\\risingdotseq", "\\fallingdotseq", "\\preccurlyeq", "\\curlyeqprec", "\\vDash", "\\Vvdash", "\\bumpeq", "\\Bumpeq", "\\geqq", "\\eqslantgtr", "\\ggg", "\\gtrless", "\\gtreqless", "\\gtreqqless", "\\succcurlyeq", "\\curlyeqsucc", "\\Vdash", "\\shortmid", "\\shortparallel", "\\between", "\\pitchfork", "\\varpropto", "\\backepsilon", "\\llless", "\\gggtr", "\\lhd", "\\rhd", "\\Join", "\\doteq", "\\doteqdot", "\\Doteq", "\\eqcirc", "\\circeq", "\\lessdot", "\\gtrdot", "\\measeq", "\\eqdef", "\\questeq"], 1200), mr("Logic", ["\\leftrightarrow", "\\Leftrightarrow", "\\to"], 4e3), mr("Logic", ["\\models", "\\vdash"], 3e3), mr("Logic", ["\\therefore", "\\because", "\\implies", "\\gets", "\\dashv", "\\impliedby", "\\biconditional", "\\roundimplies"], 1200), mr("Operators", ["+", "-", "*", "\\cdot"], 4e3), mr("Operators", ["\\sqrt"], 4e3, "$0{\\placeholder{}}"), mr("Operators", ["\\pm", "\\mp", "\\times", "\\div", "\\surd"], 3e3), mr("Operators", ["\\ltimes", "\\rtimes", "\\leftthreetimes", "\\rightthreetimes", "\\intercal", "\\dotplus", "\\centerdot", "\\doublebarwedge", "\\divideontimes", "\\divides"], 1200), mr("Logic", ["\\wedge", "\\vee", "\\neg"], 4e3), mr("Logic", ["\\lnot"], 3e3), mr("Logic", ["\\land", "\\lor", "\\barwedge", "\\veebar", "\\nor", "\\curlywedge", "\\curlyvee"], 1200), mr("Greek", ["\\alpha", "\\beta", "\\gamma", "\\delta", "\\epsilon", "\\varepsilon", "\\zeta", "\\eta", "\\theta", "\\vartheta", "\\iota", "\\kappa", "\\varkappa", "\\lambda", "\\mu", "\\nu", "\\xi", "\\pi", "\\varpi", "\\rho", "\\varrho", "\\sigma", "\\varsigma", "\\tau", "\\phi", "\\varphi", "\\upsilon", "\\chi", "\\psi", "\\omega", "\\Gamma", "\\Delta", "\\Theta", "\\Lambda", "\\Xi", "\\Pi", "\\Sigma", "\\Upsilon", "\\Phi", "\\Psi", "\\Omega", "\\digamma", "\\omicron"], 3e3), mr("Sets", ["\\emptyset", "\\varnothing", "\\cap", "\\cup", "\\in", "\\notin", "\\subset", "\\supset", "\\subseteq", "\\supseteq", "\\sqsubseteq"], 4e3), mr("Sets", ["\\setminus", "\\not", "\\ni", "\\sqsupseteq", "\\nsupseteqq", "\\supsetneq", "\\varsupsetneq", "\\supsetneqq", "\\varsupsetneqq"], 3e3), mr("Sets", ["\\smallsetminus", "\\complement", "\\owns", "\\subsetneq", "\\varsubsetneq", "\\subsetneqq", "\\varsubsetneqq", "\\nsubset", "\\nsupset", "\\nsubseteq", "\\nsupseteq", "\\nsubseteqq", "\\subseteqq", "\\Subset", "\\sqsubset", "\\supseteqq", "\\Supset", "\\sqsupset"], 1200), mr("Spacing", ["\\space, \\quad", "\\qquad"], 3e3, "\\unicode{\"203A}$0\\unicode{\"2039}"), mr("Spacing", ["\\!", "\\,", "\\:", "\\;", "\\enskip", "\\enspace"], 1200, "\\unicode{\"203A}$0\\unicode{\"2039}"), mr("Spacing", ["\\hspace", "\\hspace*"], 1200, "\\unicode{\"203A}$0{1em}\\unicode{\"2039}"), mr("Punctuation", ["\\colon", "\\cdotp", "\\ldots", "\\cdots", "\\ddots", "\\vdots", "?", "!", ":", '"', ",", ".", ";"], 3e3), mr("Punctuation", ["\\mathellipsis", "\\ldotp", "\\Colon"], 1200), mr("Boxes", ["\\square", "\\Box"], 3e3), mr("Boxes", ["\\blacksquare", "\\boxminus", "\\boxplus", "\\boxtimes", "\\boxdot"], 1200), mr("Circles", ["\\circ", "\\bullet", "\\circleddash", "\\oplus", "\\otimes"], 3e3), mr("Circles", ["\\bigcirc", "\\circledast", "\\ominus", "\\circledcirc", "\\oslash", "\\circledS", "\\circledR", "\\odot"], 1200), mr("Triangles", ["\\triangle", "\\triangleq"], 3e3), mr("Triangles", ["\\bigtriangleup", "\\vartriangle", "\\triangledown", "\\bigtriangledown", "\\triangleleft", "\\vartriangleleft", "\\trianglelefteq", "\\ntriangleleft", "\\ntrianglelefteq", "\\triangleright", "\\vartriangleright", "\\trianglerighteq", "\\ntriangleright", "\\ntrianglerighteq", "\\blacktriangle", "\\blacktriangledown", "\\blacktriangleleft", "\\blacktriangleright"], 1200), mr("Shapes", ["\\ast", "\\star"], 3e3), mr("Shapes", ["\\diamond", "\\Diamond", "\\lozenge", "\\blacklozenge", "\\bigstar"], 1200);
var fr = {
  strings: {
    en: {
      "keyboard.tooltip.functions": "Functions",
      "keyboard.tooltip.symbols": "Symbols",
      "keyboard.tooltip.greek": "Greek Letters",
      "keyboard.tooltip.command": "LaTeX Command Mode",
      "keyboard.tooltip.numeric": "Numeric",
      "keyboard.tooltip.roman": "Roman Letters",
      "tooltip.copy to clipboard": "Copy to Clipboard",
      "tooltip.redo": "Redo",
      "tooltip.toggle virtual keyboard": "Toggle Virtual Keyboard",
      "tooltip.undo": "Undo",
      "menu.insert matrix": "Insert Matrix",
      "menu.insert vector": "Insert Vector",
      "submenu.array.matrix delimiters": "Matrix Delimiters",
      "menu.array.add row above": "Add Row After",
      "menu.array.add row below": "Add Row Before",
      "menu.array.add column after": "Add Column After",
      "menu.array.add column before": "Add Column Before",
      "menu.array.delete row": "Delete Row",
      "menu.array.delete rows": "Delete Selected Rows",
      "menu.array.delete column": "Delete Column",
      "menu.array.delete columns": "Delete Selected Columns",
      "submenu.array.insert separator": "Insert Separator",
      "menu.insert table": "Insert Table",
      "submenu.table style": "Table Style"
    },
    ar: {
      "keyboard.tooltip.functions": "\u0645\u0647\u0627\u0645",
      "keyboard.tooltip.symbols": "\u062D\u0631\u0641 \u0627\u0648 \u0631\u0645\u0632",
      "keyboard.tooltip.greek": "\u062D\u0631\u0648\u0641 \u064A\u0648\u0646\u0627\u0646\u064A\u0629",
      "keyboard.tooltip.command": "\u062D\u0627\u0644\u0629 \u062A\u0644\u0642\u064A \u0627\u0644\u0623\u0648\u0627\u0645\u0631 \u0627\u0644\u0644\u0627\u062A\u0643",
      "keyboard.tooltip.numeric": "\u0627\u0644\u0631\u0642\u0645\u064A\u0629",
      "keyboard.tooltip.roman": "\u0631\u0645\u0648\u0632 \u0627\u0644\u0627\u062D\u0631\u0641 \u0627\u0644\u0631\u0648\u0645\u0627\u0646\u064A\u0629",
      "tooltip.copy to clipboard": "\u0646\u0633\u062E \u0625\u0644\u0649 \u0627\u0644\u062D\u0627\u0641\u0638\u0629",
      "tooltip.redo": "\u0627\u0644\u0625\u0639\u0627\u062F\u0629",
      "tooltip.toggle virtual keyboard": "\u062A\u0628\u062F\u064A\u0644 \u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D \u0627\u0644\u0625\u0641\u062A\u0631\u0627\u0636\u064A\u0629",
      "tooltip.undo": "\u0625\u0644\u063A\u0627\u0621",
      "menu.insert matrix": "\u0623\u062F\u062E\u0644 \u0627\u0644\u0645\u0635\u0641\u0648\u0641\u0629",
      "menu.insert vector": "\u0623\u062F\u062E\u0644 \u0645\u062A\u062C\u0647",
      "submenu.array.matrix delimiters": "\u0645\u062D\u062F\u062F\u0627\u062A \u0627\u0644\u0645\u0635\u0641\u0648\u0641\u0629",
      "menu.array.add row above": "\u0623\u0636\u0641 \u0635\u0641\u064B\u0627 \u0628\u0639\u062F \u0630\u0644\u0643",
      "menu.array.add row below": "\u0623\u0636\u0641 \u0627\u0644\u0635\u0641 \u0642\u0628\u0644",
      "menu.array.add column after": "\u0623\u0636\u0641 \u0627\u0644\u0639\u0645\u0648\u062F \u0628\u0639\u062F \u0630\u0644\u0643",
      "menu.array.add column before": "\u0623\u0636\u0641 \u0627\u0644\u0639\u0645\u0648\u062F \u0642\u0628\u0644",
      "menu.array.delete row": "\u0627\u062D\u0630\u0641 \u0635\u0641",
      "menu.array.delete rows": "\u062D\u0630\u0641 \u0627\u0644\u0635\u0641\u0648\u0641 \u0627\u0644\u0645\u062D\u062F\u062F\u0629",
      "menu.array.delete column": "\u062D\u0630\u0641 \u0627\u0644\u0639\u0645\u0648\u062F",
      "menu.array.delete columns": "\u062D\u0630\u0641 \u0627\u0644\u0623\u0639\u0645\u062F\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629",
      "submenu.array.insert separator": "\u0623\u062F\u062E\u0644 \u0641\u0627\u0635\u0644",
      "menu.insert table": "\u0625\u062F\u0631\u0627\u062C \u062C\u062F\u0648\u0644",
      "submenu.table style": "\u0646\u0645\u0637 \u0627\u0644\u062C\u062F\u0648\u0644"
    },
    bg: {
      "keyboard.tooltip.functions": "\u0424\u0443\u043D\u043A\u0446\u0438\u0438",
      "keyboard.tooltip.symbols": "\u0421\u0438\u043C\u0432\u043E\u043B\u0438",
      "keyboard.tooltip.greek": "\u0413\u0440\u044A\u0446\u043A\u0438 \u0431\u0443\u043A\u0432\u0438",
      "keyboard.tooltip.command": "\u041A\u043E\u043C\u0430\u043D\u0434\u0435\u043D \u0440\u0435\u0436\u0438\u043C \u043D\u0430 \u043B\u0430\u0442\u0435\u043A\u0441",
      "keyboard.tooltip.numeric": "\u0427\u0438\u0441\u043B\u043E\u0432\u0438",
      "keyboard.tooltip.roman": "\u0420\u0438\u043C\u0441\u043A\u0438 \u0431\u0443\u043A\u0432\u0438",
      "tooltip.copy to clipboard": "\u041A\u043E\u043F\u0438\u0440\u0430\u043D\u0435 \u0432 \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434\u0430",
      "tooltip.redo": "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
      "tooltip.toggle virtual keyboard": "\u041F\u0440\u0435\u0432\u043A\u043B\u044E\u0447\u0432\u0430\u043D\u0435 \u043D\u0430 \u0432\u0438\u0440\u0442\u0443\u0430\u043B\u043D\u0430 \u043A\u043B\u0430\u0432\u0438\u0430\u0442\u0443\u0440\u0430",
      "tooltip.undo": "\u041E\u0442\u043C\u044F\u043D\u0430",
      "menu.insert matrix": "\u0412\u043C\u044A\u043A\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u0430\u0442\u0440\u0438\u0446\u0430",
      "menu.insert vector": "\u0412\u043C\u044A\u043A\u0432\u0430\u043D\u0435 \u043D\u0430 \u0432\u0435\u043A\u0442\u043E\u0440",
      "submenu.array.matrix delimiters": "\u041C\u0430\u0442\u0440\u0438\u0447\u043D\u0438 \u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u0438",
      "menu.array.add row above": "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u0440\u0435\u0434 \u0441\u043B\u0435\u0434",
      "menu.array.add row below": "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u0440\u0435\u0434 \u043F\u0440\u0435\u0434\u0438",
      "menu.array.add column after": "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u043A\u043E\u043B\u043E\u043D\u0430 \u0441\u043B\u0435\u0434",
      "menu.array.add column before": "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u043A\u043E\u043B\u043E\u043D\u0430 \u043F\u0440\u0435\u0434\u0438",
      "menu.array.delete row": "\u0418\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435 \u043D\u0430 \u0440\u0435\u0434\u0430",
      "menu.array.delete rows": "\u0418\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435 \u043D\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0438\u0442\u0435 \u0440\u0435\u0434\u043E\u0432\u0435",
      "menu.array.delete column": "\u0418\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435 \u043D\u0430 \u043A\u043E\u043B\u043E\u043D\u0430",
      "menu.array.delete columns": "\u0418\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435 \u043D\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0438\u0442\u0435 \u043A\u043E\u043B\u043E\u043D\u0438",
      "submenu.array.insert separator": "\u041F\u043E\u0441\u0442\u0430\u0432\u0435\u0442\u0435 \u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B",
      "menu.insert table": "\u0412\u043C\u044A\u043A\u0432\u0430\u043D\u0435 \u043D\u0430 \u0442\u0430\u0431\u043B\u0438\u0446\u0430",
      "submenu.table style": "\u0422\u0430\u0431\u043B\u0438\u0447\u0435\u043D \u0441\u0442\u0438\u043B"
    },
    bs: {
      "keyboard.tooltip.functions": "Funkcije",
      "keyboard.tooltip.symbols": "Simboli",
      "keyboard.tooltip.greek": "Gr\u010Dka slova",
      "keyboard.tooltip.command": "LaTeX naredbeni na\u010Din",
      "keyboard.tooltip.numeric": "Numeri\u010Dki",
      "keyboard.tooltip.roman": "Rimska slova",
      "tooltip.copy to clipboard": "Kopirati u clipboard",
      "tooltip.redo": "Ponovi",
      "tooltip.toggle virtual keyboard": "Uklju\u010Di / isklju\u010Di virtualnu tipkovnicu",
      "tooltip.undo": "Poni\u0161ti",
      "menu.insert matrix": "Umetni matricu",
      "menu.insert vector": "Umetni vektor",
      "submenu.array.matrix delimiters": "Matri\u010Dni razdjelnici",
      "menu.array.add row above": "Dodaj redak nakon",
      "menu.array.add row below": "Dodaj red prije",
      "menu.array.add column after": "Dodaj stupac nakon",
      "menu.array.add column before": "Dodaj stupac prije",
      "menu.array.delete row": "Izbri\u0161i red",
      "menu.array.delete rows": "Izbri\u0161i odabrane redove",
      "menu.array.delete column": "Izbri\u0161i stupac",
      "menu.array.delete columns": "Izbri\u0161i odabrane stupce",
      "submenu.array.insert separator": "Umetni separator",
      "menu.insert table": "Ubaci tabelu",
      "submenu.table style": "Stil tabele"
    },
    cs: {
      "keyboard.tooltip.functions": "Funkce",
      "keyboard.tooltip.symbols": "Symboly",
      "keyboard.tooltip.greek": "\u0158eck\xE9 dopisy",
      "keyboard.tooltip.command": "P\u0159\xEDkazov\xFD re\u017Eim LaTeX",
      "keyboard.tooltip.numeric": "\u010C\xEDseln\xE9",
      "keyboard.tooltip.roman": "\u0158\xEDmsk\xE9 dopisy",
      "tooltip.copy to clipboard": "Zkop\xedrovat do schr\xe1nky",
      "tooltip.redo": "P\u0159ed\u011Blat",
      "tooltip.toggle virtual keyboard": "P\u0159epnout virtu\xE1ln\xED kl\xE1vesnici",
      "tooltip.undo": "Vr\xe1tit",
      "menu.insert matrix": "Vlo\u017Ete matici",
      "menu.insert vector": "Vlo\u017Eit vektor",
      "submenu.array.matrix delimiters": "Odd\u011Blova\u010De matic",
      "menu.array.add row above": "P\u0159idat \u0159\xE1dek za",
      "menu.array.add row below": "P\u0159idat \u0159\xE1dek p\u0159ed",
      "menu.array.add column after": "P\u0159idat sloupec za",
      "menu.array.add column before": "P\u0159idat sloupec d\u0159\xEDve",
      "menu.array.delete row": "Odstranit \u0159\xE1dek",
      "menu.array.delete rows": "Odstranit vybran\xE9 \u0159\xE1dky",
      "menu.array.delete column": "Odstranit sloupec",
      "menu.array.delete columns": "Odstranit vybran\xe9 sloupce",
      "submenu.array.insert separator": "Vlo\u017Ete odd\u011Blova\u010D",
      "menu.insert table": "Vlo\u017Eit tabulku",
      "submenu.table style": "Styl tabulky"
    },
    da: {
      "keyboard.tooltip.functions": "Funktioner",
      "keyboard.tooltip.symbols": "Symboler",
      "keyboard.tooltip.greek": "Gr\xe6ske bogstaver",
      "keyboard.tooltip.command": "LaTeX kommandotilstand",
      "keyboard.tooltip.numeric": "Numerisk",
      "keyboard.tooltip.roman": "Romerske breve",
      "tooltip.copy to clipboard": "Kopier til udklipsholder",
      "tooltip.redo": "Gentag igen",
      "tooltip.toggle virtual keyboard": "Skift virtuelt tastatur",
      "tooltip.undo": "Fortryd",
      "menu.insert matrix": "Inds\xe6t matrix",
      "menu.insert vector": "Inds\xe6t vektor",
      "submenu.array.matrix delimiters": "Matrixafgr\xe6nsere",
      "menu.array.add row above": "Tilf\xf8j r\xe6kke efter",
      "menu.array.add row below": "Tilf\xf8j r\xe6kke f\xf8r",
      "menu.array.add column after": "Tilf\xf8j kolonne efter",
      "menu.array.add column before": "Tilf\xf8j kolonne f\xf8r",
      "menu.array.delete row": "Slet r\xe6kke",
      "menu.array.delete rows": "Slet valgte r\xe6kker",
      "menu.array.delete column": "Slet kolonne",
      "menu.array.delete columns": "Slet valgte kolonner",
      "submenu.array.insert separator": "Inds\xe6t separator",
      "menu.insert table": "Inds\xe6t tabel",
      "submenu.table style": "Tabelstil"
    },
    de: {
      "keyboard.tooltip.functions": "Funktionen",
      "keyboard.tooltip.symbols": "Symbole",
      "keyboard.tooltip.greek": "Griechische Buchstaben",
      "keyboard.tooltip.command": "LaTeX-Befehlsmodus",
      "keyboard.tooltip.numeric": "Numerisch",
      "keyboard.tooltip.roman": "R\xf6mische Buchstaben",
      "tooltip.copy to clipboard": "In die Zwischenablage kopieren",
      "tooltip.redo": "Wiederholen",
      "tooltip.toggle virtual keyboard": "Virtuelle Tastatur umschalten",
      "tooltip.undo": "Widerrufen",
      "menu.insert matrix": "Matrix einf\xfcgen",
      "menu.insert vector": "Vektor einf\xfcgen",
      "submenu.array.matrix delimiters": "Matrixtrennzeichen",
      "menu.array.add row above": "Zeile hinzuf\xfcgen nach",
      "menu.array.add row below": "Zeile hinzuf\xfcgen vor",
      "menu.array.add column after": "Spalte hinzuf\xfcgen nach",
      "menu.array.add column before": "Spalte hinzuf\xfcgen vor",
      "menu.array.delete row": "Zeile l\xf6schen",
      "menu.array.delete rows": "Ausgew\xe4hlte Zeilen l\xf6schen",
      "menu.array.delete column": "Spalte l\xf6schen",
      "menu.array.delete columns": "Ausgew\xe4hlte Spalten l\xf6schen",
      "submenu.array.insert separator": "Trennzeichen einf\xfcgen",
      "menu.insert table": "Tabelle einf\xfcgen",
      "submenu.table style": "Tabellenstil"
    },
    el: {
      "keyboard.tooltip.functions": "\u03C3\u03C5\u03BD\u03B1\u03C1\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2",
      "keyboard.tooltip.symbols": "\u03C3\u03CD\u03BC\u03B2\u03BF\u03BB\u03B1",
      "keyboard.tooltip.greek": "\u03B5\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC \u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03B1",
      "keyboard.tooltip.command": "\u039B\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03B5\u03BD\u03C4\u03BF\u03BB\u03CE\u03BD LaTeX",
      "keyboard.tooltip.numeric": "\u0391\u03C1\u03B9\u03B8\u03BC\u03B7\u03C4\u03B9\u03BA\u03CC\u03C2",
      "keyboard.tooltip.roman": "\u03A1\u03C9\u03BC\u03B1\u03CA\u03BA\u03AC \u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03B1",
      "tooltip.copy to clipboard": "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03C4\u03BF \u03C0\u03C1\u03CC\u03C7\u03B5\u03B9\u03C1\u03BF",
      "tooltip.redo": "\u039E\u03B1\u03BD\u03B1\u03BA\u03AC\u03BD\u03C9",
      "tooltip.toggle virtual keyboard": "\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03B5\u03B9\u03BA\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03C0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AF\u03BF\u03C5",
      "tooltip.undo": "\u039E\u03B5\u03BA\u03AC\u03BD\u03C9",
      "menu.insert matrix": "\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE Matrix",
      "menu.insert vector": "\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03B4\u03B9\u03B1\u03BD\u03CD\u03C3\u03BC\u03B1\u03C4\u03BF\u03C2",
      "submenu.array.matrix delimiters": "\u039F\u03C1\u03B9\u03BF\u03B8\u03AD\u03C4\u03B5\u03C2 Matrix",
      "menu.array.add row above": "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C3\u03B5\u03B9\u03C1\u03AC\u03C2 \u03BC\u03B5\u03C4\u03AC",
      "menu.array.add row below": "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C3\u03B5\u03B9\u03C1\u03AC\u03C2 \u03C0\u03C1\u03B9\u03BD",
      "menu.array.add column after": "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C3\u03C4\u03AE\u03BB\u03B7\u03C2 \u03BC\u03B5\u03C4\u03AC",
      "menu.array.add column before": "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C3\u03C4\u03AE\u03BB\u03B7\u03C2 \u03C0\u03C1\u03B9\u03BD",
      "menu.array.delete row": "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03B5\u03B9\u03C1\u03AC\u03C2",
      "menu.array.delete rows": "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03C9\u03BD \u03C3\u03B5\u03B9\u03C1\u03CE\u03BD",
      "menu.array.delete column": "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03C4\u03AE\u03BB\u03B7\u03C2",
      "menu.array.delete columns": "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03C9\u03BD \u03C3\u03C4\u03B7\u03BB\u03CE\u03BD",
      "submenu.array.insert separator": "\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03B4\u03B9\u03B1\u03C7\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03BF\u03CD",
      "menu.insert table": "\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03C0\u03AF\u03BD\u03B1\u03BA\u03B1",
      "submenu.table style": "\u03A3\u03C4\u03C5\u03BB \u03C0\u03AF\u03BD\u03B1\u03BA\u03B1"
    },
    es: {
      "keyboard.tooltip.functions": "Funciones",
      "keyboard.tooltip.symbols": "S\xedmbolos",
      "keyboard.tooltip.greek": "Letras griegas",
      "keyboard.tooltip.command": "Modo Comando LaTeX",
      "keyboard.tooltip.numeric": "Num\xe9rico",
      "keyboard.tooltip.roman": "Letras romanas",
      "tooltip.copy to clipboard": "Copiar al portapapeles",
      "tooltip.redo": "Rehacer",
      "tooltip.toggle virtual keyboard": "Alternar teclado virtual",
      "tooltip.undo": "Deshacer",
      "menu.insert matrix": "A\xf1adir Matriz",
      "menu.insert vector": "A\xf1adir vector",
      "submenu.array.matrix delimiters": "Delimitadores de Matriz",
      "menu.array.add row above": "A\xf1adir L\xednea Antes",
      "menu.array.add row below": "A\xf1adir L\xednea Despues",
      "menu.array.add column after": "A\xf1adir Columna Despues",
      "menu.array.add column before": "A\xf1adir Columna Antes",
      "menu.array.delete row": "Borrar L\xednea",
      "menu.array.delete rows": "Borrar L\xedneas Seleccionadas",
      "menu.array.delete column": "Borrar Columna",
      "menu.array.delete columns": "Borrar Columnas Seleccionadas",
      "submenu.array.insert separator": "Insertar un Separador",
      "menu.insert table": "Insertar Tabla",
      "submenu.table style": "Estilo de Tabla"
    },
    et: {
      "keyboard.tooltip.functions": "Funktsioonid",
      "keyboard.tooltip.symbols": "S\xfcmbolid",
      "keyboard.tooltip.greek": "Kreeka kirjad",
      "keyboard.tooltip.command": "LaTeXi k\xE4sure\u017Eiim",
      "keyboard.tooltip.numeric": "Numbriline",
      "keyboard.tooltip.roman": "Rooma kirjad",
      "tooltip.copy to clipboard": "Kopeerida l\xf5ikelauale",
      "tooltip.redo": "Tee uuesti",
      "tooltip.toggle virtual keyboard": "L\xfclitage sisse virtuaalne klaviatuur",
      "tooltip.undo": "V\xf5ta tagasi",
      "menu.insert matrix": "Sisesta maatriks",
      "menu.insert vector": "Sisesta vektor",
      "submenu.array.matrix delimiters": "Maatriksi eraldajad",
      "menu.array.add row above": "Lisa rida p\xe4rast",
      "menu.array.add row below": "Lisa rida enne",
      "menu.array.add column after": "Lisa veerg p\xe4rast",
      "menu.array.add column before": "Lisa veerg enne",
      "menu.array.delete row": "Kustuta rida",
      "menu.array.delete rows": "Kustuta valitud read",
      "menu.array.delete column": "Kustuta veerg",
      "menu.array.delete columns": "Kustuta valitud veerud",
      "submenu.array.insert separator": "Sisestage eraldaja",
      "menu.insert table": "Sisesta tabeli",
      "submenu.table style": "Tabeli stiilis"
    },
    fa: {
      "keyboard.tooltip.functions": "\u062A\u0648\u0627\u0628\u0639",
      "keyboard.tooltip.symbols": "\u0646\u0645\u0627\u062F\u0647\u0627",
      "keyboard.tooltip.greek": "\u062D\u0631\u0648\u0641 \u06CC\u0648\u0646\u0627\u0646\u06CC",
      "keyboard.tooltip.command": "\u062D\u0627\u0644\u062A \u062F\u0633\u062A\u0648\u0631 \u0644\u0627\u062A\u06A9",
      "keyboard.tooltip.numeric": "\u0639\u062F\u062F\u06CC",
      "keyboard.tooltip.roman": "\u062D\u0631\u0648\u0641 \u0631\u0648\u0645\u06CC",
      "tooltip.copy to clipboard": "\u06A9\u067E\u06CC \u0628\u0647 \u06A9\u0644\u06CC\u067E\u0628\u0648\u0631\u062F",
      "tooltip.redo": "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0628\u0639\u062F",
      "tooltip.toggle virtual keyboard": "\u0646\u0645\u0627\u06CC\u0634/\u0646\u0647\u0641\u062A\u0646 \u06A9\u06CC\u0628\u0648\u0631\u062F \u0645\u062C\u0627\u0632\u06CC",
      "tooltip.undo": "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0642\u0628\u0644",
      "menu.insert matrix": "\u0645\u0627\u062A\u0631\u06CC\u0633 \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F",
      "menu.insert vector": "\u062F\u0631\u062C \u0628\u0631\u062F\u0627\u0631",
      "submenu.array.matrix delimiters": "\u0645\u0631\u0632\u0647\u0627\u06CC \u0645\u0627\u062A\u0631\u06CC\u0633",
      "menu.array.add row above": "\u0628\u0639\u062F \u0627\u0632 \u0622\u0646 \u0631\u062F\u06CC\u0641 \u0627\u0636\u0627\u0641\u0647 \u06A9\u0646\u06CC\u062F",
      "menu.array.add row below": "\u0631\u062F\u06CC\u0641 \u0631\u0627 \u0642\u0628\u0644 \u0627\u0636\u0627\u0641\u0647 \u06A9\u0646\u06CC\u062F",
      "menu.array.add column after": "\u0627\u0636\u0627\u0641\u0647 \u06A9\u0631\u062F\u0646 \u0633\u062A\u0648\u0646 \u0628\u0639\u062F",
      "menu.array.add column before": "\u0633\u062A\u0648\u0646 \u0642\u0628\u0644 \u0631\u0627 \u0627\u0636\u0627\u0641\u0647 \u06A9\u0646\u06CC\u062F",
      "menu.array.delete row": "\u0631\u062F\u06CC\u0641 \u0631\u0627 \u062D\u0630\u0641 \u06A9\u0646\u06CC\u062F",
      "menu.array.delete rows": "\u0631\u062F\u06CC\u0641 \u0647\u0627\u06CC \u0627\u0646\u062A\u062E\u0627\u0628 \u0634\u062F\u0647 \u0631\u0627 \u062D\u0630\u0641 \u06A9\u0646\u06CC\u062F",
      "menu.array.delete column": "\u062D\u0630\u0641 \u0633\u062A\u0648\u0646",
      "menu.array.delete columns": "\u0633\u062A\u0648\u0646 \u0647\u0627\u06CC \u0627\u0646\u062A\u062E\u0627\u0628 \u0634\u062F\u0647 \u0631\u0627 \u062D\u0630\u0641 \u06A9\u0646\u06CC\u062F",
      "submenu.array.insert separator": "\u062F\u0631\u062C \u062C\u062F\u0627 \u06A9\u0646\u0646\u062F\u0647",
      "menu.insert table": "\u0642\u0631\u0627\u0631 \u062F\u0627\u062F\u0646 \u062C\u062F\u0648\u0644",
      "submenu.table style": "\u0633\u0628\u06A9 \u0645\u06CC\u0632"
    },
    fi: {
      "keyboard.tooltip.functions": "Toiminnot",
      "keyboard.tooltip.symbols": "Symbolit",
      "keyboard.tooltip.greek": "Kreikkalaiset kirjeet",
      "keyboard.tooltip.command": "LaTeX-komentotila",
      "keyboard.tooltip.numeric": "Numeerinen",
      "keyboard.tooltip.roman": "Roomalaiset kirjeet",
      "tooltip.copy to clipboard": "Kopioi leikep\xf6yd\xe4lle",
      "tooltip.redo": "Tee uudelleen",
      "tooltip.toggle virtual keyboard": "Vaihda virtuaalin\xe4pp\xe4imist\xf6",
      "tooltip.undo": "Kumoa",
      "menu.insert matrix": "Lis\xe4\xe4 matriisi",
      "menu.insert vector": "Lis\xe4\xe4 vektori",
      "submenu.array.matrix delimiters": "Matriisin erottimet",
      "menu.array.add row above": "Lis\xe4\xe4 rivi j\xe4lkeen",
      "menu.array.add row below": "Lis\xe4\xe4 rivi ennen",
      "menu.array.add column after": "Lis\xe4\xe4 sarake j\xe4lkeen",
      "menu.array.add column before": "Lis\xe4\xe4 sarake ennen",
      "menu.array.delete row": "Poista rivi",
      "menu.array.delete rows": "Poista valitut rivit",
      "menu.array.delete column": "Poista sarake",
      "menu.array.delete columns": "Poista valitut sarakkeet",
      "submenu.array.insert separator": "Aseta erotin",
      "menu.insert table": "Lis\xe4\xe4 taulukko",
      "submenu.table style": "Taulukon tyyli"
    },
    fr: {
      "keyboard.tooltip.functions": "Fonctions",
      "keyboard.tooltip.symbols": "Symboles",
      "keyboard.tooltip.greek": "Lettres grecques",
      "keyboard.tooltip.command": "Mode de commandes LaTeX",
      "keyboard.tooltip.numeric": "Num\xe9rique",
      "keyboard.tooltip.roman": "Lettres romaines",
      "tooltip.copy to clipboard": "Copier dans le presse-papiers",
      "tooltip.redo": "R\xe9tablir",
      "tooltip.toggle virtual keyboard": "Afficher/Masquer le clavier virtuel",
      "tooltip.undo": "Annuler",
      "menu.insert matrix": "Ins\xe9rer une Matrice",
      "menu.insert vector": "Ins\xe9rer un Vecteur",
      "submenu.array.matrix delimiters": "D\xe9limiteurs de la Matrice",
      "menu.array.add row above": "Ajouter une Ligne Avant",
      "menu.array.add row below": "Ajouter une Ligne Apr\xe8s",
      "menu.array.add column before": "Ajouter une Colonne Avant",
      "menu.array.add column after": "Ajouter une Colonne Apr\xe8s",
      "menu.array.delete row": "Enlever une Ligne",
      "menu.array.delete rows": "Enlever les Lignes S\xe9lection\xe9es",
      "menu.array.delete column": "Enlever une Colone",
      "menu.array.delete columns": "Enlever les Colonnes S\xe9lection\xe9es",
      "submenu.array.insert separator": "Ins\xe9rer un S\xe9parateur",
      "menu.insert table": "Ins\xe9rer une Table",
      "submenu.table style": "Style de la  Table"
    },
    ga: {
      "keyboard.tooltip.functions": "Feidhmeanna",
      "keyboard.tooltip.symbols": "Siombail\xed",
      "keyboard.tooltip.greek": "Litreacha na Gr\xe9ige",
      "keyboard.tooltip.command": "M\xf3d Ord\xfa LaTeX",
      "keyboard.tooltip.numeric": "Uimhri\xfail",
      "keyboard.tooltip.roman": "Litreacha R\xf3mh\xe1nacha",
      "tooltip.copy to clipboard": "C\xf3ipe\xe1il chuig an Ghearrthaisce",
      "tooltip.redo": "Athdh\xe9an",
      "tooltip.toggle virtual keyboard": "M\xe9archl\xe1ir F\xedor\xfail a Fh\xe1il",
      "tooltip.undo": "Cealaigh",
      "menu.insert matrix": "Cuir isteach Maitr\xeds",
      "menu.insert vector": "Cuir isteach Veicteoir",
      "submenu.array.matrix delimiters": "Delimiters Maitr\xeds",
      "menu.array.add row above": "Cuir Rae Tar \xe9is",
      "menu.array.add row below": "Cuir Rae Roimh",
      "menu.array.add column after": "Cuir Col\xfan Tar \xe9is",
      "menu.array.add column before": "Cuir Col\xfan Roimh",
      "menu.array.delete row": "Scrios Rae",
      "menu.array.delete rows": "Scrios Sraitheanna Roghnaithe",
      "menu.array.delete column": "Scrios Col\xfan",
      "menu.array.delete columns": "Scrios Col\xfain Roghnaithe",
      "submenu.array.insert separator": "Cuir Deighilteoir isteach",
      "menu.insert table": "Ions\xe1igh T\xe1bla",
      "submenu.table style": "St\xedl T\xe1bla"
    },
    he: {
      "keyboard.tooltip.functions": "\u05E4\u05D5\u05E0\u05E7\u05E6\u05D9\u05D5\u05EA",
      "keyboard.tooltip.symbols": "\u05E1\u05DE\u05DC\u05D9\u05DD",
      "keyboard.tooltip.greek": "\u05D0\u05D5\u05EA\u05D9\u05D5\u05EA \u05D9\u05D5\u05D5\u05E0\u05D9\u05D5\u05EA",
      "keyboard.tooltip.command": "\u05DE\u05E6\u05D1 \u05E4\u05E7\u05D5\u05D3\u05D4 \u05DC\u05D8\u05E7\u05E1",
      "keyboard.tooltip.numeric": "\u05DE\u05E1\u05E4\u05E8\u05D9",
      "keyboard.tooltip.roman": "\u05DE\u05DB\u05EA\u05D1\u05D9\u05DD \u05E8\u05D5\u05DE\u05D9\u05D9\u05DD",
      "tooltip.copy to clipboard": "\u05D4\u05E2\u05EA\u05E7 \u05DC\u05DC\u05D5\u05D7",
      "tooltip.redo": "\u05DC\u05B7\u05E2\u05B2\u05E9\u05C2\u05D5\u05B9\u05EA \u05E9\u05C1\u05D5\u05BC\u05D1",
      "tooltip.toggle virtual keyboard": "\u05D4\u05D7\u05DC\u05E3 \u05D0\u05EA \u05D4\u05DE\u05E7\u05DC\u05D3\u05EA \u05D4\u05D5\u05D5\u05D9\u05E8\u05D8\u05D5\u05D0\u05DC\u05D9\u05EA",
      "tooltip.undo": "\u05DC\u05D1\u05D8\u05DC",
      "menu.insert matrix": "\u05D4\u05DB\u05E0\u05E1 \u05DE\u05D8\u05E8\u05D9\u05E7\u05E1",
      "menu.insert vector": "\u05D4\u05DB\u05E0\u05E1 \u05D5\u05E7\u05D8\u05D5\u05E8",
      "submenu.array.matrix delimiters": "\u05DE\u05E4\u05E8\u05D9\u05D3\u05D9 \u05DE\u05D8\u05E8\u05D9\u05E7\u05E1",
      "menu.array.add row above": "\u05D4\u05D5\u05E1\u05E3 \u05E9\u05D5\u05E8\u05D4 \u05D0\u05D7\u05E8\u05D9",
      "menu.array.add row below": "\u05D4\u05D5\u05E1\u05E3 \u05E9\u05D5\u05E8\u05D4 \u05DC\u05E4\u05E0\u05D9",
      "menu.array.add column after": "\u05D4\u05D5\u05E1\u05E3 \u05E2\u05DE\u05D5\u05D3\u05D4 \u05D0\u05D7\u05E8\u05D9",
      "menu.array.add column before": "\u05D4\u05D5\u05E1\u05E3 \u05E2\u05DE\u05D5\u05D3\u05D4 \u05DC\u05E4\u05E0\u05D9",
      "menu.array.delete row": "\u05DE\u05D7\u05E7 \u05E9\u05D5\u05E8\u05D4",
      "menu.array.delete rows": "\u05DE\u05D7\u05E7 \u05E9\u05D5\u05E8\u05D5\u05EA \u05E9\u05E0\u05D1\u05D7\u05E8\u05D5",
      "menu.array.delete column": "\u05DE\u05D7\u05E7 \u05E2\u05DE\u05D5\u05D3\u05D4",
      "menu.array.delete columns": "\u05DE\u05D7\u05E7 \u05E2\u05DE\u05D5\u05D3\u05D5\u05EA \u05E9\u05E0\u05D1\u05D7\u05E8\u05D5",
      "submenu.array.insert separator": "\u05D4\u05DB\u05E0\u05E1 \u05DE\u05E4\u05E8\u05D9\u05D3",
      "menu.insert table": "\u05D4\u05DB\u05E0\u05E1 \u05D8\u05D1\u05DC\u05D4",
      "submenu.table style": "\u05D8\u05D1\u05DC\u05D4 \u05E1\u05B4\u05D2\u05B0\u05E0\u05D5\u05B9\u05DF"
    },
    hr: {
      "keyboard.tooltip.functions": "Funkcije",
      "keyboard.tooltip.symbols": "Simboli",
      "keyboard.tooltip.greek": "Gr\u010Dka slova",
      "keyboard.tooltip.command": "LaTeX naredbeni na\u010Din",
      "keyboard.tooltip.numeric": "Numeri\u010Dki",
      "keyboard.tooltip.roman": "Rimska slova",
      "tooltip.copy to clipboard": "Kopirati u me\u0111uspremnik",
      "tooltip.redo": "Ponovi",
      "tooltip.toggle virtual keyboard": "Uklju\u010Di / isklju\u010Di virtualnu tipkovnicu",
      "tooltip.undo": "Poni\u0161ti",
      "menu.insert matrix": "Umetni matricu",
      "menu.insert vector": "Umetni vektor",
      "submenu.array.matrix delimiters": "Matri\u010Dni razdjelnici",
      "menu.array.add row above": "Dodaj redak nakon",
      "menu.array.add row below": "Dodaj redak prije",
      "menu.array.add column after": "Dodaj stupac nakon",
      "menu.array.add column before": "Dodaj stupac prije",
      "menu.array.delete row": "Izbri\u0161i redak",
      "menu.array.delete rows": "Izbri\u0161i odabrane retke",
      "menu.array.delete column": "Izbri\u0161i stupac",
      "menu.array.delete columns": "Izbri\u0161i odabrane stupce",
      "submenu.array.insert separator": "Umetni separator",
      "menu.insert table": "Umetni tablicu",
      "submenu.table style": "Stil tabele"
    },
    id: {
      "keyboard.tooltip.functions": "Fungsi",
      "keyboard.tooltip.symbols": "Simbol",
      "keyboard.tooltip.greek": "Huruf Yunani",
      "keyboard.tooltip.command": "Mode Perintah LaTeX",
      "keyboard.tooltip.numeric": "Numerik",
      "keyboard.tooltip.roman": "Surat Romawi",
      "tooltip.copy to clipboard": "Menyalin ke clipboard",
      "tooltip.redo": "Mengulangi",
      "tooltip.toggle virtual keyboard": "Alihkan Keyboard Virtual",
      "tooltip.undo": "Membuka",
      "menu.insert matrix": "Sisipkan Matriks",
      "menu.insert vector": "Sisipkan Vektor",
      "submenu.array.matrix delimiters": "Pembatas Matriks",
      "menu.array.add row above": "Tambahkan Baris Setelah",
      "menu.array.add row below": "Tambahkan Baris Sebelumnya",
      "menu.array.add column after": "Tambahkan Kolom Setelah",
      "menu.array.add column before": "Tambahkan Kolom Sebelumnya",
      "menu.array.delete row": "Hapus Baris",
      "menu.array.delete rows": "Hapus Baris yang Dipilih",
      "menu.array.delete column": "Hapus Kolom",
      "menu.array.delete columns": "Hapus Kolom yang Dipilih",
      "submenu.array.insert separator": "Sisipkan Pemisah",
      "menu.insert table": "Sisipkan Tabel",
      "submenu.table style": "Gaya Tabel"
    },
    hi: {
      "keyboard.tooltip.functions": "\u0915\u093E\u0930\u094D\u092F\u094B\u0902",
      "keyboard.tooltip.symbols": "\u092A\u094D\u0930\u0924\u0940\u0915",
      "keyboard.tooltip.greek": "\u0917\u094D\u0930\u0940\u0915 \u0905\u0915\u094D\u0937\u0930",
      "keyboard.tooltip.command": "\u0932\u093E\u091F\u0947\u0915\u094D\u0938 \u0915\u092E\u093E\u0902\u0921 \u092E\u094B\u0921",
      "keyboard.tooltip.numeric": "\u0938\u0902\u0916\u094D\u092F\u093E\u0924\u094D\u092E\u0915",
      "keyboard.tooltip.roman": "\u0930\u094B\u092E\u0928 \u092A\u0924\u094D\u0930",
      "tooltip.copy to clipboard": "\u0915\u094D\u0932\u093F\u092A\u092C\u094B\u0930\u094D\u0921 \u092A\u0930 \u0915\u0949\u092A\u0940 \u0915\u0930\u0947\u0902",
      "tooltip.redo": "\u092B\u093F\u0930 \u0938\u0947 \u0915\u0930\u0947\u0902",
      "tooltip.toggle virtual keyboard": "\u0935\u0930\u094D\u091A\u0941\u0905\u0932 \u0915\u0940\u092C\u094B\u0930\u094D\u0921 \u091F\u0949\u0917\u0932 \u0915\u0930\u0947\u0902",
      "tooltip.undo": "\u092A\u0942\u0930\u094D\u0935\u0935\u0924",
      "menu.insert matrix": "\u092E\u0948\u091F\u094D\u0930\u093F\u0915\u094D\u0938 \u0921\u093E\u0932\u0947\u0902",
      "menu.insert vector": "\u0935\u0947\u0915\u094D\u091F\u0930 \u0921\u093E\u0932\u0947\u0902",
      "submenu.array.matrix delimiters": "\u092E\u0948\u091F\u094D\u0930\u093F\u0915\u094D\u0938 \u0938\u0940\u092E\u093E\u0902\u0915\u0915",
      "menu.array.add row above": "\u092C\u093E\u0926 \u092E\u0947\u0902 \u092A\u0902\u0915\u094D\u0924\u093F \u091C\u094B\u0921\u093C\u0947\u0902",
      "menu.array.add row below": "\u092A\u0939\u0932\u0947 \u092A\u0902\u0915\u094D\u0924\u093F \u091C\u094B\u0921\u093C\u0947\u0902",
      "menu.array.add column after": "\u092C\u093E\u0926 \u092E\u0947\u0902 \u0915\u0949\u0932\u092E \u091C\u094B\u0921\u093C\u0947\u0902",
      "menu.array.add column before": "\u092A\u0939\u0932\u0947 \u0915\u0949\u0932\u092E \u091C\u094B\u0921\u093C\u0947\u0902",
      "menu.array.delete row": "\u092A\u0902\u0915\u094D\u0924\u093F \u0915\u094B \u0939\u091F\u093E\u090F\u0902",
      "menu.array.delete rows": "\u091A\u092F\u0928\u093F\u0924 \u092A\u0902\u0915\u094D\u0924\u093F\u092F\u094B\u0902 \u0915\u094B \u0939\u091F\u093E\u090F\u0902",
      "menu.array.delete column": "\u0915\u0949\u0932\u092E \u0939\u091F\u093E\u090F\u0902",
      "menu.array.delete columns": "\u091A\u092F\u0928\u093F\u0924 \u0915\u0949\u0932\u092E \u0939\u091F\u093E\u090F\u0902",
      "submenu.array.insert separator": "\u0935\u093F\u092D\u093E\u091C\u0915 \u0921\u093E\u0932\u0947\u0902",
      "menu.insert table": "\u091F\u0947\u092C\u0932 \u0907\u0902\u0938\u0930\u094D\u091F \u0915\u0930\u0947\u0902",
      "submenu.table style": "\u091F\u0947\u092C\u0932 \u0938\u094D\u091F\u093E\u0907\u0932"
    },
    hu: {
      "keyboard.tooltip.functions": "Funkci\xf3k",
      "keyboard.tooltip.symbols": "Szimb\xf3lumok",
      "keyboard.tooltip.greek": "G\xf6r\xf6g levelek",
      "keyboard.tooltip.command": "LaTeX Parancs m\xf3d",
      "keyboard.tooltip.numeric": "Numerikus",
      "keyboard.tooltip.roman": "R\xf3mai levelek",
      "tooltip.copy to clipboard": "M\xe1solja a v\xe1g\xf3lapra",
      "tooltip.redo": "\xdajra",
      "tooltip.toggle virtual keyboard": "V\xE1lt\xE1s a virtu\xE1lis billenty\u0171zetre",
      "tooltip.undo": "Visszavon\xe1s",
      "menu.insert matrix": "Helyezze be a M\xe1trixot",
      "menu.insert vector": "Vektor besz\xfar\xe1sa",
      "submenu.array.matrix delimiters": "M\xe1trixhat\xe1rol\xf3k",
      "menu.array.add row above": "Sor hozz\xe1ad\xe1sa ut\xe1n",
      "menu.array.add row below": "Add Add Sor el\u0151tt",
      "menu.array.add column after": "Oszlop hozz\xe1ad\xe1sa ut\xe1n",
      "menu.array.add column before": "Add oszlop el\u0151tt",
      "menu.array.delete row": "Sor t\xf6rl\xe9se",
      "menu.array.delete rows": "Kijel\xf6lt sorok t\xf6rl\xe9se",
      "menu.array.delete column": "Oszlop t\xf6rl\xe9se",
      "menu.array.delete columns": "A kijel\xf6lt oszlopok t\xf6rl\xe9se",
      "submenu.array.insert separator": "Helyezze be az elv\xe1laszt\xf3t",
      "menu.insert table": "Helyezze be a t\xe1bl\xe1zatot",
      "submenu.table style": "T\xe1bl\xe1zatos st\xedlus"
    },
    it: {
      "keyboard.tooltip.functions": "Funzioni",
      "keyboard.tooltip.symbols": "Simboli",
      "keyboard.tooltip.greek": "Lettere greche",
      "keyboard.tooltip.command": "Modalit\xe0 di comando LaTeX",
      "keyboard.tooltip.numeric": "Numerico",
      "keyboard.tooltip.roman": "Lettere romane",
      "tooltip.copy to clipboard": "Copia negli appunti",
      "tooltip.redo": "Rifare",
      "tooltip.toggle virtual keyboard": "Attiva / disattiva la tastiera virtuale",
      "tooltip.undo": "Disfare",
      "menu.insert matrix": "Inserisci una Matrice",
      "menu.insert vector": "Inserisci Vettore",
      "submenu.array.matrix delimiters": "Delimitatori di Matrice",
      "menu.array.add row above": "Aggiungi una Riga Prima",
      "menu.array.add row below": "Aggiungi una Riga Dopo",
      "menu.array.add column before": "Aggiungi una Colonna Prima",
      "menu.array.add column after": "Aggiungi una Colonna Dopo",
      "menu.array.delete row": "Rimuovi una Riga",
      "menu.array.delete rows": "Rimuovi le Righe Selezionate",
      "menu.array.delete column": "Rimuovi una Colonna",
      "menu.array.delete columns": "Rimuovi le Colonne Selezionate",
      "submenu.array.insert separator": "Inserisci un Separatore",
      "menu.insert table": "Inserisci Tabella",
      "submenu.table style": "Stile tabella"
    },
    is: {
      "keyboard.tooltip.functions": "A\xf0ger\xf0ir",
      "keyboard.tooltip.symbols": "T\xe1kn",
      "keyboard.tooltip.greek": "Gr\xedsk br\xe9f",
      "keyboard.tooltip.command": "LaTeX stj\xf3rnunarstilling",
      "keyboard.tooltip.numeric": "T\xf6lulegt",
      "keyboard.tooltip.roman": "R\xf3mversk br\xe9f",
      "tooltip.copy to clipboard": "Afrita\xf0u \xe1 klemmuspjald",
      "tooltip.redo": "Endurtaka",
      "tooltip.toggle virtual keyboard": "Skiptu um s\xfdndarlyklabor\xf0",
      "tooltip.undo": "Afturkalla",
      "menu.insert matrix": "Settu fylki inn",
      "menu.insert vector": "Settu inn Vector",
      "submenu.array.matrix delimiters": "Matrix afm\xf6rkun",
      "menu.array.add row above": "B\xe6ta vi\xf0 r\xf6\xf0 \xe1 eftir",
      "menu.array.add row below": "B\xe6ta vi\xf0 r\xf6\xf0 \xe1\xf0ur",
      "menu.array.add column after": "B\xe6ta vi\xf0 d\xe1lki \xe1 eftir",
      "menu.array.add column before": "B\xe6ta vi\xf0 d\xe1lki \xe1\xf0ur",
      "menu.array.delete row": "Ey\xf0a r\xf6\xf0",
      "menu.array.delete rows": "Ey\xf0a v\xf6ldum l\xednum",
      "menu.array.delete column": "Ey\xf0a d\xe1lki",
      "menu.array.delete columns": "Ey\xf0a v\xf6ldum d\xe1lkum",
      "submenu.array.insert separator": "Settu skiljuna \xed",
      "menu.insert table": "Settu inn t\xf6flu",
      "submenu.table style": "T\xf6flu st\xedl"
    },
    ja: {
      "keyboard.tooltip.functions": "\u95A2\u6570",
      "keyboard.tooltip.symbols": "\u30B7\u30F3\u30DC\u30EB",
      "keyboard.tooltip.greek": "\u30AE\u30EA\u30B7\u30E3\u6587\u5B57",
      "keyboard.tooltip.command": "\u30E9\u30C6\u30C3\u30AF\u30B9\u30B3\u30DE\u30F3\u30C9\u30E2\u30FC\u30C9",
      "keyboard.tooltip.numeric": "\u6570\u5024",
      "keyboard.tooltip.roman": "\u30ED\u30FC\u30DE\u5B57",
      "tooltip.copy to clipboard": "\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC",
      "tooltip.redo": "\u3084\u308A\u76F4\u3057",
      "tooltip.toggle virtual keyboard": "\u4EEE\u60F3\u30AD\u30FC\u30DC\u30FC\u30C9\u306E\u5207\u308A\u66FF\u3048",
      "tooltip.undo": "\u5143\u306B\u623B\u3059",
      "menu.insert matrix": "\u30DE\u30C8\u30EA\u30C3\u30AF\u30B9\u3092\u633F\u5165",
      "menu.insert vector": "\u30D9\u30AF\u30C8\u30EB\u3092\u633F\u5165",
      "submenu.array.matrix delimiters": "\u884C\u5217\u533A\u5207\u308A\u6587\u5B57",
      "menu.array.add row above": "\u5F8C\u306B\u884C\u3092\u8FFD\u52A0",
      "menu.array.add row below": "\u524D\u306B\u884C\u3092\u8FFD\u52A0",
      "menu.array.add column after": "\u5F8C\u306B\u5217\u3092\u8FFD\u52A0",
      "menu.array.add column before": "\u524D\u306B\u5217\u3092\u8FFD\u52A0",
      "menu.array.delete row": "\u884C\u3092\u524A\u9664",
      "menu.array.delete rows": "\u9078\u629E\u3057\u305F\u884C\u3092\u524A\u9664\u3059\u308B",
      "menu.array.delete column": "\u5217\u3092\u524A\u9664",
      "menu.array.delete columns": "\u9078\u629E\u3057\u305F\u5217\u3092\u524A\u9664\u3059\u308B",
      "submenu.array.insert separator": "\u30BB\u30D1\u30EC\u30FC\u30BF\u30FC\u3092\u633F\u5165",
      "menu.insert table": "\u30C6\u30FC\u30D6\u30EB\u3092\u633F\u5165",
      "submenu.table style": "\u30C6\u30FC\u30D6\u30EB\u30B9\u30BF\u30A4\u30EB"
    },
    ko: {
      "keyboard.tooltip.functions": "\uAE30\uB2A5",
      "keyboard.tooltip.symbols": "\uAE30\uD638",
      "keyboard.tooltip.greek": "\uADF8\uB9AC\uC2A4 \uBB38\uC790",
      "keyboard.tooltip.command": "\uC720\uC561 \uBA85\uB839 \uBAA8\uB4DC",
      "keyboard.tooltip.numeric": "\uC22B\uC790",
      "keyboard.tooltip.roman": "\uB85C\uB9C8 \uBB38\uC790",
      "tooltip.copy to clipboard": "\uD074\uB9BD \uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC",
      "tooltip.redo": "\uB2E4\uC2DC \uD558\uB2E4",
      "tooltip.toggle virtual keyboard": "\uAC00\uC0C1 \uD0A4\uBCF4\uB4DC \uC804\uD658",
      "tooltip.undo": "\uC2E4\uD589 \uCDE8\uC18C",
      "menu.insert matrix": "\uB9E4\uD2B8\uB9AD\uC2A4 \uC0BD\uC785",
      "menu.insert vector": "\uBCA1\uD130 \uC0BD\uC785",
      "submenu.array.matrix delimiters": "\uD589\uB82C \uAD6C\uBD84 \uAE30\uD638",
      "menu.array.add row above": "\uB4A4\uC5D0 \uD589 \uCD94\uAC00",
      "menu.array.add row below": "\uC55E\uC5D0 \uD589 \uCD94\uAC00",
      "menu.array.add column after": "\uB4A4\uC5D0 \uC5F4 \uCD94\uAC00",
      "menu.array.add column before": "\uC55E\uC5D0 \uC5F4 \uCD94\uAC00",
      "menu.array.delete row": "\uD589 \uC0AD\uC81C",
      "menu.array.delete rows": "\uC120\uD0DD\uD55C \uD589 \uC0AD\uC81C",
      "menu.array.delete column": "\uC5F4 \uC0AD\uC81C",
      "menu.array.delete columns": "\uC120\uD0DD\uD55C \uC5F4 \uC0AD\uC81C",
      "submenu.array.insert separator": "\uAD6C\uBD84\uC790 \uC0BD\uC785",
      "menu.insert table": "\uD45C \uC0BD\uC785",
      "submenu.table style": "\uD14C\uC774\uBE14 \uC2A4\uD0C0\uC77C"
    },
    lv: {
      "keyboard.tooltip.functions": "Funkcijas",
      "keyboard.tooltip.symbols": "Simboli",
      "keyboard.tooltip.greek": "Grie\u0137u burti",
      "keyboard.tooltip.command": "LaTeX komandu re\u017E\u012Bms",
      "keyboard.tooltip.numeric": "Ciparu skaitlis",
      "keyboard.tooltip.roman": "Romie\u0161u v\u0113stules",
      "tooltip.copy to clipboard": "Kop\u0113t starpliktuv\u0113",
      "tooltip.redo": "P\u0101rtais\u012Bt",
      "tooltip.toggle virtual keyboard": "P\u0101rsl\u0113gt virtu\u0101lo tastat\u016Bru",
      "tooltip.undo": "Atsaukt",
      "menu.insert matrix": "Ievietojiet matricu",
      "menu.insert vector": "Ievietot vektoru",
      "submenu.array.matrix delimiters": "Matricas norobe\u017Eot\u0101ji",
      "menu.array.add row above": "Pievienot rindu p\u0113c",
      "menu.array.add row below": "Pievienot rindu pirms",
      "menu.array.add column after": "Pievienot kolonnu p\u0113c",
      "menu.array.add column before": "Pievienot kolonnu pirms",
      "menu.array.delete row": "Dz\u0113st rindu",
      "menu.array.delete rows": "Dz\u0113st atlas\u012Bt\u0101s rindas",
      "menu.array.delete column": "Dz\u0113st kolonnu",
      "menu.array.delete columns": "Dz\u0113st atlas\u012Bt\u0101s kolonnas",
      "submenu.array.insert separator": "Ievietojiet atdal\u012Bt\u0101ju",
      "menu.insert table": "Ievietojiet tabulu",
      "submenu.table style": "Galda stils"
    },
    lt: {
      "keyboard.tooltip.functions": "Funkcijos",
      "keyboard.tooltip.symbols": "Simboliai",
      "keyboard.tooltip.greek": "Graiki\u0161kos raid\u0117s",
      "keyboard.tooltip.command": "LaTeX komand\u0173 re\u017Eimas",
      "keyboard.tooltip.numeric": "Skaitmeninis",
      "keyboard.tooltip.roman": "Romos lai\u0161kai",
      "tooltip.copy to clipboard": "Nukopijuoti \u012F i\u0161karpin\u0119",
      "tooltip.redo": "Perdaryti",
      "tooltip.toggle virtual keyboard": "Perjungti virtuali\u0105j\u0105 klaviat\u016Br\u0105",
      "tooltip.undo": "At\u0161aukti",
      "menu.insert matrix": "Ievietojiet matricu",
      "menu.insert vector": "Ievietot vektoru",
      "submenu.array.matrix delimiters": "Matricas norobe\u017Eot\u0101ji",
      "menu.array.add row above": "Pievienot rindu p\u0113c",
      "menu.array.add row below": "Pievienot rindu pirms",
      "menu.array.add column after": "Pievienot kolonnu p\u0113c",
      "menu.array.add column before": "Pievienot kolonnu pirms",
      "menu.array.delete row": "Dz\u0113st rindu",
      "menu.array.delete rows": "Dz\u0113st atlas\u012Bt\u0101s rindas",
      "menu.array.delete column": "Dz\u0113st kolonnu",
      "menu.array.delete columns": "Dz\u0113st atlas\u012Bt\u0101s kolonnas",
      "submenu.array.insert separator": "Ievietojiet atdal\u012Bt\u0101ju",
      "menu.insert table": "Ievietojiet tabulu",
      "submenu.table style": "Tabulas stili"
    },
    lu: {
      "keyboard.tooltip.functions": "Funktiounen",
      "keyboard.tooltip.symbols": "Symboler",
      "keyboard.tooltip.greek": "Griichesch Br\xe9iwer",
      "keyboard.tooltip.command": "Latex Kommando Modus",
      "keyboard.tooltip.numeric": "Numeresch",
      "keyboard.tooltip.roman": "R\xe9imesch Br\xe9iwer",
      "tooltip.copy to clipboard": "Kop\xe9iert op Clipboard",
      "tooltip.redo": "Nees nei maachen",
      "tooltip.toggle virtual keyboard": "Wiesselt Virtuell Tastatur",
      "tooltip.undo": "Undoen",
      "menu.insert matrix": "Matrix asetzen",
      "menu.insert vector": "Insert Vector",
      "submenu.array.matrix delimiters": "Matrix Ofgrenzer",
      "menu.array.add row above": "Dob\xe4izemaachen Rei No",
      "menu.array.add row below": "F\xfc\xfcgt Rei vir",
      "menu.array.add column after": "Dob\xe4izemaachen Kolonn No",
      "menu.array.add column before": "Kolonn derb\xe4i Virun",
      "menu.array.delete row": "Rad l\xe4schen",
      "menu.array.delete rows": "L\xe4scht Ausgewielte Reien",
      "menu.array.delete column": "L\xe4scht Kolonn",
      "menu.array.delete columns": "L\xe4scht Ausgewielte Kolonnen",
      "submenu.array.insert separator": "Insert Separator",
      "menu.insert table": "D\xebsch anzeginn",
      "submenu.table style": "D\xebsch Style"
    },
    nl: {
      "keyboard.tooltip.functions": "Functies",
      "keyboard.tooltip.symbols": "Symbolen",
      "keyboard.tooltip.greek": "Griekse letters",
      "keyboard.tooltip.command": "LaTeX commando mode",
      "keyboard.tooltip.numeric": "Numeriek",
      "keyboard.tooltip.roman": "Romeinse letters",
      "tooltip.copy to clipboard": "Kopi\xebren naar klembord",
      "tooltip.redo": "Opnieuw",
      "tooltip.toggle virtual keyboard": "Schakel naar virtueel toetsenbord",
      "tooltip.undo": "Ongedaan maken",
      "menu.insert matrix": "Matrix invoegen",
      "menu.insert vector": "Vector invoegen",
      "submenu.array.matrix delimiters": "Matrixscheidingstekens",
      "menu.array.add row above": "Rij toevoegen na",
      "menu.array.add row below": "Rij toevoegen eerder",
      "menu.array.add column after": "Kolom toevoegen na",
      "menu.array.add column before": "Kolom toevoegen voor",
      "menu.array.delete row": "Verwijder rij",
      "menu.array.delete rows": "Geselecteerde rijen verwijderen",
      "menu.array.delete column": "Kolom verwijderen",
      "menu.array.delete columns": "Geselecteerde kolommen verwijderen",
      "submenu.array.insert separator": "Scheidingsteken invoegen",
      "menu.insert table": "Tabel invoegen",
      "submenu.table style": "Tabelstijl"
    },
    no: {
      "keyboard.tooltip.functions": "Funksjoner",
      "keyboard.tooltip.symbols": "Symboler",
      "keyboard.tooltip.greek": "Greske bokstaver",
      "keyboard.tooltip.command": "LaTeX kommandomodus",
      "keyboard.tooltip.numeric": "Numerisk",
      "keyboard.tooltip.roman": "Romerske bokstaver",
      "tooltip.copy to clipboard": "Kopiere til utklippstavle",
      "tooltip.redo": "Gj\xf8re om",
      "tooltip.toggle virtual keyboard": "Bytt virtuelt tastatur",
      "tooltip.undo": "Angre",
      "menu.insert matrix": "Sett inn matrise",
      "menu.insert vector": "Sett inn vektor",
      "submenu.array.matrix delimiters": "Matrix avgrensere",
      "menu.array.add row above": "Legg til rad etter",
      "menu.array.add row below": "Legg til rad f\xf8r",
      "menu.array.add column after": "Legg til kolonne etter",
      "menu.array.add column before": "Legg til kolonne f\xf8r",
      "menu.array.delete row": "Slett rad",
      "menu.array.delete rows": "Slett valgte rader",
      "menu.array.delete column": "Slett kolonne",
      "menu.array.delete columns": "Slett valgte kolonner",
      "submenu.array.insert separator": "Sett inn skilletegn",
      "menu.insert table": "Sett inn tabell",
      "submenu.table style": "Tabellstil"
    },
    mk: {
      "keyboard.tooltip.functions": "\u0424\u0443\u043D\u043A\u0446\u0438\u0438",
      "keyboard.tooltip.symbols": "\u0421\u0438\u043C\u0431\u043E\u043B\u0438",
      "keyboard.tooltip.greek": "\u0413\u0440\u0447\u043A\u0438 \u0431\u0443\u043A\u0432\u0438",
      "keyboard.tooltip.command": "\u0420\u0435\u0436\u0438\u043C \u043D\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \u0432\u043E \u043B\u0430\u0442\u0435\u043A\u0441",
      "keyboard.tooltip.numeric": "\u041D\u0443\u043C\u0435\u0440\u0438\u0447\u043A\u0438",
      "keyboard.tooltip.roman": "\u0420\u0438\u043C\u0441\u043A\u0438 \u043F\u0438\u0441\u043C\u0430",
      "tooltip.copy to clipboard": "\u041A\u043E\u043F\u0438\u0440\u0430\u0458\u0442\u0435 \u0432\u043E \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434",
      "tooltip.redo": "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
      "tooltip.toggle virtual keyboard": "\u0412\u043A\u043B\u0443\u0447\u0435\u0442\u0435 \u0458\u0430 \u0432\u0438\u0440\u0442\u0443\u0435\u043B\u043D\u0430\u0442\u0430 \u0442\u0430\u0441\u0442\u0430\u0442\u0443\u0440\u0430",
      "tooltip.undo": "\u0412\u0440\u0430\u0442\u0438",
      "menu.insert matrix": "\u0412\u043C\u0435\u0442\u043D\u0435\u0442\u0435 \u043C\u0430\u0442\u0440\u0438\u0446\u0430",
      "menu.insert vector": "\u0412\u043C\u0435\u0442\u043D\u0438 \u0432\u0435\u043A\u0442\u043E\u0440",
      "submenu.array.matrix delimiters": "\u0420\u0430\u0437\u0433\u0440\u0430\u043D\u0438\u0447\u0443\u0432\u0430\u0447\u0438 \u043D\u0430 \u043C\u0430\u0442\u0440\u0438\u0446\u0430",
      "menu.array.add row above": "\u0414\u043E\u0434\u0430\u0434\u0435\u0442\u0435 \u0440\u0435\u0434 \u043F\u043E\u0441\u043B\u0435",
      "menu.array.add row below": "\u0414\u043E\u0434\u0430\u0434\u0438 \u0440\u0435\u0434 \u043F\u0440\u0435\u0434 \u0442\u043E\u0430",
      "menu.array.add column after": "\u0414\u043E\u0434\u0430\u0434\u0435\u0442\u0435 \u043A\u043E\u043B\u043E\u043D\u0430 \u043F\u043E\u0441\u043B\u0435",
      "menu.array.add column before": "\u0414\u043E\u0434\u0430\u0434\u0435\u0442\u0435 \u043A\u043E\u043B\u043E\u043D\u0430 \u043F\u0440\u0435\u0434 \u0442\u043E\u0430",
      "menu.array.delete row": "\u0418\u0437\u0431\u0440\u0438\u0448\u0438 \u0433\u043E \u0440\u0435\u0434\u043E\u0442",
      "menu.array.delete rows": "\u0418\u0437\u0431\u0440\u0438\u0448\u0435\u0442\u0435 \u0433\u0438 \u0438\u0437\u0431\u0440\u0430\u043D\u0438\u0442\u0435 \u0440\u0435\u0434\u043E\u0432\u0438",
      "menu.array.delete column": "\u0418\u0437\u0431\u0440\u0438\u0448\u0438 \u0458\u0430 \u043A\u043E\u043B\u043E\u043D\u0430\u0442\u0430",
      "menu.array.delete columns": "\u0418\u0437\u0431\u0440\u0438\u0448\u0438 \u0458\u0430 \u043A\u043E\u043B\u043E\u043D\u0430\u0442\u0430",
      "submenu.array.insert separator": "\u0412\u043C\u0435\u0442\u043D\u0435\u0442\u0435 \u0441\u0435\u043F\u0430\u0440\u0430\u0442\u043E\u0440",
      "menu.insert table": "\u0412\u043C\u0435\u0442\u043D\u0438 \u0442\u0430\u0431\u0435\u043B\u0430",
      "submenu.table style": "\u0422\u0430\u0431\u0435\u043B\u0430 \u0441\u0442\u0438\u043B"
    },
    pl: {
      "keyboard.tooltip.functions": "Funkcje",
      "keyboard.tooltip.symbols": "Symbolika",
      "keyboard.tooltip.greek": "Litery greckie",
      "keyboard.tooltip.command": "Tryb polece\u0144 LaTeX",
      "keyboard.tooltip.numeric": "Numeryczne",
      "keyboard.tooltip.roman": "Litery rzymskie",
      "tooltip.copy to clipboard": "Kopiuj do Schowka",
      "tooltip.redo": "Przywr\xF3\u0107",
      "tooltip.toggle virtual keyboard": "Prze\u0142\u0105cz wirtualn\u0105 klawiatur\u0119",
      "tooltip.undo": "Cofnij",
      "menu.insert matrix": "Wstaw macierz",
      "menu.insert vector": "Wstaw wektor",
      "submenu.array.matrix delimiters": "Ograniczniki macierzy",
      "menu.array.add row above": "Dodaj wiersz po",
      "menu.array.add row below": "Dodaj wiersz przed",
      "menu.array.add column after": "Dodaj kolumn\u0119 po",
      "menu.array.add column before": "Dodaj kolumn\u0119 przed",
      "menu.array.delete row": "Usu\u0144 wiersz",
      "menu.array.delete rows": "Usu\u0144 wybrane wiersze",
      "menu.array.delete column": "Usu\u0144 kolumn\u0119",
      "menu.array.delete columns": "Usu\u0144 wybrane kolumny",
      "submenu.array.insert separator": "Wstaw separator",
      "menu.insert table": "Wype\u0142nij tabel\u0119",
      "submenu.table style": "Styl tabel\u0119"
    },
    pt: {
      "keyboard.tooltip.functions": "Functions",
      "keyboard.tooltip.symbols": "S\xedmbolos",
      "keyboard.tooltip.greek": "Letras gregas",
      "keyboard.tooltip.command": "Modo de Comando LaTeX",
      "keyboard.tooltip.numeric": "Num\xe9rico",
      "keyboard.tooltip.roman": "Letras romanas",
      "tooltip.copy to clipboard": "Copiar para \xe1rea de transfer\xeancia",
      "tooltip.redo": "Refazer",
      "tooltip.toggle virtual keyboard": "Alternar teclado virtual",
      "tooltip.undo": "Desfazer",
      "menu.insert matrix": "Inserir Matriz",
      "menu.insert vector": "Inserir vetor",
      "submenu.array.matrix delimiters": "Delimitadores de matriz",
      "menu.array.add row above": "Adicionar linha depois",
      "menu.array.add row below": "Adicionar linha antes",
      "menu.array.add column after": "Adicionar coluna depois",
      "menu.array.add column before": "Adicionar coluna antes",
      "menu.array.delete row": "Excluir linha",
      "menu.array.delete rows": "Excluir linhas selecionadas",
      "menu.array.delete column": "Apagar Coluna",
      "menu.array.delete columns": "Excluir Colunas Selecionadas",
      "submenu.array.insert separator": "Inserir Separador",
      "menu.insert table": "Insira a tabela",
      "submenu.table style": "Estilo tabela"
    },
    ro: {
      "keyboard.tooltip.functions": "Func\u021Bii",
      "keyboard.tooltip.symbols": "Simboluri",
      "keyboard.tooltip.greek": "Scrisori grece\u0219ti",
      "keyboard.tooltip.command": "Modul de comand\u0103 latex",
      "keyboard.tooltip.numeric": "Numeric",
      "keyboard.tooltip.roman": "Scrisori romane",
      "tooltip.copy to clipboard": "Copia\u021Bi \xEEn clipboard",
      "tooltip.redo": "A reface",
      "tooltip.toggle virtual keyboard": "Comuta\u021Bi tastatura virtual\u0103",
      "tooltip.undo": "Anula",
      "menu.insert matrix": "Introduce\u021Bi Matrix",
      "menu.insert vector": "Insera\u021Bi Vector",
      "submenu.array.matrix delimiters": "Delimitatori de matrice",
      "menu.array.add row above": "Ad\u0103uga\u021Bi r\xE2ndul dup\u0103",
      "menu.array.add row below": "Ad\u0103uga\u021Bi r\xE2ndul \xEEnainte",
      "menu.array.add column after": "Ad\u0103uga\u021Bi o coloan\u0103 dup\u0103",
      "menu.array.add column before": "Ad\u0103uga\u021Bi o coloan\u0103 \xEEnainte",
      "menu.array.delete row": "\u0218terge\u021Bi r\xE2ndul",
      "menu.array.delete rows": "\u0218terge\u021Bi r\xE2ndurile selectate",
      "menu.array.delete column": "\u0218terge\u021Bi coloana",
      "menu.array.delete columns": "\u0218terge\u021Bi coloanele selectate",
      "submenu.array.insert separator": "Introduce\u021Bi separatorul",
      "menu.insert table": "Introduce\u021Bi tabelul",
      "submenu.table style": "Table style"
    },
    ru: {
      "keyboard.tooltip.functions": "\u0424\u0443\u043D\u043A\u0446\u0438\u0438",
      "keyboard.tooltip.symbols": "\u0421\u0438\u043C\u0432\u043E\u043B\u044B",
      "keyboard.tooltip.greek": "\u0413\u0440\u0435\u0447\u0435\u0441\u043A\u0438\u0435 \u0431\u0443\u043A\u0432\u044B",
      "keyboard.tooltip.command": "\u0420\u0435\u0436\u0438\u043C \u043A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0439 \u0441\u0442\u0440\u043E\u043A\u0438 \u041B\u0430\u0442\u0435\u043A\u0441",
      "keyboard.tooltip.numeric": "\u0447\u0438\u0441\u043B\u043E\u0432\u043E\u0439",
      "keyboard.tooltip.roman": "\u041B\u0430\u0442\u0438\u043D\u0441\u043A\u0438\u0435 \u0431\u0443\u043A\u0432\u044B",
      "tooltip.copy to clipboard": "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
      "tooltip.redo": "\u043F\u0435\u0440\u0435\u0434\u0435\u043B\u044B\u0432\u0430\u0442\u044C",
      "tooltip.toggle virtual keyboard": "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u0443\u044E \u043A\u043B\u0430\u0432\u0438\u0430\u0442\u0443\u0440\u0443",
      "tooltip.undo": "\u0440\u0430\u0441\u0441\u0442\u0435\u0433\u0438\u0432\u0430\u0442\u044C",
      "menu.insert matrix": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043C\u0430\u0442\u0440\u0438\u0446\u0443",
      "menu.insert vector": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0432\u0435\u043A\u0442\u043E\u0440",
      "submenu.array.matrix delimiters": "\u041C\u0430\u0442\u0440\u0438\u0447\u043D\u044B\u0435 \u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u0438",
      "menu.array.add row above": "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u0443 \u043F\u043E\u0441\u043B\u0435",
      "menu.array.add row below": "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u0443 \u043F\u0435\u0440\u0435\u0434",
      "menu.array.add column after": "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446 \u043F\u043E\u0441\u043B\u0435",
      "menu.array.add column before": "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446 \u043F\u0435\u0440\u0435\u0434",
      "menu.array.delete row": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u0443",
      "menu.array.delete rows": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0441\u0442\u0440\u043E\u043A\u0438",
      "menu.array.delete column": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446",
      "menu.array.delete columns": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0441\u0442\u043E\u043B\u0431\u0446\u044B",
      "submenu.array.insert separator": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C",
      "menu.insert table": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0442\u0430\u0431\u043B\u0438\u0446\u0443",
      "submenu.table style": "\u0422\u0430\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C"
    },
    sk: {
      "keyboard.tooltip.functions": "Functions",
      "keyboard.tooltip.symbols": "Symboly",
      "keyboard.tooltip.greek": "Gr\xe9cke listy",
      "keyboard.tooltip.command": "Pr\xEDkazov\xFD re\u017Eim LaTeX",
      "keyboard.tooltip.numeric": "Numerick\xe9",
      "keyboard.tooltip.roman": "R\xedmske listy",
      "tooltip.copy to clipboard": "Skop\xEDrova\u0165 do schr\xE1nky",
      "tooltip.redo": "Znova",
      "tooltip.toggle virtual keyboard": "Prepn\xFA\u0165 virtu\xE1lnu kl\xE1vesnicu",
      "tooltip.undo": "Vr\xE1tenie sp\xE4\u0165",
      "menu.insert matrix": "Vlo\u017Ete maticu",
      "menu.insert vector": "Vlo\u017Ete vektor",
      "submenu.array.matrix delimiters": "Odde\u013Eova\u010De mat\xEDc",
      "menu.array.add row above": "Pridajte riadok za",
      "menu.array.add row below": "Pridajte riadok pred",
      "menu.array.add column after": "Prida\u0165 st\u013Apec za",
      "menu.array.add column before": "Pridajte st\u013Apec predt\xFDm",
      "menu.array.delete row": "Odstr\xE1ni\u0165 riadok",
      "menu.array.delete rows": "Odstr\xE1ni\u0165 vybrat\xE9 riadky",
      "menu.array.delete column": "Odstr\xE1ni\u0165 st\u013Apec",
      "menu.array.delete columns": "Odstr\xE1ni\u0165 vybrat\xE9 st\u013Apce",
      "submenu.array.insert separator": "Vlo\u017Ete odde\u013Eova\u010D",
      "menu.insert table": "Vlo\u017Ete tabu\u013Eku",
      "submenu.table style": "\u0160t\xFDl tabu\u013Eky"
    },
    sl: {
      "keyboard.tooltip.functions": "Funkcije",
      "keyboard.tooltip.symbols": "Simboli",
      "keyboard.tooltip.greek": "Gr\u0161ka pisma",
      "keyboard.tooltip.command": "Ukazni na\u010Din LaTeX",
      "keyboard.tooltip.numeric": "\u0160tevilsko",
      "keyboard.tooltip.roman": "Rimska pisma",
      "tooltip.copy to clipboard": "Kopirati v odlo\u017Ei\u0161\u010De",
      "tooltip.redo": "Ponovi",
      "tooltip.toggle virtual keyboard": "Preklop navidezne tipkovnice",
      "tooltip.undo": "Razveljavi",
      "menu.insert matrix": "Vstavi matrico",
      "menu.insert vector": "Vstavi vektor",
      "submenu.array.matrix delimiters": "Matri\u010Dni lo\u010Devalniki",
      "menu.array.add row above": "Dodaj vrstico po",
      "menu.array.add row below": "Dodaj vrstico prej",
      "menu.array.add column after": "Dodaj stolpec po",
      "menu.array.add column before": "Dodaj stolpec prej",
      "menu.array.delete row": "Izbri\u0161i vrstico",
      "menu.array.delete rows": "Izbri\u0161i izbrane vrstice",
      "menu.array.delete column": "Izbri\u0161i stolpec",
      "menu.array.delete columns": "Izbri\u0161i izbrane stolpce",
      "submenu.array.insert separator": "Vstavi lo\u010Dilo",
      "menu.insert table": "Vstavi tabelo",
      "submenu.table style": "Tabela slog"
    },
    sq: {
      "keyboard.tooltip.functions": "Funksione",
      "keyboard.tooltip.symbols": "Simbolet",
      "keyboard.tooltip.greek": "Letrat Greke",
      "keyboard.tooltip.command": "Modaliteti i komand\xebs latex",
      "keyboard.tooltip.numeric": "Numerike",
      "keyboard.tooltip.roman": "Letrat romake",
      "tooltip.copy to clipboard": "Kopjoni n\xeb Clipboard",
      "tooltip.redo": "Riparo",
      "tooltip.toggle virtual keyboard": "Aktivizo tastier\xebn virtuale",
      "tooltip.undo": "Zhb\xebj",
      "menu.insert matrix": "Vendosni Matric\xebn",
      "menu.insert vector": "Vendos vektorin",
      "submenu.array.matrix delimiters": "P\xebrcaktuesit e matric\xebs",
      "menu.array.add row above": "Shto Rreshtin Pas",
      "menu.array.add row below": "Shto Rreshtin Para",
      "menu.array.add column after": "Shto kolon\xebn pas",
      "menu.array.add column before": "Shto kolon\xebn para",
      "menu.array.delete row": "Fshi Rreshtin",
      "menu.array.delete rows": "Fshi rreshtat e zgjedhur",
      "menu.array.delete column": "Fshi kolon\xebn",
      "menu.array.delete columns": "Fshi kolonat e zgjedhura",
      "submenu.array.insert separator": "Vendos Ndar\xebsin",
      "menu.insert table": "Vendos tabel\xebn",
      "submenu.table style": "Stili tabel\xebn"
    },
    sr: {
      "keyboard.tooltip.functions": "\u0424\u0443\u043D\u043A\u0446\u0438\u0458\u0435",
      "keyboard.tooltip.symbols": "\u0421\u0438\u043C\u0431\u043E\u043B\u0438",
      "keyboard.tooltip.greek": "\u0413\u0440\u0435\u0435\u043A \u041B\u0435\u0442\u0442\u0435\u0440\u0441",
      "keyboard.tooltip.command": "\u041B\u0430\u0422\u0435\u041A\u0441 \u043A\u043E\u043C\u0430\u043D\u0434\u043D\u0438 \u0440\u0435\u0436\u0438\u043C",
      "keyboard.tooltip.numeric": "\u041D\u0443\u043C\u0435\u0440\u0438\u0447\u043A\u0438",
      "keyboard.tooltip.roman": "\u0420\u0438\u043C\u0441\u043A\u0430 \u043F\u0438\u0441\u043C\u0430",
      "tooltip.copy to clipboard": "\u041A\u043E\u043F\u0438\u0440\u0430\u0458\u0442\u0435 \u0443 \u043C\u0435\u0452\u0443\u0441\u043F\u0440\u0435\u043C\u043D\u0438\u043A",
      "tooltip.redo": "\u041F\u043E\u043D\u043E\u0432\u0438",
      "tooltip.toggle virtual keyboard": "\u0423\u043A\u0459\u0443\u0447\u0438 / \u0438\u0441\u043A\u0459\u0443\u0447\u0438 \u0432\u0438\u0440\u0442\u0443\u0435\u043B\u043D\u0443 \u0442\u0430\u0441\u0442\u0430\u0442\u0443\u0440\u0443",
      "tooltip.undo": "\u041E\u043F\u043E\u0437\u043E\u0432\u0438",
      "menu.insert matrix": "\u0423\u043C\u0435\u0442\u043D\u0438 \u043C\u0430\u0442\u0440\u0438\u0446\u0443",
      "menu.insert vector": "\u0423\u043C\u0435\u0442\u043D\u0438 \u0432\u0435\u043A\u0442\u043E\u0440",
      "submenu.array.matrix delimiters": "\u041C\u0430\u0442\u0440\u0438\u043A \u0414\u0435\u043B\u0438\u043C\u0438\u0442\u0435\u0440\u0441",
      "menu.array.add row above": "\u0414\u043E\u0434\u0430\u0458 \u0440\u0435\u0434 \u043F\u043E\u0441\u043B\u0435",
      "menu.array.add row below": "\u0414\u043E\u0434\u0430\u0458 \u0440\u0435\u0434 \u043F\u0440\u0435",
      "menu.array.add column after": "\u0414\u043E\u0434\u0430\u0458 \u043A\u043E\u043B\u043E\u043D\u0443 \u043F\u043E\u0441\u043B\u0435",
      "menu.array.add column before": "\u0414\u043E\u0434\u0430\u0458 \u043A\u043E\u043B\u043E\u043D\u0443 \u043F\u0440\u0435",
      "menu.array.delete row": "\u0418\u0437\u0431\u0440\u0438\u0448\u0438 \u0440\u0435\u0434",
      "menu.array.delete rows": "\u0418\u0437\u0431\u0440\u0438\u0448\u0438 \u0438\u0437\u0430\u0431\u0440\u0430\u043D\u0435 \u0440\u0435\u0434\u043E\u0432\u0435",
      "menu.array.delete column": "\u0418\u0437\u0431\u0440\u0438\u0448\u0438 \u043A\u043E\u043B\u043E\u043D\u0443",
      "menu.array.delete columns": "\u0418\u0437\u0431\u0440\u0438\u0448\u0438 \u0438\u0437\u0430\u0431\u0440\u0430\u043D\u0435 \u043A\u043E\u043B\u043E\u043D\u0435",
      "submenu.array.insert separator": "\u0423\u043C\u0435\u0442\u043D\u0438 \u0441\u0435\u043F\u0430\u0440\u0430\u0442\u043E\u0440",
      "menu.insert table": "\u0423\u0431\u0430\u0446\u0438 \u0442\u0430\u0431\u0435\u043B\u0443",
      "submenu.table style": "\u0422\u0430\u0431\u0435\u043B\u0430\u0440\u043D\u0438 \u0441\u0442\u0438\u043B"
    },
    sv: {
      "keyboard.tooltip.functions": "Funktioner",
      "keyboard.tooltip.symbols": "Symboler",
      "keyboard.tooltip.greek": "Grekiska bokst\xe4ver",
      "keyboard.tooltip.command": "LaTeX kommandol\xe4ge",
      "keyboard.tooltip.numeric": "Numerisk",
      "keyboard.tooltip.roman": "Romerska bokst\xe4ver",
      "tooltip.copy to clipboard": "Kopiera till Urklipp",
      "tooltip.redo": "G\xf6ra om",
      "tooltip.toggle virtual keyboard": "V\xe4xla virtuellt tangentbord",
      "tooltip.undo": "\xc5ngra",
      "menu.insert matrix": "S\xe4tt in matris",
      "menu.insert vector": "Infoga vektor",
      "submenu.array.matrix delimiters": "Matrisavgr\xe4nsare",
      "menu.array.add row above": "L\xe4gg till rad efter",
      "menu.array.add row below": "L\xe4gg till rad f\xf6re",
      "menu.array.add column after": "L\xe4gg till kolumn efter",
      "menu.array.add column before": "L\xe4gg till kolumn f\xf6re",
      "menu.array.delete row": "Radera rad",
      "menu.array.delete rows": "Ta bort valda rader",
      "menu.array.delete column": "Ta bort kolumn",
      "menu.array.delete columns": "Ta bort valda kolumner",
      "submenu.array.insert separator": "S\xe4tt i separator",
      "menu.insert table": "Infoga tabell",
      "submenu.table style": "Tabellstil"
    },
    th: {
      "keyboard.tooltip.functions": "\u0E1F\u0E31\u0E07\u0E01\u0E4C\u0E0A\u0E31\u0E48\u0E19",
      "keyboard.tooltip.symbols": "\u0E2A\u0E31\u0E0D\u0E25\u0E31\u0E01\u0E29\u0E13\u0E4C",
      "keyboard.tooltip.greek": "\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E01\u0E23\u0E35\u0E01",
      "keyboard.tooltip.command": "\u0E42\u0E2B\u0E21\u0E14\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07 \u0E19\u0E49\u0E33\u0E22\u0E32\u0E07",
      "keyboard.tooltip.numeric": "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02",
      "keyboard.tooltip.roman": "\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E42\u0E23\u0E21\u0E31\u0E19",
      "tooltip.copy to clipboard": "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E04\u0E25\u0E34\u0E1B\u0E1A\u0E2D\u0E23\u0E4C\u0E14",
      "tooltip.redo": "\u0E17\u0E33\u0E0B\u0E49\u0E33",
      "tooltip.toggle virtual keyboard": "\u0E2A\u0E25\u0E31\u0E1A\u0E41\u0E1B\u0E49\u0E19\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E40\u0E2A\u0E21\u0E37\u0E2D\u0E19",
      "tooltip.undo": "\u0E40\u0E25\u0E34\u0E01\u0E17\u0E33",
      "menu.insert matrix": "\u0E41\u0E17\u0E23\u0E01\u0E40\u0E21\u0E17\u0E23\u0E34\u0E01\u0E0B\u0E4C",
      "menu.insert vector": "\u0E41\u0E17\u0E23\u0E01\u0E40\u0E27\u0E01\u0E40\u0E15\u0E2D\u0E23\u0E4C",
      "submenu.array.matrix delimiters": "\u0E15\u0E31\u0E27\u0E04\u0E31\u0E48\u0E19\u0E40\u0E21\u0E17\u0E23\u0E34\u0E01\u0E0B\u0E4C",
      "menu.array.add row above": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E16\u0E27\u0E2B\u0E25\u0E31\u0E07",
      "menu.array.add row below": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E16\u0E27\u0E01\u0E48\u0E2D\u0E19",
      "menu.array.add column after": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E2D\u0E25\u0E31\u0E21\u0E19\u0E4C\u0E2B\u0E25\u0E31\u0E07",
      "menu.array.add column before": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E2D\u0E25\u0E31\u0E21\u0E19\u0E4C\u0E01\u0E48\u0E2D\u0E19",
      "menu.array.delete row": "\u0E25\u0E1A\u0E41\u0E16\u0E27",
      "menu.array.delete rows": "\u0E25\u0E1A\u0E41\u0E16\u0E27\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01",
      "menu.array.delete column": "\u0E25\u0E1A\u0E04\u0E2D\u0E25\u0E31\u0E21\u0E19\u0E4C",
      "menu.array.delete columns": "\u0E25\u0E1A\u0E04\u0E2D\u0E25\u0E31\u0E21\u0E19\u0E4C\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01",
      "submenu.array.insert separator": "\u0E15\u0E31\u0E27\u0E04\u0E31\u0E48\u0E19\u0E41\u0E17\u0E23\u0E01",
      "menu.insert table": "\u0E41\u0E17\u0E23\u0E01\u0E15\u0E32\u0E23\u0E32\u0E07",
      "submenu.table style": "\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E15\u0E32\u0E23\u0E32\u0E07"
    },
    tr: {
      "keyboard.tooltip.functions": "Fonksiyonlar",
      "keyboard.tooltip.symbols": "Semboller",
      "keyboard.tooltip.greek": "Yunan harfleri",
      "keyboard.tooltip.command": "LaTeX Komut Modu",
      "keyboard.tooltip.numeric": "Say\u0131sal",
      "keyboard.tooltip.roman": "Roma Harfleri",
      "tooltip.copy to clipboard": "Panoya kopyala",
      "tooltip.redo": "Yeniden yap",
      "tooltip.toggle virtual keyboard": "Sanal Klavyeyi A\xe7/Kapat",
      "tooltip.undo": "Geri alma",
      "menu.insert matrix": "Matris Ekle",
      "menu.insert vector": "Vekt\xf6r Ekle",
      "submenu.array.matrix delimiters": "Matris S\u0131n\u0131rlay\u0131c\u0131lar",
      "menu.array.add row above": "Sat\u0131rdan Sonra Ekle",
      "menu.array.add row below": "\xD6nce Sat\u0131r Ekle",
      "menu.array.add column after": "Sonra S\xfctun Ekle",
      "menu.array.add column before": "\xd6nce S\xfctun Ekle",
      "menu.array.delete row": "S\u0131ray\u0131 sil",
      "menu.array.delete rows": "Se\xE7ili Sat\u0131rlar\u0131 Sil",
      "menu.array.delete column": "S\xfctunu Sil",
      "menu.array.delete columns": "Se\xE7ili S\xFCtunlar\u0131 Sil",
      "submenu.array.insert separator": "Ay\u0131r\u0131c\u0131 Ekle",
      "menu.insert table": "Tablo Ekle",
      "submenu.table style": "Tablo Stili"
    },
    uk: {
      "keyboard.tooltip.functions": "\u0424\u0443\u043D\u043A\u0446\u0456\u0457",
      "keyboard.tooltip.symbols": "\u0421\u0438\u043C\u0432\u043E\u043B\u0438",
      "keyboard.tooltip.greek": "\u0413\u0440\u0435\u0446\u044C\u043A\u0456 \u043B\u0456\u0442\u0435\u0440\u0438",
      "keyboard.tooltip.command": "\u041A\u043E\u043C\u0430\u043D\u0434\u043D\u0438\u0439 \u0440\u0435\u0436\u0438\u043C \u043B\u0430\u0442\u0435\u043A\u0441\u0443",
      "keyboard.tooltip.numeric": "\u0427\u0438\u0441\u043B\u043E\u0432\u0438\u0439",
      "keyboard.tooltip.roman": "\u0420\u0438\u043C\u0441\u044C\u043A\u0456 \u043B\u0456\u0442\u0435\u0440\u0438",
      "tooltip.copy to clipboard": "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0456\u043D\u0443",
      "tooltip.redo": "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
      "tooltip.toggle virtual keyboard": "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u0438 \u0432\u0456\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u0443 \u043A\u043B\u0430\u0432\u0456\u0430\u0442\u0443\u0440\u0443",
      "tooltip.undo": "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
      "menu.insert matrix": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043C\u0430\u0442\u0440\u0438\u0446\u044E",
      "menu.insert vector": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0432\u0435\u043A\u0442\u043E\u0440",
      "submenu.array.matrix delimiters": "\u041C\u0430\u0442\u0440\u0438\u0447\u043D\u0456 \u0440\u043E\u0437\u0434\u0456\u043B\u044C\u043D\u0438\u043A\u0438",
      "menu.array.add row above": "\u0414\u043E\u0434\u0430\u0442\u0438 \u0440\u044F\u0434\u043E\u043A \u043F\u0456\u0441\u043B\u044F",
      "menu.array.add row below": "\u0414\u043E\u0434\u0430\u0442\u0438 \u0440\u044F\u0434\u043E\u043A \u0434\u043E",
      "menu.array.add column after": "\u0414\u043E\u0434\u0430\u0442\u0438 \u0441\u0442\u043E\u0432\u043F\u0435\u0446\u044C \u043F\u0456\u0441\u043B\u044F",
      "menu.array.add column before": "\u0414\u043E\u0434\u0430\u0442\u0438 \u0441\u0442\u043E\u0432\u043F\u0435\u0446\u044C \u043F\u0435\u0440\u0435\u0434",
      "menu.array.delete row": "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0440\u044F\u0434\u043E\u043A",
      "menu.array.delete rows": "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0440\u044F\u0434\u043A\u0438",
      "menu.array.delete column": "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0441\u0442\u043E\u0432\u043F\u0435\u0446\u044C",
      "menu.array.delete columns": "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0441\u0442\u043E\u0432\u043F\u0446\u0456",
      "submenu.array.insert separator": "\u0412\u0441\u0442\u0430\u0432\u0442\u0435 \u0440\u043E\u0437\u0434\u0456\u043B\u044C\u043D\u0438\u043A",
      "menu.insert table": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0442\u0430\u0431\u043B\u0438\u0446\u044E",
      "submenu.table style": "\u0421\u0442\u0438\u043B\u044C \u0442\u0430\u0431\u043B\u0438\u0446\u0456"
    },
    vi: {
      "keyboard.tooltip.functions": "Ch\u1EE9c n\u0103ng",
      "keyboard.tooltip.symbols": "K\xFD hi\u1EC7u",
      "keyboard.tooltip.greek": "Ch\u1EEF Hy L\u1EA1p",
      "keyboard.tooltip.command": "Ch\u1EBF \u0111\u1ED9 l\u1EC7nh LaTeX",
      "keyboard.tooltip.numeric": "S\u1ED1",
      "keyboard.tooltip.roman": "Ch\u1EEF c\xE1i La m\xE3",
      "tooltip.copy to clipboard": "Sao ch\xe9p v\xe0o clipboard",
      "tooltip.redo": "L\xE0m l\u1EA1i",
      "tooltip.toggle virtual keyboard": "Chuy\u1EC3n \u0111\u1ED5i b\xE0n ph\xEDm \u1EA3o",
      "tooltip.undo": "Ho\xe0n t\xe1c",
      "menu.insert matrix": "Ch\xE8n ma tr\u1EADn",
      "menu.insert vector": "Insert Vector",
      "submenu.array.matrix delimiters": "D\u1EA5u ph\xE2n c\xE1ch ma tr\u1EADn",
      "menu.array.add row above": "Th\xeam h\xe0ng sau",
      "menu.array.add row below": "Th\xEAm h\xE0ng tr\u01B0\u1EDBc",
      "menu.array.add column after": "Th\xEAm c\u1ED9t sau",
      "menu.array.add column before": "Th\xEAm c\u1ED9t tr\u01B0\u1EDBc",
      "menu.array.delete row": "X\xf3a h\xe0ng",
      "menu.array.delete rows": "X\xF3a h\xE0ng \u0111\xE3 ch\u1ECDn",
      "menu.array.delete column": "X\xF3a c\u1ED9t",
      "menu.array.delete columns": "X\xF3a c\xE1c c\u1ED9t \u0111\xE3 ch\u1ECDn",
      "submenu.array.insert separator": "Ch\xE8n d\u1EA5u ph\xE2n c\xE1ch",
      "menu.insert table": "Ch\xE8n b\u1EA3ng",
      "submenu.table style": "Ki\u1EC3u b\u1EA3ng"
    },
    zh_cn: {
      "keyboard.tooltip.functions": "\u804C\u80FD",
      "keyboard.tooltip.symbols": "\u7B26\u53F7",
      "keyboard.tooltip.greek": "\u5E0C\u814A\u5B57\u6BCD",
      "keyboard.tooltip.command": "\u4E73\u80F6 \u547D\u4EE4\u6A21\u5F0F",
      "keyboard.tooltip.numeric": "\u6570\u5B57",
      "keyboard.tooltip.roman": "\u7F57\u9A6C\u5B57\u6BCD",
      "tooltip.copy to clipboard": "\u590D\u5236\u5230\u526A\u8D34\u677F",
      "tooltip.redo": "\u91CD\u505A",
      "tooltip.toggle virtual keyboard": "\u5207\u6362\u865A\u62DF\u952E\u76D8",
      "tooltip.undo": "\u64A4\u6D88",
      "menu.insert matrix": "\u63D2\u5165\u77E9\u9635",
      "menu.insert vector": "\u63D2\u5165\u5411\u91CF",
      "submenu.array.matrix delimiters": "\u77E9\u9635\u5206\u9694\u7B26",
      "menu.array.add row above": "\u5728\u540E\u9762\u6DFB\u52A0\u884C",
      "menu.array.add row below": "\u5728\u524D\u9762\u6DFB\u52A0\u884C",
      "menu.array.add column after": "\u5728\u540E\u9762\u6DFB\u52A0\u5217r",
      "menu.array.add column before": "\u5728\u524D\u9762\u6DFB\u52A0\u5217",
      "menu.array.delete row": "\u5220\u9664\u884C",
      "menu.array.delete rows": "\u5220\u9664\u9009\u5B9A\u884C",
      "menu.array.delete column": "\u5220\u9664\u5217",
      "menu.array.delete columns": "\u5220\u9664\u9009\u5B9A\u7684\u5217",
      "submenu.array.insert separator": "\u63D2\u5165\u5206\u9694\u7B26",
      "menu.insert table": "\u63D2\u5165\u8868\u683C",
      "submenu.table style": "\u8868\u683C\u6837\u5F0F"
    },
    zh_tw: {
      "keyboard.tooltip.functions": "\u8077\u80FD",
      "keyboard.tooltip.symbols": "\u7B26\u865F",
      "keyboard.tooltip.greek": "\u5E0C\u81D8\u5B57\u6BCD",
      "keyboard.tooltip.command": "\u4E73\u81A0\u547D\u4EE4\u6A21\u5F0F",
      "keyboard.tooltip.numeric": "\u6578\u5B57",
      "keyboard.tooltip.roman": "\u7F85\u99AC\u5B57\u6BCD",
      "tooltip.copy to clipboard": "\u8907\u88FD\u5230\u526A\u8CBC\u677F",
      "tooltip.redo": "\u91CD\u505A",
      "tooltip.toggle virtual keyboard": "\u5207\u63DB\u865B\u64EC\u9375\u76E4",
      "tooltip.undo": "\u64A4\u6D88",
      "menu.insert matrix": "\u63D2\u5165\u77E9\u9663",
      "menu.insert vector": "\u63D2\u5165\u5411\u91CF",
      "submenu.array.matrix delimiters": "\u77E9\u9663\u5206\u9694\u7B26",
      "menu.array.add row above": "\u5728\u5F8C\u9762\u6DFB\u52A0\u884C",
      "menu.array.add row below": "\u5728\u524D\u9762\u6DFB\u52A0\u884C",
      "menu.array.add column after": "\u5728\u5F8C\u9762\u6DFB\u52A0\u5217",
      "menu.array.add column before": "\u5728\u524D\u9762\u6DFB\u52A0\u5217",
      "menu.array.delete row": "\u522A\u9664\u884C",
      "menu.array.delete rows": "\u522A\u9664\u9078\u5B9A\u884C",
      "menu.array.delete column": "\u522A\u9664\u5217",
      "menu.array.delete columns": "\u522A\u9664\u9078\u5B9A\u7684\u5217",
      "submenu.array.insert separator": "\u63D2\u5165\u5206\u9694\u7B26",
      "menu.insert table": "\u63D2\u5165\u8868\u683C",
      "submenu.table style": "\u8868\u683C\u6A23\u5F0F"
    }
  },
  _locale: "en",
  get locale() {
    var e;
    return fr._locale || (fr._locale = null !== (e = ke() ? navigator.language.slice(0, 5) : null) && void 0 !== e ? e : "en"), fr._locale;
  },
  set locale(e) {
    fr._locale = e;
  },
  merge: function merge(e, t) {
    if (e && t) {
      var _i83 = fr._locale;
      fr.locale = e, fr.strings[e] = _objectSpread(_objectSpread({}, fr.strings[e]), t), fr.locale = _i83;
    } else if (e && !t) for (var _i84 = 0, _Object$keys5 = Object.keys(e); _i84 < _Object$keys5.length; _i84++) {
      var _t94 = _Object$keys5[_i84];
      fr.merge(_t94, e[_t94]);
    }
  }
};
function gr(e) {
  if (void 0 === e) return;
  var t = fr.locale.slice(0, 2);
  var i = "";
  return fr.strings[fr.locale] && (i = fr.strings[fr.locale][e]), !i && fr.strings[t] && (i = fr.strings[t][e]), i || (i = fr.strings.en[e]), i || void 0;
}
function yr(e, t, i, r) {
  var n = t.split(" ");
  var _iterator60 = _createForOfIteratorHelper(n),
    _step60;
  try {
    for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
      var _t95 = _step60.value;
      var _n23 = _t95.match(/(.*):(.*)/);
      if (_n23) {
        var _t96 = null != r ? r : {};
        "active" === _n23[2] ? _t96.passive = !1 : _t96[_n23[2]] = !0, e.addEventListener(_n23[1], i, _t96);
      } else e.addEventListener(_t95, i, r);
    }
  } catch (err) {
    _iterator60.e(err);
  } finally {
    _iterator60.f();
  }
}
function br(e, t, i, r) {
  var n = t.split(" ");
  var _iterator61 = _createForOfIteratorHelper(n),
    _step61;
  try {
    for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
      var _t97 = _step61.value;
      var _n24 = _t97.match(/(.*):(.*)/);
      if (_n24) {
        var _t98 = null != r ? r : {};
        "active" === _n24[2] ? _t98.passive = !1 : _t98[_n24[2]] = !0, e.removeEventListener(_n24[1], i, _t98);
      } else e.removeEventListener(_t97, i, r);
    }
  } catch (err) {
    _iterator61.e(err);
  } finally {
    _iterator61.f();
  }
}
function vr(e) {
  var t;
  we();
  var i = document.getElementById(e);
  return i ? i.dataset.refcount = Number(Number.parseInt(null !== (t = i.getAttribute("data-refcount")) && void 0 !== t ? t : "0") + 1).toString() : (i = document.createElement("div"), i.setAttribute("aria-hidden", "true"), i.dataset.refcount = "1", i.id = e, document.body.append(i)), i;
}
function xr(e) {
  var t;
  if (!e) return;
  var i = Number.parseInt(null !== (t = e.getAttribute("data-refcount")) && void 0 !== t ? t : "0");
  i <= 1 ? e.remove() : e.dataset.refcount = Number(i - 1).toString();
}
function kr(e) {
  return void 0 !== e.element && e.element.mathfield === e;
}
function wr(e) {
  var t = function (e) {
    var t, i;
    return null !== (i = null !== (t = e.querySelector(".ML__caret")) && void 0 !== t ? t : e.querySelector(".ML__text-caret")) && void 0 !== i ? i : e.querySelector(".ML__latex-caret");
  }(e);
  if (!t) return null;
  var i = t.getBoundingClientRect();
  return {
    x: i.right,
    y: i.bottom,
    height: i.height
  };
}
function _r(e) {
  var t;
  if (!e.parent) return "root";
  var i = null !== (t = e.parent.id) && void 0 !== t ? t : "";
  return i += "string" == typeof e.treeBranch ? "-" + e.treeBranch : "-".concat(e.treeBranch[0], "/").concat(e.treeBranch[0]), i;
}
function Mr(e, t) {
  if (!t) return null;
  var i = e.field.getBoundingClientRect(),
    r = t.right - t.left,
    n = t.bottom - t.top,
    a = Math.ceil(t.left - i.left + e.field.scrollLeft),
    o = Math.ceil(t.top - i.top);
  return {
    left: a,
    right: a + r,
    top: o,
    bottom: o + n
  };
}
function Sr(e) {
  var t = e.getBoundingClientRect(),
    i = parseInt(getComputedStyle(e).marginRight),
    r = {
      top: t.top - 1,
      bottom: t.bottom,
      left: t.left,
      right: t.right - 1 + i
    };
  if (e.children.length > 0 && "SVG" !== e.tagName.toUpperCase()) {
    var _iterator62 = _createForOfIteratorHelper(e.children),
      _step62;
    try {
      for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
        var _t99 = _step62.value;
        if (1 === _t99.nodeType && "atom-id" in _t99.dataset && !_t99.classList.contains("pstrut")) {
          var _e117 = Sr(_t99);
          r.left = Math.min(r.left, _e117.left), r.right = Math.max(r.right, _e117.right), r.top = Math.min(r.top, _e117.top), r.bottom = Math.max(r.bottom, _e117.bottom);
        }
      }
    } catch (err) {
      _iterator62.e(err);
    } finally {
      _iterator62.f();
    }
  }
  return r;
}
function Lr(e, t) {
  var i, r;
  if (!t.id) return null;
  var n = null !== (r = null === (i = e._atomBoundsCache) || void 0 === i ? void 0 : i.get(t.id)) && void 0 !== r ? r : null;
  if (null !== n) return n;
  var a = e.field.querySelector("[data-atom-id=\"".concat(t.id, "\"]"));
  return n = a ? Sr(a) : null, e._atomBoundsCache && (n ? e._atomBoundsCache.set(t.id, n) : e._atomBoundsCache.delete(t.id)), null != n ? n : null;
}
function Cr(e, t) {
  return e.model.selection.ranges.reduce(function (i, r) {
    return i.concat.apply(i, _toConsumableArray(function (e, t, i) {
      var r = new Map();
      var _iterator63 = _createForOfIteratorHelper(e.model.getAtoms(t, {
          includeChildren: !0
        })),
        _step63;
      try {
        for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
          var _n25 = _step63.value;
          if ((null == i ? void 0 : i.excludeAtomsWithBackground) && _n25.style.backgroundColor) break;
          var _t100 = Mr(e, Lr(e, _n25));
          if (_t100) {
            var _e118 = _r(_n25);
            if (r.has(_e118)) {
              var _i85 = r.get(_e118);
              r.set(_e118, {
                left: Math.min(_i85.left, _t100.left),
                right: Math.max(_i85.right, _t100.right),
                top: Math.min(_i85.top, _t100.top),
                bottom: Math.max(_i85.bottom, _t100.bottom)
              });
            } else r.set(_e118, _t100);
          }
        }
      } catch (err) {
        _iterator63.e(err);
      } finally {
        _iterator63.f();
      }
      return _toConsumableArray(r.values());
    }(e, r, t)));
  }, []);
}
function Ar(e, t) {
  return "none" === t || ("same-origin" === t ? e === window.origin : "function" == typeof t && t(e));
}
function Nr(e, t, i) {
  var r, n, a, o, s;
  "object" == typeof i && ("default" in i || "pressed" in i) ? (i.default && (t.dataset.command = JSON.stringify(i.default)), i.alt && (t.dataset.commandAlt = JSON.stringify(i.alt)), i.altshift && (t.dataset.commandAltshift = JSON.stringify(i.altshift)), i.shift && (t.dataset.commandShift = JSON.stringify(i.shift)), i.pressed && (t.dataset.commandPressed = JSON.stringify(i.pressed)), i.pressAndHoldStart && (t.dataset.commandPressAndHoldStart = JSON.stringify(i.pressAndHoldStart)), i.pressAndHoldEnd && (t.dataset.commandPressAndHoldEnd = JSON.stringify(i.pressAndHoldEnd))) : t.dataset.command = JSON.stringify(i), yr(t, "mousedown touchstart:passive", function (i) {
    if ("mousedown" !== i.type || 1 === i.buttons) {
      i.stopPropagation(), "touchstart" !== i.type && i.preventDefault(), document.body.style["-webkit-user-select"] = "none", t.classList.add("is-pressed"), r = Date.now(), "touchstart" === i.type && (a = i.changedTouches[0].identifier);
      var _o15 = t.getAttribute("data-command-pressed");
      _o15 && e(JSON.parse(_o15));
      var _l6 = t.getAttribute("data-command-press-and-hold-start");
      _l6 && (n = t, s && clearTimeout(s), s = setTimeout(function () {
        t.classList.contains("is-pressed") && e(JSON.parse(_l6));
      }, 300));
    }
  }), yr(t, "mouseleave touchcancel", function () {
    t.classList.remove("is-pressed");
  }), yr(t, "touchmove:passive", function (e) {
    for (var _t101 = 0; _t101 < e.changedTouches.length; _t101++) if (e.changedTouches[_t101].identifier === a) {
      var _i86 = document.elementFromPoint(e.changedTouches[_t101].clientX, e.changedTouches[_t101].clientY);
      _i86 !== o && o && (o.dispatchEvent(new MouseEvent("mouseleave"), {
        bubbles: !0
      }), o = null), _i86 && (o = _i86, _i86.dispatchEvent(new MouseEvent("mouseenter", {
        bubbles: !0,
        buttons: 1
      })));
    }
  }), yr(t, "mouseenter", function (e) {
    1 === e.buttons && t.classList.add("is-pressed");
  }), yr(t, "mouseup touchend click", function (i) {
    if (document.body.style["-webkit-user-select"] = "", o) {
      i.stopPropagation(), i.preventDefault();
      var _e119 = o;
      return o = null, void _e119.dispatchEvent(new MouseEvent("mouseup", {
        bubbles: !0
      }));
    }
    if (t.classList.remove("is-pressed"), t.classList.add("is-active"), "click" === i.type && 0 !== i.detail) return i.stopPropagation(), void i.preventDefault();
    window.setTimeout(function () {
      t.classList.remove("is-active");
    }, 150);
    var a = t.getAttribute("data-command-press-and-hold-end");
    var s = Date.now();
    (t !== n || s < r + 300) && (a = null), !a && i.altKey && i.shiftKey && (a = t.getAttribute("data-command-altshift")), !a && i.altKey && (a = t.getAttribute("data-command-alt")), !a && i.shiftKey && (a = t.getAttribute("data-command-shift")), a || (a = t.getAttribute("data-command")), a && e(JSON.parse(a)), i.stopPropagation(), i.preventDefault();
  });
}
var zr = '.ML__keyboard{--keyboard-background:rgba(209,213,217,.97);--keyboard-text:#000;--keyboard-text-active:var(--primary,hsl(var(--hue,212),40%,50%));--keyboard-background-border:#ddd;--keycap-background:#fff;--keycap-background-active:#e5e5e5;--keycap-background-border:#e5e6e9;--keycap-background-border-bottom:#8d8f92;--keycap-text:#000;--keycap-text-active:#fff;--keycap-secondary-text:#000;--keycap-modifier-background:#b9bdc7;--keycap-modifier-border:#c5c9d0;--keycap-modifier-border-bottom:#989da6;--keyboard-alternate-background:#fff;--keyboard-alternate-background-active:var(--primary,hsl(var(--hue,212),40%,50%));--keyboard-alternate-text:var(--keycap-text,#000);--keyboard-alternate-text-active:#fff;--keyboard-alternate-key-length:70px;--keyboard-alternate-key-font-size:30px;--keyboard-alternate-key-aside-font-size:12px;--keyboard-height:276px;--keycap-height:52px;--keycap-font-size:20px;--keycap-small-font-size:calc(var(--keycap-font-size)*0.8);--keycap-extra-small-font-size:calc(var(--keycap-font-size)/1.42);--keycap-tt-font-size:calc(var(--keycap-font-size)*1.5);height:100%;pointer-events:none;position:fixed;top:0;width:100%}.ML__keyboard.is-visible .ML__keyboard--plate{opacity:1;transform:translateY(calc(var(--keyboard-height, 276px)*-1));transition-timing-function:cubic-bezier(.4,0,1,1);visibility:visible}.ML__keyboard.alternate-keys{align-content:center;background-color:var(--keyboard-alternate-background);border-radius:6px;bottom:auto;box-shadow:0 14px 28px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.22);box-sizing:content-box;display:flex;flex-direction:row;justify-content:center;max-width:286px;position:fixed;text-align:center;top:0;transform:none;transition:none;visibility:hidden;z-index:calc(var(--keyboard-zindex, 105) + 1)}@media only screen and (max-height:412px){.ML__keyboard.alternate-keys{max-width:320px}}.ML__keyboard.alternate-keys.is-visible{visibility:visible}.ML__keyboard.alternate-keys.compact{--keyboard-alternate-key-length:50px;--keyboard-alternate-key-font-size:24px;--keyboard-alternate-key-aside-font-size:10px}.ML__keyboard.alternate-keys ul{display:flex;flex-flow:row wrap-reverse;justify-content:center;list-style:none;margin:3px;padding:0}.ML__keyboard.alternate-keys ul>li{fill:currentColor;align-items:center;background:transparent;border:1px solid transparent;border-radius:5px;box-sizing:border-box;color:var(--keyboard-alternate-text);display:flex;flex-flow:column;font-size:var(--keyboard-alternate-key-font-size);height:var(--keyboard-alternate-key-length);justify-content:center;margin:0;pointer-events:all;width:var(--keyboard-alternate-key-length)}@media only screen and (max-height:412px){.ML__keyboard.alternate-keys ul>li{font-size:24px;height:50px;width:50px}}.ML__keyboard.alternate-keys ul>li.is-active,.ML__keyboard.alternate-keys ul>li.is-pressed,.ML__keyboard.alternate-keys ul>li:hover{background:var(--keyboard-alternate-background-active);color:var(--keyboard-alternate-text-active)}.ML__keyboard.alternate-keys ul>li.small{font-size:var(--keycap-small-font-size,16px)}.ML__keyboard.alternate-keys ul>li.small-button{background:#fbfbfb;height:42px;margin:2px;width:42px}.ML__keyboard.alternate-keys ul>li.small-button:hover{background:var(--keyboard-alternate-background-active)}.ML__keyboard.alternate-keys ul>li.box>div,.ML__keyboard.alternate-keys ul>li.box>span{border:1px dashed rgba(0,0,0,.24)}.ML__keyboard.alternate-keys ul>li .warning{align-items:center;background:#cd0030;border-radius:5px;color:#fff;display:flex;justify-content:center;min-height:60px;min-width:60px;padding:5px}.ML__keyboard.alternate-keys ul>li .warning.is-active,.ML__keyboard.alternate-keys ul>li .warning.is-pressed,.ML__keyboard.alternate-keys ul>li .warning:hover{background:red}.ML__keyboard.alternate-keys ul>li .warning svg.svg-glyph{height:50px;width:50px}.ML__keyboard.alternate-keys ul>li aside{font-size:var(--keyboard-alternate-key-aside-font-size);line-height:12px;opacity:.78;padding-top:2px}.ML__keyboard .ML__keyboard--plate{-webkit-backdrop-filter:grayscale(50%);backdrop-filter:grayscale(50%);background-color:var(--keyboard-background);border:1px solid var(--keyboard-background-border);bottom:calc(var(--keyboard-height, 276px)*-1);box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);box-sizing:border-box;cursor:pointer;font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;font-size:16px;font-weight:400;left:0;margin:0;opacity:0;padding-top:5px;position:absolute;text-shadow:none;touch-action:none;transform:translate(0);transition:.28s cubic-bezier(0,0,.2,1);transition-property:transform,opacity;-webkit-user-select:none;user-select:none;visibility:hidden;width:100%;z-index:var(--keyboard-zindex,105)}.ML__keyboard .ML__keyboard--plate .tex{font-family:KaTeX_Math,KaTeX_Main,Cambria Math,Asana Math,OpenSymbol,Symbola,STIX,Times,serif!important}.ML__keyboard .ML__keyboard--plate .tex-math{font-family:KaTeX_Math,Cambria Math,Asana Math,OpenSymbol,Symbola,STIX,Times,serif!important}.ML__keyboard .ML__keyboard--plate .tt{font-family:IBM Plex Mono,Source Code Pro,Consolas,Roboto Mono,Menlo,Bitstream Vera Sans Mono,DejaVu Sans Mono,Monaco,Courier,monospace!important;font-size:var(--keycap-tt-font-size,30px);font-weight:400}.ML__keyboard .ML__keyboard--plate>div.keyboard-layer{display:none;outline:none}.ML__keyboard .ML__keyboard--plate>div.keyboard-layer.is-visible{display:flex;flex-flow:column}.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar{align-self:center;display:flex;flex-flow:row;justify-content:space-between;width:736px}@media only screen and (min-width:768px) and (max-width:1024px){.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar{width:556px}}@media only screen and (max-width:767px){.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar{max-width:100vw;width:365px}}.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar svg{height:20px;width:20px}@media only screen and (max-width:767px){.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar svg{height:13px;width:17px}}.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar>.left{display:flex;flex-flow:row;justify-content:flex-start;position:relative}.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar>.right{display:flex;flex-flow:row;justify-content:flex-end}.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar>div>div{fill:currentColor;align-items:baseline;background:0;border:none;border-bottom:2px solid transparent;box-shadow:none;color:var(--keyboard-text);cursor:pointer;display:flex;font-size:110%;justify-content:center;margin:7px 4px 6px;min-height:0;padding:4px 10px;pointer-events:all}.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar>div>div.disabled.is-pressed svg,.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar>div>div.disabled:hover svg,.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar>div>div.disabled svg{color:var(--keyboard-text);opacity:.2}@media only screen and (max-width:414px){.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar>div>div{font-size:100%;padding:0 6px 0 0}}@media only screen and (max-width:767px){.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar>div>div{font-size:90%;padding-left:4px;padding-right:4px}}.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar>div>div.is-active,.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar>div>div.is-pressed,.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar>div>div:active,.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar>div>div:hover{color:var(--keyboard-text-active)}.ML__keyboard .ML__keyboard--plate>div>div.keyboard-toolbar>div>div.selected{border-bottom:2px solid var(--keyboard-text-active);color:var(--keyboard-text-active);margin-bottom:8px;padding-bottom:0}.ML__keyboard .ML__keyboard--plate div .rows{align-items:center;border:0;border-collapse:separate;clear:both;display:flex;flex-flow:column;margin:auto}.ML__keyboard .ML__keyboard--plate div .rows>ul{height:40px;list-style:none;margin:0 0 3px;padding:0}.ML__keyboard .ML__keyboard--plate div .rows>ul>li{fill:currentColor;-webkit-tap-highlight-color:transparent;align-items:center;background:var(--keycap-background);border:1px solid var(--keycap-background-border);border-bottom-color:var(--keycap-background-border-bottom);border-radius:5px;box-sizing:border-box;color:var(--keycap-text);display:flex;flex-flow:column;float:left;font-size:var(--keycap-font-size,20px);height:40px;justify-content:center;margin-right:2px;overflow:hidden;padding:8px 0;pointer-events:all;position:relative;text-align:center;-webkit-user-select:none;user-select:none;vertical-align:top;width:34px}.ML__keyboard .ML__keyboard--plate div .rows>ul>li:last-child{margin-right:0}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.small{font-size:var(--keycap-small-font-size,16px)}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.tt{color:var(--keyboard-text-active)}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.bottom{justify-content:flex-end}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.left{align-items:flex-start;padding-left:4px}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.right{align-items:flex-end;padding-right:4px}.ML__keyboard .ML__keyboard--plate div .rows>ul>li svg.svg-glyph{height:20px;width:20px}.ML__keyboard .ML__keyboard--plate div .rows>ul>li .warning{align-items:center;background:#cd0030;border-radius:100%;color:#fff;display:flex;height:25px;justify-content:center;margin-bottom:-2px;min-height:25px;min-width:25px;padding:5px;width:25px}.ML__keyboard .ML__keyboard--plate div .rows>ul>li .warning svg.svg-glyph{height:16px;width:16px}@media only screen and (max-width:768px){.ML__keyboard .ML__keyboard--plate div .rows>ul>li .warning{height:16px;min-height:16px;min-width:16px;width:16px}.ML__keyboard .ML__keyboard--plate div .rows>ul>li .warning svg.svg-glyph{height:14px;width:14px}}.ML__keyboard .ML__keyboard--plate div .rows>ul>li>.w0{width:0}.ML__keyboard .ML__keyboard--plate div .rows>ul>li>.w5{width:16px}.ML__keyboard .ML__keyboard--plate div .rows>ul>li>.w15{width:52px}.ML__keyboard .ML__keyboard--plate div .rows>ul>li>.w20{width:70px}.ML__keyboard .ML__keyboard--plate div .rows>ul>li>.w50{width:178px}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.separator{background:transparent;border:none;pointer-events:none}@media only screen and (max-width:560px){.ML__keyboard .ML__keyboard--plate div .rows>ul>li.if-wide{display:none}}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.tex-math{font-size:25px}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.is-pressed,.ML__keyboard .ML__keyboard--plate div .rows>ul>li:hover{background:var(--keycap-background-active);color:var(--keyboard-text-active)}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.action.is-active,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.action:active,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.keycap.is-active,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.keycap:active{color:var(--keyboard-text-active);transform:translateY(calc(var(--keycap-height, 52px)*-.2)) scale(1.4);z-index:calc(var(--keyboard-zindex, 105) - 5)}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.modifier.is-active,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.modifier:active{background:var(--keyboard-text-active);color:var(--keycap-text-active)}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.action.font-glyph,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.modifier.font-glyph{font-size:18px}@media only screen and (max-width:767px){.ML__keyboard .ML__keyboard--plate div .rows>ul>li.action.font-glyph,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.modifier.font-glyph{font-size:16px}}@media only screen and (max-width:767px){.ML__keyboard .ML__keyboard--plate div .rows>ul>li.fnbutton{font-size:12px}}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.bigfnbutton{font-size:var(--keycap-extra-small-font-size,14px)}@media only screen and (max-width:767px){.ML__keyboard .ML__keyboard--plate div .rows>ul>li.bigfnbutton{font-size:calc(var(--keycap-extra-small-font-size, 14px)/1.55)}}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.action,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.modifier{background-color:var(--keycap-modifier-background);border-bottom-color:var(--keycap-modifier-border);border-color:var(--keycap-modifier-border) var(--keycap-modifier-border) var(--keycap-modifier-border-bottom);font-size:65%;font-weight:100}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.action.selected,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.modifier.selected{color:var(--keyboard-text-active)}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.action.selected.is-active,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.action.selected.is-pressed,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.action.selected:active,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.action.selected:hover,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.modifier.selected.is-active,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.modifier.selected.is-pressed,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.modifier.selected:active,.ML__keyboard .ML__keyboard--plate div .rows>ul>li.modifier.selected:hover{color:#fff}.ML__keyboard .ML__keyboard--plate div .rows>ul>li.keycap.w50{font-size:80%;font-weight:100;padding-top:10px}.ML__keyboard .ML__keyboard--plate div .rows>ul>li small{color:#555}@media only screen and (max-width:767px){.ML__keyboard .ML__keyboard--plate div .rows>ul>li small{font-size:9px}}.ML__keyboard .ML__keyboard--plate div .rows>ul>li aside{color:#666;font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;font-size:10px;line-height:10px}@media only screen and (max-width:767px){.ML__keyboard .ML__keyboard--plate div .rows>ul>li aside{display:none}}@media only screen and (max-width:414px){.ML__keyboard .ML__keyboard--plate div .rows>ul>li{margin-right:2px;width:calc(10vw - 2px)}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w5{width:calc(5vw - 2px)}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w15{width:calc(15vw - 2px)}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w20{width:calc(20vw - 2px)}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w50{width:calc(50vw - 2px)}}@media only screen and (min-width:415px) and (max-width:768px){.ML__keyboard .ML__keyboard--plate div .rows>ul>li{margin-right:3px;width:37px}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w5{width:17px}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w15{width:57px}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w20{width:77px}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w50{width:197px}}@media only screen and (min-width:768px) and (max-width:1024px){.ML__keyboard .ML__keyboard--plate div .rows>ul{height:var(--keycap-height,52px)}.ML__keyboard .ML__keyboard--plate div .rows>ul>li{height:var(--keycap-height,52px);margin-right:4px;width:51px}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w5{width:23.5px}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w15{width:78.5px}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w20{width:106px}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w50{width:271px}}@media only screen and (min-width:1025px){.ML__keyboard .ML__keyboard--plate div .rows>ul{height:var(--keycap-height,52px)}.ML__keyboard .ML__keyboard--plate div .rows>ul>li{height:var(--keycap-height,52px);margin-right:6px;width:66px}.ML__keyboard .ML__keyboard--plate div .rows>ul>.action,.ML__keyboard .ML__keyboard--plate div .rows>ul>.modifier{font-size:80%}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w5{width:30px}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w15{width:102px}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w20{width:138px}.ML__keyboard .ML__keyboard--plate div .rows>ul>.w50{width:354px}}@media (prefers-color-scheme:dark){body:not([theme=light]) .ML__keyboard{--hue:206;--keyboard-background:hsl(var(--hue,212),19%,38%);--keyboard-text:#f0f0f0;--keyboard-text-active:hsl(var(--hue,212),100%,60%);--keyboard-background-border:#333;--keycap-background:hsl(var(--hue,212),25%,39%);--keycap-background-active:hsl(var(--hue,212),35%,42%);--keycap-background-border:hsl(var(--hue,212),25%,35%);--keycap-background-border-bottom:#426b8a;--keycap-text:#d0d0d0;--keycap-text-active:#000;--keycap-secondary-text:#fff;--keycap-modifier-background:hsl(var(--hue,212),35%,40%);--keycap-modifier-border:hsl(var(--hue,212),35%,35%);--keycap-modifier-border-bottom:hsl(var(--hue,212),35%,42%);--keyboard-alternate-background:hsl(var(--hue,212),19%,38%)}}body[theme=dark] .ML__keyboard{--hue:206;--keyboard-background:hsl(var(--hue,212),19%,38%);--keyboard-text:#f0f0f0;--keyboard-text-active:hsl(var(--hue,212),100%,60%);--keyboard-background-border:#333;--keycap-background:hsl(var(--hue,212),25%,39%);--keycap-background-active:hsl(var(--hue,212),35%,42%);--keycap-background-border:hsl(var(--hue,212),25%,35%);--keycap-background-border-bottom:#426b8a;--keycap-text:#d0d0d0;--keycap-text-active:#000;--keycap-secondary-text:#fff;--keycap-modifier-background:hsl(var(--hue,212),35%,40%);--keycap-modifier-border:hsl(var(--hue,212),35%,35%);--keycap-modifier-border-bottom:hsl(var(--hue,212),35%,42%);--keyboard-alternate-background:hsl(var(--hue,212),19%,38%)}div.ML__keyboard.material{--keyboard-background:rgba(209,213,217,.9);--keyboard-background-border:#ddd;--keycap-background:transparent;--keycap-background-active:#cccfd1;--keycap-background-border:transparent;--keyboard-alternate-background:#efefef;--keyboard-alternate-text:#000;font-family:Roboto,sans-serif}div.ML__keyboard.material.alternate-keys{background:var(--keyboard-alternate-background);border:1px solid transparent;border-radius:5px;box-shadow:0 14px 28px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.22)}div.ML__keyboard.material.alternate-keys ul li.is-active,div.ML__keyboard.material.alternate-keys ul li.is-pressed,div.ML__keyboard.material.alternate-keys ul li:active,div.ML__keyboard.material.alternate-keys ul li:hover{fill:currentColor;background:#5f97fc;border:1px solid transparent;color:#fff}div.ML__keyboard.material .ML__keyboard__plate .keyboard-toolbar>div>div{font-size:16px}div.ML__keyboard.material .ML__keyboard__plate .keyboard-toolbar div.div.is-active,div.ML__keyboard.material .ML__keyboard__plate .keyboard-toolbar div.div.is-pressed,div.ML__keyboard.material .ML__keyboard__plate .keyboard-toolbar div div:active,div.ML__keyboard.material .ML__keyboard__plate .keyboard-toolbar div div:hover{fill:currentColor;color:#5f97fc}div.ML__keyboard.material .ML__keyboard__plate .keyboard-toolbar>div>.selected{fill:currentColor;border-bottom:2px solid #5f97fc;color:#5f97fc;margin-bottom:8px;padding-bottom:0}div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap{fill:currentColor;background:transparent;border:1px solid transparent;border-radius:5px;color:var(--keycap-text);transition:none}div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap.tt{color:#5f97fc}div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap[data-key=" "]{background:#e0e0e0;height:20px;margin-bottom:10px;margin-top:10px}div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap[data-key=" "].is-active,div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap[data-key=" "].is-pressed,div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap[data-key=" "]:active,div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap[data-key=" "]:hover{background:#d0d0d0;box-shadow:none;transform:none}div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap:not([data-key=" "]):hover{background:var(--keycap-background-active);border:1px solid transparent;box-shadow:none}div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap:not([data-key=" "]).is-active,div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap:not([data-key=" "]).is-pressed,div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap:not([data-key=" "]):active{background:var(--keyboard-alternate-background);box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);color:var(--keyboard-alternate-text)}@media only screen and (max-width:767px){div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap:not([data-key=" "]).is-active,div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap:not([data-key=" "]).is-pressed,div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap:not([data-key=" "]):active{box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);font-size:10px;justify-content:flex-start;margin-left:10px;margin-right:10px;padding:2px 0 0;transform:translateY(-10px) scale(2);transition:none;vertical-align:top;width:19.5px;z-index:calc(var(--ML_keyboard-zindex, 105) - 5)}}@media only screen and (max-width:414px){div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap:not([data-key=" "]).is-active,div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap:not([data-key=" "]).is-pressed,div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap:not([data-key=" "]):active{width:16.5px}}@media only screen and (max-width:767px){div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap:last-child.is-active,div.ML__keyboard.material .ML__keyboard__plate div>.rows>ul>.keycap:last-child:active{margin-left:14px;margin-right:0}}div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.action,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.modifier{fill:currentColor;background:transparent;border:0;color:#869096;font-size:16px;transition:none}div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.action.selected,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.modifier.selected{border-bottom:2px solid #5f97fc;border-radius:0;color:#5f97fc}div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.action.is-active,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.action.is-pressed,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.action:active,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.action:hover,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.modifier.is-active,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.modifier.is-pressed,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.modifier:active,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.modifier:hover{background:var(--keycap-background-active);border:0;box-shadow:none;color:var(--keycap-text)}div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.bigfnbutton,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.fnbutton{background:transparent;border:0}div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.bigfnbutton.selected,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.fnbutton.selected{fill:currentColor;border-bottom:2px solid #5f97fc;border-radius:0;color:#5f97fc}div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.bigfnbutton.is-active,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.bigfnbutton.is-pressed,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.bigfnbutton:active,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.bigfnbutton:hover,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.fnbutton.is-active,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.fnbutton.is-pressed,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.fnbutton:active,div.ML__keyboard.material .ML__keyboard__plate div div.rows ul li.fnbutton:hover{fill:currentColor;background:var(--keycap-background-active);border:0;box-shadow:none;color:#5f97fc}@media (prefers-color-scheme:dark){body:not([theme=light]) div.ML__keyboard.material{--hue:198;--keyboard-background:hsl(var(--hue,212),19%,18%);--keyboard-text:#d4d6d7;--keyboard-text-active:#5f97fc;--keyboard-background-border:#333;--keycap-background:hsl(var(--hue,212),25%,39%);--keycap-background-active:#5f97fc;--keycap-background-border:transparent;--keycap-background-border-bottom:transparent;--keycap-text:#d0d0d0;--keycap-text-active:#d4d6d7;--keycap-secondary-text:#5f97fc;--keycap-modifier-background:hsl(var(--hue,212),35%,40%);--keycap-modifier-border:hsl(var(--hue,212),35%,35%);--keycap-modifier-border-bottom:hsl(var(--hue,212),35%,42%);--keyboard-alternate-background:hsl(var(--hue,212),8%,2%);--keyboard-alternate-background-active:hsl(var(--hue,212),35%,42%);--keyboard-alternate-text:#d1d1d1}}body[theme=dark] div.ML__keyboard.material{--hue:198;--keyboard-background:hsl(var(--hue,212),19%,18%);--keyboard-text:#d4d6d7;--keyboard-text-active:#5f97fc;--keyboard-background-border:#333;--keycap-background:hsl(var(--hue,212),25%,39%);--keycap-background-active:#5f97fc;--keycap-background-border:transparent;--keycap-background-border-bottom:transparent;--keycap-text:#d0d0d0;--keycap-text-active:#d4d6d7;--keycap-secondary-text:#5f97fc;--keycap-modifier-background:hsl(var(--hue,212),35%,40%);--keycap-modifier-border:hsl(var(--hue,212),35%,35%);--keycap-modifier-border-bottom:hsl(var(--hue,212),35%,42%);--keyboard-alternate-background:hsl(var(--hue,212),8%,2%);--keyboard-alternate-background-active:hsl(var(--hue,212),35%,42%);--keyboard-alternate-text:#d1d1d1}';
var qr = {
    main: ["Main-Regular", "ML__cmr"],
    "main-italic": ["Main-Italic", "ML__cmr ML__it"],
    "main-bold": ["Main-Bold", "ML__cmr ML__bold"],
    "main-bolditalic": ["Main-BoldItalic", "ML__cmr ML__bold ML__it"],
    normal: ["Main-Regular", "ML__cmr"],
    "normal-bold": ["Main-Bold", "ML__mathbf"],
    "normal-italic": ["Math-Italic", "ML__mathit"],
    "normal-bolditalic": ["Math-BoldItalic", "ML__mathbfit"],
    ams: ["AMS-Regular", "ML__ams"],
    "ams-bold": ["AMS-Regular", "ML__ams"],
    "ams-italic": ["AMS-Regular", "ML__ams"],
    "ams-bolditalic": ["AMS-Regular", "ML__ams"],
    "sans-serif": ["SansSerif-Regular", "ML__sans"],
    "sans-serif-bold": ["SansSerif-Regular", "ML__sans ML__bold"],
    "sans-serif-italic": ["SansSerif-Regular", "ML__sans"],
    "sans-serif-bolditalic": ["SansSerif-Regular", "ML__sans"],
    calligraphic: ["Caligraphic-Regular", "ML__cal"],
    "calligraphic-bold": ["Caligraphic-Regular", "ML__cal ML__bold"],
    "calligraphic-italic": ["Caligraphic-Regular", "ML__cal ML__it"],
    "calligraphic-bolditalic": ["Caligraphic-Regular", "ML__cal ML__bold ML__it"],
    script: ["Script-Regular", "ML__script"],
    "script-bold": ["Script-Regular", "ML__script ML__bold"],
    "script-italic": ["Script-Regular", "ML__script ML__it"],
    "script-bolditalic": ["Script-Regular", "ML__script ML__bold ML__it"],
    fraktur: ["Fraktur-Regular", "ML__frak"],
    "fraktur-bold": ["Fraktur-Regular", "ML__frak"],
    "fraktur-italic": ["Fraktur-Regular", "ML__frak"],
    "fraktur-bolditalic": ["Fraktur-Regular", "ML__frak"],
    monospace: ["Typewriter-Regular", "ML__tt"],
    "monospace-bold": ["Typewriter-Regular", "ML__tt ML__bold"],
    "monospace-italic": ["Typewriter-Regular", "ML__tt ML__it"],
    "monospace-bolditalic": ["Typewriter-Regular", "ML__tt ML__bold ML__it"],
    "double-struck": ["AMS-Regular", "ML__bb"],
    "double-struck-bold": ["AMS-Regular", "ML__bb"],
    "double-struck-italic": ["AMS-Regular", "ML__bb"],
    "double-struck-bolditalic": ["AMS-Regular", "ML__bb"]
  },
  Dr = {
    "double-struck": /^[A-Z ]$/,
    script: /^[A-Z ]$/,
    calligraphic: /^[\dA-Z ]$/,
    fraktur: /^[\dA-Za-z ]$|^[!"#$%&'()*+,\-./:;=?[]^\u2019\u2018]$/,
    monospace: /^[\dA-Za-z ]$|^[!"&'()*+,\-./:;=?@[\]^_~\u0131\u0237\u0393\u0394\u0398\u039B\u039E\u03A0\u03A3\u03A5\u03A8\u03A9]$/,
    "sans-serif": /^[\dA-Za-z ]$|^[!"&'()*+,\-./:;=?@[\]^_~\u0131\u0237\u0393\u0394\u0398\u039B\u039E\u03A0\u03A3\u03A5\u03A8\u03A9]$/
  },
  Er = /^[\u03B1-\u03C9]|\u03D1|\u03D5|\u03D6|\u03F1|\u03F5]$/,
  Tr = [/^[a-z]$/, /^[A-Z]$/, Er, /^[\u0393|\u0394\u0398\u039B\u039E\u03A0\u03A3\u03A5\u03A6\u03A8\u03A9]$/],
  Or = {
    iso: ["it", "it", "it", "it"],
    tex: ["it", "it", "it", "up"],
    french: ["it", "up", "up", "up"],
    upright: ["up", "up", "up", "up"]
  };
function Br(e) {
  if (!e) return "";
  var t = e.style;
  if (void 0 === t.variant) return "";
  var i = t.variant;
  return t.variantStyle && "up" !== t.variantStyle && (i += "-" + t.variantStyle), i;
}
function Kr(e, t) {
  var i = e[0].parent,
    r = null == i ? void 0 : i.computedStyle.backgroundColor;
  return ve(X(e, "backgroundColor").map(function (e) {
    var n;
    var a = function (e, t) {
      var i;
      if (!e || 0 === e.length) return "";
      var r = null === (i = e[0].parent) || void 0 === i ? void 0 : i.style.color;
      return ve(X(e, "color").map(function (e) {
        var i;
        var n = function (e, t) {
          return function (e, t) {
            return ve(X(e, "fontFamily").map(function (e) {
              var i, r;
              var n = function (e, t) {
                  return ve(X(e, "fontSize").map(function (e) {
                    var i, r;
                    var n = function (e, t) {
                        return ve(X(e, "fontSeries").map(function (e) {
                          var i = function (e, t) {
                              return ve(X(e, "fontShape").map(function (e) {
                                var i = function (e, t) {
                                    return ve(e.map(function (e) {
                                      return rt.serialize(e, t);
                                    }));
                                  }(e, t),
                                  r = e[0].style.fontShape;
                                return "it" === r ? "\\textit{" + i + "}" : "sl" === r ? "\\textsl{" + i + "}" : "sc" === r ? "\\textsc{" + i + "}" : "n" === r ? "\\textup{" + i + "}" : r ? "\\fontshape{" + e[0].style.fontShape + "}" + i : i;
                              }));
                            }(e, t),
                            r = e[0].style.fontSeries;
                          return "b" === r ? "\\textbf{" + i + "}" : "l" === r ? "\\textlf{" + i + "}" : "m" === r ? "\\textmd{" + i + "}" : r ? "\\fontseries{" + r + "}" + i : i;
                        }));
                      }(e, t),
                      a = null !== (r = ["", "tiny", "scriptsize", "footnotesize", "small", "normalsize", "large", "Large", "LARGE", "huge", "Huge"][null !== (i = e[0].style.fontSize) && void 0 !== i ? i : ""]) && void 0 !== r ? r : "";
                    return a ? "\\".concat(a, " ").concat(n) : n;
                  }));
                }(e, t),
                a = null !== (r = {
                  roman: "textrm",
                  monospace: "texttt",
                  "sans-serif": "textsf"
                }[null !== (i = e[0].style.fontFamily) && void 0 !== i ? i : ""]) && void 0 !== r ? r : "";
              return a ? "\\".concat(a, "{").concat(n, "}") : e[0].style.fontFamily ? "\\fontfamily{" + e[0].style.fontFamily + "}" + n : n;
            }));
          }(e, t);
        }(e, t);
        return e[0].style.color && "none" !== e[0].style.color && r !== e[0].style.color ? "\\textcolor{" + (null !== (i = e[0].style.verbatimColor) && void 0 !== i ? i : e[0].style.color) + "}{" + n + "}" : n;
      }));
    }(e, t);
    var o = e[0].computedStyle;
    return !o.backgroundColor || i && r === o.backgroundColor || !(e.length > 0) && e[0] instanceof Tt || (a = "\\colorbox{".concat(null !== (n = o.verbatimBackgroundColor) && void 0 !== n ? n : o.backgroundColor, "}{").concat(a, "}")), a;
  }));
}
new ( /*#__PURE__*/function (_G) {
  _inherits(_class, _G);
  var _super27 = _createSuper(_class);
  function _class() {
    _classCallCheck(this, _class);
    return _super27.call(this, "math");
  }
  _createClass(_class, [{
    key: "createAtom",
    value: function createAtom(e, t) {
      var i, r;
      var n = Re(e, "math"),
        a = new rt(null !== (i = null == n ? void 0 : n.type) && void 0 !== i ? i : "mord", {
          mode: "math",
          command: e,
          value: (null == n ? void 0 : n.codepoint) ? String.fromCodePoint(null == n ? void 0 : n.codepoint) : e,
          style: t
        });
      return null !== (r = null == n ? void 0 : n.isFunction) && void 0 !== r && r && (a.isFunction = !0), e.startsWith("\\") && (a.verbatimLatex = e), a;
    }
  }, {
    key: "serialize",
    value: function serialize(e, t) {
      var _this30 = this;
      var i = e[0].parent,
        r = null == i ? void 0 : i.computedStyle.fontSize;
      return ve(X(e, "fontSize").map(function (e) {
        var n = _this30.emitBackgroundColorRun(e, t),
          a = e[0].computedStyle.fontSize;
        return !a || i && r === a ? n : "\\" + ["", "tiny", "scriptsize", "footnotesize", "small", "normalsize", "large", "Large", "LARGE", "huge", "Huge"][a] + " " + n;
      }));
    }
  }, {
    key: "emitBackgroundColorRun",
    value: function emitBackgroundColorRun(e, t) {
      var _this31 = this;
      var i = e[0].parent,
        r = null == i ? void 0 : i.computedStyle.backgroundColor;
      return ve(X(e, "backgroundColor").map(function (e) {
        var n;
        var a = _this31.emitColorRun(e, t);
        var o = e[0].computedStyle;
        return !o.backgroundColor || i && r === o.backgroundColor || !(e.length > 0) && e[0] instanceof Tt || (a = "inline-math" === t.defaultMode ? "\\( ".concat(a, " \\)") : "\\[ ".concat(a, " \\]"), a = "\\colorbox{".concat(null !== (n = o.verbatimBackgroundColor) && void 0 !== n ? n : o.backgroundColor, "}{").concat(a, "}")), a;
      }));
    }
  }, {
    key: "emitColorRun",
    value: function emitColorRun(e, t) {
      var i;
      var r = e[0].parent,
        n = null !== (i = null == r ? void 0 : r.mode) && void 0 !== i ? i : "math",
        a = Br(r),
        o = null == r ? void 0 : r.computedStyle.color;
      return ve(X(e, "color").map(function (e) {
        var i;
        var s = ve(X(e, "variant").map(function (e) {
            var i = Br(e[0]);
            if (e.every(function (e) {
              var t = Re(e.command, n);
              return !(!t || !t.variant) && Br(e) === i;
            })) return ve(e.map(function (e) {
              return rt.serialize(e, t);
            }));
            var r = "";
            return i && i !== a && (r = {
              calligraphic: "\\mathcal{",
              fraktur: "\\mathfrak{",
              "double-struck": "\\mathbb{",
              script: "\\mathscr{",
              monospace: "\\mathtt{",
              "sans-serif": "\\mathsf{",
              normal: "\\mathrm{",
              "normal-italic": "\\mathit{",
              "normal-bold": "\\mathbf{",
              "normal-bolditalic": "\\mathbfit{",
              ams: "",
              "ams-italic": "\\mathit{",
              "ams-bold": "\\mathbf{",
              "ams-bolditalic": "\\mathbfit{",
              main: "",
              "main-italic": "\\mathit{",
              "main-bold": "\\mathbf{",
              "main-bolditalic": "\\mathbfit{"
            }[i]), ve([r].concat(_toConsumableArray(e.map(function (e) {
              return rt.serialize(e, t);
            })))) + (r ? "}" : "");
          })),
          l = e[0].computedStyle;
        return !l.color || r && o === l.color ? s : "\\textcolor{" + (null !== (i = l.verbatimColor) && void 0 !== i ? i : l.color) + "}{" + s + "}";
      }));
    }
  }, {
    key: "applyStyle",
    value: function applyStyle(e, t) {
      if (void 0 === t.variant) return "";
      var i = "auto" !== t.letterShapeStyle && t.letterShapeStyle ? t.letterShapeStyle : "tex";
      var r = t.variant,
        n = t.variantStyle;
      "normal" === r && !n && /[\u00A3\u0131\u0237]/.test(e.value) && (r = "main", n = "italic"), "normal" !== r || n || 1 !== e.value.length || Tr.forEach(function (t, r) {
        t.test(e.value) && "it" === Or[i][r] && (n = "italic");
      }), "up" === n && (n = void 0);
      var a = n ? r + "-" + n : r,
        _qr$a = _slicedToArray(qr[a], 2),
        o = _qr$a[0],
        s = _qr$a[1];
      return Dr[r] && !Dr[r].test(e.value) ? (e.value = function (e, t, i) {
        if (!/[A-Za-z\d]/.test(e)) return e;
        if (!t && !i) return e;
        var r = e.codePointAt(0);
        if (void 0 === r) return e;
        for (var _i87 = 0, _Ie2 = Ie; _i87 < _Ie2.length; _i87++) {
          var _e120 = _Ie2[_i87];
          if ((!t || _e120.variant === t) && (!i || _e120.style === i) && r >= _e120.offset && r < _e120.offset + _e120.len) {
            var _t102 = _e120.start + r - _e120.offset;
            return String.fromCodePoint(Pe[_t102] || _t102);
          }
        }
        return e;
      }(e.value, r, n), null) : (Er.test(e.value) && (e.classes += " lcGreek"), s && (e.classes += " " + s), o);
    }
  }]);
  return _class;
}(G))();
var Fr = {
  roman: "",
  "sans-serif": "ML__sans",
  monospace: "ML__tt"
};
new ( /*#__PURE__*/function (_G2) {
  _inherits(_class2, _G2);
  var _super28 = _createSuper(_class2);
  function _class2() {
    _classCallCheck(this, _class2);
    return _super28.call(this, "text");
  }
  _createClass(_class2, [{
    key: "createAtom",
    value: function createAtom(e, t) {
      var i = Re(e, "text");
      return new Ct(e, (null == i ? void 0 : i.codepoint) ? String.fromCodePoint(null == i ? void 0 : i.codepoint) : e, t);
    }
  }, {
    key: "serialize",
    value: function serialize(e, t) {
      var i, r, n;
      var a = _toConsumableArray(e);
      var o = "";
      for (; null !== (r = null === (i = a[0]) || void 0 === i ? void 0 : i.changeMode) && void 0 !== r && r;) o += Kr([a[0]], t), a.shift();
      var s = "";
      return a.length > 0 && (s += Kr(a, t)), null !== (n = t.skipModeCommand) && void 0 !== n && n || s && (a.every(function (e) {
        return void 0 !== e.style.fontSeries || void 0 !== e.style.fontShape || void 0 !== e.style.fontFamily;
      }) || (s = "\\text{".concat(s, "}"))), o + s;
    }
  }, {
    key: "applyStyle",
    value: function applyStyle(e, t) {
      var i, r, n, a, o, s;
      var l = t.fontFamily;
      if (Fr[l] ? e.classes += null !== (i = " " + Fr[l]) && void 0 !== i ? i : "" : l && e.setStyle("font-family", l), t.fontShape && (e.classes += " ", e.classes += null !== (r = {
        it: "ML__it",
        sl: "ML__shape_sl",
        sc: "ML__shape_sc",
        ol: "ML__shape_ol"
      }[t.fontShape]) && void 0 !== r ? r : ""), t.fontSeries) {
        var _i88 = t.fontSeries.match(/(.?[lbm])?(.?[cx])?/);
        _i88 && (e.classes += " ", e.classes += null !== (a = {
          ul: "ML__series_ul",
          el: "ML__series_el",
          l: "ML__series_l",
          sl: "ML__series_sl",
          m: "",
          sb: "ML__series_sb",
          b: "ML__bold",
          eb: "ML__series_eb",
          ub: "ML__series_ub"
        }[null !== (n = _i88[1]) && void 0 !== n ? n : ""]) && void 0 !== a ? a : "", e.classes += " ", e.classes += null !== (s = {
          uc: "ML__series_uc",
          ec: "ML__series_ec",
          c: "ML__series_c",
          sc: "ML__series_sc",
          n: "",
          sx: "ML__series_sx",
          x: "ML__series_x",
          ex: "ML__series_ex",
          ux: "ML__series_ux"
        }[null !== (o = _i88[2]) && void 0 !== o ? o : ""]) && void 0 !== s ? s : "");
      }
      return "Main-Regular";
    }
  }, {
    key: "parse",
    value: function parse(e, t, i) {
      var r,
        n = [];
      var _loop = function _loop() {
        var a = e.shift();
        if ("<space>" === a) n.push(new Ct(" ", " ", i.style));else if (a && a.startsWith("\\")) {
          var _i$parse, _i$parse2;
          var _t103;
          e.unshift(a), (_i$parse = i.parse("text", e, i), _i$parse2 = _slicedToArray(_i$parse, 2), _t103 = _i$parse2[0], e = _i$parse2[1]), n = [].concat(_toConsumableArray(n), _toConsumableArray(_t103));
        } else if ("<$>" === a || "<$$>" === a) {
          var _t104 = e.slice(0, e.findIndex(function (e) {
            return e === a;
          }));
          e = e.slice(_t104.length + 1);
          var _i$parse3 = i.parse("math", _t104, i),
            _i$parse4 = _slicedToArray(_i$parse3, 1),
            _r27 = _i$parse4[0];
          n = [].concat(_toConsumableArray(n), _toConsumableArray(_r27));
        } else if ("<{>" === a || "<}>" === a) ;else if (a) {
          var _e121 = Re(a, "text", i.macros);
          !_e121 || _e121.ifMode && !_e121.ifMode.includes("text") ? t({
            code: "unexpected-token"
          }) : _e121.codepoint && (r = new Ct(a, String.fromCodePoint(_e121.codepoint), i.style), r.verbatimLatex = $e("text", a.codePointAt(0)), n.push(r));
        }
      };
      for (; e.length > 0;) {
        _loop();
      }
      return [n, e];
    }
  }]);
  return _class2;
}(G))();
var $r = /*#__PURE__*/function (_rt25) {
  _inherits($r, _rt25);
  var _super29 = _createSuper($r);
  function $r(e, t) {
    var _this32;
    _classCallCheck(this, $r);
    var i;
    _this32 = _super29.call(this, "latex", {
      value: e,
      mode: "latex"
    }), _this32.isSuggestion = null !== (i = null == t ? void 0 : t.isSuggestion) && void 0 !== i && i, _this32.isError = !1, _this32.verbatimLatex = e;
    return _this32;
  }
  _createClass($r, [{
    key: "computedStyle",
    get: function get() {
      return {};
    }
  }, {
    key: "render",
    value: function render(e) {
      var t = new te(this.value, {
        classes: this.isSuggestion ? "ML__suggestion" : this.isError ? "ML__error" : "",
        type: "latex",
        maxFontSize: 1
      });
      return t ? (this.caret && (t.caret = this.caret), this.bind(e, t)) : null;
    }
  }]);
  return $r;
}(rt);
var Pr = /*#__PURE__*/function (_rt26) {
  _inherits(Pr, _rt26);
  var _super30 = _createSuper(Pr);
  function Pr(e) {
    var _this33;
    _classCallCheck(this, Pr);
    _this33 = _super30.call(this, "group", {
      mode: "latex"
    }), _this33.body = _toConsumableArray(e).map(function (e) {
      return new $r(e);
    }), _this33.skipBoundary = !1;
    return _this33;
  }
  _createClass(Pr, [{
    key: "render",
    value: function render(e) {
      var t = rt.createBox(e, this.body, {
        newList: !0
      });
      return t ? (this.caret && (t.caret = this.caret), this.bind(e, t)) : null;
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      var t, i;
      return null !== (i = null === (t = this.body) || void 0 === t ? void 0 : t.map(function (e) {
        return e.value;
      }).join("")) && void 0 !== i ? i : "";
    }
  }]);
  return Pr;
}(rt);
new ( /*#__PURE__*/function (_G3) {
  _inherits(_class3, _G3);
  var _super31 = _createSuper(_class3);
  function _class3() {
    _classCallCheck(this, _class3);
    return _super31.call(this, "latex");
  }
  _createClass(_class3, [{
    key: "createAtom",
    value: function createAtom(e, t) {
      return new $r(e);
    }
  }, {
    key: "serialize",
    value: function serialize(e, t) {
      return e.filter(function (e) {
        return e instanceof $r && !e.isSuggestion;
      }).map(function (e) {
        return e.value;
      }).join("");
    }
  }]);
  return _class3;
}(G))();
var Ir = {
    "p@": "1pt ",
    "z@": "0pt",
    maxdimen: "16383.99999pt",
    hfuzz: "0.1pt",
    vfuzz: "0.1pt",
    overfullrule: "5pt",
    hsize: "6.5in",
    vsize: "8.9in",
    parindent: "20pt",
    maxdepth: "4pt",
    splitmaxdepth: "\\maxdimen",
    boxmaxdepth: "\\maxdimen",
    delimitershortfall: "5pt",
    nulldelimiterspace: "1.2pt",
    scriptspace: "0.5pt",
    topskip: "10pt",
    splittopskip: "10pt",
    normalbaselineskip: "12pt",
    normallineskip: "1pt",
    normallineskiplimit: "0pt",
    jot: "3pt",
    doublerulesep: "2pt",
    arrayrulewidth: "0.4pt",
    arraycolsep: "5pt",
    fboxsep: "3pt",
    fboxrule: "0.4pt"
  },
  Rr = {
    "z@skip": "0pt plust0pt minus0pt",
    hideskip: "-1000pt plust 1fill",
    "@flushglue": "0pt plust 1fill",
    parskip: "0pt plus 1pt",
    abovedisplayskip: "12pt plus 3pt minus 9pt",
    abovedisplayshortskip: "0pt plus 3pt",
    belowdisplayskip: "12pt plus 3pt minus 9pt",
    belowdisplayshortskip: "7pt plus 3pt minus 4pt",
    parfillskip: "0pt plus 1fil",
    thinmuskip: "3mu",
    medmuskip: "4mu plus 2mu minus 4mu",
    thickmuskip: "5mu plus 5mu",
    smallskipamount: "3pt plus1pt minus1pt",
    medskipamount: "6pt plus2pt minus2pt",
    bigskipamount: "12pt plus4pt minus4pt"
  },
  Vr = {
    pretolerance: 100,
    tolerance: 200,
    hbadness: 1e3,
    vbadness: 1e3,
    linepenalty: 10,
    hyphenpenalty: 50,
    exhyphenpenalty: 50,
    binoppenalty: 700,
    relpenalty: 500,
    clubpenalty: 150,
    widowpenalty: 150,
    displaywidowpenalty: 50,
    brokenpenalty: 100,
    predisplaypenalty: 1e4,
    doublehyphendemerits: 1e4,
    finalhyphendemerits: 5e3,
    adjdemerits: 1e4,
    tracinglostchars: 1,
    uchyph: 1,
    delimiterfactor: 901,
    defaulthyphenchar: "\\-",
    defaultskewchar: -1,
    newlinechar: -1,
    showboxbreadth: 5,
    showboxdepth: 3,
    errorcontextlines: 5,
    interdisplaylinepenalty: 100,
    interfootnotelinepenalty: 100,
    baselineSkip: 1.2,
    arraystretch: "",
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
    year: new Date().getFullYear()
  };
var jr;
function Hr() {
  var e, t, i, r;
  if (jr) return jr;
  jr = _objectSpread({}, Vr);
  for (var _i89 = 0, _Object$keys6 = Object.keys(Ir); _i89 < _Object$keys6.length; _i89++) {
    var _t105 = _Object$keys6[_i89];
    jr[_t105] = null !== (e = qt(Ir[_t105], jr)) && void 0 !== e ? e : 0;
  }
  for (var _i90 = 0, _Object$keys7 = Object.keys(Rr); _i90 < _Object$keys7.length; _i90++) {
    var _e122 = _Object$keys7[_i90];
    jr[_e122] = null !== (r = jr, t = "object" == typeof (i = Rr[_e122]) && "glue" in i ? i : "object" == typeof i && "dimension" in i ? {
      glue: i
    } : "number" == typeof i ? {
      glue: {
        dimension: i
      }
    } : new Nt(be(i), {
      registers: r
    }).scanGlue()) && void 0 !== t ? t : 0;
  }
  return jr;
}
function Ur(e, t) {
  return function (e, t) {
    return e;
  }(e, (null == t ? void 0 : t.registers) ? t.registers : Hr());
}
var Wr = '#mathlive-popover-panel{background-color:rgba(97,97,97,.95);border-radius:6px;box-shadow:0 14px 28px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.22);color:#fff;display:flex;flex-direction:column;justify-content:center;min-width:160px;position:fixed;text-align:center;transition:all .2s cubic-bezier(.64,.09,.08,1);visibility:hidden;z-index:1}#mathlive-popover-panel:after{border-bottom:5px solid rgba(97,97,97,.9);border-left:5px solid transparent;border-right:5px solid transparent;content:"";font-size:1rem;height:0;left:calc(50% - 3px);position:absolute;top:-5px;width:0}.ML__popover--reverse-direction:after{border-bottom:0;border-top:5px solid rgba(97,97,97,.9);bottom:-5px;top:auto}#mathlive-popover-panel.is-visible{animation:ML__fade-in .15s cubic-bezier(0,0,.2,1);visibility:inherit}@keyframes ML__fade-in{0%{opacity:0}to{opacity:1}}.ML__popover__content{border-radius:6px;cursor:pointer;display:flex;flex-direction:column;justify-content:center;margin-left:8px;margin-right:8px;min-height:100px;padding:2px}.ML__popover__content a{color:#5ea6fd;display:block;margin-top:.4em;padding-top:.3em}.ML__popover__content a:hover{color:#5ea6fd;text-decoration:underline}.ML__popover__content.is-active,.ML__popover__content.is-pressed,.ML__popover__content:hover{background:hsla(0,0%,100%,.1)}.ML__popover__command{font-family:KaTeX_Main;font-size:1.6rem}.ML__popover__prev-shortcut{cursor:pointer;height:31px;margin-left:8px;margin-right:8px;opacity:.1;padding-bottom:2px;padding-top:4px}.ML__popover__next-shortcut:hover,.ML__popover__prev-shortcut:hover{opacity:.3}.ML__popover__next-shortcut.is-active,.ML__popover__next-shortcut.is-pressed,.ML__popover__prev-shortcut.is-active,.ML__popover__prev-shortcut.is-pressed{opacity:1}.ML__popover__next-shortcut>span,.ML__popover__prev-shortcut>span{border-radius:8px;display:inline-block;height:20px;padding:5px;width:20px}.ML__popover__prev-shortcut>span>span{display:block;margin-top:-2px}.ML__popover__next-shortcut>span>span{display:block;margin-top:2px}.ML__popover__next-shortcut:hover>span,.ML__popover__prev-shortcut:hover>span{background:hsla(0,0%,100%,.1)}.ML__popover__next-shortcut{cursor:pointer;height:34px;margin-left:8px;margin-right:8px;opacity:.1;padding-bottom:4px;padding-top:2px}.ML__popover__shortcut{font-size:.8em;margin-top:.25em}.ML__popover__note,.ML__popover__shortcut{font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;opacity:.7;padding-top:.25em}.ML__popover__note{font-size:.8rem;line-height:1em;padding-left:.5em;padding-right:.5em}.ML__shortcut-join{opacity:.5}';
var Zr,
  Gr = null,
  Xr = null;
var Yr = {
  "\\text": "roman text",
  "\\textrm": "roman text",
  "\\textnormal": "roman text",
  "\\textit": "italic text",
  "\\textbf": "bold text",
  "\\texttt": "monospaced text",
  "\\textsf": "sans-serif text",
  "\\mathrm": ["roman", "(upright)"],
  "\\mathbf": "bold",
  "\\bf": "bold",
  "\\bold": "bold",
  "\\mathit": "italic",
  "\\mathbb": "blackboard",
  "\\mathscr": "script",
  "\\mathtt": ["typewriter", "(monospaced)"],
  "\\mathsf": "sans-serif",
  "\\mathcal": "caligraphic",
  "\\frak": ["fraktur", "(gothic)"],
  "\\mathfrak": ["fraktur", "(gothic)"],
  "\\textcolor": "text color",
  "\\color": "color",
  "\\forall": "for all",
  "\\exists": "there exists",
  "\\nexists": "there does not exist",
  "\\frac": "fraction",
  "\\dfrac": "display fraction",
  "\\cfrac": "continuous fraction",
  "\\tfrac": "text fraction",
  "\\binom": "binomial coefficient",
  "\\dbinom": "display binomial coefficient",
  "\\tbinom": "text binomial coefficient",
  "\\pdiff": "partial differential",
  "\\vec": "vector",
  "\\check": "caron",
  "\\acute": "acute",
  "\\breve": "breve",
  "\\tilde": "tilde",
  "\\dot": "dot",
  "\\hat": ["hat", "circumflex"],
  "\\ddot": "double dot",
  "\\bar": "bar",
  "\\prime": "prime",
  "\\doubleprime": "double prime",
  "\\varnothing": "empty set",
  "\\emptyset": "empty set",
  "\\subseteq": "subset of or <br>equal to",
  "\\supseteq": "superset of or <br>equal to",
  "\\supset": "superset of",
  "\\subset": "subset of",
  "\\partial": "partial derivative",
  "\\bigcup": "union",
  "\\bigcap": "intersection",
  "\\approx": "approximately equal to",
  "\\notin": "not an element of",
  "\\in": ["element of", "included in"],
  "\\infty": "infinity",
  "\\land": "logical and",
  "\\sqrt": "square root",
  "\\prod": "product",
  "\\sum": "summation",
  "\\amalg": ["amalgamation", "coproduct", "free product", "disjoint union"],
  "\\cup": "union with",
  "\\cap": "intersection with",
  "\\int": "integral",
  "\\iint": "surface integral",
  "\\oint": "curve integral",
  "\\iiint": "volume integral",
  "\\iff": "if and only if",
  "\\ln": "natural logarithm",
  "\\boldsymbol": "bold",
  "\\setminus": "set subtraction",
  "\\stackrel": "relation with symbol above",
  "\\stackbin": "operator with symbol above",
  "\\underset": "symbol with annotation below",
  "\\overset": "symbol with annotation above",
  "\\hslash": ["h-bar", "Planck constant"],
  "\\gtrsim": "greater than or <br>similar to",
  "\\propto": "proportional to",
  "\\equiv": "equivalent to",
  "\\!": ["negative thin space", "(-3 mu)"],
  "\\ ": ["space", "(6 mu)"],
  "\\,": ["thin space", "(3 mu)"],
  "\\:": ["medium space", "(4 mu)"],
  "\\;": ["thick space", "(5 mu)"],
  "\\quad": ["1 em space", "(18 mu)"],
  "\\qquad": ["2 em space", "(36 mu)"],
  "\\enskip": ["&#189; em space", "(9 mu)"],
  "\\mp": "minus or plus",
  "\\pm": "plus or minus",
  "\\Im": "Imaginary part of",
  "\\Re": "Real part of",
  "\\gothicCapitalR": "Real part of",
  "\\gothicCapitalI": "Imaginary part part of",
  "\\differentialD": "differential d",
  "\\aleph": ["aleph", "infinite cardinal", '<a target="_blank" href="https://en.wikipedia.org/wiki/Cardinal_number">Wikipedia <big>&#x203A;</big></a>'],
  "\\beth": ["beth", "beth number", '<a target="_blank" href="https://en.wikipedia.org/wiki/Beth_number">Wikipedia <big>&#x203A;</big></a>'],
  "\\gimel": ["gimel", "gimel function", '<a target="_blank" href="https://en.wikipedia.org/wiki/Gimel_function">Wikipedia <big>&#x203A;</big></a>'],
  "\\O": "empty set",
  "\\N": "set of <br>natural numbers",
  "\\Z": "set of <br>integers",
  "\\Q": "set of <br>rational numbers",
  "\\C": "set of <br>complex numbers",
  "\\R": "set of <br>real numbers",
  "\\P": "set of <br>prime numbers",
  "\\lesseqqgtr": "less than, equal to or<br> greater than",
  "\\gnapprox": "greater than and <br>not approximately",
  "\\lnapprox": "lesser than and <br>not approximately",
  "\\j": "dotless j",
  "\\i": "dotless i",
  "\\cdot": "centered dot",
  "\\lmoustache": "left moustache",
  "\\rmoustache": "right moustache",
  "\\nabla": ["nabla", "del", "differential vector operator"],
  "\\square": ["square", "d\u2019Alembert operator", '<a target="_blank" href="https://en.wikipedia.org/wiki/D%27Alembert_operator">Wikipedia <big>&#x203A;</big></a>'],
  "\\blacksquare": ["black square", "end of proof", "tombstone", "Halmos symbol"],
  "\\Box": "end of proof",
  "\\colon": ["such that", "ratio"],
  "\\coloneq": ["is defined by", "is assigned"],
  "\\Colon": ["is defined by", "as"],
  "\\_": ["underbar", "underscore"],
  "\\ll": "much less than",
  "\\gg": "much greater than",
  "\\doteq": "approximately equal to",
  "\\Doteq": "approximately equal to",
  "\\doteqdot": "approximately equal to",
  "\\cong": ["isomorphism of", "(for algebras, modules...)"],
  "\\det": ["determinant of", "(of a matrix)"],
  "\\dotplus": "Cartesian product algebra",
  "\\otimes": ["tensor product", "(of algebras)", "Kronecker product", "(of matrices)"],
  "\\oplus": ["direct sum", "(of modules)"],
  "\\lb": "base-2 logarithm",
  "\\lg": "base-10 logarithm",
  "\\wp": ["Weierstrass P", '<a target="_blank" href="https://en.wikipedia.org/wiki/Weierstrass%27s_elliptic_functions">Wikipedia <big>&#x203A;</big></a>'],
  "\\wr": ["wreath product", '<a target="_blank" href="https://en.wikipedia.org/wiki/Wreath_product">Wikipedia <big>&#x203A;</big></a>'],
  "\\top": ["tautology", "Proposition P is universally true"],
  "\\bot": ["contradiction", "Proposition P is contradictory"],
  "\\mid": ["probability", "of event A given B"],
  "\\mho": ["Siemens", "electrical conductance in SI unit", '<a target="_blank" href="https://en.wikipedia.org/wiki/Siemens_(unit)">Wikipedia <big>&#x203A;</big></a>'],
  "\\Longrightarrow": "implies",
  "\\Longleftrightarrow": "if, and only if,",
  "\\prec": "precedes",
  "\\preceq": "precedes or is equal to",
  "\\succ": "succeedes",
  "\\succeq": "succeedes or is equal to",
  "\\perp": ["is perpendicular to", "is independent of"],
  "\\models": ["entails", "double-turnstyle, models", "is a semantic consequence of", '<a target="_blank" href="https://en.wikipedia.org/wiki/Double_turnstile">Wikipedia <big>&#x203A;</big></a>'],
  "\\vdash": ["satisfies", "turnstyle, assertion sign", "syntactic inference", '<a target="_blank" href="https://en.wikipedia.org/wiki/Turnstile_(symbol)">Wikipedia <big>&#x203A;</big></a>'],
  "\\implies": ["implies", "logical consequence"],
  "\\impliedby": ["implied by", "logical consequence"],
  "\\surd": ["surd", "root of", "checkmark"],
  "\\ltimes": ["semi direct product", '<a target="_blank" href="https://en.wikipedia.org/wiki/Semidirect_product">Wikipedia <big>&#x203A;</big></a>'],
  "\\rtimes": ["semi direct product", '<a target="_blank" href="https://en.wikipedia.org/wiki/Semidirect_product">Wikipedia <big>&#x203A;</big></a>'],
  "\\leftthreetimes": ["semi direct product", '<a target="_blank" href="https://en.wikipedia.org/wiki/Semidirect_product">Wikipedia <big>&#x203A;</big></a>'],
  "\\rightthreetimes": ["semi direct product", '<a target="_blank" href="https://en.wikipedia.org/wiki/Semidirect_product">Wikipedia <big>&#x203A;</big></a>'],
  "\\divideontimes": ["divide on times"],
  "\\curlywedge": "nor",
  "\\curlyvee": "nand",
  "\\simeq": "is group isomorphic with",
  "\\vartriangleleft": ["is a normal subgroup of", "is an ideal ring of"],
  "\\circ": ["circle", "ring", "function composition"],
  "\\rlap": ["overlap right", "\\rlap{x}o"],
  "\\llap": ["overlap left", "o\\llap{/}"],
  "\\colorbox": ["color box", "\\colorbox{#fbc0bd}{...}"],
  "\\ast": ["asterisk", "reflexive closure (as a superscript)"],
  "\\bullet": "bullet",
  "\\lim": "limit"
};
function Qr(e, t) {
  var i;
  if (e.element && e.element.mathfield === e && e.popover && e.popoverVisible) if (null == t ? void 0 : t.deferred) setTimeout(function () {
    return Qr(e);
  }, 100);else if ("latex" !== (null === (i = e.model.at(e.model.position)) || void 0 === i ? void 0 : i.type)) en(e);else {
    var _t106 = wr(e.field);
    _t106 && Jr(e, _t106);
  }
}
function Jr(e, t) {
  if (we(), !e.popover || !e.popoverVisible) return;
  var i = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
    r = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    n = window.innerWidth - document.documentElement.clientWidth,
    a = window.innerHeight - document.documentElement.clientHeight,
    o = e.virtualKeyboard.height;
  t.x + e.popover.offsetWidth / 2 > r - n ? e.popover.style.left = r - e.popover.offsetWidth - n + "px" : t.x - e.popover.offsetWidth / 2 < 0 ? e.popover.style.left = "0" : e.popover.style.left = t.x - e.popover.offsetWidth / 2 + "px", t.y + e.popover.offsetHeight + 5 > i - a - o ? (e.popover.classList.add("ML__popover--reverse-direction"), e.popover.style.top = t.y - t.height - e.popover.offsetHeight - 5 + "px") : (e.popover.classList.remove("ML__popover--reverse-direction"), e.popover.style.top = "".concat(t.y + 5, "px"));
}
function en(e) {
  e.suggestionIndex = 0, e.popoverVisible = !1, e.popover && (e.popover.classList.remove("is-visible"), e.popover.innerHTML = "");
}
function tn(e) {
  var t = 0;
  for (var _i91 = 0; _i91 < e.length; _i91++) t = 31 * t + e.charCodeAt(_i91), t |= 0;
  return Math.abs(t);
}
function rn(e, t) {
  e.dirty || (e.dirty = !0, requestAnimationFrame(function () {
    kr(e) && e.dirty && (e._atomBoundsCache = new Map(), nn(e, t), e._atomBoundsCache = void 0);
  }));
}
function nn(e, t) {
  var i, r;
  if (we(), !kr(e)) return;
  t = null != t ? t : {}, e.dirty = !1;
  var n = e.model;
  void 0 === window.mathlive && (window.mathlive = {}), n.root.caret = "", n.root.isSelected = !1, n.root.containsCaret = !0;
  var _iterator64 = _createForOfIteratorHelper(n.atoms),
    _step64;
  try {
    for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
      var _e125 = _step64.value;
      _e125.caret = "", _e125.isSelected = !1, _e125.containsCaret = !1;
    }
  } catch (err) {
    _iterator64.e(err);
  } finally {
    _iterator64.f();
  }
  var a = e.hasFocus() && !e.options.readOnly;
  if (n.selectionIsCollapsed) n.at(n.position).caret = a ? e.mode : "";else {
    var _iterator65 = _createForOfIteratorHelper(n.getAtoms(n.selection, {
        includeChildren: !0
      })),
      _step65;
    try {
      for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
        var _e123 = _step65.value;
        _e123.isSelected = !0;
      }
    } catch (err) {
      _iterator65.e(err);
    } finally {
      _iterator65.f();
    }
  }
  if (a) {
    var _e124 = n.at(n.position).parent;
    for (; _e124;) _e124.containsCaret = !0, _e124 = _e124.parent;
  }
  var o = n.root.render(new H({
      macros: e.options.macros,
      registers: e.options.registers,
      atomIdsSettings: {
        seed: tn(rt.serialize(n.root, {
          expandMacro: !1,
          defaultMode: e.options.defaultMode
        })),
        groupNumbers: null !== (i = t.forHighlighting) && void 0 !== i && i
      },
      smartFence: e.options.smartFence,
      renderPlaceholder: e.options.readOnly ? function (t, i) {
        if (i.placeholderId) {
          var _r28 = e.getPlaceholderField(i.placeholderId);
          return i.createMathfieldBox(t, {
            placeholderId: i.placeholderId,
            element: _r28
          });
        }
        return i.createBox(t);
      } : void 0,
      isSelected: n.root.isSelected
    }, {
      fontSize: 5,
      letterShapeStyle: e.options.letterShapeStyle
    }, "inline-math" === e.options.defaultMode ? "textstyle" : "displaystyle")),
    s = se(oe(o, e.options.horizontalSpacingScale), {
      classes: "ML__mathlive",
      attributes: {
        translate: "no",
        "aria-hidden": "true"
      }
    }),
    l = e.field,
    c = l.classList.contains("ML__focused");
  c && !a ? l.classList.remove("ML__focused") : !c && a && l.classList.add("ML__focused"), l.innerHTML = e.options.createHTML(s.toMarkup()), e.fieldContent = l.querySelector(".ML__mathlive"), e.accessibleNode.innerHTML = e.options.createHTML('<math xmlns="http://www.w3.org/1998/Math/MathML">' + lr(n.root, e.options) + "</math>"), an(e), e.options.readOnly && e.attachNestedMathfield(), null !== (r = t.interactive) && void 0 !== r && r || setTimeout(function () {
    return an(e);
  }, 32);
}
function an(e) {
  if (we(), !e.field) return;
  var _iterator66 = _createForOfIteratorHelper(e.field.querySelectorAll(".ML__selection, .ML__contains-highlight")),
    _step66;
  try {
    for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
      var _t110 = _step66.value;
      _t110.remove();
    }
  } catch (err) {
    _iterator66.e(err);
  } finally {
    _iterator66.f();
  }
  if (!e.hasFocus()) return;
  var t = e.model;
  if (t.selectionIsCollapsed) {
    setTimeout(function () {
      return Qr(e);
    }, 32);
    var _i92 = t.at(t.position);
    for (; _i92 && (!_i92.containsCaret || !_i92.displayContainsHighlight);) _i92 = _i92.parent;
    if ((null == _i92 ? void 0 : _i92.containsCaret) && _i92.displayContainsHighlight) {
      var _t107 = Mr(e, Lr(e, _i92));
      if (_t107) {
        var _i93 = document.createElement("div");
        _i93.classList.add("ML__contains-highlight"), _i93.style.position = "absolute", _i93.style.left = "".concat(_t107.left, "px"), _i93.style.top = "".concat(_t107.top, "px"), _i93.style.width = "".concat(Math.ceil(_t107.right - _t107.left), "px"), _i93.style.height = "".concat(Math.ceil(_t107.bottom - _t107.top - 1), "px"), e.field.insertBefore(_i93, e.field.childNodes[0]);
      }
    }
  } else {
    var _iterator67 = _createForOfIteratorHelper(function (e) {
        var t = [];
        var _iterator68 = _createForOfIteratorHelper(e),
          _step68;
        try {
          for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
            var _i94 = _step68.value;
            var _e126 = !1;
            var _iterator70 = _createForOfIteratorHelper(t),
              _step70;
            try {
              for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
                var _r29 = _step70.value;
                if (_i94.left === _r29.left && _i94.right === _r29.right && _i94.top === _r29.top && _i94.bottom === _r29.bottom) {
                  _e126 = !0;
                  break;
                }
              }
            } catch (err) {
              _iterator70.e(err);
            } finally {
              _iterator70.f();
            }
            _e126 || t.push(_i94);
          }
        } catch (err) {
          _iterator68.e(err);
        } finally {
          _iterator68.f();
        }
        var _iterator69 = _createForOfIteratorHelper(e),
          _step69;
        try {
          for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
            var _i95 = _step69.value;
            var _r30 = 0;
            var _iterator71 = _createForOfIteratorHelper(e),
              _step71;
            try {
              for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
                var _t108 = _step71.value;
                if (_i95.left >= _t108.left && _i95.right <= _t108.right && _i95.top >= _t108.top && _i95.bottom <= _t108.bottom && (_r30 += 1, _r30 > 1)) break;
              }
            } catch (err) {
              _iterator71.e(err);
            } finally {
              _iterator71.f();
            }
            1 === _r30 && t.push(_i95);
          }
        } catch (err) {
          _iterator69.e(err);
        } finally {
          _iterator69.f();
        }
        return t;
      }(Cr(e, {
        excludeAtomsWithBackground: !0
      }))),
      _step67;
    try {
      for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
        var _t109 = _step67.value;
        var _i96 = document.createElement("div");
        _i96.classList.add("ML__selection"), _i96.style.position = "absolute", _i96.style.left = "".concat(_t109.left, "px"), _i96.style.top = "".concat(_t109.top, "px"), _i96.style.width = "".concat(Math.ceil(_t109.right - _t109.left), "px"), _i96.style.height = "".concat(Math.ceil(_t109.bottom - _t109.top - 1), "px"), e.field.insertBefore(_i96, e.field.childNodes[0]);
      }
    } catch (err) {
      _iterator67.e(err);
    } finally {
      _iterator67.f();
    }
  }
}
function on(e, t) {
  return e[0] === t[0] && e[1] === t[1] ? "equal" : "different";
}
function sn(e) {
  var t = 1 / 0,
    i = -1 / 0;
  var _iterator72 = _createForOfIteratorHelper(e.ranges),
    _step72;
  try {
    for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
      var _r31 = _step72.value;
      t = Math.min(t, _r31[0], _r31[1]), i = Math.max(i, _r31[0], _r31[1]);
    }
  } catch (err) {
    _iterator72.e(err);
  } finally {
    _iterator72.f();
  }
  return [t, i];
}
var ln = function ln(e, t, i) {
  return fi.some(function (e) {
    return t.startsWith(e[0]) && t.endsWith(e[1]);
  }) || (t = "\\begin{equation*} ".concat(t, " \\end{equation*}")), t;
};
var cn = /*#__PURE__*/function () {
  function cn(e) {
    _classCallCheck(this, cn);
    cn._registry[e] = this;
  }
  _createClass(cn, [{
    key: "onPaste",
    value: function onPaste(e, t) {
      return !1;
    }
  }, {
    key: "insert",
    value: function insert(e, t, i) {
      return !1;
    }
  }], [{
    key: "onPaste",
    value: function onPaste(e, t, i) {
      return cn._registry[e].onPaste(t, i);
    }
  }, {
    key: "onCopy",
    value: function onCopy(e, t) {
      if (!t.clipboardData) return;
      var i = e.model,
        r = i.selectionIsCollapsed ? [0, i.lastOffset] : sn(i.selection),
        n = i.getAtoms(r);
      if (n.every(function (e) {
        return "text" === e.mode || !e.mode;
      })) t.clipboardData.setData("text/plain", n.filter(function (e) {
        return e instanceof Ct;
      }).map(function (e) {
        return e.value;
      }).join(""));else if (n.every(function (e) {
        return "latex" === e.mode;
      })) t.clipboardData.setData("text/plain", i.getAtoms(r, {
        includeChildren: !0
      }).map(function (e) {
        var t;
        return null !== (t = e.value) && void 0 !== t ? t : "";
      }).join(""));else {
        var _a16 = "";
        1 === n.length && n[0].verbatimLatex && (_a16 = n[0].verbatimLatex), _a16 || (_a16 = i.getValue(r, "latex-expanded")), t.clipboardData.setData("application/x-latex", _a16), t.clipboardData.setData("text/plain", e.options.onExport(e, _a16, r));
        var _o16 = i.getValue(r, "math-json");
        _o16 && t.clipboardData.setData("application/json", _o16);
        var _s11 = i.getValue(r, "math-ml");
        _s11 && t.clipboardData.setData("application/mathml+xml", _s11);
      }
      t.preventDefault();
    }
  }, {
    key: "insert",
    value: function insert(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      return cn._registry[e].insert(t, i, r);
    }
  }]);
  return cn;
}();
function un(e) {
  var t;
  "function" != typeof (null === (t = e.listeners) || void 0 === t ? void 0 : t.onSelectionDidChange) || e.suppressChangeNotifications || (e.suppressChangeNotifications = !0, e.listeners.onSelectionDidChange(e), e.suppressChangeNotifications = !1);
}
function dn(e) {
  var t;
  "function" != typeof (null === (t = e.listeners) || void 0 === t ? void 0 : t.onContentDidChange) || e.suppressChangeNotifications || (e.suppressChangeNotifications = !0, e.listeners.onContentDidChange(e), e.suppressChangeNotifications = !1);
}
function hn(e) {
  var t, i;
  var r = e.atoms.find(function (e) {
    return e instanceof Pr;
  });
  return r && null !== (i = null === (t = r.body) || void 0 === t ? void 0 : t.filter(function (e) {
    return e instanceof $r;
  })) && void 0 !== i ? i : [];
}
function pn(e, t) {
  var i;
  var r = 0,
    n = !1;
  var a = Number.isFinite(null == t ? void 0 : t.before) ? null !== (i = null == t ? void 0 : t.before) && void 0 !== i ? i : 0 : e.lastOffset;
  for (; r <= a && !n;) {
    var _t111 = e.at(r);
    n = _t111 instanceof $r && _t111.isSuggestion, n || r++;
  }
  if (!n) return [void 0, void 0];
  var o = r,
    s = !1;
  for (; o <= a && !s;) {
    var _t112 = e.at(o);
    s = !(_t112 instanceof $r && _t112.isSuggestion), s || o++;
  }
  return [r - 1, o - 1];
}
function mn(t, i) {
  var r;
  var n = t.model;
  var _iterator73 = _createForOfIteratorHelper(hn(n)),
    _step73;
  try {
    for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
      var _e129 = _step73.value;
      _e129.isSuggestion ? _e129.parent.removeChild(_e129) : _e129.isError = !1;
    }
  } catch (err) {
    _iterator73.e(err);
  } finally {
    _iterator73.f();
  }
  if (!n.selectionIsCollapsed) return void en(t);
  var a = [];
  var o = n.at(n.position);
  for (; o && o instanceof $r && /[a-zA-Z*]$/.test(o.value);) a.unshift(o), o = o.leftSibling;
  var s = null == o ? void 0 : o.leftSibling;
  if (o && o instanceof $r && "\\" === o.value && !(s instanceof $r && "\\" === o.value)) for (a.unshift(o), o = n.at(n.position).rightSibling; o && o instanceof $r && /[a-zA-Z*]$/.test(o.value);) a.push(o), o = o.rightSibling;
  var l = a.map(function (e) {
      return e.value;
    }).join(""),
    c = l ? function (e) {
      var t, i;
      if ("\\" === e) return [];
      var r = [];
      for (var _i97 in Ne) _i97.startsWith(e) && !Ne[_i97].infix && r.push({
        match: _i97,
        frequency: null !== (t = Ne[_i97].frequency) && void 0 !== t ? t : 0
      });
      for (var _t113 in Ce) _t113.startsWith(e) && r.push({
        match: _t113,
        frequency: null !== (i = Ce[_t113].frequency) && void 0 !== i ? i : 0
      });
      return r.sort(function (e, t) {
        var i, r;
        return e.frequency === t.frequency ? e.match.length === t.match.length ? e.match.localeCompare(t.match) : e.match.length - t.match.length : (null !== (i = t.frequency) && void 0 !== i ? i : 0) - (null !== (r = e.frequency) && void 0 !== r ? r : 0);
      }), r;
    }(l) : [];
  if (0 === c.length) return /^\\[a-zA-Z\*]+$/.test(l) && a.forEach(function (e) {
    e.isError = !0;
  }), void en(t);
  t.suggestionIndex = null !== (r = null == i ? void 0 : i.atIndex) && void 0 !== r ? r : 0, t.suggestionIndex < 0 && (t.suggestionIndex = c.length - 1);
  var u = c[t.suggestionIndex % c.length].match;
  if (u !== l) {
    var _e127 = a[a.length - 1];
    _e127.parent.addChildrenAfter(_toConsumableArray(u.slice(l.length - u.length)).map(function (e) {
      return new $r(e, {
        isSuggestion: !0
      });
    }), _e127), rn(t);
  }
  !function (t, i, r) {
    if (!i || 0 === i.length) return void en(t);
    var n = i,
      a = function (e) {
        var t = new rt("root", {
          mode: "math"
        });
        return t.body = Ur(zt(e, {
          parseMode: "math",
          macros: Xe(),
          registers: Hr()
        })), se(re(oe(new te(t.render(new H({
          macros: Xe(),
          registers: Hr(),
          smartFence: !1
        }, {
          fontSize: 5
        }, "displaystyle")), {
          classes: "ML__base"
        }))), {
          classes: "ML__mathlive"
        }).toMarkup();
      }(i),
      o = function (t) {
        var i;
        var r = null !== (i = Yr[t]) && void 0 !== i ? i : "";
        return e(r) && (r = r.join("<br>")), r;
      }(n),
      s = function (t, i) {
        var r = [];
        if ("string" == typeof i) {
          var _t114 = Ci[i];
          e(_t114) ? r = _t114.slice() : _t114 && r.push(_t114);
        }
        var n = Fi(i),
          a = new RegExp("^" + n.replace("\\", "\\\\").replace("|", "\\|").replace("*", "\\*").replace("$", "\\$").replace("^", "\\^") + "([^*a-zA-Z]|$)");
        var _iterator74 = _createForOfIteratorHelper(t),
          _step74;
        try {
          for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
            var _e128 = _step74.value;
            a.test(Fi(_e128.command)) && r.push(_e128.key);
          }
        } catch (err) {
          _iterator74.e(err);
        } finally {
          _iterator74.f();
        }
        return r.map($i);
      }(t.keybindings, n).join("<br>");
    var l = r ? '<div class="ML__popover__prev-shortcut" role="button" aria-label="Previous suggestion"><span><span>&#x25B2;</span></span></div>' : "";
    l += '<span class="ML__popover__content" role="button">', l += '<div class="ML__popover__command">' + a + "</div>", o && (l += '<div class="ML__popover__note">' + o + "</div>"), s && (l += '<div class="ML__popover__shortcut">' + s + "</div>"), l += "</span>", l += r ? '<div class="ML__popover__next-shortcut" role="button" aria-label="Next suggestion"><span><span>&#x25BC;</span></span></div>' : "", t.popover = function (e, t) {
      return e.popover ? (e.popover.innerHTML = e.options.createHTML(t), e.popover) : (e.popover = vr("mathlive-popover-panel"), void 0 === Zr && (Zr = yi(Wr).toString(36)), Gr = si(null, Wr, Zr), Xr = si(null, li, yi(li).toString(36)), e.popover.innerHTML = e.options.createHTML(t), e.popover);
    }(t, l);
    var c = t.popover.querySelectorAll(".ML__popover__content");
    c && c.length > 0 && Nr(function (e) {
      return t.executeCommand(e);
    }, c[0], {
      default: ["complete", "accept-suggestion"]
    }), c = t.popover.querySelectorAll(".ML__popover__prev-shortcut"), c && c.length > 0 && Nr(function (e) {
      return t.executeCommand(e);
    }, c[0], "previousSuggestion"), c = t.popover.querySelectorAll(".ML__popover__next-shortcut"), c && c.length > 0 && Nr(function (e) {
      return t.executeCommand(e);
    }, c[0], "nextSuggestion"), setTimeout(function () {
      var e = wr(t.field);
      e && Jr(t, e), t.popover && (t.popover.classList.add("is-visible"), t.popoverVisible = !0);
    }, 32);
  }(t, u, c.length > 1);
}
function fn(e) {
  var _pn = pn(e, {
      before: e.position
    }),
    _pn2 = _slicedToArray(_pn, 2),
    t = _pn2[0],
    i = _pn2[1];
  if (void 0 === t || void 0 === i) return !1;
  var r = !1;
  return e.getAtoms([t, i]).forEach(function (e) {
    e.isSuggestion && (e.isSuggestion = !1, r = !0);
  }), r;
}
function gn(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "accept";
  var i = arguments.length > 2 ? arguments[2] : undefined;
  var r, n;
  en(e);
  var a = e.model.atoms.find(function (e) {
    return e instanceof Pr;
  });
  if (!a) return !1;
  if ("accept-suggestion" === t) {
    var _t115 = hn(e.model).filter(function (e) {
      return e.isSuggestion;
    });
    if (0 === _t115.length) return !1;
    var _iterator75 = _createForOfIteratorHelper(_t115),
      _step75;
    try {
      for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
        var _e130 = _step75.value;
        _e130.isSuggestion = !1;
      }
    } catch (err) {
      _iterator75.e(err);
    } finally {
      _iterator75.f();
    }
    return e.model.position = e.model.offsetOf(_t115[_t115.length - 1]), !0;
  }
  var o = hn(e.model).filter(function (e) {
      return !e.isSuggestion;
    }).map(function (e) {
      return e.value;
    }).join(""),
    s = a.leftSibling;
  return a.parent.removeChild(a), e.model.position = e.model.offsetOf(s), e.mode = null !== (r = null == i ? void 0 : i.mode) && void 0 !== r ? r : "math", "reject" === t || (cn.insert("math", e.model, o, {
    macros: e.options.macros,
    selectionMode: null !== (n = null == i ? void 0 : i.selectItem) && void 0 !== n && n ? "item" : "placeholder",
    format: "latex"
  }), e.snapshot(), e.model.announce("replacement")), !0;
}
cn._registry = {}, new ( /*#__PURE__*/function (_cn) {
  _inherits(_class4, _cn);
  var _super32 = _createSuper(_class4);
  function _class4() {
    _classCallCheck(this, _class4);
    return _super32.call(this, "latex");
  }
  _createClass(_class4, [{
    key: "createAtom",
    value: function createAtom(e, t) {
      return new $r(e);
    }
  }, {
    key: "onPaste",
    value: function onPaste(e, t) {
      if (!t.clipboardData) return !1;
      var i = t.clipboardData.getData("text/plain");
      return !!i && (e.snapshot(), this.insert(e.model, i) && rn(e), t.preventDefault(), t.stopPropagation(), !0);
    }
  }, {
    key: "insert",
    value: function insert(e, t, i) {
      i || (i = {}), i.insertionMode || (i.insertionMode = "replaceSelection"), i.selectionMode || (i.selectionMode = "placeholder");
      var r = e.suppressChangeNotifications;
      i.suppressChangeNotifications && (e.suppressChangeNotifications = !0);
      var n = e.suppressChangeNotifications;
      e.suppressChangeNotifications = !0, "replaceSelection" !== i.insertionMode || e.selectionIsCollapsed ? "replaceAll" === i.insertionMode ? (e.root.setChildren([], "body"), e.position = 0) : "insertBefore" === i.insertionMode ? e.collapseSelection("backward") : "insertAfter" === i.insertionMode && e.collapseSelection("forward") : e.position = e.deleteAtoms(sn(e.selection));
      var a = [];
      var _iterator76 = _createForOfIteratorHelper(t),
        _step76;
      try {
        for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
          var _e131 = _step76.value;
          Ee.test(_e131) && a.push(new $r(_e131));
        }
      } catch (err) {
        _iterator76.e(err);
      } finally {
        _iterator76.f();
      }
      var o = e.at(e.position),
        s = o.parent.addChildrenAfter(a, o);
      return e.suppressChangeNotifications = n, "before" === i.selectionMode || ("item" === i.selectionMode ? e.setSelection(e.anchor, e.offsetOf(s)) : s && (e.position = e.offsetOf(s))), dn(e), e.suppressChangeNotifications = r, !0;
    }
  }]);
  return _class4;
}(cn))();
var yn = {};
function bn(e, t) {
  t = null != t ? t : {
    target: "mathfield",
    canUndo: !1
  };
  for (var _i98 = 0, _Object$keys8 = Object.keys(e); _i98 < _Object$keys8.length; _i98++) {
    var _i99 = _Object$keys8[_i98];
    yn[_i99] = _objectSpread(_objectSpread({}, t), {}, {
      fn: e[_i99]
    });
  }
}
function vn(t) {
  var i;
  var r;
  return r = e(t) ? t[0] : t, r = r.replace(/-\w/g, function (e) {
    return e[1].toUpperCase();
  }), null === (i = yn[r]) || void 0 === i ? void 0 : i.target;
}
bn({
  performWithFeedback: function performWithFeedback(e, t) {
    return function (e, t) {
      var i, r, n;
      e.focus(), e.options.keypressVibration && Me() && navigator.vibrate(3), t = t.replace(/-\w/g, function (e) {
        return e[1].toUpperCase();
      }), "moveToNextPlaceholder" === t || "moveToPreviousPlaceholder" === t || "complete" === t ? null === (i = e.returnKeypressSound) || void 0 === i || i.play().catch(console.warn) : "deleteBackward" === t || "deleteForward" === t || "deletePreviousWord" === t || "deleteNextWord" === t || "deleteToGroupStart" === t || "deleteToGroupEnd" === t || "deleteToMathFieldStart" === t || "deleteToMathFieldEnd" === t ? null === (r = e.deleteKeypressSound) || void 0 === r || r.play().catch(console.warn) : null === (n = e.keypressSound) || void 0 === n || n.play().catch(console.warn);
      var a = e.executeCommand(t);
      return e.scrollIntoView(), a;
    }(e, t);
  }
}), bn({
  complete: gn,
  nextSuggestion: function nextSuggestion(e) {
    return mn(e, {
      atIndex: e.suggestionIndex + 1
    }), !1;
  },
  previousSuggestion: function previousSuggestion(e) {
    return mn(e, {
      atIndex: e.suggestionIndex - 1
    }), !1;
  }
}, {
  target: "mathfield",
  category: "autocomplete"
});
var xn = /*#__PURE__*/function () {
  function xn(e) {
    _classCallCheck(this, xn);
    var t, i;
    this.preventOverlayClose = null !== (t = null == e ? void 0 : e.preventOverlayClose) && void 0 !== t && t, this.translucent = null !== (i = null == e ? void 0 : e.translucent) && void 0 !== i && i, this.state = "closed";
  }
  _createClass(xn, [{
    key: "element",
    get: function get() {
      if (this._element) return this._element;
      var e = document.createElement("div");
      return e.setAttribute("role", "presentation"), e.style.position = "fixed", e.style.contain = "content", e.style.top = "0", e.style.left = "0", e.style.right = "0", e.style.bottom = "0", e.style.zIndex = "var(--scrim-zindex, 10099)", e.style.outline = "none", this.translucent ? (e.style.background = "rgba(255, 255, 255, .2)", e.style.backdropFilter = "contrast(40%)") : e.style.background = "transparent", this._element = e, e;
    }
  }, {
    key: "open",
    value: function open(e) {
      var t;
      if ("closed" !== this.state) return;
      this.state = "opening", this.savedActiveElement = function () {
        var e;
        var t = document.activeElement;
        for (; null === (e = null == t ? void 0 : t.shadowRoot) || void 0 === e ? void 0 : e.activeElement;) t = t.shadowRoot.activeElement;
        return t;
      }();
      var i = this.element;
      (null !== (t = null == e ? void 0 : e.root) && void 0 !== t ? t : document.body).appendChild(i), i.addEventListener("click", this), document.addEventListener("touchmove", this, !1), document.addEventListener("scroll", this, !1);
      var r = window.innerWidth - document.documentElement.clientWidth;
      this.savedMarginRight = document.body.style.marginRight, this.savedOverflow = document.body.style.overflow, document.body.style.overflow = "hidden";
      var n = Number.parseFloat(getComputedStyle(document.body).marginRight);
      document.body.style.marginRight = "".concat(n + r, "px"), (null == e ? void 0 : e.child) && i.append(e.child), this.state = "open";
    }
  }, {
    key: "close",
    value: function close() {
      var e, t, i, r;
      if ("open" !== this.state) return;
      this.state = "closing", "function" == typeof this.onClose && this.onClose();
      var n = this.element;
      n.removeEventListener("click", this), document.removeEventListener("touchmove", this, !1), document.removeEventListener("scroll", this, !1), n.remove(), document.body.style.overflow = null !== (e = this.savedOverflow) && void 0 !== e ? e : "", document.body.style.marginRight = null !== (t = this.savedMarginRight) && void 0 !== t ? t : "", document.activeElement !== this.savedActiveElement && (null === (r = null === (i = this.savedActiveElement) || void 0 === i ? void 0 : i.focus) || void 0 === r || r.call(i)), n.innerHTML = "", this.state = "closed";
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      this.preventOverlayClose || (e.target === this._element && "click" === e.type ? (this.close(), e.preventDefault(), e.stopPropagation()) : e.target !== document || "touchmove" !== e.type && "scroll" !== e.type || (this.close(), e.preventDefault(), e.stopPropagation()));
    }
  }]);
  return xn;
}();
var kn,
  wn = null;
function _n() {
  we();
  var e = document.querySelector("#mathlive-alternate-keys-panel");
  return e && (e.classList.remove("is-visible"), e.innerHTML = ""), null == wn || wn.close(), !1;
}
var Mn = /*#__PURE__*/function () {
  function Mn(e, t) {
    _classCallCheck(this, Mn);
    this.options = e, this.visible = !1, this._mathfield = t, this.coreStylesheet = null, this.virtualKeyboardStylesheet = null;
  }
  _createClass(Mn, [{
    key: "setOptions",
    value: function setOptions(e) {
      var t;
      this.visible = !1, null === (t = this._element) || void 0 === t || t.remove(), this._element = void 0, this.options = e;
    }
  }, {
    key: "element",
    get: function get() {
      return this._element;
    },
    set: function set(e) {
      var t;
      null === (t = this._element) || void 0 === t || t.remove(), this._element = e;
    }
  }, {
    key: "visible",
    get: function get() {
      return this._visible;
    },
    set: function set(e) {
      this._visible = e;
    }
  }, {
    key: "height",
    get: function get() {
      var e, t;
      return null !== (t = null === (e = this.element) || void 0 === e ? void 0 : e.offsetHeight) && void 0 !== t ? t : 0;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (this.element) switch (e.type) {
        case "mouseup":
        case "blur":
        case "touchend":
        case "touchcancel":
          document.body.style.userSelect = "", Tn(this);
      }
    }
  }, {
    key: "focusMathfield",
    value: function focusMathfield() {
      var e, t;
      null === (t = null === (e = this._mathfield) || void 0 === e ? void 0 : e.focus) || void 0 === t || t.call(e);
    }
  }, {
    key: "blurMathfield",
    value: function blurMathfield() {
      var e, t;
      null === (t = null === (e = this._mathfield) || void 0 === e ? void 0 : e.blur) || void 0 === t || t.call(e);
    }
  }, {
    key: "stateChanged",
    value: function stateChanged() {
      var e, t;
      null === (t = null === (e = this._mathfield) || void 0 === e ? void 0 : e.element) || void 0 === t || t.dispatchEvent(new Event("virtual-keyboard-toggle", {
        bubbles: !0,
        cancelable: !1,
        composed: !0
      }));
    }
  }, {
    key: "executeCommand",
    value: function executeCommand(t) {
      var _yn$a;
      var i, r, n;
      var a,
        o = [];
      return e(t) ? (a = t[0], o = t.slice(1)) : a = t, a = a.replace(/-\w/g, function (e) {
        return e[1].toUpperCase();
      }), "virtual-keyboard" === (null === (i = yn[a]) || void 0 === i ? void 0 : i.target) ? (_yn$a = yn[a]).fn.apply(_yn$a, [this].concat(_toConsumableArray(o))) : null !== (n = null === (r = this._mathfield) || void 0 === r ? void 0 : r.executeCommand(t)) && void 0 !== n && n;
    }
  }, {
    key: "create",
    value: function create() {
      kn || (kn = yi(zr).toString(36)), this.virtualKeyboardStylesheet = this.virtualKeyboardStylesheet = si(null, zr, kn), this.coreStylesheet = si(null, li, yi(li).toString(36)), oi(this.options.fontsDirectory);
    }
  }, {
    key: "enable",
    value: function enable() {
      window.addEventListener("mouseup", this), window.addEventListener("blur", this), window.addEventListener("touchend", this), window.addEventListener("touchcancel", this);
    }
  }, {
    key: "disable",
    value: function disable() {
      var e, t, i;
      window.removeEventListener("mouseup", this), window.removeEventListener("blur", this), window.removeEventListener("touchend", this), window.removeEventListener("touchcancel", this), _n(), this.visible = !1, null === (e = this.coreStylesheet) || void 0 === e || e.release(), this.coreStylesheet = null, null === (t = this.virtualKeyboardStylesheet) || void 0 === t || t.release(), this.virtualKeyboardStylesheet = null, null === (i = this._element) || void 0 === i || i.remove(), this._element = void 0;
    }
  }, {
    key: "dispose",
    value: function dispose() {}
  }]);
  return Mn;
}();
var Sn = {
    numeric: {
      tooltip: "keyboard.tooltip.numeric",
      layer: "math",
      label: "123",
      layers: ["math"]
    },
    roman: {
      tooltip: "keyboard.tooltip.roman",
      layer: "lower-roman",
      label: "ABC",
      layers: ["lower-roman", "upper-roman"]
    },
    greek: {
      tooltip: "keyboard.tooltip.greek",
      layer: "lower-greek",
      label: "&alpha;&beta;&gamma;",
      classes: "tex-math",
      layers: ["lower-greek", "upper-greek"]
    },
    functions: {
      tooltip: "keyboard.tooltip.functions",
      layer: "functions",
      label: "<i>f</i>&thinsp;()",
      classes: "tex",
      layers: ["functions"]
    },
    symbols: {
      tooltip: "keyboard.tooltip.symbols",
      layer: "symbols",
      label: "&infin;\u2260\u2208",
      classes: "tex",
      layers: ["symbols"]
    },
    latex: {
      tooltip: "keyboard.tooltip.command",
      command: ["switchMode", "latex"],
      label: "<svg class=\"svg-glyph\"><use xlink:href='#svg-command' /></svg>",
      layers: ["latex-lower", "latex-upper", "latex-symbols"]
    },
    style: {
      tooltip: "keyboard.tooltip.style",
      layer: "style",
      label: "<b>b</b><i>i</i>\uD835\uDD39"
    }
  },
  Ln = {
    "\\varphi ": ["&Phi;", "\\Phi "],
    "\\varsigma ": ["&Sigma;", "\\Sigma "],
    "\\epsilon ": ["&#x0190;", '{\\char"0190}'],
    "\\rho ": ["&#x3A1", '{\\char"3A1}'],
    "\\tau ": ["&#x3A4;", '{\\char"3A4}'],
    "\\upsilon ": ["&Upsilon;", "\\Upsilon "],
    "\\theta ": ["&Theta;", "\\Theta "],
    "\\iota ": ["&Iota;", '{\\char"399}'],
    "\\omicron ": ["&#x039F;", '{\\char"39F}'],
    "\\pi ": ["&Pi;", "\\Pi "],
    "\\alpha ": ["&Alpha;", '{\\char"391}'],
    "\\sigma ": ["&Sigma;", "\\Sigma "],
    "\\delta ": ["&Delta;", "\\Delta "],
    "\\phi ": ["&#x03a6;", "\\Phi "],
    "\\gamma ": ["&Gamma;", "\\Gamma "],
    "\\eta ": ["&Eta;", '{\\char"397}'],
    "\\xi ": ["&Xi;", "\\Xi "],
    "\\kappa ": ["&Kappa;", '{\\char"39A}'],
    "\\lambda ": ["&Lambda;", "\\Lambda "],
    "\\zeta ": ["&Zeta;", '{\\char"396}'],
    "\\chi ": ["&Chi;", '{\\char"3A7}'],
    "\\psi ": ["&Psi;", "\\Psi "],
    "\\omega ": ["&Omega;", "\\Omega "],
    "\\beta ": ["&Beta;", '{\\char"392}'],
    "\\nu ": ["&Nu;", '{\\char"39D}'],
    "\\mu ": ["&Mu;", '{\\char"39C}']
  },
  Cn = {
    0: ["\\emptyset", "\\varnothing", "\\infty", {
      latex: "#?_0",
      insert: "#@_0"
    }, "\\circ", "\\bigcirc", "\\bullet"],
    2: ["\\frac{1}{2}", {
      latex: "#?^2",
      insert: "#@^2"
    }],
    3: ["\\frac{1}{3}", {
      latex: "#?^3",
      insert: "#@^3"
    }],
    ".": [",", ";", "\\colon", {
      latex: ":",
      aside: "ratio"
    }, {
      latex: "\\cdotp",
      aside: "center dot",
      class: "box"
    }, {
      latex: "\\cdots",
      aside: "center ellipsis",
      class: "box"
    }, {
      latex: "\\ldotp",
      aside: "low dot",
      class: "box"
    }, {
      latex: "\\ldots",
      aside: "low ellipsis",
      class: "box"
    }, {
      latex: "\\vdots",
      aside: "",
      class: "box"
    }, {
      latex: "\\ddots",
      aside: "",
      class: "box"
    }, "\\odot", "\\oslash", "\\circledcirc"],
    "*": ["\\cdot", "\\ast", "\\star", "\\bigstar", "\\ltimes", "\\rtimes", "\\rightthreetimes", "\\leftthreetimes", "\\intercal", "\\prod", {
      latex: "\\prod_{n\\mathop=0}^{\\infty}",
      class: "small"
    }],
    "+": ["\\pm", "\\mp", "\\sum", {
      latex: "\\sum_{n\\mathop=0}^{\\infty}",
      class: "small"
    }, "\\dotplus", "\\oplus"],
    "-": ["\\pm", "\\mp", "\\ominus", "\\vert #0  \\vert"],
    "/": ["\\divideontimes", "/", "\\div", "\\%"],
    "(": ["\\left( #0\\right)", "\\left[ #0\\right]", "\\left\\{ #0\\right\\}", "\\left\\langle #0\\right\\rangle", "\\lfloor", "\\llcorner", "(", "\\lbrack", "\\lvert", "\\lVert", "\\lgroup", "\\langle", "\\lceil", "\\ulcorner", "\\lmoustache", "\\lbrace"],
    ")": ["\\rfloor", "\\lrcorner", ")", "\\rbrack", "\\rvert", "\\rVert", "\\rgroup", "\\rangle", "\\rceil", "\\urcorner", "\\rmoustache", "\\rbrace"],
    "=": ["\\cong", "\\asymp", "\\equiv", "\\differencedelta", "\\varpropto", "\\thickapprox", "\\approxeq", "\\thicksim", "\\backsim", "\\eqsim", "\\simeq", "\\Bumpeq", "\\bumpeq", "\\doteq", "\\Doteq", "\\fallingdotseq", "\\risingdotseq", "\\coloneq", "\\eqcirc", "\\circeq", "\\triangleq", "\\between"],
    "!=": ["\\neq", "\\ncong", "", "\\nsim"],
    "<": ["\\leq", "\\leqq", "\\lneqq", "\\ll", "\\lessgtr", "\\nless", "\\nleq", "\\lesssim", "\\precsim", "\\prec", "\\nprec", "\\preccurlyeq", "\\lessdot"],
    ">": ["\\geq", "\\geqq", "\\gneqq", "\\gg", "\\gtrless", "\\ngtr", "\\ngeq", "\\gtrsim", "\\succsim", "\\succ", "\\nsucc", "\\succcurlyeq", "\\gtrdot"],
    in: ["\\owns"],
    "!in": ["\\backepsilon"],
    subset: ["\\subseteq", "\\nsubset", "\\nsubseteq"],
    superset: ["\\supseteq", "\\nsupset", "\\nsupseteq"],
    infinity: ["\\aleph_0", "\\aleph_1", "\\omega", "\\mathfrak{m}"],
    "numeric-pi": ["\\prod", "\\theta", "\\rho", "\\sin", "\\cos", "\\tan"],
    ee: ["\\times 10^{#?}", "\\ln", "\\ln_{10}", "\\log"],
    "^": ["_{#?}"],
    int: [{
      latex: "\\int_{#?}^{#?}",
      class: "small"
    }, {
      latex: "\\int",
      class: "small"
    }, {
      latex: "\\smallint",
      class: "small"
    }, {
      latex: "\\iint",
      class: "small"
    }, {
      latex: "\\iiint",
      class: "small"
    }, {
      latex: "\\oint",
      class: "small"
    }, {
      latex: "\\dfrac{\\rd}{\\rd x}",
      class: "small"
    }, {
      latex: "\\frac{\\partial}{\\partial x}",
      class: "small"
    }, "\\capitalDifferentialD", "\\rd", "\\partial"],
    nabla: ["\\nabla\\times", "\\nabla\\cdot", "\\nabla^{2}"],
    "!": ["!!", "\\Gamma", "\\Pi"],
    accents: ["\\bar{#@}", "\\vec{#@}", "\\hat{#@}", "\\check{#@}", "\\dot{#@}", "\\ddot{#@}", "\\mathring{#@}", "\\breve{#@}", "\\acute{#@}", "\\tilde{#@}", "\\grave{#@}"],
    underline: ["\\underbrace{#@}", "\\underlinesegment{#@}", "\\underleftrightarrow{#@}", "\\underrightarrow{#@}", "\\underleftarrow{#@}", "\\undergroup{#@}"],
    overline: ["\\overbrace{#@}", "\\overlinesegment{#@}", "\\overleftrightarrow{#@}", "\\overrightarrow{#@}", "\\overleftarrow{#@}", "\\overgroup{#@}"],
    xleftarrows: ["\\xlongequal{}", "\\xleftrightarrow{}", "\\xLeftrightarrow{}", "\\xleftrightharpoons{}", "\\xLeftarrow{}", "\\xleftharpoonup{}", "\\xleftharpoondown{}", "\\xtwoheadleftarrow{}", "\\xhookleftarrow{}", "\\xtofrom{}", "\\xleftequilibrium{}", "\\xrightleftarrows{}"],
    xrightarrows: ["\\xlongequal{}", "\\xleftrightarrow{}", "\\xLeftrightarrow{}", "\\xleftrightharpoons{}", "\\xRightarrow{}", "\\xrightharpoonup{}", "\\xrightharpoondown{}", "\\xtwoheadrightarrow{}", "\\xrightleftharpoons{}", "\\xhookrightarrow{}", "\\xmapsto{}", "\\xrightequilibrium{}", "\\xrightleftarrows{}"],
    A: [{
      latex: "\\aleph",
      aside: "aleph"
    }, {
      latex: "\\forall",
      aside: "for all"
    }],
    a: [{
      latex: "\\aleph",
      aside: "aleph"
    }, {
      latex: "\\forall",
      aside: "for all"
    }],
    b: [{
      latex: "\\beth",
      aside: "beth"
    }],
    B: [{
      latex: "\\beth",
      aside: "beth"
    }],
    c: [{
      latex: "\\C",
      aside: "set of complex numbers"
    }],
    d: [{
      latex: "\\daleth",
      aside: "daleth"
    }],
    D: [{
      latex: "\\daleth",
      aside: "daleth"
    }],
    e: [{
      latex: "\\exponentialE",
      aside: "exponential e"
    }, {
      latex: "\\exists",
      aside: "there is"
    }, {
      latex: "\\nexists",
      aside: "there isn\u2019t"
    }],
    g: [{
      latex: "\\gimel",
      aside: "gimel"
    }],
    G: [{
      latex: "\\gimel",
      aside: "gimel"
    }],
    h: [{
      latex: "\\hbar",
      aside: "h bar"
    }, {
      latex: "\\hslash",
      aside: "h slash"
    }],
    i: [{
      latex: "\\imaginaryI",
      aside: "imaginary i"
    }],
    j: [{
      latex: "\\imaginaryJ",
      aside: "imaginary j"
    }],
    l: [{
      latex: "\\ell",
      aside: "ell"
    }],
    n: [{
      latex: "\\N",
      aside: "set of natural numbers"
    }],
    p: [{
      latex: "\\P",
      aside: "set of primes"
    }],
    q: [{
      latex: "\\Q",
      aside: "set of rational numbers"
    }],
    r: [{
      latex: "\\R",
      aside: "set of real numbers"
    }],
    z: [{
      latex: "\\Z",
      aside: "set of integers"
    }],
    "x-var": ["y", "z", "t", "r", {
      latex: "f(#?)",
      class: "small"
    }, {
      latex: "g(#?)",
      class: "small"
    }, "x^2", "x^n", "x_n", "x_{n+1}", "x_i", "x_{i+1}"],
    "n-var": ["i", "j", "p", "k", "a", "u"],
    ii: ["\\Re", "\\Im", "\\imaginaryJ", "\\Vert #0 \\Vert"],
    logic: [{
      latex: "\\exists",
      aside: "there is"
    }, {
      latex: "\\nexists",
      aside: "there isn\u2019t"
    }, {
      latex: "\\ni",
      aside: "such that"
    }, {
      latex: "\\Colon",
      aside: "such that"
    }, {
      latex: "\\implies",
      aside: "implies"
    }, {
      latex: "\\impliedby",
      aside: "implied by"
    }, {
      latex: "\\iff",
      aside: "if and only if"
    }, {
      latex: "\\land",
      aside: "and"
    }, {
      latex: "\\lor",
      aside: "or"
    }, {
      latex: "\\oplus",
      aside: "xor"
    }, {
      latex: "\\lnot",
      aside: "not"
    }, {
      latex: "\\downarrow",
      aside: "nor"
    }, {
      latex: "\\uparrow",
      aside: "nand"
    }, {
      latex: "\\curlywedge",
      aside: "nor"
    }, {
      latex: "\\bar\\curlywedge",
      aside: "nand"
    }, {
      latex: "\\therefore",
      aside: "therefore"
    }, {
      latex: "\\because",
      aside: "because"
    }, {
      latex: "^\\biconditional",
      aside: "biconditional"
    }, "\\leftrightarrow", "\\Leftrightarrow", "\\to", "\\models", "\\vdash", "\\gets", "\\dashv", "\\roundimplies"],
    "set-operators": ["\\cap", "\\cup", "\\setminus", "\\smallsetminus", "\\complement"],
    "set-relations": ["\\in", "\\notin", "\\ni", "\\owns", "\\subset", "\\supset", "\\subseteq", "\\supseteq", "\\subsetneq", "\\supsetneq", "\\varsubsetneq", "\\subsetneqq", "\\nsubset", "\\nsupset", "\\nsubseteq", "\\nsupseteq"],
    space: [{
      latex: '\\char"203A\\!\\char"2039',
      insert: "\\!",
      aside: "negative thin space<br>\u207B\xB3\u29F8\u2081\u2088 em"
    }, {
      latex: "\\unicode{\"203A}\\,\\unicode{\"2039}",
      insert: "\\,",
      aside: "thin space<br>\xB3\u29F8\u2081\u2088 em"
    }, {
      latex: "\\unicode{\"203A}\\:\\unicode{\"2039}",
      insert: "\\:",
      aside: "medium space<br>\u2074\u29F8\u2081\u2088 em"
    }, {
      latex: "\\unicode{\"203A}\\;\\unicode{\"2039}",
      insert: "\\;",
      aside: "thick space<br>\u2075\u29F8\u2081\u2088 em"
    }, {
      latex: "\\unicode{\"203A}\\ \\unicode{\"2039}",
      insert: "\\ ",
      aside: "\u2153 em"
    }, {
      latex: "\\unicode{\"203A}\\enspace\\unicode{\"2039}",
      insert: "\\enspace",
      aside: "\xbd em"
    }, {
      latex: "\\unicode{\"203A}\\quad\\unicode{\"2039}",
      insert: "\\quad",
      aside: "1 em"
    }, {
      latex: "\\unicode{\"203A}\\qquad\\unicode{\"2039}",
      insert: "\\qquad",
      aside: "2 em"
    }],
    delete: [{
      label: '<span class="warning"><svg class="svg-glyph"><use xlink:href="#svg-trash" /></svg></span>',
      command: "deleteAll"
    }],
    "->|": []
  };
var An = {};
var Nn = {
  math: "\n        <div class='rows'>\n            <ul>\n                <li class='keycap tex' data-alt-keys='x-var'><i>x</i></li>\n                <li class='keycap tex' data-alt-keys='n-var'><i>n</i></li>\n                <li class='separator w5'></li>\n                <row name='numpad-1'/>\n                <li class='separator w5'></li>\n                <li class='keycap tex' data-latex='\\exponentialE' data-alt-keys='ee'>e</li>\n                <li class='keycap tex' data-latex='\\imaginaryI' data-alt-keys='ii'>i</li>\n                <li class='keycap tex' data-latex='\\pi' data-alt-keys='numeric-pi'></li>\n            </ul>\n            <ul>\n                <li class='keycap tex' data-key='<' data-alt-keys='<'>&lt;</li>\n                <li class='keycap tex' data-key='>' data-alt-keys='>'>&gt;</li>\n                <li class='separator w5'></li>\n                <row name='numpad-2'/>\n                <li class='separator w5'></li>\n                <li class='keycap tex' data-latex='#@^{2}' data-latex='x^2'></li>\n                <li class='keycap tex' data-alt-keys='^' data-insert='#@^{#?}' data-latex='x^\\placeholder'></li>\n                <li class='keycap tex small' data-insert='\\sqrt{#0}' data-latex='\\sqrt{#0}'></li>\n            </ul>\n            <ul>\n                <li class='keycap tex' data-alt-keys='(' >(</li>\n                <li class='keycap tex' data-alt-keys=')' >)</li>\n                <li class='separator w5'></li>\n                <row name='numpad-3'/>\n                <li class='separator w5'></li>\n                <li class='keycap small' data-alt-keys='int' data-latex='\\int_0^\\infty'></li>\n                <li class='keycap' data-latex='\\forall' data-alt-keys='logic' ></li>\n                <li class='action font-glyph bottom right' data-alt-keys='delete' data-command='[\"performWithFeedback\",\"deleteBackward\"]'>&#x232b;</li></ul>\n            </ul>\n            <ul>\n                <li class='keycap' data-alt-keys='foreground-color' data-command='[\"applyStyle\",{\"color\":\"red\"}]'><span style='border-radius: 50%;width:22px;height:22px; border: 3px solid #cc2428; box-sizing: border-box'></span></li>\n                <li class='keycap' data-alt-keys='background-color' data-command='[\"applyStyle\",{\"backgroundColor\":\"yellow\"}]'><span style='border-radius: 50%;width:22px;height:22px; background:#fff590; box-sizing: border-box'></span></li>\n                <li class='separator w5'></li>\n                <row name='numpad-4'/>\n                <li class='separator w5'></li>\n                <arrows/>\n            </ul>\n        </div>\n    ",
  "lower-roman": "\n        <div class='rows'>\n            <ul>\n                <row name='numpad-1' class='if-wide'/>\n                <row name='lower-1' shift-layer='upper-roman'/>\n            </ul>\n            <ul>\n                <row name='numpad-2' class='if-wide'/>\n                <row name='lower-2'  shift-layer='upper-roman''/>\n            </ul>\n            <ul>\n                <row name='numpad-3' class='if-wide'/>\n                <row name='lower-3'  shift-layer='upper-roman''/>\n            </ul>\n            <ul>\n                <row name='numpad-4' class='if-wide'/>\n                <li class='keycap' >;</li>\n                <li class='keycap' >,</li>\n                <li class='keycap w50' data-key=' ' data-alt-keys='space'>&nbsp;</li>\n                <arrows/>\n            </ul>\n        </div>",
  "upper-roman": "\n        <div class='rows'>\n            <ul>\n                <row name='numpad-1' class='if-wide'/>\n                <row name='upper-1'  shift-layer='lower-roman'/>\n            </ul>\n            <ul>\n                <row name='numpad-2' class='if-wide'/>\n                <row name='upper-2' shift-layer='lower-roman'/>\n            </ul>\n            <ul>\n                <row name='numpad-3' class='if-wide'/>\n                <row name='upper-3' shift-layer='lower-roman'/>\n            </ul>\n            <ul>\n                <row name='numpad-4' class='if-wide'/>\n                <li class='keycap' >;</li>\n                <li class='keycap' data-alt-keys='.'>;</li>\n                <li class='keycap w50' data-key=' '>&nbsp;</li>\n                <arrows/>\n            </ul>\n        </div>",
  symbols: "\n        <div class='rows'>\n            <ul>\n                <row name='numpad-1' class='if-wide'/>\n                <li class='keycap tex' data-alt-keys='(' data-insert='\\lbrace '>{</li>\n                <li class='keycap tex' data-alt-keys=')' data-insert='\\rbrace '>}</li>\n                <li class='separator w5'></li>\n                <li class='keycap tex' data-alt-keys='in' data-insert='\\in '>&#x2208;</li>\n                <li class='keycap tex' data-alt-keys='!in' data-insert='\\notin '>&#x2209;</li>\n                <li class='keycap tex' data-insert='\\Re '>&#x211c;<aside>Real</aside></li>\n                <li class='keycap tex' data-insert='\\Im '>&#x2111;<aside>Imaginary</aside></li>\n                <li class='keycap w15' data-insert='\\ulcorner#0\\urcorner '><span><sup>&#x250c;</sup><span><span style='color:#ddd'>o</span><sup>&#x2510;</sup></span><aside>ceil</aside></li>\n                <li class='keycap tex' data-alt-keys='nabla' data-insert='\\nabla '>&#x2207;<aside>nabla</aside></li>\n                <li class='keycap tex' data-alt-keys='infinity' data-insert='\\infty '>&#x221e;</li>\n\n            </ul>\n            <ul>\n                <row name='numpad-2' class='if-wide'/>\n                <li class='keycap tex' data-alt-keys='(' data-insert='\\lbrack '>[</li>\n                <li class='keycap tex' data-alt-keys=')' data-insert='\\rbrack '>]</li>\n                <li class='separator w5'></li>\n                <li class='keycap tex' data-alt-keys='subset' data-insert='\\subset '>&#x2282;</li>\n                <li class='keycap tex' data-alt-keys='superset' data-insert='\\supset '>&#x2283;</li>\n                <li class='keycap tex' data-key='!' data-alt-keys='!'>!<aside>factorial</aside></li>\n                <li class='keycap' data-latex='^{\\prime} '><span><sup><span><span style='color:#ddd'>o</span>&#x2032</sup></span><aside>prime</aside></li>\n                <li class='keycap w15' data-insert='\\llcorner#0\\lrcorner '><span><sub>&#x2514;</sub><span style='color:#ddd'>o</span><sub>&#x2518;</sub></span><aside>floor</aside></li>\n                <li class='keycap tex' data-insert='\\partial '>&#x2202;<aside>partial<br>derivative</aside></li>\n                <li class='keycap tex' data-insert='\\emptyset '>&#x2205;<aside>empty set</aside></li>\n\n            </ul>\n            <ul>\n                <row name='numpad-3' class='if-wide'/>\n                <li class='keycap tex' data-alt-keys='(' data-insert='\\langle '>&#x27e8;</li>\n                <li class='keycap tex' data-alt-keys=')' data-insert='\\rangle '>&#x27e9;</li>\n                <li class='separator w5'></li>\n                <li class='keycap tex' data-alt-keys='overline' data-latex='\\overline{#?}' data-aside='overline'></li>\n                <li class='keycap tex' data-alt-keys='underline' data-latex='\\underline{#?}' data-aside='underline'></li>\n                <li class='keycap tex' data-alt-keys='accents' data-insert='\\vec{#@}' data-latex='\\vec{#?}' data-aside='vector'></li>\n                <li class='keycap tex small' data-alt-keys='xleftarrows' data-latex='\\xleftarrow{}' ></li>\n                <li class='keycap tex small' data-alt-keys='xrightarrows' data-latex='\\xrightarrow{}' ></li>\n                <li class='keycap tex' data-alt-keys='absnorm' data-insert='\\left| #0 \\right|' data-latex='\\left| #? \\right|' data-aside='abs'></li>\n\n                <li class='action font-glyph bottom right w15'\n                    data-shifted='<span class=\"warning\"><svg class=\"svg-glyph\"><use xlink:href=\"#svg-trash\" /></svg></span>'\n                    data-shifted-command='\"deleteAll\"'\n                    data-alt-keys='delete' data-command='[\"performWithFeedback\",\"deleteBackward\"]'\n                >&#x232b;</li>\n            </ul>\n            <ul>\n                <row name='numpad-4' class='if-wide'/>\n                <li class='keycap tex' data-insert=','>,</li>\n                <li class='keycap tex' data-insert='\\cdot '>&#x22c5;<aside>centered dot</aside></li>\n                <li class='keycap tex' data-insert='\\colon '>:<aside>colon</aside></li>\n                <li class='keycap tex' data-insert='\\circ '>&#x2218;<aside>circle</aside></li>\n                <li class='keycap tex' data-insert='\\approx '>&#x2248;<aside>approx.</aside></li>\n                <li class='keycap tex' data-insert='\\ne '>&#x2260;</li>\n                <li class='keycap tex' data-insert='\\pm '>&#x00b1;</li>\n                <arrows/>\n            </ul>\n        </div>",
  "lower-greek": "\n        <div class='rows'>\n            <ul><li class='keycap tex' data-insert='\\varphi '><i>&#x03c6;</i><aside>phi var.</aside></li>\n                <li class='keycap tex' data-insert='\\varsigma '><i>&#x03c2;</i><aside>sigma var.</aside></li>\n                <li class='keycap tex' data-insert='\\epsilon '><i>&#x03f5;</i></li>\n                <li class='keycap tex' data-insert='\\rho '><i>&rho;</i></li>\n                <li class='keycap tex' data-insert='\\tau '><i>&tau;</i></li>\n                <li class='keycap tex' data-insert='\\upsilon '><i>&upsilon;</i></li>\n                <li class='keycap tex' data-insert='\\theta '><i>&theta;</i></li>\n                <li class='keycap tex' data-insert='\\iota '><i>&iota;</i></li>\n                <li class='keycap tex' data-insert='\\omicron '>&omicron;</i></li>\n                <li class='keycap tex' data-insert='\\pi '><i>&pi;</i></li>\n            </ul>\n            <ul><li class='keycap tex' data-insert='\\alpha ' data-shifted='&Alpha;' data-shifted-command='[\"insert\",\"{\\\\char\\\"391}\"]'><i>&alpha;</i></li>\n                <li class='keycap tex' data-insert='\\sigma '><i>&sigma;</i></li>\n                <li class='keycap tex' data-insert='\\delta '><i>&delta;</i></li>\n                <li class='keycap tex' data-insert='\\phi '><i>&#x03d5;</i></i></li>\n                <li class='keycap tex' data-insert='\\gamma '><i>&gamma;</i></li>\n                <li class='keycap tex' data-insert='\\eta '><i>&eta;</i></li>\n                <li class='keycap tex' data-insert='\\xi '><i>&xi;</i></li>\n                <li class='keycap tex' data-insert='\\kappa '><i>&kappa;</i></li>\n                <li class='keycap tex' data-insert='\\lambda '><i>&lambda;</i></li>\n            </ul>\n            <ul><li class='shift modifier font-glyph bottom left w15 layer-switch' data-layer='upper-greek'>&#x21e7;</li>\n                <li class='keycap tex' data-insert='\\zeta '><i>&zeta;</i></li>\n                <li class='keycap tex' data-insert='\\chi '><i>&chi;</i></li>\n                <li class='keycap tex' data-insert='\\psi '><i>&psi;</i></li>\n                <li class='keycap tex' data-insert='\\omega '><i>&omega;</i></li>\n                <li class='keycap tex' data-insert='\\beta '><i>&beta;</i></li>\n                <li class='keycap tex' data-insert='\\nu '><i>&nu;</i></li>\n                <li class='keycap tex' data-insert='\\mu '><i>&mu;</i></li>\n                <li class='action font-glyph bottom right w15'\n                    data-shifted='<span class=\"warning\"><svg class=\"svg-glyph\"><use xlink:href=\"#svg-trash\" /></svg></span>'\n                    data-shifted-command='\"deleteAll\"'\n                    data-alt-keys='delete' data-command='[\"performWithFeedback\",\"deleteBackward\"]'\n                >&#x232b;</li>\n            </ul>\n            <ul>\n                <li class='keycap ' data-key=' '>&nbsp;</li>\n                <li class='keycap'>,</li>\n                <li class='keycap tex' data-insert='\\varepsilon '><i>&#x03b5;</i><aside>epsilon var.</aside></li>\n                <li class='keycap tex' data-insert='\\vartheta '><i>&#x03d1;</i><aside>theta var.</aside></li>\n                <li class='keycap tex' data-insert='\\varkappa '><i>&#x3f0;</i><aside>kappa var.</aside></li>\n                <li class='keycap tex' data-insert='\\varpi '><i>&#x03d6;<aside>pi var.</aside></i></li>\n                <li class='keycap tex' data-insert='\\varrho '><i>&#x03f1;</i><aside>rho var.</aside></li>\n                <arrows/>\n            </ul>\n        </div>",
  "upper-greek": "\n        <div class='rows'>\n            <ul><li class='keycap tex' data-insert='\\Phi '>&Phi;<aside>phi</aside></li>\n                <li class='keycap tex' data-insert='\\Sigma '>&Sigma;<aside>sigma</aside></li>\n                <li class='keycap tex' data-insert='{\\char\"0190}'>&#x0190;<aside>epsilon</aside></li>\n                <li class='keycap tex' data-insert='{\\char\"3A1}'>&#x3A1;<aside>rho</aside></li>\n                <li class='keycap tex' data-insert='{\\char\"3A4}'>&#x3A4;<aside>tau</aside></li>\n                <li class='keycap tex' data-insert='\\Upsilon '>&Upsilon;<aside>upsilon</aside></li>\n                <li class='keycap tex' data-insert='\\Theta '>&Theta;<aside>theta</aside></li>\n                <li class='keycap tex' data-insert='{\\char\"399}'>&Iota;<aside>iota</aside></li>\n                <li class='keycap tex' data-insert='{\\char\"39F}'>&#x039F;<aside>omicron</aside></li>\n                <li class='keycap tex' data-insert='\\Pi '>&Pi;<aside>pi</aside></li></ul>\n            <ul><li class='keycap tex' data-insert='{\\char\"391}'>&#x391;<aside>alpha</aside></li>\n                <li class='keycap tex' data-insert='\\Sigma '>&Sigma;<aside>sigma</aside></li>\n                <li class='keycap tex' data-insert='\\Delta '>&Delta;<aside>delta</aside></li>\n                <li class='keycap tex' data-insert='\\Phi '>&#x03a6;<aside>phi</aside></li>\n                <li class='keycap tex' data-insert='\\Gamma '>&Gamma;<aside>gamma</aside></li>\n                <li class='keycap tex' data-insert='{\\char\"397}'>&Eta;<aside>eta</aside></li>\n                <li class='keycap tex' data-insert='\\Xi '>&Xi;<aside>xi</aside></li>\n                <li class='keycap tex' data-insert='{\\char\"39A}'>&Kappa;<aside>kappa</aside></li>\n                <li class='keycap tex' data-insert='\\Lambda '>&Lambda;<aside>lambda</aside></li></ul>\n            <ul><li class='shift modifier font-glyph bottom left selected w15 layer-switch' data-layer='lower-greek'>&#x21e7;</li>\n                <li class='keycap tex' data-insert='{\\char\"396}'>&Zeta;<aside>zeta</aside></li>\n                <li class='keycap tex' data-insert='{\\char\"3A7}'>&Chi;<aside>chi</aside></li>\n                <li class='keycap tex' data-insert='\\Psi '>&Psi;<aside>psi</aside></li>\n                <li class='keycap tex' data-insert='\\Omega '>&Omega;<aside>omega</aside></li>\n                <li class='keycap tex' data-insert='{\\char\"392}'>&Beta;<aside>beta</aside></li>\n                <li class='keycap tex' data-insert='{\\char\"39D}'>&Nu;<aside>nu</aside></li>\n                <li class='keycap tex' data-insert='{\\char\"39C}'>&Mu;<aside>mu</aside></li>\n                <li class='action font-glyph bottom right w15' data-command='[\"performWithFeedback\",\"deleteBackward\"]'>&#x232b;</li></ul>\n            <ul>\n                <li class='separator w10'>&nbsp;</li>\n                <li class='keycap'>.</li>\n                <li class='keycap w50' data-key=' '>&nbsp;</li>\n                <arrows/>\n            </ul>\n        </div>",
  "latex-lower": "\n        <div class='rows'>\n            <ul><row name='lower-1' class='tt' shift-layer='latex-upper'/></ul>\n            <ul><row name='lower-2' class='tt' shift-layer='latex-upper'/></ul>\n            <ul><row name='lower-3' class='tt' shift-layer='latex-upper'/></ul>\n            <ul>\n                <li class='layer-switch font-glyph modifier bottom left' data-layer='latex-symbols'>01#</li>\n                <li class='keycap tt' data-shifted='[' data-shifted-command='[\"insertAndUnshiftKeyboardLayer\", \"[\"]'>{</li>\n                <li class='keycap tt' data-shifted=']' data-shifted-command='[\"insertAndUnshiftKeyboardLayer\", \"]\"]'>}</li>\n                <li class='keycap tt' data-shifted='(' data-shifted-command='[\"insertAndUnshiftKeyboardLayer\", \"(\"]'>^</li>\n                <li class='keycap tt' data-shifted=')' data-shifted-command='[\"insertAndUnshiftKeyboardLayer\", \")\"]'>_</li>\n                <li class='keycap w20' data-key=' '>&nbsp;</li>\n                <arrows/>\n            </ul>\n        </div>",
  "latex-upper": "\n        <div class='rows'>\n            <ul><row name='upper-1' class='tt' shift-layer='latex-lower'/></ul>\n            <ul><row name='upper-2' class='tt' shift-layer='latex-lower'/></ul>\n            <ul><row name='upper-3' class='tt' shift-layer='latex-lower'/></ul>\n            <ul>\n                <li class='layer-switch font-glyph modifier bottom left' data-layer='latex-symbols'01#</li>\n                <li class='keycap tt'>[</li>\n                <li class='keycap tt'>]</li>\n                <li class='keycap tt'>(</li>\n                <li class='keycap tt'>)</li>\n                <li class='keycap w20' data-key=' '>&nbsp;</li>\n                <arrows/>\n            </ul>\n        </div>",
  "latex-symbols": "\n        <div class='rows'>\n            <ul><li class='keycap tt'>1</li><li class='keycap tt'>2</li><li class='keycap tt'>3</li><li class='keycap tt'>4</li><li class='keycap tt'>5</li><li class='keycap tt'>6</li><li class='keycap tt'>7</li><li class='keycap tt'>8</li><li class='keycap tt'>9</li><li class='keycap tt'>0</li></ul>\n            <ul><li class='keycap tt'>!</li><li class='keycap tt'>@</li><li class='keycap tt'>#</li><li class='keycap tt'>$</li><li class='keycap tt'>%</li><li class='keycap tt'>^</li><li class='keycap tt'>&</li><li class='keycap tt'>*</li><li class='keycap tt'>+</li><li class='keycap tt'>=</li></ul>\n            <ul>\n                <li class='keycap tt'>\\</li>\n                <li class='keycap tt'>|</li>\n                <li class='keycap tt'>/</li>\n                <li class='keycap tt'>`</li>\n                <li class='keycap tt'>;</li>\n                <li class='keycap tt'>:</li>\n                <li class='keycap tt'>?</li>\n                <li class='keycap tt'>'</li>\n                <li class='keycap tt'>\"</li>\n                <li class='action font-glyph bottom right'\n                    data-shifted='<span class=\"warning\"><svg class=\"svg-glyph\"><use xlink:href=\"#svg-trash\" /></svg></span>'\n                    data-shifted-command='\"deleteAll\"'\n                    data-alt-keys='delete' data-command='[\"performWithFeedback\",\"deleteBackward\"]'\n                >&#x232b;</li>\n            </ul>\n            <ul>\n                <li class='layer-switch font-glyph modifier bottom left' data-layer='latex-lower'>abc</li>\n                <li class='keycap tt'>&lt;</li>\n                <li class='keycap tt'>&gt;</li>\n                <li class='keycap tt'>~</li>\n                <li class='keycap tt'>,</li>\n                <li class='keycap tt'>.</li>\n                <li class='keycap' data-key=' '>&nbsp;</li>\n                <arrows/>\n            </ul>\n        </div>",
  functions: "\n        <div class='rows'>\n            <ul><li class='separator'></li>\n                <li class='fnbutton' data-insert='\\sin'></li>\n                <li class='fnbutton' data-insert='\\sin^{-1}'></li>\n                <li class='fnbutton' data-insert='\\ln'></li>\n                <li class='fnbutton' data-insert='\\exponentialE^{#?}'></li>\n                <li class='bigfnbutton' data-insert='\\operatorname{lcm}(#?)' data-latex='\\operatorname{lcm}()'></li>\n                <li class='bigfnbutton' data-insert='\\operatorname{ceil}(#?)' data-latex='\\operatorname{ceil}()'></li>\n                <li class='bigfnbutton' data-insert='\\lim_{n\\to\\infty}'></li>\n                <li class='bigfnbutton' data-insert='\\int'></li>\n                <li class='bigfnbutton' data-insert='\\operatorname{abs}(#?)' data-latex='\\operatorname{abs}()'></li>\n            </ul>\n            <ul><li class='separator'></li>\n                <li class='fnbutton' data-latex='\\cos'></li>\n                <li class='fnbutton' data-latex='\\cos^{-1}'></li>\n                <li class='fnbutton' data-latex='\\ln_{10}'></li>\n                <li class='fnbutton' data-latex='10^{#?}'></li>\n                <li class='bigfnbutton' data-latex='\\operatorname{gcd}(#?)' data-latex='\\operatorname{gcd}()'></li>\n                <li class='bigfnbutton' data-latex='\\operatorname{floor}(#?)' data-latex='\\operatorname{floor}()'></li>\n                <li class='bigfnbutton' data-latex='\\sum_{n\\mathop=0}^{\\infty}'></li>\n                <li class='bigfnbutton' data-latex='\\int_{0}^{\\infty}'></li>\n                <li class='bigfnbutton' data-latex='\\operatorname{sign}(#?)' data-latex='\\operatorname{sign}()'></li>\n            </ul>\n            <ul><li class='separator'></li>\n                <li class='fnbutton' data-latex='\\tan'></li>\n                <li class='fnbutton' data-latex='\\tan^{-1}'></li>\n                <li class='fnbutton' data-latex='\\log_{#?}'></li>\n                <li class='fnbutton' data-latex='\\sqrt[#?]{#0}'></li>\n                <li class='bigfnbutton' data-insert='#0 \\mod' data-latex='\\mod'></li>\n                <li class='bigfnbutton' data-insert='\\operatorname{round}(#?) ' data-latex='\\operatorname{round}()'></li>\n                <li class='bigfnbutton' data-insert='\\prod_{n\\mathop=0}^{\\infty}' data-latex='{\\scriptstyle \\prod_{n=0}^{\\infty}}'></li>\n                <li class='bigfnbutton' data-insert='\\frac{\\differentialD #0}{\\differentialD x}'></li>\n                <li class='action font-glyph bottom right' data-command='[\"performWithFeedback\",\"deleteBackward\"]'>&#x232b;</li></ul>\n            <ul><li class='separator'></li>\n                <li class='fnbutton'>(</li>\n                <li class='fnbutton'>)</li>\n                <li class='fnbutton' data-insert='^{#?}' data-latex='x^{#?}'></li>\n                <li class='fnbutton' data-insert='_{#?}' data-latex='x_{#?}'></li>\n                <li class='keycap w20 ' data-key=' '>&nbsp;</li>\n                <arrows/>\n            </ul>\n        </div>",
  style: "\n        <div class='rows'>\n            <ul>\n                <li class='keycap' data-alt-keys='foreground-color' data-command='[\"applyStyle\",{\"color\":\"red\"}]'><span style='border-radius: 50%;width:22px;height:22px; border: 3px solid #cc2428'></span></li>\n                <li class='keycap' data-alt-keys='background-color' data-command='[\"applyStyle\",{\"backgroundColor\":\"yellow\"}]'><span style='border-radius: 50%;width:22px;height:22px; background:#fff590'></span></li>\n                <li class='separator w5'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"size\":\"3\"}]' data-latex='\\scriptsize\\text{small}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"size\":\"5\"}]' data-latex='\\scriptsize\\text{normal}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"size\":\"9\"}]' data-latex='\\huge\\text{big}'></li>\n                <li class='separator w5'></li>\n                <li class='keycap' data-latex='\\langle' data-command='[\"insert\", \"\\\\langle\", {\"smartFence\":true}]'></li>\n            </ul>\n            <ul>\n                <li class='keycap' data-command='[\"applyStyle\",{\"series\":\"l\"}]' data-latex='\\fontseries{l}\\text{Ab}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"series\":\"m\"}]' data-latex='\\fontseries{m}\\text{Ab}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"series\":\"b\"}]' data-latex='\\fontseries{b}\\text{Ab}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"series\":\"bx\"}]' data-latex='\\fontseries{bx}\\text{Ab}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"series\":\"sb\"}]' data-latex='\\fontseries{sb}\\text{Ab}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"series\":\"c\"}]' data-latex='\\fontseries{c}\\text{Ab}'></li>\n            </ul>\n            <ul>\n                <li class='keycap' data-command='[\"applyStyle\",{\"shape\":\"up\"}]' data-latex='\\textup{Ab}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"shape\":\"it\"}]' data-latex='\\textit{Ab}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"shape\":\"sl\"}]' data-latex='\\textsl{Ab}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"shape\":\"sc\"}]' data-latex='\\textsc{Ab}'></li>\n                <li class='separator w5'></li>\n                <li class='keycap' data-insert='\\emph{#?} ' data-latex='\\text{\\emph{emph}}'></li>\n            </ul>\n            <ul>\n                <li class='keycap' data-command='[\"applyStyle\",{\"fontFamily\":\"cmr\"}]' data-latex='\\textrm{Az}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"fontFamily\":\"cmtt\"}]' data-latex='\\texttt{Az}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"fontFamily\":\"cmss\"}]' data-latex='\\textsf{Az}'></li>\n\n                <li class='keycap' data-command='[\"applyStyle\",{\"fontFamily\":\"bb\"}]'  data-latex='\\mathbb{AZ}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"fontFamily\":\"scr\"}]'  data-latex='\\mathscr{AZ}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"fontFamily\":\"cal\"}]' data-latex='\\mathcal{A1}'></li>\n                <li class='keycap' data-command='[\"applyStyle\",{\"fontFamily\":\"frak\"}]' data-latex='\\mathfrak{Az}'></li>\n            </ul>\n        </div>"
};
function zn(e, t) {
  e = e.replace(/(^|[^\\])#@/g, "$1#?");
  var i = new rt("root", {
    mode: "math"
  });
  return i.body = Ur(zt(e, {
    parseMode: "math",
    args: t,
    macros: Xe(),
    registers: Hr()
  })), se(re(oe(new te(i.render(new H({
    macros: Xe(),
    registers: Hr(),
    smartFence: !1
  }, {
    fontSize: 5
  }, "displaystyle")), {
    classes: "ML__base"
  }))), {
    classes: "ML__mathlive"
  }).toMarkup();
}
function qn(e, t, i) {
  var r, n, a;
  var o = "<div class='left'>";
  var s = t.replace(/\s+/g, " ").split(" ");
  if (s.length > 1) {
    var _t116 = _objectSpread(_objectSpread({}, Sn), null !== (r = e.customVirtualKeyboards) && void 0 !== r ? r : {});
    var _iterator77 = _createForOfIteratorHelper(s),
      _step77;
    try {
      for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
        var _e132 = _step77.value;
        if (!_t116[_e132]) break;
        o += "<div class='", _e132 === i ? o += "selected " : _t116[_e132].command ? o += "action " : o += "layer-switch ", o += (null !== (n = _t116[_e132].classes) && void 0 !== n ? n : "") + "'", _t116[_e132].tooltip && (o += "data-ML__tooltip='" + (null !== (a = gr(_t116[_e132].tooltip)) && void 0 !== a ? a : _t116[_e132].tooltip) + "' ", o += "data-placement='top' data-delay='1s'"), _e132 !== i && ("string" == typeof _t116[_e132].command ? o += "data-command='\"".concat(_t116[_e132].command, "\"'") : Array.isArray(_t116[_e132].command) && (o += "data-command='\"".concat(_t116[_e132].command.join(""), "\"'")), _t116[_e132].layer && (o += "data-layer='" + _t116[_e132].layer + "'")), o += ">" + _t116[_e132].label + "</div>";
      }
    } catch (err) {
      _iterator77.e(err);
    } finally {
      _iterator77.f();
    }
  }
  o += "</div>";
  var l = "default" === e.virtualKeyboardToolbar ? ["copyToClipboard", "undo", "redo"] : [],
    c = {
      copyToClipboard: "\n            <div class='action'\n                data-command='\"copyToClipboard\"'\n                data-ML__tooltip='".concat(gr("tooltip.copy to clipboard"), "' data-placement='top' data-delay='1s'>\n                <svg><use xlink:href='#svg-copy' /></svg>\n            </div>\n        "),
      undo: "\n            <div class='action disabled'\n                data-command='\"undo\"'\n                data-ML__tooltip='".concat(gr("tooltip.undo"), "' data-placement='top' data-delay='1s'>\n                <svg><use xlink:href='#svg-undo' /></svg>\n            </div>\n        "),
      redo: "\n            <div class='action disabled'\n                data-command='\"redo\"'\n                data-ML__tooltip='".concat(gr("tooltip.redo"), "' data-placement='top' data-delay='1s'>\n                <svg><use xlink:href='#svg-redo' /></svg>\n            </div>\n        ")
    };
  return l.length > 0 && (o += "\n            <div class='right'>\n                ".concat(l.map(function (e) {
    return c[e];
  }).join(""), "\n            </div>\n        ")), "<div class='keyboard-toolbar' role='toolbar'>" + o + "</div>";
}
function Dn(e, t, i) {
  var r, n;
  var _iterator78 = _createForOfIteratorHelper(t),
    _step78;
  try {
    for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
      var _a17 = _step78.value;
      var _t117 = void 0;
      _a17.getAttribute("data-latex") ? _t117 = zn(_a17.getAttribute("data-latex").replace(/&quot;/g, '"'), function () {
        return "\\placeholder{}";
      }) : _a17.getAttribute("data-insert") && "" === _a17.innerHTML ? _t117 = zn(_a17.getAttribute("data-insert").replace(/&quot;/g, '"'), function () {
        return "\\placeholder{}";
      }) : _a17.getAttribute("data-content") && (_t117 = _a17.getAttribute("data-content").replace(/&quot;/g, '"')), _a17.getAttribute("data-aside") && (_t117 = (null != _t117 ? _t117 : "") + "<aside>" + _a17.getAttribute("data-aside").replace(/&quot;/g, '"') + "</aside>"), void 0 !== _t117 && (_a17.innerHTML = e.options.createHTML(_t117)), _a17.getAttribute("data-classes") && _a17.classList.add(_a17.getAttribute("data-classes"));
      var _o17 = null === (r = _a17.getAttribute("data-insert")) || void 0 === r ? void 0 : r.replace(/&quot;/g, '"');
      var _s12 = void 0;
      _o17 && Ln[_o17] && (_a17.dataset.shifted = Ln[_o17][0], _a17.dataset.shiftedCommand = JSON.stringify(["insertAndUnshiftKeyboardLayer", Ln[_o17][1]])), _s12 = _a17.getAttribute("data-command") ? JSON.parse(_a17.getAttribute("data-command")) : _a17.getAttribute("data-insert") ? ["insert", _a17.getAttribute("data-insert"), {
        focus: !0,
        feedback: !0,
        scrollIntoView: !0,
        mode: "math",
        format: "latex",
        resetStyle: !0
      }] : _a17.getAttribute("data-latex") ? ["insert", _a17.getAttribute("data-latex"), {
        focus: !0,
        feedback: !0,
        scrollIntoView: !0,
        mode: "math",
        format: "latex",
        resetStyle: !0
      }] : ["typedText", null !== (n = _a17.getAttribute("data-key")) && void 0 !== n ? n : _a17.textContent, {
        focus: !0,
        feedback: !0,
        simulateKeystroke: !0
      }], i && (_s12 = [i, _s12]);
      var _l7 = _s12;
      var _c4 = _a17.getAttribute("data-alt-keys");
      _c4 && An[_c4] && (_l7 = {
        default: _s12,
        pressAndHoldStart: ["showAlternateKeys", _c4],
        pressAndHoldEnd: "hideAlternateKeys"
      }), Nr(function (t) {
        return e.executeCommand(t);
      }, _a17, _l7);
    }
  } catch (err) {
    _iterator78.e(err);
  } finally {
    _iterator78.f();
  }
}
function En(e, t) {
  var i, r, n;
  var a = {
    qwerty: {
      "lower-1": "qwertyuiop",
      "lower-2": " asdfghjkl ",
      "lower-3": "^zxcvbnm~",
      "upper-1": "QWERTYUIOP",
      "upper-2": " ASDFGHJKL ",
      "upper-3": "^ZXCVBNM~",
      "numpad-1": "789/",
      "numpad-2": "456*",
      "numpad-3": "123-",
      "numpad-4": "0.=+"
    },
    azerty: {
      "lower-1": "azertyuiop",
      "lower-2": "qsdfghjklm",
      "lower-3": "^ wxcvbn ~",
      "upper-1": "AZERTYUIOP",
      "upper-2": "QSDFGHJKLM",
      "upper-3": "^ WXCVBN ~"
    },
    qwertz: {
      "lower-1": "qwertzuiop",
      "lower-2": " asdfghjkl ",
      "lower-3": "^yxcvbnm~",
      "upper-1": "QWERTZUIOP",
      "upper-2": " ASDFGHJKL",
      "upper-3": "^YXCVBNM~"
    },
    dvorak: {
      "lower-1": "^  pyfgcrl ",
      "lower-2": "aoeuidhtns",
      "lower-3": "qjkxbmwvz~",
      "upper-1": "^  PYFGCRL ",
      "upper-2": "AOEUIDHTNS",
      "upper-3": "QJKXBMWVZ~"
    },
    colemak: {
      "lower-1": " qwfpgjluy ",
      "lower-2": "arstdhneio",
      "lower-3": "^zxcvbkm~",
      "upper-1": " QWFPGNLUY ",
      "upper-2": "ARSTDHNEIO",
      "upper-3": "^ZXCVBKM~"
    }
  };
  var o = e.virtualKeyboardLayout;
  if ("auto" === o) {
    var _e133 = Ki();
    _e133 && (o = _e133.virtualLayout), o && "auto" !== o || (o = null !== (i = {
      fr: "azerty",
      be: "azerty",
      al: "qwertz",
      ba: "qwertz",
      cz: "qwertz",
      de: "qwertz",
      hu: "qwertz",
      sk: "qwertz",
      ch: "qwertz"
    }[fr.locale.slice(0, 2)]) && void 0 !== i ? i : "qwerty");
  }
  var s = null !== (r = a[o]) && void 0 !== r ? r : a.qwerty;
  var l,
    c = t;
  c = c.replace(/<arrows\/>/g, '\n        <li class=\'action\' data-command=\'["performWithFeedback","moveToPreviousChar"]\'\n            data-shifted=\'<svg class="svg-glyph"><use xlink:href="#svg-angle-double-left" /></svg>\'\n            data-shifted-command=\'["performWithFeedback","extendToPreviousChar"]\'>\n            <svg class="svg-glyph"><use xlink:href=\'#svg-arrow-left\' /></svg>\n        </li>\n        <li class=\'action\' data-command=\'["performWithFeedback","moveToNextChar"]\'\n            data-shifted=\'<svg class="svg-glyph"><use xlink:href="#svg-angle-double-right" /></svg>\'\n            data-shifted-command=\'["performWithFeedback","extendToNextChar"]\'>\n            <svg class="svg-glyph"><use xlink:href=\'#svg-arrow-right\' /></svg>\n        </li>\n        <li class=\'action\' data-command=\'["performWithFeedback","moveToNextPlaceholder"]\'>\n        <svg class="svg-glyph"><use xlink:href=\'#svg-tab\' /></svg></li>');
  var u = c.match(/(<row\s+)(.*)((?:<\/row|\/)>)/);
  for (; u;) {
    l = "";
    var _e134 = u[2].match(/[a-zA-Z][a-zA-Z\d-]*=(['"])(.*?)\1/g),
      _t118 = {};
    if (_e134) {
      var _iterator79 = _createForOfIteratorHelper(_e134),
        _step79;
      try {
        for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
          var _i100 = _step79.value;
          var _e135 = _i100.match(/([a-zA-Z][a-zA-Z\d-]*)=(['"])(.*?)\2/);
          _e135 && (_t118[_e135[1]] = _e135[3]);
        }
      } catch (err) {
        _iterator79.e(err);
      } finally {
        _iterator79.f();
      }
    }
    var _i101 = s[_t118.name];
    if (_i101 || (_i101 = a.qwerty[_t118.name]), _i101) {
      var _iterator80 = _createForOfIteratorHelper(_i101),
        _step80;
      try {
        for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
          var _e136 = _step80.value;
          var _r32 = null !== (n = _t118.class) && void 0 !== n ? n : "";
          _r32 && (_r32 = " ".concat(_r32)), "~" === _e136 ? (l += "<li class='action font-glyph bottom right ", l += _i101.length - (_i101.match(/ /g) || []).length / 2 == 10 ? "w10" : "w15", l += '\' data-shifted=\'<span class="warning"><svg class="svg-glyph"><use xlink:href="#svg-trash" /></svg></span>\'\n                        data-shifted-command=\'"deleteAll"\'\n                        data-alt-keys=\'delete\' data-command=\'["performWithFeedback","deleteBackward"]\'\n                        >&#x232b;</li>') : " " === _e136 ? l += "<li class='separator w5'></li>" : "^" === _e136 ? l += "<li class='shift modifier font-glyph bottom left w15 layer-switch' data-layer='" + _t118["shift-layer"] + "'>&#x21e7;</li>" : "/" === _e136 ? l += "<li class='keycap" + _r32 + "' data-alt-keys='/' data-insert='\\frac{#@}{#?}'>&divide;</li>" : "*" === _e136 ? l += "<li class='keycap" + _r32 + "' data-alt-keys='*' data-insert='\\times '>&times;</li>" : "-" === _e136 ? l += "<li class='keycap" + _r32 + "' data-alt-keys='-' data-key='-' data-alt-keys='-'>&#x2212;</li>" : _r32.includes("tt") ? l += "<li class='keycap".concat(_r32, "' data-alt-keys='").concat(_e136, "' data-command='[\"typedText\",\"").concat(_e136, "\",{\"mode\":\"command\", \"focus\":true, \"feedback\":true}]'>").concat(_e136, "</li>") : l += "<li class='keycap" + _r32 + "' data-alt-keys='" + _e136 + "'>" + _e136 + "</li>";
        }
      } catch (err) {
        _iterator80.e(err);
      } finally {
        _iterator80.f();
      }
    }
    c = c.replace(new RegExp(u[1] + u[2] + u[3]), l), u = c.match(/(<row\s+)(.*)((?:<\/row|\/)>)/);
  }
  return c;
}
function Tn(e) {
  _n();
  var t = e.element.querySelectorAll("div.keyboard-layer.is-visible .rows .keycap, div.keyboard-layer.is-visible .rows .action");
  if (t) {
    var _iterator81 = _createForOfIteratorHelper(t),
      _step81;
    try {
      for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
        var _i102 = _step81.value;
        var _t119 = _i102.getAttribute("data-unshifted-content");
        _t119 && (_i102.innerHTML = e.options.createHTML(_t119));
        var _r33 = _i102.getAttribute("data-unshifted-command");
        _r33 && (_i102.dataset.command = _r33);
      }
    } catch (err) {
      _iterator81.e(err);
    } finally {
      _iterator81.f();
    }
  }
  return !1;
}
function On(e, t) {
  if ("off" !== e.options.virtualKeyboardMode) {
    "lower-command" !== t && "upper-command" !== t && "symbols-command" !== t && e.executeCommand("complete"), Bn(e), _n(), Tn(e);
    var _i103 = null == e ? void 0 : e.element.querySelectorAll(".keyboard-layer");
    var _r34 = !1;
    var _iterator82 = _createForOfIteratorHelper(_i103),
      _step82;
    try {
      for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
        var _e138 = _step82.value;
        if (_e138.dataset.layer === t) {
          _r34 = !0;
          break;
        }
      }
    } catch (err) {
      _iterator82.e(err);
    } finally {
      _iterator82.f();
    }
    if (_r34) {
      var _iterator83 = _createForOfIteratorHelper(_i103),
        _step83;
      try {
        for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
          var _e137 = _step83.value;
          _e137.dataset.layer === t ? _e137.classList.add("is-visible") : _e137.classList.remove("is-visible");
        }
      } catch (err) {
        _iterator83.e(err);
      } finally {
        _iterator83.f();
      }
    }
    e.focusMathfield();
  }
  return !0;
}
function Bn(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return e.visible = !1, Kn(e, t), !1;
}
function Kn(e, t) {
  return !!e.options.virtualKeyboardContainer && (e.visible = !e.visible, e.visible ? (e.focusMathfield(), e.element ? e.element.classList.add("is-visible") : (e.element = function (e, t) {
    var i, a, o, s;
    we();
    var l = '<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">\n\n            <symbol id="svg-command" viewBox="0 0 640 512">\n                <path d="M34.495 36.465l211.051 211.05c4.686 4.686 4.686 12.284 0 16.971L34.495 475.535c-4.686 4.686-12.284 4.686-16.97 0l-7.071-7.07c-4.686-4.686-4.686-12.284 0-16.971L205.947 256 10.454 60.506c-4.686-4.686-4.686-12.284 0-16.971l7.071-7.07c4.686-4.687 12.284-4.687 16.97 0zM640 468v-10c0-6.627-5.373-12-12-12H300c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h328c6.627 0 12-5.373 12-12z"/>\n            </symbol>\n\n            <symbol id="svg-undo" viewBox="0 0 512 512">\n                <path d="M20 8h10c6.627 0 12 5.373 12 12v110.625C85.196 57.047 165.239 7.715 256.793 8.001 393.18 8.428 504.213 120.009 504 256.396 503.786 393.181 392.834 504 256 504c-63.926 0-122.202-24.187-166.178-63.908-5.113-4.618-5.354-12.561-.482-17.433l7.069-7.069c4.503-4.503 11.749-4.714 16.482-.454C150.782 449.238 200.935 470 256 470c117.744 0 214-95.331 214-214 0-117.744-95.331-214-214-214-82.862 0-154.737 47.077-190.289 116H180c6.627 0 12 5.373 12 12v10c0 6.627-5.373 12-12 12H20c-6.627 0-12-5.373-12-12V20c0-6.627 5.373-12 12-12z"/>\n            </symbol>\n            <symbol id="svg-redo" viewBox="0 0 512 512">\n                <path d="M492 8h-10c-6.627 0-12 5.373-12 12v110.625C426.804 57.047 346.761 7.715 255.207 8.001 118.82 8.428 7.787 120.009 8 256.396 8.214 393.181 119.166 504 256 504c63.926 0 122.202-24.187 166.178-63.908 5.113-4.618 5.354-12.561.482-17.433l-7.069-7.069c-4.503-4.503-11.749-4.714-16.482-.454C361.218 449.238 311.065 470 256 470c-117.744 0-214-95.331-214-214 0-117.744 95.331-214 214-214 82.862 0 154.737 47.077 190.289 116H332c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12z"/>\n            </symbol>\n            <symbol id="svg-arrow-left" viewBox="0 0 192 512">\n                <path d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z"/>\n            </symbol>\n            <symbol id="svg-arrow-right" viewBox="0 0 192 512">\n                    <path d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z"/>\n            </symbol>\n            <symbol id="svg-tab" viewBox="0 0 448 512">\n                    <path d="M32 217.1c0-8.8 7.2-16 16-16h144v-93.9c0-7.1 8.6-10.7 13.6-5.7l143.5 143.1c6.3 6.3 6.3 16.4 0 22.7L205.6 410.4c-5 5-13.6 1.5-13.6-5.7v-93.9H48c-8.8 0-16-7.2-16-16v-77.7m-32 0v77.7c0 26.5 21.5 48 48 48h112v61.9c0 35.5 43 53.5 68.2 28.3l143.6-143c18.8-18.8 18.8-49.2 0-68L228.2 78.9c-25.1-25.1-68.2-7.3-68.2 28.3v61.9H48c-26.5 0-48 21.6-48 48zM436 64h-8c-6.6 0-12 5.4-12 12v360c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12z"/>\n            </symbol>\n            <symbol id="svg-copy" viewBox="0 0 448 512">\n                <path d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"/>\n            </symbol>\n            <symbol id="svg-angle-double-right" viewBox="0 0 320 512">\n                <path d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17zm128-17l-117.8-116c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17L255.3 256 153.1 356.4c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l117.8-116c4.6-4.7 4.6-12.3-.1-17z"/>\n            </symbol>\n            <symbol id="svg-angle-double-left" viewBox="0 0 320 512">\n                <path d="M153.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L192.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L153 264.5c-4.6-4.7-4.6-12.3.1-17zm-128 17l117.8 116c4.7 4.7 12.3 4.7 17 0l7.1-7.1c4.7-4.7 4.7-12.3 0-17L64.7 256l102.2-100.4c4.7-4.7 4.7-12.3 0-17l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L25 247.5c-4.6 4.7-4.6 12.3.1 17z"/>\n            </symbol>\n            <symbol id="svg-trash" viewBox="0 0 448 512">\n                <path d="M336 64l-33.6-44.8C293.3 7.1 279.1 0 264 0h-80c-15.1 0-29.3 7.1-38.4 19.2L112 64H24C10.7 64 0 74.7 0 88v2c0 3.3 2.7 6 6 6h26v368c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V96h26c3.3 0 6-2.7 6-6v-2c0-13.3-10.7-24-24-24h-88zM184 32h80c5 0 9.8 2.4 12.8 6.4L296 64H152l19.2-25.6c3-4 7.8-6.4 12.8-6.4zm200 432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V96h320v368zm-176-44V156c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v264c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12zm-80 0V156c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v264c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12zm160 0V156c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v264c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12z"/>\n            </symbol>\n        </svg>\n        ';
    e.create(), Cn["foreground-color"] = [];
    for (var _i104 = 0, _Object$keys9 = Object.keys(n); _i104 < _Object$keys9.length; _i104++) {
      var _e139 = _Object$keys9[_i104];
      Cn["foreground-color"].push({
        class: "small-button",
        content: '<span style="border-radius:50%;width:32px;height:32px; box-sizing: border-box; border: 3px solid ' + n[_e139] + '"></span>',
        command: ["applyStyle", {
          color: _e139
        }]
      });
    }
    Cn["background-color"] = [];
    for (var _i105 = 0, _Object$keys10 = Object.keys(r); _i105 < _Object$keys10.length; _i105++) {
      var _e140 = _Object$keys10[_i105];
      Cn["background-color"].push({
        class: "small-button",
        content: '<span style="border-radius:50%;width:32px;height:32px; background:' + r[_e140] + '"></span>',
        command: ["applyStyle", {
          backgroundColor: _e140
        }]
      });
    }
    An = _objectSpread({}, Cn);
    for (var _i106 = 0, _Object$keys11 = Object.keys(An); _i106 < _Object$keys11.length; _i106++) {
      var _e141 = _Object$keys11[_i106];
      An[_e141] = An[_e141].slice();
    }
    for (var _e142 = 0; _e142 < 26; _e142++) {
      var _t120 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"[_e142];
      An[_t120] || (An[_t120] = []), An[_t120].unshift({
        latex: "\\mathbb{" + _t120 + "}",
        aside: "blackboard",
        insert: "\\mathbb{" + _t120 + "}"
      }), An[_t120].unshift({
        latex: "\\mathbf{" + _t120 + "}",
        aside: "bold",
        insert: "\\mathbf{" + _t120 + "}"
      }), An[_t120].unshift({
        latex: "\\mathsf{" + _t120 + "}",
        aside: "sans",
        insert: "\\mathsf{" + _t120 + "}"
      }), An[_t120].unshift({
        latex: "\\mathtt{" + _t120 + "}",
        aside: "monospace",
        insert: "\\mathtt{" + _t120 + "}"
      }), An[_t120].unshift({
        latex: "\\mathcal{" + _t120 + "}",
        aside: "calligraphy",
        insert: "\\mathcal{" + _t120 + "}"
      }), An[_t120].unshift({
        latex: "\\mathfrak{" + _t120 + "}",
        aside: "fraktur",
        insert: "\\mathfrak{" + _t120 + "}"
      });
    }
    for (var _e143 = 0; _e143 <= 26; _e143++) {
      var _t121 = "abcdefghijklmnopqrstuvwxyz"[_e143];
      An[_t121] || (An[_t121] = []), An[_t121].unshift({
        latex: "\\mathsf{" + _t121 + "}",
        aside: "sans",
        insert: "\\mathsf{" + _t121 + "}"
      }), An[_t121].unshift({
        latex: "\\mathbf{" + _t121 + "}",
        aside: "bold",
        insert: "\\mathbf{" + _t121 + "}"
      }), An[_t121].unshift({
        latex: "\\mathtt{" + _t121 + "}",
        aside: "monospace",
        insert: "\\mathtt{" + _t121 + "}"
      }), An[_t121].unshift({
        latex: "\\mathfrak{" + _t121 + "}",
        aside: "fraktur",
        insert: "\\mathfrak{" + _t121 + "}"
      });
    }
    for (var _e144 = 0; _e144 < 10; _e144++) {
      var _t122 = "0123456789"[_e144];
      An[_t122] || (An[_t122] = []), An[_t122].unshift({
        latex: "\\mathbf{" + _t122 + "}",
        aside: "bold",
        insert: "\\mathbf{" + _t122 + "}"
      }), An[_t122].unshift({
        latex: "\\mathsf{" + _t122 + "}",
        aside: "sans",
        insert: "\\mathsf{" + _t122 + "}"
      }), An[_t122].unshift({
        latex: "\\mathtt{" + _t122 + "}",
        aside: "monospace",
        insert: "\\mathtt{" + _t122 + "}"
      }), An[_t122].unshift({
        latex: "\\mathcal{" + _t122 + "}",
        aside: "script",
        insert: "\\mathcal{" + _t122 + "}"
      }), An[_t122].unshift({
        latex: "\\mathfrak{" + _t122 + "}",
        aside: "fraktur",
        insert: "\\mathfrak{" + _t122 + "}"
      });
    }
    var c = e.options.virtualKeyboards;
    c || (c = "all"), c = c.replace(/\ball\b/i, "numeric functions symbols roman  greek");
    var u = _objectSpread(_objectSpread({}, Nn), null !== (i = e.options.customVirtualKeyboardLayers) && void 0 !== i ? i : {}),
      d = _objectSpread(_objectSpread({}, Sn), null !== (a = e.options.customVirtualKeyboards) && void 0 !== a ? a : {}),
      h = c.replace(/\s+/g, " ").split(" ");
    var _iterator84 = _createForOfIteratorHelper(h),
      _step84;
    try {
      for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
        var _t123 = _step84.value;
        if (!d[_t123]) continue;
        var _i107 = null !== (o = d[_t123].layers) && void 0 !== o ? o : [];
        d[_t123].layer && _i107.push(d[_t123].layer), _i107 = _toConsumableArray(new Set(_i107));
        var _iterator88 = _createForOfIteratorHelper(_i107),
          _step88;
        try {
          for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
            var _r35 = _step88.value;
            if (!u[_r35]) break;
            if ("object" == typeof u[_r35]) {
              var _e145 = u[_r35];
              var _t124 = "";
              if (_e145.styles && (_t124 += "<style>".concat(_e145.styles, "</style>")), _e145.backdrop && (_t124 += "<div class='".concat(_e145.backdrop, "'>")), _e145.container && (_t124 += "<div class='".concat(_e145.container, "'>")), _e145.rows) {
                _t124 += "<div class='rows'>";
                var _iterator89 = _createForOfIteratorHelper(_e145.rows),
                  _step89;
                try {
                  for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
                    var _i108 = _step89.value;
                    _t124 += "<ul>";
                    var _iterator90 = _createForOfIteratorHelper(_i108),
                      _step90;
                    try {
                      for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
                        var _e146 = _step90.value;
                        if (_t124 += "<li", _e146.class && /separator/.test(_e146.class) ? _t124 += " class=\"".concat(_e146.class, "\"") : _e146.class ? _t124 += " class=\"keycap ".concat(_e146.class, "\"") : _t124 += ' class="keycap"', _e146.key && (_t124 += " data-key=\"".concat(_e146.key, "\"")), _e146.command && ("string" == typeof _e146.command ? _t124 += " data-command='\"".concat(_e146.command, "\"'") : (_t124 += " data-command='", _t124 += JSON.stringify(_e146.command), _t124 += "'")), _e146.insert && (_t124 += " data-insert=\"".concat(_e146.insert, "\"")), _e146.latex && (_t124 += " data-latex=\"".concat(_e146.latex, "\"")), _e146.aside && (_t124 += " data-aside=\"".concat(_e146.aside, "\"")), _e146.variants) {
                          var _i109 = Date.now().toString(36).slice(-2) + Math.floor(1e5 * Math.random()).toString(36);
                          An[_i109] = _e146.variants, _t124 += " data-alt-keys=\"".concat(_i109, "\"");
                        }
                        _e146.shifted && (_t124 += " data-shifted=\"".concat(_e146.shifted, "\"")), _e146.shiftedCommand && (_t124 += " data-shifted-command=\"".concat(_e146.shiftedCommand, "\"")), _t124 += ">".concat(_e146.label ? _e146.label : "", "</li>");
                      }
                    } catch (err) {
                      _iterator90.e(err);
                    } finally {
                      _iterator90.f();
                    }
                    _t124 += "</ul>";
                  }
                } catch (err) {
                  _iterator89.e(err);
                } finally {
                  _iterator89.f();
                }
                _t124 += "</div>";
              }
              _e145.container && (_t124 += "</div>"), _e145.backdrop && (_t124 += "</div>"), u[_r35] = _t124;
            }
            l += "<div tabindex=\"-1\" class='keyboard-layer' data-layer='".concat(_r35, "'>"), l += qn(e.options, c, _t123);
            var _i110 = u[_r35];
            l += En(e.options, _i110), l += "</div>";
          }
        } catch (err) {
          _iterator88.e(err);
        } finally {
          _iterator88.f();
        }
      }
    } catch (err) {
      _iterator84.e(err);
    } finally {
      _iterator84.f();
    }
    var p = document.createElement("div");
    p.className = "ML__keyboard", t ? p.classList.add(t) : e.options.virtualKeyboardTheme && p.classList.add(e.options.virtualKeyboardTheme);
    var m = document.createElement("div");
    m.className = "ML__keyboard--plate", m.innerHTML = e.options.createHTML(l), p.appendChild(m);
    var f = p.querySelectorAll(".keycap, .action, .fnbutton, .bigfnbutton");
    var _iterator85 = _createForOfIteratorHelper(f),
      _step85;
    try {
      for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
        var _e147 = _step85.value;
        _e147.id = "ML__k" + Date.now().toString(36).slice(-2) + Math.floor(1e5 * Math.random()).toString(36);
      }
    } catch (err) {
      _iterator85.e(err);
    } finally {
      _iterator85.f();
    }
    Dn(e, _toConsumableArray(f));
    var g = p.querySelectorAll(".layer-switch");
    var _iterator86 = _createForOfIteratorHelper(g),
      _step86;
    try {
      for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
        var _t125 = _step86.value;
        _t125.classList.contains("shift") ? Nr(function (t) {
          return e.executeCommand(t);
        }, _t125, {
          pressed: "shiftKeyboardLayer",
          default: ["switchKeyboardLayer", _t125.getAttribute("data-layer")],
          pressAndHoldEnd: "unshiftKeyboardLayer"
        }) : Nr(function (t) {
          return e.executeCommand(t);
        }, _t125, {
          default: ["switchKeyboardLayer", _t125.getAttribute("data-layer")]
        });
      }
    } catch (err) {
      _iterator86.e(err);
    } finally {
      _iterator86.f();
    }
    var y = p.querySelectorAll(".keyboard-layer");
    var _iterator87 = _createForOfIteratorHelper(y),
      _step87;
    try {
      for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
        var _e148 = _step87.value;
        _e148.addEventListener("mousedown", function (e) {
          e.preventDefault(), e.stopPropagation();
        }), _e148.addEventListener("touchstart", function (e) {
          e.preventDefault(), e.stopPropagation();
        }, {
          passive: !1
        });
      }
    } catch (err) {
      _iterator87.e(err);
    } finally {
      _iterator87.f();
    }
    return null === (s = y[0]) || void 0 === s || s.classList.add("is-visible"), p;
  }(e, null != t ? t : ""), yr(e.element, "touchstart:passive mousedown", function () {
    return e.focusMathfield();
  }), e.options.virtualKeyboardContainer.appendChild(e.element)), window.setTimeout(function () {
    var t;
    null === (t = null == e ? void 0 : e.element) || void 0 === t || t.classList.add("is-visible");
  }, 1)) : e.element && e.disable(), e.stateChanged(), !1);
}
function Fn(e, t, i) {
  return t + pr(i, _objectSpread(_objectSpread({}, e), {}, {
    textToSpeechMarkup: "",
    textToSpeechRulesOptions: _objectSpread(_objectSpread({}, e.textToSpeechRulesOptions), {}, {
      markup: "none"
    })
  }));
}
function $n(e, t) {
  var i, r;
  if (!t && (null === window || void 0 === window ? void 0 : window.mathlive) && (t = window.mathlive.config), (t = null != t ? t : {}).speechEngine && "local" !== t.speechEngine) {
    if ("amazon" === t.speechEngine) {
      if (window && window.AWS) {
        var _n26 = new window.AWS.Polly({
            apiVersion: "2016-06-10"
          }),
          _a18 = {
            OutputFormat: "mp3",
            VoiceId: null !== (i = t.speechEngineVoice) && void 0 !== i ? i : "Joanna",
            Engine: ["Amy", "Emma", "Brian", "Ivy", "Joanna", "Kendra", "Kimberly", "Salli", "Joey", "Justin", "Matthew"].includes(null !== (r = t.speechEngineVoice) && void 0 !== r ? r : "Joanna") ? "neural" : "standard",
            Text: e,
            TextType: "ssml"
          };
        _n26.synthesizeSpeech(_a18, function (e, t) {
          if (e) ;else if (null == t ? void 0 : t.AudioStream) {
            var _e149 = new Uint8Array(t.AudioStream),
              _i111 = new Blob([_e149.buffer], {
                type: "audio/mpeg"
              }),
              _r36 = URL.createObjectURL(_i111);
            new Audio(_r36).play().catch(function (e) {});
          }
        });
      }
    } else t.speechEngine;
  } else {
    var _t126 = new SpeechSynthesisUtterance(e);
    window && window.speechSynthesis.speak(_t126);
  }
}
function Pn(e) {
  var t;
  if ("body" === e.treeBranch) t = {
    enclose: "cross out",
    leftright: "fence",
    surd: "square root",
    root: "math field",
    mop: "operator"
  }[e.parent.type];else if ("genfrac" === e.parent.type) {
    if ("above" === e.treeBranch) return "numerator";
    if ("below" === e.treeBranch) return "denominator";
  } else "surd" === e.parent.type ? "above" === e.treeBranch && (t = "index") : "superscript" === e.treeBranch ? t = "superscript" : "subscript" === e.treeBranch && (t = "subscript");
  return null != t ? t : "parent";
}
function In(e, t, i, r) {
  var n;
  var a = "";
  "plonk" === t ? (null === (n = e.plonkSound) || void 0 === n || n.play().catch(function (e) {}), e.resetKeystrokeBuffer()) : "delete" === t ? a = Fn(e.options, "deleted: ", r) : "focus" === t || t.includes("move") ? a = function (e, t) {
    if (Number.isNaN(t)) return "";
    var i = e.at(t);
    if (!i) return "";
    if (i.treeDepth <= e.at(e.position).treeDepth) return "";
    var r = "",
      n = i.parent;
    var a = e.at(e.position).parent;
    for (; n !== e.root && n !== a;) r += "out of ".concat(Pn(n), ";"), n = n.parent;
    return r;
  }(e.model, i) + (e.model.selectionIsCollapsed ? "" : "selected: ") + function (e, t) {
    if (!e.selectionIsCollapsed) return Fn(t, "", e.getAtoms(e.selection));
    var i = "";
    var r = e.at(e.position),
      n = Pn(r);
    return r.isFirstSibling && (i = (n ? "start of " + n : "unknown") + ": "), r.isLastSibling ? r.isFirstSibling || (i += n ? "end of " + n : "unknown") : i += Fn(t, "", r), i;
  }(e.model, e.options) : "replacement" === t ? a = Fn(e.options, "", e.model.at(e.model.position)) : "line" === t ? (a = Fn(e.options, "", e.model.root), e.keyboardDelegate.setAriaLabel("after: " + a)) : a = r ? Fn(e.options, t + " ", r) : t;
  var o = e.ariaLiveText.textContent.includes("\xa0") ? " \u202F " : " \xa0 ";
  e.ariaLiveText.textContent = a + o;
}
function Rn(e) {
  if (e.classList.remove("ML__highlight"), e.children) {
    var _iterator91 = _createForOfIteratorHelper(e.children),
      _step91;
    try {
      for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
        var _t127 = _step91.value;
        Rn(_t127);
      }
    } catch (err) {
      _iterator91.e(err);
    } finally {
      _iterator91.f();
    }
  }
}
function Vn(e, t) {
  var i;
  t && (null === (i = e.dataset) || void 0 === i ? void 0 : i.atomId) !== t ? (e.classList.remove("ML__highlight"), e.children && e.children.length > 0 && _toConsumableArray(e.children).forEach(function (e) {
    e instanceof HTMLElement && Vn(e, t);
  })) : (e.classList.add("ML__highlight"), e.children && e.children.length > 0 && _toConsumableArray(e.children).forEach(function (e) {
    e instanceof HTMLElement && Vn(e);
  }));
}
function jn(e, t, i) {
  var r, n, a;
  if ("undefined" == typeof window) return;
  if (!i && window.mathlive && (i = window.mathlive.config), "amazon" !== i.speechEngine) return void (i.speakHook && i.speakHook(t, i));
  if (!window.AWS) return;
  var o = new window.AWS.Polly({
      apiVersion: "2016-06-10"
    }),
    s = {
      OutputFormat: "json",
      VoiceId: null !== (r = i.speechEngineVoice) && void 0 !== r ? r : "Joanna",
      Engine: "standard",
      Text: t,
      TextType: "ssml",
      SpeechMarkTypes: ["ssml"]
    };
  window.mathlive = null !== (n = window.mathlive) && void 0 !== n ? n : {}, window.mathlive.readAloudElement = e;
  var l = null !== (a = i.onReadAloudStatus) && void 0 !== a ? a : window.mathlive.onReadAloudStatus;
  o.synthesizeSpeech(s, function (e, t) {
    if (e) return;
    if (!t || !t.AudioStream) return;
    var i = new TextDecoder("utf-8").decode(new Uint8Array(t.AudioStream));
    window.mathlive.readAloudMarks = i.split("\n").map(function (e) {
      return e ? JSON.parse(e) : {};
    }), window.mathlive.readAloudTokens = [];
    var _iterator92 = _createForOfIteratorHelper(window.mathlive.readAloudMarks),
      _step92;
    try {
      for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
        var _e150 = _step92.value;
        _e150.value && window.mathlive.readAloudTokens.push(_e150.value);
      }
    } catch (err) {
      _iterator92.e(err);
    } finally {
      _iterator92.f();
    }
    window.mathlive.readAloudCurrentMark = "", s.OutputFormat = "mp3", s.SpeechMarkTypes = [], o.synthesizeSpeech(s, function (e, t) {
      if (e) return;
      if (!t || !t.AudioStream) return;
      var i = new Uint8Array(t.AudioStream),
        r = new Blob([i.buffer], {
          type: "audio/mpeg"
        }),
        n = URL.createObjectURL(r);
      window.mathlive.readAloudAudio ? window.mathlive.readAloudAudio.pause() : (window.mathlive.readAloudAudio = new Audio(), window.mathlive.readAloudAudio.addEventListener("ended", function () {
        var e = window.mathlive.readAloudMathField;
        l && l(e, "ended"), e ? (nn(e), window.mathlive.readAloudElement = null, window.mathlive.readAloudMathField = null, window.mathlive.readAloudTokens = [], window.mathlive.readAloudMarks = [], window.mathlive.readAloudCurrentMark = "") : Rn(window.mathlive.readAloudElement);
      }), window.mathlive.readAloudAudio.addEventListener("timeupdate", function () {
        var e = "";
        var t = 1e3 * window.mathlive.readAloudAudio.currentTime + 100;
        var _iterator93 = _createForOfIteratorHelper(window.mathlive.readAloudMarks),
          _step93;
        try {
          for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
            var _i112 = _step93.value;
            _i112.time < t && (e = _i112.value);
          }
        } catch (err) {
          _iterator93.e(err);
        } finally {
          _iterator93.f();
        }
        window.mathlive.readAloudCurrentMark !== e && (window.mathlive.readAloudCurrentToken = e, e && e === window.mathlive.readAloudFinalToken ? window.mathlive.readAloudAudio.pause() : (window.mathlive.readAloudCurrentMark = e, Vn(window.mathlive.readAloudElement, window.mathlive.readAloudCurrentMark)));
      })), window.mathlive.readAloudAudio.src = n, l && l(window.mathlive.readAloudMathField, "playing"), window.mathlive.readAloudAudio.play();
    });
  });
}
bn({
  showAlternateKeys: function showAlternateKeys(e, t) {
    var i;
    we();
    var r = An[t],
      n = document.createElement("div");
    n.setAttribute("aria-hidden", "true"), n.className = "ML__keyboard alternate-keys" + (e.element.classList.contains("material") ? " material" : ""), n.id = "mathlive-alternate-keys-panel", r.length >= 14 ? n.style.width = "236px" : r.length >= 7 ? n.style.width = "286px" : 4 === r.length || 2 === r.length ? n.style.width = "146px" : 1 === r.length ? n.style.width = "86px" : n.style.width = "146px", n.style.height = "auto";
    var a = "";
    var _iterator94 = _createForOfIteratorHelper(r),
      _step94;
    try {
      for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
        var _e152 = _step94.value;
        a += "<li", "string" == typeof _e152 ? a += ' data-latex="' + _e152.replace(/"/g, "&quot;") + '"' : (_e152.latex && (a += ' data-latex="' + _e152.latex.replace(/"/g, "&quot;") + '"'), _e152.content && (a += ' data-content="' + _e152.content.replace(/"/g, "&quot;") + '"'), _e152.insert && (a += ' data-insert="' + _e152.insert.replace(/"/g, "&quot;") + '"'), _e152.command && ("string" == typeof _e152.command ? a += " data-command=\"".concat(_e152.command.replace(/"/g, "&quot;"), "\"") : a += " data-command='" + JSON.stringify(_e152.command).replace(/"/g, "&quot;") + "'"), _e152.aside && (a += " data-aside=\"".concat(_e152.aside.replace(/"/g, "&quot;"), "\"")), _e152.class && (a += " data-classes=\"".concat(_e152.class, "\""))), a += ">", a += "string" == typeof _e152 ? _e152 : null !== (i = _e152.label) && void 0 !== i ? i : "", a += "</li>";
      }
    } catch (err) {
      _iterator94.e(err);
    } finally {
      _iterator94.f();
    }
    a = "<ul>" + a + "</ul>", n.innerHTML = e.options.createHTML(a), Dn(e, _toConsumableArray(n.querySelectorAll("li")), "performAlternateKeys"), null === wn && (wn = new xn()), wn.open({
      root: e.options.virtualKeyboardContainer,
      child: n
    });
    var o = null == e ? void 0 : e.element.querySelector('div.keyboard-layer.is-visible div.rows ul li[data-alt-keys="' + t + '"]'),
      s = null == o ? void 0 : o.getBoundingClientRect();
    if (s) {
      s.top - n.clientHeight < 0 && (n.style.width = "auto", r.length <= 6 ? n.style.height = "56px" : r.length <= 12 ? n.style.height = "108px" : r.length <= 18 ? n.style.height = "205px" : n.classList.add("compact"));
      var _e151 = (s.top - n.clientHeight + 5).toString() + "px",
        _t128 = Math.max(0, Math.min(window.innerWidth - n.offsetWidth, (s.left + s.right - n.offsetWidth) / 2)) + "px";
      n.style.transform = "translate(" + _t128 + "," + _e151 + ")", n.classList.add("is-visible");
    }
    return !1;
  }
}, {
  target: "virtual-keyboard"
}), bn({
  shiftKeyboardLayer: function shiftKeyboardLayer(t) {
    var i = null == t ? void 0 : t.element.querySelectorAll("div.keyboard-layer.is-visible .rows .keycap, div.keyboard-layer.is-visible .rows .action");
    if (i) {
      var _iterator95 = _createForOfIteratorHelper(i),
        _step95;
      try {
        for (_iterator95.s(); !(_step95 = _iterator95.n()).done;) {
          var _r37 = _step95.value;
          var _i113 = _r37.getAttribute("data-shifted");
          if (_i113 || /^[a-z]$/.test(_r37.innerHTML)) {
            _r37.dataset.unshiftedContent = _r37.innerHTML, _i113 || (_i113 = _r37.innerHTML.toUpperCase()), _r37.innerHTML = t.options.createHTML(_i113);
            var _n27 = _r37.getAttribute("data-command");
            if (_n27) {
              _r37.dataset.unshiftedCommand = _n27;
              var _t129 = _r37.getAttribute("data-shifted-command");
              if (_t129) _r37.dataset.command = _t129;else {
                var _t130 = JSON.parse(_n27);
                e(_t130) && (_t130[1] = _t130[1].toUpperCase()), _r37.dataset.command = JSON.stringify(_t130);
              }
            }
          }
        }
      } catch (err) {
        _iterator95.e(err);
      } finally {
        _iterator95.f();
      }
    }
    return !1;
  }
}, {
  target: "virtual-keyboard"
}), bn({
  hideAlternateKeys: function hideAlternateKeys() {
    return _n();
  },
  performAlternateKeys: function performAlternateKeys(e, t) {
    return _n(), e.executeCommand(t);
  },
  switchKeyboardLayer: function switchKeyboardLayer(e, t) {
    return On(e, t);
  },
  unshiftKeyboardLayer: function unshiftKeyboardLayer(e) {
    return Tn(e);
  },
  insertAndUnshiftKeyboardLayer: function insertAndUnshiftKeyboardLayer(e, t) {
    return e.executeCommand(["insert", t]), Tn(e), !0;
  }
}, {
  target: "virtual-keyboard"
}), bn({
  toggleVirtualKeyboardAlt: function toggleVirtualKeyboardAlt(e) {
    var t = !1;
    return (null == e ? void 0 : e.element) && (t = null == e ? void 0 : e.element.classList.contains("material"), e.disable()), Bn(e, t ? "" : "material"), !1;
  },
  toggleVirtualKeyboardShift: function toggleVirtualKeyboardShift(e) {
    var t, i;
    e.options.virtualKeyboardLayout = {
      qwerty: "azerty",
      azerty: "qwertz",
      qwertz: "dvorak",
      dvorak: "colemak",
      colemak: "qwerty"
    }[e.options.virtualKeyboardLayout];
    var r = null !== (i = null === (t = null == e ? void 0 : e.element.querySelector("div.keyboard-layer.is-visible")) || void 0 === t ? void 0 : t.id) && void 0 !== i ? i : "";
    return e && e.disable(), Bn(e), r && On(e, r), !1;
  }
}, {
  target: "virtual-keyboard"
}), bn({
  toggleVirtualKeyboard: function toggleVirtualKeyboard(e, t) {
    return Kn(e, t);
  },
  hideVirtualKeyboard: function hideVirtualKeyboard(e) {
    return function (e) {
      return e.visible = !0, Kn(e), !1;
    }(e);
  },
  showVirtualKeyboard: function showVirtualKeyboard(e, t) {
    return Bn(e, t);
  },
  onUndoStateChanged: function onUndoStateChanged(e, t, i) {
    return function (e, t, i) {
      var r;
      var n = null === (r = e.element) || void 0 === r ? void 0 : r.querySelector(".keyboard-toolbar");
      if (!n) return !1;
      var a = n.querySelector("[data-command='\"undo\"']"),
        o = n.querySelector("[data-command='\"redo\"']");
      return o && (i ? o.classList.remove("disabled") : o.classList.add("disabled")), a && (t ? a.classList.remove("disabled") : a.classList.add("disabled")), !1;
    }(e, t, i);
  }
}, {
  target: "virtual-keyboard"
}), bn({
  speak: function speak(e, t, i) {
    return function (e, t, i) {
      var r, n;
      i = null != i ? i : {
        withHighlighting: !1
      };
      var a = e.model,
        o = function (e) {
          var t = null;
          switch (e) {
            default:
              t = a.root;
              break;
            case "selection":
              t = a.getAtoms(a.selection);
              break;
            case "left":
              t = a.getAtoms(a.offsetOf(a.at(a.position).leftSibling), a.position);
              break;
            case "right":
              t = a.getAtoms(a.position, a.offsetOf(a.at(a.position).rightSibling));
              break;
            case "group":
              t = a.getAtoms(a.getSiblingsRange(a.position));
              break;
            case "parent":
              {
                var _a$at = a.at(a.position),
                  _e153 = _a$at.parent;
                t = _e153 && "root" !== _e153.type ? _e153 : a.root;
                break;
              }
          }
          return t;
        }(t);
      if (null === o) return null === (n = (r = e.options).speakHook) || void 0 === n || n.call(r, function (e) {
        var t = "";
        switch (e) {
          default:
            break;
          case "selection":
            t = "no selection";
            break;
          case "left":
            t = "at start";
            break;
          case "right":
            t = "at end";
            break;
          case "parent":
            t = "no parent";
        }
        return t;
      }(t), e.options), !1;
      var s = _objectSpread({}, e.options);
      (i.withHighlighting || "amazon" === s.speechEngine) && (s.textToSpeechMarkup = window.sre && "sre" === s.textToSpeechRules ? "ssml_step" : "ssml");
      var l = pr(o, s);
      return i.withHighlighting ? (window.mathlive.readAloudMathField = e, nn(e, {
        forHighlighting: !0
      }), e.options.readAloudHook && e.options.readAloudHook(e.field, l, e.options)) : e.options.speakHook && e.options.speakHook(l, s), !1;
    }(e, t, i);
  }
}, {
  target: "mathfield",
  category: "speech"
});
var Hn = function Hn() {};
function Un(e, t) {
  if (null == t || "none" === t || "null" === t) return null;
  if (t instanceof HTMLAudioElement) return t.load(), t;
  if (0 === (t = t.trim()).length) return null;
  var i = ni((void 0 === e || 0 === e.length ? "./sounds" : e) + "/" + t).toString(),
    r = new Audio();
  return r.src = i, r.volume = .5, r.load(), r;
}
function Wn(e) {
  e instanceof HTMLAudioElement && (e.pause(), e.removeAttribute("src"), e.load());
}
function Zn(t, i) {
  var r, n, a, o, s, l, c;
  var u = null !== (n = null !== (r = i.soundsDirectory) && void 0 !== r ? r : t.soundsDirectory) && void 0 !== n ? n : "./sounds",
    d = Gn(t, Object.keys(t));
  for (var _i114 = 0, _Object$keys12 = Object.keys(i); _i114 < _Object$keys12.length; _i114++) {
    var _t131 = _Object$keys12[_i114];
    switch (_t131) {
      case "scriptDepth":
        if (e(i.scriptDepth)) d.scriptDepth = [i.scriptDepth[0], i.scriptDepth[1]];else {
          if ("number" != typeof i.scriptDepth) throw new TypeError("Unexpected value for scriptDepth");
          d.scriptDepth = [i.scriptDepth, i.scriptDepth];
        }
        break;
      case "locale":
        d.locale = "auto" === i.locale ? null !== (a = ke() ? navigator.language.slice(0, 5) : null) && void 0 !== a ? a : "en" : i.locale, fr.locale = d.locale;
        break;
      case "strings":
        fr.merge(i.strings), d.strings = fr.strings;
        break;
      case "virtualKeyboardLayout":
        d.virtualKeyboardLayout = i.virtualKeyboardLayout;
        break;
      case "virtualKeyboardMode":
        "auto" === i.virtualKeyboardMode ? d.virtualKeyboardMode = _e() ? "onfocus" : "off" : d.virtualKeyboardMode = i.virtualKeyboardMode;
        break;
      case "customVirtualKeyboardLayers":
        d.customVirtualKeyboardLayers = _objectSpread(_objectSpread({}, d.customVirtualKeyboardLayers), i.customVirtualKeyboardLayers);
        break;
      case "customVirtualKeyboards":
        d.customVirtualKeyboards = _objectSpread(_objectSpread({}, d.customVirtualKeyboards), i.customVirtualKeyboards);
        break;
      case "letterShapeStyle":
        "auto" === i.letterShapeStyle ? fr.locale.startsWith("fr") ? d.letterShapeStyle = "french" : d.letterShapeStyle = "tex" : d.letterShapeStyle = i.letterShapeStyle;
        break;
      case "plonkSound":
        Wn(d.plonkSound), d.plonkSound = Un(u, i.plonkSound);
        break;
      case "keypressSound":
        if ("object" == typeof d.keypressSound && null !== d.keypressSound && "default" in d.keypressSound && (Wn(d.keypressSound.default), Wn(d.keypressSound.delete), Wn(d.keypressSound.return), Wn(d.keypressSound.spacebar)), null === i.keypressSound) d.keypressSound = {
          default: null,
          delete: null,
          return: null,
          spacebar: null
        };else if ("string" == typeof i.keypressSound) {
          var _e154 = Un(u, i.keypressSound);
          d.keypressSound = {
            delete: _e154,
            return: _e154,
            spacebar: _e154,
            default: _e154
          };
        } else i.keypressSound instanceof HTMLAudioElement ? d.keypressSound = {
          delete: i.keypressSound,
          return: i.keypressSound,
          spacebar: i.keypressSound,
          default: i.keypressSound
        } : "object" == typeof i.keypressSound && "default" in i.keypressSound && (d.keypressSound = _objectSpread({}, i.keypressSound), d.keypressSound.default = Un(u, d.keypressSound.default), d.keypressSound.delete = null !== (o = Un(u, d.keypressSound.delete)) && void 0 !== o ? o : i.keypressSound.default, d.keypressSound.return = null !== (s = Un(u, d.keypressSound.return)) && void 0 !== s ? s : i.keypressSound.default, d.keypressSound.spacebar = null !== (l = Un(u, d.keypressSound.spacebar)) && void 0 !== l ? l : i.keypressSound.default);
        break;
      case "virtualKeyboardContainer":
        d.virtualKeyboardContainer = i.virtualKeyboardContainer;
        break;
      case "macros":
        d.macros = null !== (c = Qe(i.macros)) && void 0 !== c ? c : {};
        break;
      case "onBlur":
      case "onFocus":
      case "onContentWillChange":
      case "onContentDidChange":
      case "onSelectionWillChange":
      case "onSelectionDidChange":
      case "onUndoStateWillChange":
      case "onUndoStateDidChange":
      case "onModeChange":
      case "onCommit":
      case "onReadAloudStatus":
      case "onError":
        if (null === i[_t131]) d[_t131] = Hn;else if ("function" != typeof i[_t131]) throw new TypeError(_t131 + " must be a function or null");
        d[_t131] = i[_t131];
        break;
      default:
        e(i[_t131]) ? d[_t131] = _toConsumableArray(i[_t131]) : "object" == typeof i[_t131] ? d[_t131] = _objectSpread({}, i[_t131]) : d[_t131] = i[_t131];
    }
  }
  return d;
}
function Gn(t, i) {
  var r;
  r = "string" == typeof i ? [i] : void 0 === i ? Object.keys(t) : i;
  var n = {};
  var _iterator96 = _createForOfIteratorHelper(r),
    _step96;
  try {
    for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
      var _i115 = _step96.value;
      e(t[_i115]) ? n[_i115] = _toConsumableArray(t[_i115]) : t[_i115] instanceof HTMLElement ? n[_i115] = t[_i115] : null === t[_i115] ? n[_i115] = null : "object" == typeof t[_i115] ? n[_i115] = _objectSpread({}, t[_i115]) : n[_i115] = t[_i115];
    }
  } catch (err) {
    _iterator96.e(err);
  } finally {
    _iterator96.f();
  }
  return "string" == typeof i ? n[i] : n;
}
var Xn = '<span style="width: 21px; margin-top: 4px;"><svg style="width: 21px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm16 336c0 8.823-7.177 16-16 16H48c-8.823 0-16-7.177-16-16V112c0-8.823 7.177-16 16-16h480c8.823 0 16 7.177 16 16v288zM168 268v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm-336 80v-24c0-6.627-5.373-12-12-12H84c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm384 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zM120 188v-24c0-6.627-5.373-12-12-12H84c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm-96 152v-8c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"/></svg></span>';
function Yn() {
  var e, t, i, r;
  return {
    readOnly: !1,
    createHTML: function createHTML(e) {
      return e;
    },
    fontsDirectory: "./fonts",
    soundsDirectory: "./sounds",
    defaultMode: "math",
    macros: Xe(),
    registers: _objectSpread({}, Hr()),
    colorMap: s,
    backgroundColorMap: l,
    horizontalSpacingScale: 1,
    letterShapeStyle: fr.locale.startsWith("fr") ? "french" : "tex",
    smartMode: !1,
    smartFence: !0,
    smartSuperscript: !0,
    scriptDepth: [1 / 0, 1 / 0],
    removeExtraneousParentheses: !0,
    mathModeSpace: "",
    locale: null !== (e = fr.locale) && void 0 !== e ? e : "en",
    strings: fr.strings,
    keybindings: Li,
    inlineShortcuts: ui,
    inlineShortcutTimeout: 0,
    virtualKeyboardToggleGlyph: Xn,
    virtualKeyboardMode: "auto",
    virtualKeyboards: "all",
    virtualKeyboardLayout: "auto",
    customVirtualKeyboardLayers: {},
    customVirtualKeyboards: {},
    virtualKeyboardTheme: ke() && /android|cros/i.test(navigator.userAgent) ? "material" : "apple",
    keypressVibration: !0,
    keypressSound: null,
    plonkSound: null,
    virtualKeyboardToolbar: "default",
    virtualKeyboardContainer: null !== (i = null === (t = globalThis.document) || void 0 === t ? void 0 : t.body) && void 0 !== i ? i : null,
    useSharedVirtualKeyboard: !1,
    sharedVirtualKeyboardTargetOrigin: null === (r = globalThis.window) || void 0 === r ? void 0 : r.origin,
    originValidator: "same-origin",
    textToSpeechRules: "mathlive",
    textToSpeechMarkup: "",
    textToSpeechRulesOptions: {},
    speechEngine: "local",
    speechEngineVoice: "Joanna",
    speechEngineRate: "100%",
    speakHook: $n,
    readAloudHook: jn,
    onAnnounce: In,
    onKeystroke: function onKeystroke() {
      return !0;
    },
    onMoveOutOf: function onMoveOutOf() {
      return !0;
    },
    onTabOutOf: function onTabOutOf() {
      return !0;
    },
    onPlaceholderDidChange: function onPlaceholderDidChange() {},
    onBlur: Hn,
    onFocus: Hn,
    onContentWillChange: Hn,
    onContentDidChange: Hn,
    onSelectionWillChange: Hn,
    onSelectionDidChange: Hn,
    onUndoStateWillChange: Hn,
    onUndoStateDidChange: Hn,
    onModeChange: Hn,
    onReadAloudStatus: Hn,
    onCommit: Hn,
    onExport: ln,
    onError: function onError() {},
    value: ""
  };
}
function Qn(e) {
  return "inline-math" === e.defaultMode ? "math" : e.defaultMode;
}
var Jn = /*#__PURE__*/function () {
  function Jn(e) {
    _classCallCheck(this, Jn);
    var t, i;
    this.targetOrigin = null !== (t = e.targetOrigin) && void 0 !== t ? t : window.origin, this.originValidator = null !== (i = e.originValidator) && void 0 !== i ? i : "same-origin", this._mathfield = e.mathfield, this.enable();
  }
  _createClass(Jn, [{
    key: "setOptions",
    value: function setOptions(e) {}
  }, {
    key: "create",
    value: function create() {}
  }, {
    key: "dispose",
    value: function dispose() {
      this.disable();
    }
  }, {
    key: "enable",
    value: function enable() {
      this.enabled || (this.enabled = !0, window.addEventListener("message", this));
    }
  }, {
    key: "disable",
    value: function disable() {
      this.enabled && (window.removeEventListener("message", this), this.enabled = !1);
    }
  }, {
    key: "executeCommand",
    value: function executeCommand(e) {
      var t;
      return "virtual-keyboard" === vn(e) ? (this.sendMessage("executeCommand", {
        command: e
      }), !1) : null === (t = this._mathfield) || void 0 === t ? void 0 : t.executeCommand(e);
    }
  }, {
    key: "focusMathfield",
    value: function focusMathfield() {}
  }, {
    key: "blurMathfield",
    value: function blurMathfield() {}
  }, {
    key: "stateChanged",
    value: function stateChanged() {}
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      var t, i, r, n;
      if ("message" === e.type && e.data && "ml#systemPostMessage" === e.data.type) {
        if (!Ar(e.origin, this.originValidator)) throw new Error("Message from unknown origin (".concat(e.origin, ") cannot be handled"));
        var _a19 = e.data.action;
        "executeCommand" === _a19 ? this.executeCommand(e.data.command) : "updateState" === _a19 ? (this.visible = e.data.state.visible, this.height = e.data.state.height) : "focus" === _a19 ? null === (i = null === (t = this._mathfield) || void 0 === t ? void 0 : t.focus) || void 0 === i || i.call(t) : "blur" === _a19 && (null === (n = null === (r = this._mathfield) || void 0 === r ? void 0 : r.blur) || void 0 === n || n.call(r));
      }
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return !!window.parent && (window.parent.postMessage(_objectSpread({
        type: "ml#systemPostMessage",
        action: e
      }, t), this.targetOrigin), !0);
    }
  }]);
  return Jn;
}();
var ea = /*#__PURE__*/function (_Mn) {
  _inherits(ea, _Mn);
  var _super33 = _createSuper(ea);
  function ea(e) {
    var _this34;
    _classCallCheck(this, ea);
    _this34 = _super33.call(this, _objectSpread(_objectSpread({}, ea.defaultOptions), null != e ? e : {})), window.addEventListener("message", _assertThisInitialized(_this34));
    return _this34;
  }
  _createClass(ea, [{
    key: "handleEvent",
    value: function handleEvent(e) {
      if ("message" === e.type && e.data && "ml#systemPostMessage" === e.data.type) {
        if (!Ar(e.origin, this.options.originValidator)) throw new Error("Can not handle message from unknown origin (".concat(e.origin, ")."));
        var _t132 = e.data.action;
        if ("executeCommand" === _t132) {
          var _t133 = e.data.command;
          this.sourceFrame = e.source, this.executeCommand(_t133);
        }
      }
    }
  }, {
    key: "stateChanged",
    value: function stateChanged() {
      var e, t;
      this.sendMessage("stateChanged", {
        state: {
          visible: this.visible,
          height: null !== (t = null === (e = this.element) || void 0 === e ? void 0 : e.offsetHeight) && void 0 !== t ? t : 0
        }
      });
    }
  }, {
    key: "executeCommand",
    value: function executeCommand(e) {
      return "virtual-keyboard" === vn(e) ? _get(_getPrototypeOf(ea.prototype), "executeCommand", this).call(this, e) : (this.sendMessage("executeCommand", {
        command: e
      }), !1);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.sendMessage("focus");
    }
  }, {
    key: "blur",
    value: function blur() {
      this.sendMessage("blur");
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return this.canUndoState;
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return this.canRedoState;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      window.removeEventListener("message", this);
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i;
      null === (i = this.sourceFrame) || void 0 === i || i.postMessage(_objectSpread({
        type: "ml#systemPostMessage",
        action: e
      }, t), this.options.targetOrigin);
    }
  }], [{
    key: "defaultOptions",
    get: function get() {
      var e, t;
      return {
        createHTML: function createHTML(e) {
          return e;
        },
        fontsDirectory: "./fonts",
        soundsDirectory: "./sounds",
        targetOrigin: window.origin,
        originValidator: "same-origin",
        virtualKeyboards: "all",
        virtualKeyboardLayout: "auto",
        customVirtualKeyboardLayers: {},
        customVirtualKeyboards: {},
        virtualKeyboardTheme: /macos|ios/.test(Se()) ? "apple" : "material",
        keypressVibration: !0,
        keypressSound: null,
        plonkSound: null,
        virtualKeyboardToolbar: "default",
        virtualKeyboardToggleGlyph: Xn,
        virtualKeyboardMode: "auto",
        virtualKeyboardContainer: null !== (t = null === (e = globalThis.document) || void 0 === e ? void 0 : e.body) && void 0 !== t ? t : null
      };
    }
  }]);
  return ea;
}(Mn);
function ta(e) {
  return "number" == typeof e && !Number.isNaN(e);
}
function ia(e) {
  return Array.isArray(e) && 2 === e.length;
}
function ra(e) {
  return null != e && "object" == typeof e && "ranges" in e && Array.isArray(e.ranges);
}
var na = [127462, 127487];
function aa(e) {
  return 8205 === e || 65038 === e || 65039 === e || e >= 127995 && e <= 128e3 || e >= 129456 && e <= 129460 || e >= 917536 && e <= 917632;
}
function oa(e) {
  return e >= na[0] && e <= na[1];
}
var sa = /*#__PURE__*/function () {
  function sa(e) {
    _classCallCheck(this, sa);
    this.obeyspaces = !1, this.s = function (e) {
      if (/^[\u0020-\u00FF]*$/.test(e)) return e;
      var t = [],
        i = function (e) {
          var t = [];
          for (var _i116 = 0; _i116 < e.length; _i116++) {
            var _r38 = e.charCodeAt(_i116);
            if (_r38 >= 55296 && _r38 <= 56319) {
              var _t134 = e.charCodeAt(_i116 + 1);
              _t134 >= 56320 && _t134 <= 57343 && (_r38 = 65536 + 1024 * (_r38 - 55296) + (_t134 - 56320), _i116++);
            }
            t.push(_r38);
          }
          return t;
        }(e);
      var r = 0;
      for (; r < i.length;) {
        var _e155 = i[r++],
          _n28 = i[r];
        if (8205 === _n28) {
          var _e156 = r - 1;
          for (r += 2; 8205 === i[r];) r += 2;
          t.push(String.fromCodePoint.apply(String, _toConsumableArray(i.slice(_e156, 2 * r - _e156 + 1))));
        } else if (aa(_n28)) {
          var _e157 = r - 1;
          for (; aa(i[r]);) r += 8205 === i[r] ? 2 : 1;
          t.push(String.fromCodePoint.apply(String, _toConsumableArray(i.slice(_e157, 2 * r - _e157 - 1))));
        } else oa(_e155) ? (r += 1, t.push(String.fromCodePoint.apply(String, _toConsumableArray(i.slice(r - 2, 2))))) : t.push(String.fromCodePoint(_e155));
      }
      return t;
    }(e), this.pos = 0;
  }
  _createClass(sa, [{
    key: "end",
    value: function end() {
      return this.pos >= this.s.length;
    }
  }, {
    key: "get",
    value: function get() {
      return this.pos < this.s.length ? this.s[this.pos++] : "";
    }
  }, {
    key: "peek",
    value: function peek() {
      return this.s[this.pos];
    }
  }, {
    key: "match",
    value: function match(e) {
      var t;
      return t = "string" == typeof this.s ? e.exec(this.s.slice(this.pos)) : e.exec(this.s.slice(this.pos).join("")), (null == t ? void 0 : t[0]) ? (this.pos += t[0].length, t[0]) : null;
    }
  }, {
    key: "next",
    value: function next() {
      if (this.end()) return null;
      if (!this.obeyspaces && this.match(/^[ \f\n\r\t\v\xA0\u2028\u2029]+/)) return "<space>";
      if (this.obeyspaces && this.match(/^[ \f\n\r\t\v\xA0\u2028\u2029]/)) return "<space>";
      var e = this.get();
      if ("\\" === e) {
        if (!this.end()) {
          var _e158 = this.match(/^[a-zA-Z*]+/);
          if (_e158) this.match(/^[ \f\n\r\t\v\xA0\u2028\u2029]*/);else if (_e158 = this.get(), " " === _e158) return "<space>";
          return "\\" + _e158;
        }
      } else {
        if ("{" === e) return "<{>";
        if ("}" === e) return "<}>";
        if ("^" === e) {
          if ("^" === this.peek()) {
            this.get();
            var _e159 = this.match(/^(\^(\^(\^(\^[0-9a-f])?[0-9a-f])?[0-9a-f])?[0-9a-f])?[0-9a-f][0-9a-f]/);
            if (_e159) return String.fromCodePoint(parseInt(_e159.slice(_e159.lastIndexOf("^") + 1), 16));
          }
          return e;
        }
        if ("#" === e) {
          if (!this.end()) {
            var _e160 = !1;
            if (/[0-9?]/.test(this.peek()) && (_e160 = !0, this.pos + 1 < this.s.length)) {
              var _t135 = this.s[this.pos + 1];
              _e160 = /[^0-9A-Za-z]/.test(_t135);
            }
            return _e160 ? "#" + this.get() : "#";
          }
        } else if ("$" === e) return "$" === this.peek() ? (this.get(), "<$$>") : "<$>";
      }
      return e;
    }
  }]);
  return sa;
}();
function la(e, t) {
  var i, r, n, a;
  var o = [],
    s = e.next();
  if (s) if ("\\relax" === s) ;else if ("\\noexpand" === s) s = e.next(), s && o.push(s);else if ("\\obeyspaces" === s) e.obeyspaces = !0;else if ("\\space" === s || "~" === s) o.push("<space>");else if ("\\bgroup" === s) o.push("<{>");else if ("\\egroup" === s) o.push("<}>");else if ("\\string" === s) s = e.next(), s && ("\\" === s[0] ? Array.from(s).forEach(function (e) {
    return o.push("\\" === e ? "\\backslash" : e);
  }) : "<{>" === s ? o.push("\\{") : "<space>" === s ? o.push("~") : "<}>" === s && o.push("\\}"));else if ("\\csname" === s) {
    for (; "<space>" === e.peek();) e.next();
    var _n29 = "",
      _a20 = !1,
      _l8 = [];
    do {
      if (0 === _l8.length) if (/^#[0-9?]$/.test(e.peek())) {
        var _n30 = e.get().slice(1);
        _l8 = ca(null !== (r = null !== (i = null == t ? void 0 : t[_n30]) && void 0 !== i ? i : null == t ? void 0 : t["?"]) && void 0 !== r ? r : "\\placeholder{}", t), s = _l8[0];
      } else s = e.next(), _l8 = s ? [s] : [];
      _a20 = 0 === _l8.length, _a20 || "\\endcsname" !== s || (_a20 = !0, _l8.shift()), _a20 || (_a20 = "<$>" === s || "<$$>" === s || "<{>" === s || "<}>" === s || !!s && s.length > 1 && "\\" === s[0]), _a20 || (_n29 += _l8.shift());
    } while (!_a20);
    _n29 && o.push("\\" + _n29), o = o.concat(_l8);
  } else if ("\\endcsname" === s) ;else if (s.length > 1 && "#" === s[0]) {
    var _e161 = s.slice(1);
    o = o.concat(ca(null !== (a = null !== (n = null == t ? void 0 : t[_e161]) && void 0 !== n ? n : null == t ? void 0 : t["?"]) && void 0 !== a ? a : "\\placeholder{}", t));
  } else o.push(s);
  return o;
}
function ca(e, t) {
  var i = e.toString().split(/\r?\n/);
  var r = "",
    n = "";
  var _iterator97 = _createForOfIteratorHelper(i),
    _step97;
  try {
    for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
      var _e162 = _step97.value;
      r += n, n = " ";
      var _t136 = _e162.match(/((?:\\%)|[^%])*/);
      null !== _t136 && (r += _t136[0]);
    }
  } catch (err) {
    _iterator97.e(err);
  } finally {
    _iterator97.f();
  }
  var a = new sa(r);
  var o = [];
  do {
    o = o.concat(la(a, t));
  } while (!a.end());
  return o;
}
function ua(e) {
  var t = "",
    i = "";
  var _iterator98 = _createForOfIteratorHelper(e),
    _step98;
  try {
    for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
      var _r39 = _step98.value;
      _r39 && (/[a-zA-Z*]/.test(_r39[0]) && (i += t), t = /\\[a-zA-Z]+\*?$/.test(_r39) ? " " : "", i += _r39);
    }
  } catch (err) {
    _iterator98.e(err);
  } finally {
    _iterator98.f();
  }
  return i;
}
function da(e) {
  var t = [];
  if (Array.isArray(e)) {
    var _iterator99 = _createForOfIteratorHelper(e),
      _step99;
    try {
      for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
        var _i117 = _step99.value;
        Array.isArray(_i117) ? t = [].concat(_toConsumableArray(t), _toConsumableArray(_i117)) : t.push(_i117);
      }
    } catch (err) {
      _iterator99.e(err);
    } finally {
      _iterator99.f();
    }
  } else t = [e];
  return ua(t.map(function (e) {
    var t;
    return null !== (t = {
      "<space>": " ",
      "<$$>": "$$",
      "<$>": "$",
      "<{>": "{",
      "<}>": "}"
    }[e]) && void 0 !== t ? t : e;
  }));
}
var ha,
  pa = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
  ma = {
    exports: {}
  };
ha = ma, function (e) {
  var t,
    i,
    r,
    n,
    a = 9e15,
    o = 1e9,
    s = "0123456789abcdef",
    l = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058",
    c = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789",
    u = {
      precision: 20,
      rounding: 4,
      modulo: 1,
      toExpNeg: -7,
      toExpPos: 21,
      minE: -a,
      maxE: a,
      crypto: !1
    },
    d = !0,
    h = "[DecimalError] ",
    p = h + "Invalid argument: ",
    m = h + "Precision limit exceeded",
    f = h + "crypto unavailable",
    g = Math.floor,
    y = Math.pow,
    b = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i,
    v = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i,
    x = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i,
    k = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
    w = 1e7,
    _ = l.length - 1,
    M = c.length - 1,
    S = {
      name: "[object Decimal]"
    };
  function L(e) {
    var t,
      i,
      r,
      n = e.length - 1,
      a = "",
      o = e[0];
    if (n > 0) {
      for (a += o, t = 1; t < n; t++) (i = 7 - (r = e[t] + "").length) && (a += K(i)), a += r;
      (i = 7 - (r = (o = e[t]) + "").length) && (a += K(i));
    } else if (0 === o) return "0";
    for (; o % 10 == 0;) o /= 10;
    return a + o;
  }
  function C(e, t, i) {
    if (e !== ~~e || e < t || e > i) throw Error(p + e);
  }
  function A(e, t, i, r) {
    var n, a, o, s;
    for (a = e[0]; a >= 10; a /= 10) --t;
    return --t < 0 ? (t += 7, n = 0) : (n = Math.ceil((t + 1) / 7), t %= 7), a = y(10, 7 - t), s = e[n] % a | 0, null == r ? t < 3 ? (0 == t ? s = s / 100 | 0 : 1 == t && (s = s / 10 | 0), o = i < 4 && 99999 == s || i > 3 && 49999 == s || 5e4 == s || 0 == s) : o = (i < 4 && s + 1 == a || i > 3 && s + 1 == a / 2) && (e[n + 1] / a / 100 | 0) == y(10, t - 2) - 1 || (s == a / 2 || 0 == s) && 0 == (e[n + 1] / a / 100 | 0) : t < 4 ? (0 == t ? s = s / 1e3 | 0 : 1 == t ? s = s / 100 | 0 : 2 == t && (s = s / 10 | 0), o = (r || i < 4) && 9999 == s || !r && i > 3 && 4999 == s) : o = ((r || i < 4) && s + 1 == a || !r && i > 3 && s + 1 == a / 2) && (e[n + 1] / a / 1e3 | 0) == y(10, t - 3) - 1, o;
  }
  function N(e, t, i) {
    for (var r, n, a = [0], o = 0, l = e.length; o < l;) {
      for (n = a.length; n--;) a[n] *= t;
      for (a[0] += s.indexOf(e.charAt(o++)), r = 0; r < a.length; r++) a[r] > i - 1 && (void 0 === a[r + 1] && (a[r + 1] = 0), a[r + 1] += a[r] / i | 0, a[r] %= i);
    }
    return a.reverse();
  }
  S.absoluteValue = S.abs = function () {
    var e = new this.constructor(this);
    return e.s < 0 && (e.s = 1), q(e);
  }, S.ceil = function () {
    return q(new this.constructor(this), this.e + 1, 2);
  }, S.comparedTo = S.cmp = function (e) {
    var t,
      i,
      r,
      n,
      a = this,
      o = a.d,
      s = (e = new a.constructor(e)).d,
      l = a.s,
      c = e.s;
    if (!o || !s) return l && c ? l !== c ? l : o === s ? 0 : !o ^ l < 0 ? 1 : -1 : NaN;
    if (!o[0] || !s[0]) return o[0] ? l : s[0] ? -c : 0;
    if (l !== c) return l;
    if (a.e !== e.e) return a.e > e.e ^ l < 0 ? 1 : -1;
    for (t = 0, i = (r = o.length) < (n = s.length) ? r : n; t < i; ++t) if (o[t] !== s[t]) return o[t] > s[t] ^ l < 0 ? 1 : -1;
    return r === n ? 0 : r > n ^ l < 0 ? 1 : -1;
  }, S.cosine = S.cos = function () {
    var e,
      t,
      i = this,
      r = i.constructor;
    return i.d ? i.d[0] ? (e = r.precision, t = r.rounding, r.precision = e + Math.max(i.e, i.sd()) + 7, r.rounding = 1, i = function (e, t) {
      var i,
        r,
        n = t.d.length;
      n < 32 ? r = (1 / W(4, i = Math.ceil(n / 3))).toString() : (i = 16, r = "2.3283064365386962890625e-10"), e.precision += i, t = U(e, 1, t.times(r), new e(1));
      for (var a = i; a--;) {
        var o = t.times(t);
        t = o.times(o).minus(o).times(8).plus(1);
      }
      return e.precision -= i, t;
    }(r, Z(r, i)), r.precision = e, r.rounding = t, q(2 == n || 3 == n ? i.neg() : i, e, t, !0)) : new r(1) : new r(NaN);
  }, S.cubeRoot = S.cbrt = function () {
    var e,
      t,
      i,
      r,
      n,
      a,
      o,
      s,
      l,
      c,
      u = this,
      h = u.constructor;
    if (!u.isFinite() || u.isZero()) return new h(u);
    for (d = !1, (a = u.s * y(u.s * u, 1 / 3)) && Math.abs(a) != 1 / 0 ? r = new h(a.toString()) : (i = L(u.d), (a = ((e = u.e) - i.length + 1) % 3) && (i += 1 == a || -2 == a ? "0" : "00"), a = y(i, 1 / 3), e = g((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2)), (r = new h(i = a == 1 / 0 ? "5e" + e : (i = a.toExponential()).slice(0, i.indexOf("e") + 1) + e)).s = u.s), o = (e = h.precision) + 3;;) if (c = (l = (s = r).times(s).times(s)).plus(u), r = z(c.plus(u).times(s), c.plus(l), o + 2, 1), L(s.d).slice(0, o) === (i = L(r.d)).slice(0, o)) {
      if ("9999" != (i = i.slice(o - 3, o + 1)) && (n || "4999" != i)) {
        +i && (+i.slice(1) || "5" != i.charAt(0)) || (q(r, e + 1, 1), t = !r.times(r).times(r).eq(u));
        break;
      }
      if (!n && (q(s, e + 1, 0), s.times(s).times(s).eq(u))) {
        r = s;
        break;
      }
      o += 4, n = 1;
    }
    return d = !0, q(r, e, h.rounding, t);
  }, S.decimalPlaces = S.dp = function () {
    var e,
      t = this.d,
      i = NaN;
    if (t) {
      if (i = 7 * ((e = t.length - 1) - g(this.e / 7)), e = t[e]) for (; e % 10 == 0; e /= 10) i--;
      i < 0 && (i = 0);
    }
    return i;
  }, S.dividedBy = S.div = function (e) {
    return z(this, new this.constructor(e));
  }, S.dividedToIntegerBy = S.divToInt = function (e) {
    var t = this.constructor;
    return q(z(this, new t(e), 0, 1, 1), t.precision, t.rounding);
  }, S.equals = S.eq = function (e) {
    return 0 === this.cmp(e);
  }, S.floor = function () {
    return q(new this.constructor(this), this.e + 1, 3);
  }, S.greaterThan = S.gt = function (e) {
    return this.cmp(e) > 0;
  }, S.greaterThanOrEqualTo = S.gte = function (e) {
    var t = this.cmp(e);
    return 1 == t || 0 === t;
  }, S.hyperbolicCosine = S.cosh = function () {
    var e,
      t,
      i,
      r,
      n,
      a = this,
      o = a.constructor,
      s = new o(1);
    if (!a.isFinite()) return new o(a.s ? 1 / 0 : NaN);
    if (a.isZero()) return s;
    i = o.precision, r = o.rounding, o.precision = i + Math.max(a.e, a.sd()) + 4, o.rounding = 1, (n = a.d.length) < 32 ? t = (1 / W(4, e = Math.ceil(n / 3))).toString() : (e = 16, t = "2.3283064365386962890625e-10"), a = U(o, 1, a.times(t), new o(1), !0);
    for (var l, c = e, u = new o(8); c--;) l = a.times(a), a = s.minus(l.times(u.minus(l.times(u))));
    return q(a, o.precision = i, o.rounding = r, !0);
  }, S.hyperbolicSine = S.sinh = function () {
    var e,
      t,
      i,
      r,
      n = this,
      a = n.constructor;
    if (!n.isFinite() || n.isZero()) return new a(n);
    if (t = a.precision, i = a.rounding, a.precision = t + Math.max(n.e, n.sd()) + 4, a.rounding = 1, (r = n.d.length) < 3) n = U(a, 2, n, n, !0);else {
      e = (e = 1.4 * Math.sqrt(r)) > 16 ? 16 : 0 | e, n = U(a, 2, n = n.times(1 / W(5, e)), n, !0);
      for (var o, s = new a(5), l = new a(16), c = new a(20); e--;) o = n.times(n), n = n.times(s.plus(o.times(l.times(o).plus(c))));
    }
    return a.precision = t, a.rounding = i, q(n, t, i, !0);
  }, S.hyperbolicTangent = S.tanh = function () {
    var e,
      t,
      i = this,
      r = i.constructor;
    return i.isFinite() ? i.isZero() ? new r(i) : (e = r.precision, t = r.rounding, r.precision = e + 7, r.rounding = 1, z(i.sinh(), i.cosh(), r.precision = e, r.rounding = t)) : new r(i.s);
  }, S.inverseCosine = S.acos = function () {
    var e,
      t = this,
      i = t.constructor,
      r = t.abs().cmp(1),
      n = i.precision,
      a = i.rounding;
    return -1 !== r ? 0 === r ? t.isNeg() ? O(i, n, a) : new i(0) : new i(NaN) : t.isZero() ? O(i, n + 4, a).times(.5) : (i.precision = n + 6, i.rounding = 1, t = t.asin(), e = O(i, n + 4, a).times(.5), i.precision = n, i.rounding = a, e.minus(t));
  }, S.inverseHyperbolicCosine = S.acosh = function () {
    var e,
      t,
      i = this,
      r = i.constructor;
    return i.lte(1) ? new r(i.eq(1) ? 0 : NaN) : i.isFinite() ? (e = r.precision, t = r.rounding, r.precision = e + Math.max(Math.abs(i.e), i.sd()) + 4, r.rounding = 1, d = !1, i = i.times(i).minus(1).sqrt().plus(i), d = !0, r.precision = e, r.rounding = t, i.ln()) : new r(i);
  }, S.inverseHyperbolicSine = S.asinh = function () {
    var e,
      t,
      i = this,
      r = i.constructor;
    return !i.isFinite() || i.isZero() ? new r(i) : (e = r.precision, t = r.rounding, r.precision = e + 2 * Math.max(Math.abs(i.e), i.sd()) + 6, r.rounding = 1, d = !1, i = i.times(i).plus(1).sqrt().plus(i), d = !0, r.precision = e, r.rounding = t, i.ln());
  }, S.inverseHyperbolicTangent = S.atanh = function () {
    var e,
      t,
      i,
      r,
      n = this,
      a = n.constructor;
    return n.isFinite() ? n.e >= 0 ? new a(n.abs().eq(1) ? n.s / 0 : n.isZero() ? n : NaN) : (e = a.precision, t = a.rounding, r = n.sd(), Math.max(r, e) < 2 * -n.e - 1 ? q(new a(n), e, t, !0) : (a.precision = i = r - n.e, n = z(n.plus(1), new a(1).minus(n), i + e, 1), a.precision = e + 4, a.rounding = 1, n = n.ln(), a.precision = e, a.rounding = t, n.times(.5))) : new a(NaN);
  }, S.inverseSine = S.asin = function () {
    var e,
      t,
      i,
      r,
      n = this,
      a = n.constructor;
    return n.isZero() ? new a(n) : (t = n.abs().cmp(1), i = a.precision, r = a.rounding, -1 !== t ? 0 === t ? ((e = O(a, i + 4, r).times(.5)).s = n.s, e) : new a(NaN) : (a.precision = i + 6, a.rounding = 1, n = n.div(new a(1).minus(n.times(n)).sqrt().plus(1)).atan(), a.precision = i, a.rounding = r, n.times(2)));
  }, S.inverseTangent = S.atan = function () {
    var e,
      t,
      i,
      r,
      n,
      a,
      o,
      s,
      l,
      c = this,
      u = c.constructor,
      h = u.precision,
      p = u.rounding;
    if (c.isFinite()) {
      if (c.isZero()) return new u(c);
      if (c.abs().eq(1) && h + 4 <= M) return (o = O(u, h + 4, p).times(.25)).s = c.s, o;
    } else {
      if (!c.s) return new u(NaN);
      if (h + 4 <= M) return (o = O(u, h + 4, p).times(.5)).s = c.s, o;
    }
    for (u.precision = s = h + 10, u.rounding = 1, e = i = Math.min(28, s / 7 + 2 | 0); e; --e) c = c.div(c.times(c).plus(1).sqrt().plus(1));
    for (d = !1, t = Math.ceil(s / 7), r = 1, l = c.times(c), o = new u(c), n = c; -1 !== e;) if (n = n.times(l), a = o.minus(n.div(r += 2)), n = n.times(l), void 0 !== (o = a.plus(n.div(r += 2))).d[t]) for (e = t; o.d[e] === a.d[e] && e--;);
    return i && (o = o.times(2 << i - 1)), d = !0, q(o, u.precision = h, u.rounding = p, !0);
  }, S.isFinite = function () {
    return !!this.d;
  }, S.isInteger = S.isInt = function () {
    return !!this.d && g(this.e / 7) > this.d.length - 2;
  }, S.isNaN = function () {
    return !this.s;
  }, S.isNegative = S.isNeg = function () {
    return this.s < 0;
  }, S.isPositive = S.isPos = function () {
    return this.s > 0;
  }, S.isZero = function () {
    return !!this.d && 0 === this.d[0];
  }, S.lessThan = S.lt = function (e) {
    return this.cmp(e) < 0;
  }, S.lessThanOrEqualTo = S.lte = function (e) {
    return this.cmp(e) < 1;
  }, S.logarithm = S.log = function (e) {
    var t,
      i,
      r,
      n,
      a,
      o,
      s,
      l,
      c = this,
      u = c.constructor,
      h = u.precision,
      p = u.rounding;
    if (null == e) e = new u(10), t = !0;else {
      if (i = (e = new u(e)).d, e.s < 0 || !i || !i[0] || e.eq(1)) return new u(NaN);
      t = e.eq(10);
    }
    if (i = c.d, c.s < 0 || !i || !i[0] || c.eq(1)) return new u(i && !i[0] ? -1 / 0 : 1 != c.s ? NaN : i ? 0 : 1 / 0);
    if (t) if (i.length > 1) a = !0;else {
      for (n = i[0]; n % 10 == 0;) n /= 10;
      a = 1 !== n;
    }
    if (d = !1, o = R(c, s = h + 5), r = t ? T(u, s + 10) : R(e, s), A((l = z(o, r, s, 1)).d, n = h, p)) do {
      if (o = R(c, s += 10), r = t ? T(u, s + 10) : R(e, s), l = z(o, r, s, 1), !a) {
        +L(l.d).slice(n + 1, n + 15) + 1 == 1e14 && (l = q(l, h + 1, 0));
        break;
      }
    } while (A(l.d, n += 10, p));
    return d = !0, q(l, h, p);
  }, S.minus = S.sub = function (e) {
    var t,
      i,
      r,
      n,
      a,
      o,
      s,
      l,
      c,
      u,
      h,
      p,
      m = this,
      f = m.constructor;
    if (e = new f(e), !m.d || !e.d) return m.s && e.s ? m.d ? e.s = -e.s : e = new f(e.d || m.s !== e.s ? m : NaN) : e = new f(NaN), e;
    if (m.s != e.s) return e.s = -e.s, m.plus(e);
    if (c = m.d, p = e.d, s = f.precision, l = f.rounding, !c[0] || !p[0]) {
      if (p[0]) e.s = -e.s;else {
        if (!c[0]) return new f(3 === l ? -0 : 0);
        e = new f(m);
      }
      return d ? q(e, s, l) : e;
    }
    if (i = g(e.e / 7), u = g(m.e / 7), c = c.slice(), a = u - i) {
      for ((h = a < 0) ? (t = c, a = -a, o = p.length) : (t = p, i = u, o = c.length), a > (r = Math.max(Math.ceil(s / 7), o) + 2) && (a = r, t.length = 1), t.reverse(), r = a; r--;) t.push(0);
      t.reverse();
    } else {
      for ((h = (r = c.length) < (o = p.length)) && (o = r), r = 0; r < o; r++) if (c[r] != p[r]) {
        h = c[r] < p[r];
        break;
      }
      a = 0;
    }
    for (h && (t = c, c = p, p = t, e.s = -e.s), o = c.length, r = p.length - o; r > 0; --r) c[o++] = 0;
    for (r = p.length; r > a;) {
      if (c[--r] < p[r]) {
        for (n = r; n && 0 === c[--n];) c[n] = w - 1;
        --c[n], c[r] += w;
      }
      c[r] -= p[r];
    }
    for (; 0 === c[--o];) c.pop();
    for (; 0 === c[0]; c.shift()) --i;
    return c[0] ? (e.d = c, e.e = E(c, i), d ? q(e, s, l) : e) : new f(3 === l ? -0 : 0);
  }, S.modulo = S.mod = function (e) {
    var t,
      i = this,
      r = i.constructor;
    return e = new r(e), !i.d || !e.s || e.d && !e.d[0] ? new r(NaN) : !e.d || i.d && !i.d[0] ? q(new r(i), r.precision, r.rounding) : (d = !1, 9 == r.modulo ? (t = z(i, e.abs(), 0, 3, 1)).s *= e.s : t = z(i, e, 0, r.modulo, 1), t = t.times(e), d = !0, i.minus(t));
  }, S.naturalExponential = S.exp = function () {
    return I(this);
  }, S.naturalLogarithm = S.ln = function () {
    return R(this);
  }, S.negated = S.neg = function () {
    var e = new this.constructor(this);
    return e.s = -e.s, q(e);
  }, S.plus = S.add = function (e) {
    var t,
      i,
      r,
      n,
      a,
      o,
      s,
      l,
      c,
      u,
      h = this,
      p = h.constructor;
    if (e = new p(e), !h.d || !e.d) return h.s && e.s ? h.d || (e = new p(e.d || h.s === e.s ? h : NaN)) : e = new p(NaN), e;
    if (h.s != e.s) return e.s = -e.s, h.minus(e);
    if (c = h.d, u = e.d, s = p.precision, l = p.rounding, !c[0] || !u[0]) return u[0] || (e = new p(h)), d ? q(e, s, l) : e;
    if (a = g(h.e / 7), r = g(e.e / 7), c = c.slice(), n = a - r) {
      for (n < 0 ? (i = c, n = -n, o = u.length) : (i = u, r = a, o = c.length), n > (o = (a = Math.ceil(s / 7)) > o ? a + 1 : o + 1) && (n = o, i.length = 1), i.reverse(); n--;) i.push(0);
      i.reverse();
    }
    for ((o = c.length) - (n = u.length) < 0 && (n = o, i = u, u = c, c = i), t = 0; n;) t = (c[--n] = c[n] + u[n] + t) / w | 0, c[n] %= w;
    for (t && (c.unshift(t), ++r), o = c.length; 0 == c[--o];) c.pop();
    return e.d = c, e.e = E(c, r), d ? q(e, s, l) : e;
  }, S.precision = S.sd = function (e) {
    var t,
      i = this;
    if (void 0 !== e && e !== !!e && 1 !== e && 0 !== e) throw Error(p + e);
    return i.d ? (t = B(i.d), e && i.e + 1 > t && (t = i.e + 1)) : t = NaN, t;
  }, S.round = function () {
    var e = this,
      t = e.constructor;
    return q(new t(e), e.e + 1, t.rounding);
  }, S.sine = S.sin = function () {
    var e,
      t,
      i = this,
      r = i.constructor;
    return i.isFinite() ? i.isZero() ? new r(i) : (e = r.precision, t = r.rounding, r.precision = e + Math.max(i.e, i.sd()) + 7, r.rounding = 1, i = function (e, t) {
      var i,
        r = t.d.length;
      if (r < 3) return U(e, 2, t, t);
      i = (i = 1.4 * Math.sqrt(r)) > 16 ? 16 : 0 | i, t = U(e, 2, t = t.times(1 / W(5, i)), t);
      for (var n, a = new e(5), o = new e(16), s = new e(20); i--;) n = t.times(t), t = t.times(a.plus(n.times(o.times(n).minus(s))));
      return t;
    }(r, Z(r, i)), r.precision = e, r.rounding = t, q(n > 2 ? i.neg() : i, e, t, !0)) : new r(NaN);
  }, S.squareRoot = S.sqrt = function () {
    var e,
      t,
      i,
      r,
      n,
      a,
      o = this,
      s = o.d,
      l = o.e,
      c = o.s,
      u = o.constructor;
    if (1 !== c || !s || !s[0]) return new u(!c || c < 0 && (!s || s[0]) ? NaN : s ? o : 1 / 0);
    for (d = !1, 0 == (c = Math.sqrt(+o)) || c == 1 / 0 ? (((t = L(s)).length + l) % 2 == 0 && (t += "0"), c = Math.sqrt(t), l = g((l + 1) / 2) - (l < 0 || l % 2), r = new u(t = c == 1 / 0 ? "5e" + l : (t = c.toExponential()).slice(0, t.indexOf("e") + 1) + l)) : r = new u(c.toString()), i = (l = u.precision) + 3;;) if (r = (a = r).plus(z(o, a, i + 2, 1)).times(.5), L(a.d).slice(0, i) === (t = L(r.d)).slice(0, i)) {
      if ("9999" != (t = t.slice(i - 3, i + 1)) && (n || "4999" != t)) {
        +t && (+t.slice(1) || "5" != t.charAt(0)) || (q(r, l + 1, 1), e = !r.times(r).eq(o));
        break;
      }
      if (!n && (q(a, l + 1, 0), a.times(a).eq(o))) {
        r = a;
        break;
      }
      i += 4, n = 1;
    }
    return d = !0, q(r, l, u.rounding, e);
  }, S.tangent = S.tan = function () {
    var e,
      t,
      i = this,
      r = i.constructor;
    return i.isFinite() ? i.isZero() ? new r(i) : (e = r.precision, t = r.rounding, r.precision = e + 10, r.rounding = 1, (i = i.sin()).s = 1, i = z(i, new r(1).minus(i.times(i)).sqrt(), e + 10, 0), r.precision = e, r.rounding = t, q(2 == n || 4 == n ? i.neg() : i, e, t, !0)) : new r(NaN);
  }, S.times = S.mul = function (e) {
    var t,
      i,
      r,
      n,
      a,
      o,
      s,
      l,
      c,
      u = this,
      h = u.constructor,
      p = u.d,
      m = (e = new h(e)).d;
    if (e.s *= u.s, !(p && p[0] && m && m[0])) return new h(!e.s || p && !p[0] && !m || m && !m[0] && !p ? NaN : p && m ? 0 * e.s : e.s / 0);
    for (i = g(u.e / 7) + g(e.e / 7), (l = p.length) < (c = m.length) && (a = p, p = m, m = a, o = l, l = c, c = o), a = [], r = o = l + c; r--;) a.push(0);
    for (r = c; --r >= 0;) {
      for (t = 0, n = l + r; n > r;) s = a[n] + m[r] * p[n - r - 1] + t, a[n--] = s % w | 0, t = s / w | 0;
      a[n] = (a[n] + t) % w | 0;
    }
    for (; !a[--o];) a.pop();
    return t ? ++i : a.shift(), e.d = a, e.e = E(a, i), d ? q(e, h.precision, h.rounding) : e;
  }, S.toBinary = function (e, t) {
    return G(this, 2, e, t);
  }, S.toDecimalPlaces = S.toDP = function (e, t) {
    var i = this,
      r = i.constructor;
    return i = new r(i), void 0 === e ? i : (C(e, 0, o), void 0 === t ? t = r.rounding : C(t, 0, 8), q(i, e + i.e + 1, t));
  }, S.toExponential = function (e, t) {
    var i,
      r = this,
      n = r.constructor;
    return void 0 === e ? i = D(r, !0) : (C(e, 0, o), void 0 === t ? t = n.rounding : C(t, 0, 8), i = D(r = q(new n(r), e + 1, t), !0, e + 1)), r.isNeg() && !r.isZero() ? "-" + i : i;
  }, S.toFixed = function (e, t) {
    var i,
      r,
      n = this,
      a = n.constructor;
    return void 0 === e ? i = D(n) : (C(e, 0, o), void 0 === t ? t = a.rounding : C(t, 0, 8), i = D(r = q(new a(n), e + n.e + 1, t), !1, e + r.e + 1)), n.isNeg() && !n.isZero() ? "-" + i : i;
  }, S.toFraction = function (e) {
    var t,
      i,
      r,
      n,
      a,
      o,
      s,
      l,
      c,
      u,
      h,
      m,
      f = this,
      g = f.d,
      b = f.constructor;
    if (!g) return new b(f);
    if (c = i = new b(1), r = l = new b(0), o = (a = (t = new b(r)).e = B(g) - f.e - 1) % 7, t.d[0] = y(10, o < 0 ? 7 + o : o), null == e) e = a > 0 ? t : c;else {
      if (!(s = new b(e)).isInt() || s.lt(c)) throw Error(p + s);
      e = s.gt(t) ? a > 0 ? t : c : s;
    }
    for (d = !1, s = new b(L(g)), u = b.precision, b.precision = a = 7 * g.length * 2; h = z(s, t, 0, 1, 1), 1 != (n = i.plus(h.times(r))).cmp(e);) i = r, r = n, n = c, c = l.plus(h.times(n)), l = n, n = t, t = s.minus(h.times(n)), s = n;
    return n = z(e.minus(i), r, 0, 1, 1), l = l.plus(n.times(c)), i = i.plus(n.times(r)), l.s = c.s = f.s, m = z(c, r, a, 1).minus(f).abs().cmp(z(l, i, a, 1).minus(f).abs()) < 1 ? [c, r] : [l, i], b.precision = u, d = !0, m;
  }, S.toHexadecimal = S.toHex = function (e, t) {
    return G(this, 16, e, t);
  }, S.toNearest = function (e, t) {
    var i = this,
      r = i.constructor;
    if (i = new r(i), null == e) {
      if (!i.d) return i;
      e = new r(1), t = r.rounding;
    } else {
      if (e = new r(e), void 0 === t ? t = r.rounding : C(t, 0, 8), !i.d) return e.s ? i : e;
      if (!e.d) return e.s && (e.s = i.s), e;
    }
    return e.d[0] ? (d = !1, i = z(i, e, 0, t, 1).times(e), d = !0, q(i)) : (e.s = i.s, i = e), i;
  }, S.toNumber = function () {
    return +this;
  }, S.toOctal = function (e, t) {
    return G(this, 8, e, t);
  }, S.toPower = S.pow = function (e) {
    var t,
      i,
      r,
      n,
      a,
      o,
      s = this,
      l = s.constructor,
      c = +(e = new l(e));
    if (!(s.d && e.d && s.d[0] && e.d[0])) return new l(y(+s, c));
    if ((s = new l(s)).eq(1)) return s;
    if (r = l.precision, a = l.rounding, e.eq(1)) return q(s, r, a);
    if ((t = g(e.e / 7)) >= e.d.length - 1 && (i = c < 0 ? -c : c) <= 9007199254740991) return n = F(l, s, i, r), e.s < 0 ? new l(1).div(n) : q(n, r, a);
    if ((o = s.s) < 0) {
      if (t < e.d.length - 1) return new l(NaN);
      if (0 == (1 & e.d[t]) && (o = 1), 0 == s.e && 1 == s.d[0] && 1 == s.d.length) return s.s = o, s;
    }
    return (t = 0 != (i = y(+s, c)) && isFinite(i) ? new l(i + "").e : g(c * (Math.log("0." + L(s.d)) / Math.LN10 + s.e + 1))) > l.maxE + 1 || t < l.minE - 1 ? new l(t > 0 ? o / 0 : 0) : (d = !1, l.rounding = s.s = 1, i = Math.min(12, (t + "").length), (n = I(e.times(R(s, r + i)), r)).d && A((n = q(n, r + 5, 1)).d, r, a) && (t = r + 10, +L((n = q(I(e.times(R(s, t + i)), t), t + 5, 1)).d).slice(r + 1, r + 15) + 1 == 1e14 && (n = q(n, r + 1, 0))), n.s = o, d = !0, l.rounding = a, q(n, r, a));
  }, S.toPrecision = function (e, t) {
    var i,
      r = this,
      n = r.constructor;
    return void 0 === e ? i = D(r, r.e <= n.toExpNeg || r.e >= n.toExpPos) : (C(e, 1, o), void 0 === t ? t = n.rounding : C(t, 0, 8), i = D(r = q(new n(r), e, t), e <= r.e || r.e <= n.toExpNeg, e)), r.isNeg() && !r.isZero() ? "-" + i : i;
  }, S.toSignificantDigits = S.toSD = function (e, t) {
    var i = this.constructor;
    return void 0 === e ? (e = i.precision, t = i.rounding) : (C(e, 1, o), void 0 === t ? t = i.rounding : C(t, 0, 8)), q(new i(this), e, t);
  }, S.toString = function () {
    var e = this,
      t = e.constructor,
      i = D(e, e.e <= t.toExpNeg || e.e >= t.toExpPos);
    return e.isNeg() && !e.isZero() ? "-" + i : i;
  }, S.truncated = S.trunc = function () {
    return q(new this.constructor(this), this.e + 1, 1);
  }, S.valueOf = S.toJSON = function () {
    var e = this,
      t = e.constructor,
      i = D(e, e.e <= t.toExpNeg || e.e >= t.toExpPos);
    return e.isNeg() ? "-" + i : i;
  };
  var z = function () {
    function e(e, t, i) {
      var r,
        n = 0,
        a = e.length;
      for (e = e.slice(); a--;) r = e[a] * t + n, e[a] = r % i | 0, n = r / i | 0;
      return n && e.unshift(n), e;
    }
    function t(e, t, i, r) {
      var n, a;
      if (i != r) a = i > r ? 1 : -1;else for (n = a = 0; n < i; n++) if (e[n] != t[n]) {
        a = e[n] > t[n] ? 1 : -1;
        break;
      }
      return a;
    }
    function r(e, t, i, r) {
      for (var n = 0; i--;) e[i] -= n, n = e[i] < t[i] ? 1 : 0, e[i] = n * r + e[i] - t[i];
      for (; !e[0] && e.length > 1;) e.shift();
    }
    return function (n, a, o, s, l, c) {
      var u,
        d,
        h,
        p,
        m,
        f,
        y,
        b,
        v,
        x,
        k,
        _,
        M,
        S,
        L,
        C,
        A,
        N,
        z,
        D,
        E = n.constructor,
        T = n.s == a.s ? 1 : -1,
        O = n.d,
        B = a.d;
      if (!(O && O[0] && B && B[0])) return new E(n.s && a.s && (O ? !B || O[0] != B[0] : B) ? O && 0 == O[0] || !B ? 0 * T : T / 0 : NaN);
      for (c ? (m = 1, d = n.e - a.e) : (c = w, m = 7, d = g(n.e / m) - g(a.e / m)), z = B.length, A = O.length, x = (v = new E(T)).d = [], h = 0; B[h] == (O[h] || 0); h++);
      if (B[h] > (O[h] || 0) && d--, null == o ? (S = o = E.precision, s = E.rounding) : S = l ? o + (n.e - a.e) + 1 : o, S < 0) x.push(1), f = !0;else {
        if (S = S / m + 2 | 0, h = 0, 1 == z) {
          for (p = 0, B = B[0], S++; (h < A || p) && S--; h++) L = p * c + (O[h] || 0), x[h] = L / B | 0, p = L % B | 0;
          f = p || h < A;
        } else {
          for ((p = c / (B[0] + 1) | 0) > 1 && (B = e(B, p, c), O = e(O, p, c), z = B.length, A = O.length), C = z, _ = (k = O.slice(0, z)).length; _ < z;) k[_++] = 0;
          (D = B.slice()).unshift(0), N = B[0], B[1] >= c / 2 && ++N;
          do {
            p = 0, (u = t(B, k, z, _)) < 0 ? (M = k[0], z != _ && (M = M * c + (k[1] || 0)), (p = M / N | 0) > 1 ? (p >= c && (p = c - 1), 1 == (u = t(y = e(B, p, c), k, b = y.length, _ = k.length)) && (p--, r(y, z < b ? D : B, b, c))) : (0 == p && (u = p = 1), y = B.slice()), (b = y.length) < _ && y.unshift(0), r(k, y, _, c), -1 == u && (u = t(B, k, z, _ = k.length)) < 1 && (p++, r(k, z < _ ? D : B, _, c)), _ = k.length) : 0 === u && (p++, k = [0]), x[h++] = p, u && k[0] ? k[_++] = O[C] || 0 : (k = [O[C]], _ = 1);
          } while ((C++ < A || void 0 !== k[0]) && S--);
          f = void 0 !== k[0];
        }
        x[0] || x.shift();
      }
      if (1 == m) v.e = d, i = f;else {
        for (h = 1, p = x[0]; p >= 10; p /= 10) h++;
        v.e = h + d * m - 1, q(v, l ? o + v.e + 1 : o, s, f);
      }
      return v;
    };
  }();
  function q(e, t, i, r) {
    var n,
      a,
      o,
      s,
      l,
      c,
      u,
      h,
      p,
      m = e.constructor;
    e: if (null != t) {
      if (!(h = e.d)) return e;
      for (n = 1, s = h[0]; s >= 10; s /= 10) n++;
      if ((a = t - n) < 0) a += 7, o = t, l = (u = h[p = 0]) / y(10, n - o - 1) % 10 | 0;else if ((p = Math.ceil((a + 1) / 7)) >= (s = h.length)) {
        if (!r) break e;
        for (; s++ <= p;) h.push(0);
        u = l = 0, n = 1, o = (a %= 7) - 7 + 1;
      } else {
        for (u = s = h[p], n = 1; s >= 10; s /= 10) n++;
        l = (o = (a %= 7) - 7 + n) < 0 ? 0 : u / y(10, n - o - 1) % 10 | 0;
      }
      if (r = r || t < 0 || void 0 !== h[p + 1] || (o < 0 ? u : u % y(10, n - o - 1)), c = i < 4 ? (l || r) && (0 == i || i == (e.s < 0 ? 3 : 2)) : l > 5 || 5 == l && (4 == i || r || 6 == i && (a > 0 ? o > 0 ? u / y(10, n - o) : 0 : h[p - 1]) % 10 & 1 || i == (e.s < 0 ? 8 : 7)), t < 1 || !h[0]) return h.length = 0, c ? (t -= e.e + 1, h[0] = y(10, (7 - t % 7) % 7), e.e = -t || 0) : h[0] = e.e = 0, e;
      if (0 == a ? (h.length = p, s = 1, p--) : (h.length = p + 1, s = y(10, 7 - a), h[p] = o > 0 ? (u / y(10, n - o) % y(10, o) | 0) * s : 0), c) for (;;) {
        if (0 == p) {
          for (a = 1, o = h[0]; o >= 10; o /= 10) a++;
          for (o = h[0] += s, s = 1; o >= 10; o /= 10) s++;
          a != s && (e.e++, h[0] == w && (h[0] = 1));
          break;
        }
        if (h[p] += s, h[p] != w) break;
        h[p--] = 0, s = 1;
      }
      for (a = h.length; 0 === h[--a];) h.pop();
    }
    return d && (e.e > m.maxE ? (e.d = null, e.e = NaN) : e.e < m.minE && (e.e = 0, e.d = [0])), e;
  }
  function D(e, t, i) {
    if (!e.isFinite()) return V(e);
    var r,
      n = e.e,
      a = L(e.d),
      o = a.length;
    return t ? (i && (r = i - o) > 0 ? a = a.charAt(0) + "." + a.slice(1) + K(r) : o > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (e.e < 0 ? "e" : "e+") + e.e) : n < 0 ? (a = "0." + K(-n - 1) + a, i && (r = i - o) > 0 && (a += K(r))) : n >= o ? (a += K(n + 1 - o), i && (r = i - n - 1) > 0 && (a = a + "." + K(r))) : ((r = n + 1) < o && (a = a.slice(0, r) + "." + a.slice(r)), i && (r = i - o) > 0 && (n + 1 === o && (a += "."), a += K(r))), a;
  }
  function E(e, t) {
    var i = e[0];
    for (t *= 7; i >= 10; i /= 10) t++;
    return t;
  }
  function T(e, t, i) {
    if (t > _) throw d = !0, i && (e.precision = i), Error(m);
    return q(new e(l), t, 1, !0);
  }
  function O(e, t, i) {
    if (t > M) throw Error(m);
    return q(new e(c), t, i, !0);
  }
  function B(e) {
    var t = e.length - 1,
      i = 7 * t + 1;
    if (t = e[t]) {
      for (; t % 10 == 0; t /= 10) i--;
      for (t = e[0]; t >= 10; t /= 10) i++;
    }
    return i;
  }
  function K(e) {
    for (var t = ""; e--;) t += "0";
    return t;
  }
  function F(e, t, i, r) {
    var n,
      a = new e(1),
      o = Math.ceil(r / 7 + 4);
    for (d = !1;;) {
      if (i % 2 && X((a = a.times(t)).d, o) && (n = !0), 0 === (i = g(i / 2))) {
        i = a.d.length - 1, n && 0 === a.d[i] && ++a.d[i];
        break;
      }
      X((t = t.times(t)).d, o);
    }
    return d = !0, a;
  }
  function $(e) {
    return 1 & e.d[e.d.length - 1];
  }
  function P(e, t, i) {
    for (var r, n = new e(t[0]), a = 0; ++a < t.length;) {
      if (!(r = new e(t[a])).s) {
        n = r;
        break;
      }
      n[i](r) && (n = r);
    }
    return n;
  }
  function I(e, t) {
    var i,
      r,
      n,
      a,
      o,
      s,
      l,
      c = 0,
      u = 0,
      h = 0,
      p = e.constructor,
      m = p.rounding,
      f = p.precision;
    if (!e.d || !e.d[0] || e.e > 17) return new p(e.d ? e.d[0] ? e.s < 0 ? 0 : 1 / 0 : 1 : e.s ? e.s < 0 ? 0 : e : NaN);
    for (null == t ? (d = !1, l = f) : l = t, s = new p(.03125); e.e > -2;) e = e.times(s), h += 5;
    for (l += r = Math.log(y(2, h)) / Math.LN10 * 2 + 5 | 0, i = a = o = new p(1), p.precision = l;;) {
      if (a = q(a.times(e), l, 1), i = i.times(++u), L((s = o.plus(z(a, i, l, 1))).d).slice(0, l) === L(o.d).slice(0, l)) {
        for (n = h; n--;) o = q(o.times(o), l, 1);
        if (null != t) return p.precision = f, o;
        if (!(c < 3 && A(o.d, l - r, m, c))) return q(o, p.precision = f, m, d = !0);
        p.precision = l += 10, i = a = s = new p(1), u = 0, c++;
      }
      o = s;
    }
  }
  function R(e, t) {
    var i,
      r,
      n,
      a,
      o,
      s,
      l,
      c,
      u,
      h,
      p,
      m = 1,
      f = e,
      g = f.d,
      y = f.constructor,
      b = y.rounding,
      v = y.precision;
    if (f.s < 0 || !g || !g[0] || !f.e && 1 == g[0] && 1 == g.length) return new y(g && !g[0] ? -1 / 0 : 1 != f.s ? NaN : g ? 0 : f);
    if (null == t ? (d = !1, u = v) : u = t, y.precision = u += 10, r = (i = L(g)).charAt(0), !(Math.abs(a = f.e) < 15e14)) return c = T(y, u + 2, v).times(a + ""), f = R(new y(r + "." + i.slice(1)), u - 10).plus(c), y.precision = v, null == t ? q(f, v, b, d = !0) : f;
    for (; r < 7 && 1 != r || 1 == r && i.charAt(1) > 3;) r = (i = L((f = f.times(e)).d)).charAt(0), m++;
    for (a = f.e, r > 1 ? (f = new y("0." + i), a++) : f = new y(r + "." + i.slice(1)), h = f, l = o = f = z(f.minus(1), f.plus(1), u, 1), p = q(f.times(f), u, 1), n = 3;;) {
      if (o = q(o.times(p), u, 1), L((c = l.plus(z(o, new y(n), u, 1))).d).slice(0, u) === L(l.d).slice(0, u)) {
        if (l = l.times(2), 0 !== a && (l = l.plus(T(y, u + 2, v).times(a + ""))), l = z(l, new y(m), u, 1), null != t) return y.precision = v, l;
        if (!A(l.d, u - 10, b, s)) return q(l, y.precision = v, b, d = !0);
        y.precision = u += 10, c = o = f = z(h.minus(1), h.plus(1), u, 1), p = q(f.times(f), u, 1), n = s = 1;
      }
      l = c, n += 2;
    }
  }
  function V(e) {
    return String(e.s * e.s / 0);
  }
  function j(e, t) {
    var i, r, n;
    for ((i = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (r = t.search(/e/i)) > 0 ? (i < 0 && (i = r), i += +t.slice(r + 1), t = t.substring(0, r)) : i < 0 && (i = t.length), r = 0; 48 === t.charCodeAt(r); r++);
    for (n = t.length; 48 === t.charCodeAt(n - 1); --n);
    if (t = t.slice(r, n)) {
      if (n -= r, e.e = i = i - r - 1, e.d = [], r = (i + 1) % 7, i < 0 && (r += 7), r < n) {
        for (r && e.d.push(+t.slice(0, r)), n -= 7; r < n;) e.d.push(+t.slice(r, r += 7));
        r = 7 - (t = t.slice(r)).length;
      } else r -= n;
      for (; r--;) t += "0";
      e.d.push(+t), d && (e.e > e.constructor.maxE ? (e.d = null, e.e = NaN) : e.e < e.constructor.minE && (e.e = 0, e.d = [0]));
    } else e.e = 0, e.d = [0];
    return e;
  }
  function H(e, i) {
    var r, n, a, o, s, l, c, u, h;
    if ("Infinity" === i || "NaN" === i) return +i || (e.s = NaN), e.e = NaN, e.d = null, e;
    if (v.test(i)) r = 16, i = i.toLowerCase();else if (b.test(i)) r = 2;else {
      if (!x.test(i)) throw Error(p + i);
      r = 8;
    }
    for ((o = i.search(/p/i)) > 0 ? (c = +i.slice(o + 1), i = i.substring(2, o)) : i = i.slice(2), s = (o = i.indexOf(".")) >= 0, n = e.constructor, s && (o = (l = (i = i.replace(".", "")).length) - o, a = F(n, new n(r), o, 2 * o)), o = h = (u = N(i, r, w)).length - 1; 0 === u[o]; --o) u.pop();
    return o < 0 ? new n(0 * e.s) : (e.e = E(u, h), e.d = u, d = !1, s && (e = z(e, a, 4 * l)), c && (e = e.times(Math.abs(c) < 54 ? y(2, c) : t.pow(2, c))), d = !0, e);
  }
  function U(e, t, i, r, n) {
    var a,
      o,
      s,
      l,
      c = e.precision,
      u = Math.ceil(c / 7);
    for (d = !1, l = i.times(i), s = new e(r);;) {
      if (o = z(s.times(l), new e(t++ * t++), c, 1), s = n ? r.plus(o) : r.minus(o), r = z(o.times(l), new e(t++ * t++), c, 1), void 0 !== (o = s.plus(r)).d[u]) {
        for (a = u; o.d[a] === s.d[a] && a--;);
        if (-1 == a) break;
      }
      a = s, s = r, r = o, o = a;
    }
    return d = !0, o.d.length = u + 1, o;
  }
  function W(e, t) {
    for (var i = e; --t;) i *= e;
    return i;
  }
  function Z(e, t) {
    var i,
      r = t.s < 0,
      a = O(e, e.precision, 1),
      o = a.times(.5);
    if ((t = t.abs()).lte(o)) return n = r ? 4 : 1, t;
    if ((i = t.divToInt(a)).isZero()) n = r ? 3 : 2;else {
      if ((t = t.minus(i.times(a))).lte(o)) return n = $(i) ? r ? 2 : 3 : r ? 4 : 1, t;
      n = $(i) ? r ? 1 : 4 : r ? 3 : 2;
    }
    return t.minus(a).abs();
  }
  function G(e, t, r, n) {
    var a,
      l,
      c,
      u,
      d,
      h,
      p,
      m,
      f,
      g = e.constructor,
      y = void 0 !== r;
    if (y ? (C(r, 1, o), void 0 === n ? n = g.rounding : C(n, 0, 8)) : (r = g.precision, n = g.rounding), e.isFinite()) {
      for (y ? (a = 2, 16 == t ? r = 4 * r - 3 : 8 == t && (r = 3 * r - 2)) : a = t, (c = (p = D(e)).indexOf(".")) >= 0 && (p = p.replace(".", ""), (f = new g(1)).e = p.length - c, f.d = N(D(f), 10, a), f.e = f.d.length), l = d = (m = N(p, 10, a)).length; 0 == m[--d];) m.pop();
      if (m[0]) {
        if (c < 0 ? l-- : ((e = new g(e)).d = m, e.e = l, m = (e = z(e, f, r, n, 0, a)).d, l = e.e, h = i), c = m[r], u = a / 2, h = h || void 0 !== m[r + 1], h = n < 4 ? (void 0 !== c || h) && (0 === n || n === (e.s < 0 ? 3 : 2)) : c > u || c === u && (4 === n || h || 6 === n && 1 & m[r - 1] || n === (e.s < 0 ? 8 : 7)), m.length = r, h) for (; ++m[--r] > a - 1;) m[r] = 0, r || (++l, m.unshift(1));
        for (d = m.length; !m[d - 1]; --d);
        for (c = 0, p = ""; c < d; c++) p += s.charAt(m[c]);
        if (y) {
          if (d > 1) if (16 == t || 8 == t) {
            for (c = 16 == t ? 4 : 3, --d; d % c; d++) p += "0";
            for (d = (m = N(p, a, t)).length; !m[d - 1]; --d);
            for (c = 1, p = "1."; c < d; c++) p += s.charAt(m[c]);
          } else p = p.charAt(0) + "." + p.slice(1);
          p = p + (l < 0 ? "p" : "p+") + l;
        } else if (l < 0) {
          for (; ++l;) p = "0" + p;
          p = "0." + p;
        } else if (++l > d) for (l -= d; l--;) p += "0";else l < d && (p = p.slice(0, l) + "." + p.slice(l));
      } else p = y ? "0p+0" : "0";
      p = (16 == t ? "0x" : 2 == t ? "0b" : 8 == t ? "0o" : "") + p;
    } else p = V(e);
    return e.s < 0 ? "-" + p : p;
  }
  function X(e, t) {
    if (e.length > t) return e.length = t, !0;
  }
  function Y(e) {
    return new this(e).abs();
  }
  function Q(e) {
    return new this(e).acos();
  }
  function J(e) {
    return new this(e).acosh();
  }
  function ee(e, t) {
    return new this(e).plus(t);
  }
  function te(e) {
    return new this(e).asin();
  }
  function ie(e) {
    return new this(e).asinh();
  }
  function re(e) {
    return new this(e).atan();
  }
  function ne(e) {
    return new this(e).atanh();
  }
  function ae(e, t) {
    e = new this(e), t = new this(t);
    var i,
      r = this.precision,
      n = this.rounding,
      a = r + 4;
    return e.s && t.s ? e.d || t.d ? !t.d || e.isZero() ? (i = t.s < 0 ? O(this, r, n) : new this(0)).s = e.s : !e.d || t.isZero() ? (i = O(this, a, 1).times(.5)).s = e.s : t.s < 0 ? (this.precision = a, this.rounding = 1, i = this.atan(z(e, t, a, 1)), t = O(this, a, 1), this.precision = r, this.rounding = n, i = e.s < 0 ? i.minus(t) : i.plus(t)) : i = this.atan(z(e, t, a, 1)) : (i = O(this, a, 1).times(t.s > 0 ? .25 : .75)).s = e.s : i = new this(NaN), i;
  }
  function oe(e) {
    return new this(e).cbrt();
  }
  function se(e) {
    return q(e = new this(e), e.e + 1, 2);
  }
  function le(e) {
    if (!e || "object" != typeof e) throw Error(h + "Object expected");
    var t,
      i,
      r,
      n = !0 === e.defaults,
      s = ["precision", 1, o, "rounding", 0, 8, "toExpNeg", -a, 0, "toExpPos", 0, a, "maxE", 0, a, "minE", -a, 0, "modulo", 0, 9];
    for (t = 0; t < s.length; t += 3) if (i = s[t], n && (this[i] = u[i]), void 0 !== (r = e[i])) {
      if (!(g(r) === r && r >= s[t + 1] && r <= s[t + 2])) throw Error(p + i + ": " + r);
      this[i] = r;
    }
    if (i = "crypto", n && (this[i] = u[i]), void 0 !== (r = e[i])) {
      if (!0 !== r && !1 !== r && 0 !== r && 1 !== r) throw Error(p + i + ": " + r);
      if (r) {
        if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw Error(f);
        this[i] = !0;
      } else this[i] = !1;
    }
    return this;
  }
  function ce(e) {
    return new this(e).cos();
  }
  function ue(e) {
    return new this(e).cosh();
  }
  function de(e, t) {
    return new this(e).div(t);
  }
  function he(e) {
    return new this(e).exp();
  }
  function pe(e) {
    return q(e = new this(e), e.e + 1, 3);
  }
  function me() {
    var e,
      t,
      i = new this(0);
    for (d = !1, e = 0; e < arguments.length;) if ((t = new this(arguments[e++])).d) i.d && (i = i.plus(t.times(t)));else {
      if (t.s) return d = !0, new this(1 / 0);
      i = t;
    }
    return d = !0, i.sqrt();
  }
  function fe(e) {
    return e instanceof t || e && "[object Decimal]" === e.name || !1;
  }
  function ge(e) {
    return new this(e).ln();
  }
  function ye(e, t) {
    return new this(e).log(t);
  }
  function be(e) {
    return new this(e).log(2);
  }
  function ve(e) {
    return new this(e).log(10);
  }
  function xe() {
    return P(this, arguments, "lt");
  }
  function ke() {
    return P(this, arguments, "gt");
  }
  function we(e, t) {
    return new this(e).mod(t);
  }
  function _e(e, t) {
    return new this(e).mul(t);
  }
  function Me(e, t) {
    return new this(e).pow(t);
  }
  function Se(e) {
    var t,
      i,
      r,
      n,
      a = 0,
      s = new this(1),
      l = [];
    if (void 0 === e ? e = this.precision : C(e, 1, o), r = Math.ceil(e / 7), this.crypto) {
      if (crypto.getRandomValues) for (t = crypto.getRandomValues(new Uint32Array(r)); a < r;) (n = t[a]) >= 429e7 ? t[a] = crypto.getRandomValues(new Uint32Array(1))[0] : l[a++] = n % 1e7;else {
        if (!crypto.randomBytes) throw Error(f);
        for (t = crypto.randomBytes(r *= 4); a < r;) (n = t[a] + (t[a + 1] << 8) + (t[a + 2] << 16) + ((127 & t[a + 3]) << 24)) >= 214e7 ? crypto.randomBytes(4).copy(t, a) : (l.push(n % 1e7), a += 4);
        a = r / 4;
      }
    } else for (; a < r;) l[a++] = 1e7 * Math.random() | 0;
    for (e %= 7, (r = l[--a]) && e && (n = y(10, 7 - e), l[a] = (r / n | 0) * n); 0 === l[a]; a--) l.pop();
    if (a < 0) i = 0, l = [0];else {
      for (i = -1; 0 === l[0]; i -= 7) l.shift();
      for (r = 1, n = l[0]; n >= 10; n /= 10) r++;
      r < 7 && (i -= 7 - r);
    }
    return s.e = i, s.d = l, s;
  }
  function Le(e) {
    return q(e = new this(e), e.e + 1, this.rounding);
  }
  function Ce(e) {
    return (e = new this(e)).d ? e.d[0] ? e.s : 0 * e.s : e.s || NaN;
  }
  function Ae(e) {
    return new this(e).sin();
  }
  function Ne(e) {
    return new this(e).sinh();
  }
  function ze(e) {
    return new this(e).sqrt();
  }
  function qe(e, t) {
    return new this(e).sub(t);
  }
  function De(e) {
    return new this(e).tan();
  }
  function Ee(e) {
    return new this(e).tanh();
  }
  function Te(e) {
    return q(e = new this(e), e.e + 1, 1);
  }
  (t = function e(t) {
    var i, r, n;
    function a(e) {
      var t,
        i,
        r,
        n = this;
      if (!(n instanceof a)) return new a(e);
      if (n.constructor = a, e instanceof a) return n.s = e.s, void (d ? !e.d || e.e > a.maxE ? (n.e = NaN, n.d = null) : e.e < a.minE ? (n.e = 0, n.d = [0]) : (n.e = e.e, n.d = e.d.slice()) : (n.e = e.e, n.d = e.d ? e.d.slice() : e.d));
      if ("number" == (r = typeof e)) {
        if (0 === e) return n.s = 1 / e < 0 ? -1 : 1, n.e = 0, void (n.d = [0]);
        if (e < 0 ? (e = -e, n.s = -1) : n.s = 1, e === ~~e && e < 1e7) {
          for (t = 0, i = e; i >= 10; i /= 10) t++;
          return void (d ? t > a.maxE ? (n.e = NaN, n.d = null) : t < a.minE ? (n.e = 0, n.d = [0]) : (n.e = t, n.d = [e]) : (n.e = t, n.d = [e]));
        }
        return 0 * e != 0 ? (e || (n.s = NaN), n.e = NaN, void (n.d = null)) : j(n, e.toString());
      }
      if ("string" !== r) throw Error(p + e);
      return 45 === (i = e.charCodeAt(0)) ? (e = e.slice(1), n.s = -1) : (43 === i && (e = e.slice(1)), n.s = 1), k.test(e) ? j(n, e) : H(n, e);
    }
    if (a.prototype = S, a.ROUND_UP = 0, a.ROUND_DOWN = 1, a.ROUND_CEIL = 2, a.ROUND_FLOOR = 3, a.ROUND_HALF_UP = 4, a.ROUND_HALF_DOWN = 5, a.ROUND_HALF_EVEN = 6, a.ROUND_HALF_CEIL = 7, a.ROUND_HALF_FLOOR = 8, a.EUCLID = 9, a.config = a.set = le, a.clone = e, a.isDecimal = fe, a.abs = Y, a.acos = Q, a.acosh = J, a.add = ee, a.asin = te, a.asinh = ie, a.atan = re, a.atanh = ne, a.atan2 = ae, a.cbrt = oe, a.ceil = se, a.cos = ce, a.cosh = ue, a.div = de, a.exp = he, a.floor = pe, a.hypot = me, a.ln = ge, a.log = ye, a.log10 = ve, a.log2 = be, a.max = xe, a.min = ke, a.mod = we, a.mul = _e, a.pow = Me, a.random = Se, a.round = Le, a.sign = Ce, a.sin = Ae, a.sinh = Ne, a.sqrt = ze, a.sub = qe, a.tan = De, a.tanh = Ee, a.trunc = Te, void 0 === t && (t = {}), t && !0 !== t.defaults) for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], i = 0; i < n.length;) t.hasOwnProperty(r = n[i++]) || (t[r] = this[r]);
    return a.config(t), a;
  }(u)).default = t.Decimal = t, l = new t(l), c = new t(c), ha.exports ? ("function" == typeof Symbol && "symbol" == typeof Symbol.iterator && (S[Symbol.for("nodejs.util.inspect.custom")] = S.toString, S[Symbol.toStringTag] = "Decimal"), ha.exports = t) : (e || (e = "undefined" != typeof self && self && self.self == self ? self : window), r = e.Decimal, t.noConflict = function () {
    return e.Decimal = r, t;
  }, e.Decimal = t);
}(pa);
var fa = {
  exports: {}
};
/**
 * @license Complex.js v2.0.13 12/05/2020
 *
 * Copyright (c) 2020, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/
!function (e, t) {
  !function (t) {
    var i = function i(e) {
        return .5 * (Math.exp(e) + Math.exp(-e));
      },
      r = function r(e) {
        return .5 * (Math.exp(e) - Math.exp(-e));
      },
      n = function n() {
        throw SyntaxError("Invalid Param");
      };
    function a(e, t) {
      var i = Math.abs(e),
        r = Math.abs(t);
      return 0 === e ? Math.log(r) : 0 === t ? Math.log(i) : i < 3e3 && r < 3e3 ? .5 * Math.log(e * e + t * t) : Math.log(e / Math.cos(Math.atan2(t, e)));
    }
    function o(e, t) {
      if (!(this instanceof o)) return new o(e, t);
      var i = function (e, t) {
        var i = {
          re: 0,
          im: 0
        };
        if (null == e) i.re = i.im = 0;else if (void 0 !== t) i.re = e, i.im = t;else switch (typeof e) {
          case "object":
            if ("im" in e && "re" in e) i.re = e.re, i.im = e.im;else if ("abs" in e && "arg" in e) {
              if (!Number.isFinite(e.abs) && Number.isFinite(e.arg)) return o.INFINITY;
              i.re = e.abs * Math.cos(e.arg), i.im = e.abs * Math.sin(e.arg);
            } else if ("r" in e && "phi" in e) {
              if (!Number.isFinite(e.r) && Number.isFinite(e.phi)) return o.INFINITY;
              i.re = e.r * Math.cos(e.phi), i.im = e.r * Math.sin(e.phi);
            } else 2 === e.length ? (i.re = e[0], i.im = e[1]) : n();
            break;
          case "string":
            i.im = i.re = 0;
            var r = e.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g),
              a = 1,
              s = 0;
            null === r && n();
            for (var l = 0; l < r.length; l++) {
              var c = r[l];
              " " === c || "\t" === c || "\n" === c || ("+" === c ? a++ : "-" === c ? s++ : "i" === c || "I" === c ? (a + s === 0 && n(), " " === r[l + 1] || isNaN(r[l + 1]) ? i.im += parseFloat((s % 2 ? "-" : "") + "1") : (i.im += parseFloat((s % 2 ? "-" : "") + r[l + 1]), l++), a = s = 0) : ((a + s === 0 || isNaN(c)) && n(), "i" === r[l + 1] || "I" === r[l + 1] ? (i.im += parseFloat((s % 2 ? "-" : "") + c), l++) : i.re += parseFloat((s % 2 ? "-" : "") + c), a = s = 0));
            }
            a + s > 0 && n();
            break;
          case "number":
            i.im = 0, i.re = e;
            break;
          default:
            n();
        }
        return isNaN(i.re) || isNaN(i.im), i;
      }(e, t);
      this.re = i.re, this.im = i.im;
    }
    o.prototype = {
      re: 0,
      im: 0,
      sign: function sign() {
        var e = this.abs();
        return new o(this.re / e, this.im / e);
      },
      add: function add(e, t) {
        var i = new o(e, t);
        return this.isInfinite() && i.isInfinite() ? o.NAN : this.isInfinite() || i.isInfinite() ? o.INFINITY : new o(this.re + i.re, this.im + i.im);
      },
      sub: function sub(e, t) {
        var i = new o(e, t);
        return this.isInfinite() && i.isInfinite() ? o.NAN : this.isInfinite() || i.isInfinite() ? o.INFINITY : new o(this.re - i.re, this.im - i.im);
      },
      mul: function mul(e, t) {
        var i = new o(e, t);
        return this.isInfinite() && i.isZero() || this.isZero() && i.isInfinite() ? o.NAN : this.isInfinite() || i.isInfinite() ? o.INFINITY : 0 === i.im && 0 === this.im ? new o(this.re * i.re, 0) : new o(this.re * i.re - this.im * i.im, this.re * i.im + this.im * i.re);
      },
      div: function div(e, t) {
        var i = new o(e, t);
        if (this.isZero() && i.isZero() || this.isInfinite() && i.isInfinite()) return o.NAN;
        if (this.isInfinite() || i.isZero()) return o.INFINITY;
        if (this.isZero() || i.isInfinite()) return o.ZERO;
        e = this.re, t = this.im;
        var r,
          n,
          a = i.re,
          s = i.im;
        return 0 === s ? new o(e / a, t / a) : Math.abs(a) < Math.abs(s) ? new o((e * (n = a / s) + t) / (r = a * n + s), (t * n - e) / r) : new o((e + t * (n = s / a)) / (r = s * n + a), (t - e * n) / r);
      },
      pow: function pow(e, t) {
        var i = new o(e, t);
        if (e = this.re, t = this.im, i.isZero()) return o.ONE;
        if (0 === i.im) {
          if (0 === t && e > 0) return new o(Math.pow(e, i.re), 0);
          if (0 === e) switch ((i.re % 4 + 4) % 4) {
            case 0:
              return new o(Math.pow(t, i.re), 0);
            case 1:
              return new o(0, Math.pow(t, i.re));
            case 2:
              return new o(-Math.pow(t, i.re), 0);
            case 3:
              return new o(0, -Math.pow(t, i.re));
          }
        }
        if (0 === e && 0 === t && i.re > 0 && i.im >= 0) return o.ZERO;
        var r = Math.atan2(t, e),
          n = a(e, t);
        return e = Math.exp(i.re * n - i.im * r), t = i.im * n + i.re * r, new o(e * Math.cos(t), e * Math.sin(t));
      },
      sqrt: function sqrt() {
        var e,
          t,
          i = this.re,
          r = this.im,
          n = this.abs();
        if (i >= 0) {
          if (0 === r) return new o(Math.sqrt(i), 0);
          e = .5 * Math.sqrt(2 * (n + i));
        } else e = Math.abs(r) / Math.sqrt(2 * (n - i));
        return t = i <= 0 ? .5 * Math.sqrt(2 * (n - i)) : Math.abs(r) / Math.sqrt(2 * (n + i)), new o(e, r < 0 ? -t : t);
      },
      exp: function exp() {
        var e = Math.exp(this.re);
        return this.im, new o(e * Math.cos(this.im), e * Math.sin(this.im));
      },
      expm1: function expm1() {
        var e = this.re,
          t = this.im;
        return new o(Math.expm1(e) * Math.cos(t) + function (e) {
          var t = Math.PI / 4;
          if (e < -t || e > t) return Math.cos(e) - 1;
          var i = e * e;
          return i * (i * (1 / 24 + i * (-1 / 720 + i * (1 / 40320 + i * (-1 / 3628800 + i * (1 / 4790014600 + i * (-1 / 87178291200 + i * (1 / 20922789888e3))))))) - .5);
        }(t), Math.exp(e) * Math.sin(t));
      },
      log: function log() {
        var e = this.re,
          t = this.im;
        return new o(a(e, t), Math.atan2(t, e));
      },
      abs: function abs() {
        return e = this.re, t = this.im, i = Math.abs(e), r = Math.abs(t), i < 3e3 && r < 3e3 ? Math.sqrt(i * i + r * r) : (i < r ? (i = r, r = e / t) : r = t / e, i * Math.sqrt(1 + r * r));
        var e, t, i, r;
      },
      arg: function arg() {
        return Math.atan2(this.im, this.re);
      },
      sin: function sin() {
        var e = this.re,
          t = this.im;
        return new o(Math.sin(e) * i(t), Math.cos(e) * r(t));
      },
      cos: function cos() {
        var e = this.re,
          t = this.im;
        return new o(Math.cos(e) * i(t), -Math.sin(e) * r(t));
      },
      tan: function tan() {
        var e = 2 * this.re,
          t = 2 * this.im,
          n = Math.cos(e) + i(t);
        return new o(Math.sin(e) / n, r(t) / n);
      },
      cot: function cot() {
        var e = 2 * this.re,
          t = 2 * this.im,
          n = Math.cos(e) - i(t);
        return new o(-Math.sin(e) / n, r(t) / n);
      },
      sec: function sec() {
        var e = this.re,
          t = this.im,
          n = .5 * i(2 * t) + .5 * Math.cos(2 * e);
        return new o(Math.cos(e) * i(t) / n, Math.sin(e) * r(t) / n);
      },
      csc: function csc() {
        var e = this.re,
          t = this.im,
          n = .5 * i(2 * t) - .5 * Math.cos(2 * e);
        return new o(Math.sin(e) * i(t) / n, -Math.cos(e) * r(t) / n);
      },
      asin: function asin() {
        var e = this.re,
          t = this.im,
          i = new o(t * t - e * e + 1, -2 * e * t).sqrt(),
          r = new o(i.re - t, i.im + e).log();
        return new o(r.im, -r.re);
      },
      acos: function acos() {
        var e = this.re,
          t = this.im,
          i = new o(t * t - e * e + 1, -2 * e * t).sqrt(),
          r = new o(i.re - t, i.im + e).log();
        return new o(Math.PI / 2 - r.im, r.re);
      },
      atan: function atan() {
        var e = this.re,
          t = this.im;
        if (0 === e) {
          if (1 === t) return new o(0, 1 / 0);
          if (-1 === t) return new o(0, -1 / 0);
        }
        var i = e * e + (1 - t) * (1 - t),
          r = new o((1 - t * t - e * e) / i, -2 * e / i).log();
        return new o(-.5 * r.im, .5 * r.re);
      },
      acot: function acot() {
        var e = this.re,
          t = this.im;
        if (0 === t) return new o(Math.atan2(1, e), 0);
        var i = e * e + t * t;
        return 0 !== i ? new o(e / i, -t / i).atan() : new o(0 !== e ? e / 0 : 0, 0 !== t ? -t / 0 : 0).atan();
      },
      asec: function asec() {
        var e = this.re,
          t = this.im;
        if (0 === e && 0 === t) return new o(0, 1 / 0);
        var i = e * e + t * t;
        return 0 !== i ? new o(e / i, -t / i).acos() : new o(0 !== e ? e / 0 : 0, 0 !== t ? -t / 0 : 0).acos();
      },
      acsc: function acsc() {
        var e = this.re,
          t = this.im;
        if (0 === e && 0 === t) return new o(Math.PI / 2, 1 / 0);
        var i = e * e + t * t;
        return 0 !== i ? new o(e / i, -t / i).asin() : new o(0 !== e ? e / 0 : 0, 0 !== t ? -t / 0 : 0).asin();
      },
      sinh: function sinh() {
        var e = this.re,
          t = this.im;
        return new o(r(e) * Math.cos(t), i(e) * Math.sin(t));
      },
      cosh: function cosh() {
        var e = this.re,
          t = this.im;
        return new o(i(e) * Math.cos(t), r(e) * Math.sin(t));
      },
      tanh: function tanh() {
        var e = 2 * this.re,
          t = 2 * this.im,
          n = i(e) + Math.cos(t);
        return new o(r(e) / n, Math.sin(t) / n);
      },
      coth: function coth() {
        var e = 2 * this.re,
          t = 2 * this.im,
          n = i(e) - Math.cos(t);
        return new o(r(e) / n, -Math.sin(t) / n);
      },
      csch: function csch() {
        var e = this.re,
          t = this.im,
          n = Math.cos(2 * t) - i(2 * e);
        return new o(-2 * r(e) * Math.cos(t) / n, 2 * i(e) * Math.sin(t) / n);
      },
      sech: function sech() {
        var e = this.re,
          t = this.im,
          n = Math.cos(2 * t) + i(2 * e);
        return new o(2 * i(e) * Math.cos(t) / n, -2 * r(e) * Math.sin(t) / n);
      },
      asinh: function asinh() {
        var e = this.im;
        this.im = -this.re, this.re = e;
        var t = this.asin();
        return this.re = -this.im, this.im = e, e = t.re, t.re = -t.im, t.im = e, t;
      },
      acosh: function acosh() {
        var e = this.acos();
        if (e.im <= 0) {
          var t = e.re;
          e.re = -e.im, e.im = t;
        } else t = e.im, e.im = -e.re, e.re = t;
        return e;
      },
      atanh: function atanh() {
        var e = this.re,
          t = this.im,
          i = e > 1 && 0 === t,
          r = 1 - e,
          n = 1 + e,
          s = r * r + t * t,
          l = 0 !== s ? new o((n * r - t * t) / s, (t * r + n * t) / s) : new o(-1 !== e ? e / 0 : 0, 0 !== t ? t / 0 : 0),
          c = l.re;
        return l.re = a(l.re, l.im) / 2, l.im = Math.atan2(l.im, c) / 2, i && (l.im = -l.im), l;
      },
      acoth: function acoth() {
        var e = this.re,
          t = this.im;
        if (0 === e && 0 === t) return new o(0, Math.PI / 2);
        var i = e * e + t * t;
        return 0 !== i ? new o(e / i, -t / i).atanh() : new o(0 !== e ? e / 0 : 0, 0 !== t ? -t / 0 : 0).atanh();
      },
      acsch: function acsch() {
        var e = this.re,
          t = this.im;
        if (0 === t) return new o(0 !== e ? Math.log(e + Math.sqrt(e * e + 1)) : 1 / 0, 0);
        var i = e * e + t * t;
        return 0 !== i ? new o(e / i, -t / i).asinh() : new o(0 !== e ? e / 0 : 0, 0 !== t ? -t / 0 : 0).asinh();
      },
      asech: function asech() {
        var e = this.re,
          t = this.im;
        if (this.isZero()) return o.INFINITY;
        var i = e * e + t * t;
        return 0 !== i ? new o(e / i, -t / i).acosh() : new o(0 !== e ? e / 0 : 0, 0 !== t ? -t / 0 : 0).acosh();
      },
      inverse: function inverse() {
        if (this.isZero()) return o.INFINITY;
        if (this.isInfinite()) return o.ZERO;
        var e = this.re,
          t = this.im,
          i = e * e + t * t;
        return new o(e / i, -t / i);
      },
      conjugate: function conjugate() {
        return new o(this.re, -this.im);
      },
      neg: function neg() {
        return new o(-this.re, -this.im);
      },
      ceil: function ceil(e) {
        return e = Math.pow(10, e || 0), new o(Math.ceil(this.re * e) / e, Math.ceil(this.im * e) / e);
      },
      floor: function floor(e) {
        return e = Math.pow(10, e || 0), new o(Math.floor(this.re * e) / e, Math.floor(this.im * e) / e);
      },
      round: function round(e) {
        return e = Math.pow(10, e || 0), new o(Math.round(this.re * e) / e, Math.round(this.im * e) / e);
      },
      equals: function equals(e, t) {
        var i = new o(e, t);
        return Math.abs(i.re - this.re) <= o.EPSILON && Math.abs(i.im - this.im) <= o.EPSILON;
      },
      clone: function clone() {
        return new o(this.re, this.im);
      },
      toString: function toString() {
        var e = this.re,
          t = this.im,
          i = "";
        return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(e) < o.EPSILON && (e = 0), Math.abs(t) < o.EPSILON && (t = 0), 0 === t ? i + e : (0 !== e ? (i += e, i += " ", t < 0 ? (t = -t, i += "-") : i += "+", i += " ") : t < 0 && (t = -t, i += "-"), 1 !== t && (i += t), i + "i"));
      },
      toVector: function toVector() {
        return [this.re, this.im];
      },
      valueOf: function valueOf() {
        return 0 === this.im ? this.re : null;
      },
      isNaN: function (_isNaN) {
        function isNaN() {
          return _isNaN.apply(this, arguments);
        }
        isNaN.toString = function () {
          return _isNaN.toString();
        };
        return isNaN;
      }(function () {
        return isNaN(this.re) || isNaN(this.im);
      }),
      isZero: function isZero() {
        return 0 === this.im && 0 === this.re;
      },
      isFinite: function (_isFinite) {
        function isFinite() {
          return _isFinite.apply(this, arguments);
        }
        isFinite.toString = function () {
          return _isFinite.toString();
        };
        return isFinite;
      }(function () {
        return isFinite(this.re) && isFinite(this.im);
      }),
      isInfinite: function isInfinite() {
        return !(this.isNaN() || this.isFinite());
      }
    }, o.ZERO = new o(0, 0), o.ONE = new o(1, 0), o.I = new o(0, 1), o.PI = new o(Math.PI, 0), o.E = new o(Math.E, 0), o.INFINITY = new o(1 / 0, 1 / 0), o.NAN = new o(NaN, NaN), o.EPSILON = 1e-15, Object.defineProperty(o, "__esModule", {
      value: !0
    }), o.default = o, o.Complex = o, e.exports = o;
  }();
}(fa), new ma.exports.Decimal(0), new ma.exports.Decimal(1), new ma.exports.Decimal(-1), new ma.exports.Decimal(NaN), new ma.exports.Decimal(1 / 0), new ma.exports.Decimal(-1 / 0), [.9999999999998099, 676.5203681218851, -1259.1392167224028, 771.3234287776531, -176.6150291621406, 12.507343278686905, -.13857109526572012, 9984369578019572e-21, 1.5056327351493116e-7].map(function (e) {
  return new ma.exports.Decimal(e);
}), new ma.exports.Decimal(607).div(128), [.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, .0001580887032249125, -.00021026444172410488, .00021743961811521265, -.0001643181065367639, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22].map(function (e) {
  return new ma.exports.Decimal(e);
});
var ga = "List",
  ya = "Missing",
  ba = "Nothing",
  va = "Add",
  xa = "Divide",
  ka = "Multiply",
  wa = "Power";
function _a(e) {
  return null !== e && "object" == typeof e && "num" in e;
}
function Ma(e) {
  return null !== e && "object" == typeof e && "sym" in e;
}
function Sa(e) {
  return null !== e && "object" == typeof e && "fn" in e;
}
function La(e) {
  if ("number" == typeof e) return e;
  if (null === e) return null;
  if (_a(e)) return e.num.endsWith("d") || e.num.endsWith("n") ? null : parseFloat(e.num);
  var t = Da(e);
  return null === t ? null : "NaN" === t ? NaN : "+Infinity" === t ? 1 / 0 : "-Infinity" === t ? -1 / 0 : "Complex" === qa(e) && 0 === La(Oa(e, 2)) ? La(Oa(e, 1)) : null;
}
function Ca(e) {
  return null === e ? null : "object" == typeof e && "str" in e ? e.str : "string" != typeof e || e.length < 2 || "'" !== e[0] || "'" !== e[e.length - 1] ? null : e.substring(1, e.length - 1);
}
function Aa(e) {
  var t, i, r, n, a, o;
  var s = Da(e);
  if ("ThreeQuarter" === s) return [3, 4];
  if ("TwoThird" === s) return [2, 3];
  if ("Half" === s) return [1, 2];
  if ("Third" === s) return [1, 3];
  if ("Quarter" === s) return [1, 4];
  if (za(e)) return [null, null];
  var l = qa(e);
  if (!l) return [null, null];
  var c = null,
    u = null;
  if (l === wa) {
    var _r40 = La(Oa(e, 2));
    1 === _r40 ? (c = null !== (t = La(Oa(e, 1))) && void 0 !== t ? t : null, u = 1) : -1 === _r40 && (c = 1, u = null !== (i = La(Oa(e, 1))) && void 0 !== i ? i : null);
  }
  return l === xa && (c = null !== (r = La(Oa(e, 1))) && void 0 !== r ? r : null, u = null !== (n = La(Oa(e, 2))) && void 0 !== n ? n : null), l === ka && qa(Oa(e, 2)) === wa && -1 === La(Oa(Oa(e, 2), 2)) && (c = null !== (a = La(Oa(e, 1))) && void 0 !== a ? a : null, u = null !== (o = La(Oa(Oa(e, 2), 1))) && void 0 !== o ? o : null), null === c || null === u ? [null, null] : Number.isInteger(c) && Number.isInteger(u) ? [c, u] : [null, null];
}
function Na(e) {
  return null === e ? null : Array.isArray(e) ? e[0] : Sa(e) ? e.fn[0] : null;
}
function za(e) {
  return null === e || !Array.isArray(e) && ("object" != typeof e || !("fn" in e || "dic" in e));
}
function qa(e) {
  if (null === e) return "";
  var t = Na(e);
  return "string" == typeof t ? t : "";
}
function Da(e) {
  return null === e ? null : "string" == typeof e ? e.length >= 2 && "'" === e[0] && "'" === e[e.length - 1] ? null : e : Ma(e) ? e.sym : null;
}
function Ea(e) {
  return Array.isArray(e) ? e.slice(1) : Sa(e) ? e.fn.slice(1) : [];
}
function Ta(e, t) {
  var i = null;
  if (Array.isArray(e) && (i = e), Sa(e) && (i = e.fn), null === i) return [];
  var r = 1;
  var n = [];
  for (; r < i.length;) n.push(t(i[r])), r += 1;
  return n;
}
function Oa(e, t) {
  var i, r;
  return null === e ? null : Array.isArray(e) ? null !== (i = e[t]) && void 0 !== i ? i : null : Sa(e) && null !== (r = e.fn[t]) && void 0 !== r ? r : null;
}
function Ba(e) {
  return Array.isArray(e) ? Math.max(0, e.length - 1) : Sa(e) ? Math.max(0, e.fn.length - 1) : 0;
}
function Ka(e) {
  return "object" == typeof e && "dict" in e ? e.dict : null;
}
var Fa = [{
  name: "Overscript",
  trigger: {
    infix: "\\overset"
  },
  precedence: 700
}, {
  name: "Underscript",
  trigger: {
    infix: "\\underset"
  },
  precedence: 700
}, {
  name: "Increment",
  trigger: {
    postfix: ["+", "+"]
  },
  precedence: 880
}, {
  name: "Decrement",
  trigger: {
    postfix: ["-", "-"]
  },
  precedence: 880
}, {
  name: "PreIncrement",
  trigger: {
    prefix: ["+", "+"]
  },
  precedence: 880
}, {
  name: "PreDecrement",
  trigger: {
    prefix: ["-", "-"]
  },
  precedence: 880
}, {
  name: "Ring",
  trigger: {
    infix: "\\circ"
  },
  precedence: 265
}, {
  name: "Transpose",
  trigger: {
    superfix: "T"
  }
}, {
  name: "ConjugateTranspose",
  trigger: {
    superfix: "H"
  }
}, {
  name: "StringJoin",
  trigger: {
    infix: ["\\lt", "\\gt"]
  },
  precedence: 780
}, {
  name: "Starstar",
  trigger: {
    infix: ["\\star", "\\star"]
  },
  precedence: 780
}, {
  name: "PartialDerivative",
  trigger: {
    prefix: "\\partial"
  },
  parse: function parse(e, t, i) {
    var r, n;
    var a = !1,
      o = ba,
      s = ba;
    for (; !a;) t.skipSpace(), t.match("_") ? s = t.matchRequiredLatexArgument() : t.match("^") ? o = t.matchRequiredLatexArgument() : a = !0;
    if ("Sequence" === qa(s) && (s = [ga].concat(_toConsumableArray(Ea(s)))), !s || !o) return [e, null];
    var l = null !== (r = t.matchRequiredLatexArgument()) && void 0 !== r ? r : ba;
    return l !== ba && (l = [l].concat(_toConsumableArray(null !== (n = t.matchArguments("group")) && void 0 !== n ? n : ba))), [null, ["PartialDerivative", l, s, o]];
  },
  serialize: function serialize(e, t) {
    var i = "\\partial";
    var r = Oa(t, 1),
      n = Oa(t, 2),
      a = Oa(t, 3);
    return null !== n && n !== ba && (Na(n) === ga ? i += "_{" + e.serialize(["Sequence"].concat(_toConsumableArray(Ea(n)))) + "}" : i += "_{" + e.serialize(n) + "}"), null !== a && a !== ba && (i += "^{" + e.serialize(a) + "}"), null !== r && r !== ba && (i += e.serialize(r)), i;
  },
  precedence: 740
}, {
  name: "OverBar",
  trigger: {
    symbol: "\\overline"
  },
  requiredLatexArg: 1
}, {
  name: "UnderBar",
  trigger: {
    symbol: "\\underline"
  },
  requiredLatexArg: 1
}, {
  name: "OverVector",
  trigger: {
    symbol: "\\vec"
  },
  requiredLatexArg: 1
}, {
  name: "OverTile",
  trigger: {
    symbol: "\\tilde"
  },
  requiredLatexArg: 1
}, {
  name: "OverHat",
  trigger: {
    symbol: "\\hat"
  },
  requiredLatexArg: 1
}, {
  name: "OverHat",
  trigger: {
    symbol: "\\hat"
  },
  requiredLatexArg: 1
}, {
  name: "OverRightArrow",
  trigger: {
    symbol: "\\overrightarrow"
  },
  requiredLatexArg: 1
}, {
  name: "OverLeftArrow",
  trigger: {
    symbol: "\\overleftarrow"
  },
  requiredLatexArg: 1
}, {
  name: "OverRightDoubleArrow",
  trigger: {
    symbol: "\\Overrightarrow"
  },
  requiredLatexArg: 1
}, {
  name: "OverLeftHarpoon",
  trigger: {
    symbol: "\\overleftharpoon"
  },
  requiredLatexArg: 1
}, {
  name: "OverRightHarpoon",
  trigger: {
    symbol: "\\overrightharpoon"
  },
  requiredLatexArg: 1
}, {
  name: "OverLeftRightArrow",
  trigger: {
    symbol: "\\overleftrightarrow"
  },
  requiredLatexArg: 1
}, {
  name: "OverBrace",
  trigger: {
    symbol: "\\overbrace"
  },
  requiredLatexArg: 1
}, {
  name: "OverLineSegment",
  trigger: {
    symbol: "\\overlinesegment"
  },
  requiredLatexArg: 1
}, {
  name: "OverGroup",
  trigger: {
    symbol: "\\overgroup"
  },
  requiredLatexArg: 1
}];
function $a(e, t) {
  return t > 2 ? "solidus" : "radical";
}
function Pa(e) {
  return "<space>" === e || "\\qquad" === e || "\\quad" === e || "\\enskip" === e || "\\;" === e || "\\," === e || "\\ " === e || "~" === e;
}
function Ia(e, t, i) {
  return function (r, n, a) {
    if (a >= t) return [r, null];
    n.skipSpace(), n.match(i), "Missing" === r && (r = ba);
    var o = [e, null != r ? r : ba];
    var s = !1;
    for (; !s;) {
      for (s = !0, n.skipSpace(); n.match(i);) o.push(ba), n.skipSpace();
      if (n.atEnd) o.push(ba);else {
        var _e163 = n.matchExpression(t);
        o.push(null != _e163 ? _e163 : ba), s = null === _e163;
      }
      s || (n.skipSpace(), s = !n.match(i));
    }
    return [null, o];
  };
}
function Ra(e) {
  return function (t, i) {
    return Ea(i).map(function (e) {
      return t.serialize(e);
    }).join(e);
  };
}
var Va = [{
  name: "LatexTokens",
  serialize: function serialize(e, t) {
    return Ea(t).map(function (t) {
      var i = Ca(t);
      return null === i ? e.serialize(t) : "<{>" === i ? "{" : "<}>" === i ? "}" : "<$>" === i ? "$" : "<$$>" === i ? "$$" : "<space>'" === i ? " " : i;
    }).join("");
  }
}, {
  name: "Parentheses",
  trigger: {
    matchfix: "("
  },
  parse: function parse(e, t, i) {
    var r;
    var n = t.index;
    if (!t.match("(")) return [e, null];
    var a = !1,
      o = !0,
      s = !1,
      l = 0,
      c = "";
    for (; !a && o;) {
      var _e164 = t.next();
      t.atEnd || ")" === _e164 ? a = !0 : "\\mathtt" === _e164 ? (t.match("<{>"), s = !0) : Pa(_e164) || (/^[0-9a-zA-Z]$/.test(_e164) ? (l = Math.max(l, parseInt(_e164, 36)), c += _e164) : o = !1), s && t.match("<}>");
    }
    if (t.skipSpace(), o && t.match("_")) {
      var _i118 = null !== (r = La(t.matchRequiredLatexArgument())) && void 0 !== r ? r : NaN;
      return !isFinite(_i118) || _i118 < 2 || _i118 > 36 || l >= _i118 ? (t.onError({
        code: "base-out-of-range"
      }), [e, ba]) : [e, ["BaseForm", parseInt(c, _i118), _i118]];
    }
    t.index = n;
    var u = t.matchBalancedExpression("(", ")", t.onError);
    return u ? "Sequence" === qa(u) ? [e, ["Parentheses"].concat(_toConsumableArray(Ea(u)))] : [e, ["Parentheses", u]] : [e, ["Parentheses"]];
  },
  serialize: function serialize(e, t) {
    return e.wrapString(Ra(",")(e, t), (e.level, "paren"));
  },
  separator: ",",
  closeFence: ")",
  precedence: 20
}, {
  name: ga,
  trigger: {
    matchfix: "\\lbrack"
  },
  separator: ",",
  closeFence: "\\rbrack",
  precedence: 20,
  parse: function parse(e, t, i) {
    if (null === e) {
      var _i119 = t.matchBalancedExpression("\\lbrack", "\\rbrack", t.onError);
      return _i119 ? "Sequence" === qa(_i119) ? [e, [ga].concat(_toConsumableArray(Ea(_i119)))] : [e, [ga, _i119]] : [null, [ga]];
    }
    return [e, null];
  }
}, {
  name: "BaseForm",
  serialize: function serialize(e, t) {
    var i, r;
    var n = null !== (i = La(Oa(t, 2))) && void 0 !== i ? i : NaN;
    if (isFinite(n) && n >= 2 && n <= 36) {
      var _e165 = null !== (r = La(Oa(t, 1))) && void 0 !== r ? r : NaN;
      if (isFinite(_e165)) {
        var _t137 = Number(_e165).toString(n),
          _i120 = 0;
        if (2 === n || 10 === n ? _i120 = 4 : 16 === n ? _i120 = 2 : n > 16 && (_i120 = 4), _i120 > 0) {
          var _e166 = _t137;
          _t137 = "";
          for (var _r41 = 0; _r41 < _e166.length; _r41++) _r41 > 0 && _r41 % _i120 == 0 && (_t137 = "\\, " + _t137), _t137 = _e166[_e166.length - _r41 - 1] + _t137;
        }
        return "(\\mathtt{".concat(_t137, "})_{").concat(n, "}");
      }
    }
    return "\\operatorname{BaseForm}(" + e.serialize(Oa(t, 1)) + ", " + e.serialize(Oa(t, 2)) + ")";
  }
}, {
  name: "Set",
  trigger: {
    matchfix: "\\lbrace"
  },
  separator: ",",
  closeFence: "\\rbrace",
  precedence: 20
}, {
  name: "Sequence",
  trigger: {
    infix: ","
  },
  parse: Ia("Sequence", 20, ","),
  serialize: Ra(", "),
  precedence: 20
}, {
  name: "Sequence2",
  trigger: {
    infix: ";"
  },
  parse: Ia("Sequence2", 19, ";"),
  serialize: Ra("; "),
  precedence: 19
}, {
  name: ya,
  trigger: "\\placeholder",
  serialize: "\\placeholder",
  requiredLatexArg: 1
}, {
  name: "Subscript",
  trigger: {
    infix: "_"
  },
  precedence: 720,
  serialize: function serialize(e, t) {
    return 2 === Ba(t) ? e.serialize(Oa(t, 1)) + "_{" + e.serialize(Oa(t, 2)) + "}" : "_{" + e.serialize(Oa(t, 1)) + "}";
  },
  parse: function parse(e, t, i) {
    var r;
    if (!t.match("_")) return [e, null];
    var n = null !== (r = t.matchRequiredLatexArgument()) && void 0 !== r ? r : ya;
    return e ? [null, ["Subscript", e, n]] : [null, ["Subscript", n]];
  }
}, {
  name: "Superplus",
  trigger: {
    superfix: "+"
  }
}, {
  name: "Subplus",
  trigger: {
    subfix: "+"
  }
}, {
  name: "Superminus",
  trigger: {
    superfix: "-"
  }
}, {
  name: "Subminus",
  trigger: {
    subfix: "-"
  }
}, {
  name: "Superstar",
  trigger: {
    superfix: "*"
  }
}, {
  name: "Superstar",
  trigger: {
    superfix: "\\star"
  }
}, {
  name: "Substar",
  trigger: {
    subfix: "*"
  }
}, {
  name: "Substar",
  trigger: {
    subfix: "\\star"
  }
}, {
  name: "Superdagger",
  trigger: {
    superfix: "\\dagger"
  }
}, {
  name: "Superdagger",
  trigger: {
    superfix: "\\dag"
  }
}, {
  name: "Prime",
  trigger: {
    superfix: "\\prime"
  },
  arguments: "group"
}, {
  trigger: {
    superfix: "\\doubleprime"
  },
  parse: function parse(e, t) {
    return [null, ["Prime", null != e ? e : ba, 2]];
  },
  arguments: "group"
}, {
  name: "InverseFunction",
  serialize: function serialize(e, t) {
    return e.serialize(Oa(t, 1)) + "^{-1}";
  }
}, {
  name: "Derivative",
  trigger: "D",
  parse: function parse(e, t) {
    return [e, ["Derivative", 1]];
  },
  serialize: function serialize(e, t) {
    var i;
    var r = null !== (i = La(Oa(t, 1))) && void 0 !== i ? i : NaN;
    if (!isFinite(r)) return "";
    var n = e.serialize(Oa(t, 2));
    return 1 === r ? n + "^{\\prime}" : 2 === r ? n + "^{\\doubleprime}" : n + "^{(" + Number(r).toString() + ")}";
  }
}, {
  name: "Piecewise",
  trigger: {
    environment: "cases"
  },
  parse: function parse(e, t) {
    var i;
    return [e, ["Piecewise", null !== (i = t.matchTabular()) && void 0 !== i ? i : ba]];
  },
  serialize: function serialize(e, t) {
    if (qa(Oa(t, 1)) !== ga) return "";
    var i = Ea(Oa(t, 1));
    var r = "",
      n = "";
    var _iterator100 = _createForOfIteratorHelper(i),
      _step100;
    try {
      for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
        var _t138 = _step100.value;
        r += n;
        var _i121 = Oa(_t138, 1);
        if (null !== _i121) {
          r += e.serialize(_i121);
          var _n31 = Oa(_t138, 2);
          null !== _n31 && (r += "&" + e.serialize(_n31));
        }
        n = "\\\\";
      }
    } catch (err) {
      _iterator100.e(err);
    } finally {
      _iterator100.f();
    }
    return "\\begin{cases}" + r + "\\end{cases}";
  }
}];
function ja(e) {
  var t, i, r, n;
  if ("number" == typeof (e = Ha(e))) return -e;
  if (e && _a(e)) return "-" === e.num[0] ? {
    num: e.num.slice(1)
  } : "+" === e.num[0] ? {
    num: "-" + e.num.slice(1)
  } : {
    num: "-" + e.num
  };
  if (e instanceof ma.exports.Decimal) return e.mul(-1);
  if (e instanceof fa.exports.Complex) return e.mul(-1);
  var a = qa(e),
    o = Ba(e);
  if ("Negate" === a && 1 === o) return null !== (t = Oa(e, 1)) && void 0 !== t ? t : ya;
  if (a === ka) {
    var _t139 = ja(null !== (i = Oa(e, 1)) && void 0 !== i ? i : ya);
    return [ka, _t139].concat(_toConsumableArray(Ea(e).slice(1)));
  }
  return a === va ? [va].concat(_toConsumableArray(Ta(e, ja))) : "Subtract" === a ? ["Subtract", null !== (r = Oa(e, 2)) && void 0 !== r ? r : ya, null !== (n = Oa(e, 1)) && void 0 !== n ? n : ya] : "Parentheses" === a && 1 === o ? ja(Oa(Oa(e, 1), 1)) : ["Negate", null != e ? e : ya];
}
function Ha(e) {
  return null === e ? ba : za(e) ? e : "Parentheses" === Na(e) && 1 === Ba(e) ? Ha(Oa(e, 1)) : function (e, t) {
    var i = Na(e);
    if (null !== i) return [t(i)].concat(_toConsumableArray(Ea(e).map(t)));
    var r = Ka(e);
    if (null !== r) {
      var _e167 = Object.keys(r),
        _i122 = {};
      for (var _i123 = 0, _e168 = _e167; _i123 < _e168.length; _i123++) {
        var _n32 = _e168[_i123];
        _i122[_n32] = t(r[_n32]);
      }
      return {
        dict: _i122
      };
    }
    return t(e);
  }(e, Ha);
}
function Ua(e, t, i, r) {
  return null === i ? "\\sqrt{}" : (r = null != r ? r : 2, "solidus" === t ? e.wrapShort(i) + "^{1\\/" + e.serialize(r) + "}" : "quotient" === t ? e.wrapShort(i) + "^{\\frac{1}{" + e.serialize(r) + "}}" : 2 === La(r) ? "\\sqrt{" + e.serialize(i) + "}" : "\\sqrt[" + e.serialize(r) + "]{" + e.serialize(i) + "}");
}
function Wa(e, t, i) {
  if (!t.match("\\sqrt")) return [e, null];
  var r = t.matchOptionalLatexArgument(),
    n = t.matchRequiredLatexArgument();
  return null === n ? null !== r ? [e, ["Root", ba, r]] : [e, ["Sqrt"]] : null !== r ? [e, ["Root", n, r]] : [e, ["Sqrt", n]];
}
function Za(e, t, i) {
  if (276 < i) return [e, null];
  var r = t.index;
  if (!t.match("-")) return [e, null];
  var n = t.matchExpression(null === e ? 400 : 277);
  return null === n ? (t.index = r, [e, null]) : null === e ? [null, ["Negate", n]] : [null, ["Subtract", e, n]];
}
function Ga(e, t) {
  var i;
  if (null === t) return "";
  e.level -= 1;
  var r = "";
  var _ref17 = function (e) {
      var t, i, r, n, a, o;
      if (qa(e) !== ka) return [[], []];
      var s = [],
        l = [],
        c = Ea(e);
      var _iterator101 = _createForOfIteratorHelper(c),
        _step101;
      try {
        for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
          var _e169 = _step101.value;
          if (qa(_e169) === wa) {
            if ("Negate" === qa(Oa(_e169, 2))) {
              var _r42 = null !== (t = Oa(_e169, 1)) && void 0 !== t ? t : ba,
                _n33 = null !== (i = Oa(Oa(_e169, 2), 1)) && void 0 !== i ? i : ba;
              l.push([wa, _r42, _n33]);
            } else {
              var _t140 = null !== (r = La(Oa(_e169, 2))) && void 0 !== r ? r : NaN;
              -1 === _t140 ? l.push(null !== (n = Oa(_e169, 1)) && void 0 !== n ? n : ba) : _t140 < 0 ? l.push([wa, null !== (a = Oa(_e169, 1)) && void 0 !== a ? a : ba, null !== (o = ja(Oa(_e169, 2))) && void 0 !== o ? o : ba]) : s.push(_e169);
            }
          } else s.push(_e169);
        }
      } catch (err) {
        _iterator101.e(err);
      } finally {
        _iterator101.f();
      }
      return [s, l];
    }(t),
    _ref18 = _slicedToArray(_ref17, 2),
    n = _ref18[0],
    a = _ref18[1];
  if (a.length > 0 && (r = 1 === a.length && 1 === a[0] ? 0 === n.length ? "1" : 1 === n.length ? e.serialize(n[0]) : Ga(e, [ka].concat(_toConsumableArray(n))) : e.serialize([xa, 1 === n.length ? n[0] : [ka].concat(_toConsumableArray(n)), 1 === a.length ? a[0] : [ka].concat(_toConsumableArray(a))])), r) return e.level += 1, r;
  var o = !1,
    s = null;
  var l = Ba(t) + 1;
  var c = !1;
  for (var _n34 = 1; _n34 < l; _n34++) if (s = Oa(t, _n34), null !== s) {
    var _t141 = void 0;
    "number" == typeof s || _a(s) ? (_t141 = e.serialize(s), "-1" !== _t141 || r ? ("-" === _t141[0] && (_t141 = _t141.slice(1), o = !o), r = r ? ua([r, e.options.multiply, _t141]) : _t141) : r = "-", c = !0) : qa(s) !== wa || isNaN(null !== (i = La(Oa(s, 1))) && void 0 !== i ? i : NaN) ? ("Negate" === qa(s) && (s = Oa(s, 1), o = !o), _t141 = e.wrap(s, 390), r = r ? c && qa(s) === xa ? ua([r, "\\times", _t141]) : e.options.invisibleMultiply ? ua([r, e.options.invisibleMultiply, _t141]) : ua([r, _t141]) : _t141, c = !1) : (r = r ? ua([r, e.options.multiply, e.serialize(s)]) : e.serialize(s), c = !0);
  }
  return e.level += 1, o ? "-" + r : r;
}
function Xa(e, t) {
  if (null === t) return "";
  if (1 === Ba(t)) return e.serialize(Oa(t, 1));
  var i = e.level > 3 ? "inline-solidus" : "quotient";
  if ("inline-solidus" === i || "nice-solidus" === i) {
    var _r43 = e.wrapShort(Oa(t, 1)),
      _n35 = e.wrapShort(Oa(t, 2));
    return "nice-solidus" === i ? "^{".concat(_r43, "}\\!\\!/\\!_{").concat(_n35, "}") : "".concat(_r43, "\\/").concat(_n35);
  }
  return "reciprocal" === i ? e.wrap(Oa(t, 1)) + e.wrap(Oa(t, 2)) + "^{-1}" : "factor" === i ? "\\frac{1}{" + e.serialize(Oa(t, 2)) + "}" + e.wrap(Oa(t, 1)) : "\\frac{" + e.serialize(Oa(t, 1)) + "}{" + e.serialize(Oa(t, 2)) + "}";
}
function Ya(e, t) {
  var i;
  var r = Oa(t, 1),
    n = Oa(t, 2);
  if (null === n) return e.serialize(r);
  if (null === r) return "";
  var a = qa(t);
  if ("Sqrt" === a || "Root" === a) return Ua(e, $a(0, e.level), Oa(t, 1), Oa(t, 2));
  var o = null !== (i = La(n)) && void 0 !== i ? i : 1;
  if (-1 === o) return e.serialize([xa, "1", r]);
  if (o < 0) return e.serialize([xa, "1", [wa, r, -o]]);
  if (qa(n) === xa) {
    if (1 === La(Oa(n, 1))) return Ua(e, $a(0, e.level), r, Oa(n, 2));
  } else if (qa(n) === wa && -1 === La(Oa(n, 2))) return Ua(e, $a(0, e.level), r, Oa(n, 1));
  return e.wrapShort(r) + "^{" + e.serialize(n) + "}";
}
function Qa(e, t, i) {
  var r;
  var n = t.next();
  var a = !1,
    o = 0;
  if (t.skipSpace(), t.match("^")) {
    if (t.skipSpace(), t.match("<{>")) {
      t.skipSpace(), t.match("-") && t.match("1") && (a = !0);
      do {
        t.match("\\doubleprime") && (o += 2), t.match("\\prime") && (o += 1), t.match("'") && (o += 1);
      } while (!t.match("<}>") && !t.atEnd);
    }
    var _e170 = !1;
    for (; !_e170;) t.skipSpace(), t.match("\\doubleprime") ? o += 2 : t.match("\\prime") || t.match("'") ? o += 1 : _e170 = !0;
  }
  var s = null !== (r = {
    "\\arcsin": "Arcsin",
    "\\arccos": "Arccos",
    "\\arctan": "Arctan",
    "\\arctg": "Arctan",
    "\\arcctg": "Arctan",
    "\\arcsec": "Arcsec",
    "\\arccsc": " Arccsc",
    "\\arsinh": "Arsinh",
    "\\arcosh": "Arcosh",
    "\\artanh": "Artanh",
    "\\arcsech": "Arcsech",
    "\\arccsch": "Arcsch",
    "\\ch": "Cosh",
    "\\cos": "Cos",
    "\\cosec": "Csc",
    "\\cosh": "Csch",
    "\\cot": "Cot",
    "\\cotg": "Cot",
    "\\coth": "Coth",
    "\\csc": "Csc",
    "\\ctg": "Cot",
    "\\cth": "Coth",
    "\\sec": "Sec",
    "\\sin": "Sin",
    "\\sinh": "Sinh",
    "\\sh": "Sinh",
    "\\tan": "Tan",
    "\\tanh": "Tanh",
    "\\tg": "Tan",
    "\\th": "Tanh"
  }[n]) && void 0 !== r ? r : n;
  a && (s = ["InverseFunction", s]), o >= 1 && (s = ["Derivative", o, s]);
  var l = t.matchArguments("implicit");
  return null === l ? [null, s] : [null, [s].concat(_toConsumableArray(l))];
}
function Ja(e) {
  return da(e);
}
Number.EPSILON.toString();
var eo = {
    algebra: [{
      name: "To",
      trigger: {
        infix: "\\to"
      },
      precedence: 270
    }],
    arithmetic: [{
      name: "ThreeQuarter",
      serialize: "\\frac{3}{4}"
    }, {
      name: "TwoThird",
      serialize: "\\frac{2}{3}"
    }, {
      name: "Half",
      serialize: "\\frac{1}{2}"
    }, {
      name: "Third",
      serialize: "\\frac{1}{3}"
    }, {
      name: "Quarter",
      serialize: "\\frac{1}{4}"
    }, {
      name: "CatalanConstant",
      serialize: "G"
    }, {
      name: "GoldenRatio",
      serialize: "\\varphi"
    }, {
      name: "EulerGamma",
      serialize: "\\gamma"
    }, {
      name: "Degrees",
      serialize: "\\frac{\\pi}{180}"
    }, {
      name: "MinusDoublePi",
      serialize: "-2\\pi"
    }, {
      name: "MinusPi",
      serialize: "-\\pi"
    }, {
      name: "MinusHalfPi",
      serialize: "-\\frac{\\pi}{2}"
    }, {
      name: "QuarterPi",
      serialize: "\\frac{\\pi}{4}"
    }, {
      name: "ThirdPi",
      serialize: "\\frac{\\pi}{3}"
    }, {
      name: "HalfPi",
      serialize: "\\frac{\\pi}{2}"
    }, {
      name: "TwoThirdPi",
      serialize: "\\frac{2\\pi}{3}"
    }, {
      name: "ThreeQuarterPi",
      serialize: "\\frac{3\\pi}{4}"
    }, {
      name: "DoublePi",
      serialize: "2\\pi"
    }, {
      name: "Complex",
      precedence: 275,
      serialize: function serialize(e, t) {
        var i = La(Oa(t, 1)),
          r = La(Oa(t, 2));
        if (0 === r) return e.serialize(Oa(t, 1));
        var n = 1 === r ? "\\imaginaryI" : -1 === r ? "-\\imaginaryI" : ua([e.serialize(Oa(t, 2)), "\\imaginaryI"]);
        return 0 === i ? n : ua([e.serialize(Oa(t, 1)), "+", n]);
      }
    }, {
      name: "Exp",
      serialize: function serialize(e, t) {
        var i;
        return ua(["\\exponentialE^{", e.serialize(null !== (i = Oa(t, 1)) && void 0 !== i ? i : ba), "}"]);
      }
    }, {
      name: "Square",
      serialize: function serialize(e, t) {
        return e.wrapShort(Oa(t, 1)) + "^2";
      }
    }, {
      trigger: {
        symbol: "\\infty"
      },
      parse: {
        num: "+Infinity"
      }
    }, {
      name: "ComplexInfinity",
      trigger: {
        symbol: ["\\tilde", "\\infty"]
      },
      serialize: "\\tilde\\infty"
    }, {
      name: "ComplexInfinity",
      trigger: {
        symbol: ["\\tilde", "<{>", "\\infty", "<}>"]
      },
      serialize: "\\tilde\\infty"
    }, {
      name: "Pi",
      trigger: {
        symbol: "\\pi"
      }
    }, {
      name: "Pi",
      trigger: {
        symbol: "\u03C0"
      },
      serialize: "\\pi"
    }, {
      name: "ExponentialE",
      trigger: {
        symbol: "e"
      },
      serialize: "e"
    }, {
      name: "ImaginaryUnit",
      trigger: {
        symbol: "i"
      },
      serialize: "\\imaginaryI"
    }, {
      name: "ImaginaryUnit",
      trigger: {
        symbol: "\\imaginaryI"
      }
    }, {
      name: va,
      trigger: {
        prefix: "+",
        infix: "+"
      },
      parse: function parse(e, t, i) {
        if (275 < i) return [e, null];
        var r = t.index;
        if (!t.match("+")) return [e, null];
        var n = t.matchExpression(null === e ? 400 : 275);
        return null === n ? (t.index = r, [e, null]) : null === e ? [null, n] : t.applyOperator(va, e, n);
      },
      serialize: function serialize(e, t) {
        var i, r;
        e.level -= 1;
        var n = qa(t);
        var a = "",
          o = Oa(t, 1),
          s = !Number.isNaN(null !== (i = La(o)) && void 0 !== i ? i : NaN);
        if ("Negate" === n) a = "-" + e.wrap(o, 276);else if (n === va) {
          a = e.serialize(o);
          var _i124 = Ba(t) + 1;
          for (var _n36 = 2; _n36 < _i124; _n36++) {
            o = Oa(t, _n36);
            var _i125 = null !== (r = La(o)) && void 0 !== r ? r : NaN,
              _l9 = !Number.isNaN(_i125);
            var _c5 = !1;
            if (null !== o && s) {
              var _Aa = Aa(o),
                _Aa2 = _slicedToArray(_Aa, 2),
                _t142 = _Aa2[0],
                _i126 = _Aa2[1];
              null !== _t142 && null !== _i126 && isFinite(_t142) && isFinite(_i126) && 1 !== _i126 && (a += e.options.invisiblePlus + e.serialize(o), _c5 = !0);
            }
            if (!_c5) if (_i125 < 0) a += e.serialize(o);else if ("Negate" === qa(o)) a += e.wrap(o, 275);else {
              var _t143 = e.wrap(o, 275);
              "-" === _t143[0] || "+" === _t143[0] ? a += _t143 : a = a + "+" + _t143;
            }
            s = _l9;
          }
        } else if ("Subtract" === n) {
          var _i127 = Oa(t, 2);
          a = null !== _i127 ? e.wrap(o, 275) + "-" + e.wrap(_i127, 275) : e.wrap(o, 275);
        }
        return e.level += 1, a;
      },
      associativity: "both",
      precedence: 275
    }, {
      name: "Negate",
      trigger: {
        prefix: "-"
      },
      parse: Za,
      associativity: "left",
      precedence: 275
    }, {
      name: "Subtract",
      trigger: {
        infix: "-"
      },
      parse: Za,
      associativity: "both",
      precedence: 275
    }, {
      name: "PlusMinus",
      trigger: {
        infix: "\\pm"
      },
      associativity: "both",
      precedence: 270
    }, {
      name: "MinusPlus",
      trigger: {
        infix: "\\mp"
      },
      associativity: "both",
      precedence: 270
    }, {
      name: ka,
      trigger: {
        infix: "\\times"
      },
      serialize: Ga,
      associativity: "both",
      precedence: 390
    }, {
      name: ka,
      trigger: {
        infix: "\\cdot"
      },
      serialize: Ga,
      associativity: "both",
      precedence: 390
    }, {
      name: ka,
      trigger: {
        infix: "*"
      },
      serialize: Ga,
      associativity: "both",
      precedence: 390
    }, {
      name: xa,
      trigger: "\\frac",
      parse: function parse(e, t, i) {
        var r, n, a, o;
        if (!t.match("\\frac")) return [e, null];
        var s = null !== (r = t.matchRequiredLatexArgument()) && void 0 !== r ? r : ya,
          l = null !== (n = t.matchRequiredLatexArgument()) && void 0 !== n ? n : ya;
        if ("PartialDerivative" === qa(s) && ("PartialDerivative" === qa(l) || qa(l) === ka && "PartialDerivative" === qa(Oa(l, 1)))) {
          var _i128 = null !== (a = Oa(s, 3)) && void 0 !== a ? a : ba;
          var _r44 = Oa(s, 1);
          null !== _r44 && _r44 !== ba || (_r44 = null !== (o = t.matchExpression()) && void 0 !== o ? o : ba);
          var _n37 = [];
          if (qa(l) === ka) {
            var _iterator102 = _createForOfIteratorHelper(Ea(l)),
              _step102;
            try {
              for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
                var _e171 = _step102.value;
                if ("PartialDerivative" === Na(_e171)) {
                  var _t144 = Oa(_e171, 2);
                  _t144 && _n37.push(_t144);
                }
              }
            } catch (err) {
              _iterator102.e(err);
            } finally {
              _iterator102.f();
            }
          } else {
            var _e172 = Oa(l, 2);
            _e172 && _n37.push(_e172);
          }
          return _n37.length > 1 && (_n37 = [ga].concat(_toConsumableArray(_n37))), [e, ["PartialDerivative", _r44, _n37, _i128 === ba ? 1 : _i128]];
        }
        return [e, [xa, s, l]];
      },
      serialize: Xa,
      requiredLatexArg: 2
    }, {
      name: xa,
      trigger: {
        infix: "\\/"
      },
      serialize: Xa,
      associativity: "non",
      precedence: 660
    }, {
      name: xa,
      trigger: {
        infix: "/"
      },
      serialize: Xa,
      associativity: "non",
      precedence: 660
    }, {
      name: xa,
      trigger: {
        infix: "\\div"
      },
      serialize: Xa,
      associativity: "non",
      precedence: 660
    }, {
      name: wa,
      trigger: {
        infix: "^"
      },
      associativity: "non",
      precedence: 720,
      serialize: Ya
    }, {
      name: wa,
      trigger: {
        infix: ["*", "*"]
      },
      associativity: "non",
      precedence: 720,
      serialize: Ya
    }, {
      name: "Sqrt",
      trigger: "\\sqrt",
      optionalLatexArg: 1,
      requiredLatexArg: 1,
      parse: Wa,
      serialize: Ya
    }, {
      name: "Root",
      trigger: "\\sqrt",
      optionalLatexArg: 1,
      requiredLatexArg: 1,
      parse: Wa
    }, {
      name: "Norm",
      trigger: {
        matchfix: "\\lVert"
      },
      closeFence: "\\rVert"
    }, {
      name: "Norm",
      trigger: {
        matchfix: "\\|"
      },
      closeFence: "\\|"
    }, {
      name: "Norm",
      trigger: {
        matchfix: ["|", "|"]
      },
      closeFence: ["|", "|"]
    }, {
      name: "Abs",
      trigger: {
        matchfix: "|"
      },
      closeFence: "|"
    }, {
      name: "Abs",
      trigger: {
        matchfix: "\\lvert"
      },
      closeFence: "\\rvert"
    }, {
      name: "Factorial",
      trigger: {
        postfix: "!"
      },
      precedence: 810
    }, {
      name: "Factorial2",
      trigger: {
        postfix: ["!", "!"]
      },
      precedence: 810
    }, {
      name: "Lcm",
      trigger: {
        symbol: ["\\operatorname", "<{>", "l", "c", "m", "<}>"]
      }
    }, {
      name: "Gcd",
      trigger: {
        symbol: ["\\operatorname", "<{>", "g", "c", "d", "<}>"]
      }
    }, {
      name: "Ceil",
      trigger: {
        symbol: ["\\operatorname", "<{>", "c", "e", "i", "l", "<}>"]
      }
    }, {
      name: "Floor",
      trigger: {
        symbol: ["\\operatorname", "<{>", "f", "l", "o", "o", "r", "<}>"]
      }
    }, {
      name: "Round",
      trigger: {
        symbol: ["\\operatorname", "<{>", "r", "o", "u", "n", "d", "<}>"]
      }
    }, {
      name: "Sign",
      trigger: {
        symbol: ["\\operatorname", "<{>", "s", "g", "n", "<}>"]
      }
    }],
    calculus: [{
      trigger: {
        symbol: "\\int"
      },
      parse: function parse(e, t, i) {
        if (!t.match("\\int")) return [e, null];
        var r = ba,
          n = ba,
          a = !1;
        for (; !a;) t.skipSpace(), t.match("_") ? n = t.matchRequiredLatexArgument() : t.match("^") ? r = t.matchRequiredLatexArgument() : a = !0;
        var o = t.matchBalancedExpression("<{>", "<}>");
        return [e, ["Integral", null != o ? o : "", null != r ? r : ba, null != n ? n : ba]];
      },
      serialize: function serialize(e, t) {
        return "";
      }
    }],
    core: Va,
    inequalities: [{
      name: "NotLess",
      trigger: {
        infix: ["!", "<"]
      },
      associativity: "right",
      precedence: 246
    }, {
      name: "NotLess",
      trigger: {
        infix: "\\nless"
      },
      associativity: "right",
      precedence: 246
    }, {
      name: "Less",
      trigger: {
        infix: "<"
      },
      associativity: "right",
      precedence: 245
    }, {
      name: "Less",
      trigger: {
        infix: "\\lt"
      },
      associativity: "right",
      precedence: 245
    }, {
      name: "LessEqual",
      trigger: {
        infix: ["<", "="]
      },
      associativity: "right",
      precedence: 241
    }, {
      name: "LessEqual",
      trigger: {
        infix: "\\le"
      },
      associativity: "right",
      precedence: 241
    }, {
      name: "LessEqual",
      trigger: {
        infix: "\\leq"
      },
      associativity: "right",
      precedence: 241
    }, {
      name: "LessEqual",
      trigger: {
        infix: "\\leqslant"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "LessNotEqual",
      trigger: {
        infix: "\\lneqq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "NotLessNotEqual",
      trigger: {
        infix: "\\nleqq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "LessOverEqual",
      trigger: {
        infix: "\\leqq"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "GreaterOverEqual",
      trigger: {
        infix: "\\geqq"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "Equal",
      trigger: {
        infix: "="
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "StarEqual",
      trigger: {
        infix: ["*", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "StarEqual",
      trigger: {
        infix: ["\\star", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "PlusEqual",
      trigger: {
        infix: ["+", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "MinusEqual",
      trigger: {
        infix: ["-", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "SlashEqual",
      trigger: {
        infix: ["/", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "EqualEqual",
      trigger: {
        infix: ["=", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "EqualEqualEqual",
      trigger: {
        infix: ["=", "=", "="]
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "TildeFullEqual",
      trigger: {
        infix: "\\cong"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "NotTildeFullEqual",
      trigger: {
        infix: "\\ncong"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Assign",
      trigger: {
        infix: [":", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Assign",
      trigger: {
        infix: "\\coloneq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Approx",
      trigger: {
        infix: "\\approx"
      },
      associativity: "right",
      precedence: 247
    }, {
      name: "NotApprox",
      trigger: {
        infix: "\\approx"
      },
      associativity: "right",
      precedence: 247
    }, {
      name: "ApproxEqual",
      trigger: {
        infix: "\\approxeq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "NotApproxEqual",
      trigger: {
        infix: ["!", "\\approxeq"]
      },
      associativity: "right",
      precedence: 250
    }, {
      name: "NotEqual",
      trigger: {
        infix: "\\ne"
      },
      associativity: "right",
      precedence: 255
    }, {
      name: "Unequal",
      trigger: {
        infix: ["!", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "GreaterEqual",
      trigger: {
        infix: "\\ge"
      },
      associativity: "right",
      precedence: 242
    }, {
      name: "GreaterEqual",
      trigger: {
        infix: "\\geq"
      },
      associativity: "right",
      precedence: 242
    }, {
      name: "GreaterEqual",
      trigger: {
        infix: [">", "="]
      },
      associativity: "right",
      precedence: 243
    }, {
      name: "GreaterEqual",
      trigger: {
        infix: "\\geqslant"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "GreaterNotEqual",
      trigger: {
        infix: "\\gneqq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "NotGreaterNotEqual",
      trigger: {
        infix: "\\ngeqq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Greater",
      trigger: {
        infix: ">"
      },
      associativity: "right",
      precedence: 245
    }, {
      name: "Greater",
      trigger: {
        infix: "\\gt"
      },
      associativity: "right",
      precedence: 245
    }, {
      name: "NotGreater",
      trigger: {
        infix: "\\ngtr"
      },
      associativity: "right",
      precedence: 244
    }, {
      name: "NotGreater",
      trigger: {
        infix: ["!", ">"]
      },
      associativity: "right",
      precedence: 244
    }, {
      name: "RingEqual",
      trigger: {
        infix: "\\circeq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "TriangleEqual",
      trigger: {
        infix: "\\triangleq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "DotEqual",
      trigger: {
        infix: "\\doteq"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "DotEqualDot",
      trigger: {
        infix: "\\doteqdot"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "FallingDotEqual",
      trigger: {
        infix: "\\fallingdotseq"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "RisingDotEqual",
      trigger: {
        infix: "\\fallingdotseq"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "QuestionEqual",
      trigger: {
        infix: "\\questeq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Equivalent",
      trigger: {
        infix: "\\equiv"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "MuchLess",
      trigger: {
        infix: "\\ll"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "MuchGreater",
      trigger: {
        infix: "\\gg"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Precedes",
      trigger: {
        infix: "\\prec"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Succeeds",
      trigger: {
        infix: "\\succ"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "PrecedesEqual",
      trigger: {
        infix: "\\preccurlyeq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "SucceedsEqual",
      trigger: {
        infix: "\\curlyeqprec"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "NotPrecedes",
      trigger: {
        infix: "\\nprec"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "NotSucceeds",
      trigger: {
        infix: "\\nsucc"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Between",
      trigger: {
        infix: "\\between"
      },
      associativity: "right",
      precedence: 265
    }],
    other: Fa,
    physics: [{
      name: "mu-0",
      trigger: {
        symbol: ["\\mu", "_", "0"]
      }
    }],
    sets: [{
      trigger: {
        symbol: "\\N"
      },
      parse: "NaturalNumber"
    }, {
      trigger: {
        symbol: "\\Z"
      },
      parse: "Integer"
    }, {
      trigger: {
        symbol: "\\Q"
      },
      parse: "RationalNumber"
    }, {
      trigger: {
        symbol: ["\\mathbb", "<{>", "A", "<}>"]
      },
      parse: "AlgebraicNumber"
    }, {
      trigger: {
        symbol: "\\R"
      },
      parse: "RealNumber"
    }, {
      trigger: {
        symbol: "\\C"
      },
      parse: "ComplexNumber"
    }, {
      trigger: {
        symbol: "\\varnothing"
      },
      parse: "EmptySet"
    }, {
      trigger: {
        symbol: "\\emptyset"
      },
      parse: "EmptySet"
    }, {
      name: "Complement",
      trigger: {
        infix: "\\complement"
      },
      precedence: 240
    }, {
      name: "Element",
      trigger: {
        infix: "\\in"
      },
      precedence: 240
    }, {
      name: "Intersection",
      trigger: {
        infix: "\\Cap"
      },
      precedence: 350
    }, {
      name: "NotElement",
      trigger: {
        infix: "\\notin"
      },
      precedence: 240
    }, {
      name: "SetMinus",
      trigger: {
        infix: "\\setminus"
      },
      precedence: 650
    }, {
      name: "SubsetEqual",
      trigger: {
        infix: "\\subseteq"
      },
      precedence: 240
    }, {
      name: "SymmetricDifference",
      trigger: {
        infix: "\\triangle"
      },
      precedence: 260
    }, {
      name: "Union",
      trigger: {
        infix: "\\cup"
      },
      precedence: 350
    }, {
      name: "Contains",
      trigger: {
        infix: "\\ni"
      },
      associativity: "right",
      precedence: 160
    }, {
      name: "Subset",
      trigger: {
        infix: "\\subset"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "SquareSubset",
      trigger: {
        infix: "\\sqsubset"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "SquareSubsetEqual",
      trigger: {
        infix: "\\sqsubseteq"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "Superset",
      trigger: {
        infix: "\\supset"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "SquareSuperset",
      trigger: {
        infix: "\\sqsupset"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "SquareSupersetEqual",
      trigger: {
        infix: "\\sqsupseteq"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "NotSubset",
      trigger: {
        infix: "\\nsubset"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "NotSuperset",
      trigger: {
        infix: "\\nsupset"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "SupersetEqual",
      trigger: {
        infix: "\\supseteq"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "NotSubsetNotEqual",
      trigger: {
        infix: "\\nsubseteq"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "NotSupersetNotEqual",
      trigger: {
        infix: "\\nsupseteq"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "SubsetNotEqual",
      trigger: {
        infix: "\\subsetneq"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "SubsetNotEqual",
      trigger: {
        infix: "\\varsupsetneqq"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "SupersetNotEqual",
      trigger: {
        infix: "\\supsetneq"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "SupersetNotEqual",
      trigger: {
        infix: "\\varsupsetneq"
      },
      associativity: "right",
      precedence: 240
    }],
    symbols: [{
      trigger: {
        symbol: "\\alpha"
      },
      parse: "\u03B1"
    }, {
      trigger: {
        symbol: "\\beta"
      },
      parse: "\u03B2"
    }, {
      trigger: {
        symbol: "\\gamma"
      },
      parse: "\u03B3"
    }, {
      trigger: {
        symbol: "\\delta"
      },
      parse: "\u03B4"
    }, {
      trigger: {
        symbol: "\\epsilon"
      },
      parse: "\u03F5"
    }, {
      trigger: {
        symbol: "\\varepsilon"
      },
      parse: "\u03B5"
    }, {
      trigger: {
        symbol: "\\zeta"
      },
      parse: "\u03B6"
    }, {
      trigger: {
        symbol: "\\eta"
      },
      parse: "\u03B7"
    }, {
      trigger: {
        symbol: "\\theta"
      },
      parse: "\u03B8"
    }, {
      trigger: {
        symbol: "\\vartheta"
      },
      parse: "\u03D1"
    }, {
      trigger: {
        symbol: "\\iota"
      },
      parse: "\u03B9"
    }, {
      trigger: {
        symbol: "\\kappa"
      },
      parse: "\u03BA"
    }, {
      trigger: {
        symbol: "\\varkappa"
      },
      parse: "\u03F0"
    }, {
      trigger: {
        symbol: "\\lambda"
      },
      parse: "\u03BB"
    }, {
      trigger: {
        symbol: "\\mu"
      },
      parse: "\u03BC"
    }, {
      trigger: {
        symbol: "\\nu"
      },
      parse: "\u03BD"
    }, {
      trigger: {
        symbol: "\\xi"
      },
      parse: "\u03BE"
    }, {
      trigger: {
        symbol: "\\omicron"
      },
      parse: "\u03BF"
    }, {
      trigger: {
        symbol: "\\varpi"
      },
      parse: "\u03D6"
    }, {
      trigger: {
        symbol: "\\rho"
      },
      parse: "\u03C1"
    }, {
      trigger: {
        symbol: "\\varrho"
      },
      parse: "\u03F1"
    }, {
      trigger: {
        symbol: "\\sigma"
      },
      parse: "\u03C3"
    }, {
      trigger: {
        symbol: "\\varsigma"
      },
      parse: "\u03C2"
    }, {
      trigger: {
        symbol: "\\tau"
      },
      parse: "\u03C4"
    }, {
      trigger: {
        symbol: "\\phi"
      },
      parse: "\u03D5"
    }, {
      trigger: {
        symbol: "\\varphi"
      },
      parse: "\u03C6"
    }, {
      trigger: {
        symbol: "\\upsilon"
      },
      parse: "\u03C5"
    }, {
      trigger: {
        symbol: "\\chi"
      },
      parse: "\u03C7"
    }, {
      trigger: {
        symbol: "\\psi"
      },
      parse: "\u03C8"
    }, {
      trigger: {
        symbol: "\\omega"
      },
      parse: "\u03C9"
    }, {
      trigger: {
        symbol: "\\Gamma"
      },
      parse: "\u0393"
    }, {
      trigger: {
        symbol: "\\Delta"
      },
      parse: "\u0394"
    }, {
      trigger: {
        symbol: "\\Theta"
      },
      parse: "\u0398"
    }, {
      trigger: {
        symbol: "\\Lambda"
      },
      parse: "\u039B"
    }, {
      trigger: {
        symbol: "\\Xi"
      },
      parse: "\u039E"
    }, {
      trigger: {
        symbol: "\\Pi"
      },
      parse: "\u03A0"
    }, {
      trigger: {
        symbol: "\\Sigma"
      },
      parse: "\u03A3"
    }, {
      trigger: {
        symbol: "\\Upsilon"
      },
      parse: "\u03A5"
    }, {
      trigger: {
        symbol: "\\Phi"
      },
      parse: "\u03A6"
    }, {
      trigger: {
        symbol: "\\Psi"
      },
      parse: "\u03A8"
    }, {
      trigger: {
        symbol: "\\Omega"
      },
      parse: "\u03A9"
    }, {
      trigger: {
        symbol: "\\digamma"
      },
      parse: "\u03DD"
    }, {
      trigger: {
        symbol: "\\aleph"
      },
      parse: "\u2135"
    }, {
      trigger: {
        symbol: "\\beth"
      },
      parse: "\u2136"
    }, {
      trigger: {
        symbol: "\\daleth"
      },
      parse: "\u2138"
    }, {
      trigger: {
        symbol: "\\gimel"
      },
      parse: "\u2137"
    }, {
      trigger: {
        symbol: "\\Finv"
      },
      parse: "\u2132"
    }, {
      trigger: {
        symbol: "\\Game"
      },
      parse: "\u2141"
    }, {
      trigger: {
        symbol: "\\wp"
      },
      parse: "\u2118"
    }, {
      trigger: {
        symbol: "\\eth"
      },
      parse: "\xf0"
    }, {
      trigger: {
        symbol: "\\mho"
      },
      parse: "\u2127"
    }, {
      trigger: {
        symbol: "\\clubsuit"
      },
      parse: "\u2663"
    }, {
      trigger: {
        symbol: "\\heartsuit"
      },
      parse: "\u2661"
    }, {
      trigger: {
        symbol: "\\spadesuit"
      },
      parse: "\u2660"
    }, {
      trigger: {
        symbol: "\\diamondsuit"
      },
      parse: "\u2662"
    }, {
      trigger: {
        symbol: "\\sharp"
      },
      parse: "\u266F"
    }, {
      trigger: {
        symbol: "\\flat"
      },
      parse: "\u266D"
    }, {
      trigger: {
        symbol: "\\natural"
      },
      parse: "\u266E"
    }],
    trigonometry: [{
      name: "Arcsin",
      trigger: "\\arcsin",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Arccos",
      trigger: "\\arccos",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Arctan",
      trigger: "\\arctan",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Arctan",
      trigger: "\\arctg",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Arccot",
      trigger: "\\arcctg",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Arcsec",
      trigger: "\\arcsec",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Arccsc",
      trigger: "\\arccsc",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Arsinh",
      trigger: "\\arsinh",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Arcosh",
      trigger: "\\arcosh",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Artanh",
      trigger: "\\artanh",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Arsech",
      trigger: "\\arsech",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Arcsch",
      trigger: "\\arcsch",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Cosh",
      trigger: "\\ch",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Cosec",
      trigger: "\\cosec",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Cosh",
      trigger: "\\cosh",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Cot",
      trigger: "\\cot",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Cot",
      trigger: "\\cotg",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Coth",
      trigger: "\\coth",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Csc",
      trigger: "\\csc",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Cot",
      trigger: "\\ctg",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Coth",
      trigger: "\\cth",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Sec",
      trigger: "\\sec",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Sinh",
      trigger: "\\sinh",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Sinh",
      trigger: "\\sh",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Tan",
      trigger: "\\tan",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Tan",
      trigger: "\\tg",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Tanh",
      trigger: "\\tanh",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Tanh",
      trigger: "\\th",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Cos",
      trigger: "\\cos",
      arguments: "implicit",
      parse: Qa
    }, {
      name: "Sin",
      trigger: "\\sin",
      arguments: "implicit",
      parse: Qa
    }]
  },
  to = {
    precision: 15,
    positiveInfinity: "\\infty",
    negativeInfinity: "-\\infty",
    notANumber: "\\operatorname{NaN}",
    decimalMarker: ".",
    groupSeparator: ",",
    exponentProduct: "\\cdot",
    beginExponentMarker: "10^{",
    endExponentMarker: "}",
    notation: "auto",
    truncationMarker: "\\ldots",
    beginRepeatingDigits: "\\overline{",
    endRepeatingDigits: "}",
    imaginaryNumber: "\\imaginaryI"
  },
  io = {
    invisibleOperator: ka,
    skipSpace: !0,
    parseArgumentsOfUnknownLatexCommands: !0,
    parseNumbers: !0,
    promoteUnknownSymbols: /^[a-zA-Z]$/,
    promoteUnknownFunctions: /^[fg]$/,
    ignoreCommands: ["\\displaystyle", "\\!", "\\:", "\\enskip", "\\quad", "\\,", "\\;", "\\enspace", "\\qquad", "\\selectfont", "\\tiny", "\\scriptsize", "\\footnotesize", "\\small", "\\normalsize", "\\large", "\\Large", "\\LARGE", "\\huge", "\\Huge"],
    idempotentCommands: ["\\left", "\\right", "\\mleft", "\\mright", "\\middle", "\\bigl", "\\bigm", "\\bigr", "\\Bigl", "\\Bigm", "\\Bigr", "\\biggl", "\\biggm", "\\biggr", "\\Biggl", "\\Biggm", "\\Biggr"],
    invisiblePlusOperator: va,
    preserveLatex: !1
  },
  ro = {
    invisibleMultiply: "",
    invisiblePlus: "",
    multiply: "\\times"
  };
function no(e, t) {
  var i;
  var r = e;
  for (var _e173 = 0; _e173 < t.length; _e173++) {
    var _n38 = null !== (i = t[_e173]) && void 0 !== i ? i : "";
    if (/[a-zA-Z*]/.test(_n38[0])) {
      var _t145 = r.match(new RegExp("(.*)#" + Number(_e173 + 1).toString()));
      _t145 && /\\[a-zA-Z*]+/.test(_t145[1]) && (_n38 = " " + _n38);
    }
    r = r.replace("#" + Number(_e173 + 1).toString(), _n38);
  }
  return r;
}
var ao = /*#__PURE__*/function () {
  function ao(e, t, i, r) {
    var _this35 = this;
    _classCallCheck(this, ao);
    var n;
    this.index = 0, this.options = _objectSpread(_objectSpread(_objectSpread({}, to), io), t), this.tokens = e, this.onError = function (e) {
      return r(_objectSpread(_objectSpread({}, e), {}, {
        before: _this35.latexBefore(),
        after: _this35.latexAfter()
      }));
    }, this.dictionary = i, this.invisibleOperatorPrecedence = 0, this.options.invisibleOperator && (n = this.dictionary.name.get(this.options.invisibleOperator), void 0 === n ? r({
      code: "unknown-operator",
      arg: "invisible operator " + this.options.invisibleOperator
    }) : void 0 === n.precedence ? r({
      code: "expected-operator",
      arg: "invisible operator " + this.options.invisibleOperator
    }) : this.invisibleOperatorPrecedence = n.precedence);
  }
  _createClass(ao, [{
    key: "clone",
    value: function clone(e, t) {
      return new ao(this.tokens.slice(e, t), this.options, this.dictionary, this.onError);
    }
  }, {
    key: "balancedClone",
    value: function balancedClone(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      if (!this.matchAll(e)) return i || this.onError({
        code: "syntax-error",
        arg: "Expected " + da(e)
      }), null;
      var r = this.index;
      var n = r,
        a = 1;
      for (; !this.atEnd && 0 !== a;) this.skipSpace(), n = this.index, this.matchAll(t) ? a -= 1 : this.matchAll(e) ? a += 1 : this.next();
      return 0 !== a ? (i || this.onError({
        code: "unbalanced-symbols",
        arg: da(e) + da(t)
      }), this.index = r, null) : this.clone(r, n);
    }
  }, {
    key: "atEnd",
    get: function get() {
      return this.index >= this.tokens.length;
    }
  }, {
    key: "peek",
    get: function get() {
      return this.tokens[this.index];
    }
  }, {
    key: "latex",
    value: function latex(e, t) {
      return da(this.tokens.slice(e, t));
    }
  }, {
    key: "latexAhead",
    value: function latexAhead(e) {
      return da(this.tokens.slice(this.index, this.index + e));
    }
  }, {
    key: "latexBefore",
    value: function latexBefore() {
      return this.latex(0, this.index);
    }
  }, {
    key: "latexAfter",
    value: function latexAfter() {
      return this.latex(this.index);
    }
  }, {
    key: "lookAhead",
    value: function lookAhead() {
      var e = Math.min(this.dictionary.lookahead, this.tokens.length - this.index);
      var t = [];
      for (; e > 0;) t[e] = this.latexAhead(e--);
      return t;
    }
  }, {
    key: "peekDefinition",
    value: function peekDefinition(e) {
      var _this36 = this;
      var t;
      t = "operator" === e ? this.lookAhead().map(function (e, t) {
        var i, r, n, a, o;
        return null !== (a = null !== (r = null === (i = _this36.dictionary.infix[t]) || void 0 === i ? void 0 : i.get(e)) && void 0 !== r ? r : null === (n = _this36.dictionary.postfix[t]) || void 0 === n ? void 0 : n.get(e)) && void 0 !== a ? a : null === (o = _this36.dictionary.prefix[t]) || void 0 === o ? void 0 : o.get(e);
      }) : this.lookAhead().map(function (t, i) {
        var r;
        return null === (r = _this36.dictionary[e][i]) || void 0 === r ? void 0 : r.get(t);
      });
      for (var _e174 = t.length; _e174 > 0; _e174--) if (void 0 !== t[_e174]) return [t[_e174], _e174];
      return [null, 0];
    }
  }, {
    key: "next",
    value: function next() {
      return this.tokens[this.index++];
    }
  }, {
    key: "skipSpace",
    value: function skipSpace() {
      if (!this.atEnd && "<{>" === this.peek && "<}>" === this.tokens[this.index + 1]) return this.index += 2, this.skipSpace(), !0;
      var e = !1;
      for (; !this.atEnd && (this.options.ignoreCommands.includes(this.peek) || this.options.idempotentCommands.includes(this.peek));) this.index += 1, this.skipSpace(), e = !0;
      if (!this.options.skipSpace) return !1;
      for (; this.match("<space>");) e = !0;
      return e && this.skipSpace(), e;
    }
  }, {
    key: "match",
    value: function match(e) {
      return this.tokens[this.index] === e && (this.index++, !0);
    }
  }, {
    key: "matchAll",
    value: function matchAll(e) {
      var t = !0;
      "string" == typeof e && (e = [e]);
      var i = 0;
      do {
        t = this.tokens[this.index + i] === e[i++];
      } while (t && i < e.length);
      return t && (this.index += i), t;
    }
  }, {
    key: "matchAny",
    value: function matchAny(e) {
      return e.includes(this.tokens[this.index]) ? this.tokens[this.index++] : "";
    }
  }, {
    key: "matchWhile",
    value: function matchWhile(e) {
      var t = [];
      for (; e.includes(this.tokens[this.index]);) t.push(this.tokens[this.index++]);
      return t;
    }
  }, {
    key: "matchSign",
    value: function matchSign() {
      var e = !1,
        t = !1;
      for (; !t;) this.skipSpace() ? t = !1 : this.match("-") ? (e = !e, t = !1) : t = !this.match("+");
      return e ? "-" : "+";
    }
  }, {
    key: "matchDecimalDigits",
    value: function matchDecimalDigits() {
      var e = "",
        t = !1;
      for (; !t;) if (e += this.matchWhile(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]).join(""), t = !0, this.options.groupSeparator) {
        var _e175 = this.index;
        this.match(this.options.groupSeparator) && (/[0-9]/.test(this.peek) ? t = !1 : this.index = _e175);
      }
      return e;
    }
  }, {
    key: "matchSignedInteger",
    value: function matchSignedInteger() {
      var e = this.index,
        t = this.matchSign(),
        i = this.matchDecimalDigits();
      return i ? ("-" === t ? "-" : "") + i : (this.index = e, "");
    }
  }, {
    key: "matchExponent",
    value: function matchExponent() {
      var e = this.index;
      var t = "";
      if (this.matchAny(["e", "E", "d", "D"])) {
        var _e176 = this.matchSignedInteger();
        _e176 && (t = "e" + _e176);
      }
      if (t) return t;
      if (this.match("\\times") && (this.skipSpace(), this.match("1") && this.match("0") && this.match("^"))) {
        if (/[0-9]/.test(this.peek)) return "e" + this.next();
        if (this.match("<{>")) {
          this.skipSpace();
          var _e177 = this.matchSignedInteger();
          if (this.skipSpace(), this.match("<}>") && _e177) return "e" + _e177;
        }
      }
      return this.index = e, "";
    }
  }, {
    key: "matchNumber",
    value: function matchNumber() {
      var e, t;
      if (!this.options.parseNumbers) return "";
      var i = this.index,
        r = this.matchSign();
      var n = this.matchDecimalDigits();
      if (!n) return this.index = i, "";
      n = ("-" === r ? "-" : "") + n;
      var a = !1,
        o = !1;
      this.match(null !== (e = this.options.decimalMarker) && void 0 !== e ? e : "") && (a = !0, n += "." + (null !== (t = this.matchDecimalDigits()) && void 0 !== t ? t : "0"));
      var s = this.matchExponent();
      return s && (o = !0), n ? n.length + s.length > 12 ? a || o ? n + s + "d" : n + "n" : n + s : (this.index = i, "");
    }
  }, {
    key: "matchOperator",
    value: function matchOperator(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var _this$peekDefinition = this.peekDefinition(e),
        _this$peekDefinition2 = _slicedToArray(_this$peekDefinition, 2),
        r = _this$peekDefinition2[0],
        n = _this$peekDefinition2[1];
      if (null === r) return null;
      if ("function" == typeof r.parse) {
        var _r$parse, _r$parse2;
        var _e178 = null;
        return (_r$parse = r.parse(t, this, i), _r$parse2 = _slicedToArray(_r$parse, 2), t = _r$parse2[0], _e178 = _r$parse2[1]), null === _e178 ? null : this.applyInvisibleOperator(t, _e178);
      }
      var a = r.precedence;
      if (void 0 === a || a < i) return null;
      a += "left" === r.associativity ? 1 : 0, this.index += n;
      var o = this.matchExpression(a);
      return this.applyInvisibleOperator.apply(this, _toConsumableArray(this.applyOperator(r.parse, t, o)));
    }
  }, {
    key: "matchArguments",
    value: function matchArguments(e) {
      if (!e) return null;
      var t = this.index;
      var i = null;
      var r = this.matchMatchfixOperator();
      if ("group" === e && "Parentheses" === qa(r)) i = Ea(r);else if ("implicit" === e) {
        if ("Parentheses" === qa(r)) i = Ea(r);else if (null !== r) i = [r];else {
          var _e179 = this.matchPrimary();
          null !== _e179 && (i = [_e179]);
        }
      } else this.index = t;
      return i;
    }
  }, {
    key: "matchMatchfixOperator",
    value: function matchMatchfixOperator() {
      var _this$peekDefinition3 = this.peekDefinition("matchfix"),
        _this$peekDefinition4 = _slicedToArray(_this$peekDefinition3, 1),
        e = _this$peekDefinition4[0];
      if (null === e) return null;
      if ("function" == typeof e.parse) return this.applyInvisibleOperator.apply(this, _toConsumableArray(e.parse(null, this, 0)));
      var t = "object" == typeof e.trigger ? e.trigger.matchfix : e.trigger;
      if (!t || !e.closeFence || !e.parse) return null;
      var i = this.matchBalancedExpression(t, e.closeFence, this.onError);
      return i ? [e.parse, i] : [e.parse];
    }
  }, {
    key: "matchDefinition",
    value: function matchDefinition(e) {
      var _this$peekDefinition5 = this.peekDefinition(e),
        _this$peekDefinition6 = _slicedToArray(_this$peekDefinition5, 2),
        t = _this$peekDefinition6[0],
        i = _this$peekDefinition6[1];
      if ("function" == typeof (null == t ? void 0 : t.parse)) {
        var _t$parse = t.parse(null, this, 0),
          _t$parse2 = _slicedToArray(_t$parse, 2),
          _e180 = _t$parse2[1];
        return [t, _e180];
      }
      return this.index += i, [t, null];
    }
  }, {
    key: "matchSymbol",
    value: function matchSymbol() {
      var e, t, i, r;
      var _this$matchDefinition = this.matchDefinition("symbol"),
        _this$matchDefinition2 = _slicedToArray(_this$matchDefinition, 2),
        n = _this$matchDefinition2[0],
        a = _this$matchDefinition2[1];
      if (null !== a) return a;
      if (null === n) {
        if (null === (e = this.options.promoteUnknownFunctions) || void 0 === e ? void 0 : e.test(this.peek)) {
          var _e181 = this.next(),
            _t146 = this.matchMatchfixOperator();
          return null === _t146 ? _e181 : "Parentheses" !== qa(_t146) ? null : [_e181].concat(_toConsumableArray(Ea(_t146)));
        }
        return (null === (t = this.options.promoteUnknownSymbols) || void 0 === t ? void 0 : t.test(this.peek)) ? this.next() : this.matchUnknownLatexCommand();
      }
      var o = [],
        s = [];
      var l,
        c = null !== (i = n.optionalLatexArg) && void 0 !== i ? i : 0;
      for (; c > 0;) l = this.matchOptionalLatexArgument(), null !== l && s.push(l), c--;
      for (c = null !== (r = n.requiredLatexArg) && void 0 !== r ? r : 0; c > 0;) l = this.matchRequiredLatexArgument(), null === l && this.onError({
        code: "expected-argument"
      }), null !== l && o.push(l), c--;
      var u = this.matchArguments(n.arguments);
      return null === u ? 0 === o.length && 0 === s.length ? n.parse : [n.parse].concat(o, s) : [n.parse].concat(o, _toConsumableArray(u), s);
    }
  }, {
    key: "matchOptionalLatexArgument",
    value: function matchOptionalLatexArgument() {
      return this.skipSpace(), this.matchBalancedExpression("[", "]");
    }
  }, {
    key: "matchRequiredLatexArgument",
    value: function matchRequiredLatexArgument() {
      return this.skipSpace(), this.matchBalancedExpression("<{>", "<}>") || (/^[0-9]$/.test(this.peek) ? parseFloat(this.next()) : /^[^\\#]$/.test(this.peek) ? this.next() : this.matchSymbol());
    }
  }, {
    key: "matchSupsub",
    value: function matchSupsub(e) {
      var _this37 = this;
      if (null === e) return null;
      var t = null;
      return this.skipSpace(), [["^", "superfix"], ["_", "subfix"]].forEach(function (i) {
        var _this37$peekDefinitio, _this37$peekDefinitio2, _this37$peekDefinitio3, _this37$peekDefinitio4, _this37$applyOperator, _this37$applyOperator2;
        var r, n, a;
        if (null !== t) return;
        var _i129 = _slicedToArray(i, 2),
          o = _i129[0],
          s = _i129[1],
          l = _this37.index;
        if (!_this37.match(o)) return;
        var c = _this37.index;
        var u,
          d = 0;
        if (_this37.match("<{>") ? ((_this37$peekDefinitio = _this37.peekDefinition(s), _this37$peekDefinitio2 = _slicedToArray(_this37$peekDefinitio, 2), u = _this37$peekDefinitio2[0], d = _this37$peekDefinitio2[1]), u ? "function" == typeof u.parse ? t = u.parse(e, _this37, 0)[1] : (_this37.index += d, _this37.match("<}>") ? t = [null !== (r = u.parse) && void 0 !== r ? r : u.name, e] : _this37.index = c) : _this37.index = c) : ((_this37$peekDefinitio3 = _this37.peekDefinition(s), _this37$peekDefinitio4 = _slicedToArray(_this37$peekDefinitio3, 2), u = _this37$peekDefinitio4[0], d = _this37$peekDefinitio4[1]), u ? "function" == typeof u.parse ? t = u.parse(e, _this37, 0)[1] : (_this37.index += d, t = [null !== (n = u.parse) && void 0 !== n ? n : u.name, e]) : _this37.index = c), null === t && (u = null === (a = _this37.dictionary.infix[1]) || void 0 === a ? void 0 : a.get(o), "function" == typeof (null == u ? void 0 : u.parse) ? (_this37.index = l, t = u.parse(e, _this37, 0)[1]) : "string" == typeof (null == u ? void 0 : u.parse) ? ((_this37$applyOperator = _this37.applyOperator(u.parse, e, _this37.matchRequiredLatexArgument()), _this37$applyOperator2 = _slicedToArray(_this37$applyOperator, 2), e = _this37$applyOperator2[0], t = _this37$applyOperator2[1]), t = _this37.applyInvisibleOperator(e, t)) : t = _this37.applyInvisibleOperator(e, o)), null !== t) {
          var _e182 = _this37.matchArguments(null == u ? void 0 : u.arguments);
          null !== _e182 && (t = [t].concat(_toConsumableArray(_e182)));
        }
      }), t;
    }
  }, {
    key: "matchPostfix",
    value: function matchPostfix(e) {
      var _t$parse3, _t$parse4;
      if (null === e) return null;
      var _this$peekDefinition7 = this.peekDefinition("postfix"),
        _this$peekDefinition8 = _slicedToArray(_this$peekDefinition7, 2),
        t = _this$peekDefinition8[0],
        i = _this$peekDefinition8[1];
      return null == t ? null : "function" == typeof t.parse ? ((_t$parse3 = t.parse(e, this, 0), _t$parse4 = _slicedToArray(_t$parse3, 2), e = _t$parse4[1]), null === e ? null : e) : (this.index += i, [t.parse, e]);
    }
  }, {
    key: "matchString",
    value: function matchString() {
      var e = "",
        t = this.atEnd;
      for (; !t;) {
        if (this.match("<space>")) e += " ";else {
          var _i130 = this.peek;
          "]" === _i130 ? t = !0 : /^<({|}|\$|\$\$|space)>$/.test(_i130) ? "\\" === _i130[0] ? (this.onError({
            code: "unexpected-command"
          }), e += this.next()) : t = !0 : e += this.next();
        }
        t = t || this.atEnd;
      }
      return e;
    }
  }, {
    key: "matchEnvironmentName",
    value: function matchEnvironmentName(e, t) {
      if (this.match(e)) {
        var _e183 = this.index;
        if (this.match("<{>")) {
          var _e184 = this.matchString();
          if (this.match("<}>") && _e184 === t) return !0;
        }
        this.index = _e183;
      }
      return !1;
    }
  }, {
    key: "matchTabular",
    value: function matchTabular() {
      var e = ["list"];
      var t = ["list"],
        i = null,
        r = !1;
      for (; !this.atEnd && !r;) if (this.match("&")) t.push(null != i ? i : ba), i = null;else if (this.match("\\\\") || this.match("\\cr")) this.skipSpace(), this.matchOptionalLatexArgument(), null !== i && t.push(i), e.push(t), t = ["list"], i = null;else {
        var _e185 = this.matchExpression();
        null === _e185 && (r = !0), i = null !== i ? this.applyInvisibleOperator(i, _e185) : _e185;
      }
      return t.length > 1 && e.push(t), e;
    }
  }, {
    key: "matchEnvironment",
    value: function matchEnvironment() {
      var e;
      if (this.match("\\begin") && this.match("<{>")) {
        var _t147 = this.matchString();
        if (this.match("<}>")) {
          var _i131 = this.index;
          var _r45 = this.index,
            _n39 = 1;
          for (; !this.atEnd && 0 !== _n39;) _r45 = this.index, this.matchEnvironmentName("\\begin", _t147) ? _n39 += 1 : this.matchEnvironmentName("\\end", _t147) ? _n39 -= 1 : this.next();
          var _a21 = this.dictionary.environment.get(_t147);
          return "function" == typeof (null == _a21 ? void 0 : _a21.parse) ? _a21.parse(null, this.clone(_i131, _r45), 0)[1] : null !== (e = null == _a21 ? void 0 : _a21.parse) && void 0 !== e ? e : null;
        }
      }
      return null;
    }
  }, {
    key: "applyOperator",
    value: function applyOperator(e, t, i) {
      var r, n, a, o;
      var s = this.dictionary.name.get(e);
      if (void 0 === s) return this.onError({
        code: "unknown-operator"
      }), [t, i];
      if (void 0 !== (null === (r = s.trigger) || void 0 === r ? void 0 : r.prefix) && null === t && null !== i) return [null, [s.name, i]];
      if (void 0 !== (null === (n = s.trigger) || void 0 === n ? void 0 : n.postfix) && null !== t) return [null, [s.name, t]];
      if (void 0 !== (null === (a = s.trigger) || void 0 === a ? void 0 : a.matchfix) || void 0 !== (null === (o = s.trigger) || void 0 === o ? void 0 : o.infix)) {
        if ("non" === s.associativity) return [null, [e, null != t ? t : "Missing", null != i ? i : "Missing"]];
        if (qa(t) === e) {
          if ("both" === s.associativity) {
            if (qa(i) === e) {
              if (Array.isArray(t)) return [null, t.concat(Ea(i))];
              if (Sa(t)) return [null, t.fn.concat(Ea(i))];
            } else i && (Array.isArray(t) && t.push(i), Sa(t) && t.fn.push(i));
            return [null, t];
          }
          return "left" === s.associativity ? [null, [e, null != t ? t : ya, null != i ? i : ya]] : Array.isArray(t) ? [null, [e, t[1], [e, t[2], null != i ? i : ya]]] : (Sa(t) && (t.fn[2] = [e, t.fn[2], null != i ? i : ya]), [null, t]);
        }
        return qa(i) === e ? "both" === s.associativity ? (Array.isArray(i) && t && i.splice(1, 0, t), Sa(i) && t && i.fn.splice(1, 0, t), [null, i]) : "right" === s.associativity ? [null, [e, null != t ? t : ya, null != i ? i : ya]] : Array.isArray(i) ? [null, [e, i[1], [e, i[2], null != t ? t : ya]]] : (Sa(i) && (i.fn[2] = [e, i.fn[2], null != t ? t : ya]), [null, i]) : [null, [e, null != t ? t : "Missing", null != i ? i : "Missing"]];
      }
      return [t, null];
    }
  }, {
    key: "applyInvisibleOperator",
    value: function applyInvisibleOperator(e, t) {
      var _this$applyOperator, _this$applyOperator2, _this$applyOperator3, _this$applyOperator4;
      if (null === e) return t;
      if (null === t) return e;
      if (this.options.invisiblePlusOperator && ("number" == typeof e || _a(e)) && function (e) {
        var t, i;
        var r = Da(e);
        if (null !== r && ["ThreeQuarter", "TwoThird", "Half", "Third", "Quarter"].includes(r)) return !0;
        if (qa(e) !== xa) return !1;
        var n = null !== (t = La(Oa(e, 1))) && void 0 !== t ? t : NaN,
          a = null !== (i = La(Oa(e, 2))) && void 0 !== i ? i : NaN;
        return Number.isInteger(n) && Number.isInteger(a);
      }(t)) return (_this$applyOperator = this.applyOperator(this.options.invisiblePlusOperator, e, t), _this$applyOperator2 = _slicedToArray(_this$applyOperator, 2), e = _this$applyOperator2[0], t = _this$applyOperator2[1]), null === e ? t : null;
      if (this.options.invisibleOperator) return (_this$applyOperator3 = this.applyOperator(this.options.invisibleOperator, e, t), _this$applyOperator4 = _slicedToArray(_this$applyOperator3, 2), e = _this$applyOperator4[0], t = _this$applyOperator4[1]), null === e ? t : null;
      var i = ["LatexTokens"];
      return "LatexTokens" === qa(e) ? i = i.concat(Ea(e)) : i.push(e), null !== t && ("LatexTokens" === qa(t) ? i = i.concat(Ea(t)) : i.push(t)), this.options.invisibleOperator && this.onError({
        code: "unexpected-sequence"
      }), i;
    }
  }, {
    key: "matchUnknownLatexCommand",
    value: function matchUnknownLatexCommand() {
      var e;
      var t = this.peek;
      if (!t || "\\" !== t[0]) return null;
      if (this.next(), "\\operatorname" === t) {
        if (this.skipSpace(), "<{>" === this.peek) {
          var _e186 = "";
          for (this.next(); !this.atEnd && "<}>" !== this.tokens[this.index];) _e186 += this.next();
          return _e186;
        }
        return null !== (e = this.next()) && void 0 !== e ? e : ya;
      }
      var i = [],
        r = [];
      var n = !1;
      do {
        n = !0;
        var _e187 = this.matchOptionalLatexArgument();
        null !== _e187 && (i.push(_e187), n = !1), this.skipSpace(), "<{>" === this.peek && (_e187 = this.matchRequiredLatexArgument(), null !== _e187 && (r.push(_e187), n = !1));
      } while (!n);
      return i.length > 0 || r.length > 0 ? [t].concat(r, i) : t;
    }
  }, {
    key: "matchPrimary",
    value: function matchPrimary(e) {
      var t = null;
      var i = this.index,
        r = this.matchNumber();
      r && (t = {
        num: r
      }), null === t && (t = this.matchMatchfixOperator()), null === t && (t = this.matchEnvironment()), null === t && (t = this.matchSymbol());
      var n = null;
      do {
        n = this.matchSupsub(t), t = null != n ? n : t;
      } while (null !== n);
      var a = null;
      do {
        a = this.matchPostfix(t), t = null != a ? a : t;
      } while (null !== a);
      return this.decorate(t, i);
    }
  }, {
    key: "matchBalancedExpression",
    value: function matchBalancedExpression(e, t, i) {
      var r = this.balancedClone(e, t);
      if (!r) return null == i || i({
        code: "unbalanced-symbols",
        arg: da(e) + da(t)
      }), null;
      var n = r.matchExpression();
      return r.atEnd || null == i || i({
        code: "unbalanced-symbols",
        arg: da(e) + da(t)
      }), n;
    }
  }, {
    key: "matchExpression",
    value: function matchExpression() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = null;
      var i = this.index;
      this.skipSpace(), t = this.matchPrimary(e), null === t && (t = this.matchOperator("prefix"));
      var r = !1;
      for (; !this.atEnd && !r;) {
        this.skipSpace();
        var _i132 = this.matchOperator("infix", t, e);
        if (null === _i132 && null !== t) {
          var _this$peekDefinition9 = this.peekDefinition("operator"),
            _this$peekDefinition10 = _slicedToArray(_this$peekDefinition9, 1),
            _e188 = _this$peekDefinition10[0];
          if (null === _e188) {
            var _e189 = this.matchExpression(this.invisibleOperatorPrecedence);
            null !== _e189 && (_i132 = this.applyInvisibleOperator(t, _e189));
          }
        }
        null !== _i132 ? t = _i132 : r = !0;
      }
      return this.decorate(t, i);
    }
  }, {
    key: "decorate",
    value: function decorate(e, t) {
      if (null === e) return null;
      if (this.options.preserveLatex) {
        var _i133 = this.latex(t, this.index);
        Array.isArray(e) ? e = {
          latex: _i133,
          fn: e
        } : "number" == typeof e ? e = {
          latex: _i133,
          num: Number(e).toString()
        } : "string" == typeof e ? e = {
          latex: _i133,
          sym: e
        } : "object" == typeof e && null !== e && (e.latex = _i133);
      }
      return e;
    }
  }]);
  return ao;
}();
function oo(e, t) {
  var i = e.length,
    r = e;
  e = e.slice(0, -1);
  for (var _i134 = 0; _i134 < e.length - 16; _i134++) {
    var _r46 = e.substr(0, _i134);
    for (var _n40 = 0; _n40 < 17; _n40++) {
      var _a22 = e.substr(_i134, _n40 + 1),
        _o18 = Math.floor((e.length - _r46.length) / _a22.length);
      if (_o18 > 1 && (_r46 + _a22.repeat(_o18 + 1)).startsWith(e)) return "0" === _a22 ? _r46.replace(/(\d{3})/g, "$1" + t.groupSeparator) : _r46.replace(/(\d{3})/g, "$1" + t.groupSeparator) + t.beginRepeatingDigits + _a22 + t.endRepeatingDigits;
    }
  }
  var n = i > t.precision - 1;
  return e = r, n && (e = e.substr(0, t.precision - 1)), t.groupSeparator && (e = e.replace(/(\d{3})/g, "$1" + t.groupSeparator)).endsWith(t.groupSeparator) && (e = e.slice(0, -t.groupSeparator.length)), n ? e + t.truncationMarker : e;
}
function so(e, t) {
  var i;
  return e ? t.beginExponentMarker ? t.beginExponentMarker + e + (null !== (i = t.endExponentMarker) && void 0 !== i ? i : "") : "10^{" + e + "}" : "";
}
var lo = /*#__PURE__*/function () {
  function lo(e, t, i) {
    _classCallCheck(this, lo);
    this.level = -1, this.options = e, e.invisibleMultiply && (/#1/.test(e.invisibleMultiply) && /#2/.test(e.invisibleMultiply) || i({
      code: "expected-argument",
      arg: "invisibleMultiply"
    })), this.onError = i, this.dictionary = t;
  }
  _createClass(lo, [{
    key: "wrap",
    value: function wrap(e, t) {
      if (null === e) return "";
      if (void 0 === t) return "(" + this.serialize(e) + ")";
      if ("number" == typeof e || _a(e) || "string" == typeof e || Ma(e)) return this.serialize(e);
      var i = qa(e);
      if (i && "Parentheses" !== i) {
        var _r47 = this.dictionary.name.get(i);
        if (_r47 && void 0 !== _r47.precedence && _r47.precedence < t) return this.wrapString(this.serialize(e), (this.level, "paren"));
      }
      return this.serialize(e);
    }
  }, {
    key: "wrapShort",
    value: function wrapShort(e) {
      if (null === e) return "";
      var t = this.serialize(e);
      return "Parentheses" === qa(e) || "number" == typeof e || _a(e) || /(^(.|\\[a-zA-Z*]+))$/.test(t) ? t : this.wrapString(t, (this.level, "paren"));
    }
  }, {
    key: "wrapString",
    value: function wrapString(e, t) {
      return "none" === t ? e : "(" + e + ")";
    }
  }, {
    key: "serializeSymbol",
    value: function serializeSymbol(e, t) {
      var _this38 = this;
      var i = Na(e);
      if (!i) {
        if ("string" == typeof (null == t ? void 0 : t.serialize)) return t.serialize;
        var _i135 = Da(e);
        return null === _i135 ? "" : "upright" === function (e, t) {
          var i = Da(e);
          return null === i ? "asis" : i.length > 1 ? "upright" : "asis";
        }(e, this.level) ? "\\operatorname{" + _i135 + "}" : _i135;
      }
      var r = Ea(e);
      if (!t) {
        if ("string" == typeof i && i.length > 0 && "\\" === i[0]) {
          var _e190 = i;
          var _iterator103 = _createForOfIteratorHelper(r),
            _step103;
          try {
            for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
              var _t148 = _step103.value;
              _e190 += "{" + this.serialize(_t148) + "}";
            }
          } catch (err) {
            _iterator103.e(err);
          } finally {
            _iterator103.f();
          }
          return _e190;
        }
        return "".concat(this.serialize(i), "(").concat(r.map(function (e) {
          return _this38.serialize(e);
        }).join(", "), ")");
      }
      if (t.requiredLatexArg > 0) {
        var _e191 = "",
          _i136 = "",
          _n41 = 0;
        for (; _n41 < t.requiredLatexArg;) _i136 += "{" + this.serialize(r[_n41++]) + "}";
        for (; _n41 < Math.min(r.length, t.optionalLatexArg + t.requiredLatexArg);) {
          var _t149 = this.serialize(r[1 + _n41++]);
          _t149 && (_e191 += "[" + _t149 + "]");
        }
        return t.serialize + (_e191 + _i136);
      }
      return this.level, t.serialize + this.serialize(["Parentheses"].concat(_toConsumableArray(r)));
    }
  }, {
    key: "serializeDictionary",
    value: function serializeDictionary(e) {
      var _this39 = this;
      return "\\left[\\begin{array}{lll}".concat(Object.keys(e).map(function (t) {
        return "\\textbf{".concat(t, "} & \\rightarrow & ").concat(_this39.serialize(e[t]));
      }).join("\\\\"), "\\end{array}\\right]");
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      var _this40 = this;
      if (null === e) return "";
      this.level += 1;
      var t = function () {
        var t, i, r, n;
        var a = function (e, t) {
          var i, r;
          var n;
          if ("number" == typeof e) n = e;else {
            if (!_a(e)) return "";
            n = e.num;
          }
          if (n === 1 / 0 || "Infinity" === n || "+Infinity" === n) return t.positiveInfinity;
          if (n === -1 / 0 || "-Infinity" === n) return t.negativeInfinity;
          if ("NaN" === n || "number" == typeof n && Number.isNaN(n)) return t.notANumber;
          if ("number" == typeof n) return "engineering" === t.notation ? function (e, t) {
            if (0 === e) return "0";
            var i = Math.abs(e);
            var r = Math.round(Math.log10(i));
            r -= r % 3, i < 1e3 && (r = 0);
            var n = i / Math.pow(10, r);
            var a = "";
            var o = n.toString().match(/^(.*)\.(.*)$/);
            (null == o ? void 0 : o[1]) && o[2] && (a = o[1] + t.decimalMarker + o[2]), t.groupSeparator && (a = oo(n.toExponential(), t));
            var s = "";
            return 0 !== r && (s = so(r.toString(), t)), (e < 0 ? "-" : "") + a + s;
          }(n, t) : function (e, t) {
            var i,
              r = e.match(/^(.*)[e|E]([-+]?[0-9]+)$/i);
            (null == r ? void 0 : r[1]) && r[2] && (i = so(r[2], t), i && (i = t.exponentProduct + i));
            var n = e,
              a = "";
            return r = (i ? r[1] : e).match(/^(.*)\.(.*)$/), (null == r ? void 0 : r[1]) && r[2] && (n = r[1], a = r[2]), t.groupSeparator && (n = n.replace(/\B(?=(\d{3})+(?!\d))/g, t.groupSeparator), a = oo(a, t)), a && (a = t.decimalMarker + a), n + a + (null != i ? i : "");
          }(n.toString(), t);
          /[a-zA-Z]$/.test(n) && (n = n.slice(0, -1));
          var a = "";
          for ("-" === n[0] ? (a = "-", n = n.substr(1)) : "+" === n[0] && (n = n.substr(1)); "0" === n[0];) n = n.substr(1);
          if (0 === n.length) return a + "0";
          "." === n[0] && (n = "0" + n);
          var o = "";
          if (n.indexOf(".") >= 0) {
            var _e192 = n.match(/(\d*)\.(\d*)([e|E]([-+]?[0-9]*))?/);
            if (!_e192) return "";
            var _r48 = _e192[1],
              _s13 = _e192[2];
            if (o = null !== (i = _e192[4]) && void 0 !== i ? i : "", "0" === _r48) {
              var _e193 = 0;
              for (; "0" === _s13[_e193] && _e193 < _s13.length;) _e193 += 1;
              var _i137 = "";
              if (_e193 <= 4) _i137 = "0" + t.decimalMarker, _i137 += _s13.substr(0, _e193), _i137 += oo(n.substr(_i137.length), t);else if (_e193 + 1 >= t.precision) _i137 = "0", a = "";else {
                _i137 = n[_e193];
                var _r49 = oo(n.substr(_e193 + 1), t);
                _r49 && (_i137 += t.decimalMarker + _r49);
              }
              "0" !== _i137 && (!(n.length - 1 > t.precision) || t.endRepeatingDigits && _i137.endsWith(t.endRepeatingDigits) || !t.truncationMarker || _i137.endsWith(t.truncationMarker) || (_i137 += t.truncationMarker), _e193 > 4 && (_i137 += t.exponentProduct + so((1 - _e193).toString(), t))), n = _i137;
            } else {
              n = _r48.replace(/\B(?=(\d{3})+(?!\d))/g, t.groupSeparator);
              var _e194 = oo(_s13, t);
              _e194 && (n += t.decimalMarker + _e194);
            }
          } else if (n.length > t.precision) {
            var _e195 = n.length;
            var _i138 = n[0];
            var _r50 = oo(n.substr(1), t);
            _r50 && (_i138 += t.decimalMarker + _r50, t.truncationMarker && !_i138.endsWith(t.truncationMarker) && t.endRepeatingDigits && !_i138.endsWith(t.endRepeatingDigits) && (_i138 += t.truncationMarker)), "1" !== _i138 ? _i138 += t.exponentProduct : _i138 = "", n = _i138 + so((_e195 - 1).toString(), t);
          } else {
            var _e196 = n.match(/([0-9]*)\.?([0-9]*)([e|E]([-+]?[0-9]+))?/);
            _e196 && (n = _e196[1], _e196[2] && (n += t.decimalMarker + _e196[2]), o = null !== (r = _e196[4]) && void 0 !== r ? r : ""), n = n.replace(/\B(?=(\d{3})+(?!\d))/g, t.groupSeparator);
          }
          var s = so(o, t);
          return a + n + (s ? t.exponentProduct + s : "");
        }(e, _this40.options);
        if (a) return a;
        var o = Ca(e);
        if (null !== o) return "\\text{".concat(o, "}");
        var s = Da(e);
        if (null !== s) return _this40.serializeSymbol(e, _this40.dictionary.name.get(s));
        var l = Ka(e);
        if (null !== l) return _this40.serializeDictionary(l);
        var c = qa(e);
        if (c) {
          if ("\\" === c[0]) {
            var _t150 = Ea(e);
            return 0 === _t150.length ? c : c + "{" + _t150.map(function (e) {
              return _this40.serialize(e);
            }).filter(function (e) {
              return Boolean(e);
            }).join("}{") + "}";
          }
          var _a23 = _this40.dictionary.name.get(c);
          if (_a23) {
            var _o19 = "";
            return "function" == typeof _a23.serialize && (_o19 = _a23.serialize(_this40, e)), _o19 || void 0 === _a23.precedence && !(null === (t = _a23.trigger) || void 0 === t ? void 0 : t.superfix) && !(null === (i = _a23.trigger) || void 0 === i ? void 0 : i.subfix) || (_o19 = function (e, t, i) {
              var r, n, a, o, s;
              var l = "";
              var c = Ba(t),
                u = qa(t);
              if ((null === (r = i.trigger) || void 0 === r ? void 0 : r.superfix) || (null === (n = i.trigger) || void 0 === n ? void 0 : n.subfix)) return 1 !== c && e.onError({
                code: "operator-requires-one-operand",
                arg: e.serializeSymbol(u)
              }), no(i.serialize, [e.serialize(Oa(t, 1))]);
              if (null === (a = i.trigger) || void 0 === a ? void 0 : a.postfix) return 1 !== c && e.onError({
                code: "postfix-operator-requires-one-operand",
                arg: e.serializeSymbol(u)
              }), no(i.serialize, [e.wrap(Oa(t, 1), i.precedence)]);
              if (null === (o = i.trigger) || void 0 === o ? void 0 : o.prefix) return 1 !== c && e.onError({
                code: "prefix-operator-requires-one-operand",
                arg: e.serializeSymbol(u)
              }), no(i.serialize, [e.wrap(Oa(t, 1), i.precedence + 1)]);
              if (null === (s = i.trigger) || void 0 === s ? void 0 : s.infix) {
                l = e.wrap(Oa(t, 1), i.precedence);
                for (var _r51 = 2; _r51 < c + 1; _r51++) {
                  var _n42 = Oa(t, _r51);
                  null !== _n42 && (l = no(i.serialize, [l, e.wrap(_n42, i.precedence)]));
                }
              }
              return l;
            }(_this40, e, _a23)), !_o19 && (null === (r = _a23.trigger) || void 0 === r ? void 0 : r.matchfix) && (_o19 = function (e, t, i) {
              var r, n;
              var a = [];
              if ("string" == typeof (null === (r = i.trigger) || void 0 === r ? void 0 : r.matchfix) ? a.push(null === (n = i.trigger) || void 0 === n ? void 0 : n.matchfix) : i.trigger && Array.isArray(i.trigger.matchfix) && (a = _toConsumableArray(i.trigger.matchfix)), Ba(t) >= 1) {
                var _r52 = "";
                var _iterator104 = _createForOfIteratorHelper(Ea(t)),
                  _step104;
                try {
                  for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
                    var _n43 = _step104.value;
                    _n43 && (a.push(_r52), a.push(e.serialize(_n43)), _r52 = i.separator);
                  }
                } catch (err) {
                  _iterator104.e(err);
                } finally {
                  _iterator104.f();
                }
              }
              return a.push(da(i.closeFence)), ua(a);
            }(_this40, e, _a23)), !_o19 && (null === (n = _a23.trigger) || void 0 === n ? void 0 : n.symbol) && (_o19 = _this40.serializeSymbol(e, _a23)), _o19;
          }
        }
        if (Array.isArray(e) || Sa(e)) return _this40.serializeSymbol(e);
        _this40.onError({
          code: "syntax-error",
          arg: JSON.stringify(e)
        });
      }();
      return this.level -= 1, null != t ? t : "";
    }
  }]);
  return lo;
}();
var co = /*#__PURE__*/function () {
  function co(e) {
    _classCallCheck(this, co);
    var t, i;
    this.onError = null !== (t = null == e ? void 0 : e.onError) && void 0 !== t ? t : function (e) {
      "undefined" != typeof window && (!e.before || e.after);
    };
    var r = _objectSpread({}, null != e ? e : {});
    delete r.dictionary, delete r.onError, this.options = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, to), ro), io), r), this.dictionary = function (e, t) {
      var i, r, n, a, o, s, l, c, u, d, h, p, m, f, g;
      var y = {
        lookahead: 1,
        name: new Map(),
        prefix: [],
        infix: [],
        postfix: [],
        matchfix: [],
        superfix: [],
        subfix: [],
        symbol: [],
        environment: new Map()
      };
      var _iterator105 = _createForOfIteratorHelper(e),
        _step105;
      try {
        var _loop2 = function _loop2() {
          var b = _step105.value;
          void 0 === b.parse && (b.parse = b.name), "string" == typeof b.trigger && (b.trigger = {
            symbol: b.trigger
          }), "string" == typeof b.serialize && void 0 !== (null === (i = b.trigger) || void 0 === i ? void 0 : i.symbol) && /#[0-9]/.test(b.serialize) && t({
            code: "unexpected-argument",
            arg: b.name
          }), void 0 === b.serialize && (void 0 !== (null === (r = b.trigger) || void 0 === r ? void 0 : r.postfix) ? b.serialize = "#1" + Ja(b.trigger.postfix) : void 0 !== (null === (n = b.trigger) || void 0 === n ? void 0 : n.prefix) ? b.serialize = Ja(b.trigger.prefix) + "#1" : void 0 !== (null === (a = b.trigger) || void 0 === a ? void 0 : a.infix) ? b.serialize = "#1" + Ja(b.trigger.infix) + "#2" : void 0 !== (null === (o = b.trigger) || void 0 === o ? void 0 : o.symbol) ? b.serialize = Ja(b.trigger.symbol) : void 0 !== (null === (s = b.trigger) || void 0 === s ? void 0 : s.superfix) ? b.serialize = "#1^{" + Ja(null === (l = b.trigger) || void 0 === l ? void 0 : l.superfix) + "}" : void 0 !== (null === (c = b.trigger) || void 0 === c ? void 0 : c.subfix) ? b.serialize = "#1_{" + Ja(null === (u = b.trigger) || void 0 === u ? void 0 : u.subfix) + "}" : b.serialize = ""), void 0 !== (null === (d = b.trigger) || void 0 === d ? void 0 : d.infix) && (void 0 === b.precedence && t({
            code: "syntax-error",
            arg: "Infix operators require a precedence"
          }), b.associativity || (b.associativity = "non")), void 0 !== (null === (h = b.trigger) || void 0 === h ? void 0 : h.symbol) && (b.arguments = null !== (p = b.arguments) && void 0 !== p ? p : "", b.optionalLatexArg = null !== (m = b.optionalLatexArg) && void 0 !== m ? m : 0, b.requiredLatexArg = null !== (f = b.requiredLatexArg) && void 0 !== f ? f : 0), void 0 !== (null === (g = b.trigger) || void 0 === g ? void 0 : g.matchfix) && ("function" === b.parse || b.closeFence || t({
            code: "syntax-error",
            arg: "Matchfix operators require a close fence or a custom parse function"
          })), void 0 !== b.trigger && (["infix", "prefix", "postfix", "symbol", "matchfix", "superfix", "subfix"].forEach(function (e) {
            if (b.trigger[e]) {
              var _i139 = (t = b.trigger[e], Array.isArray(t) ? t.length : 1);
              y.lookahead = Math.max(y.lookahead, _i139), void 0 === y[e][_i139] && (y[e][_i139] = new Map()), y[e][_i139].set(Ja(b.trigger[e]), b);
            }
            var t;
          }), void 0 !== b.trigger.environment && y.environment.set(b.trigger.environment, b)), void 0 !== b.name ? y.name.set(Ja(b.name), b) : "string" == typeof b.parse && y.name.set(b.parse, b), void 0 !== b.trigger || b.name || t({
            code: "syntax-error",
            arg: "Need at least a trigger or a name"
          });
        };
        for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator105.e(err);
      } finally {
        _iterator105.f();
      }
      return y;
    }(null !== (i = null == e ? void 0 : e.dictionary) && void 0 !== i ? i : co.getDictionary(), this.onError);
  }
  _createClass(co, [{
    key: "parse",
    value: function parse(e) {
      var t;
      var i = new ao(ca(e, []), this.options, this.dictionary, this.onError),
        r = i.matchExpression();
      return i.atEnd || null === (t = this.onError) || void 0 === t || t.call(this, {
        code: "syntax-error"
      }), null != r ? r : "";
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      return new lo(this.options, this.dictionary, this.onError).serialize(e);
    }
  }], [{
    key: "getDictionary",
    value: function getDictionary() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "all";
      if ("all" === e) {
        var _e197 = [];
        for (var _i140 = 0, _Object$keys13 = Object.keys(eo); _i140 < _Object$keys13.length; _i140++) {
          var _t151 = _Object$keys13[_i140];
          _e197 = [].concat(_toConsumableArray(_e197), _toConsumableArray(eo[_t151]));
        }
        return _e197;
      }
      return eo[e] ? _toConsumableArray(eo[e]) : [];
    }
  }]);
  return co;
}();
var uo = /*#__PURE__*/function () {
  function uo(e, t, i, r) {
    _classCallCheck(this, uo);
    this.options = e, this.root = new rt("root", {
      mode: this.options.mode
    }), this.root.body = [], this._selection = {
      ranges: [[0, 0]],
      direction: "none"
    }, this._anchor = 0, this._position = 0, this.setListeners(t), this.setHooks(i), this.mathfield = r, this.suppressChangeNotifications = !1;
  }
  _createClass(uo, [{
    key: "atoms",
    get: function get() {
      return this.root.children;
    }
  }, {
    key: "selection",
    get: function get() {
      return this._selection;
    },
    set: function set(e) {
      this.setSelection(e);
    }
  }, {
    key: "setSelection",
    value: function setSelection(e, t) {
      var _this41 = this;
      return this.deferNotifications({
        selection: !0
      }, function () {
        var i = _this41.normalizeSelection(e, t);
        if (void 0 === i) throw new TypeError("Invalid selection");
        if (1 === i.ranges.length && i.ranges[0][0] === i.ranges[0][1]) {
          var _e198 = i.ranges[0][0];
          _this41._position = _e198, _this41._anchor = _e198, _this41._selection = i;
        } else {
          var _e200, _e201, _e202, _e203;
          var _e199 = sn(i);
          "backward" === i.direction ? (_e200 = _e199, _e201 = _slicedToArray(_e200, 2), _this41._position = _e201[0], _this41._anchor = _e201[1], _e200) : (_e202 = _e199, _e203 = _slicedToArray(_e202, 2), _this41._anchor = _e203[0], _this41._position = _e203[1], _e202);
          var _t152 = _this41.at(_e199[0]),
            _r53 = _this41.at(_e199[1]),
            _n44 = rt.commonAncestor(_t152, _r53);
          "array" === (null == _n44 ? void 0 : _n44.type) && _t152.parent === _n44 && _r53.parent === _n44 || (_this41._selection = {
            ranges: [[_this41.offsetOf(_t152), _this41.offsetOf(_r53)]],
            direction: i.direction
          }, "backward" === i.direction ? _this41._position = _this41._selection.ranges[0][0] : _this41._position = _this41._selection.ranges[0][1]);
        }
      });
    }
  }, {
    key: "position",
    get: function get() {
      return this._position;
    },
    set: function set(e) {
      this.setSelection(e, e);
    }
  }, {
    key: "anchor",
    get: function get() {
      return this._anchor;
    }
  }, {
    key: "selectionIsCollapsed",
    get: function get() {
      return this._anchor === this._position;
    }
  }, {
    key: "selectionIsPlaceholder",
    get: function get() {
      return 1 === Math.abs(this._anchor - this._position) && "placeholder" === this.at(Math.max(this._anchor, this._position)).type;
    }
  }, {
    key: "collapseSelection",
    value: function collapseSelection() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "forward";
      return this._anchor !== this._position && (this.position = "backward" === e ? Math.min(this._anchor, this._position) : Math.max(this._anchor, this._position), !0);
    }
  }, {
    key: "lastOffset",
    get: function get() {
      return this.atoms.length - 1;
    }
  }, {
    key: "at",
    value: function at(e) {
      return this.atoms[e];
    }
  }, {
    key: "offsetOf",
    value: function offsetOf(e) {
      return this.atoms.indexOf(e);
    }
  }, {
    key: "getSiblingsRange",
    value: function getSiblingsRange(e) {
      var t = this.at(e),
        i = t.parent;
      if (!i) return [0, this.lastOffset];
      var r = t.parent.branch(t.treeBranch);
      return [this.offsetOf(r[0]), this.offsetOf(r[r.length - 1])];
    }
  }, {
    key: "getBranchRange",
    value: function getBranchRange(e, t) {
      var i = this.at(e).branch(t);
      return [this.offsetOf(i[0]), this.offsetOf(i[i.length - 1])];
    }
  }, {
    key: "getAtoms",
    value: function getAtoms(e, t, i) {
      var _this42 = this,
        _e204,
        _e205;
      var r, n;
      var a,
        o,
        s = null != i ? i : {};
      if (ra(e)) {
        if (s = null !== (r = t) && void 0 !== r ? r : {}, e.ranges.length > 1) return e.ranges.reduce(function (e, t) {
          return [].concat(_toConsumableArray(e), _toConsumableArray(_this42.getAtoms(t, s)));
        }, []);
        e = e.ranges[0];
      }
      if (ta(e)) {
        if (a = e, !ta(t)) return [];
        o = t;
      } else (_e204 = e, _e205 = _slicedToArray(_e204, 2), a = _e205[0], o = _e205[1]), s = null !== (n = t) && void 0 !== n ? n : {};
      if (!Number.isFinite(a)) return [];
      void 0 === s.includeChildren && (s.includeChildren = !1), a < 0 && (a = this.lastOffset - a + 1), o < 0 && (o = this.lastOffset - o + 1);
      var l = Math.min(a, o) + 1,
        c = Math.max(a, o);
      if (1 === l && c === this.lastOffset) return [this.root];
      var u = [];
      for (var _e206 = l; _e206 <= c; _e206++) {
        var _t153 = this.atoms[_e206];
        ho(this, _t153, l, c) && u.push(_t153);
      }
      return s.includeChildren || (u = u.filter(function (e) {
        var t = !1,
          i = e.parent;
        for (; i && !t;) t = ho(_this42, i, l, c), i = i.parent;
        return !t;
      })), u;
    }
  }, {
    key: "getAllAtoms",
    value: function getAllAtoms(e) {
      var t = [],
        i = this.lastOffset;
      for (var _r54 = e; _r54 <= i; _r54++) t.push(this.atoms[_r54]);
      for (var _i141 = 0; _i141 < e; _i141++) t.push(this.atoms[_i141]);
      return t;
    }
  }, {
    key: "extractAtoms",
    value: function extractAtoms(e) {
      var t = this.getAtoms(e);
      1 === t.length && "root" === t[0].type && (t = t[0].children);
      var _iterator106 = _createForOfIteratorHelper(t),
        _step106;
      try {
        for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
          var _e207 = _step106.value;
          _e207.parent.removeChild(_e207);
        }
      } catch (err) {
        _iterator106.e(err);
      } finally {
        _iterator106.f();
      }
      return t;
    }
  }, {
    key: "deleteAtoms",
    value: function deleteAtoms(e) {
      return this.extractAtoms(e), e[0];
    }
  }, {
    key: "atomToString",
    value: function atomToString(e, t) {
      var i = null != t ? t : "latex";
      var r = "";
      if ("latex" === i || "latex-expanded" === i) r = rt.serialize(e, {
        expandMacro: "latex-expanded" === i,
        defaultMode: this.mathfield.options.defaultMode
      });else if ("math-ml" === i) r = lr(e, this.mathfield.options);else if ("spoken" === i) r = pr(e, this.mathfield.options);else if ("spoken-text" === i) {
        var _t154 = this.mathfield.options.textToSpeechMarkup;
        this.mathfield.options.textToSpeechMarkup = "", r = pr(e, this.mathfield.options), this.mathfield.options.textToSpeechMarkup = _t154;
      } else if ("spoken-ssml" === i || "spoken-ssml-with-highlighting" === i) {
        var _t155 = this.mathfield.options.textToSpeechMarkup;
        this.mathfield.options.textToSpeechMarkup = "ssml", r = pr(e, this.mathfield.options), this.mathfield.options.textToSpeechMarkup = _t155;
      } else if ("math-json" === i) try {
        var _t156 = function (e, t) {
          return new co(t).parse(e);
        }(rt.serialize(e, {
          expandMacro: !1,
          defaultMode: "math"
        }), {
          onError: this.mathfield.options.onError
        });
        r = JSON.stringify(_t156);
      } catch (e) {
        return "";
      } else "ascii-math" === i && (r = ji(e));
      return r;
    }
  }, {
    key: "getValue",
    value: function getValue(e, t, i) {
      var _this43 = this;
      if (void 0 === e) return this.atomToString(this.root, "latex");
      if ("string" == typeof e) return this.atomToString(this.root, e);
      var r, n;
      if (ta(e) && ta(t) ? (r = [this.normalizeRange([e, t])], n = null != i ? i : "latex") : ia(e) ? (r = [this.normalizeRange(e)], n = t) : ra(e) ? (r = e.ranges, n = t) : (r = [], n = "latex"), "latex" === n || "latex-expanded" === n) {
        var _e208 = {
          expandMacro: "latex-expanded" === n,
          defaultMode: this.mathfield.options.defaultMode
        };
        return ve(r.map(function (t) {
          return rt.serialize(_this43.getAtoms(t), _e208);
        }));
      }
      return r.map(function (e) {
        return _this43.getAtoms(e).map(function (e) {
          return _this43.atomToString(e, n);
        }).join("");
      }).join("");
    }
  }, {
    key: "extendSelection",
    value: function extendSelection(e) {
      var t = this._anchor;
      if ("forward" === e) {
        var _e209 = this._position;
        do {
          var _t157 = this.at(_e209 + 1);
          if (null == _t157 ? void 0 : _t157.inCaptureSelection) {
            for (; !_t157.captureSelection;) _t157 = _t157.parent;
            _e209 = this.offsetOf(null == _t157 ? void 0 : _t157.parent.lastChild) + 1;
          } else _e209 += 1;
        } while (_e209 <= this.lastOffset && this.at(_e209).isFirstSibling);
        return _e209 === t - 1 && "first" === this.at(t).type && (_e209 = t), this.extendSelectionTo(t, _e209);
      }
      var i = this._position - 1;
      if (i < 0) return !1;
      for (; i >= 0 && this.at(i).isLastSibling;) {
        var _e210 = this.at(i);
        if (null == _e210 ? void 0 : _e210.inCaptureSelection) {
          for (; !_e210.captureSelection;) _e210 = _e210.parent;
          i = this.offsetOf(null == _e210 ? void 0 : _e210.parent.firstChild) - 1;
        } else i -= 1;
      }
      return i < 0 && (i = 0), i === t + 1 && "first" === this.at(i).type && (t = i), this.extendSelectionTo(t, i);
    }
  }, {
    key: "extendSelectionTo",
    value: function extendSelectionTo(e, t) {
      var _this44 = this;
      return this.deferNotifications({
        selection: !0
      }, function () {
        var i = _this44.normalizeRange([e, t]);
        var _i142 = _slicedToArray(i, 2),
          r = _i142[0],
          n = _i142[1],
          _this44$at = _this44.at(n),
          a = _this44$at.parent;
        for (; a !== _this44.root && po(_this44, a, [r, n]);) n = _this44.offsetOf(a), a = a.parent;
        for (a = _this44.at(r).parent; a !== _this44.root && po(_this44, a, [r, n]);) r = _this44.offsetOf(a.leftSibling), a = a.parent;
        for (a = _this44.at(n).parent; a !== _this44.root && po(_this44, a, [r, n]);) n = _this44.offsetOf(a), a = a.parent;
        _this44._position = _this44.normalizeOffset(t), _this44._selection = {
          ranges: [[r, n]],
          direction: "none"
        };
      });
    }
  }, {
    key: "setListeners",
    value: function setListeners(e) {
      this.listeners = e;
    }
  }, {
    key: "setHooks",
    value: function setHooks(e) {
      this.hooks = {
        announce: (null == e ? void 0 : e.announce) ? e.announce : function (e, t, i, r) {},
        moveOut: (null == e ? void 0 : e.moveOut) ? e.moveOut : function () {
          return !0;
        },
        tabOut: (null == e ? void 0 : e.tabOut) ? e.tabOut : function () {
          return !0;
        }
      };
    }
  }, {
    key: "announce",
    value: function announce(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      this.hooks.announce(this.mathfield, e, t, i);
    }
  }, {
    key: "deferNotifications",
    value: function deferNotifications(e, t) {
      var i = this._selection,
        r = this._anchor,
        n = this._position;
      var a = !1;
      var o = this.suppressChangeNotifications;
      this.suppressChangeNotifications = !0;
      var s = this.root.changeCounter;
      t();
      var l = this.root.changeCounter !== s;
      return r === this._anchor && n === this._position && "different" !== function (e, t) {
        if (e.direction === t.direction) {
          var _i143 = e.ranges.length;
          if (t.ranges.length === _i143) {
            var _r55 = 0;
            for (; _r55 < _i143 && "equal" === on(e.ranges[_r55], t.ranges[_r55]);) _r55++;
            return _r55 === _i143 ? "equal" : "different";
          }
        }
        return "different";
      }(this._selection, i) || (a = !0), this.suppressChangeNotifications = o, this.suppressChangeNotifications || (e.content && l && dn(this), e.selection && a && un(this)), l || a;
    }
  }, {
    key: "normalizeOffset",
    value: function normalizeOffset(e) {
      return e > 0 ? e = Math.min(e, this.lastOffset) : e < 0 && (e = this.lastOffset + e + 1), e;
    }
  }, {
    key: "normalizeRange",
    value: function normalizeRange(e) {
      var _e211 = _slicedToArray(e, 2),
        t = _e211[0],
        i = _e211[1];
      return t = this.normalizeOffset(t), i = this.normalizeOffset(i), t < i ? [t, i] : [i, t];
    }
  }, {
    key: "normalizeSelection",
    value: function normalizeSelection(e, t) {
      var _this45 = this;
      var i;
      var r;
      if (ta(e)) {
        var _i144 = this.normalizeOffset(e);
        if (ta(t)) {
          var _e212 = this.normalizeOffset(t);
          r = _i144 <= _e212 ? {
            ranges: [[_i144, _e212]],
            direction: "none"
          } : {
            ranges: [[_e212, _i144]],
            direction: "backward"
          };
        } else r = {
          ranges: [[_i144, _i144]],
          direction: "none"
        };
      } else if (ia(e)) {
        var _t158 = this.normalizeOffset(e[0]),
          _i145 = this.normalizeOffset(e[1]);
        r = _t158 <= _i145 ? {
          ranges: [[_t158, _i145]],
          direction: "none"
        } : {
          ranges: [[_i145, _t158]],
          direction: "backward"
        };
      } else ra(e) && (r = {
        ranges: e.ranges.map(function (e) {
          return _this45.normalizeRange(e);
        }),
        direction: null !== (i = e.direction) && void 0 !== i ? i : "none"
      });
      return r;
    }
  }]);
  return uo;
}();
function ho(e, t, i, r) {
  var n = e.offsetOf(t);
  if (n < i || n > r) return !1;
  if (!t.hasChildren) return !0;
  var a = e.offsetOf(t.firstChild);
  if (a >= i && a <= r) {
    var _n45 = e.offsetOf(t.lastChild);
    if (_n45 >= i && _n45 <= r) return !0;
  }
  return !1;
}
function po(e, t, i) {
  if (!(null == t ? void 0 : t.hasChildren)) return !1;
  var _i146 = _slicedToArray(i, 2),
    r = _i146[0],
    n = _i146[1],
    a = e.offsetOf(t.firstChild),
    o = e.offsetOf(t.lastChild);
  return a >= r && a <= n && o >= a && o <= n;
}
function mo(e) {
  return dn(e), !0;
}
function fo(e) {
  return dn(e), !0;
}
function go(e, t, i, r) {
  var n, a, o, s, l, c;
  var u = i.parent;
  if (i instanceof wt) {
    var _n46 = !r && "forward" === t || "body" === r && "backward" === t,
      _a24 = _n46 ? e.offsetOf(i) - 1 : e.offsetOf(i.lastChild);
    return _n46 || "?" === i.leftDelim || "." === i.leftDelim ? _n46 && "?" !== i.rightDelim && "." !== i.rightDelim && u.addChildAfter(new rt("mclose", {
      value: i.rightDelim
    }), i) : u.addChildBefore(new rt("mopen", {
      value: i.leftDelim
    }), i), u.addChildrenAfter(i.removeBranch("body"), i), u.removeChild(i), e.position = _a24, !0;
  }
  if ("surd" === i.type) {
    if ("forward" === t && !r || "backward" === t && "body" === r) {
      var _t159 = i.leftSibling;
      i.hasChildren && u.addChildrenAfter(i.removeBranch("body"), i), u.removeChild(i), e.position = e.offsetOf(_t159);
    } else "forward" === t && "body" === r ? e.position = e.offsetOf(i) : r || "backward" !== t ? "above" === r && (i.hasEmptyBranch("above") && i.removeBranch("above"), e.position = "backward" === t ? e.offsetOf(i.leftSibling) : e.offsetOf(i.body[0])) : i.hasChildren ? e.position = e.offsetOf(i.lastChild) : (e.position = Math.max(e.offsetOf(i) - 1), u.removeChild(i));
    return !0;
  }
  if ("box" === i.type || "enclose" === i.type) {
    var _n47 = r && "backward" === t || !r && "forward" === t ? i.leftSibling : i.lastChild;
    return u.addChildrenAfter(i.removeBranch("body"), i), u.removeChild(i), e.position = e.offsetOf(_n47), !0;
  }
  if ("genfrac" === i.type || "overunder" === i.type) {
    if (!r) return !!i.hasChildren && (e.position = e.offsetOf("forward" === t ? i.firstChild : i.lastChild), !0);
    if ("forward" === t && "above" === r || "backward" === t && "below" === r) {
      var _t160 = i.removeBranch("above"),
        _r56 = i.removeBranch("below");
      return u.addChildrenAfter([].concat(_toConsumableArray(_t160), _toConsumableArray(_r56)), i), u.removeChild(i), e.position = e.offsetOf(_t160.length > 0 ? _t160[_t160.length - 1] : _r56[0]), !0;
    }
    return "backward" === t ? (e.position = e.offsetOf(i.leftSibling), !0) : (e.position = e.offsetOf(i), !0);
  }
  if (i.isExtensibleSymbol || "msubsup" === i.type) {
    if (!r && "forward" === t) return !1;
    if (!r) {
      if (i.subscript || i.superscript) {
        var _r57 = "forward" === t ? null !== (a = null === (n = i.superscript) || void 0 === n ? void 0 : n[0]) && void 0 !== a ? a : null === (o = i.subscript) || void 0 === o ? void 0 : o[0] : null !== (l = null === (s = i.subscript) || void 0 === s ? void 0 : s[0].lastSibling) && void 0 !== l ? l : null === (c = i.superscript) || void 0 === c ? void 0 : c[0].lastSibling;
        return _r57 && (e.position = e.offsetOf(_r57)), !0;
      }
      return !1;
    }
    if (r && i.hasEmptyBranch(r) && i.removeBranch(r), !i.hasChildren) {
      var _r58 = "forward" === t ? e.offsetOf(i) : Math.max(0, e.offsetOf(i) - 1);
      return i.parent.removeChild(i), e.position = _r58, !0;
    }
    if ("superscript" === r) {
      if ("backward" === t) {
        var _t161 = e.offsetOf(i.firstChild) - 1;
        e.position = _t161;
      } else i.subscript ? e.position = e.offsetOf(i.subscript[0]) : e.position = e.offsetOf(i);
    } else "subscript" === r && ("backward" === t && i.superscript ? e.position = e.offsetOf(i.superscript[0].lastSibling) : e.position = "backward" === t ? e.offsetOf(i.firstChild) - 1 : e.offsetOf(i));
    return !0;
  }
  return !1;
}
function yo(e, t) {
  return e.deferNotifications({
    content: !0,
    selection: !0
  }, function () {
    e.deleteAtoms(t), e.position = t[0];
  });
}
bn({
  addRowAfter: mo,
  addColumnAfter: fo,
  addRowBefore: function addRowBefore(e) {
    return dn(e), !0;
  },
  addColumnBefore: function addColumnBefore(e) {
    return dn(e), !0;
  }
}, {
  target: "model",
  category: "array-edit"
});
var bo = /*#__PURE__*/function (_rt27) {
  _inherits(bo, _rt27);
  var _super34 = _createSuper(bo);
  function bo(e, t) {
    _classCallCheck(this, bo);
    var i;
    return _super34.call(this, "composition", {
      mode: null !== (i = null == t ? void 0 : t.mode) && void 0 !== i ? i : "math",
      value: e
    });
  }
  _createClass(bo, [{
    key: "computedStyle",
    get: function get() {
      return {};
    }
  }, {
    key: "render",
    value: function render(e) {
      var t = new te(this.value, {
        classes: "ML__composition",
        type: "composition"
      });
      return this.bind(e, t), this.caret && (t.caret = this.caret), t;
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      return "";
    }
  }]);
  return bo;
}(rt);
function vo(e, t) {
  var i = e.at(t);
  var r;
  if (i) {
    r = i.mode;
    var _e213 = i.parent;
    for (; !r && _e213;) _e213 && (r = _e213.mode), _e213 = _e213.parent;
  }
  return r;
}
function xo(t, i) {
  t && i && (e(t) ? t.forEach(function (e) {
    return xo(e, i);
  }) : "object" == typeof t && (t.style.color || t.style.backgroundColor || t.style.fontFamily || t.style.fontShape || t.style.fontSeries || t.style.fontSize || t.style.variant || t.style.variantStyle || (t.applyStyle(i), xo(t.body, i), xo(t.above, i), xo(t.below, i), xo(t.subscript, i), xo(t.superscript, i))));
}
function ko(e, t, i, r) {
  function n(e, t) {
    var _iterator107 = _createForOfIteratorHelper(a),
      _step107;
    try {
      for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
        var _i147 = _step107.value;
        if (_i147.style[e] !== t) return !1;
      }
    } catch (err) {
      _iterator107.e(err);
    } finally {
      _iterator107.f();
    }
    return !0;
  }
  if ((t = e.normalizeRange(t))[0] === t[1]) return !1;
  var a = e.getAtoms(t, {
    includeChildren: !0
  });
  "toggle" === r.operation && (i.color && n("color", i.color) && (i.color = "none", i.verbatimColor = void 0), i.backgroundColor && n("backgroundColor", i.backgroundColor) && (i.backgroundColor = "none", i.verbatimBackgroundColor = void 0), i.fontFamily && n("fontFamily", i.fontFamily) && (i.fontFamily = "none"), i.fontSeries && n("fontSeries", i.fontSeries) && (i.fontSeries = "auto"), i.fontShape && n("fontShape", i.fontShape) && (i.fontShape = "auto"), i.fontSize && n("fontSize", i.fontSize) && (i.fontSize = 5));
  var _iterator108 = _createForOfIteratorHelper(a),
    _step108;
  try {
    for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
      var _e214 = _step108.value;
      _e214.applyStyle(i);
    }
  } catch (err) {
    _iterator108.e(err);
  } finally {
    _iterator108.f();
  }
  return !0;
}
function wo(e, t, i) {
  if ("text" !== e.at(t).mode) return t;
  var r = "backward" === i ? -1 : 1;
  var n;
  if (Oe.test(e.at(t).value)) {
    var _i148,
      _a25 = t;
    do {
      _i148 = "text" === e.at(_a25).mode && Oe.test(e.at(_a25).value), _a25 += r;
    } while (e.at(_a25) && _i148);
    n = e.at(_a25) ? _a25 - 2 * r : _a25 - r;
  } else if (/\s/.test(e.at(t).value)) {
    var _i149 = t;
    for (; e.at(_i149) && "text" === e.at(_i149).mode && /\s/.test(e.at(_i149).value);) _i149 += r;
    if (e.at(_i149)) {
      var _t162 = !0;
      do {
        _t162 = "text" === e.at(_i149).mode && !/\s/.test(e.at(_i149).value), _i149 += r;
      } while (e.at(_i149) && _t162);
      n = e.at(_i149) ? _i149 - 2 * r : _i149 - r;
    } else n = _i149 - r;
  } else {
    var _i150 = t;
    for (; e.at(_i150) && "text" === e.at(_i150).mode && !/\s/.test(e.at(_i150).value);) _i150 += r;
    n = e.at(_i150) ? _i150 : _i150 - r;
    var _a26 = !0;
    for (; e.at(_i150) && _a26;) _a26 = "text" === e.at(_i150).mode && /\s/.test(e.at(_i150).value), _a26 && (n = _i150), _i150 += r;
    n = e.at(_i150) ? _i150 - 2 * r : _i150 - r;
  }
  return n - (r > 0 ? 0 : 1);
}
function _o(e, t, i) {
  var r, n, a, o, s, l, c;
  var u = e.position;
  null !== (r = null == i ? void 0 : i.extend) && void 0 !== r && r || e.collapseSelection(t);
  var d = e.at(e.position);
  if ("forward" === t && ("msubsup" === d.type ? (d = d.rightSibling, d || (d = e.at(e.position + 1))) : d = e.at(e.position + 1)), !d) return e.announce("plonk"), !1;
  var h = e.offsetOf(d);
  if (d instanceof Ct) h = wo(e, h, t);else if (d instanceof $r) {
    if (d.isSuggestion) for (; d && d instanceof $r;) d.isSuggestion = !1, h = e.offsetOf(d), d = d.rightSibling;else if ("forward" === t) {
      if (d = d.rightSibling, !(d && d instanceof $r)) return e.announce("plonk"), !1;
      for (; d && d instanceof $r && /[a-zA-Z*]/.test(d.value);) h = e.offsetOf(d), d = d.rightSibling;
    } else {
      if (d = d.leftSibling, !(d && d instanceof $r)) return e.announce("plonk"), !1;
      for (; d && d instanceof $r && /[a-zA-Z*]/.test(d.value);) h = e.offsetOf(d), d = d.leftSibling;
    }
  } else if ("forward" === t && "mopen" === d.type) {
    var _t163 = 0;
    do {
      "mopen" === d.type ? _t163 += 1 : "mclose" === d.type && (_t163 -= 1), d = d.rightSibling;
    } while (!d.isLastSibling && 0 !== _t163);
    h = e.offsetOf(d.leftSibling);
  } else if ("backward" === t && "mclose" === d.type) {
    var _t164 = 0;
    do {
      "mopen" === d.type ? _t164 += 1 : "mclose" === d.type && (_t164 -= 1), d = d.leftSibling;
    } while (!d.isFirstSibling && 0 !== _t164);
    h = e.offsetOf(d);
  } else if ("backward" === t) {
    if ("first" === d.type) for (; h > 0 && "first" === d.type;) h -= 1, d = e.at(h);else {
      var _t165 = d.type;
      "msubsup" === d.type && (h = e.offsetOf(e.at(h).leftSibling)), h -= 1;
      var _i151 = null === (n = e.at(h)) || void 0 === n ? void 0 : n.type;
      for (; h >= 0 && _i151 === _t165;) "msubsup" === (null === (a = e.at(h)) || void 0 === a ? void 0 : a.type) ? h = e.offsetOf(e.at(h).leftSibling) : h -= 1, _i151 = e.at(h).type;
    }
  } else {
    var _d2 = d,
      _t166 = _d2.type;
    var _i152 = null === (o = e.at(h)) || void 0 === o ? void 0 : o.type;
    var _r59 = e.lastOffset;
    for (; h <= _r59 && (_i152 === _t166 || "msubsup" === _i152);) {
      for (; "msubsup" === (null === (s = e.at(h).rightSibling) || void 0 === s ? void 0 : s.type);) h = e.offsetOf(e.at(h).rightSibling);
      h += 1, _i152 = null === (l = e.at(h)) || void 0 === l ? void 0 : l.type;
    }
    h -= 1;
  }
  if (null !== (c = null == i ? void 0 : i.extend) && void 0 !== c && c) {
    if (!e.setSelection(e.anchor, h)) return e.announce("plonk"), !1;
  } else {
    if (h === e.position) return e.announce("plonk"), !1;
    e.position = h;
  }
  return e.announce("move", u), !0;
}
function Mo(e, t, i) {
  var r, n, a;
  if (i = null != i ? i : {
    extend: !1
  }, "forward" !== t) {
    var _pn3 = pn(e),
      _pn4 = _slicedToArray(_pn3, 2),
      _t167 = _pn4[0],
      _i153 = _pn4[1];
    void 0 !== _t167 && void 0 !== _i153 && e.deleteAtoms([_t167, _i153]);
  }
  if ("upward" === t) return function (e, t) {
    var i, r, n;
    var a = null !== (i = null == t ? void 0 : t.extend) && void 0 !== i && i;
    e.collapseSelection("backward");
    var o = e.at(e.position);
    for (; o && "below" !== o.treeBranch;) o = o.parent;
    if (!o) {
      var _t168 = !0;
      return e.suppressChangeNotifications || (_t168 = null === (n = e.hooks) || void 0 === n ? void 0 : n.moveOut(e, "upward")), e.announce(_t168 ? "plonk" : "line"), _t168;
    }
    if (a) e.setSelection(e.offsetOf(o.parent.leftSibling), e.offsetOf(o.parent));else {
      var _t169 = null !== (r = o.parent.branch("above")) && void 0 !== r ? r : o.parent.createBranch("above");
      So(e, e.offsetOf(_t169[_t169.length - 1]));
    }
    return e.announce("move up"), !0;
  }(e, i);
  if ("downward" === t) return function (e, t) {
    var i, r, n;
    var a = null !== (i = null == t ? void 0 : t.extend) && void 0 !== i && i;
    e.collapseSelection("forward");
    var o = e.at(e.position);
    for (; o && "above" !== o.treeBranch;) o = o.parent;
    if (!o) {
      var _t170 = !0;
      return e.suppressChangeNotifications || (_t170 = null === (n = e.hooks) || void 0 === n ? void 0 : n.moveOut(e, "downward")), e.announce(_t170 ? "plonk" : "line"), _t170;
    }
    if (a) e.setSelection(e.offsetOf(o.parent.leftSibling), e.offsetOf(o.parent));else {
      var _t171 = null !== (r = o.parent.branch("below")) && void 0 !== r ? r : o.parent.createBranch("below");
      So(e, e.offsetOf(_t171[_t171.length - 1]));
    }
    return e.announce("move down"), !0;
  }(e, i);
  var o = e.position;
  if (i.extend) return e.extendSelection(t);
  if (e.selectionIsPlaceholder) return e.collapseSelection(t), Mo(e, t);
  if (!e.collapseSelection(t)) {
    var _o20 = e.position + ("forward" === t ? 1 : -1);
    if ("forward" === t) {
      var _t172 = e.at(_o20);
      if (null == _t172 ? void 0 : _t172.inCaptureSelection) {
        for (; !_t172.captureSelection;) _t172 = _t172.parent;
        _o20 = e.offsetOf(_t172);
      } else if (!(null == _t172 ? void 0 : _t172.isFirstSibling) && (null == _t172 ? void 0 : _t172.isLastSibling) && (null === (r = _t172.parent) || void 0 === r ? void 0 : r.skipBoundary)) {
        if (_o20 + 1 !== e.lastOffset) return e.position = _o20 + 1, Mo(e, "forward", i);
        _o20 += 1;
      } else _t172 instanceof $r && _t172.isSuggestion && (_t172.isSuggestion = !1);
    } else if ("backward" === t) {
      var _t173 = e.at(_o20);
      if (null == _t173 ? void 0 : _t173.inCaptureSelection) {
        for (; !_t173.captureSelection;) _t173 = _t173.parent;
        _o20 = Math.max(0, e.offsetOf(_t173.leftSibling));
      } else !(null == _t173 ? void 0 : _t173.isLastSibling) && (null == _t173 ? void 0 : _t173.isFirstSibling) && (null === (n = _t173.parent) || void 0 === n ? void 0 : n.skipBoundary) && (_o20 = Math.max(0, _o20 - 1));
    }
    if (_o20 < 0 || _o20 > e.lastOffset) {
      var _i154 = !0;
      return e.suppressChangeNotifications || (_i154 = null === (a = e.hooks) || void 0 === a ? void 0 : a.moveOut(e, t)), _i154 && e.announce("plonk"), _i154;
    }
    So(e, _o20);
  }
  return e.announce("move", o), !0;
}
function So(e, t) {
  var i, r, n;
  "placeholder" === (null === (i = e.at(t)) || void 0 === i ? void 0 : i.type) ? e.setSelection(t - 1, t) : "placeholder" === (null === (n = null === (r = e.at(t)) || void 0 === r ? void 0 : r.rightSibling) || void 0 === n ? void 0 : n.type) ? e.setSelection(t, t + 1) : e.position = t;
}
function Lo(e) {
  var t = e.position;
  return e.at(t).parent ? (e.position = e.offsetOf(e.at(e.position).parent), e.announce("move", t), !0) : (e.announce("plonk"), !1);
}
function Co(e) {
  var t;
  if (e.collapseSelection(), function (e) {
    var t = 0,
      i = e.at(e.position),
      r = !1;
    for (; i;) i.hasEmptyBranch("superscript") && i.hasEmptyBranch("subscript") || (t += 1), i.hasEmptyBranch("superscript") ? i.hasEmptyBranch("subscript") || (r = !1) : r = !0, i = i.parent;
    return r ? t : 0;
  }(e) >= e.mathfield.options.scriptDepth[1]) return e.announce("plonk"), !1;
  var i = e.at(e.position);
  return void 0 === i.subsupPlacement && ("msubsup" !== (null === (t = i.rightSibling) || void 0 === t ? void 0 : t.type) && i.parent.addChildAfter(new _t({
    style: i.computedStyle
  }), i), i = i.rightSibling), i.createBranch("superscript"), e.setSelection(e.getSiblingsRange(e.offsetOf(i.superscript[0]))), !0;
}
function Ao(e) {
  var t;
  if (e.collapseSelection(), function (e) {
    var t = 0,
      i = e.at(e.position),
      r = !1;
    for (; i;) i.hasEmptyBranch("superscript") && i.hasEmptyBranch("subscript") || (t += 1), i.hasEmptyBranch("superscript") ? i.hasEmptyBranch("subscript") || (r = !0) : r = !1, i = i.parent;
    return r ? t : 0;
  }(e) >= e.mathfield.options.scriptDepth[0]) return e.announce("plonk"), !1;
  var i = e.at(e.position);
  return void 0 === i.subsupPlacement && ("msubsup" !== (null === (t = e.at(e.position + 1)) || void 0 === t ? void 0 : t.type) && i.parent.addChildAfter(new _t({
    style: e.at(e.position).computedStyle
  }), i), i = e.at(e.position + 1)), i.createBranch("subscript"), e.setSelection(e.getSiblingsRange(e.offsetOf(i.subscript[0]))), !0;
}
function No(e, t) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
  var r, n;
  var a = "forward" === t ? 1 : -1;
  "placeholder" === e.at(e.anchor).type && Mo(e, t);
  var o = e.getAllAtoms(e.position + a);
  "backward" === t && o.reverse();
  var s = o.filter(function (e) {
    return "placeholder" === e.type || e.treeDepth > 0 && e.isFirstSibling && e.isLastSibling;
  });
  if (0 === s.length) {
    if (!i || !(null === (n = (r = e.hooks).tabOut) || void 0 === n ? void 0 : n.call(r, e, t))) return e.announce("plonk"), !1;
    var _o21 = function () {
      function e(e) {
        return !(!function (e) {
          return !(e.disabled || "hidden" === e.type && "INPUT" === e.tagName.toUpperCase() || function (e) {
            if (!ke() || e === document.activeElement || e.contains(document.activeElement)) return !1;
            if ("hidden" === getComputedStyle(e).visibility) return !0;
            var t = e.getBoundingClientRect();
            if (0 === t.width || 0 === t.height) return !0;
            for (; e;) {
              if ("none" === getComputedStyle(e).display) return !0;
              e = e.parentElement;
            }
            return !1;
          }(e));
        }(e) || (i = e, "INPUT" === i.tagName.toUpperCase() && "radio" === i.type && !function (e) {
          var t;
          if (!e.name) return !0;
          var i = function (e, t) {
            var _iterator109 = _createForOfIteratorHelper(e),
              _step109;
            try {
              for (_iterator109.s(); !(_step109 = _iterator109.n()).done;) {
                var _i155 = _step109.value;
                if (_i155.checked && _i155.form === t) return _i155;
              }
            } catch (err) {
              _iterator109.e(err);
            } finally {
              _iterator109.f();
            }
            return null;
          }((null !== (t = e.form) && void 0 !== t ? t : e.ownerDocument).querySelectorAll('input[type="radio"][name="' + e.name + '"]'), e.form);
          return !i || i === e;
        }(i)) || t(e) < 0);
        var i;
      }
      function t(e) {
        var t;
        var i = Number.parseInt(null !== (t = e.getAttribute("tabindex")) && void 0 !== t ? t : "NaN", 10);
        return Number.isNaN(i) ? "true" === e.contentEditable ? 0 : "AUDIO" !== e.nodeName && "VIDEO" !== e.nodeName || null !== e.getAttribute("tabindex") ? e.tabIndex : 0 : i;
      }
      return ke() ? function (i) {
        var r = [],
          n = [];
        return _toConsumableArray(i.querySelectorAll('input, select, textarea, a[href], button,\n        [tabindex], audio[controls], video[controls],\n        [contenteditable]:not([contenteditable="false"]), details>summary')).filter(e).forEach(function (e, i) {
          var a = t(e);
          0 === a ? r.push(e) : n.push({
            documentOrder: i,
            tabIndex: a,
            node: e
          });
        }), n.sort(function (e, t) {
          return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
        }).map(function (e) {
          return e.node;
        }).concat(r);
      }(document.body) : [];
    }();
    if (!document.activeElement || 1 === _o21.length) return e.announce("plonk"), !1;
    var _s14 = _o21.indexOf(document.activeElement) + a;
    return !!(document.activeElement instanceof vs && l(document.activeElement, t, a)) || (_s14 < 0 && (_s14 = _o21.length - 1), _s14 >= _o21.length && (_s14 = 0), !!(_o21[_s14] instanceof vs && l(_o21[_s14], t, a)) || (_o21[_s14].focus(), 0 !== _s14 || (e.announce("plonk"), !1)));
  }
  function l(e, t, i) {
    var r, n, a;
    var o = _toConsumableArray(null !== (n = null === (r = e.shadowRoot) || void 0 === r ? void 0 : r.querySelectorAll("math-field")) && void 0 !== n ? n : []);
    if (o.length) {
      var _r60 = null === (a = e.shadowRoot) || void 0 === a ? void 0 : a.activeElement,
        _n48 = o.indexOf(_r60);
      var _s15 = _n48 + i;
      if (_n48 < 0 && "backward" === t && (_s15 = o.length - 1), _s15 >= 0 && _s15 < o.length) return o[_s15].focus(), !0;
    }
    return !1;
  }
  var c = e.position,
    u = e.offsetOf(s[0]);
  return "placeholder" === s[0].type ? e.setSelection(u - 1, u) : e.position = u, e.announce("move", c), !0;
}
function zo(e) {
  return !!e && ("mord" === e.type && /[\d.]/.test(e.value) || "mpunct" === e.type && "," === e.value);
}
function qo(e) {
  if ("text" === vo(e, e.position)) {
    var _t174 = Math.min(e.anchor, e.position),
      _i156 = Math.max(e.anchor, e.position),
      _r61 = !1;
    for (; !_r61 && _t174 > 0;) {
      var _i157 = e.at(_t174);
      "text" === _i157.mode && Oe.test(_i157.value) ? _t174 -= 1 : _r61 = !0;
    }
    for (_r61 = !1; !_r61 && _i156 <= e.lastOffset;) {
      var _t175 = e.at(_i156);
      "text" === _t175.mode && Oe.test(_t175.value) ? _i156 += 1 : _r61 = !0;
    }
    if (_r61 && (_i156 -= 1), _t174 >= _i156) return e.setSelection(_i156 - 1, _i156), !0;
    e.setSelection(_t174, _i156);
  } else {
    var _t176 = e.at(e.position);
    if (zo(_t176)) {
      var _t177 = Math.min(e.anchor, e.position),
        _i158 = Math.max(e.anchor, e.position);
      for (; zo(e.at(_t177));) _t177 -= 1;
      for (; zo(e.at(_i158));) _i158 += 1;
      e.setSelection(_t177, _i158 - 1);
    } else e.setSelection(e.offsetOf(_t176.firstSibling), e.offsetOf(_t176.lastSibling));
  }
  return !0;
}
bn({
  deleteAll: function deleteAll(e) {
    return yo(e, [0, -1]);
  },
  deleteForward: function deleteForward(e) {
    return function (e) {
      return e.selectionIsCollapsed ? e.deferNotifications({
        content: !0,
        selection: !0
      }, function () {
        var t, i;
        var r = e.at(e.position).rightSibling;
        if (r && go(e, "forward", r)) return;
        if (r) {
          if (e.at(e.position).isLastSibling && go(e, "forward", r.parent, r.treeBranch)) return;
        } else {
          if (r = e.at(e.position), r.isLastSibling && go(e, "forward", r.parent, r.treeBranch)) return;
          r = null;
        }
        if (e.position === e.lastOffset || !r) return void e.announce("plonk");
        r.parent.removeChild(r);
        var n = null === (t = e.at(e.position)) || void 0 === t ? void 0 : t.rightSibling;
        for (; "msubsup" === (null == n ? void 0 : n.type);) n.parent.removeChild(n), n = null === (i = e.at(e.position)) || void 0 === i ? void 0 : i.rightSibling;
        e.announce("delete", void 0, [r]);
      }) : yo(e, sn(e.selection));
    }(e);
  },
  deleteBackward: function deleteBackward(e) {
    return function (e) {
      return e.selectionIsCollapsed ? e.deferNotifications({
        content: !0,
        selection: !0
      }, function () {
        var t = e.at(e.position);
        if (t && go(e, "backward", t)) return;
        if (null == t ? void 0 : t.isFirstSibling) {
          if (go(e, "backward", t.parent, t.treeBranch)) return;
          t = null;
        }
        if (!t) return void e.announce("plonk");
        var i = e.offsetOf(t.leftSibling);
        t.parent.removeChild(t), e.announce("delete", void 0, [t]), e.position = i;
      }) : yo(e, sn(e.selection));
    }(e);
  },
  deleteNextWord: function deleteNextWord(e) {
    return yo(e, [e.anchor, wo(e, e.position, "forward")]);
  },
  deletePreviousWord: function deletePreviousWord(e) {
    return yo(e, [e.anchor, wo(e, e.position, "backward")]);
  },
  deleteToGroupStart: function deleteToGroupStart(e) {
    return yo(e, [e.anchor, e.offsetOf(e.at(e.position).firstSibling)]);
  },
  deleteToGroupEnd: function deleteToGroupEnd(e) {
    return yo(e, [e.anchor, e.offsetOf(e.at(e.position).lastSibling)]);
  },
  deleteToMathFieldStart: function deleteToMathFieldStart(e) {
    return yo(e, [e.anchor, 0]);
  },
  deleteToMathFieldEnd: function deleteToMathFieldEnd(e) {
    return yo(e, [e.anchor, -1]);
  }
}, {
  target: "model",
  category: "delete"
}), bn({
  moveToOpposite: function moveToOpposite(e) {
    var t = e.at(e.position),
      i = t.parent;
    if (!i) return e.announce("plonk"), !1;
    var r = t.treeBranch;
    var n;
    return "string" == typeof r && (n = {
      superscript: "subscript",
      subscript: "superscript",
      above: "below",
      below: "above"
    }[r]), n ? (i.branch(n) || i.createBranch(n), e.setSelection(e.getBranchRange(e.offsetOf(i), n))) : t.subsupPlacement ? Ao(e) : Co(e);
  },
  moveBeforeParent: function moveBeforeParent(e) {
    var _e$at = e.at(e.position),
      t = _e$at.parent;
    return t ? (e.position = e.offsetOf(t), !0) : (e.announce("plonk"), !1);
  },
  moveAfterParent: function moveAfterParent(e) {
    return Lo(e);
  },
  moveToNextPlaceholder: function moveToNextPlaceholder(e) {
    return No(e, "forward");
  },
  moveToPreviousPlaceholder: function moveToPreviousPlaceholder(e) {
    return No(e, "backward");
  },
  moveToNextChar: function moveToNextChar(e) {
    return Mo(e, "forward");
  },
  moveToPreviousChar: function moveToPreviousChar(e) {
    return Mo(e, "backward");
  },
  moveUp: function moveUp(e) {
    return Mo(e, "upward");
  },
  moveDown: function moveDown(e) {
    return Mo(e, "downward");
  },
  moveToNextWord: function moveToNextWord(e) {
    return _o(e, "forward");
  },
  moveToPreviousWord: function moveToPreviousWord(e) {
    return _o(e, "backward");
  },
  moveToGroupStart: function moveToGroupStart(e) {
    var t = e.offsetOf(e.at(e.position).firstSibling);
    return t === e.position ? (e.announce("plonk"), !1) : (e.position = t, !0);
  },
  moveToGroupEnd: function moveToGroupEnd(e) {
    var t = e.offsetOf(e.at(e.position).lastSibling);
    return t === e.position ? (e.announce("plonk"), !1) : (e.position = t, !0);
  },
  moveToMathFieldStart: function moveToMathFieldStart(e) {
    return 0 === e.position ? (e.announce("plonk"), !1) : (e.position = 0, !0);
  },
  moveToMathFieldEnd: function moveToMathFieldEnd(e) {
    return e.position === e.lastOffset ? (e.announce("plonk"), !1) : (e.position = e.lastOffset, !0);
  },
  moveToSuperscript: function moveToSuperscript(e) {
    return Co(e);
  },
  moveToSubscript: function moveToSubscript(e) {
    return Ao(e);
  }
}, {
  target: "model",
  category: "selection-anchor"
}), bn({
  selectGroup: function selectGroup(e) {
    var t = qo(e);
    return t || e.announce("plonk"), t;
  },
  selectAll: function selectAll(e) {
    return e.setSelection(0, e.lastOffset);
  },
  extendSelectionForward: function extendSelectionForward(e) {
    var t = e.extendSelection("forward");
    return t || e.announce("plonk"), t;
  },
  extendSelectionBackward: function extendSelectionBackward(e) {
    var t = e.extendSelection("backward");
    return t || e.announce("plonk"), t;
  },
  extendToNextWord: function extendToNextWord(e) {
    return _o(e, "forward", {
      extend: !0
    });
  },
  extendToPreviousWord: function extendToPreviousWord(e) {
    return _o(e, "backward", {
      extend: !0
    });
  },
  extendSelectionUpward: function extendSelectionUpward(e) {
    return Mo(e, "upward", {
      extend: !0
    });
  },
  extendSelectionDownward: function extendSelectionDownward(e) {
    return Mo(e, "downward", {
      extend: !0
    });
  },
  extendToNextBoundary: function extendToNextBoundary(e) {
    return _o(e, "forward", {
      extend: !0
    });
  },
  extendToPreviousBoundary: function extendToPreviousBoundary(e) {
    return _o(e, "backward", {
      extend: !0
    });
  },
  extendToGroupStart: function extendToGroupStart(e) {
    var t = e.setSelection(e.anchor, e.offsetOf(e.at(e.position).firstSibling));
    return t || e.announce("plonk"), t;
  },
  extendToGroupEnd: function extendToGroupEnd(e) {
    var t = e.setSelection(e.anchor, e.offsetOf(e.at(e.position).lastSibling));
    return t || e.announce("plonk"), t;
  },
  extendToMathFieldStart: function extendToMathFieldStart(e) {
    var t = e.setSelection(e.anchor, 0);
    return t || e.announce("plonk"), t;
  },
  extendToMathFieldEnd: function extendToMathFieldEnd(e) {
    var t = e.setSelection(e.anchor, e.lastOffset);
    return t || e.announce("plonk"), t;
  }
}, {
  target: "model",
  category: "selection-extend"
});
var Do = new Set(["Backquote", "Digit0", "Digit1", "Digit2", "Digit3", "Digit4", "Digit5", "Digit6", "Digit7", "Digit8", "Digit9", "Minus", "Equal", "IntlYen", "KeyQ", "KeyW", "KeyE", "KeyR", "KeyT", "KeyY", "KeyU", "KeyI", "KeyO", "KeyP", "BracketLeft", "BracketRight", "Backslash", "KeyA", "KeyS", "KeyD", "KeyF", "KeyG", "KeyH", "KeyJ", "KeyK", "KeyL", "Semicolon", "Quote", "IntlBackslash", "KeyZ", "KeyX", "KeyC", "KeyV", "KeyB", "KeyN", "KeyM", "Comma", "Period", "Slash", "IntlRo", "Space", "Numpad0", "Numpad1", "Numpad2", "Numpad3", "Numpad4", "Numpad5", "Numpad6", "Numpad7", "Numpad8", "Numpad9", "NumpadAdd", "NumpadComma", "NumpadDecimal", "NumpadDivide", "NumpadEqual", "NumpadHash", "NumpadMultiply", "NumpadParenLeft", "NumpadParenRight", "NumpadStar", "NumpadSubstract"]);
function Eo(e) {
  return !e.ctrlKey && !e.metaKey && "Dead" !== e.key && ("" === e.code || Do.has(e.code));
}
function To(e) {
  var t = [];
  return (e = function (e) {
    if (!e.code) {
      var _t178 = Object.entries(Ki().mapping);
      var _i159 = !1,
        _r62 = !1,
        _n49 = "";
      for (var _a27 = 0; _a27 < 4; _a27++) {
        var _iterator110 = _createForOfIteratorHelper(_t178),
          _step110;
        try {
          for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
            var _step110$value = _slicedToArray(_step110.value, 2),
              _o22 = _step110$value[0],
              _s16 = _step110$value[1];
            if (_s16[_a27] === e.key) {
              _n49 = _o22, 3 === _a27 ? (_i159 = !0, _r62 = !0) : 2 === _a27 ? _i159 = !0 : 1 === _a27 && (_r62 = !0);
              break;
            }
          }
        } catch (err) {
          _iterator110.e(err);
        } finally {
          _iterator110.f();
        }
        if (_n49) break;
      }
      return new KeyboardEvent(e.type, _objectSpread(_objectSpread({}, e), {}, {
        altKey: _i159,
        shiftKey: _r62,
        code: _n49
      }));
    }
    return new KeyboardEvent(e.type, e);
  }(e)).ctrlKey && t.push("ctrl"), e.metaKey && t.push("meta"), e.altKey && t.push("alt"), e.shiftKey && t.push("shift"), 0 === t.length ? "[" + e.code + "]" : (t.push("[" + e.code + "]"), t.join("+"));
}
function Oo() {
  var e;
  if (!ke()) return null;
  var t = document.activeElement;
  for (; null === (e = null == t ? void 0 : t.shadowRoot) || void 0 === e ? void 0 : e.activeElement;) t = t.shadowRoot.activeElement;
  return t;
}
function Bo(e) {
  var t;
  if (!e) return "";
  var i;
  return "Unidentified" === e.key && e.target && (i = e.target.value), i = null !== (t = null != i ? i : e.key) && void 0 !== t ? t : e.code, /^(Dead|Return|Enter|Tab|Escape|Delete|PageUp|PageDown|Home|End|Help|ArrowLeft|ArrowRight|ArrowUp|ArrowDown)$/.test(i) && (i = ""), i;
}
var Ko = /*#__PURE__*/function () {
  function Ko(e) {
    _classCallCheck(this, Ko);
    this.record = !1, this.canCoalesce = !1, this.model = e, this.reset();
  }
  _createClass(Ko, [{
    key: "maximumDepth",
    get: function get() {
      return 1e3;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.stack = [], this.index = -1;
    }
  }, {
    key: "startRecording",
    value: function startRecording() {
      this.record = !0;
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return this.index > 0;
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return this.index !== this.stack.length - 1;
    }
  }, {
    key: "undo",
    value: function undo(e) {
      this.canUndo() && ("function" == typeof (null == e ? void 0 : e.onUndoStateWillChange) && e.onUndoStateWillChange(this.model.mathfield, "undo"), this.restore(this.stack[this.index - 1], e), this.index -= 1, e && "function" == typeof e.onUndoStateDidChange && e.onUndoStateDidChange(this.model.mathfield, "undo"), this.canCoalesce = !1);
    }
  }, {
    key: "redo",
    value: function redo(e) {
      this.canRedo() && ("function" == typeof (null == e ? void 0 : e.onUndoStateWillChange) && e.onUndoStateWillChange(this.model.mathfield, "redo"), this.index += 1, this.restore(this.stack[this.index], e), e && "function" == typeof e.onUndoStateDidChange && e.onUndoStateDidChange(this.model.mathfield, "redo"), this.canCoalesce = !1);
    }
  }, {
    key: "pop",
    value: function pop() {
      this.canUndo() && (this.index -= 1, this.stack.pop());
    }
  }, {
    key: "snapshot",
    value: function snapshot(e) {
      this.record && ("function" == typeof (null == e ? void 0 : e.onUndoStateWillChange) && e.onUndoStateWillChange(this.model.mathfield, "snapshot"), this.stack.splice(this.index + 1, this.stack.length - this.index - 1), this.stack.push({
        latex: rt.serialize(this.model.root, {
          expandMacro: !1,
          defaultMode: this.model.mathfield.options.defaultMode
        }),
        selection: this.model.selection
      }), this.index++, this.stack.length > this.maximumDepth && this.stack.shift(), e && "function" == typeof e.onUndoStateDidChange && e.onUndoStateDidChange(this.model.mathfield, "snapshot"), this.canCoalesce = !1);
    }
  }, {
    key: "snapshotAndCoalesce",
    value: function snapshotAndCoalesce(e) {
      this.canCoalesce && this.pop(), this.snapshot(e), this.canCoalesce = !0;
    }
  }, {
    key: "save",
    value: function save() {
      return {
        latex: rt.serialize(this.model.root, {
          expandMacro: !1,
          defaultMode: this.model.mathfield.options.defaultMode
        }),
        selection: this.model.selection
      };
    }
  }, {
    key: "restore",
    value: function restore(e, t) {
      var i = this.model.suppressChangeNotifications;
      void 0 !== t.suppressChangeNotifications && (this.model.suppressChangeNotifications = t.suppressChangeNotifications), cn.insert("math", this.model, e ? e.latex : "", _objectSpread(_objectSpread({}, t), {}, {
        format: "latex",
        insertionMode: "replaceAll",
        selectionMode: "after",
        smartFence: !1
      })), this.model.selection = e ? e.selection : {
        ranges: [[0, 0]]
      }, this.model.suppressChangeNotifications = i;
    }
  }]);
  return Ko;
}();
function Fo(e, t) {
  return "string" == typeof e ? e === t : e.test(t);
}
function $o(e, t, i, r, n) {
  var a = t.branch(i);
  if (!a) return [];
  var o = [];
  var s = a.length;
  for (; s > 0;) {
    for (var _t179 = 1; _t179 < a.length - s + 1; _t179++) {
      var _i160 = rt.serialize(a.slice(_t179, _t179 + s), {
        expandMacro: !1,
        defaultMode: e.mathfield.options.defaultMode
      });
      Fo(r, _i160) && (o.push([e.offsetOf(a[_t179].leftSibling), e.offsetOf(a[_t179 + s - 1])]), _t179 += s);
    }
    s--;
  }
  return a.reduce(function (t, i) {
    return [].concat(_toConsumableArray(t), _toConsumableArray(Po(e, i, r, n)));
  }, o);
}
function Po(e, t, i, r) {
  return "first" === t.type || (null == r ? void 0 : r.mode) && r.mode !== t.mode ? [] : t.branches.reduce(function (n, a) {
    return [].concat(_toConsumableArray(n), _toConsumableArray($o(e, t, a, i, r)));
  }, []);
}
function Io(e, t, i, r, n, a) {
  var o = t.branch(i);
  if (!o) return;
  o.forEach(function (t) {
    return function (e, t, i, r, n) {
      "first" !== t.type && ((null == n ? void 0 : n.mode) && n.mode !== t.mode || t.branches.forEach(function (a) {
        return Io(e, t, a, i, r, n);
      }));
    }(e, t, r, n, a);
  });
  var s = 1;
  for (; s < o.length;) {
    var _i161 = o.length - s;
    var _loop3 = function _loop3() {
      var a = !1;
      var l = rt.serialize(o.slice(s, s + _i161), {
          expandMacro: !1,
          defaultMode: e.mathfield.options.defaultMode
        }),
        c = {
          latex: l
        };
      if ("string" == typeof r && l === r) a = !0;else if (r instanceof RegExp) {
        var _e215 = l.match(r);
        null !== _e215 && (a = !0, _e215.length > 0 && (c.p = _toConsumableArray(_e215)), c.groups = _e215.groups);
      }
      if (a) {
        for (var _e216 = s + _i161 - 1; _e216 >= s; _e216--) t.removeChild(o[_e216]);
        var _e217;
        "string" == typeof n ? (_e217 = n, c.p && c.p.forEach(function (t, i) {
          "string" == typeof t && (_e217 = _e217.replace("$" + Number(i).toString(), t));
        }), c.groups && Object.keys(c.groups).forEach(function (t) {
          "string" == typeof t && (_e217 = _e217.replace("$" + t, c.groups[t]));
        }), _e217 = _e217.replace("$$", "$")) : _e217 = n(c);
        var _r63 = t.addChildrenAfter(zt(_e217, {
          parseMode: t.mode
        }), o[s - 1]);
        s = o.indexOf(_r63) + 1, _i161 = o.length - s;
      } else _i161--;
    };
    for (; _i161 > 0;) {
      _loop3();
    }
    s++;
  }
}
function Ro(e, t, i) {
  "function" == typeof t && (i = t, t = 1 / 0), void 0 === t && (t = 1 / 0);
  var r = e.position,
    n = !1;
  for (; !n;) {
    var _a28 = e.at(r);
    n = 0 === t || void 0 === _a28 || "math" !== _a28.mode || !(/mord|textord|mpunct/.test(_a28.type) || "mop" === _a28.type && /[a-zA-Z]+/.test(_a28.value)) || !_a28.hasEmptyBranch("superscript") || !_a28.hasEmptyBranch("subscript") || "function" == typeof i && !i(_a28), n || (_a28.mode = "text", _a28.command = _a28.value, _a28.verbatimLatex = void 0), r -= 1, t -= 1;
  }
  dn(e);
}
function Vo(e, t, i) {
  "function" == typeof t && (i = t, t = 1 / 0), void 0 === t && (t = 1 / 0);
  var r = e.position,
    n = !1;
  for (; !n;) {
    var _a29 = e.at(r);
    n = 0 === t || !_a29 || _a29.isFirstSibling || "text" !== _a29.mode || " " === _a29.value || i && !i(_a29), n || (_a29.mode = "math"), r -= 1, t -= 1;
  }
  jo(e), dn(e);
}
function jo(e) {
  var t;
  var i = e.position - 1;
  for (; i >= 0 && "math" === (null === (t = e.at(i)) || void 0 === t ? void 0 : t.mode);) i -= 1;
  if (!(i < 0) && "text" === e.at(i).mode && " " === e.at(i).value && "math" === e.at(i - 1).mode) {
    e.at(i - 1).parent.removeChild(e.at(i - 1)), dn(e);
    var _t180 = e.suppressChangeNotifications;
    e.suppressChangeNotifications = !0, e.position -= 1, e.suppressChangeNotifications = _t180;
  }
}
function Ho(e) {
  if (!e) return null;
  if (e.length > 1) return null;
  var t = e[0];
  return t instanceof wt && "(" === t.leftDelim && ")" === t.rightDelim ? t.removeBranch("body") : null;
}
function Uo(e) {
  if (e) {
    for (var _t181 = 0; e[_t181]; _t181++) {
      var _i162 = e[_t181];
      if (_i162 instanceof wt && "(" === _i162.leftDelim) {
        var _r64 = 0,
          _n50 = 0,
          _a30 = 0;
        for (var _e218 = 0; _i162.body[_e218]; _e218++) "genfrac" === _i162.body[_e218].type && (_r64++, _n50 = _e218), _a30++;
        0 === _a30 && 1 === _r64 && (e[_t181] = _i162.body[_n50]);
      }
    }
    var _iterator111 = _createForOfIteratorHelper(e),
      _step111;
    try {
      for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
        var _t182 = _step111.value;
        var _iterator112 = _createForOfIteratorHelper(_t182.branches),
          _step112;
        try {
          for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
            var _e220 = _step112.value;
            if (!_t182.hasEmptyBranch(_e220)) {
              Uo(_t182.branch(_e220));
              var _i163 = Ho(_t182.branch(_e220));
              _i163 && _t182.setChildren(_i163, _e220);
            }
          }
        } catch (err) {
          _iterator112.e(err);
        } finally {
          _iterator112.f();
        }
        if (_t182 instanceof Zt) {
          var _iterator113 = _createForOfIteratorHelper(_t182.cells),
            _step113;
          try {
            for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
              var _e219 = _step113.value;
              Uo(_e219);
            }
          } catch (err) {
            _iterator113.e(err);
          } finally {
            _iterator113.f();
          }
        }
      }
    } catch (err) {
      _iterator111.e(err);
    } finally {
      _iterator111.f();
    }
  }
}
function Wo(e) {
  if (!e) return [];
  var t = [];
  var _iterator114 = _createForOfIteratorHelper(e),
    _step114;
  try {
    for (_iterator114.s(); !(_step114 = _iterator114.n()).done;) {
      var _i164 = _step114.value;
      var _iterator115 = _createForOfIteratorHelper(_i164.branches),
        _step115;
      try {
        for (_iterator115.s(); !(_step115 = _iterator115.n()).done;) {
          var _e221 = _step115.value;
          if (!_i164.hasEmptyBranch(_e221)) {
            var _r65 = Wo(_i164.branch(_e221));
            t = t.concat(_r65);
          }
        }
      } catch (err) {
        _iterator115.e(err);
      } finally {
        _iterator115.f();
      }
      _i164 instanceof Mt && t.push(_i164);
    }
  } catch (err) {
    _iterator114.e(err);
  } finally {
    _iterator114.f();
  }
  return t;
}
function Zo(e) {
  return !!/^(mord|surd|msubsup|leftright|mop)$/.test(e.type) && !e.isExtensibleSymbol;
}
function Go(e, t, i) {
  var r = e.at(e.position),
    n = r.parent;
  var a = n instanceof wt ? n.leftDelim + n.rightDelim : "";
  if ("\\lbrace\\rbrace" === a && (a = "{}"), "\\{\\}" === a && (a = "{}"), "\\lparen\\rparen" === a && (a = "()"), "{}" === a && /\||\\vert|\\Vert|\\mvert|\\mid/.test(t)) return cn.insert("math", e, "\\,\\middle" + t + "\\, ", {
    format: "latex",
    style: i
  }), !0;
  "{" !== t && "\\{" !== t || (t = "\\lbrace"), "}" !== t && "\\}" !== t || (t = "\\rbrace"), "[" === t && (t = "\\lbrack"), "]" === t && (t = "\\rbrack");
  var o = lt[t];
  if (o && !(n instanceof wt && "|" === n.leftDelim)) {
    var _n51 = "";
    _n51 = r.isFunction ? "\\mleft".concat(t, "\\mright").concat(o) : "\\left".concat(t, "\\right?");
    var _a31 = e.offsetOf(r.lastSibling),
      _s17 = e.extractAtoms([e.position, _a31]);
    return cn.insert("math", e, _n51, {
      format: "latex",
      style: i
    }), e.at(e.position).body = _s17, e.position -= 1, !0;
  }
  var s = "";
  if (Object.keys(lt).forEach(function (e) {
    t === lt[e] && (s = e);
  }), s) {
    if (n instanceof wt && r.isLastSibling) return n.rightDelim = t, e.position += 1, dn(e), !0;
    var _a32 = e.offsetOf(r.firstSibling);
    var _o23;
    for (_o23 = e.position; _o23 >= _a32; _o23--) {
      var _t183 = e.at(_o23);
      if (_t183 instanceof wt && "?" === _t183.rightDelim) break;
    }
    var _s18 = e.at(_o23);
    if (_o23 >= _a32 && _s18 instanceof wt) return _s18.rightDelim = t, _s18.addChildren(e.extractAtoms([_o23, e.position]), r.treeBranch), e.position = _o23, dn(e), !0;
    if (n instanceof wt && "?" === n.rightDelim) return n.rightDelim = t, n.parent.addChildren(e.extractAtoms([e.position, e.offsetOf(r.lastSibling)]), n.treeBranch), e.position = e.offsetOf(n), dn(e), !0;
    var _l10 = n.parent;
    return !!(_l10 instanceof wt && "?" === _l10.rightDelim && e.at(e.position).isLastSibling) && (e.position = e.offsetOf(_l10), Go(e, t, i));
  }
  return !1;
}
new ( /*#__PURE__*/function (_cn2) {
  _inherits(_class5, _cn2);
  var _super35 = _createSuper(_class5);
  function _class5() {
    _classCallCheck(this, _class5);
    return _super35.call(this, "math");
  }
  _createClass(_class5, [{
    key: "onPaste",
    value: function onPaste(e, t) {
      if (!t.clipboardData) return !1;
      var i = "",
        r = "auto";
      var n = t.clipboardData.getData("application/json");
      if (n) try {
        i = function (e, t) {
          return new co({}).serialize(e);
        }(JSON.parse(n)), r = "latex";
      } catch (_unused) {
        i = "";
      }
      return i || (i = t.clipboardData.getData("text/plain")), i && (e.snapshot(), this.insert(e.model, i, {
        smartFence: e.options.smartFence,
        colorMap: e.colorMap,
        backgroundColorMap: e.backgroundColorMap,
        format: r
      }) && rn(e), t.preventDefault(), t.stopPropagation()), !0;
    }
  }, {
    key: "insert",
    value: function insert(e, t, i) {
      var r, n;
      if (i.insertionMode || (i.insertionMode = "replaceSelection"), i.selectionMode || (i.selectionMode = "placeholder"), i.format || (i.format = "auto"), i.macros = null !== (r = i.macros) && void 0 !== r ? r : e.options.macros, null !== (n = i.smartFence) && void 0 !== n && n) {
        if (e.selectionIsCollapsed && Go(e, t, i.style)) return !0;
      } else if ("replaceAll" !== i.insertionMode) {
        var _e$at2 = e.at(e.position),
          _i165 = _e$at2.parent;
        if (_i165 instanceof wt && "?" === _i165.rightDelim && e.at(e.position).isLastSibling && /^[)}\]|]$/.test(t)) return _i165.rightDelim = t, e.position += 1, un(e), dn(e), !0;
      }
      var a = e.suppressChangeNotifications;
      i.suppressChangeNotifications && (e.suppressChangeNotifications = !0);
      var o = e.suppressChangeNotifications;
      e.suppressChangeNotifications = !0;
      var s = {};
      if (s[0] = e.getValue(e.selection), s["?"] = "\\placeholder{}", s["@"] = s["?"], "replaceSelection" !== i.insertionMode || e.selectionIsCollapsed ? "replaceAll" === i.insertionMode ? (e.root.setChildren([], "body"), e.position = 0) : "insertBefore" === i.insertionMode ? e.collapseSelection("backward") : "insertAfter" === i.insertionMode && e.collapseSelection("forward") : e.position = e.deleteAtoms(sn(e.selection)), e.at(e.position).isLastSibling || "placeholder" !== e.at(e.position + 1).type ? "placeholder" === e.at(e.position).type && (e.deleteAtoms([e.position - 1, e.position]), e.position -= 1) : e.deleteAtoms([e.position, e.position + 1]), s[0]) s["@"] = s[0];else if (/(^|[^\\])#@/.test(t)) {
        var _t184 = function (e) {
          var t = e.at(e.position);
          if ("text" === t.mode) {
            for (; !t.isFirstSibling && "text" === t.mode;) t = t.leftSibling;
            return e.offsetOf(t);
          }
          if (!Zo(t)) return -1;
          for (; !t.isFirstSibling && Zo(t);) t = t.leftSibling;
          return e.offsetOf(t);
        }(e);
        _t184 >= 0 && (s["@"] = e.getValue(_t184, e.position), e.deleteAtoms([_t184, e.position]), e.position = _t184);
      }
      s[0] || (s[0] = s["?"]);
      var l = !1;
      var _ref19 = function (e, t, i, r) {
          var _di3, _di4, _di5, _di6, _gi3, _gi4;
          var n,
            a = [];
          return "ascii-math" === r.format ? ((_di3 = di(t, {
            format: "ascii-math",
            inlineShortcuts: e.mathfield.options.inlineShortcuts
          }), _di4 = _slicedToArray(_di3, 2), n = _di4[0], t = _di4[1]), a = zt(t, {
            parseMode: "math",
            macros: null == r ? void 0 : r.macros,
            onError: e.listeners.onError,
            colorMap: r.colorMap,
            backgroundColorMap: r.backgroundColorMap
          }), "latex" !== n && e.options.removeExtraneousParentheses && Uo(a)) : "auto" !== r.format && "latex" !== r.format || ("auto" === r.format && (_di5 = di(t, {
            format: "auto",
            inlineShortcuts: e.mathfield.options.inlineShortcuts
          }), _di6 = _slicedToArray(_di5, 2), n = _di6[0], t = _di6[1], _di5), "latex" === r.format && (_gi3 = gi(t), _gi4 = _slicedToArray(_gi3, 2), t = _gi4[1], _gi3), a = zt(t, {
            parseMode: "math",
            args: i,
            macros: r.macros,
            smartFence: r.smartFence,
            onError: e.listeners.onError,
            colorMap: r.colorMap,
            backgroundColorMap: r.backgroundColorMap
          }), "latex" !== r.format && e.options.removeExtraneousParentheses && Uo(a)), xo(a, r.style), [null != n ? n : "latex", a];
        }(e, t, function (e) {
          return l = !0, s[e];
        }, i),
        _ref20 = _slicedToArray(_ref19, 2),
        c = _ref20[0],
        u = _ref20[1];
      if (!u) return !1;
      var d = Wo(u),
        h = d.filter(function (t) {
          return t.placeholderId && !e.mathfield._placeholders.has(t.placeholderId);
        }),
        p = d.map(function (e) {
          return e.placeholderId;
        });
      _toConsumableArray(e.mathfield._placeholders.keys()).filter(function (e) {
        return !p.includes(e);
      }).forEach(function (t) {
        var i;
        e.mathfield._placeholders.has(t) && (null === (i = e.mathfield._placeholders.get(t)) || void 0 === i || i.field.remove(), e.mathfield._placeholders.delete(t));
      }), h.forEach(function (t) {
        var i, r;
        if (t.placeholderId && !e.mathfield._placeholders.has(t.placeholderId)) {
          var _n52 = new vs({
              virtualKeyboardMode: "onfocus",
              readOnly: !1,
              fontsDirectory: e.mathfield.options.fontsDirectory
            }),
            _a33 = null === (i = e.mathfield.element) || void 0 === i ? void 0 : i.querySelector(".ML__placeholdercontainer");
          _n52.value = (null === (r = t.defaultValue) || void 0 === r ? void 0 : r.length) ? rt.serialize(t.defaultValue, {
            defaultMode: "text"
          }) : "", _n52.classList.add("nested-mathfield"), _n52.style.display = "inline-block", _n52.style.zIndex = "1001", _n52.style.position = "absolute", _n52.style.minWidth = "30px";
          var _o24 = document.createElement("style");
          _o24.innerHTML = ".nested-mathfield {\n          border: 1px solid black;\n        }\n          .ML__fieldcontainer{\n            min-height:auto !important;\n          }\n\n          ", _n52.appendChild(_o24), _n52.addEventListener("input", function () {
            !function (e, t) {
              var i;
              "function" != typeof (null === (i = e.listeners) || void 0 === i ? void 0 : i.onPlaceholderDidChange) || e.suppressChangeNotifications || (e.suppressChangeNotifications = !0, e.listeners.onPlaceholderDidChange(e, t), e.suppressChangeNotifications = !1);
            }(e, t.placeholderId), setTimeout(function () {
              rn(e.mathfield);
            });
          }), null == _a33 || _a33.appendChild(_n52), e.mathfield._placeholders.set(t.placeholderId, {
            atom: t,
            field: _n52
          });
        }
      });
      var _e$at3 = e.at(e.position),
        m = _e$at3.parent;
      if ("latex" !== c && e.options.removeExtraneousParentheses && m instanceof wt && "(" === m.leftDelim && m.hasEmptyBranch("body") && 1 === u.length && "genfrac" === u[0].type) {
        var _e222 = m.parent,
          _t185 = m.treeBranch;
        _e222.removeChild(m), _e222.setChildren(u, _t185);
      }
      var f = m.hasEmptyBranch("body"),
        g = e.at(e.position);
      g.parent.addChildrenAfter(u, g), "latex" === c && "root" === m.type && f && !l && (m.verbatimLatex = t), e.suppressChangeNotifications = o;
      var y = u[u.length - 1];
      if ("placeholder" === i.selectionMode) {
        var _t186 = u.reduce(function (e, t) {
          return [].concat(_toConsumableArray(e), _toConsumableArray(t.children.filter(function (e) {
            return "placeholder" === e.type;
          })));
        }, []);
        if (_t186.length > 0) {
          var _i166 = e.offsetOf(_t186[0]);
          e.setSelection(_i166 - 1, _i166), e.announce("move");
        } else y && (e.position = e.offsetOf(y));
      } else "before" === i.selectionMode || ("after" === i.selectionMode ? y && (e.position = e.offsetOf(y)) : "item" === i.selectionMode && e.setSelection(e.anchor, e.offsetOf(y)));
      return dn(e), e.suppressChangeNotifications = a, !0;
    }
  }]);
  return _class5;
}(cn))();
var Xo = "#mathlive-keystroke-caption-panel{--keystroke:#fff;--on-keystroke:#555;--keystroke-border:#f7f7f7;background:var(--secondary,hsl(var(--hue,212),19%,26%));border-color:var(--secondary-border,#e8e8e8);border-radius:6px;box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);display:flex;flex-direction:row-reverse;justify-content:center;padding:16px;position:absolute;text-align:center;visibility:hidden;z-index:1}@media (prefers-color-scheme:dark){body:not([theme=light]) #mathlive-keystroke-caption-panel{--keystroke:hsl(var(--hue,212),50%,30%);--on-keystroke:#fafafa;--keystroke-border:hsl(var(--hue,212),50%,25%)}}body[theme=dark] #mathlive-keystroke-caption-panel{--keystroke:hsl(var(--hue,212),50%,30%);--on-keystroke:#fafafa;--keystroke-border:hsl(var(--hue,212),50%,25%)}#mathlive-keystroke-caption-panel>span{fill:currentColor;background-color:var(--keystroke);border:2px solid var(--keystroke-border);border-radius:6px;color:var(--on-keystroke);font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;font-size:1em;margin:0 8px 0 0;min-width:14px;padding:4px}";
var Yo,
  Qo = null,
  Jo = null;
function es(e) {
  return e.keystrokeCaption || (e.keystrokeCaption = vr("mathlive-keystroke-caption-panel"), void 0 === Yo && (Yo = yi(Xo).toString(36)), Qo = si(null, Xo, Yo), Jo = si(null, li, yi(li).toString(36))), e.keystrokeCaption;
}
function ts(e, t, i) {
  var r = e.model;
  !function (e) {
    var t, i;
    if (!e) return;
    var r = e.shiftKey && e.altKey ? 3 : e.altKey ? 2 : e.shiftKey ? 1 : 0;
    if ("Unidentified" !== e.key && "Dead" !== e.key) {
      for (var _i167 = 0, _Di = Di; _i167 < _Di.length; _i167++) {
        var _n53 = _Di[_i167];
        (null === (t = _n53.mapping[e.code]) || void 0 === t ? void 0 : t[r]) === e.key ? _n53.score += 1 : (null === (i = _n53.mapping[e.code]) || void 0 === i ? void 0 : i[r]) && (_n53.score = 0);
      }
      Di.sort(function (e, t) {
        return t.score - e.score;
      });
    }
  }(i);
  var n = Ki();
  if (e.keyboardLayout !== n.id && (e.keyboardLayout = n.id, e._keybindings = void 0), function (e, t) {
    if (e.options.readOnly || !e.keystrokeCaptionVisible) return;
    var i = es(e),
      r = e.element.getBoundingClientRect();
    i.style.left = "".concat(r.left, "px"), i.style.top = r.top - 64 + "px", i.innerHTML = e.options.createHTML("<span>" + ($i(t) || t) + "</span>" + i.innerHTML), i.style.visibility = "visible", setTimeout(function () {
      i.childNodes.length > 0 && i.childNodes[i.childNodes.length - 1].remove(), 0 === i.childNodes.length && (i.style.visibility = "hidden");
    }, 3e3);
  }(e, t), clearTimeout(e.keystrokeBufferResetTimer), !e.options.readOnly && e.options.onKeystroke && !e.options.onKeystroke(e, t, i)) return (null == i ? void 0 : i.preventDefault) && (i.preventDefault(), i.stopPropagation()), !1;
  var a,
    o,
    s = "",
    l = !1;
  if ("latex" !== e.mode && (!i || !i.ctrlKey && !i.metaKey)) if ("[Backspace]" === t) e.keystrokeBuffer = e.keystrokeBuffer.slice(0, -1), e.keystrokeBufferStates.pop(), e.resetKeystrokeBuffer({
    defer: !0
  });else if (i && !Eo(i)) e.resetKeystrokeBuffer();else {
    var _t187 = Bo(i),
      _n54 = e.keystrokeBuffer + _t187;
    var _s19 = 0;
    for (; !a && _s19 < _n54.length;) {
      var _t188 = e.keystrokeBufferStates[_s19] ? zt(e.keystrokeBufferStates[_s19].latex, {
        parseMode: Qn(e.options),
        macros: e.options.macros
      }) : r.getAtoms(r.offsetOf(r.at(r.position).firstSibling), r.position);
      a = ci(_t188, _n54.slice(_s19), e.options.inlineShortcuts), _s19 += 1;
    }
    o = e.keystrokeBufferStates.length - (_n54.length - _s19), e.keystrokeBuffer += _t187, e.keystrokeBufferStates.push(e.getUndoRecord()), function (e, t) {
      var i = [];
      for (var _r66 = 0; _r66 <= e.length - 1; _r66++) {
        var _n55 = e.slice(Math.max(0, _r66));
        for (var _i168 = 0, _Object$keys14 = Object.keys(t.inlineShortcuts); _i168 < _Object$keys14.length; _i168++) {
          var _e223 = _Object$keys14[_i168];
          _e223.startsWith(_n55) && !i.includes(_e223) && i.push(_e223);
        }
      }
      return i;
    }(_n54, e.options).length <= 1 ? l = !0 : e.resetKeystrokeBuffer({
      defer: !0
    });
  }
  if (e.options.smartMode) {
    var _r67 = e.mode;
    a ? e.mode = "math" : function (e, t, i) {
      if (e.smartModeSuppressed) return !1;
      var r = e.model;
      if (!r.at(r.position).isLastSibling) return !1;
      if (!i || !Eo(i)) return !1;
      var n = Bo(i);
      if (!r.selectionIsCollapsed) return !("text" !== e.mode || !/[/_^]/.test(n));
      var a = function (e) {
        var t = "",
          i = e.position,
          r = !1;
        for (; !r;) {
          var _n56 = e.at(i);
          r = !(_n56 && ("text" === _n56.mode || "math" === _n56.mode && /mord|textord|mpunct/.test(_n56.type))), r || (t = _n56.value + t), i -= 1;
        }
        return t;
      }(r) + n;
      if ("text" === e.mode) {
        if ("Esc" === t || /[/\\]/.test(n)) return !0;
        if (/[\^_]/.test(n)) return /(^|\s)[a-zA-Z][^_]$/.test(a) && Vo(r, 1), !0;
        var _e224 = {
            ")": "(",
            "}": "{",
            "]": "["
          }[n],
          _r$at = r.at(r.position),
          _i169 = _r$at.parent;
        if (_e224 && _i169 instanceof wt && _i169.leftDelim === _e224) return !0;
        if (/(^|[^a-zA-Z])(a|I) $/.test(a)) return !1;
        if (/[\$\xA2-\xA5\u0E3F\u20A1\u20A4\u20A7-\u20A9\u20AC\u20B1\u20B9\u20BA]/.test(n)) return !0;
        if (/(^|[^a-zA-Z'\u2019])[a-zA-Z] $/.test(a)) return Vo(r, 1), !1;
        if (/\D\.[^\d\s]$/.test(a)) {
          Vo(r, 1);
          var _e225 = r.at(r.position);
          return _e225.value = "\u22C5", _e225.style.variant = "normal", _e225.command = "\\cdot", _e225.verbatimLatex = void 0, dn(r), !0;
        }
        if (/(^|\s)[a-zA-Z][^a-zA-Z]$/.test(a)) return Vo(r, 1), !0;
        if (/\.\d$/.test(a)) return Vo(r, 1), !0;
        if (/\([\d+\-.]$/.test(a)) return Vo(r, 1), !0;
        if (/\([a-z][,;]$/.test(a)) return Vo(r, 2), !0;
        if (/[\d+\-=><*|]$/.test(n)) return jo(r), !0;
      } else {
        if ("[Space]" === t) return Ro(r, void 0, function (e) {
          return /[a-z][:,;.]$/.test(e.value);
        }), !0;
        if (/[a-zA-Z]{3,}$/.test(a) && !/(dxd|abc|xyz|uvw)$/.test(a)) return Ro(r, void 0, function (e) {
          return /[a-zA-Z]/.test(e.value);
        }), !0;
        if (/(^|\W)(if)$/i.test(a)) return Ro(r, 1), !0;
        if (/(\u0393|\u0394|\u0398|\u039B|\u039E|\u03A0|\u03A3|\u03A5|\u03A6|\u03A8|\u03A9|[\u03B1-\u03C9]|\u03D1|\u03D5|\u03D6|\u03F1|\u03F5){3,}$/.test(a) && !/(\u03b1\u03b2\u03b3)$/.test(a)) return Ro(r, void 0, function (e) {
          return /(:|,|;|(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\u0393|\u0394|\u0398|\u039B|\u039E|\u03A0|\u03A3|\u03A5|\u03A6|\u03A8|\u03A9|[\u03B1-\u03C9]|\u03D1|\u03D5|\u03D6|\u03F1|\u03F5)/.test(e.value);
        }), !0;
        if ("?" === n) return !0;
        if ("." === n && !/[\d-+]\.$/.test(a)) return !0;
      }
      return !1;
    }(e, t, i) && (e.mode = {
      math: "text",
      text: "math"
    }[e.mode], s = ""), e.mode !== _r67 && "function" == typeof e.options.onModeChange && e.options.onModeChange(e, e.mode);
  }
  if (a || s || (s = function (e, t, i) {
    if (0 === e.length) return "";
    var r = Ni(Ai(i));
    for (var _i170 = e.length - 1; _i170 >= 0; _i170--) if (e[_i170].key === r && (!e[_i170].ifMode || e[_i170].ifMode === t)) return e[_i170].command;
    return "";
  }(e.keybindings, e.mode, t)), !(a || s || "[Enter]" !== t && "[Return]" !== t) && "function" == typeof e.options.onCommit) return e.options.onCommit(e), (null == i ? void 0 : i.preventDefault) && (i.preventDefault(), i.stopPropagation()), !1;
  if (!a && !s) return !0;
  var c = r.at(Math.max(r.position, r.anchor)),
    u = c.parent;
  if ("moveAfterParent" === s && u && "leftright" === u.type && c.isLastSibling && e.options.smartFence && Go(r, ".", e.style) && (s = "", rn(e)), "math" === e.mode && "[Space]" === t && !a) if (e.options.mathModeSpace) e.snapshot(), cn.insert("math", r, e.options.mathModeSpace), s = "", e.dirty = !0;else {
    var _t189 = r.at(r.position + 1),
      _i171 = r.at(r.position - 1);
    (_t189 && "text" === _t189.mode || _i171 && "text" === _i171.mode) && (e.snapshot(), cn.insert("text", r, " "), e.dirty = !0);
  }
  if (s) e.executeCommand(s);else if (a) {
    e.keyboardDelegate.cancelComposition();
    var _t190 = _objectSpread(_objectSpread({}, r.at(r.position).computedStyle), e.style);
    if (!/^(\\{|\\}|\\[|\\]|\\@|\\#|\\$|\\%|\\^|\\_|\\backslash)$/.test(a)) {
      var _n57 = e.mode;
      cn.insert(e.mode, r, Bo(i), {
        suppressChangeNotifications: !0,
        style: _t190
      }), e.snapshot(), e.restoreToUndoRecord(e.keystrokeBufferStates[o]), e.mode = _n57;
    }
    r.deferNotifications({
      content: !0,
      selection: !0
    }, function () {
      return cn.insert(e.mode, r, a, {
        format: "latex",
        style: _t190,
        smartFence: !0
      }), jo(e.model), a.endsWith(" ") && (e.mode = "text", cn.insert("text", r, " ", {
        style: _t190
      })), !0;
    }), e.snapshot(), e.dirty = !0, r.announce("replacement"), l && e.resetKeystrokeBuffer();
  }
  return e.scrollIntoView(), (null == i ? void 0 : i.preventDefault) && (i.preventDefault(), i.stopPropagation()), !1;
}
function is(e, t, i) {
  var r;
  var n = e.model;
  if (e.options.readOnly) return void n.announce("plonk");
  if ((i = null != i ? i : {}).focus && e.focus(), i.feedback && (e.options.keypressVibration && Me() && navigator.vibrate(3), null === (r = e.keypressSound) || void 0 === r || r.play().catch(console.warn)), "string" == typeof i.mode && e.mode !== i.mode && e.switchMode(i.mode), i.simulateKeystroke) {
    var _i172 = t.charAt(0),
      _r68 = new KeyboardEvent("keypress", {
        key: _i172
      });
    if (!ts(e, _i172, _r68)) return;
  }
  var a = _objectSpread(_objectSpread({}, n.at(n.position).computedStyle), e.style);
  n.selectionIsCollapsed || (n.position = n.deleteAtoms(sn(n.selection)), e.snapshot());
  var o = fe(t);
  if ("latex" === e.mode) n.deferNotifications({
    content: !0,
    selection: !0
  }, function () {
    var _iterator116 = _createForOfIteratorHelper(o),
      _step116;
    try {
      for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
        var _e226 = _step116.value;
        cn.insert("latex", n, _e226);
      }
    } catch (err) {
      _iterator116.e(err);
    } finally {
      _iterator116.f();
    }
    mn(e);
  });else if ("text" === e.mode) {
    var _iterator117 = _createForOfIteratorHelper(o),
      _step117;
    try {
      for (_iterator117.s(); !(_step117 = _iterator117.n()).done;) {
        var _e227 = _step117.value;
        cn.insert("text", n, _e227, {
          style: a
        });
      }
    } catch (err) {
      _iterator117.e(err);
    } finally {
      _iterator117.f();
    }
  } else if ("math" === e.mode) {
    var _iterator118 = _createForOfIteratorHelper(o),
      _step118;
    try {
      for (_iterator118.s(); !(_step118 = _iterator118.n()).done;) {
        var _t191 = _step118.value;
        var _i173 = {
          "^": "moveToSuperscript",
          _: "moveToSubscript",
          " ": "moveAfterParent"
        }[_t191];
        " " === _t191 && e.options.mathModeSpace && (_i173 = ["insert", e.options.mathModeSpace]), _i173 ? e.executeCommand(_i173) : /\d/.test(_t191) && e.options.smartSuperscript && "superscript" === n.at(n.position).treeBranch && n.at(n.position).hasNoSiblings ? (cn.insert("math", n, _t191, {
          style: a
        }), Lo(n)) : cn.insert("math", n, _t191, {
          style: a,
          smartFence: e.options.smartFence
        });
      }
    } catch (err) {
      _iterator118.e(err);
    } finally {
      _iterator118.f();
    }
  }
  e.snapshotAndCoalesce(), e.dirty = !0, e.scrollIntoView();
}
function rs(e, t) {
  var i, r;
  var n = {};
  "string" == typeof t.color && (n.verbatimColor || (n.verbatimColor = t.color), n.color = e.colorMap(t.color)), "string" == typeof t.backgroundColor && (n.verbatimBackgroundColor || (n.verbatimBackgroundColor = t.backgroundColor), n.backgroundColor = e.backgroundColorMap(t.backgroundColor)), "string" == typeof t.fontFamily && (n.fontFamily = t.fontFamily), "string" == typeof t.series && (n.fontSeries = t.series), "string" == typeof t.fontSeries && (n.fontSeries = t.fontSeries.toLowerCase()), n.fontSeries && (n.fontSeries = {
    bold: "b",
    medium: "m",
    normal: "m"
  }[n.fontSeries] || n.fontSeries), "string" == typeof t.shape && (n.fontShape = t.shape), "string" == typeof t.fontShape && (n.fontShape = t.fontShape.toLowerCase()), n.fontShape && (n.fontShape = {
    italic: "it",
    up: "n",
    upright: "n",
    normal: "n"
  }[n.fontShape] || n.fontShape);
  var a = null !== (i = t.size) && void 0 !== i ? i : t.fontSize;
  return "number" == typeof a ? n.fontSize = Math.max(1, Math.min(10, a)) : "string" == typeof a && (n.fontSize = null !== (r = {
    size1: 1,
    size2: 2,
    size3: 3,
    size4: 4,
    size5: 5,
    size6: 6,
    size7: 7,
    size8: 8,
    size9: 9,
    size10: 10
  }[a.toLowerCase()]) && void 0 !== r ? r : {
    tiny: 1,
    scriptsize: 2,
    footnotesize: 3,
    small: 4,
    normal: 5,
    normalsize: 5,
    large: 6,
    Large: 7,
    LARGE: 8,
    huge: 9,
    Huge: 10
  }[a]), n;
}
bn({
  undo: function undo(e) {
    return gn(e, "accept"), e.undo(), !0;
  },
  redo: function redo(e) {
    return gn(e, "accept"), e.redo(), !0;
  },
  scrollIntoView: function scrollIntoView(e) {
    return e.scrollIntoView(), !0;
  },
  scrollToStart: function scrollToStart(e) {
    return e.field.scroll(0, 0), !0;
  },
  scrollToEnd: function scrollToEnd(e) {
    var t = e.field.getBoundingClientRect();
    return e.field.scroll(t.left - window.scrollX, 0), !0;
  },
  enterLatexMode: function enterLatexMode(e) {
    return e.switchMode("latex"), !0;
  },
  toggleKeystrokeCaption: function toggleKeystrokeCaption(e) {
    return e.keystrokeCaptionVisible = !e.keystrokeCaptionVisible, e.keystrokeCaptionVisible ? (e.keystrokeCaption = es(e), e.keystrokeCaption.innerHTML = "") : e.keystrokeCaption && (e.keystrokeCaption.style.visibility = "hidden"), !1;
  },
  switchMode: function switchMode(e, t, i, r) {
    return e.switchMode(t, i, r), !0;
  },
  insert: function insert(e, t, i) {
    return e.insert(t, i);
  },
  typedText: function typedText(e, t, i) {
    return is(e, t, i), !0;
  },
  commit: function commit(e) {
    return "function" == typeof e.options.onCommit && e.options.onCommit(e), !0;
  }
}), bn({
  copyToClipboard: function copyToClipboard(e) {
    return e.focus(), e.model.selectionIsCollapsed && e.select(), document.execCommand("copy"), !1;
  },
  cutToClipboard: function cutToClipboard(e) {
    return e.focus(), document.execCommand("cut"), !0;
  },
  pasteFromClipboard: function pasteFromClipboard(e) {
    return e.focus(), document.execCommand("paste"), !0;
  }
}, {
  target: "mathfield",
  category: "clipboard"
}), bn({
  applyStyle: function applyStyle(e, t) {
    var i = rs(e, t);
    e.resetKeystrokeBuffer();
    var r = e.model;
    return r.selectionIsCollapsed ? (e.style.fontSeries && i.fontSeries === e.style.fontSeries && (i.fontSeries = "auto"), i.fontShape && i.fontShape === e.style.fontShape && (i.fontShape = "auto"), i.color && i.color === e.style.color && (i.color = "none"), i.backgroundColor && i.backgroundColor === e.style.backgroundColor && (i.backgroundColor = "none"), i.fontSize && i.fontSize === e.style.fontSize && (i.fontSize = "auto"), e.style = _objectSpread(_objectSpread({}, e.style), i)) : e.model.deferNotifications({
      content: !0
    }, function () {
      r.selection.ranges.forEach(function (e) {
        return ko(r, e, i, {
          operation: "toggle"
        });
      }), e.snapshot();
    }), !0;
  }
}, {
  target: "mathfield"
});
var ns = null,
  as = 0;
function os(e) {
  return void 0 !== globalThis.TouchEvent && e instanceof TouchEvent;
}
function ss(e, t, i) {
  var r = e - (i.left + i.right) / 2,
    n = t - (i.top + i.bottom) / 2;
  return r * r + n * n;
}
function ls(e, t, i, r, n) {
  if (!i.id) return [1 / 0, null];
  if (t.has(i.id)) return t.get(i.id);
  var a = Lr(e, i);
  if (!a) return [1 / 0, null];
  var o = [ss(r, n, a), i];
  if (!i.captureSelection && r >= a.left && r <= a.right && i.hasChildren) {
    var _iterator119 = _createForOfIteratorHelper(i.children),
      _step119;
    try {
      for (_iterator119.s(); !(_step119 = _iterator119.n()).done;) {
        var _a34 = _step119.value;
        var _i174 = ls(e, t, _a34, r, n);
        _i174[0] < o[0] && (o = _i174);
      }
    } catch (err) {
      _iterator119.e(err);
    } finally {
      _iterator119.f();
    }
  }
  return o[1] || (o = [ss(r, n, a), i]), t.set(i.id, o), o;
}
function cs(e, t, i) {
  var _ls = ls(e, new Map(), e.model.root, t, i),
    _ls2 = _slicedToArray(_ls, 2),
    r = _ls2[1];
  return r;
}
function us(e, t, i, r) {
  var n;
  var a = e.fieldContent.getBoundingClientRect();
  if (t > a.right || i > a.bottom + 8) return e.model.lastOffset;
  if (t < a.left || i < a.top - 8) return 0;
  (r = null != r ? r : {}).bias = null !== (n = r.bias) && void 0 !== n ? n : 0;
  var o = cs(e, t, i);
  var s = [];
  var l = o;
  for (; l;) s.unshift(l), l = l.parent;
  for (var _i175 = 0, _s20 = s; _i175 < _s20.length; _i175++) {
    var _e228 = _s20[_i175];
    if (_e228.captureSelection) {
      o = _e228;
      break;
    }
  }
  var c = e.model.offsetOf(o);
  if (c < 0) return -1;
  if (o.leftSibling) if (0 === r.bias && "placeholder" !== o.type) {
    var _i176 = Lr(e, o);
    _i176 && t < (_i176.left + _i176.right) / 2 && (c = e.model.offsetOf(o.leftSibling));
  } else r.bias < 0 && (c = e.model.offsetOf(o.leftSibling));
  return c;
}
var ds = '@keyframes ML__caret-blink{0%,to{opacity:1}50%{opacity:0}}.ML__caret:after{animation:ML__caret-blink 1.05s step-end infinite forwards;border:none;border-radius:2px;border-right:2px solid var(--caret,hsl(var(--hue,212),40%,49%));content:"";left:-1px;margin-right:-2px;position:relative}.ML__text-caret:after{animation:ML__caret-blink 1.05s step-end infinite forwards;border:none;border-radius:1px;border-right:1px solid var(--caret,hsl(var(--hue,212),40%,49%));content:"";left:0;margin-right:-1px;position:relative}.ML__latex-caret:after{animation:ML__caret-blink 1.05s step-end infinite forwards;border:none;color:var(--caret,hsl(var(--hue,212),40%,49%));content:"_";margin-right:calc(-1ex - 2px);position:relative}.ML__fieldcontainer{align-items:flex-end;display:flex;flex-flow:row;justify-content:space-between;min-height:39px;touch-action:none;width:100%}.ML__fieldcontainer__field{align-items:center;align-self:center;display:flex;overflow:hidden;padding:2px 0 2px 1px;position:relative;width:100%}.ML__virtual-keyboard-toggle{display:none}.ML__virtual-keyboard-toggle>span{align-items:center;align-self:center;display:flex}.ML__virtual-keyboard-toggle.is-visible{fill:currentColor;align-items:center;align-self:center;background:transparent;border:1px solid transparent;border-radius:8px;box-sizing:border-box;color:var(--primary,hsl(var(--hue,212),40%,50%));cursor:pointer;display:flex;flex-direction:column;flex-shrink:0;height:34px;justify-content:center;margin-right:4px;padding:0;transition:background .2s cubic-bezier(.64,.09,.08,1);width:34px}.ML__virtual-keyboard-toggle.is-visible:hover{fill:currentColor;background:hsla(0,0%,70%,.5);border-radius:8px;color:#333}.ML__textarea__textarea{clip:rect(0 0 0 0);border:none;display:inline-block;font-family:KaTeX_Main;font-size:1em;height:1px;outline:none;position:absolute;resize:none;transform:scale(0);width:1px}.ML__focused .ML__text{background:hsla(var(--hue,212),40%,50%,.1)}.ML__smart-fence__close{color:var(--smart-fence-color,currentColor);opacity:var(--smart-fence-opacity,.5)}.ML__selection{background:var(--highlight-inactive,#ccc);box-sizing:border-box}.ML__focused .ML__selection{background:var(--highlight,hsl(var(--hue,212),97%,85%))!important;color:var(--on-highlight)}.ML__contains-caret.ML__close,.ML__contains-caret.ML__open,.ML__contains-caret .ML__sqrt-line,.ML__contains-caret .ML__sqrt-sign,.ML__contains-caret>.ML__close,.ML__contains-caret>.ML__open{color:var(--caret,hsl(var(--hue,212),40%,49%))}.ML__contains-highlight{background:var(--contains-highlight,var(--highlight,hsl(var(--hue,212),40%,95%)));box-sizing:border-box}.ML__latex{color:var(--primary,hsl(var(--hue,212),40%,50%));font-family:IBM Plex Mono,Source Code Pro,Consolas,Roboto Mono,Menlo,Bitstream Vera Sans Mono,DejaVu Sans Mono,Monaco,Courier,monospace;font-weight:400}:not(.ML__latex)+.ML__latex{margin-left:.25em}.ML__latex+:not(.ML__latex){padding-left:.25em}.ML__suggestion{opacity:.5}.ML__virtual-keyboard-toggle.is-visible.is-pressed:hover{fill:currentColor;background:hsl(var(--hue,212),25%,35%);color:#fafafa}.ML__virtual-keyboard-toggle:focus{border:2px solid var(--primary,hsl(var(--hue,212),40%,50%));border-radius:8px;outline:none}.ML__virtual-keyboard-toggle.is-active,.ML__virtual-keyboard-toggle.is-active:hover,.ML__virtual-keyboard-toggle.is-pressed{fill:currentColor;background:hsl(var(--hue,212),25%,35%);color:#fafafa}.ML__scroller{height:100vh;position:fixed;top:0;width:200px;z-index:1}[data-ML__tooltip]{position:relative}[data-ML__tooltip][data-placement=top]:after{bottom:100%;top:inherit}[data-ML__tooltip]:after{background:#616161;border-radius:2px;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12),0 3px 1px -2px rgba(0,0,0,.2);color:#fff;content:attr(data-ML__tooltip);display:none;font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;font-size:12px;font-weight:400;max-width:200px;opacity:0;padding:8px;position:absolute;text-align:center;top:110%;transform:scale(.5);transition:all .15s cubic-bezier(.4,0,1,1);width:max-content;z-index:2}@media only screen and (max-width:767px){[data-ML__tooltip]:after{font-size:14px;padding:8px 16px}}:not(.tracking) [data-ML__tooltip]:hover{position:relative}:not(.tracking) [data-ML__tooltip]:hover:after{display:inline-table;opacity:1;transform:scale(1);visibility:visible}[data-ML__tooltip][data-delay]:after{transition-delay:0s}[data-ML__tooltip][data-delay]:hover:after{transition-delay:1s}';
var hs, ps;
new ( /*#__PURE__*/function (_cn3) {
  _inherits(_class6, _cn3);
  var _super36 = _createSuper(_class6);
  function _class6() {
    _classCallCheck(this, _class6);
    return _super36.call(this, "text");
  }
  _createClass(_class6, [{
    key: "onPaste",
    value: function onPaste(e, t) {
      if (!t.clipboardData) return !1;
      var i = t.clipboardData.getData("text/plain");
      return !!i && (e.snapshot(), this.insert(e.model, i) && rn(e), t.preventDefault(), t.stopPropagation(), !0);
    }
  }, {
    key: "insert",
    value: function insert(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var r;
      i.insertionMode || (i.insertionMode = "replaceSelection"), i.selectionMode || (i.selectionMode = "placeholder"), i.format || (i.format = "auto"), i.macros = null !== (r = i.macros) && void 0 !== r ? r : e.options.macros;
      var n = e.suppressChangeNotifications;
      i.suppressChangeNotifications && (e.suppressChangeNotifications = !0);
      var a = e.suppressChangeNotifications;
      e.suppressChangeNotifications = !0, "replaceSelection" !== i.insertionMode || e.selectionIsCollapsed ? "replaceAll" === i.insertionMode ? (e.root.setChildren([], "body"), e.position = 0) : "insertBefore" === i.insertionMode ? e.collapseSelection("backward") : "insertAfter" === i.insertionMode && e.collapseSelection("forward") : e.position = e.deleteAtoms(sn(e.selection));
      var o = function (e) {
        return zt(e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = e.replace(/\\/g, "\\textbackslash ")).replace(/#/g, "\\#")).replace(/\$/g, "\\$")).replace(/%/g, "\\%")).replace(/&/g, "\\&")).replace(/_/g, "\\_")).replace(/{/g, "\\textbraceleft ")).replace(/}/g, "\\textbraceright ")).replace(/\^/g, "\\textasciicircum ")).replace(/~/g, "\\textasciitilde ")).replace(/\xa3/g, "\\textsterling "), {
          parseMode: "text",
          registers: {}
        });
      }(t);
      if (xo(o, i.style), !o) return !1;
      var s = e.at(e.position),
        l = s.parent.addChildrenAfter(o, s);
      return e.suppressChangeNotifications = a, "before" === i.selectionMode || ("item" === i.selectionMode ? e.setSelection(e.anchor, e.offsetOf(l)) : l && (e.position = e.offsetOf(l))), dn(e), e.suppressChangeNotifications = n, !0;
    }
  }]);
  return _class6;
}(cn))();
var ms = /*#__PURE__*/function () {
  function ms(e, t) {
    var _this46 = this;
    _classCallCheck(this, ms);
    var i, r, n;
    this.eventHandlingInProgress = "", this.stylesheets = [], this.options = Zn(Yn(), t.readOnly ? _objectSpread(_objectSpread({}, t), {}, {
      virtualKeyboardMode: "off"
    }) : _objectSpread({
      plonkSound: "plonk.wav",
      keypressSound: {
        spacebar: "keypress-spacebar.wav",
        return: "keypress-return.wav",
        delete: "keypress-delete.wav",
        default: "keypress-standard.wav"
      }
    }, t)), this.macros = this.options.macros, this._placeholders = new Map(), this.colorMap = function (e) {
      var t;
      return "function" == typeof _this46.options.colorMap && (t = _this46.options.colorMap(e)), t || (t = s(e)), t;
    }, this.backgroundColorMap = function (e) {
      var t;
      return "function" == typeof _this46.options.backgroundColorMap && (t = _this46.options.backgroundColorMap(e)), t || "function" != typeof _this46.options.colorMap || (t = _this46.options.colorMap(e)), t || (t = l(e)), t;
    }, this.options.readOnly || (this.virtualKeyboard = t.useSharedVirtualKeyboard ? new Jn({
      targetOrigin: this.options.sharedVirtualKeyboardTargetOrigin,
      originValidator: this.options.originValidator,
      mathfield: this
    }) : new Mn(this.options, this)), this.plonkSound = this.options.plonkSound, this.options.keypressSound ? !this.options.keypressSound || "string" == typeof this.options.keypressSound || this.options.keypressSound instanceof HTMLAudioElement || (this.keypressSound = this.options.keypressSound.default, this.spacebarKeypressSound = this.options.keypressSound.spacebar, this.returnKeypressSound = this.options.keypressSound.return, this.deleteKeypressSound = this.options.keypressSound.delete) : (this.keypressSound = null, this.spacebarKeypressSound = null, this.returnKeypressSound = null, this.deleteKeypressSound = null), this.element = e, e.mathfield = this;
    var a = null !== (i = t.value) && void 0 !== i ? i : this.element.textContent;
    a && (a = a.trim()), oi(this.options.fontsDirectory, this.options.onError), hs || (hs = yi(li).toString(36)), this.stylesheets.push(si(e, li, hs)), ps || (ps = yi(ds).toString(36)), this.stylesheets.push(si(e, ds, ps));
    var o = "";
    if (o += "<span class='ML__textarea'>", o += _e() ? '<span class=\'ML__textarea__textarea\' tabindex="-1" role="textbox"></span>' : "<textarea class=\"ML__textarea__textarea\" autocapitalize=\"off\" autocomplete=\"off\" autocorrect=\"off\" spellcheck=\"false\" aria-hidden=\"true\" tabindex=\"".concat(null !== (r = e.tabIndex) && void 0 !== r ? r : 0, "\"></textarea>"), o += "</span>", o += '<span class="ML__fieldcontainer"><span class="ML__fieldcontainer__field"></span>', o += "<div part='virtual-keyboard-toggle' class=\"ML__virtual-keyboard-toggle\" role=\"button\" data-ML__tooltip=\"".concat(gr("tooltip.toggle virtual keyboard"), "\">"), o += null !== (n = this.options.virtualKeyboardToggleGlyph) && void 0 !== n ? n : Xn, o += "</div>", o += "<div class='ML__placeholdercontainer'></div>", o += "</span>", o += '<div class="ML__sr-only"><span aria-live="assertive" aria-atomic="true"></span><span></span></div>', this.element.innerHTML = this.options.createHTML(o), !this.element.children) return;
    var c = 0;
    var u = this.element.children[c++].firstElementChild;
    this.field = this.element.children[c].children[0], this.field.addEventListener("wheel", function (e) {
      var t = -e.deltaX;
      Number.isFinite(t) && 0 !== t && (_this46.field.scrollBy({
        top: 0,
        left: 5 * -t
      }), e.preventDefault(), e.stopPropagation());
    }, {
      passive: !1
    }), c++, this.virtualKeyboardToggle = this.element.querySelector(".ML__virtual-keyboard-toggle"), this.options.readOnly || "manual" !== this.options.virtualKeyboardMode ? this.virtualKeyboardToggle.classList.remove("is-visible") : this.virtualKeyboardToggle.classList.add("is-visible"), this.options.readOnly ? this.element.classList.add("ML__isReadOnly") : this.element.classList.remove("ML__isReadOnly"), "inline-math" === this.options.defaultMode ? this.element.classList.add("ML__isInline") : this.element.classList.remove("ML__isInline"), Nr(function (e) {
      return _this46.executeCommand(e);
    }, this.virtualKeyboardToggle, {
      default: "toggleVirtualKeyboard",
      alt: "toggleVirtualKeyboardAlt",
      shift: "toggleVirtualKeyboardShift"
    }), this.ariaLiveText = this.element.children[c].children[0], this.accessibleNode = this.element.children[c++].children[1], this.keystrokeCaptionVisible = !1, this.popoverVisible = !1, this.suggestionIndex = 0, this.keystrokeBuffer = "", this.keystrokeBufferStates = [], this.keystrokeBufferResetTimer = 0, this.mode = Qn(this.options), this.smartModeSuppressed = !1, this.style = {}, this.blurred = !0, yr(this.element, "focus", this), yr(this.element, "blur", this), this.keyboardDelegate = function (e, t) {
      var i,
        r = null,
        n = null,
        a = !1,
        o = !1,
        s = !1;
      function l(e) {
        clearTimeout(i), i = setTimeout(function () {
          clearTimeout(i), e();
        });
      }
      function c() {
        if (e.selectionStart !== e.selectionEnd) return;
        var i = e.value;
        e.value = "", i.length > 0 && t.typedText(i);
      }
      var u = e;
      return u.addEventListener("keydown", function (i) {
        a || "Process" === i.key || "CapsLock" === i.code || /(Control|Meta|Alt|Shift)(Left|Right)/.test(i.code) ? r = null : (r = i, n = null, t.keystroke(To(i), i) ? _e() && t.typedText(i.key) : (r = null, e.value = ""));
      }, !0), u.addEventListener("keypress", function (e) {
        a || a || (r && n && t.keystroke(To(r), r), n = e, l(c));
      }, !0), u.addEventListener("keyup", function () {
        a || r && !n && c();
      }, !0), u.addEventListener("paste", function (i) {
        e.focus(), e.value = "", t.paste(i);
      }, !0), u.addEventListener("cut", function (e) {
        return t.cut(e);
      }, !0), u.addEventListener("copy", function (e) {
        return t.copy(e);
      }, !0), u.addEventListener("blur", function (e) {
        if (e.relatedTarget === e.target.getRootNode().host) return e.preventDefault(), void e.stopPropagation();
        s || o || (s = !0, r = null, n = null, t.blur && t.blur(), s = !1);
      }, !0), u.addEventListener("focus", function (e) {
        s || o || (o = !0, t.focus && t.focus(), o = !1);
      }, !0), u.addEventListener("compositionstart", function (i) {
        a = !0, e.value = "", t.compositionStart && t.compositionStart(i.data);
      }, !0), u.addEventListener("compositionupdate", function (e) {
        a && t.compositionUpdate && t.compositionUpdate(e.data);
      }, !0), u.addEventListener("compositionend", function (i) {
        e.value = "", a && (a = !1, t.compositionEnd && t.compositionEnd(i.data));
      }, !0), u.addEventListener("input", function (e) {
        if (!a && "insertCompositionText" !== e.inputType) {
          if ("insertFromPaste" === e.inputType) return e.preventDefault(), void e.stopPropagation();
          l(c), e.preventDefault(), e.stopPropagation();
        }
      }), {
        cancelComposition: function cancelComposition() {
          var i = t.blur,
            r = t.focus;
          t.blur = null, t.focus = null, e.blur(), e.focus(), t.blur = i, t.focus = r;
        },
        blur: function blur() {
          "function" == typeof e.blur && e.blur();
        },
        focus: function focus() {
          "function" == typeof e.focus && e.focus();
        },
        hasFocus: function hasFocus() {
          return Oo() === e;
        },
        setValue: function setValue(t) {
          t ? (e.value = t, Oo() === e && e.select && e.select()) : (e.value = "", e.setAttribute("aria-label", ""));
        },
        setAriaLabel: function setAriaLabel(t) {
          e.setAttribute("aria-label", "after: " + t);
        },
        moveTo: function moveTo(t, i) {
          e.style.top = "".concat(i, "px"), e.style.left = "".concat(t, "px");
        }
      };
    }(u, {
      typedText: function typedText(e) {
        return is(_this46, e);
      },
      cut: function cut(e) {
        _this46.options.readOnly ? _this46.model.announce("plonk") : (_this46.snapshot(), setTimeout(function () {
          yo(_this46.model, sn(_this46.model.selection)), rn(_this46);
        }, 0));
      },
      copy: function copy(e) {
        return cn.onCopy(_this46, e);
      },
      paste: function paste(e) {
        _this46.options.readOnly ? _this46.model.announce("plonk") : cn.onPaste(_this46.model.at(_this46.model.position).mode, _this46, e);
      },
      keystroke: function keystroke(e, t) {
        return ts(_this46, e, t);
      },
      focus: function focus() {
        return _this46.onFocus();
      },
      blur: function blur() {
        return _this46.onBlur();
      },
      compositionStart: function compositionStart(e) {
        return _this46.onCompositionStart(e);
      },
      compositionUpdate: function compositionUpdate(e) {
        return _this46.onCompositionUpdate(e);
      },
      compositionEnd: function compositionEnd(e) {
        return _this46.onCompositionEnd(e);
      }
    }), window.PointerEvent ? yr(this.field, "pointerdown", this) : yr(this.field, "touchstart:active mousedown", this), yr(window, "resize", this), this.model = new uo({
      mode: Qn(this.options),
      macros: this.macros,
      removeExtraneousParentheses: this.options.removeExtraneousParentheses
    }, {
      onContentDidChange: function onContentDidChange(e) {
        return _this46.options.onContentDidChange(_this46);
      },
      onSelectionDidChange: function onSelectionDidChange(e) {
        return _this46._onSelectionDidChange();
      },
      onContentWillChange: function onContentWillChange() {
        return _this46.options.onContentWillChange(_this46);
      },
      onSelectionWillChange: function onSelectionWillChange() {
        return _this46.options.onSelectionWillChange(_this46);
      },
      onError: this.options.onError,
      onPlaceholderDidChange: function onPlaceholderDidChange(e, t) {
        return _this46.options.onPlaceholderDidChange(_this46, t);
      }
    }, {
      announce: function announce(e, t, i, r) {
        var n, a;
        return null === (a = (n = _this46.options).onAnnounce) || void 0 === a ? void 0 : a.call(n, _this46, t, i, r);
      },
      moveOut: function moveOut(e, t) {
        return _this46.options.onMoveOutOf(_this46, t);
      },
      tabOut: function tabOut(e, t) {
        return _this46.options.onTabOutOf(_this46, t);
      }
    }, this), this.undoManager = new Ko(this.model), a && cn.insert("math", this.model, a, {
      insertionMode: "replaceAll",
      selectionMode: "after",
      format: "latex",
      suppressChangeNotifications: !0,
      macros: this.options.macros
    }), this.undoManager.startRecording(), this.undoManager.snapshot(this.options), this.model.setListeners({
      onContentDidChange: function onContentDidChange(e) {
        return _this46.options.onContentDidChange(_this46);
      },
      onSelectionDidChange: function onSelectionDidChange(e) {
        return _this46._onSelectionDidChange();
      },
      onContentWillChange: function onContentWillChange() {
        return _this46.options.onContentWillChange(_this46);
      },
      onSelectionWillChange: function onSelectionWillChange() {
        return _this46.options.onSelectionWillChange(_this46);
      },
      onError: this.options.onError,
      onPlaceholderDidChange: function onPlaceholderDidChange(e, t) {
        return _this46.options.onPlaceholderDidChange(_this46, t);
      }
    }), this.model.setHooks({
      announce: function announce(e, t, i, r) {
        var n, a;
        return null === (a = (n = _this46.options).onAnnounce) || void 0 === a ? void 0 : a.call(n, _this46, t, i, r);
      },
      moveOut: function moveOut(e, t) {
        return _this46.options.onMoveOutOf(_this46, t);
      },
      tabOut: function tabOut(e, t) {
        return _this46.options.onTabOutOf(_this46, t);
      }
    }), this.options.locale.startsWith(Ki().locale) || Bi(this.options.locale), rn(this), ke() && document.fonts.ready.then(function () {
      return nn(_this46);
    });
  }
  _createClass(ms, [{
    key: "virtualKeyboardState",
    get: function get() {
      var e;
      return (null === (e = this.virtualKeyboard) || void 0 === e ? void 0 : e.visible) ? "visible" : "hidden";
    },
    set: function set(e) {
      this.virtualKeyboard && ("hidden" === e ? this.virtualKeyboard.executeCommand("hideVirtualKeyboard") : "visible" === e && this.virtualKeyboard.executeCommand("showVirtualKeyboard"));
    }
  }, {
    key: "keybindings",
    get: function get() {
      var _this47 = this;
      var e;
      return this._keybindings || (this._keybindings = function (e, t, i) {
        var r = [],
          n = [];
        var _iterator120 = _createForOfIteratorHelper(e),
          _step120;
        try {
          var _loop4 = function _loop4() {
            var i = _step120.value;
            try {
              var _e229 = Pi(i, t);
              if (_e229) {
                var _n58 = r.filter(function (t) {
                  return t.key === _e229.key && t.ifMode === _e229.ifMode;
                });
                if (_n58.length > 0) throw new Error("Ambiguous key binding ".concat(i.key, " (").concat(Ii(i.command), ") matches ").concat(_n58[0].key, " (").concat(Ii(_n58[0].command), ") with the ").concat(t.displayName, " keyboard layout"));
                r.push(_e229);
              }
            } catch (e) {
              e instanceof Error && n.push(e.message);
            }
          };
          for (_iterator120.s(); !(_step120 = _iterator120.n()).done;) {
            _loop4();
          }
        } catch (err) {
          _iterator120.e(err);
        } finally {
          _iterator120.f();
        }
        return n.length > 0 && i(n), r;
      }(this.options.keybindings, null !== (e = Ki()) && void 0 !== e ? e : zi, function (e) {
        "function" == typeof _this47.options.onError && _this47.options.onError({
          code: "invalid-keybinding",
          arg: e.join("\n")
        });
      })), this._keybindings;
    }
  }, {
    key: "setOptions",
    value: function setOptions(e) {
      var _this48 = this;
      var t, i, r, n;
      if (this.options = Zn(this.options, e), this.model.setListeners({
        onContentDidChange: function onContentDidChange(e) {
          return _this48.options.onContentDidChange(_this48);
        },
        onSelectionDidChange: function onSelectionDidChange(e) {
          return _this48._onSelectionDidChange();
        },
        onContentWillChange: function onContentWillChange() {
          return _this48.options.onContentWillChange(_this48);
        },
        onSelectionWillChange: function onSelectionWillChange() {
          return _this48.options.onSelectionWillChange(_this48);
        },
        onError: this.options.onError,
        onPlaceholderDidChange: function onPlaceholderDidChange(e, t) {
          return _this48.options.onPlaceholderDidChange(_this48, t);
        }
      }), this.model.setHooks({
        announce: function announce(e, t, i, r) {
          var n, a;
          return null === (a = (n = _this48.options).onAnnounce) || void 0 === a ? void 0 : a.call(n, _this48, t, i, r);
        },
        moveOut: function moveOut(e, t) {
          return _this48.options.onMoveOutOf(_this48, t);
        },
        tabOut: function tabOut(e, t) {
          return _this48.options.onTabOutOf(_this48, t);
        }
      }), this.options.locale.startsWith(Ki().locale) || Bi(this.options.locale), this._keybindings = void 0, this.plonkSound = this.options.plonkSound, !this.options.keypressSound || "string" == typeof this.options.keypressSound || this.options.keypressSound instanceof HTMLAudioElement || (this.keypressSound = this.options.keypressSound.default, this.spacebarKeypressSound = this.options.keypressSound.spacebar, this.returnKeypressSound = this.options.keypressSound.return, this.deleteKeypressSound = this.options.keypressSound.delete), this.options.readOnly ? (this.onBlur(), this.element.classList.add("ML__isReadOnly")) : this.element.classList.remove("ML__isReadOnly"), "inline-math" === this.options.defaultMode ? this.element.classList.add("ML__isInline") : this.element.classList.remove("ML__isInline"), null === (t = this.virtualKeyboard) || void 0 === t || t.setOptions(this.options), this.options.readOnly || "manual" !== this.options.virtualKeyboardMode ? null === (r = this.virtualKeyboardToggle) || void 0 === r || r.classList.remove("is-visible") : null === (i = this.virtualKeyboardToggle) || void 0 === i || i.classList.add("is-visible"), "virtualKeyboardToggleGlyph" in e) {
        var _e230 = null === (n = this.element) || void 0 === n ? void 0 : n.querySelector(".ML__virtual-keyboard-toggle");
        _e230 && (_e230.innerHTML = this.options.createHTML(this.options.virtualKeyboardToggleGlyph));
      }
      this.colorMap = function (e) {
        var t;
        return "function" == typeof _this48.options.colorMap && (t = _this48.options.colorMap(e)), t || (t = s(e)), t;
      }, this.backgroundColorMap = function (e) {
        var t;
        return "function" == typeof _this48.options.backgroundColorMap && (t = _this48.options.backgroundColorMap(e)), t || "function" != typeof _this48.options.colorMap || (t = _this48.options.colorMap(e)), t || (t = l(e)), t;
      };
      var a = rt.serialize(this.model.root, {
        expandMacro: !1,
        defaultMode: this.options.defaultMode
      });
      ("macros" in e || this.model.getValue() !== a) && cn.insert("math", this.model, a, {
        insertionMode: "replaceAll",
        selectionMode: "after",
        format: "latex",
        suppressChangeNotifications: !0,
        macros: this.options.macros
      }), rn(this);
    }
  }, {
    key: "getOptions",
    value: function getOptions(e) {
      return Gn(this.options, e);
    }
  }, {
    key: "getOption",
    value: function getOption(e) {
      return Gn(this.options, e);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      var _this49 = this;
      switch (e.type) {
        case "focus":
          this.eventHandlingInProgress || (this.eventHandlingInProgress = "focus", this.onFocus(), this.eventHandlingInProgress = "");
          break;
        case "blur":
          this.eventHandlingInProgress || (this.eventHandlingInProgress = "blur", this.onBlur(), this.eventHandlingInProgress = "");
          break;
        case "touchstart":
        case "mousedown":
        case "pointerdown":
          !function (e, t) {
            var i;
            e._atomBoundsCache = new Map();
            var r = e;
            var n,
              a = !1,
              o = "none";
            if (t instanceof PointerEvent && 1 !== t.buttons && 0 !== t.buttons) return;
            var s = !1,
              l = !1;
            var c = os(t) ? t.touches[0].clientX : t.clientX,
              u = os(t) ? t.touches[0].clientY : t.clientY,
              d = Date.now(),
              h = r.field,
              p = setInterval(function () {
                s ? h.scroll({
                  top: 0,
                  left: h.scrollLeft - 16
                }) : l && h.scroll({
                  top: 0,
                  left: h.scrollLeft + 16
                });
              }, 32);
            function m(t) {
              window.PointerEvent ? (br(h, "pointermove", f), br(h, "pointerup pointercancel", m), t instanceof PointerEvent && h.releasePointerCapture(t.pointerId)) : (br(h, "touchmove", f), br(h, "touchcancel touchend", m), br(window, "mousemove", f), br(window, "mouseup blur", m)), a = !1, clearInterval(p), e.element.classList.remove("tracking"), t && (t.preventDefault(), t.stopPropagation());
            }
            function f(t) {
              if (!r.hasFocus()) return void m(null);
              var i = os(t) ? t.touches[0].clientX : t.clientX,
                a = os(t) ? t.touches[0].clientY : t.clientY,
                o = os(t) || "touch" === t.pointerType ? 20 : 5;
              if (Date.now() < d + 500 && Math.abs(c - i) < o && Math.abs(u - a) < o) return t.preventDefault(), void t.stopPropagation();
              var p = h.getBoundingClientRect();
              l = i > p.right, s = i < p.left;
              var f = n;
              t instanceof PointerEvent ? t.isPrimary || (f = us(r, t.clientX, t.clientY, {
                bias: 0
              })) : t.touches && 2 === t.touches.length && (f = us(r, t.touches[1].clientX, t.touches[1].clientY, {
                bias: 0
              }));
              var g = us(r, i, a, {
                bias: i <= c ? i === c ? 0 : -1 : 1
              });
              f >= 0 && g >= 0 && (r.model.extendSelectionTo(f, g), rn(e)), t.preventDefault(), t.stopPropagation();
            }
            ns && Math.abs(ns.x - c) < 5 && Math.abs(ns.y - u) < 5 && Date.now() < ns.time + 500 ? (as += 1, ns.time = d) : (ns = {
              x: c,
              y: u,
              time: d
            }, as = 1);
            var g = h.getBoundingClientRect();
            if (c >= g.left && c <= g.right && u >= g.top && u <= g.bottom) {
              if (e.hasFocus() || (o = "all", e.keyboardDelegate.focus()), e.resetKeystrokeBuffer(), e.smartModeSuppressed = !1, n = us(e, c, u, {
                bias: 0
              }), n >= 0) {
                if (e.element.classList.add("tracking"), t.shiftKey) {
                  var _t192 = e.model.selectionIsCollapsed;
                  e.model.extendSelectionTo(e.model.anchor, n), o = fn(e.model) || _t192 ? "all" : "selection";
                } else "placeholder" === e.model.at(n).type ? (e.model.setSelection(n - 1, n), o = "selection") : "placeholder" === (null === (i = e.model.at(n).rightSibling) || void 0 === i ? void 0 : i.type) ? (e.model.setSelection(n, n + 1), o = "selection") : (e.model.position = n, o = fn(e.model) ? "all" : "selection");
                e.style = {}, 3 === t.detail || as > 2 ? (m(t), 3 !== t.detail && 3 !== as || (e.model.selection = {
                  ranges: [[0, e.model.lastOffset]]
                }, o = "all")) : a || (a = !0, window.PointerEvent ? (yr(h, "pointermove", f), yr(h, "pointerup pointercancel", m), t instanceof PointerEvent && h.setPointerCapture(t.pointerId)) : (yr(window, "blur", m), os(t) && t.touches ? (yr(t.target, "touchmove", f), yr(t.target, "touchcancel touchend", m)) : (yr(window, "mousemove", f), yr(window, "mouseup", m))), 2 !== t.detail && 2 !== as || (qo(e.model), o = "all"));
              }
            } else ns = null;
            "none" !== o && (e.model.selectionIsCollapsed && (o = "all"), rn(e)), t.preventDefault();
          }(this, e);
          break;
        case "resize":
          this.resizeTimer && cancelAnimationFrame(this.resizeTimer), this.resizeTimer = requestAnimationFrame(function () {
            return kr(_this49) && _this49.onResize();
          });
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      kr(this) && (br(this.element, "pointerdown", this), br(this.element, "touchstart:active mousedown", this), br(this.element, "focus", this), br(this.element, "blur", this), br(window, "resize", this), this.element.innerHTML = this.getValue(), delete this.element.mathfield, delete this.accessibleNode, delete this.ariaLiveText, delete this.field, delete this.fieldContent, delete this.keyboardDelegate, this.virtualKeyboardToggle.remove(), delete this.virtualKeyboardToggle, this.virtualKeyboard && (this.virtualKeyboard.dispose(), delete this.virtualKeyboard), xr(this.popover), Gr && Gr.release(), Xr && Xr.release(), delete this.popover, xr(this.keystrokeCaption), Qo && Qo.release(), Jo && Jo.release(), delete this.keystrokeCaption, delete this.element, this.stylesheets.forEach(function (e) {
        return null == e ? void 0 : e.release();
      }));
    }
  }, {
    key: "resetKeystrokeBuffer",
    value: function resetKeystrokeBuffer(e) {
      var _this50 = this;
      (e = null != e ? e : {
        defer: !1
      }).defer ? this.options.inlineShortcutTimeout > 0 && (this.keystrokeBufferResetTimer = setTimeout(function () {
        _this50.resetKeystrokeBuffer();
      }, this.options.inlineShortcutTimeout)) : (this.keystrokeBuffer = "", this.keystrokeBufferStates = [], clearTimeout(this.keystrokeBufferResetTimer));
    }
  }, {
    key: "executeCommand",
    value: function executeCommand(t) {
      var i, r;
      return "virtual-keyboard" === vn(t) ? null !== (r = null === (i = this.virtualKeyboard) || void 0 === i ? void 0 : i.executeCommand(t)) && void 0 !== r && r : function (t, i) {
        var r, n, a;
        if (!i) return !1;
        var o,
          s = [],
          l = !1,
          c = !1;
        e(i) ? (o = i[0], s = i.slice(1)) : o = i, o = o.replace(/-\w/g, function (e) {
          return e[1].toUpperCase();
        });
        var u = null === (r = yn[o]) || void 0 === r ? void 0 : r.target;
        if ("model" === u) {
          var _yn$o;
          if (t.options.readOnly && /^(paste|cut|insert|delete|transpose|add)/.test(o)) return t.model.announce("plonk"), !1;
          /^(delete|transpose|add)/.test(o) && "deleteBackward" !== o && t.resetKeystrokeBuffer(), /^(delete|transpose|add)/.test(o) && "latex" !== t.mode && (t.popUndoStack(), t.snapshot()), (_yn$o = yn[o]).fn.apply(_yn$o, [t.model].concat(_toConsumableArray(s))), /^(delete|transpose|add)/.test(o) && "latex" !== t.mode && t.snapshot(), "latex" === t.mode && mn(t), c = !0, l = !0;
        } else if ("virtual-keyboard" === u) c = null !== (a = null === (n = t.virtualKeyboard) || void 0 === n ? void 0 : n.executeCommand(i)) && void 0 !== a && a, l = !0;else {
          var _yn$o2;
          if (!yn[o]) throw new Error('Unknown command "' + o + '"');
          c = (_yn$o2 = yn[o]).fn.apply(_yn$o2, [t].concat(_toConsumableArray(s))), l = !0;
        }
        return "virtual-keyboard" !== u && (t.model.selectionIsCollapsed && !/^(transpose|paste|complete|((moveToNextChar|moveToPreviousChar|extend).*))_$/.test(o) || (t.resetKeystrokeBuffer(), t.style = {})), c && rn(t), l;
      }(this, t);
    }
  }, {
    key: "lastOffset",
    get: function get() {
      return this.model.lastOffset;
    }
  }, {
    key: "selection",
    get: function get() {
      return this.model.selection;
    },
    set: function set(e) {
      this.model.selection = e;
    }
  }, {
    key: "getValue",
    value: function getValue(e, t, i) {
      return this.model.getValue(e, t, i);
    }
  }, {
    key: "setValue",
    value: function setValue(e, t) {
      var i;
      void 0 === (t = null != t ? t : {
        mode: "math"
      }).insertionMode && (t.insertionMode = "replaceAll"), void 0 !== t.format && "auto" !== t.format || (t.format = "latex");
      var r = "math";
      void 0 !== t.mode && "auto" !== t.mode || (r = null !== (i = vo(this.model, this.model.position)) && void 0 !== i ? i : "math"), cn.insert(r, this.model, e, _objectSpread(_objectSpread({}, t), {}, {
        colorMap: this.colorMap,
        backgroundColorMap: this.backgroundColorMap
      })) && (this.undoManager.snapshot(this.options), rn(this));
    }
  }, {
    key: "find",
    value: function find(e, t) {
      return function (e, t, i) {
        return $o(e, e.root, "body", t, i).sort(function (e, t) {
          return t[0] === e[0] ? t[1] - e[1] : t[0] - e[0];
        });
      }(this.model, e, t);
    }
  }, {
    key: "replace",
    value: function replace(e, t, i) {
      !function (e, t, i, r) {
        Io(e, e.root, "body", t, i, r), e.position = e.normalizeOffset(e.position);
      }(this.model, e, t, i);
    }
  }, {
    key: "getPlaceholderField",
    value: function getPlaceholderField(e) {
      var t;
      return null === (t = this._placeholders.get(e)) || void 0 === t ? void 0 : t.field;
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView() {
      var e;
      this.dirty && nn(this);
      var t = this.field.getBoundingClientRect();
      var i;
      if (this.model.selectionIsCollapsed) i = null === (e = wr(this.field)) || void 0 === e ? void 0 : e.x;else {
        var _e231 = Cr(this);
        if (_e231.length > 0) {
          var _r69 = -1 / 0;
          var _iterator121 = _createForOfIteratorHelper(_e231),
            _step121;
          try {
            for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
              var _t193 = _step121.value;
              _t193.right > _r69 && (_r69 = _t193.right);
            }
          } catch (err) {
            _iterator121.e(err);
          } finally {
            _iterator121.f();
          }
          i = _r69 + t.left - this.field.scrollLeft;
        }
      }
      if (void 0 !== i) {
        var _e232 = i - window.scrollX;
        _e232 < t.left ? this.field.scroll({
          top: 0,
          left: _e232 - t.left + this.field.scrollLeft - 20,
          behavior: "smooth"
        }) : _e232 > t.right && this.field.scroll({
          top: 0,
          left: _e232 - t.right + this.field.scrollLeft + 20,
          behavior: "smooth"
        });
      }
    }
  }, {
    key: "insert",
    value: function insert(e, t) {
      var i;
      if ("string" == typeof e && e.length > 0) {
        if ((t = null != t ? t : {
          mode: "math"
        }).focus && this.focus(), t.feedback && (this.options.keypressVibration && Me() && navigator.vibrate(3), null === (i = this.keypressSound) || void 0 === i || i.play().catch(console.warn)), t.scrollIntoView && this.scrollIntoView(), "\\\\" === e) mo(this.model);else if ("&" === e) fo(this.model);else {
          var _i177 = this.style;
          cn.insert(this.mode, this.model, e, _objectSpread({
            style: this.model.at(this.model.position).computedStyle
          }, t)), t.resetStyle && (this.style = _i177);
        }
        return this.undoManager.snapshot(this.options), rn(this), !0;
      }
      return !1;
    }
  }, {
    key: "switchMode",
    value: function switchMode(e) {
      var _this51 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      if (this.mode === e || this.options.readOnly) return;
      var r = this.model;
      r.deferNotifications({
        content: Boolean(i) || Boolean(t),
        selection: !0
      }, function () {
        var n;
        var a = !1;
        if (_this51.resetKeystrokeBuffer(), _this51.smartModeSuppressed = /text|math/.test(_this51.mode) && /text|math/.test(e), t && "latex" !== e) {
          var _i178 = zt(t, {
            parseMode: {
              math: "text",
              text: "math"
            }[e]
          });
          r.collapseSelection("forward");
          var _n59 = r.at(r.position);
          r.position = r.offsetOf(_n59.parent.addChildrenAfter(_i178, _n59)), a = !0;
        }
        if (_this51.mode = e, "latex" === e) {
          var _e233,
            _i179 = r.selectionIsCollapsed;
          gn(_this51, "accept"), (null === (n = _this51.virtualKeyboard) || void 0 === n ? void 0 : n.visible) && _this51.executeCommand(["switchKeyboardLayer", "latex-lower"]);
          var _a35 = r.at(r.position);
          if (_i179) _e233 = "\\";else {
            var _n60 = sn(r.selection);
            _e233 = _this51.model.getValue(_n60, "latex");
            var _o25 = _this51.model.extractAtoms(_n60);
            1 === _o25.length && _o25[0] instanceof Mt && (_e233 = t, _i179 = !0), _a35 = r.at(_n60[0]);
          }
          var _o26 = new Pr(_e233);
          _a35.parent.addChildAfter(_o26, _a35), _i179 ? r.position = r.offsetOf(_o26.lastChild) : r.setSelection(r.offsetOf(_o26.firstChild), r.offsetOf(_o26.lastChild));
        } else hn(r).forEach(function (e) {
          e.isError = !1;
        });
        if (i) {
          var _t194 = zt(i, {
            parseMode: {
              math: "text",
              text: "math"
            }[e]
          });
          r.collapseSelection("forward");
          var _n61 = r.at(r.position);
          r.position = r.offsetOf(_n61.parent.addChildrenAfter(_t194, _n61)), a = !0;
        }
        return "function" == typeof _this51.options.onModeChange && _this51.options.onModeChange(_this51, _this51.mode), rn(_this51), a;
      });
    }
  }, {
    key: "hasFocus",
    value: function hasFocus() {
      return ke() && document.hasFocus() && this.keyboardDelegate.hasFocus();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.hasFocus() || (this.keyboardDelegate.focus(), this.model.announce("line"));
    }
  }, {
    key: "blur",
    value: function blur() {
      this.hasFocus() && this.keyboardDelegate.blur();
    }
  }, {
    key: "select",
    value: function select() {
      this.model.selection = {
        ranges: [[0, this.model.lastOffset]]
      };
    }
  }, {
    key: "applyStyle",
    value: function applyStyle(e) {
      var _this52 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i, r;
      var n = {
        operation: "set",
        suppressChangeNotifications: !1
      };
      ia(t) ? n.range = t : (n.range = t.range, n.suppressChangeNotifications = null !== (i = t.suppressChangeNotifications) && void 0 !== i && i);
      var a = rs(this, e),
        o = null !== (r = n.operation) && void 0 !== r ? r : "set";
      this.model.deferNotifications({
        content: !n.suppressChangeNotifications
      }, function () {
        void 0 === n.range ? _this52.model.selection.ranges.forEach(function (e) {
          return ko(_this52.model, e, a, {
            operation: o
          });
        }) : ko(_this52.model, n.range, a, {
          operation: o
        });
      }), rn(this);
    }
  }, {
    key: "getCaretPoint",
    value: function getCaretPoint() {
      var e = wr(this.field);
      return e ? {
        x: e.x,
        y: e.y
      } : null;
    }
  }, {
    key: "setCaretPoint",
    value: function setCaretPoint(e, t) {
      var i = us(this, e, t, {
        bias: 0
      });
      if (i < 0) return !1;
      var r = this.model.position;
      return this.model.position = i, this.model.announce("move", r), rn(this), !0;
    }
  }, {
    key: "attachNestedMathfield",
    value: function attachNestedMathfield() {
      var _this53 = this;
      var e = !1;
      this._placeholders.forEach(function (t) {
        var i, r, n, a, o, s, l, c, u, d;
        var h = null === (i = _this53.field) || void 0 === i ? void 0 : i.querySelector("[data-placeholder-id=".concat(t.atom.placeholderId, "]"));
        if (h) {
          var _i180 = h.getBoundingClientRect(),
            _p3 = null === (r = _this53.field) || void 0 === r ? void 0 : r.getBoundingClientRect(),
            _m2 = .6 * parseInt(window.getComputedStyle(h).fontSize);
          (!t.field.style.fontSize || Math.abs(_m2 - parseFloat(t.field.style.fontSize)) >= .2) && (e = !0, t.field.style.fontSize = "".concat(_m2, "px"));
          var _f = (null !== (n = null == _i180 ? void 0 : _i180.top) && void 0 !== n ? n : 0) - (null !== (a = null == _p3 ? void 0 : _p3.top) && void 0 !== a ? a : 0) + (null !== (s = null === (o = _this53.element) || void 0 === o ? void 0 : o.offsetTop) && void 0 !== s ? s : 0),
            _g2 = (null !== (l = null == _i180 ? void 0 : _i180.left) && void 0 !== l ? l : 0) - (null !== (c = null == _p3 ? void 0 : _p3.left) && void 0 !== c ? c : 0) + (null !== (d = null === (u = _this53.element) || void 0 === u ? void 0 : u.offsetLeft) && void 0 !== d ? d : 0);
          (!t.field.style.left || Math.abs(_g2 - parseFloat(t.field.style.left)) >= 1) && (e = !0, t.field.style.left = "".concat(_g2, "px")), (!t.field.style.top || Math.abs(_f - parseFloat(t.field.style.top)) >= 1) && (e = !0, t.field.style.top = "".concat(_f, "px"));
        }
      }), e && rn(this);
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return this.undoManager.canUndo();
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return this.undoManager.canRedo();
    }
  }, {
    key: "popUndoStack",
    value: function popUndoStack() {
      this.undoManager.pop();
    }
  }, {
    key: "snapshot",
    value: function snapshot() {
      var _this54 = this;
      this.undoManager.snapshot(_objectSpread(_objectSpread({}, this.options), {}, {
        onUndoStateDidChange: function onUndoStateDidChange(e, t) {
          var i;
          null === (i = _this54.virtualKeyboard) || void 0 === i || i.executeCommand(["onUndoStateChanged", _this54.canUndo(), _this54.canRedo()]), _this54.options.onUndoStateDidChange(e, t);
        }
      }));
    }
  }, {
    key: "snapshotAndCoalesce",
    value: function snapshotAndCoalesce() {
      var _this55 = this;
      this.undoManager.snapshotAndCoalesce(_objectSpread(_objectSpread({}, this.options), {}, {
        onUndoStateDidChange: function onUndoStateDidChange(e, t) {
          var i;
          null === (i = _this55.virtualKeyboard) || void 0 === i || i.executeCommand(["onUndoStateChanged", _this55.canUndo(), _this55.canRedo()]), _this55.options.onUndoStateDidChange(e, t);
        }
      }));
    }
  }, {
    key: "getUndoRecord",
    value: function getUndoRecord() {
      return this.undoManager.save();
    }
  }, {
    key: "restoreToUndoRecord",
    value: function restoreToUndoRecord(e) {
      this.undoManager.restore(e, _objectSpread(_objectSpread({}, this.options), {}, {
        suppressChangeNotifications: !0
      }));
    }
  }, {
    key: "undo",
    value: function undo() {
      var _this56 = this;
      return this.undoManager.undo(_objectSpread(_objectSpread({}, this.options), {}, {
        onUndoStateDidChange: function onUndoStateDidChange(e, t) {
          _this56.virtualKeyboard.executeCommand(["onUndoStateChanged", _this56.canUndo(), _this56.canRedo()]), _this56.options.onUndoStateDidChange(e, t);
        }
      }));
    }
  }, {
    key: "redo",
    value: function redo() {
      var _this57 = this;
      return this.undoManager.redo(_objectSpread(_objectSpread({}, this.options), {}, {
        onUndoStateDidChange: function onUndoStateDidChange(e, t) {
          var i;
          null === (i = _this57.virtualKeyboard) || void 0 === i || i.executeCommand(["onUndoStateChanged", _this57.canUndo(), _this57.canRedo()]), _this57.options.onUndoStateDidChange(e, t);
        }
      }));
    }
  }, {
    key: "_onSelectionDidChange",
    value: function _onSelectionDidChange() {
      var e, t;
      this.keyboardDelegate.setValue(this.getValue(this.model.selection, "latex-expanded"));
      var i = this.model.getAtoms(this.model.selection);
      if (1 === i.length && "placeholder" === i[0].type) {
        var _t195 = i[0];
        this.model.mathfield._placeholders.has(_t195.placeholderId) && (null === (e = this.model.mathfield._placeholders.get(_t195.placeholderId)) || void 0 === e || e.field.focus());
      }
      {
        var _e234 = this.model.at(this.model.position),
          _i181 = null !== (t = _e234.mode) && void 0 !== t ? t : Qn(this.options);
        this.mode !== _i181 && ("latex" === this.mode ? (gn(this, "accept", {
          mode: _i181
        }), this.model.position = this.model.offsetOf(_e234)) : this.switchMode(_i181));
      }
      "function" == typeof this.options.onSelectionDidChange && this.options.onSelectionDidChange(this);
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var e, t, i;
      this.blurred && (this.blurred = !1, this.keyboardDelegate.focus(), null === (e = this.virtualKeyboard) || void 0 === e || e.enable(), "onfocus" === this.options.virtualKeyboardMode && this.executeCommand("showVirtualKeyboard"), Qr(this), null === (i = (t = this.options).onFocus) || void 0 === i || i.call(t, this), this.valueOnFocus = this.getValue(), rn(this));
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      var e;
      this.blurred || (this.blurred = !0, this.ariaLiveText.textContent = "", /onfocus|manual/.test(this.options.virtualKeyboardMode) && this.executeCommand("hideVirtualKeyboard"), gn(this, "accept"), rn(this), "function" == typeof this.options.onBlur && this.options.onBlur(this), null === (e = this.virtualKeyboard) || void 0 === e || e.disable(), "function" == typeof this.options.onCommit && this.getValue() !== this.valueOnFocus && this.options.onCommit(this));
    }
  }, {
    key: "onCompositionStart",
    value: function onCompositionStart(e) {
      var _this58 = this;
      this.model.position = this.model.deleteAtoms(sn(this.model.selection)), requestAnimationFrame(function () {
        nn(_this58);
        var e = wr(_this58.field);
        e && _this58.keyboardDelegate.moveTo(e.x, e.y);
      });
    }
  }, {
    key: "onCompositionUpdate",
    value: function onCompositionUpdate(e) {
      !function (e, t) {
        var i = e.at(e.position);
        if ("composition" === i.type) i.value = t;else {
          var _r70 = i.caret;
          i.caret = "";
          var _n62 = new bo(t, {
            mode: i.mode
          });
          _n62.caret = _r70, i.parent.addChildAfter(_n62, i), e.position += 1;
        }
      }(this.model, e), rn(this);
    }
  }, {
    key: "onCompositionEnd",
    value: function onCompositionEnd(e) {
      !function (e) {
        var t = e.at(e.position);
        "composition" === t.type && (t.parent.removeChild(t), e.position -= 1);
      }(this.model), is(this, e, {
        simulateKeystroke: !0
      });
    }
  }, {
    key: "onResize",
    value: function onResize() {
      kr(this) && (this.element.classList.remove("ML__isNarrowWidth", "ML__isWideWidth", "ML__isExtendedWidth"), window.innerWidth >= 1024 ? this.element.classList.add("ML__isExtendedWidth") : window.innerWidth >= 768 ? this.element.classList.add("ML__isWideWidth") : this.element.classList.add("ML__isNarrowWidth"), Qr(this));
    }
  }]);
  return ms;
}();
var fs, gs;
var ys = document.createElement("template");
ys.innerHTML = '<style>\n:host { display: block; position: relative; }\n:host([hidden]) { display: none; }\n:host([disabled]) { opacity:  .5; }\n:host(:focus), :host(:focus-within) {\n  outline: Highlight auto 1px;    /* For Firefox */\n  outline: -webkit-focus-ring-color auto 1px;\n}\n:host([readonly]), :host([read-only]) { outline: none; }\n</style>\n<div></div><slot style="display:none"></slot>';
var bs = new WeakMap();
var vs = /*#__PURE__*/function (_HTMLElement) {
  _inherits(vs, _HTMLElement);
  var _super37 = _createSuper(vs);
  function vs(e) {
    var _this59;
    _classCallCheck(this, vs);
    we(), _this59 = _super37.call(this), _this59.attachShadow({
      mode: "open"
    }), _this59.shadowRoot.append(ys.content.cloneNode(!0));
    var t = _this59.shadowRoot.querySelector("slot:not([name])");
    _this59._slotValue = t.assignedNodes().map(function (e) {
      return 3 === e.nodeType ? e.textContent : "";
    }).join("").trim(), e && _this59.setOptions(e), _this59.shadowRoot.host.addEventListener("focus", function (e) {
      var t;
      _this59.readOnly || null === (t = _this59._mathfield) || void 0 === t || t.focus();
    }, !0), _this59.shadowRoot.host.addEventListener("blur", function (e) {
      var t;
      _this59.readOnly || null === (t = _this59._mathfield) || void 0 === t || t.blur();
    }, !0);
    return _this59;
  }
  _createClass(vs, [{
    key: "getPlaceholderField",
    value: function getPlaceholderField(e) {
      var t;
      return null === (t = this._mathfield) || void 0 === t ? void 0 : t.getPlaceholderField(e);
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(e, t, i) {
      return _get(_getPrototypeOf(vs.prototype), "addEventListener", this).call(this, e, t, i);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(e, t, i) {
      _get(_getPrototypeOf(vs.prototype), "removeEventListener", this).call(this, e, t, i);
    }
  }, {
    key: "mode",
    get: function get() {
      var e, t;
      return null !== (t = null === (e = this._mathfield) || void 0 === e ? void 0 : e.mode) && void 0 !== t ? t : "math";
    },
    set: function set(e) {
      this._mathfield && (this._mathfield.mode = e);
    }
  }, {
    key: "getOptions",
    value: function getOptions(e) {
      return this._mathfield ? Gn(this._mathfield.options, e) : bs.has(this) ? Gn(Zn(Yn(), bs.get(this).options), e) : null;
    }
  }, {
    key: "getOption",
    value: function getOption(e) {
      return this.getOptions([e])[e];
    }
  }, {
    key: "setOptions",
    value: function setOptions(e) {
      if (this._mathfield) this._mathfield.setOptions(e), this._mathfield._placeholders.forEach(function (t) {
        t.field.setOptions(_objectSpread(_objectSpread({}, e), {}, {
          virtualKeyboardMode: "onfocus",
          readOnly: !1
        }));
      });else if (bs.has(this)) {
        var _t196 = _objectSpread(_objectSpread({}, bs.get(this).options), e);
        bs.set(this, {
          value: bs.get(this).value,
          selection: {
            ranges: _t196.readOnly ? [[0, 0]] : [[0, -1]]
          },
          options: _t196
        });
      } else bs.set(this, {
        value: "",
        selection: {
          ranges: [[0, 0]]
        },
        options: e
      });
      !function (e) {
        var t = Yn(),
          i = e.getOptions();
        Object.keys(vs.optionsAttributes).forEach(function (r) {
          var n = xs(r);
          t[n] !== i[n] && ("boolean" === vs.optionsAttributes[r] ? i[n] ? e.setAttribute(r, "") : e.removeAttribute(r) : "string" != typeof i[n] && "number" != typeof i[n] || e.setAttribute(r, i[n].toString()));
        });
      }(this);
    }
  }, {
    key: "executeCommand",
    value: function executeCommand(e) {
      var t, i;
      return null !== (i = null === (t = this._mathfield) || void 0 === t ? void 0 : t.executeCommand(e)) && void 0 !== i && i;
    }
  }, {
    key: "getValue",
    value: function getValue(e, t, i) {
      if (this._mathfield) return this._mathfield.getValue(e, t, i);
      if (bs.has(this)) {
        var _e$ranges$, _e235;
        var _r71, _n63, _a36;
        if (ra(e) ? ((_e$ranges$ = _slicedToArray(e.ranges[0], 2), _r71 = _e$ranges$[0], _n63 = _e$ranges$[1]), _a36 = t) : ia(e) ? ((_e235 = _slicedToArray(e, 2), _r71 = _e235[0], _n63 = _e235[1]), _a36 = t) : ta(e) && ta(t) ? (_r71 = e, _n63 = t, _a36 = i) : (_r71 = 0, _n63 = -1, _a36 = e), (void 0 === _a36 || "latex" === _a36) && 0 === _r71 && -1 === _n63) return bs.get(this).value;
      }
      return "";
    }
  }, {
    key: "setValue",
    value: function setValue(e, t) {
      if (this._mathfield) return void this._mathfield.setValue(null != e ? e : "", t);
      if (bs.has(this)) {
        var _t197 = bs.get(this).options;
        return void bs.set(this, {
          value: null != e ? e : "",
          selection: {
            ranges: _t197.readOnly ? [[0, 0]] : [[0, -1]],
            direction: "forward"
          },
          options: _t197
        });
      }
      var i = ks(this);
      bs.set(this, {
        value: null != e ? e : "",
        selection: {
          ranges: i.readOnly ? [[0, 0]] : [[0, -1]],
          direction: "forward"
        },
        options: i
      });
    }
  }, {
    key: "hasFocus",
    value: function hasFocus() {
      var e, t;
      return null !== (t = null === (e = this._mathfield) || void 0 === e ? void 0 : e.hasFocus()) && void 0 !== t && t;
    }
  }, {
    key: "virtualKeyboardState",
    get: function get() {
      var e, t;
      return null !== (t = null === (e = this._mathfield) || void 0 === e ? void 0 : e.virtualKeyboardState) && void 0 !== t ? t : "hidden";
    },
    set: function set(e) {
      this._mathfield && (this._mathfield.virtualKeyboardState = e);
    }
  }, {
    key: "focus",
    value: function focus() {
      _get(_getPrototypeOf(vs.prototype), "focus", this).call(this);
    }
  }, {
    key: "blur",
    value: function blur() {
      _get(_getPrototypeOf(vs.prototype), "blur", this).call(this);
    }
  }, {
    key: "select",
    value: function select() {
      var e;
      null === (e = this._mathfield) || void 0 === e || e.select();
    }
  }, {
    key: "insert",
    value: function insert(e, t) {
      var i, r;
      return null !== (r = null === (i = this._mathfield) || void 0 === i ? void 0 : i.insert(e, t)) && void 0 !== r && r;
    }
  }, {
    key: "applyStyle",
    value: function applyStyle(e, t) {
      var i;
      return null === (i = this._mathfield) || void 0 === i ? void 0 : i.applyStyle(e, t);
    }
  }, {
    key: "caretPoint",
    get: function get() {
      var e, t;
      return null !== (t = null === (e = this._mathfield) || void 0 === e ? void 0 : e.getCaretPoint()) && void 0 !== t ? t : null;
    },
    set: function set(e) {
      var t;
      e && (null === (t = this._mathfield) || void 0 === t || t.setCaretPoint(e.x, e.y));
    }
  }, {
    key: "setCaretPoint",
    value: function setCaretPoint(e, t) {
      var i, r;
      return null !== (r = null === (i = this._mathfield) || void 0 === i ? void 0 : i.setCaretPoint(e, t)) && void 0 !== r && r;
    }
  }, {
    key: "find",
    value: function find(e, t) {
      var i, r;
      return null !== (r = null === (i = this._mathfield) || void 0 === i ? void 0 : i.find(e, t)) && void 0 !== r ? r : [];
    }
  }, {
    key: "replace",
    value: function replace(e, t, i) {
      var r;
      null === (r = this._mathfield) || void 0 === r || r.replace(e, t, i);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this60 = this;
      var e, t;
      this.hasAttribute("role") || this.setAttribute("role", "textbox"), this.hasAttribute("tabindex") || this.setAttribute("tabindex", "0");
      var i = this.shadowRoot.querySelector("slot:not([name])");
      try {
        this._style = i.assignedElements().filter(function (e) {
          return "style" === e.tagName.toLowerCase();
        }).map(function (e) {
          return e.textContent;
        }).join("");
      } catch (e) {}
      if (this._style) {
        var _e236 = document.createElement("style");
        _e236.textContent = this._style, this.shadowRoot.appendChild(_e236);
      }
      try {
        var _e237 = i.assignedElements().filter(function (e) {
          return "script" === e.tagName.toLowerCase() && "application/json" === e.type;
        }).map(function (e) {
          return e.textContent;
        }).join("");
        _e237 && this.setOptions(JSON.parse(_e237));
      } catch (e) {}
      var r = "";
      if (r = this.hasAttribute("value") ? null !== (e = this.getAttribute("value")) && void 0 !== e ? e : "" : null !== (t = null == i ? void 0 : i.assignedNodes().map(function (e) {
        return 3 === e.nodeType ? e.textContent : "";
      }).join("").trim()) && void 0 !== t ? t : "", this._mathfield = new ms(this.shadowRoot.querySelector(":host > div"), _objectSpread(_objectSpread({
        onBlur: function onBlur() {
          _this60.dispatchEvent(new Event("blur", {
            cancelable: !1,
            bubbles: !1,
            composed: !0
          }));
        },
        onContentDidChange: function onContentDidChange() {
          _this60.dispatchEvent(new Event("input", {
            cancelable: !1,
            bubbles: !0,
            composed: !0
          }));
        },
        onError: function onError(e) {
          _this60.dispatchEvent(new CustomEvent("math-error", {
            detail: {
              code: e.code,
              arg: e.arg,
              latex: e.latex,
              before: e.before,
              after: e.after
            },
            cancelable: !1,
            bubbles: !0,
            composed: !0
          }));
        },
        onFocus: function onFocus() {
          _this60.dispatchEvent(new Event("focus", {
            cancelable: !1,
            bubbles: !1,
            composed: !0
          }));
        },
        onKeystroke: function onKeystroke(e, t, i) {
          return _this60.dispatchEvent(new CustomEvent("keystroke", {
            detail: {
              keystroke: t,
              event: i
            },
            cancelable: !0,
            bubbles: !0,
            composed: !0
          }));
        },
        onModeChange: function onModeChange(e, t) {
          _this60.dispatchEvent(new Event("mode-change", {
            cancelable: !1,
            bubbles: !0,
            composed: !0
          }));
        },
        onCommit: function onCommit(e) {
          _this60.dispatchEvent(new Event("change", {
            cancelable: !1,
            bubbles: !0,
            composed: !0
          }));
        },
        onMoveOutOf: function onMoveOutOf(e, t) {
          return _this60.dispatchEvent(new CustomEvent("move-out", {
            detail: {
              direction: t
            },
            cancelable: !0,
            bubbles: !0,
            composed: !0
          }));
        },
        onTabOutOf: function onTabOutOf(e, t) {
          return _this60.dispatchEvent(new CustomEvent("focus-out", {
            detail: {
              direction: t
            },
            cancelable: !0,
            bubbles: !0,
            composed: !0
          }));
        },
        onReadAloudStatus: function onReadAloudStatus() {
          _this60.dispatchEvent(new Event("read-aloud-status-change", {
            cancelable: !1,
            bubbles: !0,
            composed: !0
          }));
        },
        onSelectionDidChange: function onSelectionDidChange() {
          _this60.dispatchEvent(new Event("selection-change", {
            cancelable: !1,
            bubbles: !0,
            composed: !0
          }));
        },
        onUndoStateDidChange: function onUndoStateDidChange() {
          _this60.dispatchEvent(new Event("undo-state-change", {
            cancelable: !1,
            bubbles: !0,
            composed: !0
          }));
        }
      }, bs.has(this) ? bs.get(this).options : ks(this)), {}, {
        value: r
      })), !bs.has(this)) {
        this.upgradeProperty("disabled"), this.upgradeProperty("readonly");
        for (var _i182 = 0, _Object$keys15 = Object.keys(vs.optionsAttributes); _i182 < _Object$keys15.length; _i182++) {
          var _e238 = _Object$keys15[_i182];
          this.upgradeProperty(xs(_e238));
        }
      }
      this._mathfield && this._mathfield.model ? (bs.has(this) && this._mathfield.model.deferNotifications({
        content: !1,
        selection: !1
      }, function () {
        _this60._mathfield.setValue(bs.get(_this60).value), _this60._mathfield.selection = bs.get(_this60).selection, bs.delete(_this60);
      }), i.addEventListener("slotchange", function (e) {
        if (e.target !== i) return;
        var t = i.assignedNodes().map(function (e) {
          return 3 === e.nodeType ? e.textContent : "";
        }).join("").trim();
        t !== _this60._slotValue && (_this60._mathfield ? _this60._mathfield.setValue(t) : _this60.value = t);
      }), this.dispatchEvent(new Event("mount", {
        cancelable: !1,
        bubbles: !0,
        composed: !0
      }))) : this._mathfield = null;
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.dispatchEvent(new Event("unmount", {
        cancelable: !1,
        bubbles: !0,
        composed: !0
      })), !this._mathfield) return;
      var e = Gn(this._mathfield.options, Object.keys(vs.optionsAttributes).map(function (e) {
        return xs(e);
      }));
      bs.set(this, {
        value: this._mathfield.getValue(),
        selection: this._mathfield.selection,
        options: e
      }), this._mathfield.dispose(), this._mathfield = null;
    }
  }, {
    key: "upgradeProperty",
    value: function upgradeProperty(e) {
      if (this.hasOwnProperty(e)) {
        var _t198 = this[e];
        delete this[e], "readonly" === e && (e = "readOnly"), this[e] = _t198;
      }
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(e, t, i) {
      if (t === i) return;
      var r = null !== i;
      switch (e) {
        case "disabled":
          this.disabled = r;
          break;
        case "readonly":
          this.readOnly = r;
      }
    }
  }, {
    key: "readonly",
    get: function get() {
      return this.hasAttribute("readonly") || this.hasAttribute("read-only");
    },
    set: function set(e) {
      var t = Boolean(e);
      t ? this.setAttribute("disabled", "") : this.removeAttribute("disabled"), this.setAttribute("aria-disabled", t ? "true" : "false"), this.setOptions({
        readOnly: t
      });
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.hasAttribute("disabled");
    },
    set: function set(e) {
      var t = Boolean(e);
      t ? this.setAttribute("disabled", "") : this.removeAttribute("disabled"), this.setAttribute("aria-disabled", t ? "true" : "false"), this.setOptions({
        readOnly: t
      });
    }
  }, {
    key: "value",
    get: function get() {
      return this.getValue();
    },
    set: function set(e) {
      this.setValue(e);
    }
  }, {
    key: "defaultMode",
    get: function get() {
      return this.getOption("defaultMode");
    },
    set: function set(e) {
      this.setOptions({
        defaultMode: e
      });
    }
  }, {
    key: "fontsDirectory",
    get: function get() {
      return this.getOption("fontsDirectory");
    },
    set: function set(e) {
      this.setOptions({
        fontsDirectory: e
      });
    }
  }, {
    key: "mathModeSpace",
    get: function get() {
      return this.getOption("fontsDirectory");
    },
    set: function set(e) {
      this.setOptions({
        mathModeSpace: e
      });
    }
  }, {
    key: "inlineShortcutTimeout",
    get: function get() {
      return this.getOption("inlineShortcutTimeout");
    },
    set: function set(e) {
      this.setOptions({
        inlineShortcutTimeout: e
      });
    }
  }, {
    key: "keypressVibration",
    get: function get() {
      return this.getOption("keypressVibration");
    },
    set: function set(e) {
      this.setOptions({
        keypressVibration: e
      });
    }
  }, {
    key: "keypressSound",
    get: function get() {
      return this.getOption("keypressSound");
    },
    set: function set(e) {
      this.setOptions({
        keypressSound: e
      });
    }
  }, {
    key: "plonkSound",
    get: function get() {
      var e;
      return null !== (e = this.getOption("plonkSound")) && void 0 !== e ? e : null;
    },
    set: function set(e) {
      this.setOptions({
        plonkSound: e
      });
    }
  }, {
    key: "letterShapeStyle",
    get: function get() {
      return this.getOption("letterShapeStyle");
    },
    set: function set(e) {
      this.setOptions({
        letterShapeStyle: e
      });
    }
  }, {
    key: "locale",
    get: function get() {
      return this.getOption("locale");
    },
    set: function set(e) {
      this.setOptions({
        locale: e
      });
    }
  }, {
    key: "readOnly",
    get: function get() {
      return this.getOption("readOnly");
    },
    set: function set(e) {
      this.setOptions({
        readOnly: e
      });
    }
  }, {
    key: "removeExtraneousParentheses",
    get: function get() {
      return this.getOption("removeExtraneousParentheses");
    },
    set: function set(e) {
      this.setOptions({
        removeExtraneousParentheses: e
      });
    }
  }, {
    key: "smartFence",
    get: function get() {
      return this.getOption("smartFence");
    },
    set: function set(e) {
      this.setOptions({
        smartFence: e
      });
    }
  }, {
    key: "smartMode",
    get: function get() {
      return this.getOption("smartMode");
    },
    set: function set(e) {
      this.setOptions({
        smartMode: e
      });
    }
  }, {
    key: "smartSuperscript",
    get: function get() {
      return this.getOption("smartSuperscript");
    },
    set: function set(e) {
      this.setOptions({
        smartSuperscript: e
      });
    }
  }, {
    key: "speechEngine",
    get: function get() {
      return this.getOption("speechEngine");
    },
    set: function set(e) {
      this.setOptions({
        speechEngine: e
      });
    }
  }, {
    key: "speechEngineRate",
    get: function get() {
      return this.getOption("speechEngineRate");
    },
    set: function set(e) {
      this.setOptions({
        speechEngineRate: e
      });
    }
  }, {
    key: "speechEngineVoice",
    get: function get() {
      return this.getOption("speechEngineVoice");
    },
    set: function set(e) {
      this.setOptions({
        speechEngineVoice: e
      });
    }
  }, {
    key: "textToSpeechMarkup",
    get: function get() {
      return this.getOption("textToSpeechMarkup");
    },
    set: function set(e) {
      this.setOptions({
        textToSpeechMarkup: e
      });
    }
  }, {
    key: "textToSpeechRules",
    get: function get() {
      return this.getOption("textToSpeechRules");
    }
  }, {
    key: "textToSpeechRule",
    set: function set(e) {
      this.setOptions({
        textToSpeechRules: e
      });
    }
  }, {
    key: "virtualKeyboardLayout",
    get: function get() {
      return this.getOption("virtualKeyboardLayout");
    },
    set: function set(e) {
      this.setOptions({
        virtualKeyboardLayout: e
      });
    }
  }, {
    key: "virtualKeyboardMode",
    get: function get() {
      return this.getOption("virtualKeyboardMode");
    },
    set: function set(e) {
      this.setOptions({
        virtualKeyboardMode: e
      });
    }
  }, {
    key: "virtualKeyboardTheme",
    get: function get() {
      return this.getOption("virtualKeyboardTheme");
    },
    set: function set(e) {
      this.setOptions({
        virtualKeyboardTheme: e
      });
    }
  }, {
    key: "virtualKeyboards",
    get: function get() {
      return this.getOption("virtualKeyboards");
    },
    set: function set(e) {
      this.setOptions({
        virtualKeyboards: e
      });
    }
  }, {
    key: "useSharedVirtualKeyboard",
    get: function get() {
      return this.getOption("useSharedVirtualKeyboard");
    },
    set: function set(e) {
      this.setOptions({
        useSharedVirtualKeyboard: e
      });
    }
  }, {
    key: "sharedVirtualKeyboardTargetOrigin",
    get: function get() {
      return this.getOption("sharedVirtualKeyboardTargetOrigin");
    },
    set: function set(e) {
      this.setOptions({
        sharedVirtualKeyboardTargetOrigin: e
      });
    }
  }, {
    key: "selection",
    get: function get() {
      return this._mathfield ? this._mathfield.selection : bs.has(this) ? bs.get(this).selection : {
        ranges: [[0, 0]],
        direction: "forward"
      };
    },
    set: function set(e) {
      "number" == typeof e && (e = {
        ranges: [[e, e]]
      }), this._mathfield ? this._mathfield.selection = e : bs.has(this) ? bs.set(this, {
        value: bs.get(this).value,
        selection: e,
        options: bs.get(this).options
      }) : bs.set(this, {
        value: "",
        selection: e,
        options: ks(this)
      });
    }
  }, {
    key: "position",
    get: function get() {
      return this._mathfield ? this._mathfield.model.position : bs.has(this) ? bs.get(this).selection.ranges[0][0] : 0;
    },
    set: function set(e) {
      this._mathfield && (this._mathfield.model.position = e), bs.has(this) ? bs.set(this, {
        value: bs.get(this).value,
        selection: {
          ranges: [[e, e]]
        },
        options: bs.get(this).options
      }) : bs.set(this, {
        value: "",
        selection: {
          ranges: [[e, e]]
        },
        options: ks(this)
      });
    }
  }, {
    key: "getOffsetDepth",
    value: function getOffsetDepth(e) {
      var t, i;
      return this._mathfield && null !== (i = (null === (t = this._mathfield.model.at(e)) || void 0 === t ? void 0 : t.treeDepth) - 2) && void 0 !== i ? i : 0;
    }
  }, {
    key: "lastOffset",
    get: function get() {
      var e, t;
      return null !== (t = null === (e = this._mathfield) || void 0 === e ? void 0 : e.lastOffset) && void 0 !== t ? t : -1;
    }
  }], [{
    key: "optionsAttributes",
    get: function get() {
      return {
        "default-mode": "string",
        "fonts-directory": "string",
        "sounds-directory": "string",
        "horizontal-spacing-scale": "string",
        "math-mode-space": "string",
        "inline-shortcut-timeout": "string",
        "keypress-vibration": "boolean",
        "keypress-sound": "string",
        "plonk-sound": "string",
        "letter-shape-style": "string",
        locale: "string",
        "read-only": "boolean",
        "remove-extraneous-parentheses": "boolean",
        "smart-fence": "boolean",
        "smart-mode": "boolean",
        "smart-superscript": "boolean",
        "speech-engine": "string",
        "speech-engine-rate": "string",
        "speech-engine-voice": "string",
        "text-to-speech-markup": "string",
        "text-to-speech-rules": "string",
        "virtual-keyboard-layout": "string",
        "virtual-keyboard-mode": "string",
        "virtual-keyboard-theme": "string",
        "virtual-keyboards": "string",
        "use-shared-virtual-keyboard": "boolean",
        "shared-virtual-keyboard-target-origin": "string"
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return [].concat(_toConsumableArray(Object.keys(vs.optionsAttributes)), ["disabled", "readonly"]);
    }
  }]);
  return vs;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
function xs(e) {
  return e.toLowerCase().replace(/[^a-zA-Z\d]+(.)/g, function (e, t) {
    return t.toUpperCase();
  });
}
function ks(e) {
  var t = {},
    i = vs.optionsAttributes;
  return Object.keys(i).forEach(function (r) {
    if (e.hasAttribute(r)) {
      var _n64 = e.getAttribute(r);
      "boolean" === i[r] ? t[xs(r)] = !0 : "number" === i[r] ? t[xs(r)] = Number.parseFloat(null != _n64 ? _n64 : "0") : t[xs(r)] = _n64;
    } else "boolean" === i[r] && (t[xs(r)] = !1);
  }), t;
}
ke() && !(null === (fs = window.customElements) || void 0 === fs ? void 0 : fs.get("math-field")) && (window.MathfieldElement = vs, null === (gs = window.customElements) || void 0 === gs || gs.define("math-field", vs));
var ws = [127462, 127487];
function _s(e) {
  return 8205 === e || 65038 === e || 65039 === e || e >= 127995 && e <= 128e3 || e >= 129456 && e <= 129460 || e >= 917536 && e <= 917632;
}
function Ms(e) {
  return e >= ws[0] && e <= ws[1];
}
var Ss = /*#__PURE__*/function () {
  function Ss(e) {
    _classCallCheck(this, Ss);
    this.obeyspaces = !1, this.s = function (e) {
      if (/^[\u0020-\u00FF]*$/.test(e)) return e;
      var t = [],
        i = function (e) {
          var t = [];
          for (var _i183 = 0; _i183 < e.length; _i183++) {
            var _r72 = e.charCodeAt(_i183);
            if (_r72 >= 55296 && _r72 <= 56319) {
              var _t199 = e.charCodeAt(_i183 + 1);
              _t199 >= 56320 && _t199 <= 57343 && (_r72 = 65536 + 1024 * (_r72 - 55296) + (_t199 - 56320), _i183++);
            }
            t.push(_r72);
          }
          return t;
        }(e);
      var r = 0;
      for (; r < i.length;) {
        var _e239 = i[r++],
          _n65 = i[r];
        if (8205 === _n65) {
          var _e240 = r - 1;
          for (r += 2; 8205 === i[r];) r += 2;
          t.push(String.fromCodePoint.apply(String, _toConsumableArray(i.slice(_e240, 2 * r - _e240 + 1))));
        } else if (_s(_n65)) {
          var _e241 = r - 1;
          for (; _s(i[r]);) r += 8205 === i[r] ? 2 : 1;
          t.push(String.fromCodePoint.apply(String, _toConsumableArray(i.slice(_e241, 2 * r - _e241 - 1))));
        } else Ms(_e239) ? (r += 1, t.push(String.fromCodePoint.apply(String, _toConsumableArray(i.slice(r - 2, 2))))) : t.push(String.fromCodePoint(_e239));
      }
      return t;
    }(e), this.pos = 0;
  }
  _createClass(Ss, [{
    key: "end",
    value: function end() {
      return this.pos >= this.s.length;
    }
  }, {
    key: "get",
    value: function get() {
      return this.pos < this.s.length ? this.s[this.pos++] : "";
    }
  }, {
    key: "peek",
    value: function peek() {
      return this.s[this.pos];
    }
  }, {
    key: "match",
    value: function match(e) {
      var t;
      return t = "string" == typeof this.s ? e.exec(this.s.slice(this.pos)) : e.exec(this.s.slice(this.pos).join("")), (null == t ? void 0 : t[0]) ? (this.pos += t[0].length, t[0]) : null;
    }
  }, {
    key: "next",
    value: function next() {
      if (this.end()) return null;
      if (!this.obeyspaces && this.match(/^[ \f\n\r\t\v\xA0\u2028\u2029]+/)) return "<space>";
      if (this.obeyspaces && this.match(/^[ \f\n\r\t\v\xA0\u2028\u2029]/)) return "<space>";
      var e = this.get();
      if ("\\" === e) {
        if (!this.end()) {
          var _e242 = this.match(/^[a-zA-Z*]+/);
          if (_e242) this.match(/^[ \f\n\r\t\v\xA0\u2028\u2029]*/);else if (_e242 = this.get(), " " === _e242) return "<space>";
          return "\\" + _e242;
        }
      } else {
        if ("{" === e) return "<{>";
        if ("}" === e) return "<}>";
        if ("^" === e) {
          if ("^" === this.peek()) {
            this.get();
            var _e243 = this.match(/^(\^(\^(\^(\^[0-9a-f])?[0-9a-f])?[0-9a-f])?[0-9a-f])?[0-9a-f][0-9a-f]/);
            if (_e243) return String.fromCodePoint(parseInt(_e243.slice(_e243.lastIndexOf("^") + 1), 16));
          }
          return e;
        }
        if ("#" === e) {
          if (!this.end()) {
            var _e244 = !1;
            if (/[0-9?]/.test(this.peek()) && (_e244 = !0, this.pos + 1 < this.s.length)) {
              var _t200 = this.s[this.pos + 1];
              _e244 = /[^0-9A-Za-z]/.test(_t200);
            }
            return _e244 ? "#" + this.get() : "#";
          }
        } else if ("$" === e) return "$" === this.peek() ? (this.get(), "<$$>") : "<$>";
      }
      return e;
    }
  }]);
  return Ss;
}();
function Ls(e, t) {
  var i, r, n, a;
  var o = [],
    s = e.next();
  if (s) if ("\\relax" === s) ;else if ("\\noexpand" === s) s = e.next(), s && o.push(s);else if ("\\obeyspaces" === s) e.obeyspaces = !0;else if ("\\space" === s || "~" === s) o.push("<space>");else if ("\\bgroup" === s) o.push("<{>");else if ("\\egroup" === s) o.push("<}>");else if ("\\string" === s) s = e.next(), s && ("\\" === s[0] ? Array.from(s).forEach(function (e) {
    return o.push("\\" === e ? "\\backslash" : e);
  }) : "<{>" === s ? o.push("\\{") : "<space>" === s ? o.push("~") : "<}>" === s && o.push("\\}"));else if ("\\csname" === s) {
    for (; "<space>" === e.peek();) e.next();
    var _n66 = "",
      _a37 = !1,
      _l11 = [];
    do {
      if (0 === _l11.length) if (/^#[0-9?]$/.test(e.peek())) {
        var _n67 = e.get().slice(1);
        _l11 = Cs(null !== (r = null !== (i = null == t ? void 0 : t[_n67]) && void 0 !== i ? i : null == t ? void 0 : t["?"]) && void 0 !== r ? r : "\\placeholder{}", t), s = _l11[0];
      } else s = e.next(), _l11 = s ? [s] : [];
      _a37 = 0 === _l11.length, _a37 || "\\endcsname" !== s || (_a37 = !0, _l11.shift()), _a37 || (_a37 = "<$>" === s || "<$$>" === s || "<{>" === s || "<}>" === s || !!s && s.length > 1 && "\\" === s[0]), _a37 || (_n66 += _l11.shift());
    } while (!_a37);
    _n66 && o.push("\\" + _n66), o = o.concat(_l11);
  } else if ("\\endcsname" === s) ;else if (s.length > 1 && "#" === s[0]) {
    var _e245 = s.slice(1);
    o = o.concat(Cs(null !== (a = null !== (n = null == t ? void 0 : t[_e245]) && void 0 !== n ? n : null == t ? void 0 : t["?"]) && void 0 !== a ? a : "\\placeholder{}", t));
  } else o.push(s);
  return o;
}
function Cs(e, t) {
  var i = e.toString().split(/\r?\n/);
  var r = "",
    n = "";
  var _iterator122 = _createForOfIteratorHelper(i),
    _step122;
  try {
    for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
      var _e246 = _step122.value;
      r += n, n = " ";
      var _t201 = _e246.match(/((?:\\%)|[^%])*/);
      null !== _t201 && (r += _t201[0]);
    }
  } catch (err) {
    _iterator122.e(err);
  } finally {
    _iterator122.f();
  }
  var a = new Ss(r);
  var o = [];
  do {
    o = o.concat(Ls(a, t));
  } while (!a.end());
  return o;
}
function As(e) {
  var t = "",
    i = "";
  var _iterator123 = _createForOfIteratorHelper(e),
    _step123;
  try {
    for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
      var _r73 = _step123.value;
      _r73 && (/[a-zA-Z*]/.test(_r73[0]) && (i += t), t = /\\[a-zA-Z]+\*?$/.test(_r73) ? " " : "", i += _r73);
    }
  } catch (err) {
    _iterator123.e(err);
  } finally {
    _iterator123.f();
  }
  return i;
}
function Ns(e) {
  var t = [];
  if (Array.isArray(e)) {
    var _iterator124 = _createForOfIteratorHelper(e),
      _step124;
    try {
      for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
        var _i184 = _step124.value;
        Array.isArray(_i184) ? t = [].concat(_toConsumableArray(t), _toConsumableArray(_i184)) : t.push(_i184);
      }
    } catch (err) {
      _iterator124.e(err);
    } finally {
      _iterator124.f();
    }
  } else t = [e];
  return As(t.map(function (e) {
    var t;
    return null !== (t = {
      "<space>": " ",
      "<$$>": "$$",
      "<$>": "$",
      "<{>": "{",
      "<}>": "}"
    }[e]) && void 0 !== t ? t : e;
  }));
}
var zs,
  qs = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
  Ds = {
    exports: {}
  };
zs = Ds, function (e) {
  var t,
    i,
    r,
    n,
    a = 9e15,
    o = 1e9,
    s = "0123456789abcdef",
    l = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058",
    c = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789",
    u = {
      precision: 20,
      rounding: 4,
      modulo: 1,
      toExpNeg: -7,
      toExpPos: 21,
      minE: -a,
      maxE: a,
      crypto: !1
    },
    d = !0,
    h = "[DecimalError] ",
    p = h + "Invalid argument: ",
    m = h + "Precision limit exceeded",
    f = h + "crypto unavailable",
    g = Math.floor,
    y = Math.pow,
    b = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i,
    v = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i,
    x = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i,
    k = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
    w = 1e7,
    _ = l.length - 1,
    M = c.length - 1,
    S = {
      name: "[object Decimal]"
    };
  function L(e) {
    var t,
      i,
      r,
      n = e.length - 1,
      a = "",
      o = e[0];
    if (n > 0) {
      for (a += o, t = 1; t < n; t++) (i = 7 - (r = e[t] + "").length) && (a += K(i)), a += r;
      (i = 7 - (r = (o = e[t]) + "").length) && (a += K(i));
    } else if (0 === o) return "0";
    for (; o % 10 == 0;) o /= 10;
    return a + o;
  }
  function C(e, t, i) {
    if (e !== ~~e || e < t || e > i) throw Error(p + e);
  }
  function A(e, t, i, r) {
    var n, a, o, s;
    for (a = e[0]; a >= 10; a /= 10) --t;
    return --t < 0 ? (t += 7, n = 0) : (n = Math.ceil((t + 1) / 7), t %= 7), a = y(10, 7 - t), s = e[n] % a | 0, null == r ? t < 3 ? (0 == t ? s = s / 100 | 0 : 1 == t && (s = s / 10 | 0), o = i < 4 && 99999 == s || i > 3 && 49999 == s || 5e4 == s || 0 == s) : o = (i < 4 && s + 1 == a || i > 3 && s + 1 == a / 2) && (e[n + 1] / a / 100 | 0) == y(10, t - 2) - 1 || (s == a / 2 || 0 == s) && 0 == (e[n + 1] / a / 100 | 0) : t < 4 ? (0 == t ? s = s / 1e3 | 0 : 1 == t ? s = s / 100 | 0 : 2 == t && (s = s / 10 | 0), o = (r || i < 4) && 9999 == s || !r && i > 3 && 4999 == s) : o = ((r || i < 4) && s + 1 == a || !r && i > 3 && s + 1 == a / 2) && (e[n + 1] / a / 1e3 | 0) == y(10, t - 3) - 1, o;
  }
  function N(e, t, i) {
    for (var r, n, a = [0], o = 0, l = e.length; o < l;) {
      for (n = a.length; n--;) a[n] *= t;
      for (a[0] += s.indexOf(e.charAt(o++)), r = 0; r < a.length; r++) a[r] > i - 1 && (void 0 === a[r + 1] && (a[r + 1] = 0), a[r + 1] += a[r] / i | 0, a[r] %= i);
    }
    return a.reverse();
  }
  S.absoluteValue = S.abs = function () {
    var e = new this.constructor(this);
    return e.s < 0 && (e.s = 1), q(e);
  }, S.ceil = function () {
    return q(new this.constructor(this), this.e + 1, 2);
  }, S.comparedTo = S.cmp = function (e) {
    var t,
      i,
      r,
      n,
      a = this,
      o = a.d,
      s = (e = new a.constructor(e)).d,
      l = a.s,
      c = e.s;
    if (!o || !s) return l && c ? l !== c ? l : o === s ? 0 : !o ^ l < 0 ? 1 : -1 : NaN;
    if (!o[0] || !s[0]) return o[0] ? l : s[0] ? -c : 0;
    if (l !== c) return l;
    if (a.e !== e.e) return a.e > e.e ^ l < 0 ? 1 : -1;
    for (t = 0, i = (r = o.length) < (n = s.length) ? r : n; t < i; ++t) if (o[t] !== s[t]) return o[t] > s[t] ^ l < 0 ? 1 : -1;
    return r === n ? 0 : r > n ^ l < 0 ? 1 : -1;
  }, S.cosine = S.cos = function () {
    var e,
      t,
      i = this,
      r = i.constructor;
    return i.d ? i.d[0] ? (e = r.precision, t = r.rounding, r.precision = e + Math.max(i.e, i.sd()) + 7, r.rounding = 1, i = function (e, t) {
      var i,
        r,
        n = t.d.length;
      n < 32 ? r = (1 / W(4, i = Math.ceil(n / 3))).toString() : (i = 16, r = "2.3283064365386962890625e-10"), e.precision += i, t = U(e, 1, t.times(r), new e(1));
      for (var a = i; a--;) {
        var o = t.times(t);
        t = o.times(o).minus(o).times(8).plus(1);
      }
      return e.precision -= i, t;
    }(r, Z(r, i)), r.precision = e, r.rounding = t, q(2 == n || 3 == n ? i.neg() : i, e, t, !0)) : new r(1) : new r(NaN);
  }, S.cubeRoot = S.cbrt = function () {
    var e,
      t,
      i,
      r,
      n,
      a,
      o,
      s,
      l,
      c,
      u = this,
      h = u.constructor;
    if (!u.isFinite() || u.isZero()) return new h(u);
    for (d = !1, (a = u.s * y(u.s * u, 1 / 3)) && Math.abs(a) != 1 / 0 ? r = new h(a.toString()) : (i = L(u.d), (a = ((e = u.e) - i.length + 1) % 3) && (i += 1 == a || -2 == a ? "0" : "00"), a = y(i, 1 / 3), e = g((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2)), (r = new h(i = a == 1 / 0 ? "5e" + e : (i = a.toExponential()).slice(0, i.indexOf("e") + 1) + e)).s = u.s), o = (e = h.precision) + 3;;) if (c = (l = (s = r).times(s).times(s)).plus(u), r = z(c.plus(u).times(s), c.plus(l), o + 2, 1), L(s.d).slice(0, o) === (i = L(r.d)).slice(0, o)) {
      if ("9999" != (i = i.slice(o - 3, o + 1)) && (n || "4999" != i)) {
        +i && (+i.slice(1) || "5" != i.charAt(0)) || (q(r, e + 1, 1), t = !r.times(r).times(r).eq(u));
        break;
      }
      if (!n && (q(s, e + 1, 0), s.times(s).times(s).eq(u))) {
        r = s;
        break;
      }
      o += 4, n = 1;
    }
    return d = !0, q(r, e, h.rounding, t);
  }, S.decimalPlaces = S.dp = function () {
    var e,
      t = this.d,
      i = NaN;
    if (t) {
      if (i = 7 * ((e = t.length - 1) - g(this.e / 7)), e = t[e]) for (; e % 10 == 0; e /= 10) i--;
      i < 0 && (i = 0);
    }
    return i;
  }, S.dividedBy = S.div = function (e) {
    return z(this, new this.constructor(e));
  }, S.dividedToIntegerBy = S.divToInt = function (e) {
    var t = this.constructor;
    return q(z(this, new t(e), 0, 1, 1), t.precision, t.rounding);
  }, S.equals = S.eq = function (e) {
    return 0 === this.cmp(e);
  }, S.floor = function () {
    return q(new this.constructor(this), this.e + 1, 3);
  }, S.greaterThan = S.gt = function (e) {
    return this.cmp(e) > 0;
  }, S.greaterThanOrEqualTo = S.gte = function (e) {
    var t = this.cmp(e);
    return 1 == t || 0 === t;
  }, S.hyperbolicCosine = S.cosh = function () {
    var e,
      t,
      i,
      r,
      n,
      a = this,
      o = a.constructor,
      s = new o(1);
    if (!a.isFinite()) return new o(a.s ? 1 / 0 : NaN);
    if (a.isZero()) return s;
    i = o.precision, r = o.rounding, o.precision = i + Math.max(a.e, a.sd()) + 4, o.rounding = 1, (n = a.d.length) < 32 ? t = (1 / W(4, e = Math.ceil(n / 3))).toString() : (e = 16, t = "2.3283064365386962890625e-10"), a = U(o, 1, a.times(t), new o(1), !0);
    for (var l, c = e, u = new o(8); c--;) l = a.times(a), a = s.minus(l.times(u.minus(l.times(u))));
    return q(a, o.precision = i, o.rounding = r, !0);
  }, S.hyperbolicSine = S.sinh = function () {
    var e,
      t,
      i,
      r,
      n = this,
      a = n.constructor;
    if (!n.isFinite() || n.isZero()) return new a(n);
    if (t = a.precision, i = a.rounding, a.precision = t + Math.max(n.e, n.sd()) + 4, a.rounding = 1, (r = n.d.length) < 3) n = U(a, 2, n, n, !0);else {
      e = (e = 1.4 * Math.sqrt(r)) > 16 ? 16 : 0 | e, n = U(a, 2, n = n.times(1 / W(5, e)), n, !0);
      for (var o, s = new a(5), l = new a(16), c = new a(20); e--;) o = n.times(n), n = n.times(s.plus(o.times(l.times(o).plus(c))));
    }
    return a.precision = t, a.rounding = i, q(n, t, i, !0);
  }, S.hyperbolicTangent = S.tanh = function () {
    var e,
      t,
      i = this,
      r = i.constructor;
    return i.isFinite() ? i.isZero() ? new r(i) : (e = r.precision, t = r.rounding, r.precision = e + 7, r.rounding = 1, z(i.sinh(), i.cosh(), r.precision = e, r.rounding = t)) : new r(i.s);
  }, S.inverseCosine = S.acos = function () {
    var e,
      t = this,
      i = t.constructor,
      r = t.abs().cmp(1),
      n = i.precision,
      a = i.rounding;
    return -1 !== r ? 0 === r ? t.isNeg() ? O(i, n, a) : new i(0) : new i(NaN) : t.isZero() ? O(i, n + 4, a).times(.5) : (i.precision = n + 6, i.rounding = 1, t = t.asin(), e = O(i, n + 4, a).times(.5), i.precision = n, i.rounding = a, e.minus(t));
  }, S.inverseHyperbolicCosine = S.acosh = function () {
    var e,
      t,
      i = this,
      r = i.constructor;
    return i.lte(1) ? new r(i.eq(1) ? 0 : NaN) : i.isFinite() ? (e = r.precision, t = r.rounding, r.precision = e + Math.max(Math.abs(i.e), i.sd()) + 4, r.rounding = 1, d = !1, i = i.times(i).minus(1).sqrt().plus(i), d = !0, r.precision = e, r.rounding = t, i.ln()) : new r(i);
  }, S.inverseHyperbolicSine = S.asinh = function () {
    var e,
      t,
      i = this,
      r = i.constructor;
    return !i.isFinite() || i.isZero() ? new r(i) : (e = r.precision, t = r.rounding, r.precision = e + 2 * Math.max(Math.abs(i.e), i.sd()) + 6, r.rounding = 1, d = !1, i = i.times(i).plus(1).sqrt().plus(i), d = !0, r.precision = e, r.rounding = t, i.ln());
  }, S.inverseHyperbolicTangent = S.atanh = function () {
    var e,
      t,
      i,
      r,
      n = this,
      a = n.constructor;
    return n.isFinite() ? n.e >= 0 ? new a(n.abs().eq(1) ? n.s / 0 : n.isZero() ? n : NaN) : (e = a.precision, t = a.rounding, r = n.sd(), Math.max(r, e) < 2 * -n.e - 1 ? q(new a(n), e, t, !0) : (a.precision = i = r - n.e, n = z(n.plus(1), new a(1).minus(n), i + e, 1), a.precision = e + 4, a.rounding = 1, n = n.ln(), a.precision = e, a.rounding = t, n.times(.5))) : new a(NaN);
  }, S.inverseSine = S.asin = function () {
    var e,
      t,
      i,
      r,
      n = this,
      a = n.constructor;
    return n.isZero() ? new a(n) : (t = n.abs().cmp(1), i = a.precision, r = a.rounding, -1 !== t ? 0 === t ? ((e = O(a, i + 4, r).times(.5)).s = n.s, e) : new a(NaN) : (a.precision = i + 6, a.rounding = 1, n = n.div(new a(1).minus(n.times(n)).sqrt().plus(1)).atan(), a.precision = i, a.rounding = r, n.times(2)));
  }, S.inverseTangent = S.atan = function () {
    var e,
      t,
      i,
      r,
      n,
      a,
      o,
      s,
      l,
      c = this,
      u = c.constructor,
      h = u.precision,
      p = u.rounding;
    if (c.isFinite()) {
      if (c.isZero()) return new u(c);
      if (c.abs().eq(1) && h + 4 <= M) return (o = O(u, h + 4, p).times(.25)).s = c.s, o;
    } else {
      if (!c.s) return new u(NaN);
      if (h + 4 <= M) return (o = O(u, h + 4, p).times(.5)).s = c.s, o;
    }
    for (u.precision = s = h + 10, u.rounding = 1, e = i = Math.min(28, s / 7 + 2 | 0); e; --e) c = c.div(c.times(c).plus(1).sqrt().plus(1));
    for (d = !1, t = Math.ceil(s / 7), r = 1, l = c.times(c), o = new u(c), n = c; -1 !== e;) if (n = n.times(l), a = o.minus(n.div(r += 2)), n = n.times(l), void 0 !== (o = a.plus(n.div(r += 2))).d[t]) for (e = t; o.d[e] === a.d[e] && e--;);
    return i && (o = o.times(2 << i - 1)), d = !0, q(o, u.precision = h, u.rounding = p, !0);
  }, S.isFinite = function () {
    return !!this.d;
  }, S.isInteger = S.isInt = function () {
    return !!this.d && g(this.e / 7) > this.d.length - 2;
  }, S.isNaN = function () {
    return !this.s;
  }, S.isNegative = S.isNeg = function () {
    return this.s < 0;
  }, S.isPositive = S.isPos = function () {
    return this.s > 0;
  }, S.isZero = function () {
    return !!this.d && 0 === this.d[0];
  }, S.lessThan = S.lt = function (e) {
    return this.cmp(e) < 0;
  }, S.lessThanOrEqualTo = S.lte = function (e) {
    return this.cmp(e) < 1;
  }, S.logarithm = S.log = function (e) {
    var t,
      i,
      r,
      n,
      a,
      o,
      s,
      l,
      c = this,
      u = c.constructor,
      h = u.precision,
      p = u.rounding;
    if (null == e) e = new u(10), t = !0;else {
      if (i = (e = new u(e)).d, e.s < 0 || !i || !i[0] || e.eq(1)) return new u(NaN);
      t = e.eq(10);
    }
    if (i = c.d, c.s < 0 || !i || !i[0] || c.eq(1)) return new u(i && !i[0] ? -1 / 0 : 1 != c.s ? NaN : i ? 0 : 1 / 0);
    if (t) if (i.length > 1) a = !0;else {
      for (n = i[0]; n % 10 == 0;) n /= 10;
      a = 1 !== n;
    }
    if (d = !1, o = R(c, s = h + 5), r = t ? T(u, s + 10) : R(e, s), A((l = z(o, r, s, 1)).d, n = h, p)) do {
      if (o = R(c, s += 10), r = t ? T(u, s + 10) : R(e, s), l = z(o, r, s, 1), !a) {
        +L(l.d).slice(n + 1, n + 15) + 1 == 1e14 && (l = q(l, h + 1, 0));
        break;
      }
    } while (A(l.d, n += 10, p));
    return d = !0, q(l, h, p);
  }, S.minus = S.sub = function (e) {
    var t,
      i,
      r,
      n,
      a,
      o,
      s,
      l,
      c,
      u,
      h,
      p,
      m = this,
      f = m.constructor;
    if (e = new f(e), !m.d || !e.d) return m.s && e.s ? m.d ? e.s = -e.s : e = new f(e.d || m.s !== e.s ? m : NaN) : e = new f(NaN), e;
    if (m.s != e.s) return e.s = -e.s, m.plus(e);
    if (c = m.d, p = e.d, s = f.precision, l = f.rounding, !c[0] || !p[0]) {
      if (p[0]) e.s = -e.s;else {
        if (!c[0]) return new f(3 === l ? -0 : 0);
        e = new f(m);
      }
      return d ? q(e, s, l) : e;
    }
    if (i = g(e.e / 7), u = g(m.e / 7), c = c.slice(), a = u - i) {
      for ((h = a < 0) ? (t = c, a = -a, o = p.length) : (t = p, i = u, o = c.length), a > (r = Math.max(Math.ceil(s / 7), o) + 2) && (a = r, t.length = 1), t.reverse(), r = a; r--;) t.push(0);
      t.reverse();
    } else {
      for ((h = (r = c.length) < (o = p.length)) && (o = r), r = 0; r < o; r++) if (c[r] != p[r]) {
        h = c[r] < p[r];
        break;
      }
      a = 0;
    }
    for (h && (t = c, c = p, p = t, e.s = -e.s), o = c.length, r = p.length - o; r > 0; --r) c[o++] = 0;
    for (r = p.length; r > a;) {
      if (c[--r] < p[r]) {
        for (n = r; n && 0 === c[--n];) c[n] = w - 1;
        --c[n], c[r] += w;
      }
      c[r] -= p[r];
    }
    for (; 0 === c[--o];) c.pop();
    for (; 0 === c[0]; c.shift()) --i;
    return c[0] ? (e.d = c, e.e = E(c, i), d ? q(e, s, l) : e) : new f(3 === l ? -0 : 0);
  }, S.modulo = S.mod = function (e) {
    var t,
      i = this,
      r = i.constructor;
    return e = new r(e), !i.d || !e.s || e.d && !e.d[0] ? new r(NaN) : !e.d || i.d && !i.d[0] ? q(new r(i), r.precision, r.rounding) : (d = !1, 9 == r.modulo ? (t = z(i, e.abs(), 0, 3, 1)).s *= e.s : t = z(i, e, 0, r.modulo, 1), t = t.times(e), d = !0, i.minus(t));
  }, S.naturalExponential = S.exp = function () {
    return I(this);
  }, S.naturalLogarithm = S.ln = function () {
    return R(this);
  }, S.negated = S.neg = function () {
    var e = new this.constructor(this);
    return e.s = -e.s, q(e);
  }, S.plus = S.add = function (e) {
    var t,
      i,
      r,
      n,
      a,
      o,
      s,
      l,
      c,
      u,
      h = this,
      p = h.constructor;
    if (e = new p(e), !h.d || !e.d) return h.s && e.s ? h.d || (e = new p(e.d || h.s === e.s ? h : NaN)) : e = new p(NaN), e;
    if (h.s != e.s) return e.s = -e.s, h.minus(e);
    if (c = h.d, u = e.d, s = p.precision, l = p.rounding, !c[0] || !u[0]) return u[0] || (e = new p(h)), d ? q(e, s, l) : e;
    if (a = g(h.e / 7), r = g(e.e / 7), c = c.slice(), n = a - r) {
      for (n < 0 ? (i = c, n = -n, o = u.length) : (i = u, r = a, o = c.length), n > (o = (a = Math.ceil(s / 7)) > o ? a + 1 : o + 1) && (n = o, i.length = 1), i.reverse(); n--;) i.push(0);
      i.reverse();
    }
    for ((o = c.length) - (n = u.length) < 0 && (n = o, i = u, u = c, c = i), t = 0; n;) t = (c[--n] = c[n] + u[n] + t) / w | 0, c[n] %= w;
    for (t && (c.unshift(t), ++r), o = c.length; 0 == c[--o];) c.pop();
    return e.d = c, e.e = E(c, r), d ? q(e, s, l) : e;
  }, S.precision = S.sd = function (e) {
    var t,
      i = this;
    if (void 0 !== e && e !== !!e && 1 !== e && 0 !== e) throw Error(p + e);
    return i.d ? (t = B(i.d), e && i.e + 1 > t && (t = i.e + 1)) : t = NaN, t;
  }, S.round = function () {
    var e = this,
      t = e.constructor;
    return q(new t(e), e.e + 1, t.rounding);
  }, S.sine = S.sin = function () {
    var e,
      t,
      i = this,
      r = i.constructor;
    return i.isFinite() ? i.isZero() ? new r(i) : (e = r.precision, t = r.rounding, r.precision = e + Math.max(i.e, i.sd()) + 7, r.rounding = 1, i = function (e, t) {
      var i,
        r = t.d.length;
      if (r < 3) return U(e, 2, t, t);
      i = (i = 1.4 * Math.sqrt(r)) > 16 ? 16 : 0 | i, t = U(e, 2, t = t.times(1 / W(5, i)), t);
      for (var n, a = new e(5), o = new e(16), s = new e(20); i--;) n = t.times(t), t = t.times(a.plus(n.times(o.times(n).minus(s))));
      return t;
    }(r, Z(r, i)), r.precision = e, r.rounding = t, q(n > 2 ? i.neg() : i, e, t, !0)) : new r(NaN);
  }, S.squareRoot = S.sqrt = function () {
    var e,
      t,
      i,
      r,
      n,
      a,
      o = this,
      s = o.d,
      l = o.e,
      c = o.s,
      u = o.constructor;
    if (1 !== c || !s || !s[0]) return new u(!c || c < 0 && (!s || s[0]) ? NaN : s ? o : 1 / 0);
    for (d = !1, 0 == (c = Math.sqrt(+o)) || c == 1 / 0 ? (((t = L(s)).length + l) % 2 == 0 && (t += "0"), c = Math.sqrt(t), l = g((l + 1) / 2) - (l < 0 || l % 2), r = new u(t = c == 1 / 0 ? "5e" + l : (t = c.toExponential()).slice(0, t.indexOf("e") + 1) + l)) : r = new u(c.toString()), i = (l = u.precision) + 3;;) if (r = (a = r).plus(z(o, a, i + 2, 1)).times(.5), L(a.d).slice(0, i) === (t = L(r.d)).slice(0, i)) {
      if ("9999" != (t = t.slice(i - 3, i + 1)) && (n || "4999" != t)) {
        +t && (+t.slice(1) || "5" != t.charAt(0)) || (q(r, l + 1, 1), e = !r.times(r).eq(o));
        break;
      }
      if (!n && (q(a, l + 1, 0), a.times(a).eq(o))) {
        r = a;
        break;
      }
      i += 4, n = 1;
    }
    return d = !0, q(r, l, u.rounding, e);
  }, S.tangent = S.tan = function () {
    var e,
      t,
      i = this,
      r = i.constructor;
    return i.isFinite() ? i.isZero() ? new r(i) : (e = r.precision, t = r.rounding, r.precision = e + 10, r.rounding = 1, (i = i.sin()).s = 1, i = z(i, new r(1).minus(i.times(i)).sqrt(), e + 10, 0), r.precision = e, r.rounding = t, q(2 == n || 4 == n ? i.neg() : i, e, t, !0)) : new r(NaN);
  }, S.times = S.mul = function (e) {
    var t,
      i,
      r,
      n,
      a,
      o,
      s,
      l,
      c,
      u = this,
      h = u.constructor,
      p = u.d,
      m = (e = new h(e)).d;
    if (e.s *= u.s, !(p && p[0] && m && m[0])) return new h(!e.s || p && !p[0] && !m || m && !m[0] && !p ? NaN : p && m ? 0 * e.s : e.s / 0);
    for (i = g(u.e / 7) + g(e.e / 7), (l = p.length) < (c = m.length) && (a = p, p = m, m = a, o = l, l = c, c = o), a = [], r = o = l + c; r--;) a.push(0);
    for (r = c; --r >= 0;) {
      for (t = 0, n = l + r; n > r;) s = a[n] + m[r] * p[n - r - 1] + t, a[n--] = s % w | 0, t = s / w | 0;
      a[n] = (a[n] + t) % w | 0;
    }
    for (; !a[--o];) a.pop();
    return t ? ++i : a.shift(), e.d = a, e.e = E(a, i), d ? q(e, h.precision, h.rounding) : e;
  }, S.toBinary = function (e, t) {
    return G(this, 2, e, t);
  }, S.toDecimalPlaces = S.toDP = function (e, t) {
    var i = this,
      r = i.constructor;
    return i = new r(i), void 0 === e ? i : (C(e, 0, o), void 0 === t ? t = r.rounding : C(t, 0, 8), q(i, e + i.e + 1, t));
  }, S.toExponential = function (e, t) {
    var i,
      r = this,
      n = r.constructor;
    return void 0 === e ? i = D(r, !0) : (C(e, 0, o), void 0 === t ? t = n.rounding : C(t, 0, 8), i = D(r = q(new n(r), e + 1, t), !0, e + 1)), r.isNeg() && !r.isZero() ? "-" + i : i;
  }, S.toFixed = function (e, t) {
    var i,
      r,
      n = this,
      a = n.constructor;
    return void 0 === e ? i = D(n) : (C(e, 0, o), void 0 === t ? t = a.rounding : C(t, 0, 8), i = D(r = q(new a(n), e + n.e + 1, t), !1, e + r.e + 1)), n.isNeg() && !n.isZero() ? "-" + i : i;
  }, S.toFraction = function (e) {
    var t,
      i,
      r,
      n,
      a,
      o,
      s,
      l,
      c,
      u,
      h,
      m,
      f = this,
      g = f.d,
      b = f.constructor;
    if (!g) return new b(f);
    if (c = i = new b(1), r = l = new b(0), o = (a = (t = new b(r)).e = B(g) - f.e - 1) % 7, t.d[0] = y(10, o < 0 ? 7 + o : o), null == e) e = a > 0 ? t : c;else {
      if (!(s = new b(e)).isInt() || s.lt(c)) throw Error(p + s);
      e = s.gt(t) ? a > 0 ? t : c : s;
    }
    for (d = !1, s = new b(L(g)), u = b.precision, b.precision = a = 7 * g.length * 2; h = z(s, t, 0, 1, 1), 1 != (n = i.plus(h.times(r))).cmp(e);) i = r, r = n, n = c, c = l.plus(h.times(n)), l = n, n = t, t = s.minus(h.times(n)), s = n;
    return n = z(e.minus(i), r, 0, 1, 1), l = l.plus(n.times(c)), i = i.plus(n.times(r)), l.s = c.s = f.s, m = z(c, r, a, 1).minus(f).abs().cmp(z(l, i, a, 1).minus(f).abs()) < 1 ? [c, r] : [l, i], b.precision = u, d = !0, m;
  }, S.toHexadecimal = S.toHex = function (e, t) {
    return G(this, 16, e, t);
  }, S.toNearest = function (e, t) {
    var i = this,
      r = i.constructor;
    if (i = new r(i), null == e) {
      if (!i.d) return i;
      e = new r(1), t = r.rounding;
    } else {
      if (e = new r(e), void 0 === t ? t = r.rounding : C(t, 0, 8), !i.d) return e.s ? i : e;
      if (!e.d) return e.s && (e.s = i.s), e;
    }
    return e.d[0] ? (d = !1, i = z(i, e, 0, t, 1).times(e), d = !0, q(i)) : (e.s = i.s, i = e), i;
  }, S.toNumber = function () {
    return +this;
  }, S.toOctal = function (e, t) {
    return G(this, 8, e, t);
  }, S.toPower = S.pow = function (e) {
    var t,
      i,
      r,
      n,
      a,
      o,
      s = this,
      l = s.constructor,
      c = +(e = new l(e));
    if (!(s.d && e.d && s.d[0] && e.d[0])) return new l(y(+s, c));
    if ((s = new l(s)).eq(1)) return s;
    if (r = l.precision, a = l.rounding, e.eq(1)) return q(s, r, a);
    if ((t = g(e.e / 7)) >= e.d.length - 1 && (i = c < 0 ? -c : c) <= 9007199254740991) return n = F(l, s, i, r), e.s < 0 ? new l(1).div(n) : q(n, r, a);
    if ((o = s.s) < 0) {
      if (t < e.d.length - 1) return new l(NaN);
      if (0 == (1 & e.d[t]) && (o = 1), 0 == s.e && 1 == s.d[0] && 1 == s.d.length) return s.s = o, s;
    }
    return (t = 0 != (i = y(+s, c)) && isFinite(i) ? new l(i + "").e : g(c * (Math.log("0." + L(s.d)) / Math.LN10 + s.e + 1))) > l.maxE + 1 || t < l.minE - 1 ? new l(t > 0 ? o / 0 : 0) : (d = !1, l.rounding = s.s = 1, i = Math.min(12, (t + "").length), (n = I(e.times(R(s, r + i)), r)).d && A((n = q(n, r + 5, 1)).d, r, a) && (t = r + 10, +L((n = q(I(e.times(R(s, t + i)), t), t + 5, 1)).d).slice(r + 1, r + 15) + 1 == 1e14 && (n = q(n, r + 1, 0))), n.s = o, d = !0, l.rounding = a, q(n, r, a));
  }, S.toPrecision = function (e, t) {
    var i,
      r = this,
      n = r.constructor;
    return void 0 === e ? i = D(r, r.e <= n.toExpNeg || r.e >= n.toExpPos) : (C(e, 1, o), void 0 === t ? t = n.rounding : C(t, 0, 8), i = D(r = q(new n(r), e, t), e <= r.e || r.e <= n.toExpNeg, e)), r.isNeg() && !r.isZero() ? "-" + i : i;
  }, S.toSignificantDigits = S.toSD = function (e, t) {
    var i = this.constructor;
    return void 0 === e ? (e = i.precision, t = i.rounding) : (C(e, 1, o), void 0 === t ? t = i.rounding : C(t, 0, 8)), q(new i(this), e, t);
  }, S.toString = function () {
    var e = this,
      t = e.constructor,
      i = D(e, e.e <= t.toExpNeg || e.e >= t.toExpPos);
    return e.isNeg() && !e.isZero() ? "-" + i : i;
  }, S.truncated = S.trunc = function () {
    return q(new this.constructor(this), this.e + 1, 1);
  }, S.valueOf = S.toJSON = function () {
    var e = this,
      t = e.constructor,
      i = D(e, e.e <= t.toExpNeg || e.e >= t.toExpPos);
    return e.isNeg() ? "-" + i : i;
  };
  var z = function () {
    function e(e, t, i) {
      var r,
        n = 0,
        a = e.length;
      for (e = e.slice(); a--;) r = e[a] * t + n, e[a] = r % i | 0, n = r / i | 0;
      return n && e.unshift(n), e;
    }
    function t(e, t, i, r) {
      var n, a;
      if (i != r) a = i > r ? 1 : -1;else for (n = a = 0; n < i; n++) if (e[n] != t[n]) {
        a = e[n] > t[n] ? 1 : -1;
        break;
      }
      return a;
    }
    function r(e, t, i, r) {
      for (var n = 0; i--;) e[i] -= n, n = e[i] < t[i] ? 1 : 0, e[i] = n * r + e[i] - t[i];
      for (; !e[0] && e.length > 1;) e.shift();
    }
    return function (n, a, o, s, l, c) {
      var u,
        d,
        h,
        p,
        m,
        f,
        y,
        b,
        v,
        x,
        k,
        _,
        M,
        S,
        L,
        C,
        A,
        N,
        z,
        D,
        E = n.constructor,
        T = n.s == a.s ? 1 : -1,
        O = n.d,
        B = a.d;
      if (!(O && O[0] && B && B[0])) return new E(n.s && a.s && (O ? !B || O[0] != B[0] : B) ? O && 0 == O[0] || !B ? 0 * T : T / 0 : NaN);
      for (c ? (m = 1, d = n.e - a.e) : (c = w, m = 7, d = g(n.e / m) - g(a.e / m)), z = B.length, A = O.length, x = (v = new E(T)).d = [], h = 0; B[h] == (O[h] || 0); h++);
      if (B[h] > (O[h] || 0) && d--, null == o ? (S = o = E.precision, s = E.rounding) : S = l ? o + (n.e - a.e) + 1 : o, S < 0) x.push(1), f = !0;else {
        if (S = S / m + 2 | 0, h = 0, 1 == z) {
          for (p = 0, B = B[0], S++; (h < A || p) && S--; h++) L = p * c + (O[h] || 0), x[h] = L / B | 0, p = L % B | 0;
          f = p || h < A;
        } else {
          for ((p = c / (B[0] + 1) | 0) > 1 && (B = e(B, p, c), O = e(O, p, c), z = B.length, A = O.length), C = z, _ = (k = O.slice(0, z)).length; _ < z;) k[_++] = 0;
          (D = B.slice()).unshift(0), N = B[0], B[1] >= c / 2 && ++N;
          do {
            p = 0, (u = t(B, k, z, _)) < 0 ? (M = k[0], z != _ && (M = M * c + (k[1] || 0)), (p = M / N | 0) > 1 ? (p >= c && (p = c - 1), 1 == (u = t(y = e(B, p, c), k, b = y.length, _ = k.length)) && (p--, r(y, z < b ? D : B, b, c))) : (0 == p && (u = p = 1), y = B.slice()), (b = y.length) < _ && y.unshift(0), r(k, y, _, c), -1 == u && (u = t(B, k, z, _ = k.length)) < 1 && (p++, r(k, z < _ ? D : B, _, c)), _ = k.length) : 0 === u && (p++, k = [0]), x[h++] = p, u && k[0] ? k[_++] = O[C] || 0 : (k = [O[C]], _ = 1);
          } while ((C++ < A || void 0 !== k[0]) && S--);
          f = void 0 !== k[0];
        }
        x[0] || x.shift();
      }
      if (1 == m) v.e = d, i = f;else {
        for (h = 1, p = x[0]; p >= 10; p /= 10) h++;
        v.e = h + d * m - 1, q(v, l ? o + v.e + 1 : o, s, f);
      }
      return v;
    };
  }();
  function q(e, t, i, r) {
    var n,
      a,
      o,
      s,
      l,
      c,
      u,
      h,
      p,
      m = e.constructor;
    e: if (null != t) {
      if (!(h = e.d)) return e;
      for (n = 1, s = h[0]; s >= 10; s /= 10) n++;
      if ((a = t - n) < 0) a += 7, o = t, l = (u = h[p = 0]) / y(10, n - o - 1) % 10 | 0;else if ((p = Math.ceil((a + 1) / 7)) >= (s = h.length)) {
        if (!r) break e;
        for (; s++ <= p;) h.push(0);
        u = l = 0, n = 1, o = (a %= 7) - 7 + 1;
      } else {
        for (u = s = h[p], n = 1; s >= 10; s /= 10) n++;
        l = (o = (a %= 7) - 7 + n) < 0 ? 0 : u / y(10, n - o - 1) % 10 | 0;
      }
      if (r = r || t < 0 || void 0 !== h[p + 1] || (o < 0 ? u : u % y(10, n - o - 1)), c = i < 4 ? (l || r) && (0 == i || i == (e.s < 0 ? 3 : 2)) : l > 5 || 5 == l && (4 == i || r || 6 == i && (a > 0 ? o > 0 ? u / y(10, n - o) : 0 : h[p - 1]) % 10 & 1 || i == (e.s < 0 ? 8 : 7)), t < 1 || !h[0]) return h.length = 0, c ? (t -= e.e + 1, h[0] = y(10, (7 - t % 7) % 7), e.e = -t || 0) : h[0] = e.e = 0, e;
      if (0 == a ? (h.length = p, s = 1, p--) : (h.length = p + 1, s = y(10, 7 - a), h[p] = o > 0 ? (u / y(10, n - o) % y(10, o) | 0) * s : 0), c) for (;;) {
        if (0 == p) {
          for (a = 1, o = h[0]; o >= 10; o /= 10) a++;
          for (o = h[0] += s, s = 1; o >= 10; o /= 10) s++;
          a != s && (e.e++, h[0] == w && (h[0] = 1));
          break;
        }
        if (h[p] += s, h[p] != w) break;
        h[p--] = 0, s = 1;
      }
      for (a = h.length; 0 === h[--a];) h.pop();
    }
    return d && (e.e > m.maxE ? (e.d = null, e.e = NaN) : e.e < m.minE && (e.e = 0, e.d = [0])), e;
  }
  function D(e, t, i) {
    if (!e.isFinite()) return V(e);
    var r,
      n = e.e,
      a = L(e.d),
      o = a.length;
    return t ? (i && (r = i - o) > 0 ? a = a.charAt(0) + "." + a.slice(1) + K(r) : o > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (e.e < 0 ? "e" : "e+") + e.e) : n < 0 ? (a = "0." + K(-n - 1) + a, i && (r = i - o) > 0 && (a += K(r))) : n >= o ? (a += K(n + 1 - o), i && (r = i - n - 1) > 0 && (a = a + "." + K(r))) : ((r = n + 1) < o && (a = a.slice(0, r) + "." + a.slice(r)), i && (r = i - o) > 0 && (n + 1 === o && (a += "."), a += K(r))), a;
  }
  function E(e, t) {
    var i = e[0];
    for (t *= 7; i >= 10; i /= 10) t++;
    return t;
  }
  function T(e, t, i) {
    if (t > _) throw d = !0, i && (e.precision = i), Error(m);
    return q(new e(l), t, 1, !0);
  }
  function O(e, t, i) {
    if (t > M) throw Error(m);
    return q(new e(c), t, i, !0);
  }
  function B(e) {
    var t = e.length - 1,
      i = 7 * t + 1;
    if (t = e[t]) {
      for (; t % 10 == 0; t /= 10) i--;
      for (t = e[0]; t >= 10; t /= 10) i++;
    }
    return i;
  }
  function K(e) {
    for (var t = ""; e--;) t += "0";
    return t;
  }
  function F(e, t, i, r) {
    var n,
      a = new e(1),
      o = Math.ceil(r / 7 + 4);
    for (d = !1;;) {
      if (i % 2 && X((a = a.times(t)).d, o) && (n = !0), 0 === (i = g(i / 2))) {
        i = a.d.length - 1, n && 0 === a.d[i] && ++a.d[i];
        break;
      }
      X((t = t.times(t)).d, o);
    }
    return d = !0, a;
  }
  function $(e) {
    return 1 & e.d[e.d.length - 1];
  }
  function P(e, t, i) {
    for (var r, n = new e(t[0]), a = 0; ++a < t.length;) {
      if (!(r = new e(t[a])).s) {
        n = r;
        break;
      }
      n[i](r) && (n = r);
    }
    return n;
  }
  function I(e, t) {
    var i,
      r,
      n,
      a,
      o,
      s,
      l,
      c = 0,
      u = 0,
      h = 0,
      p = e.constructor,
      m = p.rounding,
      f = p.precision;
    if (!e.d || !e.d[0] || e.e > 17) return new p(e.d ? e.d[0] ? e.s < 0 ? 0 : 1 / 0 : 1 : e.s ? e.s < 0 ? 0 : e : NaN);
    for (null == t ? (d = !1, l = f) : l = t, s = new p(.03125); e.e > -2;) e = e.times(s), h += 5;
    for (l += r = Math.log(y(2, h)) / Math.LN10 * 2 + 5 | 0, i = a = o = new p(1), p.precision = l;;) {
      if (a = q(a.times(e), l, 1), i = i.times(++u), L((s = o.plus(z(a, i, l, 1))).d).slice(0, l) === L(o.d).slice(0, l)) {
        for (n = h; n--;) o = q(o.times(o), l, 1);
        if (null != t) return p.precision = f, o;
        if (!(c < 3 && A(o.d, l - r, m, c))) return q(o, p.precision = f, m, d = !0);
        p.precision = l += 10, i = a = s = new p(1), u = 0, c++;
      }
      o = s;
    }
  }
  function R(e, t) {
    var i,
      r,
      n,
      a,
      o,
      s,
      l,
      c,
      u,
      h,
      p,
      m = 1,
      f = e,
      g = f.d,
      y = f.constructor,
      b = y.rounding,
      v = y.precision;
    if (f.s < 0 || !g || !g[0] || !f.e && 1 == g[0] && 1 == g.length) return new y(g && !g[0] ? -1 / 0 : 1 != f.s ? NaN : g ? 0 : f);
    if (null == t ? (d = !1, u = v) : u = t, y.precision = u += 10, r = (i = L(g)).charAt(0), !(Math.abs(a = f.e) < 15e14)) return c = T(y, u + 2, v).times(a + ""), f = R(new y(r + "." + i.slice(1)), u - 10).plus(c), y.precision = v, null == t ? q(f, v, b, d = !0) : f;
    for (; r < 7 && 1 != r || 1 == r && i.charAt(1) > 3;) r = (i = L((f = f.times(e)).d)).charAt(0), m++;
    for (a = f.e, r > 1 ? (f = new y("0." + i), a++) : f = new y(r + "." + i.slice(1)), h = f, l = o = f = z(f.minus(1), f.plus(1), u, 1), p = q(f.times(f), u, 1), n = 3;;) {
      if (o = q(o.times(p), u, 1), L((c = l.plus(z(o, new y(n), u, 1))).d).slice(0, u) === L(l.d).slice(0, u)) {
        if (l = l.times(2), 0 !== a && (l = l.plus(T(y, u + 2, v).times(a + ""))), l = z(l, new y(m), u, 1), null != t) return y.precision = v, l;
        if (!A(l.d, u - 10, b, s)) return q(l, y.precision = v, b, d = !0);
        y.precision = u += 10, c = o = f = z(h.minus(1), h.plus(1), u, 1), p = q(f.times(f), u, 1), n = s = 1;
      }
      l = c, n += 2;
    }
  }
  function V(e) {
    return String(e.s * e.s / 0);
  }
  function j(e, t) {
    var i, r, n;
    for ((i = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (r = t.search(/e/i)) > 0 ? (i < 0 && (i = r), i += +t.slice(r + 1), t = t.substring(0, r)) : i < 0 && (i = t.length), r = 0; 48 === t.charCodeAt(r); r++);
    for (n = t.length; 48 === t.charCodeAt(n - 1); --n);
    if (t = t.slice(r, n)) {
      if (n -= r, e.e = i = i - r - 1, e.d = [], r = (i + 1) % 7, i < 0 && (r += 7), r < n) {
        for (r && e.d.push(+t.slice(0, r)), n -= 7; r < n;) e.d.push(+t.slice(r, r += 7));
        r = 7 - (t = t.slice(r)).length;
      } else r -= n;
      for (; r--;) t += "0";
      e.d.push(+t), d && (e.e > e.constructor.maxE ? (e.d = null, e.e = NaN) : e.e < e.constructor.minE && (e.e = 0, e.d = [0]));
    } else e.e = 0, e.d = [0];
    return e;
  }
  function H(e, i) {
    var r, n, a, o, s, l, c, u, h;
    if ("Infinity" === i || "NaN" === i) return +i || (e.s = NaN), e.e = NaN, e.d = null, e;
    if (v.test(i)) r = 16, i = i.toLowerCase();else if (b.test(i)) r = 2;else {
      if (!x.test(i)) throw Error(p + i);
      r = 8;
    }
    for ((o = i.search(/p/i)) > 0 ? (c = +i.slice(o + 1), i = i.substring(2, o)) : i = i.slice(2), s = (o = i.indexOf(".")) >= 0, n = e.constructor, s && (o = (l = (i = i.replace(".", "")).length) - o, a = F(n, new n(r), o, 2 * o)), o = h = (u = N(i, r, w)).length - 1; 0 === u[o]; --o) u.pop();
    return o < 0 ? new n(0 * e.s) : (e.e = E(u, h), e.d = u, d = !1, s && (e = z(e, a, 4 * l)), c && (e = e.times(Math.abs(c) < 54 ? y(2, c) : t.pow(2, c))), d = !0, e);
  }
  function U(e, t, i, r, n) {
    var a,
      o,
      s,
      l,
      c = e.precision,
      u = Math.ceil(c / 7);
    for (d = !1, l = i.times(i), s = new e(r);;) {
      if (o = z(s.times(l), new e(t++ * t++), c, 1), s = n ? r.plus(o) : r.minus(o), r = z(o.times(l), new e(t++ * t++), c, 1), void 0 !== (o = s.plus(r)).d[u]) {
        for (a = u; o.d[a] === s.d[a] && a--;);
        if (-1 == a) break;
      }
      a = s, s = r, r = o, o = a;
    }
    return d = !0, o.d.length = u + 1, o;
  }
  function W(e, t) {
    for (var i = e; --t;) i *= e;
    return i;
  }
  function Z(e, t) {
    var i,
      r = t.s < 0,
      a = O(e, e.precision, 1),
      o = a.times(.5);
    if ((t = t.abs()).lte(o)) return n = r ? 4 : 1, t;
    if ((i = t.divToInt(a)).isZero()) n = r ? 3 : 2;else {
      if ((t = t.minus(i.times(a))).lte(o)) return n = $(i) ? r ? 2 : 3 : r ? 4 : 1, t;
      n = $(i) ? r ? 1 : 4 : r ? 3 : 2;
    }
    return t.minus(a).abs();
  }
  function G(e, t, r, n) {
    var a,
      l,
      c,
      u,
      d,
      h,
      p,
      m,
      f,
      g = e.constructor,
      y = void 0 !== r;
    if (y ? (C(r, 1, o), void 0 === n ? n = g.rounding : C(n, 0, 8)) : (r = g.precision, n = g.rounding), e.isFinite()) {
      for (y ? (a = 2, 16 == t ? r = 4 * r - 3 : 8 == t && (r = 3 * r - 2)) : a = t, (c = (p = D(e)).indexOf(".")) >= 0 && (p = p.replace(".", ""), (f = new g(1)).e = p.length - c, f.d = N(D(f), 10, a), f.e = f.d.length), l = d = (m = N(p, 10, a)).length; 0 == m[--d];) m.pop();
      if (m[0]) {
        if (c < 0 ? l-- : ((e = new g(e)).d = m, e.e = l, m = (e = z(e, f, r, n, 0, a)).d, l = e.e, h = i), c = m[r], u = a / 2, h = h || void 0 !== m[r + 1], h = n < 4 ? (void 0 !== c || h) && (0 === n || n === (e.s < 0 ? 3 : 2)) : c > u || c === u && (4 === n || h || 6 === n && 1 & m[r - 1] || n === (e.s < 0 ? 8 : 7)), m.length = r, h) for (; ++m[--r] > a - 1;) m[r] = 0, r || (++l, m.unshift(1));
        for (d = m.length; !m[d - 1]; --d);
        for (c = 0, p = ""; c < d; c++) p += s.charAt(m[c]);
        if (y) {
          if (d > 1) if (16 == t || 8 == t) {
            for (c = 16 == t ? 4 : 3, --d; d % c; d++) p += "0";
            for (d = (m = N(p, a, t)).length; !m[d - 1]; --d);
            for (c = 1, p = "1."; c < d; c++) p += s.charAt(m[c]);
          } else p = p.charAt(0) + "." + p.slice(1);
          p = p + (l < 0 ? "p" : "p+") + l;
        } else if (l < 0) {
          for (; ++l;) p = "0" + p;
          p = "0." + p;
        } else if (++l > d) for (l -= d; l--;) p += "0";else l < d && (p = p.slice(0, l) + "." + p.slice(l));
      } else p = y ? "0p+0" : "0";
      p = (16 == t ? "0x" : 2 == t ? "0b" : 8 == t ? "0o" : "") + p;
    } else p = V(e);
    return e.s < 0 ? "-" + p : p;
  }
  function X(e, t) {
    if (e.length > t) return e.length = t, !0;
  }
  function Y(e) {
    return new this(e).abs();
  }
  function Q(e) {
    return new this(e).acos();
  }
  function J(e) {
    return new this(e).acosh();
  }
  function ee(e, t) {
    return new this(e).plus(t);
  }
  function te(e) {
    return new this(e).asin();
  }
  function ie(e) {
    return new this(e).asinh();
  }
  function re(e) {
    return new this(e).atan();
  }
  function ne(e) {
    return new this(e).atanh();
  }
  function ae(e, t) {
    e = new this(e), t = new this(t);
    var i,
      r = this.precision,
      n = this.rounding,
      a = r + 4;
    return e.s && t.s ? e.d || t.d ? !t.d || e.isZero() ? (i = t.s < 0 ? O(this, r, n) : new this(0)).s = e.s : !e.d || t.isZero() ? (i = O(this, a, 1).times(.5)).s = e.s : t.s < 0 ? (this.precision = a, this.rounding = 1, i = this.atan(z(e, t, a, 1)), t = O(this, a, 1), this.precision = r, this.rounding = n, i = e.s < 0 ? i.minus(t) : i.plus(t)) : i = this.atan(z(e, t, a, 1)) : (i = O(this, a, 1).times(t.s > 0 ? .25 : .75)).s = e.s : i = new this(NaN), i;
  }
  function oe(e) {
    return new this(e).cbrt();
  }
  function se(e) {
    return q(e = new this(e), e.e + 1, 2);
  }
  function le(e) {
    if (!e || "object" != typeof e) throw Error(h + "Object expected");
    var t,
      i,
      r,
      n = !0 === e.defaults,
      s = ["precision", 1, o, "rounding", 0, 8, "toExpNeg", -a, 0, "toExpPos", 0, a, "maxE", 0, a, "minE", -a, 0, "modulo", 0, 9];
    for (t = 0; t < s.length; t += 3) if (i = s[t], n && (this[i] = u[i]), void 0 !== (r = e[i])) {
      if (!(g(r) === r && r >= s[t + 1] && r <= s[t + 2])) throw Error(p + i + ": " + r);
      this[i] = r;
    }
    if (i = "crypto", n && (this[i] = u[i]), void 0 !== (r = e[i])) {
      if (!0 !== r && !1 !== r && 0 !== r && 1 !== r) throw Error(p + i + ": " + r);
      if (r) {
        if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw Error(f);
        this[i] = !0;
      } else this[i] = !1;
    }
    return this;
  }
  function ce(e) {
    return new this(e).cos();
  }
  function ue(e) {
    return new this(e).cosh();
  }
  function de(e, t) {
    return new this(e).div(t);
  }
  function he(e) {
    return new this(e).exp();
  }
  function pe(e) {
    return q(e = new this(e), e.e + 1, 3);
  }
  function me() {
    var e,
      t,
      i = new this(0);
    for (d = !1, e = 0; e < arguments.length;) if ((t = new this(arguments[e++])).d) i.d && (i = i.plus(t.times(t)));else {
      if (t.s) return d = !0, new this(1 / 0);
      i = t;
    }
    return d = !0, i.sqrt();
  }
  function fe(e) {
    return e instanceof t || e && "[object Decimal]" === e.name || !1;
  }
  function ge(e) {
    return new this(e).ln();
  }
  function ye(e, t) {
    return new this(e).log(t);
  }
  function be(e) {
    return new this(e).log(2);
  }
  function ve(e) {
    return new this(e).log(10);
  }
  function xe() {
    return P(this, arguments, "lt");
  }
  function ke() {
    return P(this, arguments, "gt");
  }
  function we(e, t) {
    return new this(e).mod(t);
  }
  function _e(e, t) {
    return new this(e).mul(t);
  }
  function Me(e, t) {
    return new this(e).pow(t);
  }
  function Se(e) {
    var t,
      i,
      r,
      n,
      a = 0,
      s = new this(1),
      l = [];
    if (void 0 === e ? e = this.precision : C(e, 1, o), r = Math.ceil(e / 7), this.crypto) {
      if (crypto.getRandomValues) for (t = crypto.getRandomValues(new Uint32Array(r)); a < r;) (n = t[a]) >= 429e7 ? t[a] = crypto.getRandomValues(new Uint32Array(1))[0] : l[a++] = n % 1e7;else {
        if (!crypto.randomBytes) throw Error(f);
        for (t = crypto.randomBytes(r *= 4); a < r;) (n = t[a] + (t[a + 1] << 8) + (t[a + 2] << 16) + ((127 & t[a + 3]) << 24)) >= 214e7 ? crypto.randomBytes(4).copy(t, a) : (l.push(n % 1e7), a += 4);
        a = r / 4;
      }
    } else for (; a < r;) l[a++] = 1e7 * Math.random() | 0;
    for (e %= 7, (r = l[--a]) && e && (n = y(10, 7 - e), l[a] = (r / n | 0) * n); 0 === l[a]; a--) l.pop();
    if (a < 0) i = 0, l = [0];else {
      for (i = -1; 0 === l[0]; i -= 7) l.shift();
      for (r = 1, n = l[0]; n >= 10; n /= 10) r++;
      r < 7 && (i -= 7 - r);
    }
    return s.e = i, s.d = l, s;
  }
  function Le(e) {
    return q(e = new this(e), e.e + 1, this.rounding);
  }
  function Ce(e) {
    return (e = new this(e)).d ? e.d[0] ? e.s : 0 * e.s : e.s || NaN;
  }
  function Ae(e) {
    return new this(e).sin();
  }
  function Ne(e) {
    return new this(e).sinh();
  }
  function ze(e) {
    return new this(e).sqrt();
  }
  function qe(e, t) {
    return new this(e).sub(t);
  }
  function De(e) {
    return new this(e).tan();
  }
  function Ee(e) {
    return new this(e).tanh();
  }
  function Te(e) {
    return q(e = new this(e), e.e + 1, 1);
  }
  (t = function e(t) {
    var i, r, n;
    function a(e) {
      var t,
        i,
        r,
        n = this;
      if (!(n instanceof a)) return new a(e);
      if (n.constructor = a, e instanceof a) return n.s = e.s, void (d ? !e.d || e.e > a.maxE ? (n.e = NaN, n.d = null) : e.e < a.minE ? (n.e = 0, n.d = [0]) : (n.e = e.e, n.d = e.d.slice()) : (n.e = e.e, n.d = e.d ? e.d.slice() : e.d));
      if ("number" == (r = typeof e)) {
        if (0 === e) return n.s = 1 / e < 0 ? -1 : 1, n.e = 0, void (n.d = [0]);
        if (e < 0 ? (e = -e, n.s = -1) : n.s = 1, e === ~~e && e < 1e7) {
          for (t = 0, i = e; i >= 10; i /= 10) t++;
          return void (d ? t > a.maxE ? (n.e = NaN, n.d = null) : t < a.minE ? (n.e = 0, n.d = [0]) : (n.e = t, n.d = [e]) : (n.e = t, n.d = [e]));
        }
        return 0 * e != 0 ? (e || (n.s = NaN), n.e = NaN, void (n.d = null)) : j(n, e.toString());
      }
      if ("string" !== r) throw Error(p + e);
      return 45 === (i = e.charCodeAt(0)) ? (e = e.slice(1), n.s = -1) : (43 === i && (e = e.slice(1)), n.s = 1), k.test(e) ? j(n, e) : H(n, e);
    }
    if (a.prototype = S, a.ROUND_UP = 0, a.ROUND_DOWN = 1, a.ROUND_CEIL = 2, a.ROUND_FLOOR = 3, a.ROUND_HALF_UP = 4, a.ROUND_HALF_DOWN = 5, a.ROUND_HALF_EVEN = 6, a.ROUND_HALF_CEIL = 7, a.ROUND_HALF_FLOOR = 8, a.EUCLID = 9, a.config = a.set = le, a.clone = e, a.isDecimal = fe, a.abs = Y, a.acos = Q, a.acosh = J, a.add = ee, a.asin = te, a.asinh = ie, a.atan = re, a.atanh = ne, a.atan2 = ae, a.cbrt = oe, a.ceil = se, a.cos = ce, a.cosh = ue, a.div = de, a.exp = he, a.floor = pe, a.hypot = me, a.ln = ge, a.log = ye, a.log10 = ve, a.log2 = be, a.max = xe, a.min = ke, a.mod = we, a.mul = _e, a.pow = Me, a.random = Se, a.round = Le, a.sign = Ce, a.sin = Ae, a.sinh = Ne, a.sqrt = ze, a.sub = qe, a.tan = De, a.tanh = Ee, a.trunc = Te, void 0 === t && (t = {}), t && !0 !== t.defaults) for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], i = 0; i < n.length;) t.hasOwnProperty(r = n[i++]) || (t[r] = this[r]);
    return a.config(t), a;
  }(u)).default = t.Decimal = t, l = new t(l), c = new t(c), zs.exports ? ("function" == typeof Symbol && "symbol" == typeof Symbol.iterator && (S[Symbol.for("nodejs.util.inspect.custom")] = S.toString, S[Symbol.toStringTag] = "Decimal"), zs.exports = t) : (e || (e = "undefined" != typeof self && self && self.self == self ? self : window), r = e.Decimal, t.noConflict = function () {
    return e.Decimal = r, t;
  }, e.Decimal = t);
}(qs);
var Es = {
  exports: {}
};
/**
 * @license Complex.js v2.0.13 12/05/2020
 *
 * Copyright (c) 2020, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/
!function (e, t) {
  !function (t) {
    var i = function i(e) {
        return .5 * (Math.exp(e) + Math.exp(-e));
      },
      r = function r(e) {
        return .5 * (Math.exp(e) - Math.exp(-e));
      },
      n = function n() {
        throw SyntaxError("Invalid Param");
      };
    function a(e, t) {
      var i = Math.abs(e),
        r = Math.abs(t);
      return 0 === e ? Math.log(r) : 0 === t ? Math.log(i) : i < 3e3 && r < 3e3 ? .5 * Math.log(e * e + t * t) : Math.log(e / Math.cos(Math.atan2(t, e)));
    }
    function o(e, t) {
      if (!(this instanceof o)) return new o(e, t);
      var i = function (e, t) {
        var i = {
          re: 0,
          im: 0
        };
        if (null == e) i.re = i.im = 0;else if (void 0 !== t) i.re = e, i.im = t;else switch (typeof e) {
          case "object":
            if ("im" in e && "re" in e) i.re = e.re, i.im = e.im;else if ("abs" in e && "arg" in e) {
              if (!Number.isFinite(e.abs) && Number.isFinite(e.arg)) return o.INFINITY;
              i.re = e.abs * Math.cos(e.arg), i.im = e.abs * Math.sin(e.arg);
            } else if ("r" in e && "phi" in e) {
              if (!Number.isFinite(e.r) && Number.isFinite(e.phi)) return o.INFINITY;
              i.re = e.r * Math.cos(e.phi), i.im = e.r * Math.sin(e.phi);
            } else 2 === e.length ? (i.re = e[0], i.im = e[1]) : n();
            break;
          case "string":
            i.im = i.re = 0;
            var r = e.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g),
              a = 1,
              s = 0;
            null === r && n();
            for (var l = 0; l < r.length; l++) {
              var c = r[l];
              " " === c || "\t" === c || "\n" === c || ("+" === c ? a++ : "-" === c ? s++ : "i" === c || "I" === c ? (a + s === 0 && n(), " " === r[l + 1] || isNaN(r[l + 1]) ? i.im += parseFloat((s % 2 ? "-" : "") + "1") : (i.im += parseFloat((s % 2 ? "-" : "") + r[l + 1]), l++), a = s = 0) : ((a + s === 0 || isNaN(c)) && n(), "i" === r[l + 1] || "I" === r[l + 1] ? (i.im += parseFloat((s % 2 ? "-" : "") + c), l++) : i.re += parseFloat((s % 2 ? "-" : "") + c), a = s = 0));
            }
            a + s > 0 && n();
            break;
          case "number":
            i.im = 0, i.re = e;
            break;
          default:
            n();
        }
        return isNaN(i.re) || isNaN(i.im), i;
      }(e, t);
      this.re = i.re, this.im = i.im;
    }
    o.prototype = {
      re: 0,
      im: 0,
      sign: function sign() {
        var e = this.abs();
        return new o(this.re / e, this.im / e);
      },
      add: function add(e, t) {
        var i = new o(e, t);
        return this.isInfinite() && i.isInfinite() ? o.NAN : this.isInfinite() || i.isInfinite() ? o.INFINITY : new o(this.re + i.re, this.im + i.im);
      },
      sub: function sub(e, t) {
        var i = new o(e, t);
        return this.isInfinite() && i.isInfinite() ? o.NAN : this.isInfinite() || i.isInfinite() ? o.INFINITY : new o(this.re - i.re, this.im - i.im);
      },
      mul: function mul(e, t) {
        var i = new o(e, t);
        return this.isInfinite() && i.isZero() || this.isZero() && i.isInfinite() ? o.NAN : this.isInfinite() || i.isInfinite() ? o.INFINITY : 0 === i.im && 0 === this.im ? new o(this.re * i.re, 0) : new o(this.re * i.re - this.im * i.im, this.re * i.im + this.im * i.re);
      },
      div: function div(e, t) {
        var i = new o(e, t);
        if (this.isZero() && i.isZero() || this.isInfinite() && i.isInfinite()) return o.NAN;
        if (this.isInfinite() || i.isZero()) return o.INFINITY;
        if (this.isZero() || i.isInfinite()) return o.ZERO;
        e = this.re, t = this.im;
        var r,
          n,
          a = i.re,
          s = i.im;
        return 0 === s ? new o(e / a, t / a) : Math.abs(a) < Math.abs(s) ? new o((e * (n = a / s) + t) / (r = a * n + s), (t * n - e) / r) : new o((e + t * (n = s / a)) / (r = s * n + a), (t - e * n) / r);
      },
      pow: function pow(e, t) {
        var i = new o(e, t);
        if (e = this.re, t = this.im, i.isZero()) return o.ONE;
        if (0 === i.im) {
          if (0 === t && e > 0) return new o(Math.pow(e, i.re), 0);
          if (0 === e) switch ((i.re % 4 + 4) % 4) {
            case 0:
              return new o(Math.pow(t, i.re), 0);
            case 1:
              return new o(0, Math.pow(t, i.re));
            case 2:
              return new o(-Math.pow(t, i.re), 0);
            case 3:
              return new o(0, -Math.pow(t, i.re));
          }
        }
        if (0 === e && 0 === t && i.re > 0 && i.im >= 0) return o.ZERO;
        var r = Math.atan2(t, e),
          n = a(e, t);
        return e = Math.exp(i.re * n - i.im * r), t = i.im * n + i.re * r, new o(e * Math.cos(t), e * Math.sin(t));
      },
      sqrt: function sqrt() {
        var e,
          t,
          i = this.re,
          r = this.im,
          n = this.abs();
        if (i >= 0) {
          if (0 === r) return new o(Math.sqrt(i), 0);
          e = .5 * Math.sqrt(2 * (n + i));
        } else e = Math.abs(r) / Math.sqrt(2 * (n - i));
        return t = i <= 0 ? .5 * Math.sqrt(2 * (n - i)) : Math.abs(r) / Math.sqrt(2 * (n + i)), new o(e, r < 0 ? -t : t);
      },
      exp: function exp() {
        var e = Math.exp(this.re);
        return this.im, new o(e * Math.cos(this.im), e * Math.sin(this.im));
      },
      expm1: function expm1() {
        var e = this.re,
          t = this.im;
        return new o(Math.expm1(e) * Math.cos(t) + function (e) {
          var t = Math.PI / 4;
          if (e < -t || e > t) return Math.cos(e) - 1;
          var i = e * e;
          return i * (i * (1 / 24 + i * (-1 / 720 + i * (1 / 40320 + i * (-1 / 3628800 + i * (1 / 4790014600 + i * (-1 / 87178291200 + i * (1 / 20922789888e3))))))) - .5);
        }(t), Math.exp(e) * Math.sin(t));
      },
      log: function log() {
        var e = this.re,
          t = this.im;
        return new o(a(e, t), Math.atan2(t, e));
      },
      abs: function abs() {
        return e = this.re, t = this.im, i = Math.abs(e), r = Math.abs(t), i < 3e3 && r < 3e3 ? Math.sqrt(i * i + r * r) : (i < r ? (i = r, r = e / t) : r = t / e, i * Math.sqrt(1 + r * r));
        var e, t, i, r;
      },
      arg: function arg() {
        return Math.atan2(this.im, this.re);
      },
      sin: function sin() {
        var e = this.re,
          t = this.im;
        return new o(Math.sin(e) * i(t), Math.cos(e) * r(t));
      },
      cos: function cos() {
        var e = this.re,
          t = this.im;
        return new o(Math.cos(e) * i(t), -Math.sin(e) * r(t));
      },
      tan: function tan() {
        var e = 2 * this.re,
          t = 2 * this.im,
          n = Math.cos(e) + i(t);
        return new o(Math.sin(e) / n, r(t) / n);
      },
      cot: function cot() {
        var e = 2 * this.re,
          t = 2 * this.im,
          n = Math.cos(e) - i(t);
        return new o(-Math.sin(e) / n, r(t) / n);
      },
      sec: function sec() {
        var e = this.re,
          t = this.im,
          n = .5 * i(2 * t) + .5 * Math.cos(2 * e);
        return new o(Math.cos(e) * i(t) / n, Math.sin(e) * r(t) / n);
      },
      csc: function csc() {
        var e = this.re,
          t = this.im,
          n = .5 * i(2 * t) - .5 * Math.cos(2 * e);
        return new o(Math.sin(e) * i(t) / n, -Math.cos(e) * r(t) / n);
      },
      asin: function asin() {
        var e = this.re,
          t = this.im,
          i = new o(t * t - e * e + 1, -2 * e * t).sqrt(),
          r = new o(i.re - t, i.im + e).log();
        return new o(r.im, -r.re);
      },
      acos: function acos() {
        var e = this.re,
          t = this.im,
          i = new o(t * t - e * e + 1, -2 * e * t).sqrt(),
          r = new o(i.re - t, i.im + e).log();
        return new o(Math.PI / 2 - r.im, r.re);
      },
      atan: function atan() {
        var e = this.re,
          t = this.im;
        if (0 === e) {
          if (1 === t) return new o(0, 1 / 0);
          if (-1 === t) return new o(0, -1 / 0);
        }
        var i = e * e + (1 - t) * (1 - t),
          r = new o((1 - t * t - e * e) / i, -2 * e / i).log();
        return new o(-.5 * r.im, .5 * r.re);
      },
      acot: function acot() {
        var e = this.re,
          t = this.im;
        if (0 === t) return new o(Math.atan2(1, e), 0);
        var i = e * e + t * t;
        return 0 !== i ? new o(e / i, -t / i).atan() : new o(0 !== e ? e / 0 : 0, 0 !== t ? -t / 0 : 0).atan();
      },
      asec: function asec() {
        var e = this.re,
          t = this.im;
        if (0 === e && 0 === t) return new o(0, 1 / 0);
        var i = e * e + t * t;
        return 0 !== i ? new o(e / i, -t / i).acos() : new o(0 !== e ? e / 0 : 0, 0 !== t ? -t / 0 : 0).acos();
      },
      acsc: function acsc() {
        var e = this.re,
          t = this.im;
        if (0 === e && 0 === t) return new o(Math.PI / 2, 1 / 0);
        var i = e * e + t * t;
        return 0 !== i ? new o(e / i, -t / i).asin() : new o(0 !== e ? e / 0 : 0, 0 !== t ? -t / 0 : 0).asin();
      },
      sinh: function sinh() {
        var e = this.re,
          t = this.im;
        return new o(r(e) * Math.cos(t), i(e) * Math.sin(t));
      },
      cosh: function cosh() {
        var e = this.re,
          t = this.im;
        return new o(i(e) * Math.cos(t), r(e) * Math.sin(t));
      },
      tanh: function tanh() {
        var e = 2 * this.re,
          t = 2 * this.im,
          n = i(e) + Math.cos(t);
        return new o(r(e) / n, Math.sin(t) / n);
      },
      coth: function coth() {
        var e = 2 * this.re,
          t = 2 * this.im,
          n = i(e) - Math.cos(t);
        return new o(r(e) / n, -Math.sin(t) / n);
      },
      csch: function csch() {
        var e = this.re,
          t = this.im,
          n = Math.cos(2 * t) - i(2 * e);
        return new o(-2 * r(e) * Math.cos(t) / n, 2 * i(e) * Math.sin(t) / n);
      },
      sech: function sech() {
        var e = this.re,
          t = this.im,
          n = Math.cos(2 * t) + i(2 * e);
        return new o(2 * i(e) * Math.cos(t) / n, -2 * r(e) * Math.sin(t) / n);
      },
      asinh: function asinh() {
        var e = this.im;
        this.im = -this.re, this.re = e;
        var t = this.asin();
        return this.re = -this.im, this.im = e, e = t.re, t.re = -t.im, t.im = e, t;
      },
      acosh: function acosh() {
        var e = this.acos();
        if (e.im <= 0) {
          var t = e.re;
          e.re = -e.im, e.im = t;
        } else t = e.im, e.im = -e.re, e.re = t;
        return e;
      },
      atanh: function atanh() {
        var e = this.re,
          t = this.im,
          i = e > 1 && 0 === t,
          r = 1 - e,
          n = 1 + e,
          s = r * r + t * t,
          l = 0 !== s ? new o((n * r - t * t) / s, (t * r + n * t) / s) : new o(-1 !== e ? e / 0 : 0, 0 !== t ? t / 0 : 0),
          c = l.re;
        return l.re = a(l.re, l.im) / 2, l.im = Math.atan2(l.im, c) / 2, i && (l.im = -l.im), l;
      },
      acoth: function acoth() {
        var e = this.re,
          t = this.im;
        if (0 === e && 0 === t) return new o(0, Math.PI / 2);
        var i = e * e + t * t;
        return 0 !== i ? new o(e / i, -t / i).atanh() : new o(0 !== e ? e / 0 : 0, 0 !== t ? -t / 0 : 0).atanh();
      },
      acsch: function acsch() {
        var e = this.re,
          t = this.im;
        if (0 === t) return new o(0 !== e ? Math.log(e + Math.sqrt(e * e + 1)) : 1 / 0, 0);
        var i = e * e + t * t;
        return 0 !== i ? new o(e / i, -t / i).asinh() : new o(0 !== e ? e / 0 : 0, 0 !== t ? -t / 0 : 0).asinh();
      },
      asech: function asech() {
        var e = this.re,
          t = this.im;
        if (this.isZero()) return o.INFINITY;
        var i = e * e + t * t;
        return 0 !== i ? new o(e / i, -t / i).acosh() : new o(0 !== e ? e / 0 : 0, 0 !== t ? -t / 0 : 0).acosh();
      },
      inverse: function inverse() {
        if (this.isZero()) return o.INFINITY;
        if (this.isInfinite()) return o.ZERO;
        var e = this.re,
          t = this.im,
          i = e * e + t * t;
        return new o(e / i, -t / i);
      },
      conjugate: function conjugate() {
        return new o(this.re, -this.im);
      },
      neg: function neg() {
        return new o(-this.re, -this.im);
      },
      ceil: function ceil(e) {
        return e = Math.pow(10, e || 0), new o(Math.ceil(this.re * e) / e, Math.ceil(this.im * e) / e);
      },
      floor: function floor(e) {
        return e = Math.pow(10, e || 0), new o(Math.floor(this.re * e) / e, Math.floor(this.im * e) / e);
      },
      round: function round(e) {
        return e = Math.pow(10, e || 0), new o(Math.round(this.re * e) / e, Math.round(this.im * e) / e);
      },
      equals: function equals(e, t) {
        var i = new o(e, t);
        return Math.abs(i.re - this.re) <= o.EPSILON && Math.abs(i.im - this.im) <= o.EPSILON;
      },
      clone: function clone() {
        return new o(this.re, this.im);
      },
      toString: function toString() {
        var e = this.re,
          t = this.im,
          i = "";
        return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(e) < o.EPSILON && (e = 0), Math.abs(t) < o.EPSILON && (t = 0), 0 === t ? i + e : (0 !== e ? (i += e, i += " ", t < 0 ? (t = -t, i += "-") : i += "+", i += " ") : t < 0 && (t = -t, i += "-"), 1 !== t && (i += t), i + "i"));
      },
      toVector: function toVector() {
        return [this.re, this.im];
      },
      valueOf: function valueOf() {
        return 0 === this.im ? this.re : null;
      },
      isNaN: function (_isNaN2) {
        function isNaN() {
          return _isNaN2.apply(this, arguments);
        }
        isNaN.toString = function () {
          return _isNaN2.toString();
        };
        return isNaN;
      }(function () {
        return isNaN(this.re) || isNaN(this.im);
      }),
      isZero: function isZero() {
        return 0 === this.im && 0 === this.re;
      },
      isFinite: function (_isFinite2) {
        function isFinite() {
          return _isFinite2.apply(this, arguments);
        }
        isFinite.toString = function () {
          return _isFinite2.toString();
        };
        return isFinite;
      }(function () {
        return isFinite(this.re) && isFinite(this.im);
      }),
      isInfinite: function isInfinite() {
        return !(this.isNaN() || this.isFinite());
      }
    }, o.ZERO = new o(0, 0), o.ONE = new o(1, 0), o.I = new o(0, 1), o.PI = new o(Math.PI, 0), o.E = new o(Math.E, 0), o.INFINITY = new o(1 / 0, 1 / 0), o.NAN = new o(NaN, NaN), o.EPSILON = 1e-15, Object.defineProperty(o, "__esModule", {
      value: !0
    }), o.default = o, o.Complex = o, e.exports = o;
  }();
}(Es), new Ds.exports.Decimal(0), new Ds.exports.Decimal(1), new Ds.exports.Decimal(-1), new Ds.exports.Decimal(NaN), new Ds.exports.Decimal(1 / 0), new Ds.exports.Decimal(-1 / 0), [.9999999999998099, 676.5203681218851, -1259.1392167224028, 771.3234287776531, -176.6150291621406, 12.507343278686905, -.13857109526572012, 9984369578019572e-21, 1.5056327351493116e-7].map(function (e) {
  return new Ds.exports.Decimal(e);
}), new Ds.exports.Decimal(607).div(128), [.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, .0001580887032249125, -.00021026444172410488, .00021743961811521265, -.0001643181065367639, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22].map(function (e) {
  return new Ds.exports.Decimal(e);
});
var Ts = Math.pow(10, -10),
  Os = "List",
  Bs = "Missing",
  Ks = "Nothing",
  Fs = "Add",
  $s = "Divide",
  Ps = "Multiply",
  Is = "Negate",
  Rs = "Power",
  Vs = "Root",
  js = "Sqrt";
function Hs(e) {
  return null !== e && "object" == typeof e && "num" in e;
}
function Us(e) {
  return null !== e && "object" == typeof e && "sym" in e;
}
function Ws(e) {
  return null !== e && "object" == typeof e && "fn" in e;
}
function Zs(e) {
  if ("number" == typeof e) return e;
  if (null === e) return null;
  if (Hs(e)) return e.num.endsWith("d") || e.num.endsWith("n") ? null : parseFloat(e.num);
  var t = el(e);
  return null === t ? null : "NaN" === t ? NaN : "+Infinity" === t ? 1 / 0 : "-Infinity" === t ? -1 / 0 : "Complex" === Js(e) && 0 === Zs(rl(e, 2)) ? Zs(rl(e, 1)) : null;
}
function Gs(e) {
  return null === e ? null : "object" == typeof e && "str" in e ? e.str : "string" != typeof e || e.length < 2 || "'" !== e[0] || "'" !== e[e.length - 1] ? null : e.substring(1, e.length - 1);
}
function Xs(e) {
  var t, i, r, n, a, o;
  var s = el(e);
  if ("ThreeQuarter" === s) return [3, 4];
  if ("TwoThird" === s) return [2, 3];
  if ("Half" === s) return [1, 2];
  if ("Third" === s) return [1, 3];
  if ("Quarter" === s) return [1, 4];
  if (Qs(e)) return [null, null];
  var l = Js(e);
  if (!l) return [null, null];
  var c = null,
    u = null;
  if (l === Rs) {
    var _r74 = Zs(rl(e, 2));
    1 === _r74 ? (c = null !== (t = Zs(rl(e, 1))) && void 0 !== t ? t : null, u = 1) : -1 === _r74 && (c = 1, u = null !== (i = Zs(rl(e, 1))) && void 0 !== i ? i : null);
  }
  return l === $s && (c = null !== (r = Zs(rl(e, 1))) && void 0 !== r ? r : null, u = null !== (n = Zs(rl(e, 2))) && void 0 !== n ? n : null), l === Ps && Js(rl(e, 2)) === Rs && -1 === Zs(rl(rl(e, 2), 2)) && (c = null !== (a = Zs(rl(e, 1))) && void 0 !== a ? a : null, u = null !== (o = Zs(rl(rl(e, 2), 1))) && void 0 !== o ? o : null), null === c || null === u ? [null, null] : Number.isInteger(c) && Number.isInteger(u) ? [c, u] : [null, null];
}
function Ys(e) {
  return null === e ? null : Array.isArray(e) ? e[0] : Ws(e) ? e.fn[0] : null;
}
function Qs(e) {
  return null === e || !Array.isArray(e) && ("object" != typeof e || !("fn" in e || "dic" in e));
}
function Js(e) {
  if (null === e) return "";
  var t = Ys(e);
  return "string" == typeof t ? t : "";
}
function el(e) {
  return null === e ? null : "string" == typeof e ? e.length >= 2 && "'" === e[0] && "'" === e[e.length - 1] ? null : e : Us(e) ? e.sym : null;
}
function tl(e) {
  return Array.isArray(e) ? e.slice(1) : Ws(e) ? e.fn.slice(1) : [];
}
function il(e, t) {
  var i = null;
  if (Array.isArray(e) && (i = e), Ws(e) && (i = e.fn), null === i) return [];
  var r = 1;
  var n = [];
  for (; r < i.length;) n.push(t(i[r])), r += 1;
  return n;
}
function rl(e, t) {
  var i, r;
  return null === e ? null : Array.isArray(e) ? null !== (i = e[t]) && void 0 !== i ? i : null : Ws(e) && null !== (r = e.fn[t]) && void 0 !== r ? r : null;
}
function nl(e) {
  return Array.isArray(e) ? Math.max(0, e.length - 1) : Ws(e) ? Math.max(0, e.fn.length - 1) : 0;
}
function al(e) {
  return "object" == typeof e && "dict" in e ? e.dict : null;
}
var ol = [{
  name: "Overscript",
  trigger: {
    infix: "\\overset"
  },
  precedence: 700
}, {
  name: "Underscript",
  trigger: {
    infix: "\\underset"
  },
  precedence: 700
}, {
  name: "Increment",
  trigger: {
    postfix: ["+", "+"]
  },
  precedence: 880
}, {
  name: "Decrement",
  trigger: {
    postfix: ["-", "-"]
  },
  precedence: 880
}, {
  name: "PreIncrement",
  trigger: {
    prefix: ["+", "+"]
  },
  precedence: 880
}, {
  name: "PreDecrement",
  trigger: {
    prefix: ["-", "-"]
  },
  precedence: 880
}, {
  name: "Ring",
  trigger: {
    infix: "\\circ"
  },
  precedence: 265
}, {
  name: "Transpose",
  trigger: {
    superfix: "T"
  }
}, {
  name: "ConjugateTranspose",
  trigger: {
    superfix: "H"
  }
}, {
  name: "StringJoin",
  trigger: {
    infix: ["\\lt", "\\gt"]
  },
  precedence: 780
}, {
  name: "Starstar",
  trigger: {
    infix: ["\\star", "\\star"]
  },
  precedence: 780
}, {
  name: "PartialDerivative",
  trigger: {
    prefix: "\\partial"
  },
  parse: function parse(e, t, i) {
    var r, n;
    var a = !1,
      o = Ks,
      s = Ks;
    for (; !a;) t.skipSpace(), t.match("_") ? s = t.matchRequiredLatexArgument() : t.match("^") ? o = t.matchRequiredLatexArgument() : a = !0;
    if ("Sequence" === Js(s) && (s = [Os].concat(_toConsumableArray(tl(s)))), !s || !o) return [e, null];
    var l = null !== (r = t.matchRequiredLatexArgument()) && void 0 !== r ? r : Ks;
    return l !== Ks && (l = [l].concat(_toConsumableArray(null !== (n = t.matchArguments("group")) && void 0 !== n ? n : Ks))), [null, ["PartialDerivative", l, s, o]];
  },
  serialize: function serialize(e, t) {
    var i = "\\partial";
    var r = rl(t, 1),
      n = rl(t, 2),
      a = rl(t, 3);
    return null !== n && n !== Ks && (Ys(n) === Os ? i += "_{" + e.serialize(["Sequence"].concat(_toConsumableArray(tl(n)))) + "}" : i += "_{" + e.serialize(n) + "}"), null !== a && a !== Ks && (i += "^{" + e.serialize(a) + "}"), null !== r && r !== Ks && (i += e.serialize(r)), i;
  },
  precedence: 740
}, {
  name: "OverBar",
  trigger: {
    symbol: "\\overline"
  },
  requiredLatexArg: 1
}, {
  name: "UnderBar",
  trigger: {
    symbol: "\\underline"
  },
  requiredLatexArg: 1
}, {
  name: "OverVector",
  trigger: {
    symbol: "\\vec"
  },
  requiredLatexArg: 1
}, {
  name: "OverTile",
  trigger: {
    symbol: "\\tilde"
  },
  requiredLatexArg: 1
}, {
  name: "OverHat",
  trigger: {
    symbol: "\\hat"
  },
  requiredLatexArg: 1
}, {
  name: "OverHat",
  trigger: {
    symbol: "\\hat"
  },
  requiredLatexArg: 1
}, {
  name: "OverRightArrow",
  trigger: {
    symbol: "\\overrightarrow"
  },
  requiredLatexArg: 1
}, {
  name: "OverLeftArrow",
  trigger: {
    symbol: "\\overleftarrow"
  },
  requiredLatexArg: 1
}, {
  name: "OverRightDoubleArrow",
  trigger: {
    symbol: "\\Overrightarrow"
  },
  requiredLatexArg: 1
}, {
  name: "OverLeftHarpoon",
  trigger: {
    symbol: "\\overleftharpoon"
  },
  requiredLatexArg: 1
}, {
  name: "OverRightHarpoon",
  trigger: {
    symbol: "\\overrightharpoon"
  },
  requiredLatexArg: 1
}, {
  name: "OverLeftRightArrow",
  trigger: {
    symbol: "\\overleftrightarrow"
  },
  requiredLatexArg: 1
}, {
  name: "OverBrace",
  trigger: {
    symbol: "\\overbrace"
  },
  requiredLatexArg: 1
}, {
  name: "OverLineSegment",
  trigger: {
    symbol: "\\overlinesegment"
  },
  requiredLatexArg: 1
}, {
  name: "OverGroup",
  trigger: {
    symbol: "\\overgroup"
  },
  requiredLatexArg: 1
}];
function sl(e, t) {
  return t > 2 ? "solidus" : "radical";
}
function ll(e) {
  return "<space>" === e || "\\qquad" === e || "\\quad" === e || "\\enskip" === e || "\\;" === e || "\\," === e || "\\ " === e || "~" === e;
}
function cl(e, t, i) {
  return function (r, n, a) {
    if (a >= t) return [r, null];
    n.skipSpace(), n.match(i), "Missing" === r && (r = Ks);
    var o = [e, null != r ? r : Ks];
    var s = !1;
    for (; !s;) {
      for (s = !0, n.skipSpace(); n.match(i);) o.push(Ks), n.skipSpace();
      if (n.atEnd) o.push(Ks);else {
        var _e247 = n.matchExpression(t);
        o.push(null != _e247 ? _e247 : Ks), s = null === _e247;
      }
      s || (n.skipSpace(), s = !n.match(i));
    }
    return [null, o];
  };
}
function ul(e) {
  return function (t, i) {
    return tl(i).map(function (e) {
      return t.serialize(e);
    }).join(e);
  };
}
var dl = [{
  name: "LatexTokens",
  serialize: function serialize(e, t) {
    return tl(t).map(function (t) {
      var i = Gs(t);
      return null === i ? e.serialize(t) : "<{>" === i ? "{" : "<}>" === i ? "}" : "<$>" === i ? "$" : "<$$>" === i ? "$$" : "<space>'" === i ? " " : i;
    }).join("");
  }
}, {
  name: "Parentheses",
  trigger: {
    matchfix: "("
  },
  parse: function parse(e, t, i) {
    var r;
    var n = t.index;
    if (!t.match("(")) return [e, null];
    var a = !1,
      o = !0,
      s = !1,
      l = 0,
      c = "";
    for (; !a && o;) {
      var _e248 = t.next();
      t.atEnd || ")" === _e248 ? a = !0 : "\\mathtt" === _e248 ? (t.match("<{>"), s = !0) : ll(_e248) || (/^[0-9a-zA-Z]$/.test(_e248) ? (l = Math.max(l, parseInt(_e248, 36)), c += _e248) : o = !1), s && t.match("<}>");
    }
    if (t.skipSpace(), o && t.match("_")) {
      var _i185 = null !== (r = Zs(t.matchRequiredLatexArgument())) && void 0 !== r ? r : NaN;
      return !isFinite(_i185) || _i185 < 2 || _i185 > 36 || l >= _i185 ? (t.onError({
        code: "base-out-of-range"
      }), [e, Ks]) : [e, ["BaseForm", parseInt(c, _i185), _i185]];
    }
    t.index = n;
    var u = t.matchBalancedExpression("(", ")", t.onError);
    return u ? "Sequence" === Js(u) ? [e, ["Parentheses"].concat(_toConsumableArray(tl(u)))] : [e, ["Parentheses", u]] : [e, ["Parentheses"]];
  },
  serialize: function serialize(e, t) {
    return e.wrapString(ul(",")(e, t), (e.level, "paren"));
  },
  separator: ",",
  closeFence: ")",
  precedence: 20
}, {
  name: Os,
  trigger: {
    matchfix: "\\lbrack"
  },
  separator: ",",
  closeFence: "\\rbrack",
  precedence: 20,
  parse: function parse(e, t, i) {
    if (null === e) {
      var _i186 = t.matchBalancedExpression("\\lbrack", "\\rbrack", t.onError);
      return _i186 ? "Sequence" === Js(_i186) ? [e, [Os].concat(_toConsumableArray(tl(_i186)))] : [e, [Os, _i186]] : [null, [Os]];
    }
    return [e, null];
  }
}, {
  name: "BaseForm",
  serialize: function serialize(e, t) {
    var i, r;
    var n = null !== (i = Zs(rl(t, 2))) && void 0 !== i ? i : NaN;
    if (isFinite(n) && n >= 2 && n <= 36) {
      var _e249 = null !== (r = Zs(rl(t, 1))) && void 0 !== r ? r : NaN;
      if (isFinite(_e249)) {
        var _t202 = Number(_e249).toString(n),
          _i187 = 0;
        if (2 === n || 10 === n ? _i187 = 4 : 16 === n ? _i187 = 2 : n > 16 && (_i187 = 4), _i187 > 0) {
          var _e250 = _t202;
          _t202 = "";
          for (var _r75 = 0; _r75 < _e250.length; _r75++) _r75 > 0 && _r75 % _i187 == 0 && (_t202 = "\\, " + _t202), _t202 = _e250[_e250.length - _r75 - 1] + _t202;
        }
        return "(\\mathtt{".concat(_t202, "})_{").concat(n, "}");
      }
    }
    return "\\operatorname{BaseForm}(" + e.serialize(rl(t, 1)) + ", " + e.serialize(rl(t, 2)) + ")";
  }
}, {
  name: "Set",
  trigger: {
    matchfix: "\\lbrace"
  },
  separator: ",",
  closeFence: "\\rbrace",
  precedence: 20
}, {
  name: "Sequence",
  trigger: {
    infix: ","
  },
  parse: cl("Sequence", 20, ","),
  serialize: ul(", "),
  precedence: 20
}, {
  name: "Sequence2",
  trigger: {
    infix: ";"
  },
  parse: cl("Sequence2", 19, ";"),
  serialize: ul("; "),
  precedence: 19
}, {
  name: Bs,
  trigger: "\\placeholder",
  serialize: "\\placeholder",
  requiredLatexArg: 1
}, {
  name: "Subscript",
  trigger: {
    infix: "_"
  },
  precedence: 720,
  serialize: function serialize(e, t) {
    return 2 === nl(t) ? e.serialize(rl(t, 1)) + "_{" + e.serialize(rl(t, 2)) + "}" : "_{" + e.serialize(rl(t, 1)) + "}";
  },
  parse: function parse(e, t, i) {
    var r;
    if (!t.match("_")) return [e, null];
    var n = null !== (r = t.matchRequiredLatexArgument()) && void 0 !== r ? r : Bs;
    return e ? [null, ["Subscript", e, n]] : [null, ["Subscript", n]];
  }
}, {
  name: "Superplus",
  trigger: {
    superfix: "+"
  }
}, {
  name: "Subplus",
  trigger: {
    subfix: "+"
  }
}, {
  name: "Superminus",
  trigger: {
    superfix: "-"
  }
}, {
  name: "Subminus",
  trigger: {
    subfix: "-"
  }
}, {
  name: "Superstar",
  trigger: {
    superfix: "*"
  }
}, {
  name: "Superstar",
  trigger: {
    superfix: "\\star"
  }
}, {
  name: "Substar",
  trigger: {
    subfix: "*"
  }
}, {
  name: "Substar",
  trigger: {
    subfix: "\\star"
  }
}, {
  name: "Superdagger",
  trigger: {
    superfix: "\\dagger"
  }
}, {
  name: "Superdagger",
  trigger: {
    superfix: "\\dag"
  }
}, {
  name: "Prime",
  trigger: {
    superfix: "\\prime"
  },
  arguments: "group"
}, {
  trigger: {
    superfix: "\\doubleprime"
  },
  parse: function parse(e, t) {
    return [null, ["Prime", null != e ? e : Ks, 2]];
  },
  arguments: "group"
}, {
  name: "InverseFunction",
  serialize: function serialize(e, t) {
    return e.serialize(rl(t, 1)) + "^{-1}";
  }
}, {
  name: "Derivative",
  trigger: "D",
  parse: function parse(e, t) {
    return [e, ["Derivative", 1]];
  },
  serialize: function serialize(e, t) {
    var i;
    var r = null !== (i = Zs(rl(t, 1))) && void 0 !== i ? i : NaN;
    if (!isFinite(r)) return "";
    var n = e.serialize(rl(t, 2));
    return 1 === r ? n + "^{\\prime}" : 2 === r ? n + "^{\\doubleprime}" : n + "^{(" + Number(r).toString() + ")}";
  }
}, {
  name: "Piecewise",
  trigger: {
    environment: "cases"
  },
  parse: function parse(e, t) {
    var i;
    return [e, ["Piecewise", null !== (i = t.matchTabular()) && void 0 !== i ? i : Ks]];
  },
  serialize: function serialize(e, t) {
    if (Js(rl(t, 1)) !== Os) return "";
    var i = tl(rl(t, 1));
    var r = "",
      n = "";
    var _iterator125 = _createForOfIteratorHelper(i),
      _step125;
    try {
      for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
        var _t203 = _step125.value;
        r += n;
        var _i188 = rl(_t203, 1);
        if (null !== _i188) {
          r += e.serialize(_i188);
          var _n68 = rl(_t203, 2);
          null !== _n68 && (r += "&" + e.serialize(_n68));
        }
        n = "\\\\";
      }
    } catch (err) {
      _iterator125.e(err);
    } finally {
      _iterator125.f();
    }
    return "\\begin{cases}" + r + "\\end{cases}";
  }
}];
function hl(e) {
  var t, i, r, n;
  if ("number" == typeof (e = pl(e))) return -e;
  if (e && Hs(e)) return "-" === e.num[0] ? {
    num: e.num.slice(1)
  } : "+" === e.num[0] ? {
    num: "-" + e.num.slice(1)
  } : {
    num: "-" + e.num
  };
  if (e instanceof Ds.exports.Decimal) return e.mul(-1);
  if (e instanceof Es.exports.Complex) return e.mul(-1);
  var a = Js(e),
    o = nl(e);
  if (a === Is && 1 === o) return null !== (t = rl(e, 1)) && void 0 !== t ? t : Bs;
  if (a === Ps) {
    var _t204 = hl(null !== (i = rl(e, 1)) && void 0 !== i ? i : Bs);
    return [Ps, _t204].concat(_toConsumableArray(tl(e).slice(1)));
  }
  return a === Fs ? [Fs].concat(_toConsumableArray(il(e, hl))) : "Subtract" === a ? ["Subtract", null !== (r = rl(e, 2)) && void 0 !== r ? r : Bs, null !== (n = rl(e, 1)) && void 0 !== n ? n : Bs] : "Parentheses" === a && 1 === o ? hl(rl(rl(e, 1), 1)) : [Is, null != e ? e : Bs];
}
function pl(e) {
  return null === e ? Ks : Qs(e) ? e : "Parentheses" === Ys(e) && 1 === nl(e) ? pl(rl(e, 1)) : function (e, t) {
    var i = Ys(e);
    if (null !== i) return [t(i)].concat(_toConsumableArray(tl(e).map(t)));
    var r = al(e);
    if (null !== r) {
      var _e251 = Object.keys(r),
        _i189 = {};
      for (var _i190 = 0, _e252 = _e251; _i190 < _e252.length; _i190++) {
        var _n69 = _e252[_i190];
        _i189[_n69] = t(r[_n69]);
      }
      return {
        dict: _i189
      };
    }
    return t(e);
  }(e, pl);
}
function ml(e, t, i, r) {
  return null === i ? "\\sqrt{}" : (r = null != r ? r : 2, "solidus" === t ? e.wrapShort(i) + "^{1\\/" + e.serialize(r) + "}" : "quotient" === t ? e.wrapShort(i) + "^{\\frac{1}{" + e.serialize(r) + "}}" : 2 === Zs(r) ? "\\sqrt{" + e.serialize(i) + "}" : "\\sqrt[" + e.serialize(r) + "]{" + e.serialize(i) + "}");
}
function fl(e, t, i) {
  if (!t.match("\\sqrt")) return [e, null];
  var r = t.matchOptionalLatexArgument(),
    n = t.matchRequiredLatexArgument();
  return null === n ? null !== r ? [e, [Vs, Ks, r]] : [e, [js]] : null !== r ? [e, [Vs, n, r]] : [e, [js, n]];
}
function gl(e, t, i) {
  if (276 < i) return [e, null];
  var r = t.index;
  if (!t.match("-")) return [e, null];
  var n = t.matchExpression(null === e ? 400 : 277);
  return null === n ? (t.index = r, [e, null]) : null === e ? [null, [Is, n]] : [null, ["Subtract", e, n]];
}
function yl(e, t) {
  var i;
  if (null === t) return "";
  e.level -= 1;
  var r = "";
  var _ref21 = function (e) {
      var t, i, r, n, a, o;
      if (Js(e) !== Ps) return [[], []];
      var s = [],
        l = [],
        c = tl(e);
      var _iterator126 = _createForOfIteratorHelper(c),
        _step126;
      try {
        for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
          var _e253 = _step126.value;
          if (Js(_e253) === Rs) {
            if (Js(rl(_e253, 2)) === Is) {
              var _r76 = null !== (t = rl(_e253, 1)) && void 0 !== t ? t : Ks,
                _n70 = null !== (i = rl(rl(_e253, 2), 1)) && void 0 !== i ? i : Ks;
              l.push([Rs, _r76, _n70]);
            } else {
              var _t205 = null !== (r = Zs(rl(_e253, 2))) && void 0 !== r ? r : NaN;
              -1 === _t205 ? l.push(null !== (n = rl(_e253, 1)) && void 0 !== n ? n : Ks) : _t205 < 0 ? l.push([Rs, null !== (a = rl(_e253, 1)) && void 0 !== a ? a : Ks, null !== (o = hl(rl(_e253, 2))) && void 0 !== o ? o : Ks]) : s.push(_e253);
            }
          } else s.push(_e253);
        }
      } catch (err) {
        _iterator126.e(err);
      } finally {
        _iterator126.f();
      }
      return [s, l];
    }(t),
    _ref22 = _slicedToArray(_ref21, 2),
    n = _ref22[0],
    a = _ref22[1];
  if (a.length > 0 && (r = 1 === a.length && 1 === a[0] ? 0 === n.length ? "1" : 1 === n.length ? e.serialize(n[0]) : yl(e, [Ps].concat(_toConsumableArray(n))) : e.serialize([$s, 1 === n.length ? n[0] : [Ps].concat(_toConsumableArray(n)), 1 === a.length ? a[0] : [Ps].concat(_toConsumableArray(a))])), r) return e.level += 1, r;
  var o = !1,
    s = null;
  var l = nl(t) + 1;
  var c = !1;
  for (var _n71 = 1; _n71 < l; _n71++) if (s = rl(t, _n71), null !== s) {
    var _t206 = void 0;
    "number" == typeof s || Hs(s) ? (_t206 = e.serialize(s), "-1" !== _t206 || r ? ("-" === _t206[0] && (_t206 = _t206.slice(1), o = !o), r = r ? As([r, e.options.multiply, _t206]) : _t206) : r = "-", c = !0) : Js(s) !== Rs || isNaN(null !== (i = Zs(rl(s, 1))) && void 0 !== i ? i : NaN) ? (Js(s) === Is && (s = rl(s, 1), o = !o), _t206 = e.wrap(s, 390), r = r ? c && Js(s) === $s ? As([r, "\\times", _t206]) : e.options.invisibleMultiply ? As([r, e.options.invisibleMultiply, _t206]) : As([r, _t206]) : _t206, c = !1) : (r = r ? As([r, e.options.multiply, e.serialize(s)]) : e.serialize(s), c = !0);
  }
  return e.level += 1, o ? "-" + r : r;
}
function bl(e, t) {
  if (null === t) return "";
  if (1 === nl(t)) return e.serialize(rl(t, 1));
  var i = e.level > 3 ? "inline-solidus" : "quotient";
  if ("inline-solidus" === i || "nice-solidus" === i) {
    var _r77 = e.wrapShort(rl(t, 1)),
      _n72 = e.wrapShort(rl(t, 2));
    return "nice-solidus" === i ? "^{".concat(_r77, "}\\!\\!/\\!_{").concat(_n72, "}") : "".concat(_r77, "\\/").concat(_n72);
  }
  return "reciprocal" === i ? e.wrap(rl(t, 1)) + e.wrap(rl(t, 2)) + "^{-1}" : "factor" === i ? "\\frac{1}{" + e.serialize(rl(t, 2)) + "}" + e.wrap(rl(t, 1)) : "\\frac{" + e.serialize(rl(t, 1)) + "}{" + e.serialize(rl(t, 2)) + "}";
}
function vl(e, t) {
  var i;
  var r = rl(t, 1),
    n = rl(t, 2);
  if (null === n) return e.serialize(r);
  if (null === r) return "";
  var a = Js(t);
  if (a === js || a === Vs) return ml(e, sl(0, e.level), rl(t, 1), rl(t, 2));
  var o = null !== (i = Zs(n)) && void 0 !== i ? i : 1;
  if (-1 === o) return e.serialize([$s, "1", r]);
  if (o < 0) return e.serialize([$s, "1", [Rs, r, -o]]);
  if (Js(n) === $s) {
    if (1 === Zs(rl(n, 1))) return ml(e, sl(0, e.level), r, rl(n, 2));
  } else if (Js(n) === Rs && -1 === Zs(rl(n, 2))) return ml(e, sl(0, e.level), r, rl(n, 1));
  return e.wrapShort(r) + "^{" + e.serialize(n) + "}";
}
function xl(e, t, i) {
  var r;
  var n = t.next();
  var a = !1,
    o = 0;
  if (t.skipSpace(), t.match("^")) {
    if (t.skipSpace(), t.match("<{>")) {
      t.skipSpace(), t.match("-") && t.match("1") && (a = !0);
      do {
        t.match("\\doubleprime") && (o += 2), t.match("\\prime") && (o += 1), t.match("'") && (o += 1);
      } while (!t.match("<}>") && !t.atEnd);
    }
    var _e254 = !1;
    for (; !_e254;) t.skipSpace(), t.match("\\doubleprime") ? o += 2 : t.match("\\prime") || t.match("'") ? o += 1 : _e254 = !0;
  }
  var s = null !== (r = {
    "\\arcsin": "Arcsin",
    "\\arccos": "Arccos",
    "\\arctan": "Arctan",
    "\\arctg": "Arctan",
    "\\arcctg": "Arctan",
    "\\arcsec": "Arcsec",
    "\\arccsc": " Arccsc",
    "\\arsinh": "Arsinh",
    "\\arcosh": "Arcosh",
    "\\artanh": "Artanh",
    "\\arcsech": "Arcsech",
    "\\arccsch": "Arcsch",
    "\\ch": "Cosh",
    "\\cos": "Cos",
    "\\cosec": "Csc",
    "\\cosh": "Csch",
    "\\cot": "Cot",
    "\\cotg": "Cot",
    "\\coth": "Coth",
    "\\csc": "Csc",
    "\\ctg": "Cot",
    "\\cth": "Coth",
    "\\sec": "Sec",
    "\\sin": "Sin",
    "\\sinh": "Sinh",
    "\\sh": "Sinh",
    "\\tan": "Tan",
    "\\tanh": "Tanh",
    "\\tg": "Tan",
    "\\th": "Tanh"
  }[n]) && void 0 !== r ? r : n;
  a && (s = ["InverseFunction", s]), o >= 1 && (s = ["Derivative", o, s]);
  var l = t.matchArguments("implicit");
  return null === l ? [null, s] : [null, [s].concat(_toConsumableArray(l))];
}
function kl(e) {
  return Ns(e);
}
Number.EPSILON.toString();
var wl = {
    algebra: [{
      name: "To",
      trigger: {
        infix: "\\to"
      },
      precedence: 270
    }],
    arithmetic: [{
      name: "ThreeQuarter",
      serialize: "\\frac{3}{4}"
    }, {
      name: "TwoThird",
      serialize: "\\frac{2}{3}"
    }, {
      name: "Half",
      serialize: "\\frac{1}{2}"
    }, {
      name: "Third",
      serialize: "\\frac{1}{3}"
    }, {
      name: "Quarter",
      serialize: "\\frac{1}{4}"
    }, {
      name: "CatalanConstant",
      serialize: "G"
    }, {
      name: "GoldenRatio",
      serialize: "\\varphi"
    }, {
      name: "EulerGamma",
      serialize: "\\gamma"
    }, {
      name: "Degrees",
      serialize: "\\frac{\\pi}{180}"
    }, {
      name: "MinusDoublePi",
      serialize: "-2\\pi"
    }, {
      name: "MinusPi",
      serialize: "-\\pi"
    }, {
      name: "MinusHalfPi",
      serialize: "-\\frac{\\pi}{2}"
    }, {
      name: "QuarterPi",
      serialize: "\\frac{\\pi}{4}"
    }, {
      name: "ThirdPi",
      serialize: "\\frac{\\pi}{3}"
    }, {
      name: "HalfPi",
      serialize: "\\frac{\\pi}{2}"
    }, {
      name: "TwoThirdPi",
      serialize: "\\frac{2\\pi}{3}"
    }, {
      name: "ThreeQuarterPi",
      serialize: "\\frac{3\\pi}{4}"
    }, {
      name: "DoublePi",
      serialize: "2\\pi"
    }, {
      name: "Complex",
      precedence: 275,
      serialize: function serialize(e, t) {
        var i = Zs(rl(t, 1)),
          r = Zs(rl(t, 2));
        if (0 === r) return e.serialize(rl(t, 1));
        var n = 1 === r ? "\\imaginaryI" : -1 === r ? "-\\imaginaryI" : As([e.serialize(rl(t, 2)), "\\imaginaryI"]);
        return 0 === i ? n : As([e.serialize(rl(t, 1)), "+", n]);
      }
    }, {
      name: "Exp",
      serialize: function serialize(e, t) {
        var i;
        return As(["\\exponentialE^{", e.serialize(null !== (i = rl(t, 1)) && void 0 !== i ? i : Ks), "}"]);
      }
    }, {
      name: "Square",
      serialize: function serialize(e, t) {
        return e.wrapShort(rl(t, 1)) + "^2";
      }
    }, {
      trigger: {
        symbol: "\\infty"
      },
      parse: {
        num: "+Infinity"
      }
    }, {
      name: "ComplexInfinity",
      trigger: {
        symbol: ["\\tilde", "\\infty"]
      },
      serialize: "\\tilde\\infty"
    }, {
      name: "ComplexInfinity",
      trigger: {
        symbol: ["\\tilde", "<{>", "\\infty", "<}>"]
      },
      serialize: "\\tilde\\infty"
    }, {
      name: "Pi",
      trigger: {
        symbol: "\\pi"
      }
    }, {
      name: "Pi",
      trigger: {
        symbol: "\u03C0"
      },
      serialize: "\\pi"
    }, {
      name: "ExponentialE",
      trigger: {
        symbol: "e"
      },
      serialize: "e"
    }, {
      name: "ImaginaryUnit",
      trigger: {
        symbol: "i"
      },
      serialize: "\\imaginaryI"
    }, {
      name: "ImaginaryUnit",
      trigger: {
        symbol: "\\imaginaryI"
      }
    }, {
      name: Fs,
      trigger: {
        prefix: "+",
        infix: "+"
      },
      parse: function parse(e, t, i) {
        if (275 < i) return [e, null];
        var r = t.index;
        if (!t.match("+")) return [e, null];
        var n = t.matchExpression(null === e ? 400 : 275);
        return null === n ? (t.index = r, [e, null]) : null === e ? [null, n] : t.applyOperator(Fs, e, n);
      },
      serialize: function serialize(e, t) {
        var i, r;
        e.level -= 1;
        var n = Js(t);
        var a = "",
          o = rl(t, 1),
          s = !Number.isNaN(null !== (i = Zs(o)) && void 0 !== i ? i : NaN);
        if (n === Is) a = "-" + e.wrap(o, 276);else if (n === Fs) {
          a = e.serialize(o);
          var _i191 = nl(t) + 1;
          for (var _n73 = 2; _n73 < _i191; _n73++) {
            o = rl(t, _n73);
            var _i192 = null !== (r = Zs(o)) && void 0 !== r ? r : NaN,
              _l12 = !Number.isNaN(_i192);
            var _c6 = !1;
            if (null !== o && s) {
              var _Xs = Xs(o),
                _Xs2 = _slicedToArray(_Xs, 2),
                _t207 = _Xs2[0],
                _i193 = _Xs2[1];
              null !== _t207 && null !== _i193 && isFinite(_t207) && isFinite(_i193) && 1 !== _i193 && (a += e.options.invisiblePlus + e.serialize(o), _c6 = !0);
            }
            if (!_c6) if (_i192 < 0) a += e.serialize(o);else if (Js(o) === Is) a += e.wrap(o, 275);else {
              var _t208 = e.wrap(o, 275);
              "-" === _t208[0] || "+" === _t208[0] ? a += _t208 : a = a + "+" + _t208;
            }
            s = _l12;
          }
        } else if ("Subtract" === n) {
          var _i194 = rl(t, 2);
          a = null !== _i194 ? e.wrap(o, 275) + "-" + e.wrap(_i194, 275) : e.wrap(o, 275);
        }
        return e.level += 1, a;
      },
      associativity: "both",
      precedence: 275
    }, {
      name: Is,
      trigger: {
        prefix: "-"
      },
      parse: gl,
      associativity: "left",
      precedence: 275
    }, {
      name: "Subtract",
      trigger: {
        infix: "-"
      },
      parse: gl,
      associativity: "both",
      precedence: 275
    }, {
      name: "PlusMinus",
      trigger: {
        infix: "\\pm"
      },
      associativity: "both",
      precedence: 270
    }, {
      name: "MinusPlus",
      trigger: {
        infix: "\\mp"
      },
      associativity: "both",
      precedence: 270
    }, {
      name: Ps,
      trigger: {
        infix: "\\times"
      },
      serialize: yl,
      associativity: "both",
      precedence: 390
    }, {
      name: Ps,
      trigger: {
        infix: "\\cdot"
      },
      serialize: yl,
      associativity: "both",
      precedence: 390
    }, {
      name: Ps,
      trigger: {
        infix: "*"
      },
      serialize: yl,
      associativity: "both",
      precedence: 390
    }, {
      name: $s,
      trigger: "\\frac",
      parse: function parse(e, t, i) {
        var r, n, a, o;
        if (!t.match("\\frac")) return [e, null];
        var s = null !== (r = t.matchRequiredLatexArgument()) && void 0 !== r ? r : Bs,
          l = null !== (n = t.matchRequiredLatexArgument()) && void 0 !== n ? n : Bs;
        if ("PartialDerivative" === Js(s) && ("PartialDerivative" === Js(l) || Js(l) === Ps && "PartialDerivative" === Js(rl(l, 1)))) {
          var _i195 = null !== (a = rl(s, 3)) && void 0 !== a ? a : Ks;
          var _r78 = rl(s, 1);
          null !== _r78 && _r78 !== Ks || (_r78 = null !== (o = t.matchExpression()) && void 0 !== o ? o : Ks);
          var _n74 = [];
          if (Js(l) === Ps) {
            var _iterator127 = _createForOfIteratorHelper(tl(l)),
              _step127;
            try {
              for (_iterator127.s(); !(_step127 = _iterator127.n()).done;) {
                var _e255 = _step127.value;
                if ("PartialDerivative" === Ys(_e255)) {
                  var _t209 = rl(_e255, 2);
                  _t209 && _n74.push(_t209);
                }
              }
            } catch (err) {
              _iterator127.e(err);
            } finally {
              _iterator127.f();
            }
          } else {
            var _e256 = rl(l, 2);
            _e256 && _n74.push(_e256);
          }
          return _n74.length > 1 && (_n74 = [Os].concat(_toConsumableArray(_n74))), [e, ["PartialDerivative", _r78, _n74, _i195 === Ks ? 1 : _i195]];
        }
        return [e, [$s, s, l]];
      },
      serialize: bl,
      requiredLatexArg: 2
    }, {
      name: $s,
      trigger: {
        infix: "\\/"
      },
      serialize: bl,
      associativity: "non",
      precedence: 660
    }, {
      name: $s,
      trigger: {
        infix: "/"
      },
      serialize: bl,
      associativity: "non",
      precedence: 660
    }, {
      name: $s,
      trigger: {
        infix: "\\div"
      },
      serialize: bl,
      associativity: "non",
      precedence: 660
    }, {
      name: Rs,
      trigger: {
        infix: "^"
      },
      associativity: "non",
      precedence: 720,
      serialize: vl
    }, {
      name: Rs,
      trigger: {
        infix: ["*", "*"]
      },
      associativity: "non",
      precedence: 720,
      serialize: vl
    }, {
      name: js,
      trigger: "\\sqrt",
      optionalLatexArg: 1,
      requiredLatexArg: 1,
      parse: fl,
      serialize: vl
    }, {
      name: Vs,
      trigger: "\\sqrt",
      optionalLatexArg: 1,
      requiredLatexArg: 1,
      parse: fl
    }, {
      name: "Norm",
      trigger: {
        matchfix: "\\lVert"
      },
      closeFence: "\\rVert"
    }, {
      name: "Norm",
      trigger: {
        matchfix: "\\|"
      },
      closeFence: "\\|"
    }, {
      name: "Norm",
      trigger: {
        matchfix: ["|", "|"]
      },
      closeFence: ["|", "|"]
    }, {
      name: "Abs",
      trigger: {
        matchfix: "|"
      },
      closeFence: "|"
    }, {
      name: "Abs",
      trigger: {
        matchfix: "\\lvert"
      },
      closeFence: "\\rvert"
    }, {
      name: "Factorial",
      trigger: {
        postfix: "!"
      },
      precedence: 810
    }, {
      name: "Factorial2",
      trigger: {
        postfix: ["!", "!"]
      },
      precedence: 810
    }, {
      name: "Lcm",
      trigger: {
        symbol: ["\\operatorname", "<{>", "l", "c", "m", "<}>"]
      }
    }, {
      name: "Gcd",
      trigger: {
        symbol: ["\\operatorname", "<{>", "g", "c", "d", "<}>"]
      }
    }, {
      name: "Ceil",
      trigger: {
        symbol: ["\\operatorname", "<{>", "c", "e", "i", "l", "<}>"]
      }
    }, {
      name: "Floor",
      trigger: {
        symbol: ["\\operatorname", "<{>", "f", "l", "o", "o", "r", "<}>"]
      }
    }, {
      name: "Round",
      trigger: {
        symbol: ["\\operatorname", "<{>", "r", "o", "u", "n", "d", "<}>"]
      }
    }, {
      name: "Sign",
      trigger: {
        symbol: ["\\operatorname", "<{>", "s", "g", "n", "<}>"]
      }
    }],
    calculus: [{
      trigger: {
        symbol: "\\int"
      },
      parse: function parse(e, t, i) {
        if (!t.match("\\int")) return [e, null];
        var r = Ks,
          n = Ks,
          a = !1;
        for (; !a;) t.skipSpace(), t.match("_") ? n = t.matchRequiredLatexArgument() : t.match("^") ? r = t.matchRequiredLatexArgument() : a = !0;
        var o = t.matchBalancedExpression("<{>", "<}>");
        return [e, ["Integral", null != o ? o : "", null != r ? r : Ks, null != n ? n : Ks]];
      },
      serialize: function serialize(e, t) {
        return "";
      }
    }],
    core: dl,
    inequalities: [{
      name: "NotLess",
      trigger: {
        infix: ["!", "<"]
      },
      associativity: "right",
      precedence: 246
    }, {
      name: "NotLess",
      trigger: {
        infix: "\\nless"
      },
      associativity: "right",
      precedence: 246
    }, {
      name: "Less",
      trigger: {
        infix: "<"
      },
      associativity: "right",
      precedence: 245
    }, {
      name: "Less",
      trigger: {
        infix: "\\lt"
      },
      associativity: "right",
      precedence: 245
    }, {
      name: "LessEqual",
      trigger: {
        infix: ["<", "="]
      },
      associativity: "right",
      precedence: 241
    }, {
      name: "LessEqual",
      trigger: {
        infix: "\\le"
      },
      associativity: "right",
      precedence: 241
    }, {
      name: "LessEqual",
      trigger: {
        infix: "\\leq"
      },
      associativity: "right",
      precedence: 241
    }, {
      name: "LessEqual",
      trigger: {
        infix: "\\leqslant"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "LessNotEqual",
      trigger: {
        infix: "\\lneqq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "NotLessNotEqual",
      trigger: {
        infix: "\\nleqq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "LessOverEqual",
      trigger: {
        infix: "\\leqq"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "GreaterOverEqual",
      trigger: {
        infix: "\\geqq"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "Equal",
      trigger: {
        infix: "="
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "StarEqual",
      trigger: {
        infix: ["*", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "StarEqual",
      trigger: {
        infix: ["\\star", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "PlusEqual",
      trigger: {
        infix: ["+", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "MinusEqual",
      trigger: {
        infix: ["-", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "SlashEqual",
      trigger: {
        infix: ["/", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "EqualEqual",
      trigger: {
        infix: ["=", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "EqualEqualEqual",
      trigger: {
        infix: ["=", "=", "="]
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "TildeFullEqual",
      trigger: {
        infix: "\\cong"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "NotTildeFullEqual",
      trigger: {
        infix: "\\ncong"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Assign",
      trigger: {
        infix: [":", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Assign",
      trigger: {
        infix: "\\coloneq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Approx",
      trigger: {
        infix: "\\approx"
      },
      associativity: "right",
      precedence: 247
    }, {
      name: "NotApprox",
      trigger: {
        infix: "\\approx"
      },
      associativity: "right",
      precedence: 247
    }, {
      name: "ApproxEqual",
      trigger: {
        infix: "\\approxeq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "NotApproxEqual",
      trigger: {
        infix: ["!", "\\approxeq"]
      },
      associativity: "right",
      precedence: 250
    }, {
      name: "NotEqual",
      trigger: {
        infix: "\\ne"
      },
      associativity: "right",
      precedence: 255
    }, {
      name: "Unequal",
      trigger: {
        infix: ["!", "="]
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "GreaterEqual",
      trigger: {
        infix: "\\ge"
      },
      associativity: "right",
      precedence: 242
    }, {
      name: "GreaterEqual",
      trigger: {
        infix: "\\geq"
      },
      associativity: "right",
      precedence: 242
    }, {
      name: "GreaterEqual",
      trigger: {
        infix: [">", "="]
      },
      associativity: "right",
      precedence: 243
    }, {
      name: "GreaterEqual",
      trigger: {
        infix: "\\geqslant"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "GreaterNotEqual",
      trigger: {
        infix: "\\gneqq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "NotGreaterNotEqual",
      trigger: {
        infix: "\\ngeqq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Greater",
      trigger: {
        infix: ">"
      },
      associativity: "right",
      precedence: 245
    }, {
      name: "Greater",
      trigger: {
        infix: "\\gt"
      },
      associativity: "right",
      precedence: 245
    }, {
      name: "NotGreater",
      trigger: {
        infix: "\\ngtr"
      },
      associativity: "right",
      precedence: 244
    }, {
      name: "NotGreater",
      trigger: {
        infix: ["!", ">"]
      },
      associativity: "right",
      precedence: 244
    }, {
      name: "RingEqual",
      trigger: {
        infix: "\\circeq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "TriangleEqual",
      trigger: {
        infix: "\\triangleq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "DotEqual",
      trigger: {
        infix: "\\doteq"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "DotEqualDot",
      trigger: {
        infix: "\\doteqdot"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "FallingDotEqual",
      trigger: {
        infix: "\\fallingdotseq"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "RisingDotEqual",
      trigger: {
        infix: "\\fallingdotseq"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "QuestionEqual",
      trigger: {
        infix: "\\questeq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Equivalent",
      trigger: {
        infix: "\\equiv"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "MuchLess",
      trigger: {
        infix: "\\ll"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "MuchGreater",
      trigger: {
        infix: "\\gg"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Precedes",
      trigger: {
        infix: "\\prec"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Succeeds",
      trigger: {
        infix: "\\succ"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "PrecedesEqual",
      trigger: {
        infix: "\\preccurlyeq"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "SucceedsEqual",
      trigger: {
        infix: "\\curlyeqprec"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "NotPrecedes",
      trigger: {
        infix: "\\nprec"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "NotSucceeds",
      trigger: {
        infix: "\\nsucc"
      },
      associativity: "right",
      precedence: 260
    }, {
      name: "Between",
      trigger: {
        infix: "\\between"
      },
      associativity: "right",
      precedence: 265
    }],
    other: ol,
    physics: [{
      name: "mu-0",
      trigger: {
        symbol: ["\\mu", "_", "0"]
      }
    }],
    sets: [{
      trigger: {
        symbol: "\\N"
      },
      parse: "NaturalNumber"
    }, {
      trigger: {
        symbol: "\\Z"
      },
      parse: "Integer"
    }, {
      trigger: {
        symbol: "\\Q"
      },
      parse: "RationalNumber"
    }, {
      trigger: {
        symbol: ["\\mathbb", "<{>", "A", "<}>"]
      },
      parse: "AlgebraicNumber"
    }, {
      trigger: {
        symbol: "\\R"
      },
      parse: "RealNumber"
    }, {
      trigger: {
        symbol: "\\C"
      },
      parse: "ComplexNumber"
    }, {
      trigger: {
        symbol: "\\varnothing"
      },
      parse: "EmptySet"
    }, {
      trigger: {
        symbol: "\\emptyset"
      },
      parse: "EmptySet"
    }, {
      name: "Complement",
      trigger: {
        infix: "\\complement"
      },
      precedence: 240
    }, {
      name: "Element",
      trigger: {
        infix: "\\in"
      },
      precedence: 240
    }, {
      name: "Intersection",
      trigger: {
        infix: "\\Cap"
      },
      precedence: 350
    }, {
      name: "NotElement",
      trigger: {
        infix: "\\notin"
      },
      precedence: 240
    }, {
      name: "SetMinus",
      trigger: {
        infix: "\\setminus"
      },
      precedence: 650
    }, {
      name: "SubsetEqual",
      trigger: {
        infix: "\\subseteq"
      },
      precedence: 240
    }, {
      name: "SymmetricDifference",
      trigger: {
        infix: "\\triangle"
      },
      precedence: 260
    }, {
      name: "Union",
      trigger: {
        infix: "\\cup"
      },
      precedence: 350
    }, {
      name: "Contains",
      trigger: {
        infix: "\\ni"
      },
      associativity: "right",
      precedence: 160
    }, {
      name: "Subset",
      trigger: {
        infix: "\\subset"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "SquareSubset",
      trigger: {
        infix: "\\sqsubset"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "SquareSubsetEqual",
      trigger: {
        infix: "\\sqsubseteq"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "Superset",
      trigger: {
        infix: "\\supset"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "SquareSuperset",
      trigger: {
        infix: "\\sqsupset"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "SquareSupersetEqual",
      trigger: {
        infix: "\\sqsupseteq"
      },
      associativity: "right",
      precedence: 265
    }, {
      name: "NotSubset",
      trigger: {
        infix: "\\nsubset"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "NotSuperset",
      trigger: {
        infix: "\\nsupset"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "SupersetEqual",
      trigger: {
        infix: "\\supseteq"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "NotSubsetNotEqual",
      trigger: {
        infix: "\\nsubseteq"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "NotSupersetNotEqual",
      trigger: {
        infix: "\\nsupseteq"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "SubsetNotEqual",
      trigger: {
        infix: "\\subsetneq"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "SubsetNotEqual",
      trigger: {
        infix: "\\varsupsetneqq"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "SupersetNotEqual",
      trigger: {
        infix: "\\supsetneq"
      },
      associativity: "right",
      precedence: 240
    }, {
      name: "SupersetNotEqual",
      trigger: {
        infix: "\\varsupsetneq"
      },
      associativity: "right",
      precedence: 240
    }],
    symbols: [{
      trigger: {
        symbol: "\\alpha"
      },
      parse: "\u03B1"
    }, {
      trigger: {
        symbol: "\\beta"
      },
      parse: "\u03B2"
    }, {
      trigger: {
        symbol: "\\gamma"
      },
      parse: "\u03B3"
    }, {
      trigger: {
        symbol: "\\delta"
      },
      parse: "\u03B4"
    }, {
      trigger: {
        symbol: "\\epsilon"
      },
      parse: "\u03F5"
    }, {
      trigger: {
        symbol: "\\varepsilon"
      },
      parse: "\u03B5"
    }, {
      trigger: {
        symbol: "\\zeta"
      },
      parse: "\u03B6"
    }, {
      trigger: {
        symbol: "\\eta"
      },
      parse: "\u03B7"
    }, {
      trigger: {
        symbol: "\\theta"
      },
      parse: "\u03B8"
    }, {
      trigger: {
        symbol: "\\vartheta"
      },
      parse: "\u03D1"
    }, {
      trigger: {
        symbol: "\\iota"
      },
      parse: "\u03B9"
    }, {
      trigger: {
        symbol: "\\kappa"
      },
      parse: "\u03BA"
    }, {
      trigger: {
        symbol: "\\varkappa"
      },
      parse: "\u03F0"
    }, {
      trigger: {
        symbol: "\\lambda"
      },
      parse: "\u03BB"
    }, {
      trigger: {
        symbol: "\\mu"
      },
      parse: "\u03BC"
    }, {
      trigger: {
        symbol: "\\nu"
      },
      parse: "\u03BD"
    }, {
      trigger: {
        symbol: "\\xi"
      },
      parse: "\u03BE"
    }, {
      trigger: {
        symbol: "\\omicron"
      },
      parse: "\u03BF"
    }, {
      trigger: {
        symbol: "\\varpi"
      },
      parse: "\u03D6"
    }, {
      trigger: {
        symbol: "\\rho"
      },
      parse: "\u03C1"
    }, {
      trigger: {
        symbol: "\\varrho"
      },
      parse: "\u03F1"
    }, {
      trigger: {
        symbol: "\\sigma"
      },
      parse: "\u03C3"
    }, {
      trigger: {
        symbol: "\\varsigma"
      },
      parse: "\u03C2"
    }, {
      trigger: {
        symbol: "\\tau"
      },
      parse: "\u03C4"
    }, {
      trigger: {
        symbol: "\\phi"
      },
      parse: "\u03D5"
    }, {
      trigger: {
        symbol: "\\varphi"
      },
      parse: "\u03C6"
    }, {
      trigger: {
        symbol: "\\upsilon"
      },
      parse: "\u03C5"
    }, {
      trigger: {
        symbol: "\\chi"
      },
      parse: "\u03C7"
    }, {
      trigger: {
        symbol: "\\psi"
      },
      parse: "\u03C8"
    }, {
      trigger: {
        symbol: "\\omega"
      },
      parse: "\u03C9"
    }, {
      trigger: {
        symbol: "\\Gamma"
      },
      parse: "\u0393"
    }, {
      trigger: {
        symbol: "\\Delta"
      },
      parse: "\u0394"
    }, {
      trigger: {
        symbol: "\\Theta"
      },
      parse: "\u0398"
    }, {
      trigger: {
        symbol: "\\Lambda"
      },
      parse: "\u039B"
    }, {
      trigger: {
        symbol: "\\Xi"
      },
      parse: "\u039E"
    }, {
      trigger: {
        symbol: "\\Pi"
      },
      parse: "\u03A0"
    }, {
      trigger: {
        symbol: "\\Sigma"
      },
      parse: "\u03A3"
    }, {
      trigger: {
        symbol: "\\Upsilon"
      },
      parse: "\u03A5"
    }, {
      trigger: {
        symbol: "\\Phi"
      },
      parse: "\u03A6"
    }, {
      trigger: {
        symbol: "\\Psi"
      },
      parse: "\u03A8"
    }, {
      trigger: {
        symbol: "\\Omega"
      },
      parse: "\u03A9"
    }, {
      trigger: {
        symbol: "\\digamma"
      },
      parse: "\u03DD"
    }, {
      trigger: {
        symbol: "\\aleph"
      },
      parse: "\u2135"
    }, {
      trigger: {
        symbol: "\\beth"
      },
      parse: "\u2136"
    }, {
      trigger: {
        symbol: "\\daleth"
      },
      parse: "\u2138"
    }, {
      trigger: {
        symbol: "\\gimel"
      },
      parse: "\u2137"
    }, {
      trigger: {
        symbol: "\\Finv"
      },
      parse: "\u2132"
    }, {
      trigger: {
        symbol: "\\Game"
      },
      parse: "\u2141"
    }, {
      trigger: {
        symbol: "\\wp"
      },
      parse: "\u2118"
    }, {
      trigger: {
        symbol: "\\eth"
      },
      parse: "\xf0"
    }, {
      trigger: {
        symbol: "\\mho"
      },
      parse: "\u2127"
    }, {
      trigger: {
        symbol: "\\clubsuit"
      },
      parse: "\u2663"
    }, {
      trigger: {
        symbol: "\\heartsuit"
      },
      parse: "\u2661"
    }, {
      trigger: {
        symbol: "\\spadesuit"
      },
      parse: "\u2660"
    }, {
      trigger: {
        symbol: "\\diamondsuit"
      },
      parse: "\u2662"
    }, {
      trigger: {
        symbol: "\\sharp"
      },
      parse: "\u266F"
    }, {
      trigger: {
        symbol: "\\flat"
      },
      parse: "\u266D"
    }, {
      trigger: {
        symbol: "\\natural"
      },
      parse: "\u266E"
    }],
    trigonometry: [{
      name: "Arcsin",
      trigger: "\\arcsin",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Arccos",
      trigger: "\\arccos",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Arctan",
      trigger: "\\arctan",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Arctan",
      trigger: "\\arctg",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Arccot",
      trigger: "\\arcctg",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Arcsec",
      trigger: "\\arcsec",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Arccsc",
      trigger: "\\arccsc",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Arsinh",
      trigger: "\\arsinh",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Arcosh",
      trigger: "\\arcosh",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Artanh",
      trigger: "\\artanh",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Arsech",
      trigger: "\\arsech",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Arcsch",
      trigger: "\\arcsch",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Cosh",
      trigger: "\\ch",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Cosec",
      trigger: "\\cosec",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Cosh",
      trigger: "\\cosh",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Cot",
      trigger: "\\cot",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Cot",
      trigger: "\\cotg",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Coth",
      trigger: "\\coth",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Csc",
      trigger: "\\csc",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Cot",
      trigger: "\\ctg",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Coth",
      trigger: "\\cth",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Sec",
      trigger: "\\sec",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Sinh",
      trigger: "\\sinh",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Sinh",
      trigger: "\\sh",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Tan",
      trigger: "\\tan",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Tan",
      trigger: "\\tg",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Tanh",
      trigger: "\\tanh",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Tanh",
      trigger: "\\th",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Cos",
      trigger: "\\cos",
      arguments: "implicit",
      parse: xl
    }, {
      name: "Sin",
      trigger: "\\sin",
      arguments: "implicit",
      parse: xl
    }]
  },
  _l = {
    precision: 15,
    positiveInfinity: "\\infty",
    negativeInfinity: "-\\infty",
    notANumber: "\\operatorname{NaN}",
    decimalMarker: ".",
    groupSeparator: ",",
    exponentProduct: "\\cdot",
    beginExponentMarker: "10^{",
    endExponentMarker: "}",
    notation: "auto",
    truncationMarker: "\\ldots",
    beginRepeatingDigits: "\\overline{",
    endRepeatingDigits: "}",
    imaginaryNumber: "\\imaginaryI"
  },
  Ml = {
    invisibleOperator: Ps,
    skipSpace: !0,
    parseArgumentsOfUnknownLatexCommands: !0,
    parseNumbers: !0,
    promoteUnknownSymbols: /^[a-zA-Z]$/,
    promoteUnknownFunctions: /^[fg]$/,
    ignoreCommands: ["\\displaystyle", "\\!", "\\:", "\\enskip", "\\quad", "\\,", "\\;", "\\enspace", "\\qquad", "\\selectfont", "\\tiny", "\\scriptsize", "\\footnotesize", "\\small", "\\normalsize", "\\large", "\\Large", "\\LARGE", "\\huge", "\\Huge"],
    idempotentCommands: ["\\left", "\\right", "\\mleft", "\\mright", "\\middle", "\\bigl", "\\bigm", "\\bigr", "\\Bigl", "\\Bigm", "\\Bigr", "\\biggl", "\\biggm", "\\biggr", "\\Biggl", "\\Biggm", "\\Biggr"],
    invisiblePlusOperator: Fs,
    preserveLatex: !1
  },
  Sl = {
    invisibleMultiply: "",
    invisiblePlus: "",
    multiply: "\\times"
  };
function Ll(e, t) {
  var i;
  var r = e;
  for (var _e257 = 0; _e257 < t.length; _e257++) {
    var _n75 = null !== (i = t[_e257]) && void 0 !== i ? i : "";
    if (/[a-zA-Z*]/.test(_n75[0])) {
      var _t210 = r.match(new RegExp("(.*)#" + Number(_e257 + 1).toString()));
      _t210 && /\\[a-zA-Z*]+/.test(_t210[1]) && (_n75 = " " + _n75);
    }
    r = r.replace("#" + Number(_e257 + 1).toString(), _n75);
  }
  return r;
}
var Cl = /*#__PURE__*/function () {
  function Cl(e, t, i, r) {
    var _this61 = this;
    _classCallCheck(this, Cl);
    var n;
    this.index = 0, this.options = _objectSpread(_objectSpread(_objectSpread({}, _l), Ml), t), this.tokens = e, this.onError = function (e) {
      return r(_objectSpread(_objectSpread({}, e), {}, {
        before: _this61.latexBefore(),
        after: _this61.latexAfter()
      }));
    }, this.dictionary = i, this.invisibleOperatorPrecedence = 0, this.options.invisibleOperator && (n = this.dictionary.name.get(this.options.invisibleOperator), void 0 === n ? r({
      code: "unknown-operator",
      arg: "invisible operator " + this.options.invisibleOperator
    }) : void 0 === n.precedence ? r({
      code: "expected-operator",
      arg: "invisible operator " + this.options.invisibleOperator
    }) : this.invisibleOperatorPrecedence = n.precedence);
  }
  _createClass(Cl, [{
    key: "clone",
    value: function clone(e, t) {
      return new Cl(this.tokens.slice(e, t), this.options, this.dictionary, this.onError);
    }
  }, {
    key: "balancedClone",
    value: function balancedClone(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      if (!this.matchAll(e)) return i || this.onError({
        code: "syntax-error",
        arg: "Expected " + Ns(e)
      }), null;
      var r = this.index;
      var n = r,
        a = 1;
      for (; !this.atEnd && 0 !== a;) this.skipSpace(), n = this.index, this.matchAll(t) ? a -= 1 : this.matchAll(e) ? a += 1 : this.next();
      return 0 !== a ? (i || this.onError({
        code: "unbalanced-symbols",
        arg: Ns(e) + Ns(t)
      }), this.index = r, null) : this.clone(r, n);
    }
  }, {
    key: "atEnd",
    get: function get() {
      return this.index >= this.tokens.length;
    }
  }, {
    key: "peek",
    get: function get() {
      return this.tokens[this.index];
    }
  }, {
    key: "latex",
    value: function latex(e, t) {
      return Ns(this.tokens.slice(e, t));
    }
  }, {
    key: "latexAhead",
    value: function latexAhead(e) {
      return Ns(this.tokens.slice(this.index, this.index + e));
    }
  }, {
    key: "latexBefore",
    value: function latexBefore() {
      return this.latex(0, this.index);
    }
  }, {
    key: "latexAfter",
    value: function latexAfter() {
      return this.latex(this.index);
    }
  }, {
    key: "lookAhead",
    value: function lookAhead() {
      var e = Math.min(this.dictionary.lookahead, this.tokens.length - this.index);
      var t = [];
      for (; e > 0;) t[e] = this.latexAhead(e--);
      return t;
    }
  }, {
    key: "peekDefinition",
    value: function peekDefinition(e) {
      var _this62 = this;
      var t;
      t = "operator" === e ? this.lookAhead().map(function (e, t) {
        var i, r, n, a, o;
        return null !== (a = null !== (r = null === (i = _this62.dictionary.infix[t]) || void 0 === i ? void 0 : i.get(e)) && void 0 !== r ? r : null === (n = _this62.dictionary.postfix[t]) || void 0 === n ? void 0 : n.get(e)) && void 0 !== a ? a : null === (o = _this62.dictionary.prefix[t]) || void 0 === o ? void 0 : o.get(e);
      }) : this.lookAhead().map(function (t, i) {
        var r;
        return null === (r = _this62.dictionary[e][i]) || void 0 === r ? void 0 : r.get(t);
      });
      for (var _e258 = t.length; _e258 > 0; _e258--) if (void 0 !== t[_e258]) return [t[_e258], _e258];
      return [null, 0];
    }
  }, {
    key: "next",
    value: function next() {
      return this.tokens[this.index++];
    }
  }, {
    key: "skipSpace",
    value: function skipSpace() {
      if (!this.atEnd && "<{>" === this.peek && "<}>" === this.tokens[this.index + 1]) return this.index += 2, this.skipSpace(), !0;
      var e = !1;
      for (; !this.atEnd && (this.options.ignoreCommands.includes(this.peek) || this.options.idempotentCommands.includes(this.peek));) this.index += 1, this.skipSpace(), e = !0;
      if (!this.options.skipSpace) return !1;
      for (; this.match("<space>");) e = !0;
      return e && this.skipSpace(), e;
    }
  }, {
    key: "match",
    value: function match(e) {
      return this.tokens[this.index] === e && (this.index++, !0);
    }
  }, {
    key: "matchAll",
    value: function matchAll(e) {
      var t = !0;
      "string" == typeof e && (e = [e]);
      var i = 0;
      do {
        t = this.tokens[this.index + i] === e[i++];
      } while (t && i < e.length);
      return t && (this.index += i), t;
    }
  }, {
    key: "matchAny",
    value: function matchAny(e) {
      return e.includes(this.tokens[this.index]) ? this.tokens[this.index++] : "";
    }
  }, {
    key: "matchWhile",
    value: function matchWhile(e) {
      var t = [];
      for (; e.includes(this.tokens[this.index]);) t.push(this.tokens[this.index++]);
      return t;
    }
  }, {
    key: "matchSign",
    value: function matchSign() {
      var e = !1,
        t = !1;
      for (; !t;) this.skipSpace() ? t = !1 : this.match("-") ? (e = !e, t = !1) : t = !this.match("+");
      return e ? "-" : "+";
    }
  }, {
    key: "matchDecimalDigits",
    value: function matchDecimalDigits() {
      var e = "",
        t = !1;
      for (; !t;) if (e += this.matchWhile(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]).join(""), t = !0, this.options.groupSeparator) {
        var _e259 = this.index;
        this.match(this.options.groupSeparator) && (/[0-9]/.test(this.peek) ? t = !1 : this.index = _e259);
      }
      return e;
    }
  }, {
    key: "matchSignedInteger",
    value: function matchSignedInteger() {
      var e = this.index,
        t = this.matchSign(),
        i = this.matchDecimalDigits();
      return i ? ("-" === t ? "-" : "") + i : (this.index = e, "");
    }
  }, {
    key: "matchExponent",
    value: function matchExponent() {
      var e = this.index;
      var t = "";
      if (this.matchAny(["e", "E", "d", "D"])) {
        var _e260 = this.matchSignedInteger();
        _e260 && (t = "e" + _e260);
      }
      if (t) return t;
      if (this.match("\\times") && (this.skipSpace(), this.match("1") && this.match("0") && this.match("^"))) {
        if (/[0-9]/.test(this.peek)) return "e" + this.next();
        if (this.match("<{>")) {
          this.skipSpace();
          var _e261 = this.matchSignedInteger();
          if (this.skipSpace(), this.match("<}>") && _e261) return "e" + _e261;
        }
      }
      return this.index = e, "";
    }
  }, {
    key: "matchNumber",
    value: function matchNumber() {
      var e, t;
      if (!this.options.parseNumbers) return "";
      var i = this.index,
        r = this.matchSign();
      var n = this.matchDecimalDigits();
      if (!n) return this.index = i, "";
      n = ("-" === r ? "-" : "") + n;
      var a = !1,
        o = !1;
      this.match(null !== (e = this.options.decimalMarker) && void 0 !== e ? e : "") && (a = !0, n += "." + (null !== (t = this.matchDecimalDigits()) && void 0 !== t ? t : "0"));
      var s = this.matchExponent();
      return s && (o = !0), n ? n.length + s.length > 12 ? a || o ? n + s + "d" : n + "n" : n + s : (this.index = i, "");
    }
  }, {
    key: "matchOperator",
    value: function matchOperator(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var _this$peekDefinition11 = this.peekDefinition(e),
        _this$peekDefinition12 = _slicedToArray(_this$peekDefinition11, 2),
        r = _this$peekDefinition12[0],
        n = _this$peekDefinition12[1];
      if (null === r) return null;
      if ("function" == typeof r.parse) {
        var _r$parse3, _r$parse4;
        var _e262 = null;
        return (_r$parse3 = r.parse(t, this, i), _r$parse4 = _slicedToArray(_r$parse3, 2), t = _r$parse4[0], _e262 = _r$parse4[1]), null === _e262 ? null : this.applyInvisibleOperator(t, _e262);
      }
      var a = r.precedence;
      if (void 0 === a || a < i) return null;
      a += "left" === r.associativity ? 1 : 0, this.index += n;
      var o = this.matchExpression(a);
      return this.applyInvisibleOperator.apply(this, _toConsumableArray(this.applyOperator(r.parse, t, o)));
    }
  }, {
    key: "matchArguments",
    value: function matchArguments(e) {
      if (!e) return null;
      var t = this.index;
      var i = null;
      var r = this.matchMatchfixOperator();
      if ("group" === e && "Parentheses" === Js(r)) i = tl(r);else if ("implicit" === e) {
        if ("Parentheses" === Js(r)) i = tl(r);else if (null !== r) i = [r];else {
          var _e263 = this.matchPrimary();
          null !== _e263 && (i = [_e263]);
        }
      } else this.index = t;
      return i;
    }
  }, {
    key: "matchMatchfixOperator",
    value: function matchMatchfixOperator() {
      var _this$peekDefinition13 = this.peekDefinition("matchfix"),
        _this$peekDefinition14 = _slicedToArray(_this$peekDefinition13, 1),
        e = _this$peekDefinition14[0];
      if (null === e) return null;
      if ("function" == typeof e.parse) return this.applyInvisibleOperator.apply(this, _toConsumableArray(e.parse(null, this, 0)));
      var t = "object" == typeof e.trigger ? e.trigger.matchfix : e.trigger;
      if (!t || !e.closeFence || !e.parse) return null;
      var i = this.matchBalancedExpression(t, e.closeFence, this.onError);
      return i ? [e.parse, i] : [e.parse];
    }
  }, {
    key: "matchDefinition",
    value: function matchDefinition(e) {
      var _this$peekDefinition15 = this.peekDefinition(e),
        _this$peekDefinition16 = _slicedToArray(_this$peekDefinition15, 2),
        t = _this$peekDefinition16[0],
        i = _this$peekDefinition16[1];
      if ("function" == typeof (null == t ? void 0 : t.parse)) {
        var _t$parse5 = t.parse(null, this, 0),
          _t$parse6 = _slicedToArray(_t$parse5, 2),
          _e264 = _t$parse6[1];
        return [t, _e264];
      }
      return this.index += i, [t, null];
    }
  }, {
    key: "matchSymbol",
    value: function matchSymbol() {
      var e, t, i, r;
      var _this$matchDefinition3 = this.matchDefinition("symbol"),
        _this$matchDefinition4 = _slicedToArray(_this$matchDefinition3, 2),
        n = _this$matchDefinition4[0],
        a = _this$matchDefinition4[1];
      if (null !== a) return a;
      if (null === n) {
        if (null === (e = this.options.promoteUnknownFunctions) || void 0 === e ? void 0 : e.test(this.peek)) {
          var _e265 = this.next(),
            _t211 = this.matchMatchfixOperator();
          return null === _t211 ? _e265 : "Parentheses" !== Js(_t211) ? null : [_e265].concat(_toConsumableArray(tl(_t211)));
        }
        return (null === (t = this.options.promoteUnknownSymbols) || void 0 === t ? void 0 : t.test(this.peek)) ? this.next() : this.matchUnknownLatexCommand();
      }
      var o = [],
        s = [];
      var l,
        c = null !== (i = n.optionalLatexArg) && void 0 !== i ? i : 0;
      for (; c > 0;) l = this.matchOptionalLatexArgument(), null !== l && s.push(l), c--;
      for (c = null !== (r = n.requiredLatexArg) && void 0 !== r ? r : 0; c > 0;) l = this.matchRequiredLatexArgument(), null === l && this.onError({
        code: "expected-argument"
      }), null !== l && o.push(l), c--;
      var u = this.matchArguments(n.arguments);
      return null === u ? 0 === o.length && 0 === s.length ? n.parse : [n.parse].concat(o, s) : [n.parse].concat(o, _toConsumableArray(u), s);
    }
  }, {
    key: "matchOptionalLatexArgument",
    value: function matchOptionalLatexArgument() {
      return this.skipSpace(), this.matchBalancedExpression("[", "]");
    }
  }, {
    key: "matchRequiredLatexArgument",
    value: function matchRequiredLatexArgument() {
      return this.skipSpace(), this.matchBalancedExpression("<{>", "<}>") || (/^[0-9]$/.test(this.peek) ? parseFloat(this.next()) : /^[^\\#]$/.test(this.peek) ? this.next() : this.matchSymbol());
    }
  }, {
    key: "matchSupsub",
    value: function matchSupsub(e) {
      var _this63 = this;
      if (null === e) return null;
      var t = null;
      return this.skipSpace(), [["^", "superfix"], ["_", "subfix"]].forEach(function (i) {
        var _this63$peekDefinitio, _this63$peekDefinitio2, _this63$peekDefinitio3, _this63$peekDefinitio4, _this63$applyOperator, _this63$applyOperator2;
        var r, n, a;
        if (null !== t) return;
        var _i196 = _slicedToArray(i, 2),
          o = _i196[0],
          s = _i196[1],
          l = _this63.index;
        if (!_this63.match(o)) return;
        var c = _this63.index;
        var u,
          d = 0;
        if (_this63.match("<{>") ? ((_this63$peekDefinitio = _this63.peekDefinition(s), _this63$peekDefinitio2 = _slicedToArray(_this63$peekDefinitio, 2), u = _this63$peekDefinitio2[0], d = _this63$peekDefinitio2[1]), u ? "function" == typeof u.parse ? t = u.parse(e, _this63, 0)[1] : (_this63.index += d, _this63.match("<}>") ? t = [null !== (r = u.parse) && void 0 !== r ? r : u.name, e] : _this63.index = c) : _this63.index = c) : ((_this63$peekDefinitio3 = _this63.peekDefinition(s), _this63$peekDefinitio4 = _slicedToArray(_this63$peekDefinitio3, 2), u = _this63$peekDefinitio4[0], d = _this63$peekDefinitio4[1]), u ? "function" == typeof u.parse ? t = u.parse(e, _this63, 0)[1] : (_this63.index += d, t = [null !== (n = u.parse) && void 0 !== n ? n : u.name, e]) : _this63.index = c), null === t && (u = null === (a = _this63.dictionary.infix[1]) || void 0 === a ? void 0 : a.get(o), "function" == typeof (null == u ? void 0 : u.parse) ? (_this63.index = l, t = u.parse(e, _this63, 0)[1]) : "string" == typeof (null == u ? void 0 : u.parse) ? ((_this63$applyOperator = _this63.applyOperator(u.parse, e, _this63.matchRequiredLatexArgument()), _this63$applyOperator2 = _slicedToArray(_this63$applyOperator, 2), e = _this63$applyOperator2[0], t = _this63$applyOperator2[1]), t = _this63.applyInvisibleOperator(e, t)) : t = _this63.applyInvisibleOperator(e, o)), null !== t) {
          var _e266 = _this63.matchArguments(null == u ? void 0 : u.arguments);
          null !== _e266 && (t = [t].concat(_toConsumableArray(_e266)));
        }
      }), t;
    }
  }, {
    key: "matchPostfix",
    value: function matchPostfix(e) {
      var _t$parse7, _t$parse8;
      if (null === e) return null;
      var _this$peekDefinition17 = this.peekDefinition("postfix"),
        _this$peekDefinition18 = _slicedToArray(_this$peekDefinition17, 2),
        t = _this$peekDefinition18[0],
        i = _this$peekDefinition18[1];
      return null == t ? null : "function" == typeof t.parse ? ((_t$parse7 = t.parse(e, this, 0), _t$parse8 = _slicedToArray(_t$parse7, 2), e = _t$parse8[1]), null === e ? null : e) : (this.index += i, [t.parse, e]);
    }
  }, {
    key: "matchString",
    value: function matchString() {
      var e = "",
        t = this.atEnd;
      for (; !t;) {
        if (this.match("<space>")) e += " ";else {
          var _i197 = this.peek;
          "]" === _i197 ? t = !0 : /^<({|}|\$|\$\$|space)>$/.test(_i197) ? "\\" === _i197[0] ? (this.onError({
            code: "unexpected-command"
          }), e += this.next()) : t = !0 : e += this.next();
        }
        t = t || this.atEnd;
      }
      return e;
    }
  }, {
    key: "matchEnvironmentName",
    value: function matchEnvironmentName(e, t) {
      if (this.match(e)) {
        var _e267 = this.index;
        if (this.match("<{>")) {
          var _e268 = this.matchString();
          if (this.match("<}>") && _e268 === t) return !0;
        }
        this.index = _e267;
      }
      return !1;
    }
  }, {
    key: "matchTabular",
    value: function matchTabular() {
      var e = ["list"];
      var t = ["list"],
        i = null,
        r = !1;
      for (; !this.atEnd && !r;) if (this.match("&")) t.push(null != i ? i : Ks), i = null;else if (this.match("\\\\") || this.match("\\cr")) this.skipSpace(), this.matchOptionalLatexArgument(), null !== i && t.push(i), e.push(t), t = ["list"], i = null;else {
        var _e269 = this.matchExpression();
        null === _e269 && (r = !0), i = null !== i ? this.applyInvisibleOperator(i, _e269) : _e269;
      }
      return t.length > 1 && e.push(t), e;
    }
  }, {
    key: "matchEnvironment",
    value: function matchEnvironment() {
      var e;
      if (this.match("\\begin") && this.match("<{>")) {
        var _t212 = this.matchString();
        if (this.match("<}>")) {
          var _i198 = this.index;
          var _r79 = this.index,
            _n76 = 1;
          for (; !this.atEnd && 0 !== _n76;) _r79 = this.index, this.matchEnvironmentName("\\begin", _t212) ? _n76 += 1 : this.matchEnvironmentName("\\end", _t212) ? _n76 -= 1 : this.next();
          var _a38 = this.dictionary.environment.get(_t212);
          return "function" == typeof (null == _a38 ? void 0 : _a38.parse) ? _a38.parse(null, this.clone(_i198, _r79), 0)[1] : null !== (e = null == _a38 ? void 0 : _a38.parse) && void 0 !== e ? e : null;
        }
      }
      return null;
    }
  }, {
    key: "applyOperator",
    value: function applyOperator(e, t, i) {
      var r, n, a, o;
      var s = this.dictionary.name.get(e);
      if (void 0 === s) return this.onError({
        code: "unknown-operator"
      }), [t, i];
      if (void 0 !== (null === (r = s.trigger) || void 0 === r ? void 0 : r.prefix) && null === t && null !== i) return [null, [s.name, i]];
      if (void 0 !== (null === (n = s.trigger) || void 0 === n ? void 0 : n.postfix) && null !== t) return [null, [s.name, t]];
      if (void 0 !== (null === (a = s.trigger) || void 0 === a ? void 0 : a.matchfix) || void 0 !== (null === (o = s.trigger) || void 0 === o ? void 0 : o.infix)) {
        if ("non" === s.associativity) return [null, [e, null != t ? t : "Missing", null != i ? i : "Missing"]];
        if (Js(t) === e) {
          if ("both" === s.associativity) {
            if (Js(i) === e) {
              if (Array.isArray(t)) return [null, t.concat(tl(i))];
              if (Ws(t)) return [null, t.fn.concat(tl(i))];
            } else i && (Array.isArray(t) && t.push(i), Ws(t) && t.fn.push(i));
            return [null, t];
          }
          return "left" === s.associativity ? [null, [e, null != t ? t : Bs, null != i ? i : Bs]] : Array.isArray(t) ? [null, [e, t[1], [e, t[2], null != i ? i : Bs]]] : (Ws(t) && (t.fn[2] = [e, t.fn[2], null != i ? i : Bs]), [null, t]);
        }
        return Js(i) === e ? "both" === s.associativity ? (Array.isArray(i) && t && i.splice(1, 0, t), Ws(i) && t && i.fn.splice(1, 0, t), [null, i]) : "right" === s.associativity ? [null, [e, null != t ? t : Bs, null != i ? i : Bs]] : Array.isArray(i) ? [null, [e, i[1], [e, i[2], null != t ? t : Bs]]] : (Ws(i) && (i.fn[2] = [e, i.fn[2], null != t ? t : Bs]), [null, i]) : [null, [e, null != t ? t : "Missing", null != i ? i : "Missing"]];
      }
      return [t, null];
    }
  }, {
    key: "applyInvisibleOperator",
    value: function applyInvisibleOperator(e, t) {
      var _this$applyOperator5, _this$applyOperator6, _this$applyOperator7, _this$applyOperator8;
      if (null === e) return t;
      if (null === t) return e;
      if (this.options.invisiblePlusOperator && ("number" == typeof e || Hs(e)) && function (e) {
        var t, i;
        var r = el(e);
        if (null !== r && ["ThreeQuarter", "TwoThird", "Half", "Third", "Quarter"].includes(r)) return !0;
        if (Js(e) !== $s) return !1;
        var n = null !== (t = Zs(rl(e, 1))) && void 0 !== t ? t : NaN,
          a = null !== (i = Zs(rl(e, 2))) && void 0 !== i ? i : NaN;
        return Number.isInteger(n) && Number.isInteger(a);
      }(t)) return (_this$applyOperator5 = this.applyOperator(this.options.invisiblePlusOperator, e, t), _this$applyOperator6 = _slicedToArray(_this$applyOperator5, 2), e = _this$applyOperator6[0], t = _this$applyOperator6[1]), null === e ? t : null;
      if (this.options.invisibleOperator) return (_this$applyOperator7 = this.applyOperator(this.options.invisibleOperator, e, t), _this$applyOperator8 = _slicedToArray(_this$applyOperator7, 2), e = _this$applyOperator8[0], t = _this$applyOperator8[1]), null === e ? t : null;
      var i = ["LatexTokens"];
      return "LatexTokens" === Js(e) ? i = i.concat(tl(e)) : i.push(e), null !== t && ("LatexTokens" === Js(t) ? i = i.concat(tl(t)) : i.push(t)), this.options.invisibleOperator && this.onError({
        code: "unexpected-sequence"
      }), i;
    }
  }, {
    key: "matchUnknownLatexCommand",
    value: function matchUnknownLatexCommand() {
      var e;
      var t = this.peek;
      if (!t || "\\" !== t[0]) return null;
      if (this.next(), "\\operatorname" === t) {
        if (this.skipSpace(), "<{>" === this.peek) {
          var _e270 = "";
          for (this.next(); !this.atEnd && "<}>" !== this.tokens[this.index];) _e270 += this.next();
          return _e270;
        }
        return null !== (e = this.next()) && void 0 !== e ? e : Bs;
      }
      var i = [],
        r = [];
      var n = !1;
      do {
        n = !0;
        var _e271 = this.matchOptionalLatexArgument();
        null !== _e271 && (i.push(_e271), n = !1), this.skipSpace(), "<{>" === this.peek && (_e271 = this.matchRequiredLatexArgument(), null !== _e271 && (r.push(_e271), n = !1));
      } while (!n);
      return i.length > 0 || r.length > 0 ? [t].concat(r, i) : t;
    }
  }, {
    key: "matchPrimary",
    value: function matchPrimary(e) {
      var t = null;
      var i = this.index,
        r = this.matchNumber();
      r && (t = {
        num: r
      }), null === t && (t = this.matchMatchfixOperator()), null === t && (t = this.matchEnvironment()), null === t && (t = this.matchSymbol());
      var n = null;
      do {
        n = this.matchSupsub(t), t = null != n ? n : t;
      } while (null !== n);
      var a = null;
      do {
        a = this.matchPostfix(t), t = null != a ? a : t;
      } while (null !== a);
      return this.decorate(t, i);
    }
  }, {
    key: "matchBalancedExpression",
    value: function matchBalancedExpression(e, t, i) {
      var r = this.balancedClone(e, t);
      if (!r) return null == i || i({
        code: "unbalanced-symbols",
        arg: Ns(e) + Ns(t)
      }), null;
      var n = r.matchExpression();
      return r.atEnd || null == i || i({
        code: "unbalanced-symbols",
        arg: Ns(e) + Ns(t)
      }), n;
    }
  }, {
    key: "matchExpression",
    value: function matchExpression() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = null;
      var i = this.index;
      this.skipSpace(), t = this.matchPrimary(e), null === t && (t = this.matchOperator("prefix"));
      var r = !1;
      for (; !this.atEnd && !r;) {
        this.skipSpace();
        var _i199 = this.matchOperator("infix", t, e);
        if (null === _i199 && null !== t) {
          var _this$peekDefinition19 = this.peekDefinition("operator"),
            _this$peekDefinition20 = _slicedToArray(_this$peekDefinition19, 1),
            _e272 = _this$peekDefinition20[0];
          if (null === _e272) {
            var _e273 = this.matchExpression(this.invisibleOperatorPrecedence);
            null !== _e273 && (_i199 = this.applyInvisibleOperator(t, _e273));
          }
        }
        null !== _i199 ? t = _i199 : r = !0;
      }
      return this.decorate(t, i);
    }
  }, {
    key: "decorate",
    value: function decorate(e, t) {
      if (null === e) return null;
      if (this.options.preserveLatex) {
        var _i200 = this.latex(t, this.index);
        Array.isArray(e) ? e = {
          latex: _i200,
          fn: e
        } : "number" == typeof e ? e = {
          latex: _i200,
          num: Number(e).toString()
        } : "string" == typeof e ? e = {
          latex: _i200,
          sym: e
        } : "object" == typeof e && null !== e && (e.latex = _i200);
      }
      return e;
    }
  }]);
  return Cl;
}();
function Al(e, t) {
  var i = e.length,
    r = e;
  e = e.slice(0, -1);
  for (var _i201 = 0; _i201 < e.length - 16; _i201++) {
    var _r80 = e.substr(0, _i201);
    for (var _n77 = 0; _n77 < 17; _n77++) {
      var _a39 = e.substr(_i201, _n77 + 1),
        _o27 = Math.floor((e.length - _r80.length) / _a39.length);
      if (_o27 > 1 && (_r80 + _a39.repeat(_o27 + 1)).startsWith(e)) return "0" === _a39 ? _r80.replace(/(\d{3})/g, "$1" + t.groupSeparator) : _r80.replace(/(\d{3})/g, "$1" + t.groupSeparator) + t.beginRepeatingDigits + _a39 + t.endRepeatingDigits;
    }
  }
  var n = i > t.precision - 1;
  return e = r, n && (e = e.substr(0, t.precision - 1)), t.groupSeparator && (e = e.replace(/(\d{3})/g, "$1" + t.groupSeparator)).endsWith(t.groupSeparator) && (e = e.slice(0, -t.groupSeparator.length)), n ? e + t.truncationMarker : e;
}
function Nl(e, t) {
  var i;
  return e ? t.beginExponentMarker ? t.beginExponentMarker + e + (null !== (i = t.endExponentMarker) && void 0 !== i ? i : "") : "10^{" + e + "}" : "";
}
var zl = /*#__PURE__*/function () {
  function zl(e, t, i) {
    _classCallCheck(this, zl);
    this.level = -1, this.options = e, e.invisibleMultiply && (/#1/.test(e.invisibleMultiply) && /#2/.test(e.invisibleMultiply) || i({
      code: "expected-argument",
      arg: "invisibleMultiply"
    })), this.onError = i, this.dictionary = t;
  }
  _createClass(zl, [{
    key: "wrap",
    value: function wrap(e, t) {
      if (null === e) return "";
      if (void 0 === t) return "(" + this.serialize(e) + ")";
      if ("number" == typeof e || Hs(e) || "string" == typeof e || Us(e)) return this.serialize(e);
      var i = Js(e);
      if (i && "Parentheses" !== i) {
        var _r81 = this.dictionary.name.get(i);
        if (_r81 && void 0 !== _r81.precedence && _r81.precedence < t) return this.wrapString(this.serialize(e), (this.level, "paren"));
      }
      return this.serialize(e);
    }
  }, {
    key: "wrapShort",
    value: function wrapShort(e) {
      if (null === e) return "";
      var t = this.serialize(e);
      return "Parentheses" === Js(e) || "number" == typeof e || Hs(e) || /(^(.|\\[a-zA-Z*]+))$/.test(t) ? t : this.wrapString(t, (this.level, "paren"));
    }
  }, {
    key: "wrapString",
    value: function wrapString(e, t) {
      return "none" === t ? e : "(" + e + ")";
    }
  }, {
    key: "serializeSymbol",
    value: function serializeSymbol(e, t) {
      var _this64 = this;
      var i = Ys(e);
      if (!i) {
        if ("string" == typeof (null == t ? void 0 : t.serialize)) return t.serialize;
        var _i202 = el(e);
        return null === _i202 ? "" : "upright" === function (e, t) {
          var i = el(e);
          return null === i ? "asis" : i.length > 1 ? "upright" : "asis";
        }(e, this.level) ? "\\operatorname{" + _i202 + "}" : _i202;
      }
      var r = tl(e);
      if (!t) {
        if ("string" == typeof i && i.length > 0 && "\\" === i[0]) {
          var _e274 = i;
          var _iterator128 = _createForOfIteratorHelper(r),
            _step128;
          try {
            for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
              var _t213 = _step128.value;
              _e274 += "{" + this.serialize(_t213) + "}";
            }
          } catch (err) {
            _iterator128.e(err);
          } finally {
            _iterator128.f();
          }
          return _e274;
        }
        return "".concat(this.serialize(i), "(").concat(r.map(function (e) {
          return _this64.serialize(e);
        }).join(", "), ")");
      }
      if (t.requiredLatexArg > 0) {
        var _e275 = "",
          _i203 = "",
          _n78 = 0;
        for (; _n78 < t.requiredLatexArg;) _i203 += "{" + this.serialize(r[_n78++]) + "}";
        for (; _n78 < Math.min(r.length, t.optionalLatexArg + t.requiredLatexArg);) {
          var _t214 = this.serialize(r[1 + _n78++]);
          _t214 && (_e275 += "[" + _t214 + "]");
        }
        return t.serialize + (_e275 + _i203);
      }
      return this.level, t.serialize + this.serialize(["Parentheses"].concat(_toConsumableArray(r)));
    }
  }, {
    key: "serializeDictionary",
    value: function serializeDictionary(e) {
      var _this65 = this;
      return "\\left[\\begin{array}{lll}".concat(Object.keys(e).map(function (t) {
        return "\\textbf{".concat(t, "} & \\rightarrow & ").concat(_this65.serialize(e[t]));
      }).join("\\\\"), "\\end{array}\\right]");
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      var _this66 = this;
      if (null === e) return "";
      this.level += 1;
      var t = function () {
        var t, i, r, n;
        var a = function (e, t) {
          var i, r;
          var n;
          if ("number" == typeof e) n = e;else {
            if (!Hs(e)) return "";
            n = e.num;
          }
          if (n === 1 / 0 || "Infinity" === n || "+Infinity" === n) return t.positiveInfinity;
          if (n === -1 / 0 || "-Infinity" === n) return t.negativeInfinity;
          if ("NaN" === n || "number" == typeof n && Number.isNaN(n)) return t.notANumber;
          if ("number" == typeof n) return "engineering" === t.notation ? function (e, t) {
            if (0 === e) return "0";
            var i = Math.abs(e);
            var r = Math.round(Math.log10(i));
            r -= r % 3, i < 1e3 && (r = 0);
            var n = i / Math.pow(10, r);
            var a = "";
            var o = n.toString().match(/^(.*)\.(.*)$/);
            (null == o ? void 0 : o[1]) && o[2] && (a = o[1] + t.decimalMarker + o[2]), t.groupSeparator && (a = Al(n.toExponential(), t));
            var s = "";
            return 0 !== r && (s = Nl(r.toString(), t)), (e < 0 ? "-" : "") + a + s;
          }(n, t) : function (e, t) {
            var i,
              r = e.match(/^(.*)[e|E]([-+]?[0-9]+)$/i);
            (null == r ? void 0 : r[1]) && r[2] && (i = Nl(r[2], t), i && (i = t.exponentProduct + i));
            var n = e,
              a = "";
            return r = (i ? r[1] : e).match(/^(.*)\.(.*)$/), (null == r ? void 0 : r[1]) && r[2] && (n = r[1], a = r[2]), t.groupSeparator && (n = n.replace(/\B(?=(\d{3})+(?!\d))/g, t.groupSeparator), a = Al(a, t)), a && (a = t.decimalMarker + a), n + a + (null != i ? i : "");
          }(n.toString(), t);
          /[a-zA-Z]$/.test(n) && (n = n.slice(0, -1));
          var a = "";
          for ("-" === n[0] ? (a = "-", n = n.substr(1)) : "+" === n[0] && (n = n.substr(1)); "0" === n[0];) n = n.substr(1);
          if (0 === n.length) return a + "0";
          "." === n[0] && (n = "0" + n);
          var o = "";
          if (n.indexOf(".") >= 0) {
            var _e276 = n.match(/(\d*)\.(\d*)([e|E]([-+]?[0-9]*))?/);
            if (!_e276) return "";
            var _r82 = _e276[1],
              _s21 = _e276[2];
            if (o = null !== (i = _e276[4]) && void 0 !== i ? i : "", "0" === _r82) {
              var _e277 = 0;
              for (; "0" === _s21[_e277] && _e277 < _s21.length;) _e277 += 1;
              var _i204 = "";
              if (_e277 <= 4) _i204 = "0" + t.decimalMarker, _i204 += _s21.substr(0, _e277), _i204 += Al(n.substr(_i204.length), t);else if (_e277 + 1 >= t.precision) _i204 = "0", a = "";else {
                _i204 = n[_e277];
                var _r83 = Al(n.substr(_e277 + 1), t);
                _r83 && (_i204 += t.decimalMarker + _r83);
              }
              "0" !== _i204 && (!(n.length - 1 > t.precision) || t.endRepeatingDigits && _i204.endsWith(t.endRepeatingDigits) || !t.truncationMarker || _i204.endsWith(t.truncationMarker) || (_i204 += t.truncationMarker), _e277 > 4 && (_i204 += t.exponentProduct + Nl((1 - _e277).toString(), t))), n = _i204;
            } else {
              n = _r82.replace(/\B(?=(\d{3})+(?!\d))/g, t.groupSeparator);
              var _e278 = Al(_s21, t);
              _e278 && (n += t.decimalMarker + _e278);
            }
          } else if (n.length > t.precision) {
            var _e279 = n.length;
            var _i205 = n[0];
            var _r84 = Al(n.substr(1), t);
            _r84 && (_i205 += t.decimalMarker + _r84, t.truncationMarker && !_i205.endsWith(t.truncationMarker) && t.endRepeatingDigits && !_i205.endsWith(t.endRepeatingDigits) && (_i205 += t.truncationMarker)), "1" !== _i205 ? _i205 += t.exponentProduct : _i205 = "", n = _i205 + Nl((_e279 - 1).toString(), t);
          } else {
            var _e280 = n.match(/([0-9]*)\.?([0-9]*)([e|E]([-+]?[0-9]+))?/);
            _e280 && (n = _e280[1], _e280[2] && (n += t.decimalMarker + _e280[2]), o = null !== (r = _e280[4]) && void 0 !== r ? r : ""), n = n.replace(/\B(?=(\d{3})+(?!\d))/g, t.groupSeparator);
          }
          var s = Nl(o, t);
          return a + n + (s ? t.exponentProduct + s : "");
        }(e, _this66.options);
        if (a) return a;
        var o = Gs(e);
        if (null !== o) return "\\text{".concat(o, "}");
        var s = el(e);
        if (null !== s) return _this66.serializeSymbol(e, _this66.dictionary.name.get(s));
        var l = al(e);
        if (null !== l) return _this66.serializeDictionary(l);
        var c = Js(e);
        if (c) {
          if ("\\" === c[0]) {
            var _t215 = tl(e);
            return 0 === _t215.length ? c : c + "{" + _t215.map(function (e) {
              return _this66.serialize(e);
            }).filter(function (e) {
              return Boolean(e);
            }).join("}{") + "}";
          }
          var _a40 = _this66.dictionary.name.get(c);
          if (_a40) {
            var _o28 = "";
            return "function" == typeof _a40.serialize && (_o28 = _a40.serialize(_this66, e)), _o28 || void 0 === _a40.precedence && !(null === (t = _a40.trigger) || void 0 === t ? void 0 : t.superfix) && !(null === (i = _a40.trigger) || void 0 === i ? void 0 : i.subfix) || (_o28 = function (e, t, i) {
              var r, n, a, o, s;
              var l = "";
              var c = nl(t),
                u = Js(t);
              if ((null === (r = i.trigger) || void 0 === r ? void 0 : r.superfix) || (null === (n = i.trigger) || void 0 === n ? void 0 : n.subfix)) return 1 !== c && e.onError({
                code: "operator-requires-one-operand",
                arg: e.serializeSymbol(u)
              }), Ll(i.serialize, [e.serialize(rl(t, 1))]);
              if (null === (a = i.trigger) || void 0 === a ? void 0 : a.postfix) return 1 !== c && e.onError({
                code: "postfix-operator-requires-one-operand",
                arg: e.serializeSymbol(u)
              }), Ll(i.serialize, [e.wrap(rl(t, 1), i.precedence)]);
              if (null === (o = i.trigger) || void 0 === o ? void 0 : o.prefix) return 1 !== c && e.onError({
                code: "prefix-operator-requires-one-operand",
                arg: e.serializeSymbol(u)
              }), Ll(i.serialize, [e.wrap(rl(t, 1), i.precedence + 1)]);
              if (null === (s = i.trigger) || void 0 === s ? void 0 : s.infix) {
                l = e.wrap(rl(t, 1), i.precedence);
                for (var _r85 = 2; _r85 < c + 1; _r85++) {
                  var _n79 = rl(t, _r85);
                  null !== _n79 && (l = Ll(i.serialize, [l, e.wrap(_n79, i.precedence)]));
                }
              }
              return l;
            }(_this66, e, _a40)), !_o28 && (null === (r = _a40.trigger) || void 0 === r ? void 0 : r.matchfix) && (_o28 = function (e, t, i) {
              var r, n;
              var a = [];
              if ("string" == typeof (null === (r = i.trigger) || void 0 === r ? void 0 : r.matchfix) ? a.push(null === (n = i.trigger) || void 0 === n ? void 0 : n.matchfix) : i.trigger && Array.isArray(i.trigger.matchfix) && (a = _toConsumableArray(i.trigger.matchfix)), nl(t) >= 1) {
                var _r86 = "";
                var _iterator129 = _createForOfIteratorHelper(tl(t)),
                  _step129;
                try {
                  for (_iterator129.s(); !(_step129 = _iterator129.n()).done;) {
                    var _n80 = _step129.value;
                    _n80 && (a.push(_r86), a.push(e.serialize(_n80)), _r86 = i.separator);
                  }
                } catch (err) {
                  _iterator129.e(err);
                } finally {
                  _iterator129.f();
                }
              }
              return a.push(Ns(i.closeFence)), As(a);
            }(_this66, e, _a40)), !_o28 && (null === (n = _a40.trigger) || void 0 === n ? void 0 : n.symbol) && (_o28 = _this66.serializeSymbol(e, _a40)), _o28;
          }
        }
        if (Array.isArray(e) || Ws(e)) return _this66.serializeSymbol(e);
        _this66.onError({
          code: "syntax-error",
          arg: JSON.stringify(e)
        });
      }();
      return this.level -= 1, null != t ? t : "";
    }
  }]);
  return zl;
}();
var ql = /*#__PURE__*/function () {
  function ql(e) {
    _classCallCheck(this, ql);
    var t, i;
    this.onError = null !== (t = null == e ? void 0 : e.onError) && void 0 !== t ? t : function (e) {
      "undefined" != typeof window && (!e.before || e.after);
    };
    var r = _objectSpread({}, null != e ? e : {});
    delete r.dictionary, delete r.onError, this.options = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _l), Sl), Ml), r), this.dictionary = function (e, t) {
      var i, r, n, a, o, s, l, c, u, d, h, p, m, f, g;
      var y = {
        lookahead: 1,
        name: new Map(),
        prefix: [],
        infix: [],
        postfix: [],
        matchfix: [],
        superfix: [],
        subfix: [],
        symbol: [],
        environment: new Map()
      };
      var _iterator130 = _createForOfIteratorHelper(e),
        _step130;
      try {
        var _loop5 = function _loop5() {
          var b = _step130.value;
          void 0 === b.parse && (b.parse = b.name), "string" == typeof b.trigger && (b.trigger = {
            symbol: b.trigger
          }), "string" == typeof b.serialize && void 0 !== (null === (i = b.trigger) || void 0 === i ? void 0 : i.symbol) && /#[0-9]/.test(b.serialize) && t({
            code: "unexpected-argument",
            arg: b.name
          }), void 0 === b.serialize && (void 0 !== (null === (r = b.trigger) || void 0 === r ? void 0 : r.postfix) ? b.serialize = "#1" + kl(b.trigger.postfix) : void 0 !== (null === (n = b.trigger) || void 0 === n ? void 0 : n.prefix) ? b.serialize = kl(b.trigger.prefix) + "#1" : void 0 !== (null === (a = b.trigger) || void 0 === a ? void 0 : a.infix) ? b.serialize = "#1" + kl(b.trigger.infix) + "#2" : void 0 !== (null === (o = b.trigger) || void 0 === o ? void 0 : o.symbol) ? b.serialize = kl(b.trigger.symbol) : void 0 !== (null === (s = b.trigger) || void 0 === s ? void 0 : s.superfix) ? b.serialize = "#1^{" + kl(null === (l = b.trigger) || void 0 === l ? void 0 : l.superfix) + "}" : void 0 !== (null === (c = b.trigger) || void 0 === c ? void 0 : c.subfix) ? b.serialize = "#1_{" + kl(null === (u = b.trigger) || void 0 === u ? void 0 : u.subfix) + "}" : b.serialize = ""), void 0 !== (null === (d = b.trigger) || void 0 === d ? void 0 : d.infix) && (void 0 === b.precedence && t({
            code: "syntax-error",
            arg: "Infix operators require a precedence"
          }), b.associativity || (b.associativity = "non")), void 0 !== (null === (h = b.trigger) || void 0 === h ? void 0 : h.symbol) && (b.arguments = null !== (p = b.arguments) && void 0 !== p ? p : "", b.optionalLatexArg = null !== (m = b.optionalLatexArg) && void 0 !== m ? m : 0, b.requiredLatexArg = null !== (f = b.requiredLatexArg) && void 0 !== f ? f : 0), void 0 !== (null === (g = b.trigger) || void 0 === g ? void 0 : g.matchfix) && ("function" === b.parse || b.closeFence || t({
            code: "syntax-error",
            arg: "Matchfix operators require a close fence or a custom parse function"
          })), void 0 !== b.trigger && (["infix", "prefix", "postfix", "symbol", "matchfix", "superfix", "subfix"].forEach(function (e) {
            if (b.trigger[e]) {
              var _i206 = (t = b.trigger[e], Array.isArray(t) ? t.length : 1);
              y.lookahead = Math.max(y.lookahead, _i206), void 0 === y[e][_i206] && (y[e][_i206] = new Map()), y[e][_i206].set(kl(b.trigger[e]), b);
            }
            var t;
          }), void 0 !== b.trigger.environment && y.environment.set(b.trigger.environment, b)), void 0 !== b.name ? y.name.set(kl(b.name), b) : "string" == typeof b.parse && y.name.set(b.parse, b), void 0 !== b.trigger || b.name || t({
            code: "syntax-error",
            arg: "Need at least a trigger or a name"
          });
        };
        for (_iterator130.s(); !(_step130 = _iterator130.n()).done;) {
          _loop5();
        }
      } catch (err) {
        _iterator130.e(err);
      } finally {
        _iterator130.f();
      }
      return y;
    }(null !== (i = null == e ? void 0 : e.dictionary) && void 0 !== i ? i : ql.getDictionary(), this.onError);
  }
  _createClass(ql, [{
    key: "parse",
    value: function parse(e) {
      var t;
      var i = new Cl(Cs(e, []), this.options, this.dictionary, this.onError),
        r = i.matchExpression();
      return i.atEnd || null === (t = this.onError) || void 0 === t || t.call(this, {
        code: "syntax-error"
      }), null != r ? r : "";
    }
  }, {
    key: "serialize",
    value: function serialize(e) {
      return new zl(this.options, this.dictionary, this.onError).serialize(e);
    }
  }], [{
    key: "getDictionary",
    value: function getDictionary() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "all";
      if ("all" === e) {
        var _e281 = [];
        for (var _i207 = 0, _Object$keys16 = Object.keys(wl); _i207 < _Object$keys16.length; _i207++) {
          var _t216 = _Object$keys16[_i207];
          _e281 = [].concat(_toConsumableArray(_e281), _toConsumableArray(wl[_t216]));
        }
        return _e281;
      }
      return wl[e] ? _toConsumableArray(wl[e]) : [];
    }
  }]);
  return ql;
}();
function Dl(e, t) {
  return new ql(t).parse(e);
}
function El(e, t) {
  return new ql(t).serialize(e);
}
var Tl = {
    Anything: [],
    Expression: "Anything",
    Domain: ["Set", "Symbol"],
    ParametricDomain: ["Domain", "Function"],
    MaybeBoolean: "Expression",
    Boolean: "MaybeBoolean",
    Collection: "Expression",
    Dictionary: "Collection",
    List: "Collection",
    Sequence: "Collection",
    Tuple: "Collection",
    Set: "Collection",
    FiniteSet: "Set",
    InfiniteSet: "Set",
    EmptySet: "FiniteSet",
    String: "Expression",
    Symbol: "String",
    Function: "Expression",
    Predicate: "Function",
    LogicalFunction: "Predicate",
    TranscendentalFunction: "Function",
    AlgebraicFunction: "Function",
    PeriodicFunction: "Function",
    TrigonometricFunction: ["PeriodicFunction", "TranscendentalFunction"],
    HyperbolicFunction: "TranscendentalFunction",
    MonotonicFunction: "Function",
    StrictMonotonicFunction: "MonotonicFunction",
    ContinuousFunction: "Function",
    DifferentiableFunction: "ContinuousFunction",
    InfinitelyDifferentiableFunction: "DifferentiableFunction",
    RationalFunction: ["AlgebraicFunction", "ContinuousFunction"],
    PolynomialFunction: ["AlgebraicFunction", "InfinitelyDifferentiableFunction"],
    QuadraticFunction: "PolynomialFunction",
    LinearFunction: ["QuadraticFunction", "MonotonicFunction"],
    ConstantFunction: "LinearFunction",
    Number: "Set",
    ImaginaryNumber: ["ComplexNumber", "InfiniteSet"],
    ComplexNumber: "ExtendedComplexNumber",
    ExtendedComplexNumber: "Number",
    ComplexInfinity: "ExtendedComplexNumber",
    NumberZero: ["CompositeNumber", "ImaginaryNumber", "FiniteSet"],
    NaturalNumber: "Integer",
    CompositeNumber: "NaturalNumber",
    PrimeNumber: "NaturalNumber",
    Integer: ["RationalNumber", "ExtendedInteger"],
    ExtendedInteger: "ExtendedRationalNumber",
    RationalNumber: ["AlgebraicNumber", "ExtendedRationalNumber"],
    IrrationalNumber: "RealNumber",
    TranscendentalNumber: ["IrrationalNumber", "ImaginaryNumber"],
    AlgebraicNumber: "IrrationalNumber",
    RealNumber: ["ComplexNumber", "ExtendedRealNumber"],
    ExtendedRealNumber: "ExtendedComplexNumber",
    ExtendedNaturalNumber: "ExtendedInteger",
    ExtendedRationalNumber: "ExtendedRealNumber",
    SignedInfinity: "ExtendedNaturalNumber",
    Tensor: "Expression",
    Scalar: "Tensor",
    Vector: "Matrix",
    Row: "Vector",
    Column: "Vector",
    Matrix: "Tensor",
    ComplexTensor: "Tensor",
    RealTensor: "ComplexTensor",
    IntegerTensor: "RealTensor",
    LogicalTensor: "IntegerTensor",
    SquareMatrix: "Matrix",
    MonomialMatrix: "SquareMatrix",
    TriangularMatrix: "SquareMatrix",
    UpperTriangularMatrix: "TriangularMatrix",
    LowerTriangularMatrix: "TriangularMatrix",
    PermutationMatrix: ["MonomialMatrix", "LogicalTensor", "OrthogonalMatrix"],
    OrthogonalMatrix: ["SquareMatrix", "RealTensor"],
    DiagonalMatrix: ["UpperTriangularMatrix", "LowerTriangularMatrix"],
    IdentityMatrix: ["DiagonalMatrix", "SymmetricMatrix", "PermutationMatrix"],
    ZeroMatrix: ["DiagonalMatrix", "SymmetricMatrix", "PermutationMatrix"],
    SymmetricMatrix: ["HermitianMatrix", "SquareMatrix", "RealTensor"],
    HermitianMatrix: "ComplexTensor",
    Quaternion: ["SquareMatrix", "ComplexTensor"]
  },
  Ol = {
    Function: "Q11348",
    ComplexNumber: "Q26851286",
    Integer: "Q47007735",
    ImaginaryNumber: "Q47310259",
    NaturalNumber: "Q28920052"
  },
  Bl = {
    MaybeBoolean: ["Union", "Boolean", ["Set", "Maybe"]],
    NaturalNumber: ["Union", "CompositeNumber", "PrimeNumber"],
    Scalar: ["Intersection", "Row", "Column"],
    TriangularMatrix: ["Union", "UpperTriangularMatrix", "LowerTriangularMatrix"],
    Vector: ["Union", "Row", "Column"]
  },
  Kl = {
    Boolean: 2,
    MaybeBoolean: 3,
    EmptySet: 0,
    IdentityMatrix: 1,
    ZeroMatrix: 1,
    NumberZero: 1
  },
  Fl = {
    Range: {
      range: "ParametricDomain",
      evaluate: function evaluate(e, t, i) {
        return t = Math.round(t), i = Math.round(i), Number.isNaN(t) || Number.isNaN(i) || t > i ? "EmptySet" : t === -1 / 0 && i === 1 / 0 ? "Integer" : 0 === t && i === 1 / 0 ? "NaturalNumber" : 0 === t && 0 === i ? "NumberZero" : ["Range", t, i];
      }
    },
    Interval: {
      range: "ParametricDomain",
      evaluate: function evaluate(e, t, i) {
        return Number.isNaN(t) || Number.isNaN(i) || t > i ? "EmptySet" : t === -1 / 0 && i === 1 / 0 ? "RealNumber" : 0 === t && 0 === i ? "NumberZero" : ["Interval", t, i];
      }
    }
  };
function $l(e, t, i) {
  if (null === t) return null;
  var r = function (e) {
    var t = e.match(/^__?_?([a-zA-Z0-9]+)/);
    return null === t ? "" : t[1];
  }(e);
  return "" === r ? i : i[r] ? null === Il(t, i[r]) ? null : i : (i[r] = t, i);
}
function Pl(e, t, i, r) {
  var n;
  var a = Zs(t);
  if (null !== a) return Math.abs(a - (null !== (n = Zs(e)) && void 0 !== n ? n : NaN)) <= r.numericalTolerance ? i : null;
  var o = Gs(t);
  if (null !== o) return Gs(e) === o ? i : null;
  var s = al(t);
  if (null !== s) {
    var _t217 = Object.keys(s),
      _n81 = al(e);
    if (null === _n81) return null;
    if (Object.keys(_n81).length !== _t217.length) return null;
    for (var _i208 = 0, _t218 = _t217; _i208 < _t218.length; _i208++) {
      var _e282 = _t218[_i208];
      var _t219 = Pl(_n81[_e282], s[_e282], i, r);
      if (null === _t219) return null;
      i = _t219;
    }
    return i;
  }
  var l = el(t);
  if (null !== l) return l.startsWith("_") ? $l(l, e, i) : l === el(e) ? "object" == typeof t && "object" == typeof e && "wikidata" in t && "wikidata" in e && t.wikidata !== e.wikidata ? null : i : "object" == typeof t && "object" == typeof e && "wikidata" in t && "wikidata" in e && t.wikidata === e.wikidata ? i : null;
  var c = Ys(t);
  if (null === c) return null;
  if ("string" == typeof c && c.startsWith("_")) return $l(c, Ys(e), i);
  {
    var _t220 = Ys(e);
    if (null === _t220) return null;
    if (null === Il(c, _t220, r)) return null;
  }
  var u = tl(t),
    d = tl(e),
    h = u.length;
  if (h !== d.length) return null;
  var p = _objectSpread({}, i),
    m = 0;
  for (; m < h;) {
    var _e283 = u[m],
      _t221 = el(_e283);
    if (null !== _t221) {
      if (_t221.startsWith("__")) {
        var _e284 = 0;
        if (void 0 === u[m + 1]) _e284 = d.length + 1;else {
          var _t222 = !1;
          for (; !_t222 && _e284 < d.length;) _t222 = null !== Il(u[m + 1], d[_e284], r), _e284 += 1;
          if (!_t222) return null;
        }
        if (!_t221.startsWith("___") && _e284 <= 1) return null;
        p = $l(_t221, ["Sequence"].concat(_toConsumableArray(d.splice(0, _e284 - 1))), p);
      } else if (_t221.startsWith("_")) p = $l(_t221, d.shift(), p);else {
        var _t223 = Il(_e283, d.shift(), r);
        if (null === _t223) return null;
        p = _objectSpread(_objectSpread({}, p), _t223);
      }
    } else {
      var _t224 = Il(_e283, d.shift(), r);
      if (null === _t224) return null;
      p = _objectSpread(_objectSpread({}, p), _t224);
    }
    if (null === p) return null;
    m += 1;
  }
  return p;
}
function Il(e, t, i) {
  return Pl(t, e, {}, null != i ? i : {
    numericalTolerance: Ts
  });
}
var Rl = /*#__PURE__*/function (_Symbol$iterator) {
  function Rl(e) {
    _classCallCheck(this, Rl);
    this._items = e ? new Map(e instanceof Rl ? e._items : e) : new Map();
  }
  _createClass(Rl, [{
    key: "has",
    value: function has(e) {
      var _iterator131 = _createForOfIteratorHelper(this._items.keys()),
        _step131;
      try {
        for (_iterator131.s(); !(_step131 = _iterator131.n()).done;) {
          var _t225 = _step131.value;
          if (Il(e, _t225)) return !0;
        }
      } catch (err) {
        _iterator131.e(err);
      } finally {
        _iterator131.f();
      }
      return !1;
    }
  }, {
    key: "get",
    value: function get(e) {
      var _iterator132 = _createForOfIteratorHelper(this._items),
        _step132;
      try {
        for (_iterator132.s(); !(_step132 = _iterator132.n()).done;) {
          var _step132$value = _slicedToArray(_step132.value, 2),
            _t226 = _step132$value[0],
            _i209 = _step132$value[1];
          if (Il(e, _t226)) return _i209;
        }
      } catch (err) {
        _iterator132.e(err);
      } finally {
        _iterator132.f();
      }
    }
  }, {
    key: "set",
    value: function set(e, t) {
      var _iterator133 = _createForOfIteratorHelper(this._items.keys()),
        _step133;
      try {
        for (_iterator133.s(); !(_step133 = _iterator133.n()).done;) {
          var _i210 = _step133.value;
          if (Il(e, _i210)) return void this._items.set(_i210, t);
        }
      } catch (err) {
        _iterator133.e(err);
      } finally {
        _iterator133.f();
      }
      this._items.set(e, t);
    }
  }, {
    key: "delete",
    value: function _delete(e) {
      this._items.delete(e);
    }
  }, {
    key: _Symbol$iterator,
    value: function value() {
      return this._items.entries();
    }
  }, {
    key: "entries",
    value: function entries() {
      return this._items.entries();
    }
  }]);
  return Rl;
}(Symbol.iterator);
var Vl = ["Sqrt", 2],
  jl = ["Sqrt", 3],
  Hl = ["Sqrt", 5],
  Ul = ["Sqrt", 6];
function Wl(e) {
  new ea(e);
}
function Zl(e, t) {
  var i, r;
  (t = null != t ? t : {}).mathstyle = null !== (i = t.mathstyle) && void 0 !== i ? i : "displaystyle";
  var n = null !== (r = t.letterShapeStyle) && void 0 !== r ? r : "auto";
  "auto" === n && (n = fr.locale.startsWith("fr") ? "french" : "tex"), t.macros = Xe(null == t ? void 0 : t.macros);
  var a = new rt("root", {
    mode: "math"
  });
  a.body = Ur(zt(e, {
    parseMode: "math",
    macros: t.macros,
    registers: t.registers,
    mathstyle: t.mathstyle,
    onError: t.onError,
    colorMap: t.colorMap,
    backgroundColorMap: t.backgroundColorMap
  }), {
    registers: t.registers
  });
  var o = a.render(new H({
    macros: t.macros,
    registers: Hr(),
    smartFence: !1,
    renderPlaceholder: function renderPlaceholder() {
      return new te(160, {
        maxFontSize: 1
      });
    }
  }, {
    fontSize: 5,
    letterShapeStyle: n
  }, t.mathstyle));
  return o ? (oe(o), re(o), se(o, {
    classes: "ML__mathlive"
  }).toMarkup()) : "";
}
function Gl(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return t.macros = Xe(null == t ? void 0 : t.macros), lr(zt(e, {
    parseMode: "math",
    args: function args() {
      return "";
    },
    macros: t.macros,
    registers: t.registers,
    mathstyle: "displaystyle",
    onError: t.onError,
    colorMap: t.colorMap,
    backgroundColorMap: t.backgroundColorMap
  }), t);
}
function Xl(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return t.macros = Xe(null == t ? void 0 : t.macros), pr(zt(e, {
    parseMode: "math",
    macros: t.macros,
    registers: t.registers,
    mathstyle: "displaystyle",
    onError: t.onError,
    colorMap: t.colorMap,
    backgroundColorMap: t.backgroundColorMap
  }), t);
}
function Yl(e) {
  we(), Ql(document.body, e);
}
function Ql(e, t) {
  var i, r, n;
  var a = function (e) {
    if ("string" == typeof e && ke()) {
      var _t227 = document.getElementById(e);
      if (null === _t227) throw new Error("The element with ID \"".concat(e, "\" could not be found."));
      return _t227;
    }
    return "string" == typeof e ? null : e;
  }(e);
  a && ((t = null != t ? t : {}).renderToMarkup = null !== (i = t.renderToMarkup) && void 0 !== i ? i : Zl, t.renderToMathML = null !== (r = t.renderToMathML) && void 0 !== r ? r : Gl, t.renderToSpeakableText = null !== (n = t.renderToSpeakableText) && void 0 !== n ? n : Xl, Si(a, t));
}
new Rl([[["Divide", "Pi", 12], {
  Sin: ["Divide", ["Subtract", Ul, Vl], 4],
  Cos: ["Divide", ["Add", Ul, Vl], 4],
  Tan: ["Subtract", [2, jl]],
  Cot: ["Add", [2, jl]],
  Sec: ["Subtract", [Ul, Vl]],
  Csc: ["Add", [Ul, Vl]]
}], [["Divide", "Pi", 10], {
  Sin: ["Divide", ["Subtract", Hl, 1], 4],
  Cos: ["Divide", ["Sqrt", ["Add", 10, ["Multiply", 2, Hl]]], 4],
  Tan: ["Divide", ["Sqrt", ["Subtract", 25, ["Multiply", 10, Hl]]], 4],
  Cot: ["Sqrt", ["Add", 5, ["Multiply", 2, Hl]]],
  Sec: ["Divide", ["Sqrt", ["Subtract", 50, ["Multiply", 10, Hl]]], 5],
  Csc: ["Add", 1, Hl]
}], [["Divide", "Pi", 4], {
  Sin: ["Divide", Vl, 2],
  Cos: ["Divide", Vl, 2],
  Tan: 1,
  Cot: 1,
  Sec: Vl,
  Csc: Vl
}], [["Divide", "Pi", 3], {
  Sin: ["Divide", jl, 2],
  Cos: "Half",
  Tan: jl,
  Cot: ["Divide", jl, 3],
  Sec: 2,
  Csc: ["Divide", ["Multiply", 2, jl], 3]
}], [["Divide", "Pi", 2], {
  Sin: 1,
  Cos: 0,
  Tan: 1 / 0,
  Cot: 0,
  Sec: 1 / 0,
  Csc: 1
}]]), function () {
  var e;
  var t = {
    Nothing: {
      countable: !0,
      supersets: [],
      domain: "Domain"
    }
  };
  var _loop6 = function _loop6() {
    var i = _Object$keys17[_i211];
    var r = Array.isArray(Tl[i]) ? Tl[i] : [Tl[i]];
    t[i] = null !== (e = Fl[i]) && void 0 !== e ? e : {}, t[i] = _objectSpread({
      domain: Fl[i] ? "ParametricDomain" : "Domain",
      wikidata: Ol[i],
      supersets: r,
      value: Bl,
      countable: void 0 !== Kl[i],
      size: function size() {
        return Kl[i];
      }
    }, t[i]);
    var _iterator134 = _createForOfIteratorHelper(r),
      _step134;
    try {
      for (_iterator134.s(); !(_step134 = _iterator134.n()).done;) {
        var _e285 = _step134.value;
        if ("Anything" !== _e285 && !Tl[_e285]) throw new Error("Unknown parent of domain \"".concat(i, "\": \"").concat(_e285, "\""));
      }
    } catch (err) {
      _iterator134.e(err);
    } finally {
      _iterator134.f();
    }
  };
  for (var _i211 = 0, _Object$keys17 = Object.keys(Tl); _i211 < _Object$keys17.length; _i211++) {
    _loop6();
  }
  var i = new Set();
  for (var _i212 = 0, _Object$keys18 = Object.keys(t); _i212 < _Object$keys18.length; _i212++) {
    var _e286 = _Object$keys18[_i212];
    i.add(_e286);
  }
  for (var _i213 = 0, _Object$keys19 = Object.keys(t); _i213 < _Object$keys19.length; _i213++) {
    var _e287 = _Object$keys19[_i213];
    var _iterator135 = _createForOfIteratorHelper(t[_e287].supersets),
      _step135;
    try {
      for (_iterator135.s(); !(_step135 = _iterator135.n()).done;) {
        var _r87 = _step135.value;
        i.delete(_r87);
      }
    } catch (err) {
      _iterator135.e(err);
    } finally {
      _iterator135.f();
    }
  }
  i.delete("Nothing"), t.Nothing.supersets = _toConsumableArray(i.values());
  for (var _i214 = 0, _Object$keys20 = Object.keys(t); _i214 < _Object$keys20.length; _i214++) {
    var _e288 = _Object$keys20[_i214];
    var _i215 = !1,
      _r88 = 0,
      _n82 = [_e288];
    for (; _r88 < 512 && !_i215;) {
      var _e289 = _n82.pop();
      _i215 = "Anything" === _e289, _i215 || (_n82 = [].concat(_toConsumableArray(_e289), _toConsumableArray(t[_e289].supersets))), _r88++;
    }
    if (!_i215) throw new Error("The \"".concat(_e288, "\" domain cannot reach \"Anything\""));
  }
}();
var Jl = {
    mathlive: "0.69.8",
    computeEngine: "0.4.2"
  },
  ec = {
    latexToAsciiMath: Hi,
    asciiMathToLatex: Ui,
    FUNCTIONS: Wi.FUNCTIONS,
    MATH_SYMBOLS: Wi.MATH_SYMBOLS,
    TEXT_SYMBOLS: Wi.TEXT_SYMBOLS,
    ENVIRONMENTS: Wi.ENVIRONMENTS,
    DEFAULT_KEYBINDINGS: Wi.DEFAULT_KEYBINDINGS,
    getKeybindingMarkup: Wi.getKeybindingMarkup
  };
export { vs as MathfieldElement, Zl as convertLatexToMarkup, Gl as convertLatexToMathMl, Xl as convertLatexToSpeakableText, ec as debug, Wl as makeSharedVirtualKeyboard, Dl as parseMathJson, Yl as renderMathInDocument, Ql as renderMathInElement, El as serializeMathJson, Jl as version };